import { ColorsTranslation } from '../colors/color_options';
import {
  RELOAD_PRODUCT_DESCRIPTION_TRANSLATE_KEY,
  RELOAD_PRODUCT_LABEL_TRANSLATE_KEY,
  ReloadDescriptionTranslation,
  ReloadLabelTranslation,
} from '../namespace';
import {
  FOOTER_MAX_ITEMS,
  NEWS_HIGHLIGHT_MAX_ITEMS,
  maxCatalogCategorySelectable,
  maxSupplementSelectable,
  maxTagSelectable,
} from '../professional_constants';
import { PROJECT_CONFIG } from '../project_branding/config';
import {
  SEO_CLIENT_DISCOVERIES_PER_MONTH_MAX,
  SEO_CLIENT_MANUAL_TOPICS_PER_MONTH_MAX,
} from '../seo/seo-client-api.schema';
import { TRIAL_DURATION_DAYS } from '../trial.constants';
import {
  SUBSCRIPTION_DESCRIPTION_TRANSLATE_KEY,
  SUBSCRIPTION_LABEL_TRANSLATE_KEY,
  SubscriptionDescriptionTranslation,
  SubscriptionLabelTranslation,
  UNSUB_OFFER_TEXT_TRANSLATE_KEY,
  UNSUB_OFFER_TRANSLATE_KEY,
  UnsubscribeOfferReasonTextTranslation,
  UnsubscribeOfferReasonTranslation,
  UnsubscribeReasonTranslation,
} from '../subscription';
import {
  AgendaViewEnumTranslation,
  AgendaGroupByEnumTranslation,
  AppointmentTypeTranslation,
  AvailabilityPrestationModeTranslation,
  BookingRecurrenceTranslation,
  ReservationCancelScopeTranslation,
  ReservationStatusTranslation,
  RidePricingPreferenceTranslation,
  RideDistanceBandsModeTranslation,
  RideTripLegTranslation,
  TRANSLATE_KEY_RIDE_PRICING_PREFERENCE,
} from '../translation_namespace/availabilities_namespace';
import {
  AvailabilityBookabilityCodeTranslation,
  AvailabilityBookabilityStatusTranslation,
} from '../translation_namespace/availability_bookability_namespace';
import { ProPrestationBookabilityTranslation } from '../translation_namespace/booking_bookability_reason_namespace';
import { RecurrenceRuleLabelTranslation } from '../translation_namespace/recurrence_rule_namespace';
import { GenreTypeTranslation } from '../translation_namespace/gender_namespace';
import { OnboardingIntentionTranslation } from '../translation_namespace/onboarding_intention_namespace';
import { BookingSourceTranslation } from '../translation_namespace/booking_source_namespace';
import {
  StatsBreakdownDimensionTranslation,
  StatsNudgeCodeTranslation,
  StatsNudgeRemedyTranslation,
} from '../translation_namespace/stats_namespace';
import {
  TRANSLATE_KEY_TRIAL_RELANCE_MOMENT,
  TRANSLATE_KEY_TRIAL_SEGMENT,
  TRANSLATE_KEY_TRIAL_VOIE,
  TrialRelanceMomentTranslation,
  TrialSegmentTranslation,
  TrialVoieTranslation,
} from '../translation_namespace/trial_relance_namespace';
import {
  GMB_PUSH_SKIP_REASON_TRANSLATE_KEY,
  GmbPushSkipReasonTranslation,
  GOOGLE_TRANSLATE_KEY,
  SyncGmbStatusTranslation,
} from '../translation_namespace/google_namespace';
import {
  PAYMENT_STATUS_TRANSLATE_KEY,
  PaymentStatusDescAlertBanner,
  PaymentStatusTitleAlertBanner,
  PaymentStatusTranslation,
} from '../translation_namespace/payment_namespace';
import { PlaceKindTranslation } from '../translation_namespace/place_kind_namespace';
import { MemberAssignmentStrategyTranslation } from '../translation_namespace/member_assignment_strategy_namespace';
import { SeoScopeTranslation } from '../translation_namespace/seo_scope_namespace';
import {
  SeoRuleStatusTranslation,
  SeoRuleTranslation,
  SeoScoreGradeTranslation,
  SeoScoreGroupTranslation,
} from '../translation_namespace/seo_score_namespace';
import {
  SeoArticleStatusTranslation,
  SeoBacklinkAcceleratorStatusTranslation,
  SeoBacklinkModeTranslation,
  SeoBacklinkOriginTranslation,
  SeoBacklinkStatusTranslation,
  SeoBacklinkTargetFamilyTranslation,
  SeoBriefStatusTranslation,
  SeoKeywordSourceTranslation,
  SeoKeywordStatusTranslation,
  SeoLinkDirectionTranslation,
  SeoProfileGapTranslation,
  SeoQaIssueKindTranslation,
  SeoUnwritableReasonTranslation,
} from '../translation_namespace/seo_content_namespace';
import { ActivityRecommendationSourceTranslation } from '../translation_namespace/activity_recommendation_source_namespace';
import { ServiceAreaTypeTranslation } from '../translation_namespace/service_area_namespace';
import { AccessStateTranslation, AccessLevelTranslation } from '../translation_namespace/access_namespace';
import { PackTypeTranslation } from '../translation_namespace/pack_namespace';
import { AddonDescriptionTranslation, AddonLabelTranslation } from '../translation_namespace/addon_namespace';
import { PlanTaglineTranslation } from '../translation_namespace/plan_tagline_namespace';
import { PriceTypeTranslation } from '../translation_namespace/price_namespace';
import {
  PrestationPaymentAmountModeTranslation,
  PrestationPaymentTypeTranslation,
  PrestationTypeTranslation,
} from '../translation_namespace/prestation_namespace';
import { PageTypeTranslation } from '../translation_namespace/page_type_namespace';
import { ProNewsStatusTranslation } from '../translation_namespace/pro_news_namespace';
import {
  NotificationTypeTranslation,
  NotificationThemeTranslation,
} from '../translation_namespace/notification_namespace';
import { SiteEventTranslation } from '../translation_namespace/site_event_namespace';
import {
  VoucherStatusTranslation,
  VoucherTypeTranslation,
  VoucherUnusableReasonTranslation,
  VoucherUsageSourceTranslation,
  VoucherUsageKindTranslation,
} from '../translation_namespace/voucher_namespace';
import {
  ProPaymentEventTypeTranslation,
  ProPaymentOriginTranslation,
  ProPaymentStatusTranslation,
  ProPaymentTypeTranslation,
} from '../translation_namespace/pro_payment_namespace';
import {
  TeamMemberRoleTranslation,
  ProfessionalAccessStatusTranslation,
} from '../translation_namespace/professional_namespace';
import {
  CalendarSyncProviderTranslation,
  CalendarSyncDirectionTranslation,
  CalendarSyncStatusTranslation,
  CalendarEventSyncStatusTranslation,
} from '../translation_namespace/calendar_sync_namespace';
import { TRANSLATE_KEY_LEAD_STATE, LeadStateTranslation } from '../translation_namespace/lead_state_namespace';
import {
  TRANSLATE_KEY_SUPPORT_TICKET_INTENT,
  TRANSLATE_KEY_SUPPORT_TICKET_AREA,
  TRANSLATE_KEY_SUPPORT_TICKET_PRIORITY,
  TRANSLATE_KEY_SUPPORT_BUG_KIND,
  TRANSLATE_KEY_SUPPORT_PULSE_STATUS,
  TRANSLATE_KEY_SUPPORT_CUSTOMER_SEGMENT,
  SupportTicketIntentTranslation,
  SupportTicketAreaTranslation,
  SupportTicketPriorityTranslation,
  SupportBugKindTranslation,
  SupportPulseStatusTranslation,
  SupportCustomerSegmentTranslation,
} from '../translation_namespace/support_ticket_namespace';
import {
  GOOGLE_REVIEW_STATUS_TRANSLATE_KEY,
  GoogleReviewStatusTranslation,
} from '../translation_namespace/google_review_namespace';
import {
  GOOGLE_FEED_RUN_STATUS_TRANSLATE_KEY,
  GOOGLE_RESERVE_STATUS_TRANSLATE_KEY,
  GoogleFeedRunStatusTranslation,
  GoogleReserveStatusTranslation,
} from '../translation_namespace/google_reserve_namespace';
import {
  StripeConnectPayoutIntervalTranslation,
  StripeConnectPayoutStatusTranslation,
} from '../translation_namespace/stripe_connect_payout_namespace';
import {
  TRANSLATE_KEY_WEBSITE_DOMAIN_ACTIVATION_STATUS,
  WebsiteDomainActivationStatusTranslation,
} from '../translation_namespace/website_domain_activation_status_namespace';
import {
  ProVatRegimeMentionTranslation,
  ProVatRegimeTranslation,
  TRANSLATE_KEY_PRO_VAT_REGIME,
  TRANSLATE_KEY_PRO_VAT_REGIME_MENTION,
} from '../translation_namespace/pro_vat_regime_namespace';
import {
  NonConversionReasonTranslation,
  TRANSLATE_KEY_NON_CONVERSION_REASON,
} from '../translation_namespace/non_conversion_reason_namespace';
import {
  ProfessionalOriginTranslation,
  TRANSLATE_KEY_PROFESSIONAL_ORIGIN,
} from '../translation_namespace/professional_origin_namespace';
import {
  PulseTextKindTranslation,
  TRANSLATE_KEY_PULSE_TEXT_KIND,
} from '../translation_namespace/pulse_text_kind_namespace';
import {
  OnboardingFlowTranslation,
  TRANSLATE_KEY_ONBOARDING_FLOW,
} from '../translation_namespace/onboarding_flow_namespace';
import {
  TRANSLATE_KEY_WEBSITE_DOMAIN_DNS_STATUS,
  WebsiteDomainDnsStatusTranslation,
} from '../translation_namespace/website_domain_dns_status_namespace';
import {
  TRANSLATE_KEY_PRO_MAIL_DOMAIN_STATUS,
  ProMailDomainStatusTranslation,
} from '../translation_namespace/pro_mail_domain_status_namespace';
import {
  TRANSLATE_KEY_PRO_MAIL_MIGRATION_STATUS,
  ProMailMigrationStatusTranslation,
} from '../translation_namespace/pro_mail_migration_status_namespace';
import {
  TRANSLATE_KEY_PRO_MAIL_MIGRATION_MAILBOX_STATUS,
  ProMailMigrationMailboxStatusTranslation,
} from '../translation_namespace/pro_mail_migration_mailbox_status_namespace';
import {
  TRANSLATE_KEY_OVH_MAIL_OFFER,
  OvhMailOfferTranslation,
} from '../translation_namespace/ovh_mail_offer_namespace';
import {
  TRANSLATE_KEY_MAIL_MIGRATION_CHECK,
  MailMigrationCheckKeyTranslation,
} from '../translation_namespace/mail_migration_check_namespace';
import {
  TRANSLATE_KEY_MAIL_MIGRATION_WARNING,
  MailMigrationWarningKeyTranslation,
} from '../translation_namespace/mail_migration_warning_namespace';
import {
  TRANSLATE_KEY_CAMPAIGN_SENDER_DOMAIN_STATUS,
  CampaignSenderDomainStatusTranslation,
} from '../translation_namespace/campaign_sender_domain_status_namespace';
import {
  SearchEnginePropertyStatusTranslation,
  SearchEngineTranslation,
  TRANSLATE_KEY_SEARCH_ENGINE,
  TRANSLATE_KEY_SEARCH_ENGINE_PROPERTY_STATUS,
} from '../translation_namespace/search_engine_property_namespace';
import {
  TRANSLATE_KEY_PRO_CUSTOMER_IMPORT_STATUS,
  TRANSLATE_KEY_IMPORT_TARGET_FIELD,
  TRANSLATE_KEY_IMPORT_ROW_ACTION,
  TRANSLATE_KEY_IMPORT_ROW_ERROR,
  ProCustomerImportStatusTranslation,
  ImportTargetFieldTranslation,
  ImportRowActionTranslation,
  ImportRowErrorTranslation,
} from '../translation_namespace/pro_customer_import_status_namespace';
import {
  TRANSLATE_KEY_PRO_CUSTOMER_DUPLICATE_TIER,
  TRANSLATE_KEY_PRO_CUSTOMER_DUPLICATE_SIGNAL,
  TRANSLATE_KEY_PRO_CUSTOMER_MERGE_WARNING,
  ProCustomerDuplicateTierTranslation,
  ProCustomerDuplicateSignalTranslation,
  ProCustomerMergeWarningTranslation,
} from '../translation_namespace/pro_customer_duplicate_namespace';
import {
  TRANSLATE_KEY_EMAIL_CHANGE_KIND,
  TRANSLATE_KEY_EMAIL_CHANGE_STATUS,
  EmailChangeKindTranslation,
  EmailChangeStatusTranslation,
} from '../translation_namespace/email_change_namespace';
import { CUSTOMER_IMPORT_MAX_NEW_TAGS, CUSTOMER_IMPORT_MAX_ROWS } from '../pro-customer-import';
import {
  TRANSLATE_KEY_PRO_MAILBOX_STATUS,
  ProMailboxStatusTranslation,
} from '../translation_namespace/pro_mailbox_status_namespace';
import {
  CrmConsentChannelTranslation,
  CrmConsentScopeTranslation,
  CrmConsentSourceTranslation,
  CrmContactPurposeTranslation,
  CrmContactStatusTranslation,
  CrmMailingListReasonTranslation,
  CrmTaskStatusTranslation,
  CrmTaskTypeTranslation,
  TRANSLATE_KEY_CRM_CONSENT_CHANNEL,
  TRANSLATE_KEY_CRM_CONSENT_SCOPE,
  TRANSLATE_KEY_CRM_CONSENT_SOURCE,
  TRANSLATE_KEY_CRM_MAILING_LIST_REASON,
  TRANSLATE_KEY_CRM_CONTACT_PURPOSE,
  TRANSLATE_KEY_CRM_CONTACT_STATUS,
  TRANSLATE_KEY_CRM_TASK_STATUS,
  TRANSLATE_KEY_CRM_TASK_TYPE,
} from '../translation_namespace/crm_contact_namespace';
import {
  CrmBlockedStepTranslation,
  CrmCallBlockReasonTranslation,
  CrmCallInputErrorTranslation,
  CrmCallOutcomeTranslation,
  CrmLateReasonTranslation,
  CrmLifecycleStageTranslation,
  CrmMessageKindTranslation,
  CrmMessageStatusTranslation,
  CrmQueueEntryReasonTranslation,
  CrmQueueEntryStatusTranslation,
  CrmQueueExitReasonTranslation,
  CrmReasonSourceTranslation,
  CrmTrainingOutcomeTranslation,
  CrmTrainingPresenceTranslation,
  CrmQueueEntryKindTranslation,
  CrmCallJournalKindTranslation,
  CrmSessionKindTranslation,
  TRANSLATE_KEY_CRM_SESSION_KIND,
  TRANSLATE_KEY_CRM_BLOCKED_STEP,
  TRANSLATE_KEY_CRM_CALL_BLOCK_REASON,
  TRANSLATE_KEY_CRM_CALL_INPUT_ERROR,
  TRANSLATE_KEY_CRM_CALL_JOURNAL_KIND,
  TRANSLATE_KEY_CRM_CALL_OUTCOME,
  TRANSLATE_KEY_CRM_LATE_REASON,
  TRANSLATE_KEY_CRM_LIFECYCLE_STAGE,
  TRANSLATE_KEY_CRM_MESSAGE_KIND,
  TRANSLATE_KEY_CRM_MESSAGE_STATUS,
  TRANSLATE_KEY_CRM_QUEUE_ENTRY_KIND,
  TRANSLATE_KEY_CRM_QUEUE_ENTRY_REASON,
  TRANSLATE_KEY_CRM_QUEUE_ENTRY_STATUS,
  TRANSLATE_KEY_CRM_QUEUE_EXIT_REASON,
  TRANSLATE_KEY_CRM_REASON_SOURCE,
  TRANSLATE_KEY_CRM_TRAINING_OUTCOME,
  TRANSLATE_KEY_CRM_TRAINING_PRESENCE,
} from '../translation_namespace/crm_queue_namespace';
import {
  CrmCampaignErrorTranslation,
  CrmCampaignExclusionReasonTranslation,
  CrmCampaignStatusTranslation,
  CrmCampaignTypeTranslation,
  CrmCommsTraceKindTranslation,
  CrmSequenceAnchorTranslation,
  CrmSequenceStepTimingTranslation,
  TRANSLATE_KEY_CRM_CAMPAIGN_ERROR,
  TRANSLATE_KEY_CRM_CAMPAIGN_EXCLUSION_REASON,
  TRANSLATE_KEY_CRM_CAMPAIGN_STATUS,
  TRANSLATE_KEY_CRM_CAMPAIGN_TYPE,
  TRANSLATE_KEY_CRM_COMMS_TRACE_KIND,
  TRANSLATE_KEY_CRM_SEQUENCE_ANCHOR,
  TRANSLATE_KEY_CRM_SEQUENCE_STEP_TIMING,
} from '../translation_namespace/crm_campaign_namespace';
import { TRANSLATE_KEY_MESSAGE_ROLE, MessageRoleTranslation } from '../translation_namespace/message_role_namespace';
import {
  TRANSLATE_KEY_MESSAGE_CHANNEL,
  MessageChannelTranslation,
} from '../translation_namespace/message_channel_namespace';
import {
  TRANSLATE_KEY_TRIGGER_RUN_STATUS,
  TriggerRunStatusTranslation,
} from '../translation_namespace/trigger_run_status_namespace';
import {
  TRANSLATE_KEY_ADMIN_AUDIT_ACTION,
  AdminAuditActionTranslation,
} from '../translation_namespace/admin_audit_action_namespace';
import {
  TRANSLATE_KEY_PRO_MIGRATION_STATUS,
  ProMigrationStatusTranslation,
} from '../translation_namespace/pro_migration_status_namespace';
import {
  TRANSLATE_KEY_V1_STRIPE_CONNECT_STATUS,
  V1StripeConnectStatusTranslation,
} from '../translation_namespace/v1_stripe_connect_status_namespace';
import { TRANSLATE_KEY_ADMIN_ROLE, AdminRoleTranslation } from '../translation_namespace/admin_role_namespace';
import {
  TRANSLATE_KEY_TOOL_INVOCATION_STATUS,
  ToolInvocationStatusTranslation,
} from '../translation_namespace/tool_invocation_status_namespace';
import {
  PRO_RESOURCE_BOOKING_MODE_TRANSLATE_KEY,
  PRO_RESOURCE_CATEGORY_TRANSLATE_KEY,
  ProResourceBookingModeTranslation,
  ProResourceCategoryTranslation,
} from '../translation_namespace/pro_resource_namespace';
import { PrestationFormatPresetTranslation } from '../translation_namespace/prestation_preset_namespace';
import { BookingCustomFieldTypeTranslation } from '../translation_namespace/booking_custom_field_namespace';
import { ProCustomerCustomFieldTypeTranslation } from '../translation_namespace/pro_customer_custom_field_namespace';
import {
  TRANSLATE_KEY_PROMO_CODE_KIND,
  TRANSLATE_KEY_VOID_ON_PLAN_CHANGE,
  TRANSLATE_KEY_PROMO_VOID_REASON,
  TRANSLATE_KEY_PROMO_INELIGIBILITY,
  PromoCodeKindTranslation,
  VoidOnPlanChangeTranslation,
  PromoVoidReasonTranslation,
  PromoIneligibilityReasonTranslation,
} from '../translation_namespace/promo_code_namespace';
import {
  TRANSLATE_KEY_PRO_PROMO_CODE_KIND,
  TRANSLATE_KEY_PRO_PROMO_CODE_DISTRIBUTION,
  TRANSLATE_KEY_BOOKING_PROMO_INELIGIBILITY,
  TRANSLATE_KEY_PRO_PROMO_CODE_TRIGGER,
  TRANSLATE_KEY_PRO_PROMO_CODE_STATUS,
  TRANSLATE_KEY_PRO_PROMO_CODE_CUSTOMER_SCOPE,
  TRANSLATE_KEY_PRO_PROMOTION_DISPLAY_STATUS,
  TRANSLATE_KEY_PRO_PROMO_CODE_WINDOW_BASIS,
  ProPromoCodeWindowBasisTranslation,
  ProPromoCodeKindTranslation,
  ProPromoCodeDistributionTranslation,
  BookingPromoIneligibilityReasonTranslation,
  ProPromoCodeTriggerTranslation,
  ProPromoCodeStatusTranslation,
  ProPromoCodeCustomerScopeTranslation,
  ProPromotionDisplayStatusTranslation,
} from '../translation_namespace/pro_promo_code_namespace';
import {
  TRANSLATE_KEY_RESERVATION_DISCOUNT_REASON,
  TRANSLATE_KEY_RESERVATION_DISCOUNT_UNAVAILABLE,
  ReservationDiscountReasonTranslation,
  ReservationDiscountUnavailableReasonTranslation,
} from '../translation_namespace/reservation_discount_namespace';
import {
  TRANSLATE_KEY_AFFILIATE_REGIME,
  TRANSLATE_KEY_AFFILIATE_STATUS,
  TRANSLATE_KEY_AFFILIATE_COMMISSION_STATUS,
  TRANSLATE_KEY_AFFILIATE_COMMISSION_KIND,
  TRANSLATE_KEY_AFFILIATE_RECONCILIATION_STATE,
  TRANSLATE_KEY_AFFILIATE_REFERRAL_REVIEW_STATE,
  TRANSLATE_KEY_AFFILIATE_SOURCE,
  AffiliateRegimeTranslation,
  AffiliateStatusTranslation,
  AffiliateCommissionStatusTranslation,
  AffiliateCommissionKindTranslation,
  AffiliateReconciliationStateTranslation,
  AffiliateReferralReviewStateTranslation,
  AffiliateSourceTranslation,
} from '../translation_namespace/affiliate_namespace';

const STRIPE_REQUIRED_COMMON = {
  STRIPE_REQUIRED_STEP_TITLE: 'Comment ça marche ?',
  STRIPE_REQUIRED_STEP_1_TITLE: 'Connecter Stripe',
  STRIPE_REQUIRED_STEP_1_DESC: 'Liez votre compte Stripe en 5 minutes. Sécurisé et conforme PCI.',
  STRIPE_REQUIRED_STEP_3_TITLE: 'Commencez à vendre',
  STRIPE_REQUIRED_CONNECT_BUTTON: 'Connecter mon compte Stripe',
  // Bandeau d'avertissement « soft » : la création reste possible sans Stripe,
  // mais les clients ne pourront pas acheter en ligne tant qu'il n'est pas activé.
  STRIPE_INACTIVE_NOTICE_TITLE: 'Paiements non activés',
  STRIPE_INACTIVE_NOTICE_TEXT:
    "Vous pouvez créer et configurer vos offres dès maintenant. En revanche, vos clients ne pourront pas les acheter en ligne tant que vous n'aurez pas activé les paiements avec Stripe.",
};

export default {
  COUNTRIES: {
    AC: 'Ascension',
    AD: 'Andorre',
    AE: 'Émirats arabes unis',
    AF: 'Afghanistan',
    AG: 'Antigua-et-Barbuda',
    AI: 'Anguilla',
    AL: 'Albanie',
    AM: 'Arménie',
    AO: 'Angola',
    AR: 'Argentine',
    AS: 'Samoa américaines',
    AT: 'Autriche',
    AU: 'Australie',
    AW: 'Aruba',
    AX: 'Îles Åland',
    AZ: 'Azerbaïdjan',
    BA: 'Bosnie-Herzégovine',
    BB: 'Barbade',
    BD: 'Bangladesh',
    BE: 'Belgique',
    BF: 'Burkina Faso',
    BG: 'Bulgarie',
    BH: 'Bahreïn',
    BI: 'Burundi',
    BJ: 'Bénin',
    BL: 'Saint-Barthélemy',
    BM: 'Bermudes',
    BN: 'Brunei',
    BO: 'Bolivie',
    BQ: 'Pays-Bas caribéens',
    BR: 'Brésil',
    BS: 'Bahamas',
    BT: 'Bhoutan',
    BW: 'Botswana',
    BY: 'Biélorussie',
    BZ: 'Belize',
    CA: 'Canada',
    CC: 'Îles Cocos',
    CD: 'République démocratique du Congo',
    CF: 'République centrafricaine',
    CG: 'République du Congo',
    CH: 'Suisse',
    CI: "Côte d'Ivoire",
    CK: 'Îles Cook',
    CL: 'Chili',
    CM: 'Cameroun',
    CN: 'Chine',
    CO: 'Colombie',
    CR: 'Costa Rica',
    CU: 'Cuba',
    CV: 'Cap-Vert',
    CW: 'Curaçao',
    CX: 'Île Christmas',
    CY: 'Chypre',
    CZ: 'Tchéquie',
    DE: 'Allemagne',
    DJ: 'Djibouti',
    DK: 'Danemark',
    DM: 'Dominique',
    DO: 'République dominicaine',
    DZ: 'Algérie',
    EC: 'Équateur',
    EE: 'Estonie',
    EG: 'Égypte',
    EH: 'Sahara occidental',
    ER: 'Érythrée',
    ES: 'Espagne',
    ET: 'Éthiopie',
    FI: 'Finlande',
    FJ: 'Fidji',
    FK: 'Îles Malouines',
    FM: 'Micronésie',
    FO: 'Îles Féroé',
    FR: 'France',
    GA: 'Gabon',
    GB: 'Royaume-Uni',
    GD: 'Grenade',
    GE: 'Géorgie',
    GF: 'Guyane française',
    GG: 'Guernesey',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GL: 'Groenland',
    GM: 'Gambie',
    GN: 'Guinée',
    GP: 'Guadeloupe',
    GQ: 'Guinée équatoriale',
    GR: 'Grèce',
    GT: 'Guatemala',
    GU: 'Guam',
    GW: 'Guinée-Bissau',
    GY: 'Guyana',
    HK: 'Hong Kong',
    HN: 'Honduras',
    HR: 'Croatie',
    HT: 'Haïti',
    HU: 'Hongrie',
    ID: 'Indonésie',
    IE: 'Irlande',
    IL: 'Israël',
    IM: 'Île de Man',
    IN: 'Inde',
    IO: "Territoire britannique de l'océan Indien",
    IQ: 'Irak',
    IR: 'Iran',
    IS: 'Islande',
    IT: 'Italie',
    JE: 'Jersey',
    JM: 'Jamaïque',
    JO: 'Jordanie',
    JP: 'Japon',
    KE: 'Kenya',
    KG: 'Kirghizistan',
    KH: 'Cambodge',
    KI: 'Kiribati',
    KM: 'Comores',
    KN: 'Saint-Christophe-et-Niévès',
    KP: 'Corée du Nord',
    KR: 'Corée du Sud',
    KW: 'Koweït',
    KY: 'Îles Caïmans',
    KZ: 'Kazakhstan',
    LA: 'Laos',
    LB: 'Liban',
    LC: 'Sainte-Lucie',
    LI: 'Liechtenstein',
    LK: 'Sri Lanka',
    LR: 'Libéria',
    LS: 'Lesotho',
    LT: 'Lituanie',
    LU: 'Luxembourg',
    LV: 'Lettonie',
    LY: 'Libye',
    MA: 'Maroc',
    MC: 'Monaco',
    MD: 'Moldavie',
    ME: 'Monténégro',
    MF: 'Saint-Martin (partie française)',
    MG: 'Madagascar',
    MH: 'Îles Marshall',
    MK: 'Macédoine du Nord',
    ML: 'Mali',
    MM: 'Birmanie',
    MN: 'Mongolie',
    MO: 'Macao',
    MP: 'Îles Mariannes du Nord',
    MQ: 'Martinique',
    MR: 'Mauritanie',
    MS: 'Montserrat',
    MT: 'Malte',
    MU: 'Maurice',
    MV: 'Maldives',
    MW: 'Malawi',
    MX: 'Mexique',
    MY: 'Malaisie',
    MZ: 'Mozambique',
    NA: 'Namibie',
    NC: 'Nouvelle-Calédonie',
    NE: 'Niger',
    NF: 'Île Norfolk',
    NG: 'Nigéria',
    NI: 'Nicaragua',
    NL: 'Pays-Bas',
    NO: 'Norvège',
    NP: 'Népal',
    NR: 'Nauru',
    NU: 'Niue',
    NZ: 'Nouvelle-Zélande',
    OM: 'Oman',
    PA: 'Panama',
    PE: 'Pérou',
    PF: 'Polynésie française',
    PG: 'Papouasie-Nouvelle-Guinée',
    PH: 'Philippines',
    PK: 'Pakistan',
    PL: 'Pologne',
    PM: 'Saint-Pierre-et-Miquelon',
    PR: 'Porto Rico',
    PS: 'Palestine',
    PT: 'Portugal',
    PW: 'Palaos',
    PY: 'Paraguay',
    QA: 'Qatar',
    RE: 'La Réunion',
    RO: 'Roumanie',
    RS: 'Serbie',
    RU: 'Russie',
    RW: 'Rwanda',
    SA: 'Arabie saoudite',
    SB: 'Îles Salomon',
    SC: 'Seychelles',
    SD: 'Soudan',
    SE: 'Suède',
    SG: 'Singapour',
    SH: 'Sainte-Hélène',
    SI: 'Slovénie',
    SJ: 'Svalbard et Jan Mayen',
    SK: 'Slovaquie',
    SL: 'Sierra Leone',
    SM: 'Saint-Marin',
    SN: 'Sénégal',
    SO: 'Somalie',
    SR: 'Suriname',
    SS: 'Soudan du Sud',
    ST: 'Sao Tomé-et-Principe',
    SV: 'Salvador',
    SX: 'Saint-Martin (partie néerlandaise)',
    SY: 'Syrie',
    SZ: 'Eswatini',
    TA: 'Tristan da Cunha',
    TC: 'Îles Turques-et-Caïques',
    TD: 'Tchad',
    TG: 'Togo',
    TH: 'Thaïlande',
    TJ: 'Tadjikistan',
    TK: 'Tokelau',
    TL: 'Timor oriental',
    TM: 'Turkménistan',
    TN: 'Tunisie',
    TO: 'Tonga',
    TR: 'Turquie',
    TT: 'Trinité-et-Tobago',
    TV: 'Tuvalu',
    TW: 'Taïwan',
    TZ: 'Tanzanie',
    UA: 'Ukraine',
    UG: 'Ouganda',
    US: 'États-Unis',
    UY: 'Uruguay',
    UZ: 'Ouzbékistan',
    VA: 'Vatican',
    VC: 'Saint-Vincent-et-les-Grenadines',
    VE: 'Venezuela',
    VG: 'Îles Vierges britanniques',
    VI: 'Îles Vierges des États-Unis',
    VN: 'Viêt Nam',
    VU: 'Vanuatu',
    WF: 'Wallis-et-Futuna',
    WS: 'Samoa',
    XK: 'Kosovo',
    YE: 'Yémen',
    YT: 'Mayotte',
    ZA: 'Afrique du Sud',
    ZM: 'Zambie',
    ZW: 'Zimbabwe',
  },
  ACCESS_BANNER: {
    TRIAL_CTA: 'Choisir ma formule',
    PAYMENT_WARNING: 'Votre dernier paiement a échoué, nous réessayerons. Mettez à jour votre moyen de paiement.',
    PAYMENT_WARNING_CTA: 'Mettre à jour mon moyen de paiement',
    SIDEBAR_TRIAL_DAYS: 'Essai · {days}j',
    SIDEBAR_TRIAL_LAST_DAY: 'Essai · dernier jour',
    SIDEBAR_PAYMENT: 'Paiement à régulariser',
    SUBSCRIBE_UNLOCK_TITLE: 'Abonnez-vous pour débloquer',
    SUBSCRIBE_UNLOCK_DESC_DEFAULT: 'Cette fonctionnalité nécessite un abonnement actif.',
    SUBSCRIBE_UNLOCK_DESC_CAMPAIGN: 'L’envoi de campagnes nécessite un abonnement actif.',
    SUBSCRIBE_UNLOCK_DESC_DOMAIN: 'Connecter un nom de domaine nécessite un abonnement actif.',
    SUBSCRIBE_UNLOCK_PRESERVE:
      'Bonne nouvelle : vous gardez vos {days} jours d’essai restants. Votre 1ère période couvre 1 mois + {days} jours.',
    SUBSCRIBE_UNLOCK_CTA: 'Voir les formules',
    SUBSCRIBE_UNLOCK_LATER: 'Plus tard',
    TRIAL_KEEP_DAYS_BANNER: 'Vous gardez vos {days} jours d’essai : votre 1ère période couvre 1 mois + {days} jours.',
  },
  // Modale bloquante (dismissable) à la connexion pendant le SEMI-GEL dunning (impayé J+30 :
  // résa en ligne publique coupée, back-office intact). cf. AccessGate.
  ACCESS_SEMI_FROZEN: {
    TITLE: 'La réservation en ligne de votre établissement est suspendue',
    DESC: 'Suite à un impayé, vos clients ne peuvent plus réserver en ligne : ils sont invités à vous appeler. Votre site reste visible et vos rendez-vous existants sont maintenus. La réactivation est immédiate dès régularisation.',
    OUTSTANDING_LABEL: 'Solde impayé : {amount}',
    CTA_REGULARIZE: 'Régulariser maintenant',
    DISMISS: 'Continuer vers mon compte',
  },
  ACCESS_FROZEN: {
    TRIAL_EXPIRED_TITLE: 'Votre essai est terminé',
    TRIAL_EXPIRED_DESC: 'Choisissez une formule pour continuer à utiliser votre compte.',
    PAST_DUE_TITLE: 'Paiement en échec',
    PAST_DUE_DESC: 'Régularisez votre paiement pour réactiver votre compte.',
    CANCELED_TITLE: 'Votre abonnement a pris fin',
    CANCELED_DESC: 'Souscrivez à nouveau pour réactiver votre compte.',
    CTA_CHOOSE_PLAN: 'Choisir une formule',
    CTA_REGULARIZE: 'Régulariser mon paiement',
    LOGOUT: 'Se déconnecter',
    READ_ONLY_NOTE: 'L’accès à ce compte est suspendu jusqu’à sa réactivation.',
    // Prise de contrôle admin d'un compte gelé : bandeau non bloquant à la place de l'écran ci-dessus.
    IMPERSONATION_NOTICE:
      '{state} : compte gelé. Le pro ne voit que l’écran de réactivation ; vos modifications seront refusées.',
    IMPERSONATION_NOTICE_CTA: 'Voir l’abonnement',
    IMPERSONATION_STATE_NEW_COMPANY: 'Entreprise à activer',
    SWITCH_ACCOUNT_LABEL: 'Ou accédez à un autre compte',
    SWITCH_REQUIRES_PASSWORD:
      'Vous êtes connecté par un lien : pour accéder à vos autres comptes, déconnectez-vous puis reconnectez-vous avec votre mot de passe.',
    NEW_COMPANY_TITLE: 'Activez votre nouvelle entreprise',
    NEW_COMPANY_DESC:
      'Choisissez une formule pour activer cette entreprise. Elle a son propre abonnement et ses propres factures, sans période d’essai.',
    ABANDON_CTA: 'Abandonner cette entreprise',
    ABANDON_CONFIRM_TITLE: 'Abandonner cette entreprise ?',
    ABANDON_CONFIRM_DESC:
      'L’entreprise « {name} » sera supprimée définitivement de votre compte. Vous pourrez en créer une nouvelle ensuite.',
  },
  GLOBAL: {
    RETRY: 'Réessayer',
    // Repli de `useOpenInNewTab` quand le navigateur (Safari surtout) refuse l'onglet.
    POPUP_BLOCKED_TITLE: 'Votre navigateur a bloqué l’ouverture de la page',
    POPUP_BLOCKED_DESCRIPTION: 'Cliquez sur « Ouvrir la page » pour y accéder.',
    POPUP_BLOCKED_OPEN: 'Ouvrir la page',
    // Libellé accessible d'une case de code à usage unique (OtpInput).
    OTP_DIGIT_ARIA: 'Chiffre {index} sur {total}',
    BACK: 'Retour',
    NO_RESULTS: 'Aucun résultat.',
    // Bas d'une liste paginée (GetterAndViewer), une fois toutes les pages chargées.
    END_OF_LIST: 'Fin de la liste · {count} {count, plural, =1 {élément} other {éléments}}',
    NO_PHONE: 'Aucun téléphone renseigné',
    ADVANCED_SETTINGS: 'Paramètres avancés',
    PERMISSION_UPGRADE_NEEDED: 'Disponible avec le plan {plan}',
    PERMISSION_UPGRADE_TITLE: 'Passez au plan {plan}',
    PERMISSION_UPGRADE_DESCRIPTION:
      'Cette fonctionnalité est disponible à partir du plan {plan}. Passez à un plan supérieur pour en profiter.',
    // Variantes sans incitation à l'achat, utilisées en WebView mobile à la place
    // des deux clés ci-dessus (App Review 3.1.3(f)) : constat de disponibilité,
    // ni verbe d'achat, ni montant, ni lien.
    PERMISSION_UPGRADE_DESCRIPTION_NO_CTA: 'Cette fonctionnalité est disponible à partir du plan {plan}.',
    PERMISSION_UPGRADE_CTA: 'Découvrir le plan {plan}',
    PERMISSION_UPGRADE_LATER: 'Plus tard',
    PERMISSION_ROLE_RESTRICTED: 'Droits insuffisants',
    PERMISSION_ROLE_RESTRICTED_TOOLTIP: "Vous n'avez pas les droits nécessaires pour effectuer cette action",
    SIDEBAR_HOME: 'Accueil',
    SIDEBAR_SEARCH: 'Rechercher',
    SIDEBAR_NOTIFICATIONS: 'Notifications',
    SIDEBAR_AGENDA: 'Agenda',
    SIDEBAR_WEBSITE: 'Site Internet',
    SIDEBAR_CATALOG: 'Catalogue',
    SIDEBAR_MARKETING: 'Communication',
    SIDEBAR_SALES: 'Mes ventes',
    SIDEBAR_CUSTOMERS: 'Clients',
    SIDEBAR_MIGRATION_V1: 'Importer depuis Cfixé',
    SIDEBAR_ESTABLISHMENT: 'Entreprise',
    SIDEBAR_REFERRAL_KICKER: 'Parrainage',
    SIDEBAR_REFERRAL_TITLE: 'Gagnez {rate} % en parrainant',
    SIDEBAR_REFERRAL_TEXT: '{bounty} offerts à chaque pro que vous invitez, une commission pour vous.',
    SIDEBAR_REFERRAL_CTA: 'Obtenir mon lien',
    SIDEBAR_REFERRAL_COLLAPSE: 'Réduire',
    SIDEBAR_REFERRAL_EXPAND: 'Agrandir',
    SIDEBAR_HELP: "Centre d'aide",
    SIDEBAR_SUBSCRIPTION: 'Abonnement',
    SIDEBAR_SETTINGS: 'Paramètres',
    SIDEBAR_INVITE: 'Inviter un collaborateur',
    SIDEBAR_MY_SETTINGS: 'Mes paramètres',
    SIDEBAR_MY_ACCOUNT: 'Mon compte',
    SIDEBAR_LEGAL_DOCS: 'Documents légaux',
    SIDEBAR_CUSTOMER_MODE: 'Mode particulier',
    SIDEBAR_LOGOUT: 'Déconnexion',
    SIDEBAR_TOGGLE_THEME: 'Changer de thème',
    SIDEBAR_SALES_PAYMENTS: 'Paiements',
    SIDEBAR_SALES_PACKS: 'Packs vendus',
    SIDEBAR_SALES_GIFT_CARDS: 'Cartes cadeaux',
    SIDEBAR_SALES_PROMOTIONS: 'Codes promo',
    SIDEBAR_MARKETING_PROMOTIONS: 'Promotions',
    SIDEBAR_MARKETING_BLOG: 'Blog & référencement',
    SIDEBAR_MARKETING_CAMPAIGNS: 'Campagne marketing',
    SIDEBAR_MARKETING_NOTIFICATIONS: 'Messages automatiques',
    SIDEBAR_MARKETING_REVIEWS: 'Avis Google',
    SIDEBAR_WEBSITE_OVERVIEW: 'Récap',
    SIDEBAR_WEBSITE_SETTINGS: 'Paramètres',
    SIDEBAR_WEBSITE_DOMAIN: 'Domaine & emails',
    SIDEBAR_STATISTICS: 'Statistiques',
    SIDEBAR_STATISTICS_ACTIVITY: 'Activité',
    SIDEBAR_STATISTICS_CUSTOMERS: 'Clients',
    SIDEBAR_STATISTICS_SALES: 'Ventes',
    SIDEBAR_STATISTICS_REVIEWS: 'Avis Google',
    SIDEBAR_STATISTICS_CAMPAIGNS: 'Campagnes',
    SIDEBAR_EMAIL: 'Emails pro',
    SIDEBAR_EMAIL_MAILBOXES: 'Boîtes mail',
    SIDEBAR_CATALOG_PRESTATIONS: 'Prestations',
    SIDEBAR_CATALOG_PACKS: 'Packs',
    SIDEBAR_CATALOG_GIFT_CARDS: 'Cartes cadeaux',
    SIDEBAR_ESTABLISHMENT_INFORMATIONS: 'Informations',
    SIDEBAR_ESTABLISHMENT_PARAMETERS: 'Paramètres',
    SIDEBAR_ESTABLISHMENT_PAYMENTS: 'Comptes de paiements',
    SIDEBAR_ESTABLISHMENT_SUBSCRIPTION: 'Abonnement',
    THEME_LIGHT: 'Clair',
    THEME_DARK: 'Sombre',
    THEME_SYSTEM: 'Système',
    REMOVE: 'Supprimer',
    LOADING: 'Chargement…',
    ERROR: 'Erreur',
    GENERIC_ERROR: 'Une erreur est survenue. Réessaie dans un instant.',
    QR_CODE_ERROR: 'Impossible de générer le QR code. Utilisez le lien ci-dessous.',
    NOT_FOUND_TITLE: "Cette page n'existe pas",
    NOT_FOUND_DESCRIPTION: "La page que vous cherchez n'existe pas, a été déplacée ou n'est plus disponible.",
    NOT_FOUND_HOME: "Retour à l'accueil",
    NOT_FOUND_BACK: 'Page précédente',
    INSERT_HERE: 'Insérer ici',
    CONNEXION: 'Connexion',
    OK: 'Ok',
    OR: 'ou',
    PASSWORD_FORGOTTEN: 'Mot de passe oublié ?',
    SHOW_PASSWORD: 'Afficher le mot de passe',
    HIDE_PASSWORD: 'Masquer le mot de passe',
    BUTTON_BACK_LOGIN_PAGE: 'Retour à la connexion',
    ADD: 'Ajouter',
    CONFIRM: 'Confirmer',
    CLOSE: 'Fermer',
    OPEN_CALENDAR: 'Ouvrir le calendrier',
    CLEAR_DATE: 'Effacer la date',
    UP: 'Monter',
    DOWN: 'Descendre',
    RESET: 'Réinitialiser',
    URL_COPIED: 'URL copiée',
    COPY_URL: "Copier l'URL",
    SHOW_QR_CODE: 'Afficher le QR code',
    SAVE: 'Enregistrer',
    VALIDATE: 'Valider',
    SEND: 'Envoyer',
    YES: 'Oui',
    NO: 'Non',
    INVITE: 'Inviter',
    EDIT: 'Modifier',
    DELETE: 'Supprimer',
    CUSTOM_COLOR_SELECT: 'Couleur personnalisée',
    CANCEL: 'Annuler',
    SETTINGS: 'Paramètres',
    SEARCH: 'Recherche',
    NO_RESULT: 'Pas de résultat',
    UNCHECK_ALL: 'Tout décocher',
    MONTH: 'mois',
    DAY_SHORT: 'j',
    HOUR_SHORT: 'h',
    MINUTE_SHORT: 'min',
    DURATION_EQUIVALENT: 'Soit {duration}',
    MONTHLY: 'mensuelle',
    YEAR: 'an',
    YEARLY: 'annuelle',
    FILTER: 'Filtres',
    SORT: 'Trier',
    SMS: 'SMS',
    EMAIL: 'Email',
    PREVIEW: 'Prévisualisation',
    TIME_PICKER_MANDATORY: 'Heure (obligatoire)',
    TIME_PICKER_OPTIONNAL: 'Heure (optionnelle)',
    ERASE_ALL: 'Tout effacer',
    MONDAY: 'Lundi',
    TUESDAY: 'Mardi',
    WEDNESDAY: 'Mercredi',
    THURSDAY: 'Jeudi',
    FRIDAY: 'Vendredi',
    SATURDAY: 'Samedi',
    SUNDAY: 'Dimanche',
    CLOSED: 'Fermé',
    ALL_DAY: 'Toute la journée',
    ALL_DAY_SHORT: '24h',
    GO_BACK: 'Retour',
    OPTIONNAL: 'Optionnel',
    CROP_IMAGE_TITLE: "Recadrer l'image",
    REPLACE_IMAGE: "Remplacer l'image",
    CONFIRM_CROP: 'Valider le recadrage',
    CROP_ZOOM: 'Zoom',
    SELECTED: 'sélectionné(s)',
    DESELECT: 'Désélectionner',
    DESELECT_ALL_MATCHING: 'Désélectionner ({count})',
    SELECT_ALL_MATCHING: 'Tout sélectionner ({count})',
    APPLY: 'Appliquer',
    BULK_DELETE: 'Supprimer',
    BULK_EDIT: 'Modifier',
    BULK_DELETE_CONFIRM_TITLE: 'Supprimer les éléments sélectionnés',
    BULK_DELETE_CONFIRM_TEXT: 'Cette action est irréversible. Voulez-vous continuer ?',
    BULK_EDIT_PICK_FIELD: 'Quel champ souhaitez-vous modifier ?',
    EXPORT: 'Exporter',
    EXPORT_SENT_BY_EMAIL: 'Export trop volumineux, il vous sera envoyé par email.',
    EXPORT_DOWNLOAD_TITLE: 'Export terminé',
    EXPORT_DOWNLOAD_TEXT:
      "Le téléchargement de votre fichier a dû se lancer automatiquement. Si ce n'est pas le cas, cliquez sur le bouton ci-dessous.",
    EXPORT_DOWNLOAD_AGAIN: 'Télécharger le fichier',
    CUSTOMER_VIEW_PROFILE: 'Voir la fiche client',
    PREVIOUS: 'Précédent',
    NEXT: 'Suivant',
    MOVE_UP: 'Déplacer vers le haut',
    MOVE_DOWN: 'Déplacer vers le bas',
    MOVE_LEFT: 'Déplacer vers la gauche',
    MOVE_RIGHT: 'Déplacer vers la droite',
    MAIN_IMAGE_BADGE: 'Principale',
    REORDER_IMAGES_HINT: 'Glissez les photos pour changer leur ordre. La première est la photo principale.',
    PLAY: 'Lecture',
    PAUSE: 'Pause',
  },
  ASSISTANT: {
    BUTTON_LABEL: 'Pulse',
    SIGNUP_LINK_LABEL: 'Créer mon compte',
    TITLE: 'Pulse',
    SUBTITLE: `Votre copilote`,
    WELCOME_TITLE: 'Bonjour, je suis Pulse 👋',
    WELCOME_HINT:
      'Je peux préparer un article, une newsletter, analyser vos stats ou faire le point sur vos rendez-vous. Posez-moi une question, ou choisissez une suggestion ci-dessous.',
    WELCOME:
      'Bonjour, je suis Pulse, votre copilote. Je peux préparer un article, une newsletter, analyser vos statistiques ou faire le point sur vos rendez-vous.',
    PLACEHOLDER: 'Écrivez à Pulse…',
    DOCK: 'Ancrer Pulse',
    UNDOCK: 'Remettre Pulse en flottant',
    NEW_CONVERSATION: 'Nouvelle conversation',
    NEW_CONVERSATION_ERROR: "Impossible de démarrer une nouvelle conversation pour l'instant.",
    SEND_MESSAGE: 'Envoyer le message',
    LOADING: 'Pulse analyse',
    THINKING_TITLE: 'Pulse réfléchit',
    THINKING_DESCRIPTION: 'Recherche des données et prépare une réponse',
    SCROLL_TO_BOTTOM: 'Revenir en bas',
    ATTACH_IMAGE: 'Joindre une image',
    ATTACH_VOICE: 'Enregistrer un message vocal',
    STOP_RECORDING: "Arrêter l'enregistrement",
    RECORDING: 'Enregistrement en cours',
    REMOVE_ATTACHMENT: 'Retirer cette pièce jointe',
    ATTACHMENT_TOO_LARGE: 'Fichier trop volumineux (max {max} Mo).',
    ATTACHMENT_INVALID_TYPE: 'Format non supporté.',
    ATTACHMENT_UPLOAD_FAILED: "Échec de l'envoi de la pièce jointe.",
    RECORDING_DENIED: 'Microphone non autorisé. Activez-le dans les réglages du navigateur.',
    RECORDING_UNAVAILABLE: 'Enregistrement vocal non disponible sur ce navigateur.',
    AUDIO_TRANSCRIPT_LABEL: 'Transcription',
    IMAGE_LABEL: 'Image',
    VOICE_LABEL: 'Message vocal',
    DEBUG_TITLE: 'Debug IA',
    DEBUG_MODEL: 'Profil',
    DEBUG_TOKENS: 'Tokens',
    DEBUG_COST: 'Coût',
    DEBUG_NOT_AVAILABLE: 'n/a',
    DEBUG_COST_AMOUNT: '{amount} EUR',
    UNAVAILABLE: 'Pulse est momentanément indisponible. Réessaie dans quelques secondes.',
    // Suggestions d'accueil pendant et juste après le tunnel v2 (lot 5, ancrage par page).
    SUGGESTION_ONBOARDING_NEXT: 'Qu’est-ce qui me reste à faire ?',
    SUGGESTION_ONBOARDING_CLOSE: 'Je ferme un après-midi par semaine',
    SUGGESTION_ONBOARDING_DEPOSIT: 'Mets un acompte sur une prestation',
    SUGGESTION_ONBOARDING_PRIORITY: 'Aide-moi pour ma priorité du jour',
    WAITING_SLOW: 'Je consulte vos données…',
    WAITING_VERY_SLOW: "C'est un peu plus long que prévu, je suis toujours dessus, merci de patienter.",
    DEV_WARNING: 'Pulse est encore en cours de développement et peut produire des réponses incorrectes.',
    SUGGESTION_BLOG: 'Écrire un article de blog',
    SUGGESTION_NEWSLETTER: 'Préparer une newsletter',
    SUGGESTION_APPOINTMENTS: 'Résumer mes rendez-vous du jour',
    SUGGESTION_BLOCK_DAY: 'Bloquer ma journée de demain',
    SUGGESTION_ADD_APPOINTMENT: 'Ajouter un rendez-vous',
    SUGGESTION_STATS: 'Analyser mes statistiques',
    SUGGESTION_TODAY_APPOINTMENTS: "Quels sont mes rendez-vous importants aujourd'hui ?",
    SUGGESTION_DAY_BRIEF: 'Préparer un brief pour ma journée',
    SUGGESTION_CAMPAIGN_STATS: 'Analyser les performances de mes campagnes',
    SUGGESTION_SEO_ARTICLE: 'Écrire un article optimisé SEO',
    SUGGESTION_CONTENT_IDEAS: 'Proposer des idées de contenus',
    FALLBACK_DEFAULT:
      "Je n'ai pas réussi à traiter ta demande cette fois-ci. Réessaie dans un instant, ou reformule-la en une phrase.",
    CARD_SUPPORT_TITLE: 'Aide & support',
    CARD_SUPPORT_DESCRIPTION:
      "Je n'ai pas la réponse fiable à ta question : la page support contient une FAQ détaillée et un accès direct à notre équipe humaine.",
    CARD_SUPPORT_OPEN: 'Ouvrir la page support',
    CONFIRMATION_ACTION_LABEL: 'Action à confirmer',
    CONFIRMATION_SUMMARY_GENERIC: 'Je réalise cette action dès que tu confirmes.',
    CONFIRMATION_SUMMARY_BLOCK_SLOT: 'Je bloque un créneau dans ton agenda.',
    CONFIRMATION_SUMMARY_OPEN_SLOT: 'Je rouvre un créneau dans ton agenda.',
    CONFIRMATION_SUMMARY_UPDATE_WEEKLY_HOURS: 'Je modifie un jour de tes horaires de la semaine.',
    CONFIRMATION_SUMMARY_CREATE_APPOINTMENT: 'Je crée un rendez-vous dans ton agenda.',
    CONFIRMATION_SUMMARY_UPDATE_APPOINTMENT: 'Je modifie un rendez-vous de ton agenda.',
    CONFIRMATION_SUMMARY_CANCEL_APPOINTMENT: "J'annule un rendez-vous de ton agenda.",
    CONFIRMATION_SUMMARY_CREATE_CUSTOMER: "J'ajoute un nouveau client à ta clientèle.",
    CONFIRMATION_SUMMARY_SCHEDULE_CAMPAIGN: "Je programme l'envoi de ta campagne.",
    CONFIRMATION_SUMMARY_UNSCHEDULE_CAMPAIGN: "J'annule la programmation de ta campagne.",
    CONFIRMATION_SUMMARY_TEST_CAMPAIGN: "J'envoie un email de test pour vérifier le rendu.",
    CONFIRMATION_SUMMARY_CREATE_CAMPAIGN: 'Je crée une nouvelle campagne email.',
    CONFIRMATION_SUMMARY_UPDATE_WEBSITE_TEXTS: 'Je modifie des textes de ton site (enregistrés en brouillon).',
    CONFIRMATION_SUMMARY_UPDATE_PAGE_SEO: "Je mets à jour le SEO d'une page de ton site (en brouillon).",
    CONFIRMATION_SUMMARY_CREATE_ARTICLE: 'Je crée un article de blog en brouillon.',
    CONFIRMATION_SUMMARY_COMPOSE_EMAIL: "Je prépare le contenu de l'email.",
    CONFIRMATION_CONFIRM: 'Confirmer',
    CONFIRMATION_CANCEL: 'Annuler',
    CONFIRMATION_DONE: 'Confirmé',
    CONFIRMATION_CANCELLED: 'Annulé',
    CONFIRMATION_ERROR: 'Une erreur est survenue, réessaie dans un instant.',
    TOOL_CONFIRM_SUCCESS: "C'est fait ✅",
    TOOL_CONFIRM_ERROR:
      "Je n'ai pas réussi à réaliser cette action. Tu peux reformuler ta demande ou réessayer dans un instant.",
    TOOL_CANCELLED: 'Action annulée. Dis-moi ce que tu veux faire à la place.',
    // Carte de confirmation créée sur le web, puis confirmée depuis l'app
    // mobile alors que l'écriture n'y est pas autorisée. Aucun lien, aucune
    // invitation à souscrire : App Review 3.1.3(f).
    TOOL_UNAVAILABLE_ON_SURFACE:
      "Cette action ne peut pas être réalisée depuis l'application. Ouvre l'app web sur ordinateur pour la faire.",
    WHATSAPP_UNSUPPORTED_TYPE:
      "Désolé, je ne peux pas encore traiter ce type de message. Tu peux m'envoyer du *texte*, une *photo* ou une *note vocale* et je m'occupe du reste.",
    // Transparence IA (AI Act art. 50) : affiché sur l'état d'accueil de l'écran Pulse natif.
    AI_DISCLOSURE: 'Pulse est une intelligence artificielle. Vérifiez les informations importantes avant d’agir.',
    HISTORY_LOAD_ERROR: 'Impossible de charger la conversation. Vérifiez votre connexion, puis réessayez.',
    HISTORY_RETRY: 'Réessayer',
    // Carte de confirmation non traitée dans l'heure : le cron de purge l'a passée en REFUSED.
    CONFIRMATION_EXPIRED: 'Cette action a expiré. Redemande-la moi si tu la veux toujours.',
    // CTA Pulse en tête de l'accueil, rendu UNIQUEMENT dans l'app mobile quand la coque
    // déclare la capability `pulse.open` (écran Pulse natif).
    MOBILE_HOME_CTA_TITLE: 'Parlez à Pulse',
    MOBILE_HOME_CTA_HINT: 'Bloquer un créneau, ajouter un rendez-vous, préparer une campagne : demandez-le.',
    MOBILE_HOME_CTA_BUTTON: 'Ouvrir Pulse',
  },
  SEARCH_COMPONENT: {
    TITLE: 'Rechercher',
    PLACEHOLDER: 'Rechercher...',
    FILTER_ALL: 'Tous',
    FILTER_CUSTOMERS: 'Clients',
    FILTER_TEAM_MEMBERS: 'Membres',
    FILTER_PLACES: 'Lieux',
    FILTER_PRESTATIONS: 'Prestations',
    FILTER_VOUCHERS: 'Bons',
    LOADING: 'Recherche en cours…',
    EMPTY: 'Aucun résultat.',
    RECENT_LABEL: 'Récemment recherchés',
    EMPTY_DESC: "Essayez d'autres mots clés",
    HELP_CLOSE: 'Fermer',
    HELP_SELECT: 'Sélectionner',
    RESULTS_LABEL: 'résultat(s)',
    CLEAR_SEARCH: 'Effacer la recherche',
    HINT: 'Clients, membres, lieux, prestations, bons…',
  },
  TIME_SLOTS: {
    TITLE: 'Plages horaires',
    ADD_PARAMETER: 'Ajouter un paramètre',
    ADD_SLOT: 'Ajouter un créneau',
    ADD_PARAMETER_TITLE: 'Ajouter un paramètre aux plages horaires',
    PARAM_PRO_PLACE: 'Lieu des rendez-vous',
    PARAM_TYPE: 'Type de rendez-vous',
    PARAM_IS_GROUP: 'Rendez-vous individuel ou en groupe',
    PARAM_MAX_BOOKING: 'Nombre maximum de rendez-vous par plage horaire',
    PARAM_RESTRICTED_TAGS: 'Qui peut réserver ?',
    PARAM_PRESTATION: 'Prestations disponibles',
    SELECT_PLACES: 'Sélectionner les lieux',
    SELECT_TYPE: 'Sélectionner le type',
    GROUP_APPOINTMENT: 'Rendez-vous en groupe',
    MAX_BOOKING_PLACEHOLDER: 'Max RDV',
    SELECT_RESTRICTED_TAGS: 'Sélectionner les tags clients autorisés',
    SELECT_PRESTATION_MODE: 'Sélectionner le mode de prestations',
    SELECT_PRESTATIONS: 'Sélectionner les prestations',
    ADD_SPECIFIC_DATE: 'Ajouter une date ponctuelle',
    SPECIFIC_DATE_NUMBER: 'Disponibilité à une date précise {number}',
    DEFAULT_VALUE: 'Par défaut',
    USE_DEFAULT_VALUES: 'Reprendre les valeurs par défaut',
    MEMBERS_SUMMARY: 'Membres : {names}',
    SELECT_DATE_MEMBERS: 'Choisir les membres pour cette plage',
    SELECT_AT_LEAST_ONE_MEMBER: 'Sélectionnez au moins un membre pour cette plage.',
    SELECT_GLOBAL_MEMBERS_FIRST: 'Sélectionnez les membres par défaut dans le formulaire.',
    SELECT_DATE: 'Sélectionner une date',
    SPECIFIC_DATE_REPLACES_WEEKLY:
      'Remplace les horaires habituels de ce jour : seules les plages de cette date seront proposées.',
    EDIT_PARAMETERS: 'Modifier les paramètres',
    PLACES_SUMMARY: '{firstLabel} +{count} {count, plural, =1 {autre} other {autres}}',
    PRESTATIONS_SUMMARY: '{count} {count, plural, =1 {prestation} other {prestations}}',
    MAX_BOOKING_SUMMARY: 'Max {count} RDV',
  },
  API_ERRORS: {
    // Planning hebdomadaire par Pulse (`PATCH availability/weekly-day`)
    NO_WEEKLY_PLANNING: "Aucun planning hebdomadaire à modifier : créez d'abord vos horaires dans l'agenda.",
    WEEKLY_PLANNING_AMBIGUOUS: 'Plusieurs plannings existent : précisez lequel modifier.',
    /** 403 du garde captcha quand le widget n'a pu fournir de jeton (clé affichée telle quelle jusqu'au 31/10). */
    CAPTCHA_REQUIRED: 'La vérification anti-robot a échoué. Rechargez la page et réessayez.',
    // Tunnel obligatoire (onboarding v4)
    TUNNEL_STEP_UNKNOWN: 'Cette étape du parcours est inconnue.',
    PULSE_WRITING_EMPTY_GENERATION: "Pulse n'a rien rédigé cette fois-ci. Réessayez dans un instant.",
    PULSE_WRITING_TARGET_ID_REQUIRED: 'Choisissez la prestation à décrire.',
    PULSE_WRITING_TEXT_NOT_FOUND: "Ce texte n'existe plus. Rechargez la page et réessayez.",
    PULSE_WRITING_PRESTATION_NOT_FOUND: "Cette prestation n'existe plus. Rechargez la page et réessayez.",
    TUNNEL_NOT_COMPLETE: 'Il reste une étape à terminer avant d’ouvrir votre espace.',
    PAYMENT_RULE_PERCENTAGE_REQUIRED: 'Indiquez le pourcentage de l’acompte.',
    PAYMENT_RULE_PRESTATIONS_REQUIRED: 'Choisissez au moins une prestation.',
    // Site par style (onboarding v4, lot 7) : contrôle de publication
    WEBSITE_PUBLISH_EMPTY_HEADLINE: 'Votre page d’accueil n’a pas d’accroche : ajoutez un titre avant de publier.',
    WEBSITE_PUBLISH_BROKEN_IMAGE: 'Une image du site est cassée : remplacez-la avant de publier.',
    WEBSITE_LOGO_NOT_PROVISIONAL: 'Vous avez déjà un vrai logo : le monogramme provisoire ne le remplace pas.',
    PRESTATION_FIXED_AMOUNT_REQUIRED:
      'Indiquez un montant fixe supérieur à 0, ou repassez le calcul en pourcentage du prix.',
    LEAD_RESET_CONVERTED: 'Ce lead a déjà un compte pro : son contexte ne peut pas être remis à zéro.',
    LEAD_PHONE_INVALID:
      'Numéro de téléphone non reconnu : indiquez-le avec l’indicatif (+33…) ou au format national (06…).',
    LEAD_EMAIL_INVALID: 'Adresse email non valide.',
    INVALID_VAT_NUMBER:
      'N° de TVA intracommunautaire invalide : vérifiez la clé (les 2 chiffres après FR) et le SIREN. Laissez le champ vide si vous n’en avez pas.',
    // ── Bascules programmées (admin, source v1) ─────────────────────────────
    MIGRATION_BASCULE_NOT_FOUND: 'Demande de bascule introuvable côté v1.',
    MIGRATION_BASCULE_ALREADY_CLOSED:
      "Cette demande n'est plus programmée côté v1 (annulée par le pro ou déjà réalisée).",
    MIGRATION_BASCULE_NOT_DONE: "L'email de fin de bascule ne peut être envoyé que pour une bascule validée.",
    MIGRATION_BASCULE_NO_V2_ACCOUNT:
      "Aucun compte Propelsia n'est rattaché à ce pro : impossible de générer le lien de mot de passe.",
    MIGRATION_BASCULE_V1_UNAVAILABLE: 'La v1 est injoignable, réessayez dans un instant.',
    // ── Renvoi d'une notification depuis l'historique client ───────────────
    NOTIFICATION_NOT_FOUND: 'Notification introuvable.',
    NOTIFICATION_NOT_RESENDABLE: 'Cette notification ne peut pas être renvoyée.',
    NOTIFICATION_ALREADY_RETRIED:
      "Cette notification a déjà été renvoyée : consultez la tentative la plus récente dans l'historique.",
    NOTIFICATION_BOOKING_CHANGED:
      "La réservation a changé depuis l'envoi initial : cette notification n'est plus d'actualité.",
    NOTIFICATION_BOOKING_PAST: 'Le rendez-vous est passé : cette notification ne peut plus être renvoyée.',
    NOTIFICATION_RECIPIENT_UNREACHABLE: "Le client n'a pas d'email ou de téléphone pour ce canal.",
    NOTIFICATION_CHANNEL_DISABLED: 'Ce canal est désactivé pour cette notification dans vos préférences.',
    AVAILABILITY_EMPTY: 'Ajoutez au moins une plage hebdomadaire ou une disponibilité à une date précise.',
    AVAILABILITY_START_REQUIRED: 'Renseignez une date de début pour vos plages hebdomadaires.',
    // ── Agenda : rendez-vous chaînés & annulation partielle ────────────────
    CHAIN_LINE_WITHOUT_DURATION:
      'Une des prestations sélectionnées n’a pas de durée : impossible de répartir le rendez-vous en créneaux successifs.',
    CHAINED_SEGMENT_REQUIRES_PRESTATION:
      'Ce créneau fait partie d’une réservation à plusieurs créneaux : il doit garder au moins une prestation. Utilisez « Retirer ce créneau » pour le supprimer.',
    PARTIAL_CANCEL_APPOINTMENT_REQUIRED: 'Sélectionnez le créneau à retirer de la réservation.',
    PARTIAL_CANCEL_RIDE_UNSUPPORTED: 'Une course s’annule dans son ensemble : impossible de n’en retirer qu’un trajet.',
    APPOINTMENT_TEAM_MEMBER_REQUIRED: 'Sélectionnez au moins un membre de l’équipe pour ce rendez-vous.',
    // ── Affiliation v2 ─────────────────────────────────────────────────────
    // Sans ces entrées, `custom-fetcher` / `ShowAlert` retombent sur
    // FRIENDLY_GLOBAL_ERROR : l'affilié qui saisit un mauvais code verrait
    // « une erreur est survenue » au lieu du message que le backend définit.
    AFFILIATE_OTP_INVALID: 'Ce code de connexion est invalide ou expiré. Demandez-en un nouveau.',
    AFFILIATE_TERMS_NOT_ACCEPTED: 'Vous devez accepter les conditions du programme pour continuer.',
    AFFILIATE_ACTIVATION_OWNER_ONLY:
      'Seul le propriétaire du compte peut activer le programme ambassadeur pour l’établissement.',
    AFFILIATE_ACCOUNT_UNAVAILABLE:
      'Un compte ambassadeur existe déjà pour cette adresse email et n’est plus actif. Contactez le support.',
    AFFILIATE_PAYOUT_THRESHOLD_NOT_REACHED: 'Votre solde à verser n’atteint pas encore le seuil minimum.',
    AFFILIATE_PAYOUT_DETAILS_REQUIRED: 'Complétez vos coordonnées de versement avant de demander un versement.',
    AFFILIATE_PAYOUT_DETAILS_MISSING: 'Les coordonnées de versement de cet ambassadeur sont incomplètes.',
    AFFILIATE_PAYOUT_IBAN_INVALID: 'Cet IBAN est invalide. Vérifiez la saisie.',
    AFFILIATE_PAYOUT_BIC_INVALID: 'Ce BIC est invalide. Vérifiez la saisie.',
    AFFILIATE_PAYOUT_REFERENCE_REQUIRED: 'Une référence de paiement est obligatoire pour ce mode de règlement.',
    AFFILIATE_NOT_FOUND: 'Cet ambassadeur est introuvable.',
    AFFILIATE_EMAIL_EXISTS: 'Un ambassadeur utilise déjà cette adresse email.',
    AFFILIATE_REF_TOKEN_EXISTS: 'Ce code de parrainage est déjà utilisé par un autre ambassadeur.',
    AFFILIATE_NOT_CLIENT_PRO: 'Ce mode de règlement est réservé aux ambassadeurs client pro.',
    AFFILIATE_PRO_SUBSCRIPTION_REQUIRED:
      'Cet ambassadeur n’a pas d’abonnement actif : la cagnotte ne peut pas être convertie en remise.',
    AFFILIATE_COMMISSION_SELECTION_INVALID:
      'La sélection de commissions n’est plus valide. Rechargez la page et réessayez.',
    AFFILIATE_SETTLE_MODE_REGIME_MISMATCH: 'Ce mode de règlement ne correspond pas au régime de l’ambassadeur.',
    AFFILIATE_SETTLE_TOTAL_NOT_POSITIVE: 'Le total à régler doit être positif.',
    AFFILIATE_PROFESSIONAL_NOT_FOUND: 'Ce professionnel est introuvable.',
    AFFILIATE_PROFESSIONAL_ALREADY_LINKED: 'Ce compte pro est déjà rattaché à un autre ambassadeur.',
    AFFILIATE_UNLINK_REGIME_REQUIRED: 'Choisir le régime de versement à appliquer après le détachement du compte pro.',
    AFFILIATE_REGIME_PRO_LINK_MISMATCH:
      'Un ambassadeur rattaché à un compte pro doit être en régime « Client (réduction abo) ».',
    AFFILIATE_PROFESSIONAL_ALREADY_REFERRED: 'Ce professionnel est déjà rattaché à un ambassadeur.',
    AFFILIATE_SUSPENDED: 'Cet ambassadeur est suspendu : aucun filleul ne peut lui être rattaché.',
    AFFILIATE_SELF_REFERRAL:
      'Auto-parrainage refusé : ce professionnel est l’établissement de l’ambassadeur ou partage un email avec lui.',
    AFFILIATE_RECONCILIATION_NOT_FOUND: 'Cette ligne de réconciliation est introuvable.',
    AFFILIATE_RECONCILIATION_PRO_REQUIRED: 'Sélectionnez le professionnel à rattacher pour résoudre cette ligne.',
    AFFILIATE_REVIEW_REASON_REQUIRED: 'Un motif est obligatoire pour refuser un parrainage.',
    // Espace affilié : pont session pro → dashboard affilié (aucun compte affilié rattaché).
    NOT_AN_AFFILIATE: 'Aucun compte ambassadeur n’est associé à votre compte pour le moment.',
    // Catégories de blog : le slug sert d'URL publique, il doit rester unique par pro.
    PRO_NEWS_TAG_SLUG_ALREADY_USED:
      'Une autre catégorie utilise déjà cette URL (slug). Choisissez un autre nom ou modifiez le slug.',
    PRO_NEWS_TAG_SLUG_INVALID:
      'Ce nom ne permet pas de créer une URL (slug) : ajoutez au moins une lettre ou un chiffre.',
    // Import de base clients CSV/XLSX.
    IMPORT_INVALID_FILE:
      'Le fichier n’a pas pu être lu. Vérifiez qu’il s’agit d’un fichier CSV ou Excel (XLSX) non vide.',
    IMPORT_TOO_MANY_ROWS: `Le fichier dépasse la limite de ${CUSTOMER_IMPORT_MAX_ROWS.toLocaleString('fr-FR')} lignes. Découpez-le en plusieurs fichiers.`,
    IMPORT_INVALID_STATE: 'Cette action n’est pas possible dans l’état actuel de l’import. Rafraîchissez la page.',
    IMPORT_MAPPING_EMPTY: 'Associez au moins une colonne à un champ client avant de continuer.',
    IMPORT_TOO_MANY_NEW_TAGS: `Cet import créerait plus de ${CUSTOMER_IMPORT_MAX_NEW_TAGS} nouveaux tags. Vérifiez qu’une colonne à forte variété de valeurs (ex. ville) n’est pas associée aux tags.`,
    IMPORT_REPORT_NOT_AVAILABLE: 'Aucun rapport n’est disponible pour cet import.',
    // Réconciliation des suppressions calendrier déclenchée depuis la fiche pro admin.
    CALENDAR_SYNC_NO_IMPORTING_CONNECTION:
      'Ce professionnel n’a aucune connexion calendrier active en import : il n’y a rien à réconcilier.',
    // Remboursement de facture depuis l'admin (avoir).
    INVOICE_NOT_FOUND: 'Facture introuvable.',
    INVOICE_NOT_REFUNDABLE:
      'Cette facture ne peut pas être remboursée (non émise, déjà remboursée, ou c’est un avoir).',
    INVOICE_PROVIDER_NOT_REFUNDABLE:
      'Cette facture a été émise chez un provider qui ne sait pas produire d’avoir. Effectuez le remboursement manuellement depuis Stripe.',
    INVOICE_PAYMENT_REF_MISSING:
      'Aucune référence de paiement n’est enregistrée sur cette facture : le remboursement doit être fait manuellement depuis Stripe.',
    INVOICE_PAID_BY_SEPA_DEBIT:
      'Cette facture a été réglée par prélèvement SEPA (GoCardless) : remboursez-la manuellement depuis le tableau de bord GoCardless, puis créez l’avoir correspondant.',
    REFUND_AMOUNT_INVALID: 'Le montant du remboursement dépasse le montant remboursable.',
    REFUND_PROVIDER_FAILED: 'Le remboursement a été refusé par le prestataire de paiement. Rien n’a été débité.',
    REFUND_IN_PROGRESS: 'Un remboursement est déjà en cours sur cette facture. Patientez puis rafraîchissez.',
    REFUND_PREVIOUS_ATTEMPT_RECOVERED:
      'Une tentative précédente avait déjà remboursé une partie de cette facture : elle vient d’être régularisée et l’avoir correspondant émis. Vérifiez le montant restant avant de relancer.',
    SUPPORT_MESSAGE_EMPTY: 'Votre message doit contenir du texte ou au moins une pièce jointe.',
    SUPPORT_MESSAGE_TOO_LONG: 'Votre message est trop long (5000 caractères maximum).',
    SUPPORT_SUBJECT_TOO_LONG: 'Le sujet est trop long (200 caractères maximum).',
    SUPPORT_ATTACHMENT_INVALID_TYPE: 'Ce type de fichier n’est pas autorisé.',
    SUPPORT_ASSIST_NOT_PENDING: 'Cette suggestion a déjà été traitée.',
    SUPPORT_ASSIST_FORBIDDEN_IMPERSONATION: 'Seul le professionnel peut accepter ou refuser une suggestion.',
    GOOGLE_RESERVE_SUBSCRIPTION_REQUIRED:
      '🔒 La demande « Réserver avec Google » est réservée aux comptes avec un abonnement actif.',
    GOOGLE_RESERVE_INVALID_STATE: 'Cette action n’est pas possible dans l’état actuel de votre demande.',
    GOOGLE_RESERVE_PRO_NOT_FOUND: 'Professionnel introuvable.',
    GOOGLE_RESERVE_NOT_PENDING: 'Cette demande n’est pas (ou plus) en attente de revue.',
    GOOGLE_RESERVE_PLACE_NOT_FOUND: 'Lieu introuvable ou non éligible.',
    GOOGLE_RESERVE_PLACE_QUOTA_REACHED:
      'Quota de lieux atteint pour votre abonnement. Passez à un plan supérieur pour activer plus de lieux.',
    HARD_LIMIT_REACHED: 'Limite atteinte pour ce type de données. Contactez le support pour en savoir plus.',
    RIDE_CONFIG_NOT_FOUND: 'Ce professionnel ne propose pas de réservation de course pour le moment.',
    RIDE_VEHICLE_NOT_FOUND:
      'Aucun véhicule disponible pour ce nombre de passagers ou de bagages. Réduisez le nombre ou choisissez un autre véhicule.',
    RIDE_NO_PRICING_TIER_FOUND: "Aucun tarif n'est disponible pour ce créneau. Essayez un autre horaire.",
    RIDE_VEHICLE_UNAVAILABLE: "Aucun véhicule n'est disponible sur ce créneau. Choisissez un autre horaire.",
    RIDE_NO_DRIVER_AVAILABLE: "🚗 Aucun chauffeur n'est disponible sur ce créneau. Essayez un autre horaire.",
    RIDE_PRESTATION_NOT_FOUND: "Cette formule de course n'existe plus. Rechargez la page et réessayez.",
    RIDE_TOO_SOON: 'Ce professionnel demande un délai de réservation minimum. Choisissez un horaire plus éloigné.',
    RIDE_TOO_FAR: 'Cette date est trop éloignée pour réserver en ligne. Choisissez une date plus proche.',
    RIDE_OUTSIDE_OPENING_HOURS:
      "Ce professionnel n'accepte pas de prise en charge à cet horaire. Choisissez un horaire dans ses heures d'ouverture.",
    RIDE_PRESTATION_REQUIRED: 'Choisissez une formule de course. Rechargez la page si le problème persiste.',
    RIDE_GROUP_TOO_LARGE:
      '🚫 Aucun véhicule, seul ou combiné, ne peut accueillir ce groupe. Réduisez le nombre de passagers ou de bagages, ou contactez le professionnel.',
    RIDE_TOO_MANY_VEHICLES:
      '🚫 Trop de véhicules demandés pour une même réservation. Réduisez la composition ou faites plusieurs réservations.',
    RIDE_QUOTE_CHANGED: 'Le devis a été mis à jour depuis son affichage. Recalculez le prix avant de réserver.',
    RIDE_INVALID_DATETIME: 'La date de prise en charge doit être dans le futur (et le retour après le départ).',
    RIDE_RETURN_BEFORE_OUTBOUND_END: "Le retour doit commencer après la fin estimée de l'aller.",
    RIDE_ROUTE_NOT_FOUND:
      "Aucun itinéraire routier n'a été trouvé entre le départ et l'arrivée. Vérifiez les adresses.",
    RIDE_PICKUP_OUTSIDE_ZONE: "📍 L'adresse de départ est en dehors de la zone couverte par ce professionnel.",
    RIDE_DEPOSIT_PERCENTAGE_REQUIRED: "Indiquez le pourcentage d'acompte pour activer ce mode de paiement.",
    RIDE_DEFAULT_ADDRESS_INCOMPLETE:
      "L'adresse par défaut du trajet est incomplète : sélectionnez une adresse proposée par l'autocomplétion.",
    RIDE_ZONE_NOT_FOUND: "Cette zone forfaitaire n'existe plus. Rechargez la page et réessayez.",
    RIDE_ZONE_POLYGON_REQUIRED: "Dessinez la zone de départ et la zone d'arrivée avant d'enregistrer.",
    RIDE_ROUTING_UNAVAILABLE:
      "Le calcul des itinéraires (Google) est momentanément indisponible : rien n'a été enregistré. Réessayez dans quelques minutes.",
    RIDE_DISTANCE_BANDS_MODE_REQUIRED:
      'Des seuils dégressifs ne peuvent être envoyés qu’avec le mode « Grille propre à ce véhicule ».',
    RIDE_DISTANCE_BANDS_INVALID:
      'Tarif dégressif invalide : 3 seuils maximum, avec des distances et des réductions qui augmentent d’un seuil à l’autre (ex. 50 km → 15 %, puis 150 km → 30 %). Réduction entre 1 et 99 %.',
    CONTACT_SUBMISSION_NO_REACHABLE_CONTACT: 'Indiquez au moins un email ou un numéro de téléphone.',
    AGENDA_WINDOW_TOO_LARGE: 'La période demandée est trop large. Réduisez la plage de dates affichée.',
    STATS_DATE_RANGE_INCOMPLETE: 'Indiquez une date de début et une date de fin.',
    STATS_DATE_RANGE_INVALID:
      'La plage de dates est invalide : la fin doit suivre le début et ne pas dépasser aujourd’hui.',
    STATS_WINDOW_TOO_LARGE: 'La période demandée dépasse 12 mois.',
    STATS_PERIOD_NOT_ALLOWED: 'Cette période est disponible avec les formules Pro et Max.',
    STATS_INVALID_DIMENSION: 'Dimension d’analyse inconnue.',
    STATS_DIMENSION_REQUIRES_UPGRADE: 'L’analyse par membre et par lieu est disponible avec la formule Max.',
    ADMIN_USER_EMAIL_TAKEN: 'Un administrateur existe déjà avec cet email.',
    ADMIN_USER_CANNOT_MODIFY_SELF:
      'Vous ne pouvez pas vous désactiver, vous supprimer ou rétrograder votre propre compte.',
    ADMIN_USER_LAST_SUPER_ADMIN: 'Impossible : c’est le dernier super admin actif.',
    AI_ASSIST_UNAVAILABLE: "L'assistant IA est momentanément indisponible. Réessayez dans un instant.",
    TOO_MANY_REDIRECTS: '🚫 Vous avez atteint le nombre maximum de redirections.',
    INVALID_REDIRECT_SOURCE: '🚫 L’adresse à rediriger est invalide (elle doit commencer par « / »).',
    INVALID_REDIRECT_DESTINATION: '🚫 La destination de la redirection est manquante ou invalide.',
    DUPLICATE_REDIRECT_SOURCE: '🚫 Deux redirections pointent depuis la même adresse.',
    REDIRECT_LOOP: '🚫 Une redirection pointe vers sa propre adresse.',
    TOO_MANY_SCRIPTS: '🚫 Vous avez atteint le nombre maximum de scripts.',
    INVALID_SCRIPT_LABEL: '🚫 Donnez un nom à chaque script (100 caractères max).',
    INVALID_SCRIPT_SRC: '🚫 L’adresse du script est invalide : une URL https:// est requise.',
    INVALID_SCRIPT_SNIPPET: '🚫 Le code du script est vide ou contient une balise <script> interdite.',
    SCRIPT_SNIPPET_TOO_LARGE: '🚫 Le code du script est trop long (10 000 caractères max).',
    INVALID_GOOGLE_TRACKING_ID:
      '🚫 Identifiant Google invalide (formats acceptés : GTM-XXXX, G-XXXX, AW-XXXX, UA-XXXX).',
    INVALID_META_PIXEL_ID: '🚫 Identifiant Meta Pixel invalide : il ne contient que des chiffres.',
    INVALID_TIKTOK_PIXEL_ID: '🚫 Identifiant Pixel TikTok invalide : lettres et chiffres uniquement (8-32 caractères).',
    INVALID_GOOGLE_ADS_CONVERSION_LABEL:
      '🚫 Libellé de conversion Google Ads invalide : lettres, chiffres, tirets et tirets bas uniquement.',
    DNS_ZONE_NOT_AVAILABLE:
      '🚫 La zone DNS de ce domaine n’est pas modifiable pour le moment (activation, transfert ou paiement en cours).',
    DNS_RECORD_NOT_FOUND: '🚫 Cet enregistrement DNS est introuvable. Rechargez la zone.',
    DNS_RECORD_PROTECTED:
      '🔒 Cet enregistrement est géré automatiquement par la plateforme et ne peut pas être modifié.',
    DNS_RECORD_MAIL_MANAGED:
      '🔒 Cet enregistrement est géré par votre hébergement email. Désactivez vos boîtes mail pour le modifier.',
    DNS_RECORD_TYPE_UNSUPPORTED: '🚫 Ce type d’enregistrement n’est pas modifiable depuis cette interface.',
    DNS_RECORD_INVALID_TARGET: '🚫 La valeur de l’enregistrement est invalide pour ce type.',
    DNS_RECORD_LIMIT_REACHED: '🚫 Vous avez atteint le nombre maximum d’enregistrements pour cette zone.',
    DNS_CNAME_CONFLICT:
      '🚫 Un CNAME ne peut pas coexister avec un autre enregistrement sur le même nom. Supprimez d’abord l’enregistrement existant.',
    DNS_PROVIDER_REJECTED: '🚫 Le registrar a refusé cette modification. Vérifiez la valeur et réessayez.',
    DNS_SPF_ALREADY_EXISTS:
      '🚫 Votre domaine a déjà une règle SPF (enregistrement qui commence par « v=spf1 »). Un domaine n’en accepte qu’une seule : modifiez celle qui existe au lieu d’en ajouter une.',
    DNS_SPF_LEGACY_EXISTS:
      '🚫 Votre domaine porte encore une ancienne règle SPF (type « SPF ») qui ne peut pas être modifiée ici. Supprimez-la d’abord (corbeille), puis ajoutez votre nouvelle règle.',
    DOMAIN_PREMIUM_NOT_OFFERED:
      '🚫 Ce nom de domaine est vendu à un tarif premium par le registrar : il ne peut pas être offert. Choisissez un autre nom, ou contactez-nous pour un devis.',
    DOMAIN_PRICE_CHECK_UNAVAILABLE:
      '⚠️ Impossible de vérifier le tarif de ce domaine auprès du registrar pour le moment. Réessayez dans quelques minutes.',
    NOTHING_TO_REVERT: '🚫 Votre site n’a jamais été publié : il n’y a pas de version en ligne à restaurer.',
    UNKNOWN_CHANGE_GROUP: '🚫 Cette modification n’existe plus. Rechargez la page pour voir la liste à jour.',
    WEBSITE_ALREADY_UNPUBLISHED: '🚫 Votre site n’est pas publié : il n’y a rien à dépublier.',
    WEBSITE_NOT_CONFIGURED: '🚫 Votre site web n’est pas encore configuré.',
    WEBSITE_PAGE_NOT_FOUND: '🚫 Cette page du site est introuvable.',
    WEBSITE_BLOCK_NOT_FOUND: '🚫 Ce bloc est introuvable sur la page ciblée.',
    WEBSITE_SHARED_BLOCK_NOT_EDITABLE:
      '🚫 Ce bloc est partagé entre plusieurs pages (menu, pied de page…) : modifiez-le depuis l’éditeur du site.',
    WEBSITE_TEXTS_INVALID: '🚫 Un ou plusieurs champs ciblés sont invalides : aucune modification n’a été faite.',
    WEBSITE_SEO_EMPTY: '🚫 Renseignez au moins un champ SEO (titre, meta title ou meta description).',
    WEBSITE_MODIFIED_CONCURRENTLY:
      '🚫 Le site a été modifié entre-temps (éditeur ouvert ailleurs ?) : aucune modification enregistrée, réessayez.',
    APPOINTMENT_NOT_FOUND: '🚫 Ce rendez-vous est introuvable.',
    INVALID_RECURRENCE_RULE: '🔁 Cette règle de récurrence est invalide ou non prise en charge.',
    BOOKING_MANAGE_LINK_EXPIRED: '⏳ Ce lien a expiré.',
    EXTERNAL_BLOCK_NOT_EDITABLE:
      "🔒 Cet événement vient d'un agenda externe (Google, Outlook…) : modifiez-le ou supprimez-le directement là-bas, il se mettra à jour automatiquement ici.",
    FRIENDLY_GLOBAL_ERROR:
      '😬 Oups… un problème inattendu est survenu. Réessayez un peu plus tard, si ça continue, contactez-nous !',
    ADDRESS_OUTSIDE_ZONE: "📍 Cette adresse est en dehors de la zone d'intervention du professionnel.",
    ZONE_ADDRESS_REQUIRED: "📍 Cette prestation se fait à domicile : renseignez d'abord votre adresse.",
    ZONE_PLACE_NOT_FOUND: "🔍 Cette zone d'intervention est introuvable.",
    SESSION_REQUIRES_CAPACITY:
      '🚫 Une prestation de type session doit avoir une capacité maximale (max_session_capacity) supérieure à 0, ou être liée à une ressource avec une capacité.',
    SELF_SERVICE_REQUIRES_RESOURCE:
      '🚫 Une prestation en libre-service doit être associée à au moins un matériel ou une salle.',
    RESOURCE_CAPACITY_EXCEEDED:
      '🚫 La capacité de la ressource est atteinte pour ce créneau. Choisissez un autre horaire.',
    RESOURCE_PARTY_SIZE_EXCEEDED:
      '🚫 Cette prestation ne peut pas accueillir un groupe de cette taille. Réduisez le nombre de personnes.',
    RESOURCE_RESERVED: '🚫 Cette ressource est déjà réservée sur ce créneau. Choisissez un autre horaire.',
    SESSION_FULL: '🚫 Cette session est complète. Plus de place disponible pour ce créneau.',
    NOT_ENOUGH_TEAM_MEMBERS_AVAILABLE: "🚫 Pas assez de membres d'équipe disponibles pour ce créneau.",
    RESOURCE_SELECTION_REQUIRED: '🚫 Vous devez choisir une option (véhicule, par exemple) pour cette prestation.',
    INVALID_SELECTED_RESOURCE: "🚫 L'option sélectionnée n'est plus disponible pour cette prestation.",
    RESOURCE_POOL_UNAVAILABLE: "🚫 Aucune ressource n'est disponible sur ce créneau. Choisissez un autre horaire.",
    INVALID_TEAM_MEMBER_SCOPE:
      '🚫 La sélection de membres ne correspond pas au planning ou à l’équipe actuelle. Rechargez puis réessayez.',
    TEAM_MEMBER_ACCESS_NOT_LINKED:
      "🔒 Votre compte n'est rattaché à aucun membre de l'équipe. Demandez à un responsable de vous associer à un membre.",
    TEAM_MEMBER_ACCESS_FORBIDDEN:
      "🔒 Votre rôle ne vous permet d'agir que sur votre propre agenda. Seul un responsable peut agir sur celui des autres membres.",
    INTERNAL_ADMIN_ACCESS_REQUIRED:
      "🔒 Accès réservé aux administrateurs internes. Vous n'avez pas les droits nécessaires.",
    INVALID_ONBOARDING_STEP: '🚫 Cette étape de configuration est inconnue. Rechargez la page et réessayez.',
    DETECTION_SOURCE_REQUIRED: '🔍 Ajoutez un lien ou au moins une image à analyser.',
    DETECTION_IMAGE_KEY_FORBIDDEN: "🚫 Une des images n'est pas accessible. Réessayez en la réimportant.",
    DETECTION_CONSENT_REQUIRED:
      "🔒 Vous devez d'abord accepter la récupération de vos informations publiques pour lancer la recherche.",
    SIGNUP_IDENTITY_REQUIRED:
      '🚫 Indiquez le nom de votre entreprise, ou votre prénom et votre nom si elle est en cours de création.',
    SIGNUP_CITY_REQUIRED: '🚫 Indiquez la ville de votre activité pour continuer.',
    PLACES_INVALID_MODE: "🚫 Type de recherche d'adresse invalide. Rechargez la page et réessayez.",
    PLACES_INVALID_SESSION_TOKEN: "🚫 Session de recherche d'adresse invalide. Rechargez la page et réessayez.",
    PLACES_PLACE_ID_REQUIRED: '🚫 Sélectionnez une adresse dans la liste pour continuer.',
    PLACES_PROVIDER_UNAVAILABLE:
      "🌐 Le service d'autocomplétion d'adresse est momentanément indisponible. Réessayez dans un instant.",
    MAX_SERVICE_AREAS_REACHED:
      '🚫 Vous avez atteint la limite de zones ciblées. Supprimez-en une avant d’en ajouter une nouvelle, ou passez en SEO national si vous couvrez trop de territoire.',
    DUPLICATE_SERVICE_AREA: '🚫 Cette zone est déjà dans votre liste de zones ciblées.',
    NO_SERVICE_AREA_SET:
      '🚫 Vous devez cibler au moins une zone pour publier votre site en SEO local. Allez dans Réglages → Périmètre géographique.',
    SERVICE_AREA_NOT_FOUND: '🚫 Cette zone n’est plus dans votre liste.',
    REORDER_KEYS_MISMATCH: '🚫 La liste réordonnée ne correspond plus à vos zones actuelles. Rechargez la page.',
    INVALID_SERVICE_AREA_PAYLOAD:
      '🚫 La zone sélectionnée n’a pas pu être enregistrée. Réessayez avec une autre suggestion.',
    SCOPE_TRANSITION_REQUIRES_CONFIRMATION:
      '🚫 Le passage en SEO national exige une confirmation explicite via la modale dédiée.',
    DEDICATED_PAGE_REQUIRES_SLUG_AND_ADDRESS:
      '🚫 Pour publier la page dédiée d’un lieu, renseignez d’abord son URL (slug) et son adresse complète.',
    ADDRESS_REQUIRED_FOR_ESTABLISHMENT: "📍 Pour un lieu de type établissement, renseignez d'abord son adresse.",
    PHONE_NUMBER_REQUIRED_FOR_PHONE_KIND:
      "📞 Pour un lieu téléphonique, renseignez d'abord le numéro à composer pour le rendez-vous.",
    VIDEO_LINK_REQUIRED_FOR_VIDEO_KIND: '🎥 Pour un lieu visio, renseignez d’abord le lien de la salle de visio.',
    MAX_ACTIVITIES_REACHED:
      "🚫 Vous avez atteint la limite de 5 activités. Retirez-en une avant d'en ajouter une autre.",
    ACTIVITY_NOT_FOUND: "🚫 Cette activité n'existe plus dans le catalogue.",
    ACTIVITY_ALREADY_ATTACHED: '🚫 Cette activité est déjà attachée à votre profil.',
    PROFESSIONAL_ACTIVITY_NOT_FOUND: "🚫 Cette activité n'est plus attachée à votre profil.",
    LAST_ACTIVITY_CANNOT_BE_DELETED:
      '🚫 Vous devez conserver au moins une activité. Ajoutez-en une autre avant de retirer celle-ci.',
    REORDER_IDS_MISMATCH: '🚫 La liste réordonnée ne correspond plus à vos activités actuelles. Rechargez la page.',
    NO_ACTIVITY_SET: '🚫 Vous devez choisir au moins une activité pour publier votre site.',
    CUSTOM_FIELD_NOT_FOUND: "🚫 Ce champ personnalisé n'existe plus.",
    CUSTOM_FIELD_LIMIT_REACHED:
      '🚫 Vous avez atteint la limite de champs personnalisés. Archivez-en un avant d’en ajouter un nouveau.',
    CUSTOM_FIELD_TOTAL_LIMIT_REACHED:
      '🚫 Vous avez atteint le nombre maximal de questions, archivées comprises. Modifiez une question existante plutôt que d’en créer une nouvelle.',
    CUSTOM_FIELD_INVALID_OPTIONS:
      '🚫 Les listes déroulantes doivent contenir au moins une option. Ajoutez-en une avant d’enregistrer.',
    CUSTOM_FIELD_INVALID_PRESTATION:
      '🚫 Une des prestations sélectionnées est introuvable. Rechargez la page et réessayez.',
    CUSTOM_FIELD_INVALID_PLACE: '🚫 Un des lieux sélectionnés est introuvable. Rechargez la page et réessayez.',
    CUSTOMER_CUSTOM_FIELD_NOT_FOUND: "🚫 Ce champ personnalisé de fiche client n'existe plus.",
    CUSTOMER_CUSTOM_FIELD_LIMIT_REACHED:
      '🚫 Vous avez atteint la limite de champs personnalisés de fiche client. Archivez-en un avant d’en ajouter un nouveau.',
    CUSTOMER_CUSTOM_FIELD_INVALID_OPTIONS:
      '🚫 Les listes déroulantes doivent contenir au moins une option. Ajoutez-en une avant d’enregistrer.',
    CUSTOMER_CUSTOM_FIELD_TOTAL_LIMIT_REACHED:
      '🚫 Vous avez atteint le nombre maximal de champs personnalisés, archivés compris. Restaurez un champ archivé plutôt que d’en créer un nouveau.',
    CUSTOMER_CUSTOM_FIELD_LABEL_TAKEN:
      '🚫 Un autre champ personnalisé porte déjà ce nom. Choisissez un nom différent pour pouvoir les distinguer à l’import et dans vos campagnes.',
    CUSTOMER_CUSTOM_FIELD_INVALID_BOUNDS: '🚫 La valeur minimale doit être inférieure ou égale à la valeur maximale.',
    CUSTOMER_CUSTOM_FIELD_INVALID_VALUE:
      '🚫 Un champ personnalisé contient une valeur qui ne convient pas à son type (nombre hors limites, choix qui n’existe plus ou date illisible). Corrigez-la puis réessayez.',
    INSTRUCTION_INVALID_PRESTATION:
      '🚫 Une des prestations sélectionnées est introuvable. Rechargez la page et réessayez.',
    INSTRUCTION_INVALID_PLACE: '🚫 Un des lieux sélectionnés est introuvable. Rechargez la page et réessayez.',
    WIDGET_DOMAIN_NOT_FOUND: "🚫 Ce domaine n'est plus autorisé pour le widget.",
    WIDGET_DOMAIN_ALREADY_EXISTS: '🚫 Ce domaine est déjà autorisé pour le widget.',
    WRONG_CREDENTIALS: '😕 Mmh, on dirait que ces identifiants ne correspondent pas. Vérifiez et réessayez !',
    INACTIVE_ACCOUNT: '😕 Mmh, on dirait que ces identifiants ne sont pas actifs. Vérifiez vos e-mails et réessayez !',
    EMAIL_ALREADY_USED: '📧 Un compte existe déjà avec cet email. Connectez-vous ou utilisez un autre email.',
    PHONE_ALREADY_USED_LOGIN_LINK_SENT:
      '📱 Ce numéro a déjà un compte : on vient de vous envoyer votre lien de connexion par SMS.',
    QUIZ_NOT_FOUND: '🔎 Ce questionnaire a expiré ou est introuvable. Recommencez, ça prend deux minutes.',
    QUIZ_INVALID: '🚫 Une réponse est invalide. Rechargez la page et réessayez.',
    QUIZ_ALREADY_CONVERTED: '✅ Votre compte existe déjà : connectez-vous pour continuer.',
    EMAIL_SUBADDRESSING_NOT_ALLOWED:
      "📧 Les adresses email avec un « + » ne sont pas acceptées à l'inscription. Utilisez votre adresse principale.",
    INVALID_TIMEZONE: '🕒 Le fuseau horaire fourni est invalide. Rechargez la page et réessayez.',
    SLUG_GENERATION_FAILED:
      "😬 Impossible de créer votre compte pour l'instant. Réessayez dans un instant ou contactez-nous si ça persiste.",
    PASSWORD_ALREADY_SET:
      '🔒 Un mot de passe est déjà défini sur ce compte. Passez par « changer mon mot de passe » pour le modifier.',
    V1_NOT_CONFIGURED: "🌐 L'import depuis Cfixe v1 n'est pas configuré sur cet environnement. Contactez le support.",
    V1_LOGIN_FAILED:
      "😕 Connexion à Cfixe v1 impossible. Vérifiez votre email et votre mot de passe (ceux de l'ancienne app).",
    V1_SESSION_EXPIRED: "⏳ Votre session Cfixe v1 a expiré. Reconnectez-vous pour reprendre l'import.",
    MIGRATION_ALREADY_COMPLETED:
      "✅ L'import depuis Cfixe v1 a déjà été terminé pour ce compte. Contactez le support si vous devez le relancer.",
    MIGRATION_ALREADY_RUNNING: "⏳ Un import est déjà en cours. Attendez qu'il se termine avant d'en lancer un autre.",
    EXPIRED_LINK_FORGOTTEN_PASSWORD: '⏳ Ce lien a expiré. Demandez-en un nouveau, ça ira vite !',
    TAGS_LIMIT_REACHED: `🚫 Vous avez atteint la limite de ${maxTagSelectable} tags. Vous voulez en ajouter plus ? Dites-nous et on vous aidera !`,
    SUPPLEMENT_LIMIT_REACHED: `🚫 Vous avez atteint la limite de ${maxSupplementSelectable} suppléments. Vous voulez en ajouter plus ? Dites-nous et on vous aidera !`,
    SUPPLEMENT_RESOURCE_INVALID: '🔍 La ressource associée à ce supplément est introuvable.',
    SUPPLEMENT_RESOURCE_NOT_REUSABLE: '⛔ Seules les ressources réutilisables peuvent être liées à un supplément.',
    SUPPLEMENT_RESOURCE_MODE_INVALID:
      '⛔ Cette ressource est destinée à être choisie par le client. Seules les ressources « contraintes » peuvent être liées à un supplément.',
    CATEGORY_LIMIT_REACHED: `🚫 Vous avez atteint la limite de ${maxCatalogCategorySelectable} catégories. Besoin d'en plus ? Contactez-nous !`,
    CATEGORY_REORDER_MISMATCH:
      "🔄 L'ordre des catégories n'a pas pu être enregistré : la liste a changé. Rechargez la page et réessayez.",
    PRESTATIONS_REORDER_MISMATCH:
      "🔄 L'ordre des prestations n'a pas pu être enregistré : la liste a changé. Rechargez la page et réessayez.",
    SUPPLEMENTS_REORDER_MISMATCH:
      "🔄 L'ordre des suppléments n'a pas pu être enregistré : la liste a changé. Rechargez la page et réessayez.",
    PRO_RESOURCES_REORDER_MISMATCH:
      "🔄 L'ordre du matériel n'a pas pu être enregistré : la liste a changé. Rechargez la page et réessayez.",
    PACKS_REORDER_MISMATCH:
      "🔄 L'ordre des packs n'a pas pu être enregistré : la liste a changé. Rechargez la page et réessayez.",
    INVALID_AUTHOR: "🚫 L'auteur sélectionné est invalide ou n'appartient pas à votre équipe.",
    INVALID_TAGS: '🚫 Une ou plusieurs catégories sélectionnées sont invalides.',
    INVALID_GMB_LOCATIONS:
      '🚫 Une ou plusieurs fiches Google sélectionnées sont invalides. Vérifiez qu’elles sont bien reliées à un de vos lieux dans Établissement.',
    ALREADY_PUBLISHED: '🚫 Cette publication est déjà publiée.',
    SEO_ARTICLE_NOT_FOUND: 'Cet article est introuvable.',
    SEO_ADMIN_ARTICLE_NOT_FOUND: 'Article introuvable (ou pas un article de pro).',
    SEO_ADMIN_ARTICLE_NOT_REVIEWABLE:
      'Action impossible : seul un article refusé par le contrôle qualité se recontrôle ou se force « à relire » (un article déjà envoyé au pro ne se recontrôle plus), ou son statut vient de changer.',
    SEO_BACKLINK_NOT_FOUND: 'Ce lien est introuvable.',
    SEO_BACKLINK_NOT_REVIEWABLE: 'Cet article n’attend plus de validation.',
    SEO_BACKLINK_ARTICLE_INVALID:
      'L’article ne respecte pas les règles du partenaire (longueur, intertitres, liens, lien vers votre page).',
    SEO_PUBLISH_DAYS_MAX:
      'Vous avez coché plus de jours de publication que votre pack n’en comprend (2 par semaine, 4 avec l’option « Doubler mes articles »).',
    SEO_ACCELERATOR_NOT_ELIGIBLE:
      '🚫 L’accélérateur référencement est réservé aux comptes dont le pack référencement est actif (formule Max, hors essai).',
    SEO_ACCELERATOR_ALREADY_ACTIVE:
      '🚫 Vous avez déjà un accélérateur à venir ou en cours : vous pourrez en racheter un dès qu’il sera terminé.',
    SEO_AUTHOR_NOT_IN_TEAM: 'Ce membre ne fait pas (ou plus) partie de votre équipe.',
    SEO_PROFILE_INCOMPLETE:
      'Complétez d’abord votre profil (activité, prestations, zone d’intervention) : votre pack référencement démarre ensuite.',
    SEO_NOT_ONBOARDED:
      'Configurez d’abord votre pack référencement (deux minutes) : vos premiers sujets partent à la fin du parcours.',
    SEO_MONTH_QUOTA_REACHED: 'Toutes les dates de ce mois sont déjà prises : ce sujet restera en réserve.',
    SEO_TOPICS_PROPOSAL_LIMIT_REACHED: `Vous avez utilisé vos ${SEO_CLIENT_DISCOVERIES_PER_MONTH_MAX} recherches de sujets pour ce mois : écrivez au support s’il vous en faut d’autres.`,
    SEO_TOPICS_UNDECIDED: 'Dites oui ou non à chaque sujet avant d’en demander d’autres.',
    SEO_TOPICS_DISCOVERY_EMPTY:
      'Notre dernière recherche de sujets n’a rien donné de pertinent : notre équipe est prévenue et relance la recherche pour vous.',
    SEO_TOPICS_MANUAL_LIMIT_REACHED: `Vous avez atteint les ${SEO_CLIENT_MANUAL_TOPICS_PER_MONTH_MAX} sujets libres pour ce mois.`,
    SEO_TOPIC_MANUAL_INVALID:
      'Formulez votre sujet comme une recherche Google : au moins 4 caractères et 8 mots au plus (ex. : prix d’un balayage à Lyon).',
    SEO_TOPICS_NOT_LAUNCHABLE:
      'Il faut un sujet choisi pour chaque date libre du mois avant de lancer la rédaction : choisissez-en d’autres ou demandez de nouveaux sujets (et attendez la fin d’une recherche en cours).',
    SEO_ARTICLE_ALREADY_REJECTED: 'Cet article a été refusé : il ne peut plus être programmé.',
    SEO_ARTICLE_NOT_READY: 'Cet article est encore en contrôle qualité : il ne peut pas être programmé pour l’instant.',
    NOT_PUBLISHED: "🚫 Cette publication n'est pas publiée.",
    GMB_DISTRIBUTION_DISABLED:
      '🚫 Le partage Google est désactivé sur cette publication. Rouvrez-la et cochez « Publier sur Google My Business » pour le réactiver.',
    NOT_SCHEDULED: "🚫 Cette publication n'est pas programmée.",
    SCHEDULED_DATE_IN_PAST: '🚫 La date de programmation doit être dans le futur.',
    NO_RECIPIENT_TO_SEND:
      "🚫 Aucun destinataire trouvé pour l'envoi. Vérifiez vos tags et les fiches clients, puis réessayez.",
    INVALID_TEST_RECIPIENT:
      '🚫 Destinataire de test invalide. Saisissez un email (campagne email) ou un numéro de téléphone (campagne SMS) valide.',
    CAMPAIGN_TEST_NO_CONTENT:
      "🚫 Cette campagne n'a pas encore de contenu à tester. Ajoutez du contenu puis réessayez.",
    CAMPAIGN_ALREADY_SENT: '🚫 Cette campagne a déjà été envoyée : il n’est plus possible d’en envoyer un test.',
    CAMPAIGN_SEND_ALREADY_IN_PROGRESS:
      '🚫 Cette campagne est déjà en cours d’envoi (ou déjà envoyée) : elle ne partira pas une seconde fois.',
    CAMPAIGN_CHANGED_DURING_SEND:
      '🚫 Cette campagne a été modifiée pendant la préparation de son envoi : rien n’est parti et aucun crédit n’a été consommé. Vérifiez-la, puis relancez l’envoi.',
    CAMPAIGN_NOT_EDITABLE: '🚫 Cette campagne est en cours d’envoi ou déjà envoyée : elle ne peut plus être modifiée.',
    CAMPAIGN_PROVIDER_REFUSED:
      '🚫 Notre prestataire d’envoi a refusé cette campagne : rien n’est parti et aucun crédit n’a été consommé. Vérifiez-la (destinataires, contenu, expéditeur), puis relancez l’envoi ; contactez le support si le refus se répète.',
    CAMPAIGN_SEND_UNCONFIRMED:
      '⚠️ L’envoi de cette campagne n’a pas pu être confirmé par notre prestataire : les messages sont peut-être partis et les crédits correspondants restent décomptés pour l’instant. Pour éviter un double envoi, elle ne peut pas être relancée. Son issue est en cours de vérification : si rien n’est parti, vos crédits vous seront rendus.',
    TEST_EMAIL_NOT_WHITELISTED:
      '🚫 Hors production, seuls les emails autorisés peuvent recevoir un test. Utilisez une adresse autorisée.',
    // Expéditeur de campagnes sur le domaine du pro (campaign-sender-domain)
    SENDER_DOMAIN_WHITE_LABEL_REQUIRED: '🚫 L’envoi depuis votre propre domaine nécessite l’option Marque blanche.',
    SENDER_DOMAIN_NOT_OWNED: '🚫 Ce domaine ne fait pas partie de vos domaines.',
    SENDER_DOMAIN_NOT_ELIGIBLE:
      '🚫 Ce domaine doit être actif et sa zone DNS gérée par la plateforme pour servir d’expéditeur.',
    SENDER_DOMAIN_NOT_FOUND: '🚫 Domaine expéditeur introuvable.',
    SENDER_DOMAIN_CHECK_THROTTLED: '⏳ Une vérification vient d’être lancée : patientez une minute avant de relancer.',
    SENDER_EMAIL_DOMAIN_REQUIRED: '🚫 Choisissez d’abord un domaine d’expédition.',
    SENDING_BLOCKED_DURING_TRIAL:
      '🚫 Les campagnes marketing ne sont pas disponibles pendant la période d’essai. Choisissez une formule pour activer les envois.',
    SUBSCRIPTION_REQUIRED:
      '🔒 Votre compte est gelé. Choisissez une formule (ou régularisez votre paiement) pour réactiver cette action.',
    ACTIVE_SUBSCRIPTION_REQUIRED:
      '🔒 Cette action nécessite un abonnement actif. Choisissez une formule : vous gardez vos jours d’essai restants.',
    PASSWORD_AUTH_REQUIRED:
      '🔒 Cette action demande une connexion par mot de passe. Définissez votre mot de passe ou reconnectez-vous avec.',
    IMPERSONATION_READ_ONLY:
      '👀 Session en lecture seule : cette action n’est pas autorisée pendant la prise de contrôle.',
    IMPERSONATION_WRITE_FORBIDDEN: '🚫 Votre rôle admin ne permet pas une prise de contrôle en écriture.',
    ADMIN_PULSE_DISABLED: '🚫 Pulse admin est désactivé sur cet environnement.',
    ADMIN_PULSE_PROFESSIONAL_NOT_FOUND: '🚫 Professionnel introuvable.',
    ADMIN_PULSE_CONVERSATION_NOT_FOUND: '🚫 Conversation Pulse introuvable.',
    ADMIN_PULSE_NOT_CONVERSATION_OWNER:
      '🚫 Seul l’agent qui a ouvert cette conversation peut la poursuivre ou l’archiver.',
    ADMIN_PULSE_PROVIDER_UNAVAILABLE: '⚠️ Pulse n’a pas répondu (modèle indisponible). Réessayez dans un instant.',
    ADMIN_PULSE_NO_FINAL_ANSWER:
      '⚠️ Pulse a consulté les données sans parvenir à conclure. Reformulez en une question plus ciblée.',
    ADMIN_PULSE_PROFESSIONAL_NO_ACCESS:
      '🚫 Ce professionnel n’a aucun accès actif : Pulse ne peut pas ouvrir de session pour lire ses données.',
    IMPERSONATION_CODE_INVALID:
      '⌛ Lien de prise de contrôle invalide ou expiré. Relancez l’impersonation depuis l’admin.',
    INSUFFICIENT_SMS_QUOTA: '🚫 Crédit SMS insuffisant pour cet envoi. Rechargez votre compte SMS pour continuer.',
    NO_PRICE_ACCEPTED: '🚫 Aucun tarif SMS configuré. Configurez vos tarifs SMS pour pouvoir envoyer des campagnes.',
    HAS_REFUSED_EMAIL: '🙅‍♂️ Ce client a refusé les emails marketing : vous ne pouvez pas modifier ce réglage pour lui.',
    HAS_REFUSED_SMS: '🙅‍♀️ Ce client a refusé les SMS marketing : vous ne pouvez pas modifier ce réglage pour lui.',
    NO_ID_ON_GOOGLE_ACCOUNT:
      "🤔 Impossible de récupérer l'ID Google pour le moment. Réessayez plus tard ou contactez-nous si besoin !",
    UNDELETABLE_LAST_PAYMENT_METHOD: '🙅‍♂️ Impossible de supprimer le dernier moyen de paiement.',
    UNDELETABLE_DEFAULT_PAYMENT_METHOD: '🙅‍♂️ Impossible de supprimer le moyen de paiement par défaut.',
    PAYMENT_METHOD_HAS_PENDING_DEBIT:
      '⏳ Un prélèvement SEPA est en cours : ce mandat pourra être supprimé une fois le prélèvement réglé, sous quelques jours ouvrés.',
    // Prélèvement SEPA depuis la page de paiement / le paiement express
    PAYMENT_NOT_PAYABLE:
      '🙅‍♂️ Ce paiement ne peut plus être réglé : il est déjà payé, un prélèvement est déjà lancé ou le lien a expiré. Rechargez la page.',
    SEPA_NOT_ALLOWED_FOR_PAYMENT: '🙅‍♂️ Le prélèvement SEPA n’est pas disponible pour ce paiement : réglez-le par carte.',
    NO_USABLE_SEPA_MANDATE: '🏦 Aucun mandat SEPA utilisable : signez un nouveau mandat ou payez par carte.',
    MEMBER_WITH_THIS_EMAIL_ALREADY_EXIST:
      '🙅‍♂️ Un membre avec cet email existe déjà, si vous avez besoin de cet email, contactez-nous.',
    LAST_TEAM_MEMBER_CANNOT_BE_DELETED:
      "🙅‍♂️ Impossible de supprimer le dernier membre de l'équipe. Il doit y avoir au moins un membre actif.",
    TOKEN_INVALID_OR_EXPIRED: '⏳ Ce lien est invalide ou a expiré. Demandez-en un nouveau.',
    CUSTOMER_SINCE_IN_FUTURE: '🙅‍♂️ La date « client depuis » ne peut pas être dans le futur.',
    CUSTOMER_IDENTIFIER_REQUIRED:
      '✏️ Renseignez au moins un email, un téléphone, ou le prénom et le nom du client pour pouvoir le retrouver.',
    INVITATION_ALREADY_ACCEPTED: '✅ Cette invitation a déjà été acceptée.',
    WRONG_CURRENT_PASSWORD: '😕 Mot de passe actuel incorrect.',
    INVITATION_WRONG_PASSWORD: '😕 Mot de passe incorrect. Saisissez celui que vous utilisez pour vous connecter.',
    AT_LEAST_AGENDA_OR_ACCOUNT_REQUIRED: "🙅‍♂️ Le membre doit avoir au moins un agenda ou un accès à l'application.",
    CANNOT_RESEND_NO_ACCOUNT: "🙅‍♂️ Ce membre n'a pas d'accès à l'application : pas d'invitation à renvoyer.",
    EMAIL_REQUIRED_WHEN_HAS_ACCOUNT: "📧 Un email est requis pour donner accès à l'application.",
    EMAIL_CHANGE_BLOCKED_MULTI_ACCESS:
      '🙅‍♂️ Cette personne a aussi un accès à un autre établissement : elle seule peut changer son email de connexion, depuis Mon compte.',
    EMAIL_ALREADY_USED_BY_ANOTHER_ACCOUNT: '📧 Ce nouvel email est déjà utilisé par un autre compte.',
    ROLE_ABOVE_YOURS: '🔒 Vous ne pouvez pas attribuer un rôle supérieur au vôtre.',
    TEAM_MEMBER_ABOVE_YOUR_ROLE:
      '🔒 Ce membre a un rôle supérieur au vôtre : seul un rôle au moins équivalent peut modifier son accès, son rôle ou son email, ou le supprimer.',
    LAST_OWNER_PROTECTED:
      "🙅‍♂️ L'établissement doit garder au moins un propriétaire avec un accès actif. Nommez d'abord un autre propriétaire.",
    EMAIL_CHANGE_REQUIRES_CONFIRMATION:
      "📧 L'email de connexion d'un membre ne se modifie qu'avec une confirmation depuis la nouvelle adresse. Rechargez la page et réessayez.",
    EMAIL_CHANGE_SAME_AS_CURRENT: "📧 C'est déjà l'adresse actuelle.",
    EMAIL_CHANGE_FORBIDDEN_DURING_IMPERSONATION:
      '🚫 Une adresse email ne peut pas être modifiée pendant une prise de contrôle. Le titulaire doit le faire lui-même.',
    NOTIFICATION_READ_FORBIDDEN_DURING_IMPERSONATION:
      '🚫 Pendant une prise de contrôle, les notifications restent non lues : c’est au professionnel de les consulter.',
    SWITCH_PRO_FORBIDDEN_DURING_IMPERSONATION:
      '🚫 Impossible de changer d’établissement pendant une prise de contrôle. Ouvrez une prise de contrôle directement sur l’autre établissement.',
    COMPANY_CREATION_FORBIDDEN_DURING_IMPERSONATION:
      '🚫 Une entreprise ne peut pas être créée pendant une prise de contrôle. Le titulaire doit le faire lui-même.',
    COMPANY_CREATION_OWNER_REQUIRED: '🔒 Seul le propriétaire d’une entreprise peut en créer une nouvelle.',
    COMPANY_CREATION_PAST_DUE:
      '💳 Un paiement est en échec sur l’une de vos entreprises. Régularisez-le avant d’en créer une nouvelle.',
    COMPANY_CREATION_PENDING_ACTIVATION:
      '⏳ Vous avez déjà une entreprise en attente d’activation. Finalisez-la ou abandonnez-la avant d’en créer une nouvelle.',
    COMPANY_LIMIT_REACHED: '🙅‍♂️ Vous avez atteint le nombre maximum d’entreprises pour ce compte.',
    COMPANY_NAME_REQUIRED: '🚫 Indiquez le nom commercial de la nouvelle entreprise.',
    COMPANY_ABANDON_NOT_ALLOWED:
      '🚫 Seule une entreprise créée depuis votre compte et jamais payée peut être abandonnée.',
    COMPANY_ABANDON_LAST_COMPANY:
      '🙅‍♂️ C’est la seule entreprise de votre compte : elle ne peut pas être abandonnée. Choisissez une formule pour l’activer.',
    COMPANY_ABANDON_PAYMENT_IN_PROGRESS:
      '⏳ Un paiement est en cours pour cette entreprise. Terminez-le, ou réessayez dans une dizaine de minutes.',
    COMPANY_ABANDON_FORBIDDEN_DURING_IMPERSONATION:
      '🚫 Une entreprise ne peut pas être abandonnée pendant une prise de contrôle. Le titulaire doit le faire lui-même.',
    PASSWORD_REQUIRED_FOR_EMAIL_CHANGE:
      "🔒 Ce compte n'a pas encore de mot de passe. Définissez-en un avant de changer l'email de connexion.",
    EMAIL_CHANGE_REQUEST_NOT_FOUND: "🔍 Aucune demande de changement d'email en attente.",
    EMAIL_CHANGE_TARGET_NOT_IN_TEAM:
      "🙅‍♂️ Cette personne n'a plus d'accès à l'établissement : la demande de changement d'email n'est plus valable.",
    RECOVERY_EMAIL_REQUIRED_FOR_HOSTED_LOGIN: `🔐 Cette adresse est une boîte hébergée par ${PROJECT_CONFIG.brand_string}. Pour vous connecter avec, ajoutez d'abord une adresse de récupération externe (Gmail, Outlook…) dans Mon compte → Adresse de récupération.`,
    MEMBER_RECOVERY_EMAIL_REQUIRED_FOR_HOSTED_LOGIN: `🔐 Cette adresse est une boîte hébergée par ${PROJECT_CONFIG.brand_string}. Pour s'y connecter, cette personne doit d'abord ajouter sa propre adresse de récupération externe, depuis Mon compte → Adresse de récupération.`,
    INVITATION_TO_HOSTED_EMAIL_FORBIDDEN: `🔐 Une invitation pas encore acceptée ne peut pas être envoyée vers une boîte hébergée par ${PROJECT_CONFIG.brand_string}. Invitez cette personne sur une adresse externe ; elle pourra passer à sa boîte pro ensuite.`,
    RECOVERY_EMAIL_MUST_BE_EXTERNAL: `🔐 L'adresse de récupération doit être externe (Gmail, Outlook…) : ni une boîte hébergée par ${PROJECT_CONFIG.brand_string}, ni une adresse ${PROJECT_CONFIG.brand_string}.`,
    RECOVERY_EMAIL_SAME_AS_LOGIN: "📧 L'adresse de récupération doit être différente de votre email de connexion.",
    RECOVERY_EMAIL_REQUIRED_WHILE_HOSTED_LOGIN: `🔐 Vous vous connectez avec une boîte hébergée par ${PROJECT_CONFIG.brand_string} : l'adresse de récupération est obligatoire. Vous pouvez la remplacer, pas la supprimer.`,
    TEAM_MEMBERS_REORDER_MISMATCH:
      "🔄 L'ordre n'a pas pu être enregistré : la liste d'équipe a changé. Rechargez la page et réessayez.",
    UNSUPPORTED_IMAGE_FORMAT:
      "🖼️ Ce format d'image n'est pas pris en charge (AVIF, HEIC, etc.). Utilisez plutôt un fichier JPG, PNG, GIF ou WebP.",
    PROFESSIONAL_NOT_FOUND: '🔍 Établissement introuvable.',
    RELANCE_NOT_FOUND: '🔍 Relance introuvable.',
    RELANCE_NOT_CANCELLABLE: 'Cette relance est déjà partie ou n’est plus en attente : impossible de l’annuler.',
    RELANCE_NOT_RETRYABLE: 'Seule une relance en échec ou annulée peut être reprogrammée.',
    CONTACT_REFUSED: '🚫 Cette personne a demandé à ne plus être contactée.',
    CONTACT_IN_CALL_QUEUE: '📞 Cette personne est dans la file d’appels : ses relances automatiques sont suspendues.',
    CRM_SUBJECT_REQUIRED: '🔍 Indiquez un lead ou un professionnel.',
    CRM_SUBJECT_NOT_FOUND: '🔍 Personne introuvable.',
    CRM_CONSENT_NOT_FOUND: '🔍 Décision introuvable.',
    CRM_CONSENT_ALREADY_REVOKED: 'Cette décision est déjà levée.',
    CRM_CONSENT_REVOKE_NEEDS_PERSON_REQUEST:
      'La personne s’est désabonnée elle-même : la reprise n’est possible que si elle l’a demandée.',
    CRM_CONSENT_ALLOW_BLOCKED_BY_REFUSAL:
      'Un refus actif couvre cette liste : un ajout manuel ne passe pas outre. Levez d’abord le refus.',
    CRM_TASK_NOT_FOUND: '🔍 Tâche introuvable.',
    CRM_AUDIENCE_NOT_FOUND: '🔍 Audience introuvable.',
    CRM_AUDIENCE_INVALID_LIST: 'Une campagne ne peut viser que la liste de diffusion ou la newsletter.',
    CRM_AUDIENCE_IN_USE:
      'Une campagne qui n’est pas encore envoyée vise cette audience : elle ne peut pas être supprimée.',
    CRM_AUDIENCE_LIST_LOCKED:
      'Une campagne qui n’est pas encore envoyée vise cette audience : sa liste de diffusion ne peut pas changer.',
    CRM_CAMPAIGN_NOT_FOUND: '🔍 Campagne introuvable.',
    CRM_CAMPAIGN_NOT_DRAFT: 'Seule une campagne en brouillon peut être modifiée, supprimée, programmée ou envoyée.',
    CRM_CAMPAIGN_NOT_SCHEDULED: 'Cette campagne n’est pas programmée.',
    CRM_CAMPAIGN_NO_CONTENT: '✍️ Cette campagne n’a pas encore de contenu (objet et email, ou texte du SMS).',
    CRM_CAMPAIGN_MISSING_UNSUBSCRIBE:
      'L’email n’a pas de lien de désinscription. Ajoutez le bloc de pied de page avant d’envoyer.',
    CRM_CAMPAIGN_INVALID_SCHEDULE: '📅 Choisissez une date d’envoi à venir.',
    CRM_CAMPAIGN_NO_RECIPIENT: 'Personne ne recevrait cette campagne pour le moment.',
    CRM_CAMPAIGN_ALREADY_SENDING: 'Cette campagne est déjà en cours d’envoi.',
    CRM_CAMPAIGN_SEND_FAILED: 'Le fournisseur a refusé l’envoi. La campagne est revenue en brouillon.',
    CRM_CAMPAIGN_SMS_WINDOW_CLOSED:
      'Les SMS ne partent qu’entre 9 h et 19 h, du lundi au samedi, hors jours fériés. Programmez la campagne ou réessayez plus tard.',
    CRM_CAMPAIGN_AUDIENCE_LIST_MISMATCH: 'Cette audience vise une autre liste que la campagne.',
    CRM_COMMS_TEST_NO_PHONE: '📵 Votre compte n’a pas de numéro de téléphone : le SMS de test ne peut pas partir.',
    CRM_COMMS_TEST_NOT_WHITELISTED:
      'Hors production, un email de test ne part que vers une adresse autorisée. La vôtre ne l’est pas.',
    CRM_SEQUENCE_NOT_FOUND: '🔍 Séquence introuvable.',
    CRM_SEQUENCE_ACTIVE_LOCKED:
      '🔒 L’audience et le point de départ d’une séquence active ne se modifient pas : désactivez-la d’abord.',
    CRM_SEQUENCE_STEP_NOT_FOUND: '🔍 Étape introuvable.',
    CRM_SEQUENCE_STEP_NO_CONTENT: '✍️ Cette étape n’a pas encore de contenu (email ou texte du SMS).',
    CRM_SEQUENCE_STEP_INVALID_TIMING:
      '🕘 Choisissez un jour pour une étape à jour fixe. Un SMS part entre 9 h et 18 h, jamais le dimanche.',
    CRM_SEQUENCE_STEP_MISSING_UNSUBSCRIBE:
      'Une étape active doit porter un lien de désinscription. Ajoutez le bloc de pied de page.',
    CRM_SEQUENCE_INVALID_DATE: '📅 Date de départ invalide.',
    CRM_EMAIL_TEMPLATE_NOT_FOUND: '🔍 Modèle d’email introuvable.',
    CRM_EMAIL_TEMPLATE_NO_CONTENT: '✍️ Ce modèle n’a pas encore d’objet ou de contenu.',
    CRM_SESSION_FOLLOWUP_UNKNOWN_PRESTATION:
      'Cette prestation n’est ni une formation ni une démo configurée (CRM_TRAINING_PRESTATION_IDS / CRM_DEMO_PRESTATION_IDS).',
    CRM_SESSION_FOLLOWUP_NO_CONTENT:
      '✍️ Cet email n’a pas encore d’objet ou de contenu : rédigez-le avant de l’activer, l’afficher ou le tester.',
    CRM_MEDIA_UNSUPPORTED_FORMAT: '🖼️ Ce format d’image n’est pas pris en charge. Utilisez un JPEG, PNG, GIF ou WebP.',
    CRM_MEDIA_INVALID_KEY: 'Cette image n’appartient pas aux communications du CRM.',
    CRM_TASK_INVALID_DUE_DATE: '📅 Échéance invalide.',
    CRM_QUEUE_NO_PHONE: '📵 Cette personne n’a pas de numéro de téléphone : elle ne peut pas entrer dans la file.',
    CRM_QUEUE_CONTACT_REFUSED: '🚫 Cette personne a demandé à ne plus être appelée.',
    CRM_QUEUE_PHONE_INVALID: '📵 Ce numéro a été marqué invalide. Corrigez-le avant de la faire entrer dans la file.',
    CRM_QUEUE_ENTRY_NOT_FOUND: '🔍 Passage en file introuvable.',
    CRM_QUEUE_ENTRY_CLOSED: 'Ce dossier est déjà sorti de la file.',
    CRM_QUEUE_ALREADY_OPEN: 'Cette personne est déjà dans la file : modifiez son rappel depuis sa fiche d’appel.',
    CRM_CALL_NOT_ALLOWED:
      'Cet appel n’était pas permis à ce moment-là (jour, heure chez la personne, une seule tentative par jour ou rappel programmé).',
    CRM_CALL_INPUT_INVALID: 'Il manque des informations pour cette issue.',
    CRM_CALL_STARTED_AT_INVALID: 'L’heure de début de l’appel n’est pas valide. Rouvrez la fiche d’appel.',
    CRM_CALLBACK_SLOT_INVALID: '📅 Le rappel doit être à venir, un jour ouvré, entre 9 h et 19 h chez la personne.',
    CRM_NOTE_NOT_FOUND: '🔍 Note introuvable.',
    CRM_NOTE_EDIT_FORBIDDEN: 'Une note ne se corrige que par son auteur, dans les dix minutes.',
    CRM_DIAL_NO_LINE: '☎️ Aucune ligne téléphonique ne vous est attribuée : composez le numéro depuis votre téléphone.',
    CRM_DIAL_FAILED:
      '☎️ L’appel n’a pas pu être lancé. Vérifiez que votre téléphone est connecté, ou composez le numéro à la main.',
    CRM_DIAL_NUMBER_INVALID: '☎️ Ce numéro ne peut pas être composé.',
    CRM_DIAL_CONTACT_REFUSED: '☎️ Cette personne a demandé à ne plus être appelée.',
    ADMIN_USER_TELEPHONY_INCOMPLETE: 'Une ligne téléphonique demande le compte et le numéro de ligne.',
    ADMIN_USER_TELEPHONY_INVALID:
      'Format inattendu : le compte de facturation ressemble à ab1234567-ovh-1, le numéro de ligne à 0033412345678.',
    ADMIN_USER_TELEPHONY_LINE_TAKEN: 'Cette ligne est déjà attribuée à un autre membre de l’équipe.',
    CRM_TRAINING_NOT_CONFIGURED: 'Aucun compte de formation n’est configuré.',
    CRM_TRAINING_APPOINTMENT_NOT_FOUND: '🔍 Ce rendez-vous n’est pas une inscription à une séance de formation.',
    CONVERSATION_NOT_FOUND: '🔍 Conversation introuvable.',
    VAT_REGIME_REQUIRES_BUYER_VAT_NUMBER:
      "⚠️ L'autoliquidation intracommunautaire exige le n° de TVA du professionnel sur la facture (art. 289 II du CGI). Renseignez-le sur sa fiche avant de choisir ce régime.",
    // Partagée admin et pro (abandon d'entreprise, checkout d'abonnement, retrait de domaine) : formulation neutre.
    SEPA_DEBIT_IN_FLIGHT:
      '⏳ Un prélèvement SEPA est en cours (ni encaissé ni rejeté) : réessayez une fois qu’il est réglé, sous quelques jours ouvrés.',
    // Migration abonnement v1→v2 (page admin)
    STRIPE_CUSTOMER_NOT_FOUND: '🔍 Client Stripe introuvable. Vérifiez l’identifiant (cus_…).',
    ALREADY_MIGRATED: '⚠️ Ce professionnel a déjà un abonnement v2 actif : migration bloquée (à traiter à la main).',
    V1_SUBSCRIPTION_CHANGED:
      '🔄 L’abonnement Stripe v1 a changé depuis l’aperçu (renouvellement ?). Rechargez l’aperçu avant de migrer.',
    V1_SUBSCRIPTION_IN_TRIAL: '⏳ Abonnement v1 en période d’essai : migration manuelle requise.',
    WEBSITE_NOT_PUBLISHED: '🌐 Le site v2 doit être publié avant de migrer les domaines.',
    INVALID_CLOCK_DATE: '📅 Date d’horloge invalide.',
    PREVIEW_NOT_FOUND: "🔍 Aperçu introuvable ou expiré. Demandez un nouveau lien d'aperçu.",
    PREVIEW_EXPIRED: '⌛ Cet aperçu a expiré. Demandez à votre conseiller un nouveau lien.',
    PREVIEW_MISSING_SOURCES: '🚫 Fournissez au moins une URL ou des paramètres de découverte pour générer un aperçu.',
    PREVIEW_NO_EXTRACTABLE_SOURCE:
      "😕 On n'a rien pu extraire des sources fournies. Vérifiez les URLs ou retentez plus tard.",
    INVALID_PROTECTED_BINDING_KEYS: '🚫 Une ou plusieurs clés de binding demandées ne sont pas protégées.',
    NO_ACCESS_TO_PROFESSIONAL:
      "🚫 Vous n'avez pas accès à cet établissement. Vérifiez vos droits ou contactez l'administrateur.",
    NO_ACTIVE_ACCESS:
      "😕 Votre compte n'est actuellement rattaché à aucun établissement actif. Contactez un administrateur.",
    OVERLAPPING_SLOTS:
      '🚫 Deux créneaux se chevauchent sur le même jour en partageant un lieu et une prestation. Donnez-leur des lieux ou des prestations différents, ou ajustez leurs horaires !',
    OVERLAPPING_SPECIFIC_DATES:
      '🚫 Deux créneaux se chevauchent sur la même date en partageant un lieu et une prestation. Donnez-leur des lieux ou des prestations différents, ou ajustez leurs horaires !',
    INVALID_SLOT_RANGE:
      "🚫 L'heure de fin doit être postérieure à l'heure de début. Vérifiez vos horaires et réessayez !",
    INVALID_SPECIFIC_DATE_RANGE: '🚫 La plage horaire spécifique est invalide. Vérifiez vos horaires et réessayez !',
    INVALID_DATE_RANGE: '🚫 La date de fin doit être postérieure à la date de début.',
    RANGE_TOO_LARGE: '🚫 La période sélectionnée est trop longue (366 jours maximum).',
    OVERLAPPING_WITH_EXISTING:
      '🚫 Certaines plages horaires se chevauchent avec un planning existant sur le même lieu et la même prestation. Vérifiez vos horaires et réessayez !',
    STRIPE_CONNECT_ACCOUNT_ALREADY_EXISTS: '🙅‍♂️ Un compte Stripe Connect est déjà associé à votre établissement.',
    STRIPE_CONNECT_ACCOUNT_NOT_FOUND:
      '🔗 Aucun compte Stripe Connect trouvé. Créez votre compte pour recevoir des paiements.',
    TAG_NOT_FOUND: '🔍 Tag introuvable.',
    TAG_NOT_EDITABLE: '🚫 Ce tag ne peut pas être modifié.',
    CUSTOMER_BANNED: '🚫 Ce client est bloqué et ne peut pas prendre de rendez-vous.',
    BANNED_TAG_NOT_FOUND: '🚫 Le tag « Bloqué » est introuvable. Contactez le support pour rétablir la configuration.',
    CUSTOMER_MERGED: '🔀 Cette fiche client a été fusionnée dans une autre fiche.',
    MERGE_SAME_CUSTOMER: '🚫 Impossible de fusionner une fiche avec elle-même.',
    MERGE_CUSTOMER_NOT_FOUND: '🔍 L’une des deux fiches est introuvable.',
    MERGE_INVALID_EMAIL: '⚠️ L’email saisi pour la fusion est invalide.',
    MERGE_EMAIL_BLACKLISTED:
      'Cette adresse appartient à une personne qui s’est désinscrite de vos communications : elle ne peut pas être saisie ici.',
    MERGE_CUSTOMER_ALREADY_MERGED: '🔀 L’une des deux fiches a déjà été fusionnée ou supprimée.',
    MERGE_BLOCKED_BY_RUNNING_IMPORT:
      '⏳ Un import de clients est en cours : réessayez la fusion une fois l’import terminé.',
    DUPLICATE_SAME_CUSTOMER: '🚫 Sélectionnez deux fiches différentes.',
    DUPLICATE_CUSTOMER_NOT_FOUND: '🔍 Fiche client introuvable.',
    DUPLICATE_FEATURE_DISABLED: '🚫 La détection de doublons est désactivée pour le moment.',
    PACK_LIMIT_REACHED: '🚫 Vous avez atteint la limite de packs. Contactez-nous pour en créer davantage !',
    PACK_NOT_FOUND: '🔍 Pack introuvable.',
    PACK_PRESTATION_NOT_FOUND: "🔍 Une ou plusieurs prestations du pack n'ont pas été trouvées.",
    PACK_INVALID_DURATION: '🔍 La durée sélectionnée dans le pack n’est plus disponible.',
    VOD_TITLE_REQUIRED: '🚫 Donnez un titre à votre vidéo avant de la publier.',
    VOD_TITLE_TOO_LONG: '🚫 Le titre de la vidéo est trop long (200 caractères max).',
    VOD_VIDEO_NOT_FOUND: '🔍 Vidéo introuvable.',
    VOD_VIDEO_NOT_OWNED: '🚫 Cette vidéo ne vous appartient pas.',
    VOD_UPLOAD_FAILED: "😬 L'envoi de votre vidéo a échoué. Réessayez dans un instant.",
    VOD_INVALID_FILE_TYPE: "🚫 Ce fichier n'est pas une vidéo.",
    VOD_FILE_TOO_LARGE: '🚫 Cette vidéo dépasse 500 Mo. Compressez-la ou coupez-la avant de la publier.',
    VOD_INVALID_YOUTUBE_URL: "🚫 Cette URL YouTube n'est pas reconnue.",
    IMAGE_FILE_TOO_LARGE: '🚫 Une ou plusieurs images dépassent 15 Mo et ont été ignorées.',
    IMAGE_UPLOAD_FAILED: "😬 L'envoi d'une ou plusieurs images a échoué. Réessayez dans un instant.",
    VOUCHER_NOT_FOUND: '🔍 Carte cadeau introuvable.',
    VOUCHER_NOT_ACTIVE: "🚫 Cette carte cadeau n'est plus active.",
    VOUCHER_INSUFFICIENT_QUANTITY: '🚫 Quantité insuffisante sur cette carte cadeau.',
    VOUCHER_INSUFFICIENT_AMOUNT: '🚫 Montant insuffisant sur cette carte cadeau.',
    VOUCHER_NOT_RECHARGEABLE:
      '🚫 Cette carte cadeau ne peut pas être rechargée (annulée, expirée ou en attente de paiement).',
    VOUCHER_RECHARGE_AMOUNT_REQUIRED: '🚫 Le montant est obligatoire pour recharger cette carte cadeau.',
    VOUCHER_RECHARGE_ITEMS_REQUIRED: '🚫 Au moins une prestation est obligatoire pour recharger cette carte cadeau.',
    VOUCHER_RECHARGE_EXCEEDS_CAP: '🚫 Le solde obtenu dépasserait le maximum autorisé pour une carte cadeau.',
    GIFT_CARD_TEMPLATE_QR_REQUIRED:
      '🚫 La carte cadeau doit garder son QR code : le destinataire le scanne pour réserver avec son code.',
    GIFT_CARD_PDF_PREVIEW_UNAVAILABLE:
      "🚫 L'aperçu PDF est momentanément indisponible. Réessayez dans quelques instants.",
    VOUCHER_AMOUNT_REQUIRED: '🚫 Le montant est obligatoire pour ce type de carte cadeau.',
    VOUCHER_PACK_REQUIRED: '🚫 Le pack est obligatoire pour ce type de carte cadeau.',
    VOUCHER_PRESTATIONS_REQUIRED: '🚫 Au moins une prestation est obligatoire pour ce type de carte cadeau.',
    VOUCHER_CUSTOMER_NOT_FOUND: '🔍 Le client sélectionné est introuvable pour cet établissement.',
    VOUCHER_INVALID_DURATION: '🔍 La durée sélectionnée pour une prestation n’est plus disponible.',
    VOUCHER_INVALID_PRICE_INDEX: '🔍 La durée sélectionnée pour une prestation n’est plus disponible.',
    PRESTATION_DUPLICATE_PRICE_DURATION: '🚫 Une prestation ne peut pas contenir plusieurs options avec la même durée.',
    VOUCHER_CODE_NOT_FOUND: '🔍 Code de carte cadeau introuvable.',
    VEHICLE_LIMIT_REACHED:
      "🚫 Vous avez atteint la limite de 10 véhicules. Supprimez-en un avant d'en créer un nouveau.",
    PRO_RESOURCE_NOT_FOUND: '🔍 Ressource introuvable.',
    PRO_RESOURCE_PRESTATION_NOT_FOUND: "🔍 Une ou plusieurs prestations associées n'ont pas été trouvées.",
    PRO_RESOURCE_PLACE_NOT_FOUND: "🔍 Un ou plusieurs lieux associés n'ont pas été trouvés.",
    PRO_RESOURCE_INVALID_RANGE: '⚠️ La valeur minimale doit être inférieure ou égale à la valeur maximale.',
    PRO_PAYMENT_NOT_FOUND: '🔍 Demande de paiement introuvable.',
    PRO_PAYMENT_ALREADY_PAID: '✅ Cette demande de paiement a déjà été payée.',
    PRO_PAYMENT_EXPIRED: '⏳ Cette demande de paiement a expiré.',
    PRO_PAYMENT_RESERVATION_NOT_FOUND: '🔍 Réservation introuvable pour déclarer le paiement.',
    PRO_PAYMENT_MANUAL_DECLARATION_NOT_ALLOWED: '🚫 Impossible de déclarer ce rendez-vous comme payé manuellement.',
    STRIPE_CONNECT_NOT_ENABLED:
      "🔗 Stripe Connect n'est pas activé. Configurez votre compte pour recevoir des paiements.",
    PRO_PAYMENT_RESERVATION_NOT_PAYABLE:
      '🚫 Impossible de demander un paiement sur cette réservation : elle est annulée ou son paiement en ligne est encore en cours.',
    PRO_PAYMENT_CANNOT_RESTORE_VOUCHER: '🚫 Le bon ne peut être restitué que depuis le paiement de la réservation.',
    PRO_PAYMENT_LINK_NOT_PAYABLE: "🚫 Ce lien de paiement n'est plus valable : le rendez-vous a été annulé.",
    PRO_PAYMENT_LINK_NOT_SENDABLE: "🚫 Ce lien ne peut pas être envoyé : la demande n'est plus en attente de paiement.",
    PRO_PAYMENT_LINK_CUSTOMER_EMAIL_MISSING:
      "📧 Ce client n'a pas d'adresse email : ajoutez-la sur sa fiche pour lui envoyer le lien.",
    PRO_PAYMENT_LINK_CUSTOMER_PHONE_MISSING:
      "📱 Ce client n'a pas de numéro de téléphone : ajoutez-le sur sa fiche pour lui envoyer le lien.",
    PRO_PAYMENT_LINK_CHANNEL_DISABLED:
      '🔕 Cet envoi est désactivé dans vos messages automatiques (« Demande de paiement »).',
    PRO_PAYMENT_LINK_CUSTOMER_BLOCKED:
      '🚫 Ce client est bloqué : aucun message ne lui est envoyé. Débloquez-le depuis sa fiche pour lui envoyer le lien.',
    PRO_PAYMENT_LINK_CUSTOMER_PHONE_NOT_MOBILE:
      "📱 Le numéro de ce client n'est pas un mobile : il ne peut pas recevoir de SMS. Envoyez le lien par email.",
    PRO_PAYMENT_LINK_SENDING_BLOCKED:
      "🚫 L'envoi de messages à vos clients est suspendu sur votre compte. Régularisez votre abonnement pour le réactiver.",
    PRO_PAYMENT_LINK_EMAIL_QUOTA_EXHAUSTED:
      "📧 Vous n'avez plus de crédits email : le lien n'a pas été envoyé. Rechargez vos crédits pour l'envoyer.",
    PRO_PAYMENT_LINK_SMS_QUOTA_EXHAUSTED:
      "📱 Vous n'avez plus de crédits SMS : le lien n'a pas été envoyé. Rechargez vos crédits pour l'envoyer.",
    PRO_PAYMENT_LINK_RECIPIENT_NOT_IN_WHITELIST:
      "🧪 Environnement de test : ce destinataire n'est pas dans la liste autorisée, le lien n'a pas été envoyé.",
    GIFT_CARD_NOT_ENABLED: '🚫 Les cartes cadeaux ne sont pas disponibles pour ce professionnel.',
    GIFT_CARD_TYPE_NOT_ALLOWED: "🚫 Ce type de carte cadeau n'est pas proposé.",
    GIFT_CARD_AMOUNT_OUT_OF_RANGE: '🚫 Le montant choisi est en dehors des limites autorisées.',
    GIFT_CARD_PRESTATION_NOT_ALLOWED: "🚫 Cette prestation n'est pas disponible en carte cadeau.",
    GIFT_CARD_PACK_NOT_ALLOWED: "🚫 Ce pack n'est pas disponible en carte cadeau.",
    GIFT_CARD_PAYMENT_NOT_AVAILABLE: "🔗 Le paiement en ligne n'est pas disponible pour ce professionnel.",
    GIFT_CARD_NOT_FOUND: '🔍 Carte cadeau ou professionnel introuvable.',
    GIFT_CARD_INVALID_DURATION: '🚫 La durée sélectionnée ne correspond à aucun tarif de cette prestation.',
    PRO_PAYMENT_CANNOT_CAPTURE: "🚫 Impossible d'encaisser cette empreinte bancaire.",
    PRO_PAYMENT_CAPTURE_AMOUNT_TOO_HIGH: '🚫 Le montant à encaisser dépasse le montant maximum accepté par le client.',
    PRO_PAYMENT_CANNOT_CANCEL: "🚫 Impossible d'annuler cette demande de paiement.",
    PRO_PAYMENT_CANNOT_REFUND: '🚫 Impossible de rembourser cette demande de paiement.',
    PRO_PAYMENT_CANNOT_UPDATE_AMOUNT: '🚫 Impossible de modifier le montant de cette demande de paiement.',
    PRO_PAYMENT_CANNOT_UNLINK:
      '🚫 Seul un paiement ajouté par vos soins (lien ou déclaration) peut être détaché du rendez-vous.',
    PRO_PAYMENT_UNLINK_PAYMENT_IN_PROGRESS:
      '⏳ Ce lien est peut-être en cours de règlement par votre client. Rechargez le rendez-vous puis réessayez.',
    PRO_PAYMENT_REFUND_AMOUNT_TOO_HIGH: '🚫 Le montant du remboursement dépasse le montant remboursable.',
    PRO_PAYMENT_REFUND_STRIPE_FAILED: '🚫 Le remboursement Stripe a échoué. Veuillez réessayer.',
    PRO_PAYMENT_RETRY_CHARGE_FAILED:
      '🚫 Échec du prélèvement de la carte enregistrée. Le client devra régler par un autre moyen.',
    PRE_RESERVATION_SLOT_NOT_AVAILABLE: "🚫 Ce créneau n'est plus disponible. Veuillez en choisir un autre.",
    PRE_RESERVATION_SLOT_WITHIN_MIN_NOTICE:
      "🚫 Ce créneau n'est plus réservable en ligne : le délai minimum de réservation est dépassé. Veuillez en choisir un autre.",
    PRE_RESERVATION_SLOT_BEYOND_HORIZON:
      "🚫 Ce créneau n'est pas encore réservable en ligne : il est trop éloigné dans le temps. Veuillez en choisir un plus proche.",
    BOOKING_RESTRICTED_TO_TAGS: '🚫 Ce créneau est réservé à certains clients. Contactez le professionnel.',
    ONLINE_BOOKING_SUSPENDED:
      '🚫 La réservation en ligne est momentanément indisponible pour cet établissement. Contactez-le directement par téléphone.',
    PRE_RESERVATION_PROFESSIONAL_NOT_FOUND: '🔍 Professionnel introuvable.',
    PRE_RESERVATION_PRESTATION_NOT_FOUND: '🔍 Une ou plusieurs prestations sont introuvables.',
    PRE_RESERVATION_VOUCHER_CODE_NOT_FOUND: '🔍 Code de carte cadeau introuvable.',
    PRE_RESERVATION_VOUCHER_NOT_ACTIVE: "🚫 Cette carte cadeau n'est plus active ou a expiré.",
    PRE_RESERVATION_VOUCHER_NO_LONGER_AVAILABLE:
      '🚫 Le solde de cette carte cadeau ne couvre plus cette réservation (utilisée entre-temps). Merci de réessayer.',
    PRE_RESERVATION_PROMO_CODE_NOT_FOUND: '🔍 Code promo introuvable.',
    PRE_RESERVATION_PROMO_NOT_ACTIVE: "🚫 Ce code promo n'est plus actif ou a expiré.",
    PRE_RESERVATION_PROMO_NOT_APPLICABLE: "🚫 Ce code promo ne s'applique à aucune prestation de votre panier.",
    PRE_RESERVATION_PROMO_ZERO_DISCOUNT: '🚫 Ce code promo ne donne aucune remise sur votre panier.',
    PRE_RESERVATION_PROMO_MIN_CART: "🚫 Le montant minimum requis pour ce code promo n'est pas atteint.",
    PRE_RESERVATION_PROMO_FIRST_TIME_ONLY: '🚫 Ce code promo est réservé aux nouveaux clients.',
    PRE_RESERVATION_PROMO_BETTER_OFFER_APPLIED:
      '🎁 Une meilleure offre est déjà appliquée à votre réservation : ce code ne donnerait pas plus.',
    PRE_RESERVATION_PROMO_CUSTOMER_NOT_TARGETED: '🚫 Ce code promo est réservé à certains clients.',
    PRE_RESERVATION_PROMO_NOT_APPLICABLE_TO_PLACE: "🚫 Ce code promo n'est pas valable dans ce lieu.",
    PRE_RESERVATION_PROMO_NOT_APPLICABLE_TO_MEMBER: "🚫 Ce code promo n'est pas valable avec ce membre de l'équipe.",
    // Repli sans détail : le backend envoie normalement la phrase avec les jours et plages du code
    // (`PROMO_HAPPY_HOURS.OUTSIDE_HOURS_MESSAGE`), que le tunnel affiche en priorité.
    PRE_RESERVATION_PROMO_OUTSIDE_HOURS:
      "🚫 Ce code promo n'est valable que certains jours ou à certaines heures. Choisissez un créneau dans ces horaires pour en profiter.",
    PRE_RESERVATION_PROMO_MAX_REDEMPTIONS: "🚫 Ce code promo a atteint son nombre maximum d'utilisations.",
    PRE_RESERVATION_PROMO_MAX_PER_CUSTOMER: '🚫 Vous avez déjà utilisé ce code promo le nombre maximum de fois.',
    PRE_RESERVATION_PROMO_PERSONAL_CODE_ALREADY_USED: '🚫 Ce code personnel a déjà été utilisé.',
    PRE_RESERVATION_PROMO_PERSONAL_CODE_NOT_FOR_CUSTOMER:
      '🚫 Ce code personnel est lié à un autre client. Utilisez l’adresse e-mail à laquelle il a été envoyé.',
    // Émis par les 5 endpoints pro du module (lecture, édition, suppression, utilisations, codes personnels).
    PROMO_CODE_NOT_FOUND: '🔍 Code promo introuvable.',
    PRE_RESERVATION_PROMO_VOUCHER_EXCLUSIVE: '🚫 Un code promo et une carte cadeau ne sont pas cumulables.',
    PROMO_CODE_ALREADY_EXISTS: '🚫 Un code promo avec ce code existe déjà.',
    PROMO_CODE_REQUIRED: '🚫 Le code est requis pour un code promo partagé.',
    PROMO_CODE_LABEL_REQUIRED: '🚫 Donnez un libellé à la promotion : il sera affiché aux clients.',
    PROMO_CODE_TAGS_REQUIRED: '🚫 Choisissez au moins un tag pour une promotion réservée aux clients avec un tag.',
    PROMO_CODE_INVALID_TRIGGER: '🚫 Une promotion à codes personnels se déclenche toujours par un code.',
    PROMO_CODE_PERSONAL_NOT_HIGHLIGHTABLE: '🚫 Une promotion à codes personnels ne se met pas en avant sur le site.',
    PROMO_CODE_INVALID_VALUE:
      '🚫 La remise doit être renseignée et supérieure à zéro (sans dépasser 100 % pour un pourcentage).',
    PROMO_CODE_LOCKED_AFTER_USE:
      '🔒 Ce code promo a déjà été utilisé : son type, sa valeur et son ciblage ne sont plus modifiables.',
    PROMO_CODE_PLAN_REQUIRED:
      '🔒 Votre offre actuelle ne permet pas de modifier ni de réactiver une promotion : vous pouvez seulement la mettre en pause ou l’archiver (ou supprimer un brouillon).',
    PROMO_CODE_INVALID_VALIDITY_PERIOD: '🚫 La date de fin de validité ne peut pas précéder la date de début.',
    PROMO_CODE_TARGETING_REQUIRED:
      '🚫 Choisissez au moins une prestation ou une catégorie, ou appliquez le code à toutes les prestations.',
    PROMO_CODE_INVALID_TARGET: '🚫 Une des prestations ou catégories ciblées est introuvable ou a été supprimée.',
    CAMPAIGN_PROMO_BINDING_MISMATCH:
      '🚫 La promotion jointe ne peut pas être utilisée : elle doit être active ou à venir, ni terminée ni épuisée. Une promotion à codes personnels demande la variable « Code de la promotion » dans le message, et les variables de la promotion demandent une promotion jointe. La variable « Code promo du client » demande une promotion à codes personnels jointe : retirez-la du message, ou joignez une promotion à codes personnels.',
    PRO_PAYMENT_HAS_DISCOUNT:
      '🚫 Impossible de modifier le montant : une remise (code promo ou carte cadeau) est appliquée sur ce paiement.',
    PRE_RESERVATION_INVALID_PRICE_INDEX: '🚫 Le tarif sélectionné est invalide pour cette prestation.',
    PRE_RESERVATION_NOT_EDITABLE:
      '🚫 Cette pré-réservation ne peut plus être modifiée (déjà payée, expirée ou paiement en cours).',
    PRE_RESERVATION_REQUIRES_PAYMENT:
      '🚫 Cette pré-réservation nécessite un paiement en ligne et ne peut pas être confirmée directement.',
    PRE_RESERVATION_NOT_OPTIONAL_PAYMENT: '🚫 Cette pré-réservation ne propose pas l’option de paiement sur place.',
    PRE_RESERVATION_SLOT_DURATION_MISMATCH:
      '🚫 La durée du créneau ne correspond pas à la durée attendue des prestations sélectionnées.',
    PRE_RESERVATION_INVALID_PARTY_SIZE:
      '🚫 Le nombre de personnes saisi dépasse la capacité autorisée pour cette prestation.',
    PRE_RESERVATION_MULTI_PRESTATION_NOT_ALLOWED:
      '🚫 Ce professionnel ne permet pas de réserver plusieurs prestations dans une même réservation.',
    PRE_RESERVATION_MULTI_MEMBER_NOT_ALLOWED:
      '🚫 Ce professionnel exige que toutes les prestations d’une réservation soient réalisées par le même intervenant.',
    BOOKING_NOT_CANCELLABLE:
      "🚫 Cette réservation ne peut pas être annulée (elle n'est pas payée ou a déjà été annulée).",
    BOOKING_ALREADY_STARTED: '🚫 Ce rendez-vous est déjà passé ou en cours, il ne peut plus être annulé.',
    BOOKING_REFUND_STRIPE_FAILED: "🚫 Le remboursement a échoué lors de l'annulation. Veuillez réessayer.",
    BOOKING_PAYMENT_OUTCOME_PENDING:
      "⏳ Votre paiement est en cours de traitement. Réessayez l'annulation dans quelques minutes.",
    BOOKING_NOT_RESCHEDULABLE: '🚫 Ce rendez-vous ne peut plus être déplacé.',
    BOOKING_RESCHEDULE_SLOT_NOT_AVAILABLE: "🚫 Ce créneau n'est plus disponible. Veuillez en choisir un autre.",
    BOOKING_RESCHEDULE_PAYLOAD_MISMATCH: '🚫 Le nouveau créneau ne correspond pas à ce rendez-vous.',
    BOOKING_RESCHEDULE_DEADLINE_PASSED:
      "🚫 Le délai d'annulation est dépassé, ce rendez-vous ne peut plus être déplacé.",
    // Repli sans détail : le backend envoie normalement la phrase avec les jours et plages du code
    // (`PROMO_HAPPY_HOURS.RESCHEDULE_OUTSIDE_HOURS_MESSAGE`), affichée en priorité.
    BOOKING_RESCHEDULE_PROMO_OUTSIDE_HOURS:
      "🚫 Votre code promo n'est valable que certains jours ou à certaines heures. Pour conserver votre remise, choisissez un nouveau créneau dans ces horaires.",
    BOOKING_RESCHEDULE_PROMO_OUTSIDE_DATES:
      '🚫 Votre remise ne vaut que pour un rendez-vous pendant les dates de l’offre. Pour un autre horaire, contactez le professionnel.',
    RESERVATION_NOT_FOUND: '🔍 Réservation introuvable.',
    // Remise posée depuis l'agenda (lot 1 Promotions).
    RESERVATION_DISCOUNT_NOT_FOUND: '🔍 Cette remise a déjà été retirée.',
    RESERVATION_DISCOUNT_INVALID_VALUE: '🚫 La remise doit être un pourcentage entre 1 et 100, ou un montant positif.',
    RESERVATION_PROMOTION_ALREADY_APPLIED:
      '🚫 Une promotion est déjà appliquée à cette réservation : une seule promotion par réservation.',
    RESERVATION_PROMOTION_NOT_ELIGIBLE: "🚫 Cette promotion ne s'applique pas à ce rendez-vous.",
    RESERVATION_PROMOTION_CUSTOMER_REQUIRED:
      '🚫 Ce rendez-vous n’a pas de client : rattachez-en un avant d’appliquer une promotion.',
    RESERVATION_DISCOUNT_EXCEEDS_TOTAL: '🚫 La remise ne peut pas dépasser le montant restant du rendez-vous.',
    RESERVATION_DISCOUNT_PRICE_NOT_FIRM:
      '🚫 Pas de remise sans prix fixé : choisissez une formule à prix ferme pour ce rendez-vous.',
    RESERVATION_DISCOUNT_RESERVATION_CANCELLED: '🚫 Ce rendez-vous est annulé : aucune remise ne peut y être posée.',
    RESERVATION_DISCOUNT_RIDE_NOT_SUPPORTED: '🚫 La remise ne s’applique pas encore aux courses : modifiez leur prix.',
    RESERVATION_DISCOUNT_RECURRING_NOT_SUPPORTED: '🚫 La remise ne s’applique pas encore aux rendez-vous récurrents.',
    RESERVATION_DISCOUNT_LEGACY_PROMO_NOT_SUPPORTED:
      '🚫 Ce rendez-vous a été réservé avec un code promo avant la mise à jour des montants : aucune remise ne peut s’y ajouter.',
    RESERVATION_AMOUNT_ADJUSTMENT_NOT_FOUND: '🔍 Le total de ce rendez-vous suit déjà ses prestations.',
    RESERVATION_NOT_CANCELLED: '🚫 Le rendez-vous doit d’abord être annulé avant de pouvoir être supprimé.',
    RESERVATION_RECURRING_RESCHEDULE_NOT_SUPPORTED:
      '🚫 Les rendez-vous récurrents ne peuvent pas être reprogrammés en bloc. Modifiez chaque occurrence individuellement.',
    APPOINTMENT_NOT_AWAITING_CONFIRMATION: "🚫 Ce rendez-vous n'est pas en attente de confirmation.",
    RESERVATION_ALREADY_CANCELLED: '🚫 Ce rendez-vous est déjà annulé.',
    RESERVATION_NOT_CONFIRMED: '🚫 Seul un rendez-vous confirmé peut être marqué « client non présenté ».',
    RESERVATION_ALREADY_NO_SHOW:
      '🚫 Ce rendez-vous est marqué « client non présenté ». Retirez d’abord ce marquage pour l’annuler.',
    RESERVATION_NOT_NO_SHOW: '🚫 Ce rendez-vous n’est pas marqué « client non présenté ».',
    APPOINTMENT_NOT_PAST: '🚫 Un rendez-vous ne peut être marqué « client non présenté » qu’une fois commencé.',
    APPOINTMENT_WITHOUT_CUSTOMER: '🚫 Un créneau sans client ne peut pas être marqué « client non présenté ».',
    CHANNEL_NOT_ALLOWED_FOR_EVENT:
      "🚫 Ce canal n'est pas autorisé pour ce type de notification. Choisissez un autre canal.",
    ADMIN_INVALID_CREDENTIALS: '🔒 Identifiants invalides ou compte désactivé.',
    ADMIN_USER_NOT_FOUND: '🔍 Compte administrateur introuvable.',
    ADMIN_SESSION_HANDOFF_FORBIDDEN_ORIGIN: '🔒 Transfert de session refusé depuis cette origine.',
    ADMIN_SESSION_COOKIE_REQUIRED: '🔒 Session administrateur expirée, reconnecte-toi.',
    ADMIN_MFA_TOKEN_INVALID: '🔒 Étape de vérification expirée : reconnecte-toi.',
    ADMIN_MFA_INVALID_CODE: '🔒 Code invalide, expiré ou déjà utilisé.',
    ADMIN_MFA_LOCKED: '🔒 Trop de codes invalides : réessaie dans 15 minutes.',
    ADMIN_MFA_ENROLL_NOT_STARTED: "🔒 Scanne d'abord le QR code, puis saisis le code affiché.",
    ADMIN_MFA_CANNOT_RESET_SELF: 'Vous ne pouvez pas réinitialiser votre propre double authentification.',
    ADMIN_MFA_SECRET_UNREADABLE:
      '🔒 Secret de double authentification illisible : demande à un super-admin de réinitialiser ta 2FA.',
    LEAD_NOT_FOUND: '🔍 Lead introuvable.',
    ASSISTANT_UNAUTHENTICATED: '🚫 Pulse requiert une session professionnelle authentifiée.',
    ASSISTANT_NO_LEAD_FOR_PRO: "🚫 Aucun lead n'est rattaché à cet établissement.",
    ASSISTANT_ATTACHMENT_TOO_LARGE: '🚫 Pièce jointe trop volumineuse.',
    ASSISTANT_ATTACHMENT_INVALID_TYPE: '🚫 Format de pièce jointe non supporté.',
    TEAM_MEMBER_LIMIT_REACHED:
      "🚫 Vous avez atteint le nombre de membres d'équipe inclus dans votre abonnement. Rendez-vous dans votre abonnement pour l'augmenter.",
    GMB_LIMIT_REACHED:
      '🚫 Vous avez atteint le nombre de fiches Google Business incluses dans votre abonnement. Rendez-vous dans votre abonnement pour l’augmenter.',
    GOOGLE_LOCATION_NOT_FOUND: '🔍 Cette fiche Google est introuvable.',
    GMB_ACCOUNT_NOT_CONNECTED: '🔌 Reconnectez votre compte Google pour envoyer vos informations.',
    GMB_NO_PUSH_FIELD_ENABLED: '☑️ Activez au moins une information avant de l’envoyer à Google.',
    GMB_PUSH_TOO_SOON: '⏳ Un envoi vient d’être effectué. Patientez une minute avant de recommencer.',
    GMB_PUSH_REQUIRES_SUBSCRIPTION:
      '🔒 Pendant l’essai, on lit votre fiche Google sans rien y écrire. L’envoi s’active avec votre abonnement.',
    GMB_PLACE_KIND_NOT_LINKABLE:
      '📍 Seul un lieu « En établissement » ou « En déplacement » peut être lié à une fiche Google.',
    MAILBOX_LIMIT_REACHED:
      '🚫 Vous avez atteint le nombre de boîtes email incluses dans votre plan. Passez à un plan supérieur pour en créer davantage.',
    EMAIL_HOSTING_UNAVAILABLE: "🚫 L'hébergement email n'est pas disponible pour le moment.",
    DOMAIN_NOT_OWNED: '🚫 Ce domaine ne vous appartient pas.',
    DOMAIN_EMAIL_HOSTING_BLOCKED: "🚫 L'hébergement email n'est pas disponible pour ce domaine (géré séparément).",
    // Migration des boîtes mail OVH → Stalwart (admin).
    MAIL_MIGRATION_NOT_FOUND: '🚫 Migration mail introuvable.',
    MAIL_MIGRATION_UNAVAILABLE: '🚫 Les clés OVH de migration mail ne sont pas configurées sur cet environnement.',
    MAIL_MIGRATION_INVALID_STATUS: "✋ Cette action n'est pas possible dans l'état actuel de la migration.",
    MAIL_MIGRATION_NOT_READY: "✋ Lancez « Préparer » d'abord : tous les prérequis doivent être verts avant de migrer.",
    MAIL_MIGRATION_NO_SNAPSHOT:
      "✋ Aucun instantané DNS n'a été pris pour ce domaine : retour arrière impossible proprement.",
    MAIL_MIGRATION_NO_PASSWORD:
      '🚫 Aucun mot de passe de remise à révéler (déjà révélé, ou retour arrière non terminé).',
    DOMAIN_EXTERNAL_MAIL_DETECTED: `✋ Ce domaine reçoit déjà ses emails sur une autre messagerie (Office 365, Google Workspace…). Créer une boîte ${PROJECT_CONFIG.brand_string} la couperait : contactez-nous si vous souhaitez migrer vos emails.`,
    DOMAIN_MAIL_CHECK_UNAVAILABLE:
      '⏳ Impossible de vérifier la configuration email de votre domaine pour le moment. Réessayez dans quelques minutes.',
    MAILBOX_ALREADY_EXISTS: '🚫 Une boîte email avec cette adresse existe déjà.',
    MAILBOX_NOT_FOUND: "🚫 Cette boîte email n'existe pas.",
    MAILBOX_NOT_READY: "🚫 Cette boîte email n'est pas encore prête.",
    MAILBOX_PASSWORD_CONTAINS_ADDRESS: '🚫 Le mot de passe ne doit pas contenir votre adresse email.',
    ADDON_UNKNOWN: "🚫 Cette option n'existe pas.",
    ADDON_NOT_ELIGIBLE: '🚫 Cette option n’est pas disponible pour votre plan actuel.',
    ADDON_SEO_PACK_INACTIVE:
      '🚫 Cette option est réservée aux comptes dont le pack référencement est actif (formule Max, hors essai).',
    ADDON_QUANTITY_REQUIRED: '🚫 Indiquez une quantité pour activer cette option.',
    ADDON_QUANTITY_INVALID: '🚫 La quantité doit être un entier positif.',
    ADDON_NOT_ACTIVE: "🚫 Cette option n'est pas active sur votre abonnement.",
    CHECKOUT_ADDONS_NOT_ALLOWED: '🚫 Vos options se gèrent depuis « Mes options » une fois abonné.',
    SUBSCRIPTION_NOT_FOUND: "🚫 Aucun abonnement actif n'a été trouvé.",
    PULSE_QUOTA_EXCEEDED:
      '🚫 Vous avez utilisé tous vos messages Pulse ce mois-ci. Passez à un plan supérieur pour plus de messages.',
    CANNOT_DETERMINE_CANCELLATION_DATE: "🚫 Impossible de déterminer la date d'annulation. Contactez le support.",
    NO_ACTIVE_SUBSCRIPTION: '🚫 Aucun abonnement actif trouvé pour cet établissement.',
    SUBSCRIPTION_DATA_NOT_FOUND: '🚫 Le plan demandé est introuvable.',
    NO_CHANGE_REQUESTED: '🚫 Le plan demandé est identique au plan actuel : rien à modifier.',
    NO_DEFAULT_PAYMENT_METHOD: '🚫 Aucun moyen de paiement par défaut. Ajoutez-en un avant de modifier votre plan.',
    OFFER_NOT_FOUND_OR_EXPIRED: "🚫 Aucune offre active ou l'offre a expiré.",
    OFFER_NOT_DISCOUNT_TYPE: "🚫 Cette offre n'est pas applicable ici.",
    NO_PENDING_PLAN_CHANGE: '🚫 Aucun changement de plan programmé à annuler.',
    NOT_PAST_DUE: '🚫 Aucun paiement en retard à régulariser.',
    NO_OUTSTANDING_PAYMENT: '🚫 Aucun paiement en échec à relancer.',
    REGULARIZATION_PAYMENT_FAILED:
      '🚫 Le paiement a été refusé. Vérifiez votre moyen de paiement, puis réessayez pour réactiver votre compte.',
    TRIAL_ADDON_NOT_AVAILABLE:
      "🚫 L'activation d'options en libre essai n'est disponible que pendant la période d'essai.",
    INVALID_TRIAL_ADDON: '🚫 Cette option ne peut pas être activée en essai.',
    INVOICE_PDF_UNAVAILABLE:
      '🚫 Le PDF de cette facture est momentanément indisponible. Réessayez dans quelques instants.',
    LIMITS_EXCEEDED_FOR_TARGET_PLAN:
      "🚫 Votre usage actuel dépasse les limites du plan visé (utilisateurs ou fiches Google). Supprimez les ressources en surplus avant de changer d'abonnement.",
    CALENDAR_SYNC_PROVIDER_NOT_SUPPORTED: "Ce fournisseur de calendrier n'est pas pris en charge.",
    CALENDAR_SYNC_MEMBER_FORBIDDEN: "Vous n'avez pas le droit de modifier la synchronisation de ce membre.",
    CALENDAR_SYNC_PROVIDER_AUTH_FAILED: "L'authentification auprès du fournisseur a échoué. Veuillez réessayer.",
    CALENDAR_SYNC_STATE_INVALID: 'Le lien de synchronisation est invalide.',
    CALENDAR_SYNC_STATE_EXPIRED: 'Le lien d’autorisation a expiré. Veuillez relancer la connexion.',
    CALENDAR_SYNC_NOT_CONNECTED: 'Aucune synchronisation active pour ce membre.',
    CALENDAR_SYNC_CALENDAR_READ_ONLY: `Ce calendrier est en lecture seule : vos rendez-vous ne peuvent pas y être ajoutés. Choisissez un calendrier dont vous êtes propriétaire, ou le sens « Calendrier connecté vers ${PROJECT_CONFIG.brand_string} ».`,
    ICAL_TEAM_MEMBER_NOT_FOUND: 'Ce membre est introuvable.',
    ICAL_FEED_NOT_FOUND: "Ce flux iCal n'existe pas ou a été révoqué.",
  },
  // Libellés des boutons d'action attachés au toast d'erreur global : une clé ici
  // (même nom que l'erreur dans API_ERRORS) = un bouton qui emmène le pro sur
  // l'écran où il peut lever le blocage. Voir `lib/api-error-actions.ts`.
  API_ERROR_ACTIONS: {
    NO_ACTIVITY_SET: 'Choisir mes activités',
  },
  // Bandeau affiché dans la pro frontend quand un admin a pris le contrôle du compte.
  IMPERSONATION_BANNER: {
    TITLE: 'Prise de contrôle : {name}',
    READ_ONLY: 'Lecture seule',
    FULL: 'Contrôle total',
    EXIT: 'Quitter',
    CONNECTING: 'Connexion à la session…',
    EXCHANGE_ERROR: 'Lien de prise de contrôle invalide ou expiré. Relancez l’impersonation depuis l’admin.',
    ALREADY_CONNECTED: 'Une session est déjà ouverte',
    ALREADY_CONNECTED_DESC:
      'Un compte est déjà connecté dans ce navigateur. Déconnectez-vous d’abord pour éviter de mélanger les sessions.',
    LOGOUT_AND_CONTINUE: 'Se déconnecter et continuer',
    SAVE_LOCKED: 'Lecture seule : l’enregistrement est désactivé pendant la prise de contrôle.',
  },
  // Page intermédiaire du lien de reprise d'essai (`/resume?token=…`, emails J0 → J7).
  TRIAL_RESUME_PAGE: {
    TITLE: 'Reprenez là où vous vous êtes arrêté',
    DESCRIPTION: 'Un clic et vous êtes connecté à votre espace, sans mot de passe.',
    CTA: 'Reprendre ma configuration',
    CONNECTING: 'Connexion à votre espace…',
    ERROR_TITLE: 'Ce lien n’est plus valable',
    ERROR_DESCRIPTION:
      'Il a expiré avec votre essai, ou vous avez depuis défini un mot de passe. Connectez-vous avec votre email.',
    GO_TO_LOGIN: 'Me connecter',
    ALREADY_CONNECTED: 'Une session est déjà ouverte',
    ALREADY_CONNECTED_DESC:
      'Un compte est déjà connecté dans ce navigateur. Déconnectez-vous d’abord pour éviter de mélanger les sessions.',
    LOGOUT_AND_CONTINUE: 'Se déconnecter et continuer',
    // Variante `?handoff=` : arrivée depuis l'inscription du quiz (suite de la passerelle « Votre espace est prêt »).
    HANDOFF_TITLE: 'On ouvre votre démo',
    HANDOFF_DESCRIPTION: 'Encore une seconde : votre site et vos prestations vous attendent.',
    HANDOFF_ERROR_TITLE: 'Votre compte est bien créé',
    HANDOFF_ERROR_DESCRIPTION:
      'Ce lien d’entrée a déjà servi. Ouvrez le lien reçu par SMS pour retrouver votre espace, ou connectez-vous.',
  },
  // Bouton + modale « prendre le contrôle d’un compte » côté admin-web.
  ADMIN_IMPERSONATION: {
    BUTTON: 'Prendre le contrôle',
    DIALOG_TITLE: 'Prendre le contrôle du compte',
    DIALOG_DESCRIPTION: 'Ouvre le compte du client dans un nouvel onglet. Toutes les prises de contrôle sont tracées.',
    SCOPE_LABEL: 'Niveau d’accès',
    SCOPE_READ_ONLY: 'Lecture seule',
    SCOPE_READ_ONLY_DESC: 'Consulter le compte sans rien pouvoir modifier (idéal support).',
    SCOPE_FULL: 'Contrôle total',
    SCOPE_FULL_DESC: 'Modifier le compte pour le corriger (réservé aux super-admins).',
    CONFIRM: 'Démarrer',
    CANCEL: 'Annuler',
    OPENING: 'Ouverture de la session…',
    ERROR: 'Impossible de démarrer la prise de contrôle. Réessayez.',
  },
  ADMIN_INVOICES: {
    TITLE: 'Factures',
    SUBTITLE: 'Factures et avoirs du client. Un remboursement rend l’argent et émet l’avoir comptable.',
    EMPTY: 'Aucune facture pour ce client.',
    COLUMN_NUMBER: 'Numéro',
    COLUMN_LABEL: 'Libellé',
    COLUMN_AMOUNT: 'Montant',
    COLUMN_DATE: 'Date',
    CREDIT_NOTE_BADGE: 'Avoir',
    PDF_LINK: 'PDF',
    PDF_ERROR: 'Impossible de récupérer le PDF de cette facture. Réessayez dans quelques instants.',
    PARTIALLY_REFUNDED: 'Remboursée en partie · reste {amount}',
    REFUND_BUTTON: 'Rembourser',
    DIALOG_TITLE: 'Rembourser la facture',
    DIALOG_DESCRIPTION:
      'L’argent est rendu au client et un avoir est émis automatiquement. L’opération est tracée et irréversible.',
    AMOUNT_LABEL: 'Montant à rembourser (TTC)',
    AMOUNT_HELP: 'Laissez vide pour rembourser la totalité ({amount}).',
    REASON_LABEL: 'Motif',
    REASON_PLACEHOLDER: 'Ex. : geste commercial, service non rendu…',
    CONFIRM: 'Rembourser',
    CANCEL: 'Annuler',
    PROCESSING: 'Remboursement en cours…',
    SUCCESS: 'Remboursement effectué et avoir émis.',
    SUCCESS_CREDIT_PENDING:
      'Argent remboursé. L’avoir n’a pas pu être émis dans l’immédiat : il sera généré automatiquement.',
    ERROR: 'Le remboursement a échoué. Rien n’a été débité.',
    // Raisons pour lesquelles le remboursement automatique n'est pas proposé.
    BLOCKED_PROVIDER_NOT_SUPPORTED:
      'Facture émise avant la bascule comptable : remboursez-la manuellement depuis le tableau de bord Stripe, puis créez l’avoir correspondant.',
    BLOCKED_PAYMENT_REF_MISSING:
      'Aucune référence de paiement enregistrée : remboursez manuellement depuis le tableau de bord Stripe.',
    BLOCKED_NOT_EMITTED: 'Facture non émise : rien à rembourser.',
    BLOCKED_FULLY_REFUNDED: 'Facture intégralement remboursée.',
    BLOCKED_IS_CREDIT_NOTE: 'Un avoir ne se rembourse pas.',
    BLOCKED_PAID_BY_SEPA_DEBIT:
      'Facture réglée par prélèvement SEPA (GoCardless) : remboursez-la manuellement depuis le tableau de bord GoCardless, puis créez l’avoir correspondant.',
  },
  AI_ASSIST: {
    BUTTON_LABEL: 'Pulse',
    MENU_TITLE: 'Assistant IA',
    ACTION_GENERATE: 'Générer',
    ACTION_REPHRASE: 'Reformuler',
    ACTION_FIX: 'Corriger',
    ACTION_SHORTEN: 'Raccourcir',
    ACTION_EXPAND: 'Développer',
    ACTION_TONE: 'Changer le ton',
    ACTION_TONE_PROFESSIONAL: 'Professionnel',
    ACTION_TONE_WARM: 'Chaleureux',
    ACTION_TONE_PUNCHY: 'Percutant',
    ACTION_TRANSLATE: 'Traduire',
    LOADING: 'Pulse rédige…',
    PREVIEW_TITLE: 'Suggestion de Pulse',
    APPLY: 'Appliquer',
    CANCEL: 'Annuler',
    RETRY: 'Réessayer',
    BACK: 'Retour',
    ERROR: "Pulse n'a pas pu répondre. Réessayez.",
    VOICE_SINGULAR: 'Je',
    VOICE_PLURAL: 'Nous',
    PANEL_TITLE: 'Pulse',
    INPUT_PLACEHOLDER: 'Demandez une modification…',
    SEND: 'Envoyer',
    ACCEPT: 'Garder',
    REJECT: 'Ignorer',
    APPLIED: 'Appliqué au champ',
    SHORTCUTS_LABEL: 'Raccourcis',
    EMPTY_THREAD: 'Choisissez un raccourci ou décrivez ce que vous voulez.',
    DRAFT_GUIDES_ACTION: 'Votre note guidera le raccourci choisi.',
    RESET_THREAD: 'Recommencer',
    EMPTY_GENERATE_HINT: 'Pulse s’appuie sur les informations déjà saisies dans la fiche.',
    YOU: 'Vous',
    STOP: 'Arrêter',
    REGENERATE: 'Régénérer',
  },
  PRO_AI_CONTEXT: {
    TITLE: 'Pulse & voix de marque',
    SUBTITLE: 'Donnez à Pulse le contexte de votre activité : il rédige alors dans votre voix, partout.',
    DEFAULT_VOICE_TITLE: 'Voix par défaut',
    DEFAULT_VOICE_HINT: 'Comment Pulse parle de vous quand il rédige.',
    DEFAULT_TONE_TITLE: 'Ton par défaut',
    TONE_PROFESSIONAL: 'Professionnel',
    TONE_WARM: 'Chaleureux',
    TONE_PUNCHY: 'Percutant',
    GUIDELINES_TITLE: 'Consignes',
    GUIDELINES_HINT:
      'Les règles que Pulse respecte en rédigeant (ex. « toujours vouvoyer », « ne jamais citer les prix »).',
    GUIDELINES_EMPTY: 'Aucune consigne pour le moment. Pulse en proposera au fil de vos échanges.',
    ADD_GUIDELINE_PLACEHOLDER: 'Ajouter une consigne…',
    ADD_GUIDELINE: 'Ajouter',
    SOURCE_PULSE: 'Appris par Pulse',
    SOURCE_MANUAL: 'Ajouté par vous',
    DELETE_GUIDELINE: 'Supprimer la consigne',
    SAVED: 'Enregistré',
  },
  DYNAMIC_FORM: {
    // Codes promo (B2C) : libellés des unions kind / distribution et champs du formulaire pro.
    ...ProPromoCodeKindTranslation['fr-FR'],
    ...ProPromoCodeDistributionTranslation['fr-FR'],
    ...ProPromoCodeTriggerTranslation['fr-FR'],
    ...ProPromoCodeStatusTranslation['fr-FR'],
    ...ProPromoCodeCustomerScopeTranslation['fr-FR'],
    INPUT_TITLE_PRO_PROMO_DISTRIBUTION: 'Type de code',
    INPUT_PLACEHOLDER_PRO_PROMO_DISTRIBUTION: 'Choisir',
    INPUT_TITLE_PRO_PROMO_CODE_CODE: 'Code',
    INPUT_PLACEHOLDER_PRO_PROMO_CODE_CODE: 'Ex : ETE20',
    INPUT_TITLE_PRO_PROMO_PERSONAL_PREFIX: 'Préfixe des codes personnels',
    INPUT_PLACEHOLDER_PRO_PROMO_PERSONAL_PREFIX: 'Ex : ETE (donne ETE-A3F9K2)',
    INPUT_TITLE_PRO_PROMO_LABEL: 'Nom interne',
    INPUT_PLACEHOLDER_PRO_PROMO_LABEL: 'Ex : Offre de rentrée',
    // Description PUBLIQUE de la promotion : reprise par le site, « Offres du moment » et Pulse.
    INPUT_TITLE_PRO_PROMO_DESCRIPTION: 'Description affichée aux clients (facultatif)',
    INPUT_PLACEHOLDER_PRO_PROMO_DESCRIPTION: 'Ex : Toutes les coupes à prix doux pendant une semaine.',
    PRO_PROMO_SECTION_DISCOUNT: 'Remise',
    INPUT_TITLE_PRO_PROMO_KIND: 'Type de remise',
    INPUT_PLACEHOLDER_PRO_PROMO_KIND: 'Choisir',
    INPUT_TITLE_PRO_PROMO_VALUE: 'Valeur de la remise',
    INPUT_PLACEHOLDER_PRO_PROMO_VALUE_PERCENT: 'Ex : 20',
    INPUT_PLACEHOLDER_PRO_PROMO_VALUE_FIXED: 'Ex : 10,00',
    PRO_PROMO_VALUE_PERCENT_SUFFIX: '%',
    INPUT_TITLE_PRO_PROMO_TARGETING: 'Prestations concernées',
    INPUT_PLACEHOLDER_PRO_PROMO_TARGETING: 'Toutes les prestations',
    PRO_PROMO_SECTION_CONDITIONS: 'Conditions d’utilisation',
    INPUT_TITLE_PRO_PROMO_VALID_FROM: 'Valable à partir du',
    INPUT_TITLE_PRO_PROMO_VALID_UNTIL: 'Valable jusqu’au',
    INPUT_PLACEHOLDER_PRO_PROMO_VALID_UNTIL: 'Sans date de fin',
    INPUT_TITLE_PRO_PROMO_DAYS_OF_WEEK: 'Jours autorisés',
    INPUT_HINT_PRO_PROMO_DAYS_OF_WEEK: 'Aucun jour coché : valable tous les jours.',
    INPUT_TITLE_PRO_PROMO_TIME_WINDOWS: 'Plages horaires autorisées',
    INPUT_TITLE_PRO_PROMO_TIME_START: 'Début',
    INPUT_TITLE_PRO_PROMO_TIME_END: 'Fin',
    INPUT_TITLE_PRO_PROMO_MAX_REDEMPTIONS: 'Nombre d’utilisations maximum',
    INPUT_TITLE_PRO_PROMO_MAX_PER_CUSTOMER: 'Utilisations maximum par client',
    INPUT_PLACEHOLDER_PRO_PROMO_UNLIMITED: 'Illimité',
    INPUT_TITLE_PRO_PROMO_MIN_CART: 'Panier minimum',
    INPUT_PLACEHOLDER_PRO_PROMO_MIN_CART: 'Aucun minimum',
    INPUT_TITLE_PRO_PROMO_FIRST_TIME_ONLY: 'Réservé aux nouveaux clients',
    INPUT_TITLE_PRO_PROMO_RESTORE_ON_CANCEL: 'Restituer l’utilisation si le client annule dans les délais',
    INPUT_TITLE_PRO_PROMO_IS_ACTIVE: 'Code actif',
    INPUT_WEEKDAY_1: 'Lun',
    INPUT_WEEKDAY_2: 'Mar',
    INPUT_WEEKDAY_3: 'Mer',
    INPUT_WEEKDAY_4: 'Jeu',
    INPUT_WEEKDAY_5: 'Ven',
    INPUT_WEEKDAY_6: 'Sam',
    INPUT_WEEKDAY_7: 'Dim',
    INPUT_TITLE_SEO_PUBLISH_MONDAY: 'Publier le lundi',
    INPUT_TITLE_SEO_PUBLISH_TUESDAY: 'Publier le mardi',
    INPUT_TITLE_SEO_PUBLISH_WEDNESDAY: 'Publier le mercredi',
    INPUT_TITLE_SEO_PUBLISH_THURSDAY: 'Publier le jeudi',
    INPUT_TITLE_SEO_PUBLISH_FRIDAY: 'Publier le vendredi',
    INPUT_TITLE_SEO_PUBLISH_SATURDAY: 'Publier le samedi',
    INPUT_TITLE_SEO_PUBLISH_SUNDAY: 'Publier le dimanche',
    INPUT_TITLE_SEO_PUBLISH_HOUR: 'Heure de publication (heure locale)',
    INPUT_TITLE_SEO_BACKLINK_MODE: 'Articles sur les sites partenaires',
    INPUT_TITLE_SEO_AUTHOR: 'Publier en tant que',
    INPUT_TITLE_SEO_TONE: 'Ton des articles',
    INPUT_PLACEHOLDER_SEO_TONE: 'Ex. : chaleureux et concret, sans jargon',
    INPUT_TITLE_SEO_FOCUS_TOPICS: 'Sujets à cibler en priorité (un par ligne, quelques mots chacun)',
    INPUT_PLACEHOLDER_SEO_FOCUS_TOPICS:
      'Ex. :\nbalayage\nlissage brésilien\ncoiffure de mariée\nUne phrase entière (angle, règle à suivre) va dans « Consignes de rédaction ».',
    INPUT_TITLE_SEO_EXCLUDED_TOPICS: 'Sujets à ne jamais proposer (un par ligne, quelques mots chacun)',
    INPUT_PLACEHOLDER_SEO_EXCLUDED_TOPICS:
      'Ex. :\nextensions de cils\ntarifs des concurrents\nUne règle en phrase va dans « Consignes de rédaction ».',
    INPUT_TITLE_SEO_FORBIDDEN_TERMS: 'Mots ou marques à ne jamais écrire (un par ligne, quelques mots chacun)',
    INPUT_PLACEHOLDER_SEO_FORBIDDEN_TERMS:
      'Ex. :\nlow cost\nnom d’un concurrent\nUne règle en phrase va dans « Consignes de rédaction ».',
    INPUT_TITLE_SEO_COMPETITOR_SITES: 'Sites concurrents à surveiller (un par ligne : domaine ou adresse de leur blog)',
    INPUT_PLACEHOLDER_SEO_COMPETITOR_SITES:
      'Ex. :\nsalon-voisin.fr\nhttps://www.autre-salon.com/blog\nLeurs sujets inspirent vos propositions, ils ne sont jamais cités.',
    INPUT_TITLE_SEO_WRITING_GUIDELINES: 'Consignes de rédaction',
    INPUT_PLACEHOLDER_SEO_WRITING_GUIDELINES:
      'Ex. : toujours rappeler que le diagnostic est offert ; ne pas parler de prix dans les titres ; vouvoyer.',
    INPUT_TITLE_SEO_PERSONA_WHO: 'Qui écrit (persona)',
    INPUT_PLACEHOLDER_SEO_PERSONA_WHO: 'Ex. : Camille, coloriste depuis douze ans à Lyon',
    INPUT_TITLE_SEO_PERSONA_CONVICTIONS: 'Vos partis pris métier (un par ligne)',
    INPUT_PLACEHOLDER_SEO_PERSONA_CONVICTIONS:
      'Ex. :\nJe refuse deux décolorations le même jour\nUne patine bien faite vaut mieux qu’un balayage refait trop tôt',
    INPUT_TITLE_SEO_PERSONA_MISCONCEPTIONS: 'Idées reçues que vous corrigez souvent (une par ligne)',
    INPUT_PLACEHOLDER_SEO_PERSONA_MISCONCEPTIONS: 'Ex. :\nUn balayage abîme forcément les cheveux',
    INPUT_TITLE_SEO_PERSONA_NEVER_SAYS: 'Ce que vous ne dites jamais (un par ligne)',
    INPUT_PLACEHOLDER_SEO_PERSONA_NEVER_SAYS: 'Ex. :\nPromettre un résultat garanti\nParler de « low cost »',
    WEBSITE_PUBLIC_CLOSE: 'Fermer',
    WEBSITE_PUBLIC_GIFT_TUNNEL_CLOSE_CONFIRM: 'Voulez-vous vraiment fermer ? Votre sélection en cours sera perdue.',
    BILLING_INFO_LEGAL_NAME: 'Nom de votre entreprise',
    BILLING_INFO_LEGAL_NAME_PLACEHOLDER: 'Ex : Salon Élodie ou Élodie Martin',
    BILLING_INFO_SIRET: 'N° SIRET',
    BILLING_INFO_SIRET_PLACEHOLDER: '123 456 789 00012',
    BILLING_INFO_VAT_NUMBER: 'N° TVA intracommunautaire',
    BILLING_INFO_VAT_NUMBER_PLACEHOLDER: 'FR32123456789',
    BILLING_INFO_ADDRESS: 'Adresse de facturation',
    TEAM_MEMBER_ROLE: 'Rôle',
    PREVIOUS: 'Précédent',
    NEXT: 'Suivant',
    MIN: 'Minimum',
    MAX: 'Maximum',
    NUMBER_RANGE_INVALID: 'Le minimum doit être inférieur au maximum',
    EMPTY_ARRAY_FIRST_INFO: 'Ajoutez vos premières informations.',
    EMPTY_ARRAY_FIRST_INFO_FOR: 'Ajoutez vos premières informations pour « {field_label} ».',
    QUIET_HOURS_WARNING_TITLE: 'Envoi en dehors des horaires recommandés',
    QUIET_HOURS_WARNING_DESC:
      'Les SMS commerciaux ne doivent pas être envoyés entre 20h et 8h, ni le dimanche ou les jours fériés. Choisissez un créneau entre 8h et 20h pour respecter la réglementation et vos clients.',
    APPLY: 'Appliquer',
    RESET: 'Réinitialiser',
    CLEAR_FILTER: 'Effacer',
    ADVANCED_FILTERS: 'Filtres avancés',
    GLOBAL_NAME: 'Nom',
    INPUT_PLACEHOLDER_CHOOSE: 'Choisir',
    INPUT_RIDE_ZONE_NAME_TITLE: 'Nom du trajet',
    INPUT_RIDE_ZONE_NAME_PLACEHOLDER: 'Ex. Aéroport → Centre-ville',
    INPUT_RIDE_ZONE_DEFAULT_PRICE_TITLE: 'Prix par défaut',
    INPUT_RIDE_ZONE_DEFAULT_PRICE_PLACEHOLDER: 'Prix forfaitaire du trajet',
    INPUT_RIDE_ZONE_POLYGON_START_TITLE: 'Zone de départ',
    INPUT_RIDE_ZONE_POLYGON_START_PLACEHOLDER: 'Rechercher une zone de départ...',
    INPUT_RIDE_ZONE_POLYGON_END_TITLE: "Zone d'arrivée",
    INPUT_RIDE_ZONE_POLYGON_END_PLACEHOLDER: "Rechercher une zone d'arrivée...",
    INPUT_PRO_RESOURCE_NAME_TITLE: 'Nom',
    INPUT_PRO_RESOURCE_NAME_PLACEHOLDER: 'Ex. Cabine n°1, Tapis de yoga…',
    INPUT_PRO_RESOURCE_DESCRIPTION_TITLE: 'Description',
    INPUT_PRO_RESOURCE_DESCRIPTION_PLACEHOLDER: 'Décrivez la ressource',
    INPUT_PRO_RESOURCE_QUANTITY_TITLE: "Nombre d'unités",
    INPUT_PRO_RESOURCE_QUANTITY_PLACEHOLDER: 'Ex. 3',
    INPUT_PRO_RESOURCE_CAPACITY_TITLE: 'Personnes par unité',
    INPUT_PRO_RESOURCE_CAPACITY_PLACEHOLDER: 'Ex. 2 (une cabine duo)',
    INPUT_PRO_RESOURCE_IS_EXCLUSIVE_TITLE: 'Réserver une unité entière par RDV',
    INPUT_PRO_RESOURCE_IS_ACTIVE_TITLE: 'Actif',
    INPUT_PRO_RESOURCE_PAX_MIN_TITLE: 'Passagers (min)',
    INPUT_PRO_RESOURCE_PAX_MIN_PLACEHOLDER: 'Nombre minimum de passagers',
    INPUT_PRO_RESOURCE_PAX_MAX_TITLE: 'Passagers (max)',
    INPUT_PRO_RESOURCE_PAX_MAX_PLACEHOLDER: 'Nombre maximum de passagers',
    INPUT_PRO_RESOURCE_SMALL_LUGGAGE_MIN_TITLE: 'Petits bagages (min)',
    INPUT_PRO_RESOURCE_SMALL_LUGGAGE_MIN_PLACEHOLDER: 'Nombre minimum de petits bagages',
    INPUT_PRO_RESOURCE_SMALL_LUGGAGE_MAX_TITLE: 'Petits bagages (max)',
    INPUT_PRO_RESOURCE_SMALL_LUGGAGE_MAX_PLACEHOLDER: 'Nombre maximum de petits bagages',
    INPUT_PRO_RESOURCE_LARGE_LUGGAGE_MIN_TITLE: 'Grands bagages (min)',
    INPUT_PRO_RESOURCE_LARGE_LUGGAGE_MIN_PLACEHOLDER: 'Nombre minimum de grands bagages',
    INPUT_PRO_RESOURCE_LARGE_LUGGAGE_MAX_TITLE: 'Grands bagages (max)',
    INPUT_PRO_RESOURCE_LARGE_LUGGAGE_MAX_PLACEHOLDER: 'Nombre maximum de grands bagages',
    INPUT_PRO_RESOURCE_VEHICLE_NAME_PLACEHOLDER: 'Ex. Berline, Van premium…',
    INPUT_PRO_RESOURCE_VEHICLE_QUANTITY_TITLE: 'Nombre de véhicules',
    INPUT_PRO_RESOURCE_VEHICLE_QUANTITY_PLACEHOLDER: 'Ex. 3',
    INPUT_PRO_RESOURCE_PICTURES_TITLE: 'Photos',
    INPUT_PRO_RESOURCE_PICTURES_PLACEHOLDER: 'Ajouter des photos',
    INPUT_PRO_RESOURCE_PRESTATION_IDS_TITLE: 'Prestations liées',
    INPUT_PRO_RESOURCE_PRESTATION_IDS_PLACEHOLDER: 'Sélectionner des prestations',
    INPUT_PRO_RESOURCE_PLACE_IDS_TITLE: 'Lieux liés',
    INPUT_PRO_RESOURCE_PLACE_IDS_PLACEHOLDER: 'Sélectionner des lieux',
    INPUT_PRO_RESOURCE_CATEGORY_TITLE: 'Catégorie',
    INPUT_PRO_RESOURCE_CATEGORY_PLACEHOLDER: 'Choisir une catégorie',
    INPUT_PRO_RESOURCE_TYPE_TITLE: 'Type',
    INPUT_PRO_RESOURCE_TYPE_PLACEHOLDER: 'Choisir un type',
    INPUT_PRO_RESOURCE_BOOKING_MODE_TITLE: 'Mode de réservation',
    INPUT_PRO_RESOURCE_BOOKING_MODE_PLACEHOLDER: 'Choisir un mode de réservation',
    INPUT_EMAIL: 'Email',
    INPUT_PASSWORD: 'Mot de passe',
    INPUT_TITLE_CURRENT_PASSWORD: 'Mot de passe actuel',
    INPUT_TITLE_NEW_EMAIL: 'Nouvelle adresse email',
    INPUT_PLACEHOLDER_NEW_EMAIL: 'nouvelle.adresse@exemple.fr',
    INPUT_CONFIRM_PASSWORD: 'Confirmer le mot de passe',
    INPUT_TAG_TITLE: 'Ajouter un titre',
    INPUT_TAG_TOP_TITLE: 'Titre',
    INPUT_TAG_COLOR_TOP_TITLE: 'Couleur du tag',
    INPUT_TITLE_PRO_CUST_NAME: 'Prénom',
    INPUT_PLACEHOLDER_PRO_CUST_NAME: 'Ajouter un prénom',
    INPUT_TITLE_PRO_CUST_LASTNAME: 'Nom',
    INPUT_PLACEHOLDER_PRO_CUST_LASTNAME: 'Ajouter un nom',
    INPUT_TITLE_PRO_CUST_GENDER: 'Genre',
    INPUT_PLACEHOLDER_PRO_CUST_GENDER: 'Ajouter un genre',
    INPUT_PLACEHOLDER_PRO_CUST_EMAIL: 'Ajouter un email',
    INPUT_TITLE_PRO_CUST_EMAIL: 'Adresse email',
    INPUT_TITLE_PRO_CUST_BIRTHDAY_YEAR_OPTIONNAL: 'Date de naissance (Année facultative)',
    INPUT_TITLE_PRO_CUST_CUSTOMER_SINCE: 'Client depuis',
    INPUT_PLACEHOLDER_PRO_CUST_CUSTOMER_SINCE: "Date d'entrée du client",
    INPUT_PLACEHOLDER_PRO_CUST_PHONE_NUMBER: 'Ajouter un téléphone',
    INPUT_TITLE_PRO_CUST_PHONE_NUMBER: 'Téléphone',
    INPUT_PLACEHOLDER_PRO_CUST_ADDRESS: 'Rechercher une adresse',
    INPUT_PLACEHOLDER_PRO_CUST_ADDRESS_OR_CITY: 'Rechercher une adresse ou une ville',
    INPUT_TITLE_PRO_CUST_ADDRESS: 'Adresse',
    INPUT_TITLE_PLACE_KIND: 'Type de lieu',
    INPUT_PLACEHOLDER_PLACE_KIND: 'Choisir un type',
    INPUT_TITLE_VIDEO_LINK: 'Lien visio',
    INPUT_PLACEHOLDER_VIDEO_LINK: 'https://meet.example.com/abc-defg-hij',
    INPUT_PLACEHOLDER_PRO_CUST_COMMENT: 'Ajouter un commentaire',
    INPUT_PLACEHOLDER_PRO_SMS_CAMPAIGN_CONTENT: 'Rédiger votre SMS',
    INPUT_TITLE_PRO_SMS_CAMPAIGN_CONTENT: 'Texte du SMS',
    INPUT_TITLE_PRO_CAMPAIGN_PROMO_CODE: 'Promotion',
    INPUT_PLACEHOLDER_PRO_CAMPAIGN_PROMO_CODE: 'Choisir une promotion',
    INPUT_OPTION_PRO_CAMPAIGN_PROMO_CODE_NONE: 'Aucune promotion',
    // Promotion déjà jointe à la campagne mais plus proposable (en pause, terminée, épuisée, supprimée).
    INPUT_OPTION_PRO_CAMPAIGN_PROMO_CODE_INACTIVE: '{label} (plus utilisable)',
    INPUT_OPTION_PRO_CAMPAIGN_PROMO_CODE_DELETED: 'Promotion supprimée',
    INPUT_OPTION_PRO_CAMPAIGN_PROMO_CODE_CURRENT: 'Promotion actuelle',
    INPUT_OPTION_PRO_CAMPAIGN_PROMO_CODE_SCHEDULED: '{label} (à venir)',
    INPUT_ERROR_PRO_CAMPAIGN_PROMO_CODES_LOAD: 'Impossible de charger les promotions.',
    // Résumé de la promotion choisie, sous le champ « Promotion » d'une campagne.
    INPUT_HINT_PRO_CAMPAIGN_PROMOTION_OFFER: '{label} : {value}',
    INPUT_HINT_PRO_CAMPAIGN_PROMOTION_ENDS_AT: 'Jusqu’au {date}',
    // Promotion jugée sur la date de réservation, pas encore commencée : le code est refusé avant.
    INPUT_HINT_PRO_CAMPAIGN_PROMOTION_USABLE_FROM: 'Vos clients pourront en profiter à partir du {date}.',
    INPUT_HINT_PRO_CAMPAIGN_PROMOTION_SHARED_CODE: 'Code {code}',
    INPUT_HINT_PRO_CAMPAIGN_PROMOTION_PERSONAL_CODES: 'Un code unique par destinataire, créé à l’envoi',
    INPUT_HINT_PRO_CAMPAIGN_PROMOTION_AUTO: 'Automatique : pas de code, la remise s’applique toute seule',
    INPUT_HINT_PRO_CAMPAIGN_PROMOTION_EMAIL:
      'Ses valeurs remplissent les variables « Promotion » et le bloc Code promo de l’email.',
    INPUT_HINT_PRO_CAMPAIGN_PROMOTION_SMS: 'Dans le SMS, {token} est remplacé par le code de la promotion.',
    INPUT_HINT_PRO_CAMPAIGN_PROMOTION_MISSING: 'Votre message cite une promotion : choisissez-la ici.',
    INPUT_HINT_PRO_CAMPAIGN_PROMOTION_EMPTY:
      'Aucune promotion active ou à venir : créez-en une dans Communication › Promotions.',
    // Texte proposé dans un SMS vide au choix d'une promotion (sans caractère hors alphabet SMS).
    PRO_CAMPAIGN_SMS_PROMOTION_PREFILL_OFFER: '{label} : {value}',
    PRO_CAMPAIGN_SMS_PROMOTION_PREFILL_ENDS_AT: " jusqu'au {date}",
    PRO_CAMPAIGN_SMS_PROMOTION_PREFILL_CODE: ' avec le code {code}',
    PRO_CAMPAIGN_SMS_PROMOTION_PREFILL_BOOKING: '. Réservez : {url}',
    INPUT_TITLE_PRO_SMS_CAMPAIGN_SENDER: 'Expéditeur',
    INPUT_PLACEHOLDER_PRO_SMS_CAMPAIGN_SENDER: 'Ajouter un expéditeur',
    INPUT_TITLE_PRO_CUST_COMMENT: 'Commentaire',
    INPUT_TITLE_PRO_CUST_TAGS: 'Tag(s)',
    INPUT_TITLE_PRO_CUST_CUSTOM_FIELDS: 'Informations personnalisées',
    INPUT_TITLE_PRO_PAYMENT_CUSTOMER: 'Client',
    INPUT_PLACEHOLDER_PRO_PAYMENT_CUSTOMER: 'Rechercher un client',
    // Nom et description sont montrés au client (page de paiement, email de demande de paiement).
    INPUT_TITLE_PRO_PAYMENT_NAME: 'Nom (visible par le client)',
    INPUT_PLACEHOLDER_PRO_PAYMENT_NAME: 'Ex : Acompte soin visage',
    INPUT_TITLE_PRO_PAYMENT_TYPE: 'Type de paiement',
    INPUT_PLACEHOLDER_PRO_PAYMENT_TYPE: 'Choisir un type de paiement',
    INPUT_TITLE_PRO_PAYMENT_PRESTATIONS: 'Prestations',
    INPUT_PLACEHOLDER_PRO_PAYMENT_PRESTATIONS: 'Ajouter des prestations',
    INPUT_TITLE_PRO_PAYMENT_AMOUNT: 'Montant',
    INPUT_PLACEHOLDER_PRO_PAYMENT_AMOUNT: 'Montant du paiement',
    INPUT_TITLE_PRO_PAYMENT_DESCRIPTION: 'Description (visible par le client)',
    INPUT_PLACEHOLDER_PRO_PAYMENT_DESCRIPTION: 'Ajouter une description',
    INPUT_TITLE_PRO_PAYMENT_APPOINTMENT_ID: 'Rendez-vous lié',
    INPUT_PLACEHOLDER_PRO_PAYMENT_APPOINTMENT_ID: "Ajouter l'identifiant du rendez-vous",
    INPUT_TITLE_PRO_PAYMENT_RESERVATION_ID: 'Réservation liée',
    INPUT_PLACEHOLDER_PRO_PAYMENT_RESERVATION_ID: "Ajouter l'identifiant de la réservation",
    INPUT_TITLE_PRO_PAYMENT_SEND_LINK_EMAIL: 'Envoyer le lien au client par email',
    INPUT_TITLE_PRO_PAYMENT_SEND_LINK_SMS: 'Envoyer le lien au client par SMS',
    ...ProPaymentTypeTranslation['fr-FR'],
    INPUT_TITLE_PRO_MARKETING_EMAIL: 'Marketing par email',
    INPUT_TITLE_PRO_MARKETING_SMS: 'Marketing par SMS',
    NO_RESULTS: 'Aucun résultat.',
    ADD_CUSTOMER_QUICK: 'Nouveau client',
    SAVE: 'Enregistrer',
    BULK_ADD_TAGS_LABEL: 'Ajouter des tags',
    BULK_REMOVE_TAGS_LABEL: 'Retirer des tags',
    INPUT_PLACEHOLDER_PRO_COMMERCIAL_NAME: 'Nom commercial',
    INPUT_TITLE_PRO_COMMERCIAL_NAME: 'Nom commercial',
    INPUT_TITLE_PRO_LEGAL_NAME: 'Nom légal',
    INPUT_TITLE_PRO_SIRET: 'N° SIRET',
    INPUT_TITLE_PRO_SIEGE_ADDRESS: 'Adresse du siège social',
    INPUT_TITLE_PRO_VAT_NUMBER: 'N° TVA intracommunautaire',
    INPUT_PLACEHOLDER_PRO_VAT_NUMBER: 'FR32123456789',
    INPUT_TITLE_PRO_BILLING_ADDRESS: 'Adresse de facturation',
    UPSERT_SECTION_TITLE_PROFILE: 'Profil',
    INPUT_PLACEHOLDER_PRO_DESCRIPTION: 'Décrivez votre établissement...',
    INPUT_TITLE_PRO_DESCRIPTION: 'Description',
    INPUT_TITLE_PRO_EXTERNAL_URLS: 'Liens externes',
    INPUT_TITLE_EXTERNAL_LINK: 'Lien',
    INPUT_TITLE_EXTERNAL_LINK_NAME: 'Nom (optionnel)',
    EXTERNAL_URL_TYPE_WEBSITE: 'Site web',
    EXTERNAL_URL_TYPE_ECOMMERCE: 'E-commerce',
    EXTERNAL_URL_TYPE_FACEBOOK: 'Facebook',
    EXTERNAL_URL_TYPE_INSTAGRAM: 'Instagram',
    EXTERNAL_URL_TYPE_TIKTOK: 'TikTok',
    EXTERNAL_URL_TYPE_LINKEDIN: 'LinkedIn',
    EXTERNAL_URL_TYPE_TWITTER: 'Twitter / X',
    EXTERNAL_URL_TYPE_PINTEREST: 'Pinterest',
    EXTERNAL_URL_TYPE_YOUTUBE: 'YouTube',
    EXTERNAL_URL_TYPE_SOUNDCLOUD: 'SoundCloud',
    UPSERT_SECTION_TITLE_LEGAL: 'Informations légales',
    INPUT_TITLE_PRO_SLUG: 'Slug (URL)',
    INPUT_PLACEHOLDER_PRO_SLUG: 'mon-salon-de-coiffure',
    INPUT_TITLE_PRO_SMS_SENDER: 'Expéditeur SMS',
    INPUT_TITLE_PRO_SMS_MARKETING_SENDER: 'Expéditeur des SMS de campagne',
    INPUT_PLACEHOLDER_PRO_SMS_SENDER: 'Entreprise',
    INPUT_TITLE_PRO_EMAIL_SENDER: "Nom d'expéditeur email",
    INPUT_PLACEHOLDER_PRO_EMAIL_SENDER: 'Mon Établissement',

    INPUT_PLACEHOLDER_PRO_CONFIRM_EVERY_BOOKING: 'Confirmer chaque rendez-vous',
    INPUT_PLACEHOLDER_PRO_MINIMUM_HOURS_BEFORE_BOOKING: 'Délai. min avant réservation (heures)',
    '0HR': 'Aucun délai',
    '1HR': '1 heure',
    '2HR': '2 heures',
    '6HR': '6 heures',
    '12HR': '12 heures',
    '24HR': '24 heures',
    '36HR': '36 heures',
    '48HR': '48 heures',
    '72HR': '72 heures',
    '7DAYS': '7 jours',
    '0MIN': 'Aucun',
    '1MIN': '1 minute',
    '2MIN': '2 minutes',
    '5MIN': '5 minutes',
    '10MIN': '10 minutes',
    '15MIN': '15 minutes',
    '20MIN': '20 minutes',
    '30MIN': '30 minutes',
    '45MIN': '45 minutes',
    '60MIN': '1 heure',
    '120MIN': '2 heures',
    '1WEEK': '1 semaine',
    '2WEEKS': '2 semaines',
    '1MONTH': '1 mois',
    '2MONTHS': '2 mois',
    '3MONTHS': '3 mois',
    '6MONTHS': '6 mois',
    '12MONTHS': '12 mois',
    INPUT_PLACEHOLDER_PRO_MINIMUM_HOURS_BEFORE_CANCEL_BOOKING: 'Délai. min avant annulation (heures)',
    INPUT_PLACEHOLDER_PRO_GAP_BETWEEN_BOOKING: 'Temps de repos entre chaque rendez-vous (minutes)',
    INPUT_PLACEHOLDER_PRO_MAX_BOOKABLE_WINDOW: 'Horizon de réservation maximum',
    INPUT_PLACEHOLDER_PRO_SLOT_STEP: 'Fréquence des créneaux proposés',
    INPUT_PLACEHOLDER_ANCHOR_SLOT_AFTER_BOOKING: 'Proposer un créneau dès la fin d’un autre rendez-vous',
    INPUT_PLACEHOLDER_REST_WITHIN_OPENING_HOURS: 'Inclure le temps de repos dans les horaires d’ouverture',
    INPUT_PLACEHOLDER_ALLOW_MULTI_PRESTATION: 'Autoriser le client à réserver plusieurs prestations à la fois',
    INPUT_PLACEHOLDER_ALLOW_MULTI_MEMBER: 'Autoriser des intervenants différents au sein d’une même réservation',
    INPUT_TITLE_MEMBER_ASSIGNMENT_STRATEGY: 'Attribution quand le client n’a pas de préférence',
    INPUT_PLACEHOLDER_MEMBER_ASSIGNMENT_STRATEGY: 'Choisir le mode d’attribution',
    INPUT_PLACEHOLDER_SHOW_REMAINING_PLACES:
      'Afficher aux clients le nombre de places restantes sur les créneaux (séances de groupe, libre-service)',
    INPUT_PLACEHOLDER_HIDE_NOT_BOOKABLE_ONLINE: 'Masquer dans le tunnel les prestations non réservables en ligne',
    INPUT_HINT_HIDE_NOT_BOOKABLE_ONLINE:
      'Sinon elles s’affichent grisées, avec « Appeler le salon ». Les prestations complètes ne sont jamais masquées.',

    INPUT_TITLE_GEO_JSON_LABEL: 'Ajouter une zone',

    INPUT_PLACEHOLDER_PRO_PLACES_LABEL: 'Ajouter un label',
    INPUT_TITLE_PRO_PLACES_LABEL: 'Label du lien',

    INPUT_TITLE_PRO_CAMPAIGN_NAME: 'Nom de la campagne',
    INPUT_TITLE_PRO_CAMPAIGN_RECIPIENTS: 'Destinataires',
    ALL_CUSTOMERS_TAG: 'Tous les clients',

    INPUT_TITLE_CAMPAIGN_EMAIL_SUBJECT: 'Objet',
    INPUT_PLACEHOLDER_CAMPAIGN_EMAIL_SUBJECT: 'Ajouter un objet',
    CAMPAIGN_EMAIL_SUBJECT_REQUIRED: "L'objet est obligatoire pour enregistrer la campagne.",
    INPUT_TITLE_CAMPAIGN_EMAIL_BODY: "Corps de l'email",
    INPUT_PLACEHOLDER_CAMPAIGN_EMAIL_BODY: "Rédiger le message de l'email",

    INPUT_TITLE_PRO_CAMPAIGN_SENDER: 'Expéditeur',
    INPUT_PLACEHOLDER_PRO_CAMPAIGN_SENDER: 'Nom affiché dans le champ De',
    INPUT_TITLE_PRO_CAMPAIGN_REPLY_TO: 'Répondre à',
    INPUT_PLACEHOLDER_PRO_CAMPAIGN_REPLY_TO: 'Adresse email de réponse',
    INPUT_TITLE_PRO_CAMPAIGN_SCHEDULED_DATE: "Date d'envoi programmé",
    INPUT_TITLE_PRO_CAMPAIGN_TEST_RECIPIENT: 'Destinataire du test',
    INPUT_PLACEHOLDER_PRO_CAMPAIGN_TEST_RECIPIENT: 'Email ou numéro de téléphone',

    INPUT_TITLE_CAMPAIGN_EMAIL_CONTENT: 'Contenu',
    INPUT_PLACEHOLDER_CAMPAIGN_EMAIL_CONTENT: 'Ajouter un contenu',

    INPUT_TITLE_PRO_CAT_NAME: 'Nom',
    INPUT_PLACEHOLDER_PRO_CAT_NAME: 'Ajouter un nom de catégorie',
    INPUT_TITLE_PRO_CAT_DESC: 'Description',
    INPUT_PLACEHOLDER_PRO_CAT_DESC: 'Ajouter une description de catégorie',
    INPUT_PLACEHOLDER_PRO_CAT_PICTURES: 'Ajouter une image de catégorie',
    INPUT_TITLE_PRO_CAT_PICTURES: 'Image de la catégorie',

    INPUT_TITLE_PRO_LOGO: 'Logo',
    INPUT_PLACEHOLDER_PRO_LOGO: 'Importer votre logo',
    INPUT_TITLE_PRO_PICTURES: 'Photos',
    INPUT_PLACEHOLDER_PRO_PICTURES: 'Importer vos photos',
    INPUT_TITLE_TEAM_MEMBER_DESCRIPTION: 'Description',
    INPUT_PLACEHOLDER_TEAM_MEMBER_DESCRIPTION: "Décrivez ce membre de l'équipe",
    INPUT_TITLE_TEAM_MEMBER_PICTURE: 'Photo',
    INPUT_PLACEHOLDER_TEAM_MEMBER_PICTURE: 'Importer une photo',
    INPUT_TITLE_TEAM_MEMBER_HAS_AGENDA: 'Apparaît dans le planning et la réservation',
    INPUT_TITLE_TEAM_MEMBER_HAS_ACCOUNT: "Donner accès à l'application",

    INPUT_TITLE_PRO_PRESTATION_NAME: 'Nom',
    INPUT_PLACEHOLDER_PRO_PRESTATION_NAME: 'Ajouter un nom de prestation',
    INPUT_TITLE_PRO_PRESTATION_CATEGORY: 'Catégorie',
    INPUT_TITLE_PAYMENT_TYPE: 'Type de paiement',
    INPUT_PLACEHOLDER_PRO_PRESTATION_CATEGORY: 'Ajouter une catégorie de prestation',
    INPUT_TITLE_PRO_PRESTATION_DESC: 'Description',
    INPUT_PLACEHOLDER_PRO_PRESTATION_DESC: 'Ajouter une description de prestation',

    INPUT_TITLE_PRO_PRESTATION_PICTURES: 'Image de la prestation',
    INPUT_PLACEHOLDER_PRO_PRESTATION_PICTURES: 'Ajouter une ou plusieurs image de prestation',
    INPUT_TITLE_PRO_PRESTATION_VIDEOS: 'Vidéos de la prestation',
    INPUT_PLACEHOLDER_PRO_PRESTATION_VIDEOS: 'Importer une vidéo ou coller un lien YouTube',

    INPUT_TITLE_PRO_PRESTATION_PRICE: 'Prix de la prestation',
    INPUT_PLACEHOLDER_PRO_PRESTATION_PRICE: 'Ajouter un prix de prestation',
    INPUT_TITLE_PRO_PRESTATION_TYPE: 'Type de prestation',
    INPUT_PLACEHOLDER_PRO_PRESTATION_TYPE: 'Choisir un type',

    SLUG_EDIT_WARNING_TITLE: "Modifier l'adresse de la page",
    SLUG_EDIT_WARNING_CONTENT:
      "Modifier l'adresse de la page peut casser les liens existants. Êtes-vous sûr de vouloir continuer ?",
    SLUG_EDIT_WARNING_CONFIRM: 'Modifier',
    SLUG_EDIT_WARNING_CANCEL: 'Annuler',

    INPUT_TITLE_PRO_PRESTATION_COLOR: 'Couleur de la prestation dans le calendrier',
    INPUT_PLACEHOLDER_PRO_PRESTATION_PRICE_TYPE: 'Ajouter un type de prix',

    INPUT_TITLE_PRO_PRESTATION_PAYMENT_TYPE: 'Type de paiement',
    INPUT_PLACEHOLDER_PRO_PRESTATION_PAYMENT_TYPE: 'Choisir un type de paiement',

    INPUT_PLACEHOLDER_PRO_PRESTATION_PERCENTAGE: 'Ex : 30',
    INPUT_PLACEHOLDER_PRO_PRESTATION_FIXED_AMOUNT: 'Ex : 20',
    // Bloc « règle de montant » (PaymentAmountRuleInput : formulaire et modification en masse) :
    // libellé court selon le type de paiement, bascule % / montant fixe, aide sous la saisie — la
    // même phrase dans les deux modes (pourcentage et montant fixe s'appliquent tous deux par
    // prestation réservée et par personne).
    INPUT_TITLE_PRO_PRESTATION_PAYMENT_RULE: "Montant retenu (acompte ou frais d'annulation tardive)",
    INPUT_TITLE_PRO_PRESTATION_PAYMENT_RULE_DEPOSIT: 'Acompte demandé à la réservation',
    INPUT_TITLE_PRO_PRESTATION_PAYMENT_RULE_IMPRINT: "Frais d'annulation tardive",
    INPUT_TITLE_PRO_PRESTATION_PAYMENT_RULE_FULL: "Part conservée en cas d'annulation tardive",
    PRESTATION_PAYMENT_RULE_MODE_PERCENTAGE: '% du prix',
    PRESTATION_PAYMENT_RULE_MODE_FIXED: 'Montant fixe',
    PRESTATION_PAYMENT_RULE_HELP_DEPOSIT:
      "Débité à la réservation (par prestation réservée et par personne) et conservé en cas d'annulation tardive.",
    PRESTATION_PAYMENT_RULE_HELP_IMPRINT:
      "Prélevé sur la carte du client en cas d'annulation tardive (par prestation réservée et par personne).",
    PRESTATION_PAYMENT_RULE_HELP_FULL:
      "Conservé en cas d'annulation tardive (par prestation réservée et par personne), le reste est remboursé.",

    INPUT_TITLE_PRO_PRESTATION_CLIENTS_PER_BOOKING_MAX: 'Nombre maximum de clients par réservation',
    INPUT_PLACEHOLDER_PRO_PRESTATION_CLIENTS_PER_BOOKING_MAX: 'Ex : 4',

    INPUT_TITLE_PRO_PRESTATION_IS_PARTY_SIZE_OPEN: 'Taille du groupe libre (le client choisit le nombre)',
    INPUT_PLACEHOLDER_PRO_PRESTATION_IS_PARTY_SIZE_OPEN: '',

    INPUT_TITLE_PRO_PRESTATION_REQUIRED_TEAM_MEMBERS_COUNT: "Nombre de membres d'équipe requis pour la prestation",
    INPUT_PLACEHOLDER_PRO_PRESTATION_REQUIRED_TEAM_MEMBERS_COUNT: 'Ex : 2',

    INPUT_TITLE_PRO_PRESTATION_IS_SESSION: 'Prestation en mode session (plusieurs clients sur le même créneau)',
    INPUT_PLACEHOLDER_PRO_PRESTATION_IS_SESSION: '',

    INPUT_TITLE_PRO_PRESTATION_MAX_SESSION_CAPACITY: 'Capacité maximale de la session',
    INPUT_PLACEHOLDER_PRO_PRESTATION_MAX_SESSION_CAPACITY: 'Ex : 10',

    INPUT_TITLE_PRO_PRESTATION_MINIMUM_TIME_BEFORE_BOOKING: 'Délai minimum de réservation',
    INPUT_PLACEHOLDER_PRO_PRESTATION_MINIMUM_TIME_BEFORE_BOOKING: 'Identique au réglage général',
    INPUT_TITLE_PRO_PRESTATION_HORIZON_BOOKABLE: 'Horizon de réservation maximum',
    INPUT_PLACEHOLDER_PRO_PRESTATION_HORIZON_BOOKABLE: 'Identique au réglage général',

    INPUT_TITLE_PRO_PRESTATION_DURATION: 'Durée de la prestation (min)',
    INPUT_PLACEHOLDER_PRO_PRESTATION_DURATION: 'Ex : 60',

    INPUT_TITLE_PRO_PRESTATION_BUFFER: 'Temps de battement (min)',
    INPUT_PLACEHOLDER_PRO_PRESTATION_BUFFER: '0',

    INPUT_TITLE_PRO_PRESTATION_PRICE_LABEL: 'Libellé de la ligne (optionnel)',
    INPUT_PLACEHOLDER_PRO_PRESTATION_PRICE_LABEL: 'Décrivez cette option (ex : Standard, Premium)',

    INPUT_TITLE_PRO_PRESTATION_SUPPLEMENT: 'Supplément(s)',
    INPUT_PLACEHOLDER_PRO_PRESTATION_SUPPLEMENT: 'Ajouter un ou plusieurs suppléments',

    INPUT_TITLE_PRO_PRESTATION_RESOURCES: 'Matériels / salles',
    INPUT_PLACEHOLDER_PRO_PRESTATION_RESOURCES: 'Sélectionner les matériels ou salles utilisés par cette prestation',

    INPUT_TITLE_PRO_SUPPLEMENT_NAME: 'Nom du supplément',
    INPUT_PLACEHOLDER_PRO_SUPPLEMENT_NAME: 'Ajouter un nom de supplément',

    INPUT_TITLE_PRO_SUPPLEMENT_DESC: 'Description du supplément',
    INPUT_PLACEHOLDER_PRO_SUPPLEMENT_DESC: 'Ajouter une description de supplément',

    INPUT_TITLE_PRO_SUPPLEMENT_PRICE: 'Prix du supplément',
    INPUT_PLACEHOLDER_PRO_SUPPLEMENT_PRICE: 'Ajouter un prix de supplément',
    INPUT_TITLE_PRO_SUPPLEMENT_RESOURCE: 'Matériel / salle lié',
    INPUT_PLACEHOLDER_PRO_SUPPLEMENT_RESOURCE: 'Sélectionner un matériel ou une salle utilisée par ce supplément',
    INPUT_TITLE_UNSUB_FEEDBACK: "Dites-nous ce qu'on aurait pu mieux faire 😊",
    INPUT_PLACEHOLDER_UNSUB_FEEDBACK: 'Ajouter un retour (facultatif)',
    INPUT_TITLE_UNSUB_REASON: 'Dommage de vous voir partir 😢 !',
    INPUT_PLACEHOLDER_UNSUB_REASON: 'Ajouter une raison ou choisir dans la liste',

    INPUT_TITLE_PACK_NAME: 'Nom du pack',
    INPUT_PLACEHOLDER_PACK_NAME: 'Ex : Cure 5 séances massage',
    INPUT_TITLE_PACK_DESCRIPTION: 'Description',
    INPUT_PLACEHOLDER_PACK_DESCRIPTION: 'Décrivez votre pack',
    INPUT_TITLE_PACK_TYPE: 'Type de pack',
    INPUT_PLACEHOLDER_PACK_TYPE: 'Choisir un type',
    INPUT_TITLE_PACK_PICTURES: 'Photo de couverture',
    INPUT_PLACEHOLDER_PACK_PICTURES: 'Ajouter une photo',
    INPUT_TITLE_PACK_PRICE: 'Prix du pack',
    INPUT_PLACEHOLDER_PACK_PRICE: 'Prix de vente du pack',
    INPUT_TITLE_PACK_VALIDITY: 'Durée de validité après achat (en mois)',
    INPUT_PLACEHOLDER_PACK_VALIDITY: 'Choisir une durée',
    INPUT_TITLE_PACK_MULTIPLE_USAGE: 'Utilisable en plusieurs fois',
    INPUT_PLACEHOLDER_PACK_MULTIPLE_USAGE: 'Ce pack est-il utilisable en plusieurs fois ?',
    INPUT_TITLE_PACK_ACTIVE: 'Visible à la vente',
    INPUT_PLACEHOLDER_PACK_ACTIVE: 'Ce pack est-il visible à la vente ?',
    INPUT_TITLE_PACK_PRESTATIONS: 'Prestations incluses',
    INPUT_TITLE_PACK_PRESTATION: 'Prestation',
    INPUT_PLACEHOLDER_PACK_PRESTATION: 'Choisir une prestation',
    INPUT_TITLE_PACK_QUANTITY: 'Quantité',
    INPUT_PLACEHOLDER_PACK_QUANTITY: 'Nb séances',
    INPUT_VEHICLE_NAME_TITLE: 'Nom du véhicule',
    INPUT_VEHICLE_NAME_PLACEHOLDER: 'Saisir le nom du véhicule',
    INPUT_VEHICLE_PAX_MIN_TITLE: 'Passagers minimum',
    INPUT_VEHICLE_PAX_MIN_PLACEHOLDER: 'Saisir le nombre minimum de passagers',
    INPUT_VEHICLE_PAX_MAX_TITLE: 'Passagers maximum',
    INPUT_VEHICLE_PAX_MAX_PLACEHOLDER: 'Saisir le nombre maximum de passagers',
    INPUT_VEHICLE_PRICING_SECTION_TITLE: 'Tarification de base',
    INPUT_PRICING_TIER_BASE_RATE_TITLE: 'Tarif de base par km',
    INPUT_PRICING_TIER_BASE_RATE_PLACEHOLDER: 'Saisir le tarif de base par km',
    INPUT_PRICING_TIER_RETURN_RATE_TITLE: 'Tarif retour par km',
    INPUT_PRICING_TIER_RETURN_RATE_PLACEHOLDER: 'Saisir le tarif retour par km',
    INPUT_PRICING_TIER_HANDLING_FEES_TITLE: 'Frais de prise en charge',
    INPUT_PRICING_TIER_HANDLING_FEES_PLACEHOLDER: 'Saisir les frais de prise en charge',
    INPUT_PRICING_TIER_WAITING_FEES_TITLE: "Frais d'attente par heure",
    INPUT_PRICING_TIER_WAITING_FEES_PLACEHOLDER: "Saisir les frais d'attente par heure",
    INPUT_PRICING_TIER_APPROACH_ONE_WAY_TITLE: 'Approche aller simple par km',
    INPUT_PRICING_TIER_APPROACH_ONE_WAY_PLACEHOLDER: "Saisir les frais d'approche aller simple",
    INPUT_PRICING_TIER_APPROACH_TWO_WAY_TITLE: 'Approche aller-retour par km',
    INPUT_PRICING_TIER_APPROACH_TWO_WAY_PLACEHOLDER: "Saisir les frais d'approche aller-retour",
    INPUT_VEHICLE_SCHEDULE_SECTION_TITLE: 'Plages horaires actives',
    INPUT_VEHICLE_SCHEDULE_TITLE: 'Plages horaires actives',

    INPUT_TITLE_VOUCHER_NAME: 'Nom interne',
    INPUT_PLACEHOLDER_VOUCHER_NAME: 'Nom de la carte',
    INPUT_TITLE_VOUCHER_TYPE: 'Type de carte',
    INPUT_PLACEHOLDER_VOUCHER_TYPE: 'Montant / Pack / Prestation',
    INPUT_TITLE_VOUCHER_CUSTOMER: 'Client',
    INPUT_PLACEHOLDER_VOUCHER_CUSTOMER: 'Rechercher un client',
    INPUT_TITLE_VOUCHER_MULTIPLE_USAGE: 'Utilisable en plusieurs fois',
    INPUT_PLACEHOLDER_VOUCHER_MULTIPLE_USAGE: 'Le bon peut être utilisé plusieurs fois',
    INPUT_TITLE_VOUCHER_EXPIRATION: "Date d'expiration",
    INPUT_PLACEHOLDER_VOUCHER_EXPIRATION: 'Choisir une date',
    INPUT_TITLE_VOUCHER_PACK: 'Pack',
    INPUT_PLACEHOLDER_VOUCHER_PACK: 'Sélectionner un pack',
    INPUT_TITLE_VOUCHER_PRESTATIONS: 'Prestations',
    INPUT_TITLE_VOUCHER_PRESTATION: 'Prestation',
    INPUT_PLACEHOLDER_VOUCHER_PRESTATION: 'Sélectionner une prestation',
    INPUT_TITLE_VOUCHER_QUANTITY: 'Quantité',
    INPUT_PLACEHOLDER_VOUCHER_QUANTITY: 'Quantité',
    INPUT_TITLE_VOUCHER_AMOUNT: 'Montant',
    INPUT_PLACEHOLDER_VOUCHER_AMOUNT: 'Montant de la carte',
    INPUT_TITLE_VOUCHER_IS_GIFT: 'Carte cadeau',
    INPUT_PLACEHOLDER_VOUCHER_IS_GIFT: 'Faut-il envoyer cette carte au destinataire ?',
    INPUT_TITLE_VOUCHER_GIFT_NAME: 'Nom du destinataire',
    INPUT_PLACEHOLDER_VOUCHER_GIFT_NAME: 'Prénom et nom',
    INPUT_TITLE_VOUCHER_GIFT_EMAIL: 'Email du destinataire',
    INPUT_PLACEHOLDER_VOUCHER_GIFT_EMAIL: 'Email',
    INPUT_TITLE_VOUCHER_GIFT_PHONE: 'Téléphone du destinataire',
    INPUT_PLACEHOLDER_VOUCHER_GIFT_PHONE: 'Numéro de téléphone',
    INPUT_TITLE_VOUCHER_GIFT_MESSAGE: 'Message personnel',
    INPUT_PLACEHOLDER_VOUCHER_GIFT_MESSAGE: 'Écrire un message...',

    INPUT_TITLE_GIFT_ALLOW_AMOUNT: "Permettre l'achat d'un montant libre",
    INPUT_TITLE_GIFT_ALLOW_PACKS: "Permettre l'achat de pack(s)",

    INPUT_TITLE_PRO_NEWS_TITLE: 'Titre',
    INPUT_PLACEHOLDER_PRO_NEWS_TITLE: 'Titre de la publication',
    INPUT_TITLE_PRO_NEWS_CONTENT: 'Contenu',
    INPUT_PLACEHOLDER_PRO_NEWS_CONTENT: 'Rédigez votre publication...',
    INPUT_TITLE_PRO_NEWS_EXCERPT: 'Résumé',
    INPUT_PLACEHOLDER_PRO_NEWS_EXCERPT: 'Résumé court pour les aperçus',
    INPUT_TITLE_PRO_NEWS_PICTURES: 'Images',
    INPUT_PLACEHOLDER_PRO_NEWS_PICTURES: 'Ajouter des images',
    INPUT_TITLE_PRO_NEWS_STATUS: 'Statut',
    INPUT_TITLE_PRO_NEWS_AUTHOR: 'Auteur',
    INPUT_OPTION_PRO_NEWS_AUTHOR_NONE: 'Aucun auteur, au nom de votre établissement',
    INPUT_TITLE_PRO_NEWS_SCHEDULED_DATE: 'Date de publication programmée',
    INPUT_TITLE_PRO_NEWS_TAGS: 'Catégorie',
    INPUT_TITLE_PRO_NEWS_FOCUS_KEYWORD: 'Mot-clé cible (référencement)',
    INPUT_PLACEHOLDER_PRO_NEWS_FOCUS_KEYWORD: 'Ex. balayage prix lyon',
    INPUT_TITLE_PRO_NEWS_FAQ: 'Questions fréquentes',
    INPUT_PLACEHOLDER_PRO_NEWS_FAQ: 'Aucune question. Ajoutez les questions que vos clients vous posent sur ce sujet.',
    INPUT_TITLE_PRO_NEWS_FAQ_QUESTION: 'Question',
    INPUT_PLACEHOLDER_PRO_NEWS_FAQ_QUESTION: 'Ex. Combien de temps dure un balayage ?',
    INPUT_TITLE_PRO_NEWS_FAQ_ANSWER: 'Réponse',
    INPUT_PLACEHOLDER_PRO_NEWS_FAQ_ANSWER: 'Une réponse courte, en 2 à 4 phrases.',
    INPUT_PLACEHOLDER_PRO_NEWS_TAGS: 'Sélectionner une catégorie',
    INPUT_TITLE_PRO_NEWS_TAG_TITLE: 'Nom de la catégorie',
    INPUT_PLACEHOLDER_PRO_NEWS_TAG_TITLE: 'Ajouter un nom de catégorie',
    INPUT_TITLE_PRO_NEWS_TAG_COLOR: 'Couleur',
    INPUT_TITLE_PRO_NEWS_DISTRIBUTE_GMB: 'Publier sur Google My Business',
    INPUT_TITLE_PRO_NEWS_GMB_LOCATIONS: 'Fiches Google concernées',
    INPUT_PLACEHOLDER_PRO_NEWS_GMB_LOCATIONS: 'Sélectionner des fiches Google',
    INPUT_PRO_NEWS_GMB_LOCATIONS_ALL: 'Toutes mes fiches Google',
    INPUT_PRO_NEWS_GMB_NO_LOCATIONS_WARNING:
      'Aucun compte Google connecté. Rendez-vous dans vos paramètres d’intégration pour connecter votre compte Google My Business.',
    INPUT_PRO_NEWS_GMB_NO_PUBLISHABLE_LOCATIONS_WARNING:
      'Votre compte Google est bien connecté mais aucune fiche d’établissement n’est exploitable. Relancez la synchronisation depuis vos paramètres d’intégration, ou vérifiez que ce compte gère bien une fiche Google.',
    INPUT_TITLE_PRO_NEWS_PUBLISHED: 'Publier',
    YEAR: 'Année',
    MONTH: 'Mois',
    DAY: 'Jour',

    WEBSITE_BUILDER_INTERACTION_NOTICE: 'Action simulée dans l’aperçu',
    WEBSITE_BUILDER_INTERACTION_NOTICE_DESCRIPTION:
      'Rien n’est envoyé depuis l’éditeur. Sur votre site en ligne, cette action (formulaire, réservation, lien…) fonctionne normalement pour vos visiteurs.',
    WEBSITE_BUILDER_INTERACTION_CTA: 'Tester sur mon site',
    WEBSITE_BUILDER_FORM_SIMULATED_TITLE: 'Envoi simulé : rien n’a été envoyé',
    WEBSITE_BUILDER_FORM_SIMULATED_NOTE:
      'Votre formulaire fonctionne — sur votre site en ligne, vous recevrez bien les demandes de vos visiteurs. Voici l’écran qu’ils verront :',
    WEBSITE_BUILDER_FORM_SIMULATED_BACK: 'Revenir au formulaire',
    WEBSITE_BUILDER_VIEW_SITE: 'Voir le site',

    WEBSITE_BUILDER_VARIANT_TITLE: "Style d'affichage",
    WEBSITE_BUILDER_VARIANT_PLACEHOLDER: "Sélectionnez un style d'affichage",

    WEBSITE_BUILDER_HERO_IMAGE: 'Image',
    WEBSITE_BUILDER_HERO_IMAGES: 'Images',
    WEBSITE_BUILDER_HERO_VIDEO: 'Vidéo',
    WEBSITE_BUILDER_HERO_VIDEO_OVERLAY: 'Intensité du voile',
    WEBSITE_BUILDER_HERO_VIDEO_OVERLAY_NONE: 'Aucun',
    WEBSITE_BUILDER_HERO_VIDEO_OVERLAY_LIGHT: 'Léger',
    WEBSITE_BUILDER_HERO_VIDEO_OVERLAY_MEDIUM: 'Moyen',
    WEBSITE_BUILDER_HERO_VIDEO_OVERLAY_STRONG: 'Fort',
    WEBSITE_BUILDER_HEADER_LOGO: 'Logo',
    WEBSITE_BUILDER_HEADER_LOGO_SIZE: 'Taille du logo',
    WEBSITE_BUILDER_HEADER_LOGO_SIZE_SMALL: 'Petit',
    WEBSITE_BUILDER_HEADER_LOGO_SIZE_MEDIUM: 'Moyen',
    WEBSITE_BUILDER_HEADER_LOGO_SIZE_LARGE: 'Grand',
    WEBSITE_BUILDER_HEADER_CTA_PAGE: 'Page en avant',
    WEBSITE_BUILDER_HEADER_LANGUAGES: 'Langues du site',
    WEBSITE_BUILDER_HEADER_LANGUAGES_PLACEHOLDER: 'Choisir les langues de traduction',
    WEBSITE_BUILDER_MENU_BACK: 'Retour',
    WEBSITE_BUILDER_MENU_LABEL: 'Menu',
    WEBSITE_BUILDER_MENU_MORE: 'Plus',
    WEBSITE_BUILDER_FOOTER_LOGO: 'Logo',
    WEBSITE_BUILDER_FOOTER_PRO_NAME: 'Nom du professionnel',
    WEBSITE_BUILDER_FOOTER_SHOW_NAV: 'Afficher les liens de navigation',
    WEBSITE_BUILDER_FOOTER_SHOW_SOCIAL: 'Afficher les réseaux sociaux',
    WEBSITE_BUILDER_FOOTER_SHOW_ARTICLES: 'Afficher les derniers articles',
    WEBSITE_BUILDER_FOOTER_SHOW_SERVICES: 'Afficher les prestations',
    WEBSITE_BUILDER_FOOTER_NAV_PAGES: 'Pages à afficher',
    WEBSITE_BUILDER_FOOTER_NAV_PAGES_PLACEHOLDER: `Toutes les pages du menu (${FOOTER_MAX_ITEMS} max)`,
    WEBSITE_BUILDER_FOOTER_ARTICLES_SELECTION: 'Articles à afficher',
    WEBSITE_BUILDER_FOOTER_ARTICLES_SELECTION_PLACEHOLDER: `Les ${FOOTER_MAX_ITEMS} derniers articles publiés`,
    WEBSITE_BUILDER_FOOTER_SERVICES_SELECTION: 'Prestations à afficher',
    WEBSITE_BUILDER_FOOTER_SERVICES_SELECTION_PLACEHOLDER: `Les ${FOOTER_MAX_ITEMS} premières prestations du catalogue`,
    WEBSITE_BUILDER_FOOTER_POWERED_BY: 'Site propulsé par',
    WEBSITE_BUILDER_VARIANT_FOOTER_CLASSIC: 'Classique',
    WEBSITE_BUILDER_VARIANT_FOOTER_MINIMAL: 'Minimaliste',
    WEBSITE_BUILDER_VARIANT_FOOTER_CENTERED: 'Centré',
    WEBSITE_BUILDER_FOOTER_NAV_TITLE: 'Navigation',
    WEBSITE_BUILDER_FOOTER_SERVICES_TITLE: 'Prestations',
    WEBSITE_BUILDER_FOOTER_ARTICLES_TITLE: 'Derniers articles',

    WEBSITE_BUILDER_VARIANT_CLASSIC: 'Classique',
    WEBSITE_BUILDER_VARIANT_HAMBURGER: 'Hamburger',
    WEBSITE_BUILDER_VARIANT_HORIZONTAL: 'Horizontal',
    WEBSITE_BUILDER_VARIANT_VERTICAL: 'Vertical',
    WEBSITE_BUILDER_VARIANT_NEWSLETTER_MINIMAL: 'Minimal',
    WEBSITE_BUILDER_VARIANT_CAROUSEL: 'Diaporama',
    WEBSITE_BUILDER_VARIANT_VIDEO: 'Vidéo',

    WEBSITE_BUILDER_VARIANT_CTA_SINGLE: 'Simple bouton',
    WEBSITE_BUILDER_VARIANT_CTA_DOUBLE: 'Double boutons',
    WEBSITE_BUILDER_CTA_TEXT: 'Texte',
    WEBSITE_BUILDER_CTA_PRIMARY_LABEL: 'Texte du bouton n°1',
    WEBSITE_BUILDER_CTA_PRIMARY_HREF: 'Lien du bouton n°1',
    WEBSITE_BUILDER_CTA_SECONDARY_LABEL: 'Texte du bouton n°2',
    WEBSITE_BUILDER_CTA_SECONDARY_HREF: 'Lien du bouton n°2',

    WEBSITE_BUILDER_NEWSLETTER_TITLE: 'Titre',
    WEBSITE_BUILDER_NEWSLETTER_DESCRIPTION: 'Description',
    WEBSITE_BUILDER_NEWSLETTER_BUTTON_LABEL: 'Bouton',
    WEBSITE_BUILDER_NEWSLETTER_CONSENT: 'Texte de consentement',
    WEBSITE_BUILDER_NEWSLETTER_TAG: 'Tag client',
    WEBSITE_BUILDER_NEWSLETTER_SUCCESS_MESSAGE: 'Message de confirmation',

    // Contact form / callback request blocks
    WEBSITE_BUILDER_CONTACT_FORM_TITLE: 'Titre',
    WEBSITE_BUILDER_CONTACT_FORM_DESCRIPTION: 'Description',
    WEBSITE_BUILDER_CONTACT_FORM_FIELDS: 'Champs du formulaire',
    WEBSITE_BUILDER_CONTACT_FORM_BUTTON_LABEL: 'Bouton',
    WEBSITE_BUILDER_CONTACT_FORM_CONSENT: 'Texte de consentement',
    WEBSITE_BUILDER_CONTACT_FORM_SUCCESS_MESSAGE: 'Message de confirmation',
    WEBSITE_BUILDER_CALLBACK_REQUEST_TITLE: 'Titre',
    WEBSITE_BUILDER_CALLBACK_REQUEST_DESCRIPTION: 'Description',
    WEBSITE_BUILDER_CALLBACK_REQUEST_FIELDS: 'Champs du formulaire',
    WEBSITE_BUILDER_CALLBACK_REQUEST_BUTTON_LABEL: 'Bouton',
    WEBSITE_BUILDER_CALLBACK_REQUEST_CONSENT: 'Texte de consentement',
    WEBSITE_BUILDER_CALLBACK_REQUEST_SUCCESS_MESSAGE: 'Message de confirmation',
    WEBSITE_BUILDER_VARIANT_CONTACT_FORM_CARD: 'Encadré',
    WEBSITE_BUILDER_VARIANT_CONTACT_FORM_PLAIN: 'Simple',

    // Website form fields editor (form_fields_editor input type)
    WEBSITE_FORM_FIELDS_EMPTY: 'Aucun champ. Ajoutez les champs à demander au visiteur.',
    WEBSITE_FORM_FIELDS_BASE_LOCKED_NOTE: 'Champs par défaut (toujours présents) :',
    WEBSITE_FORM_FIELDS_EXTRA_TITLE: 'Champs supplémentaires',
    WEBSITE_FORM_FIELDS_EXTRA_EMPTY:
      'Aucun champ supplémentaire. Ajoutez-en pour collecter plus d’informations (ex. fiche client).',
    WEBSITE_FORM_FIELDS_LABEL_LABEL: 'Libellé',
    WEBSITE_FORM_FIELDS_TYPE_LABEL: 'Type de champ',
    WEBSITE_FORM_FIELDS_LABEL_PLACEHOLDER: 'Libellé du champ',
    WEBSITE_FORM_FIELDS_REQUIRED: 'Obligatoire',
    WEBSITE_FORM_FIELDS_OPTIONS_LABEL: 'Options',
    WEBSITE_FORM_FIELDS_OPTIONS_EMPTY: 'Aucune option pour le moment.',
    WEBSITE_FORM_FIELDS_OPTION_PLACEHOLDER: 'Intitulé de l’option',
    WEBSITE_FORM_FIELDS_OPTION_REMOVE_ARIA: 'Supprimer l’option',
    WEBSITE_FORM_FIELD_TYPE_TEXT: 'Texte',
    WEBSITE_FORM_FIELD_TYPE_TEXTAREA: 'Texte long',
    WEBSITE_FORM_FIELD_TYPE_EMAIL: 'Email',
    WEBSITE_FORM_FIELD_TYPE_PHONE: 'Téléphone',
    WEBSITE_FORM_FIELD_TYPE_SELECT: 'Liste déroulante',
    WEBSITE_FORM_FIELD_TYPE_NUMBER: 'Nombre',
    WEBSITE_FORM_FIELD_TYPE_CHECKBOX: 'Case à cocher',
    WEBSITE_FORM_FIELD_TYPE_DATE: 'Date',

    // Website public component strings
    WEBSITE_PUBLIC_FIELD_REQUIRED: 'Veuillez remplir le champ « {field} ».',
    WEBSITE_PUBLIC_FIELD_REQUIRED_SHORT: 'Ce champ est obligatoire.',
    WEBSITE_PUBLIC_CONTACT_REACHABLE_REQUIRED: 'Indiquez au moins un email ou un numéro de téléphone.',
    WEBSITE_PUBLIC_CONTACT_SUCCESS_DEFAULT: 'Merci, votre message a bien été envoyé !',
    WEBSITE_PUBLIC_EMAIL_PLACEHOLDER: 'Votre adresse email',
    WEBSITE_PUBLIC_EMAIL_INVALID: 'Veuillez entrer une adresse email valide.',
    WEBSITE_PUBLIC_CONSENT_REQUIRED: 'Veuillez accepter les conditions pour continuer.',
    WEBSITE_PUBLIC_CONSENT_DEFAULT: "J'accepte de recevoir des communications par email",
    WEBSITE_PUBLIC_SUBSCRIBE_SUCCESS_DEFAULT: 'Inscription confirmée !',
    WEBSITE_PUBLIC_GENERIC_ERROR: 'Une erreur est survenue, veuillez réessayer.',
    WEBSITE_PUBLIC_LOADING_ERROR: 'Erreur de chargement',
    WEBSITE_PUBLIC_PRESTATION_LOADING_ERROR: 'Erreur de chargement des prestations',
    // Prestations « Course » (RIDE) dans les blocs catalogue : capacité du pool + CTA vers le tunnel ride.
    WEBSITE_PUBLIC_BOOK_RIDE: 'Réserver un trajet',
    WEBSITE_PUBLIC_RIDE_PASSENGERS: 'passagers',
    WEBSITE_PUBLIC_RIDE_LUGGAGE: 'bagages',
    WEBSITE_PUBLIC_RIDE_SMALL_LUGGAGE: 'petits bagages',
    WEBSITE_PUBLIC_RIDE_LARGE_LUGGAGE: 'grands bagages',
    WEBSITE_PUBLIC_PRESTATION_NOT_FOUND: 'Prestation introuvable',
    WEBSITE_PUBLIC_CATEGORY_NOT_FOUND: 'Catégorie introuvable',
    WEBSITE_PUBLIC_CATEGORY_EMPTY: 'Aucune prestation dans cette catégorie',
    WEBSITE_PUBLIC_CATEGORY_NONE: 'Aucune catégorie disponible',
    WEBSITE_BUILDER_PRESTATION_EMPTY_HINT:
      'Aucune prestation pour le moment. Ajoutez vos prestations depuis le menu « Prestations » pour qu’elles apparaissent ici.',
    WEBSITE_BUILDER_SINGLE_CATEGORY_REDIRECT:
      'Une seule catégorie : les visiteurs seront automatiquement redirigés vers celle-ci.',
    WEBSITE_PUBLIC_NEWS_LOADING_ERROR: 'Erreur de chargement des actualités',
    WEBSITE_PUBLIC_NEWS_EMPTY: 'Aucune actualité disponible',
    WEBSITE_PUBLIC_NEWS_NOT_FOUND: 'Article introuvable',
    WEBSITE_PUBLIC_NEWS_SEARCH_PLACEHOLDER: 'Rechercher...',
    WEBSITE_PUBLIC_NEWS_TAGS_TITLE: 'Tags',
    WEBSITE_PUBLIC_NEWS_WRITTEN_BY: 'Écrit par',
    WEBSITE_PUBLIC_NEWS_PUBLISHED_BY: 'Publié par',
    WEBSITE_PUBLIC_NEWS_FAQ_TITLE: 'Questions fréquentes',
    WEBSITE_PUBLIC_NEWS_ALL_CATEGORIES: 'Toutes les thématiques',
    WEBSITE_PUBLIC_NEWS_SEE_ALL: 'Voir toutes les actualités',
    // Sélecteur « nombre de personnes » de la fiche prestation (party_size) : le nombre choisi
    // multiplie le prix, d'où le rappel du plafond et le suffixe de ligne dans le panier.
    WEBSITE_PUBLIC_PARTY_SIZE: 'Nombre de personnes',
    WEBSITE_PUBLIC_PARTY_SIZE_MAX: 'Jusqu’à {count} personnes',
    WEBSITE_PUBLIC_PARTY_SIZE_DECREASE: 'Retirer une personne',
    WEBSITE_PUBLIC_PARTY_SIZE_INCREASE: 'Ajouter une personne',
    WEBSITE_PUBLIC_PARTY_SIZE_SUFFIX: '{count} pers.',
    WEBSITE_PUBLIC_SUPPLEMENTS: 'Suppléments',
    WEBSITE_PUBLIC_VIDEOS: 'Vidéos',
    WEBSITE_PUBLIC_PREVIOUS: 'Précédent',
    WEBSITE_PUBLIC_NEXT: 'Suivant',
    WEBSITE_PUBLIC_BOOK: 'Réserver maintenant',
    // Bouton de la fiche, suivi du total de la ligne calculé par le serveur (« Réserver · 63,00 € »).
    WEBSITE_PUBLIC_BOOK_SHORT: 'Réserver',
    WEBSITE_PUBLIC_QUANTITY: 'Quantité',
    WEBSITE_PUBLIC_QUANTITY_DECREASE: 'Diminuer la quantité',
    WEBSITE_PUBLIC_QUANTITY_INCREASE: 'Augmenter la quantité',
    WEBSITE_PUBLIC_SUPPLEMENTS_SHOW_MORE_ONE: 'Voir l’autre option',
    WEBSITE_PUBLIC_SUPPLEMENTS_SHOW_MORE_OTHER: 'Voir les {count} autres options',
    WEBSITE_PUBLIC_REQUEST_QUOTE: 'Demander un devis',
    WEBSITE_PUBLIC_CONTACT: 'Contacter',
    WEBSITE_PUBLIC_ON_QUOTE: 'Sur devis',
    WEBSITE_PUBLIC_FREE: 'Gratuit',
    WEBSITE_PUBLIC_GIFT_BTN: 'Offrir',
    WEBSITE_PUBLIC_PACK_BTN: 'Pack',
    WEBSITE_PUBLIC_PACKS_BTN: 'Nos packs',
    WEBSITE_PUBLIC_GIFT_TITLE: 'Offrir cette prestation',
    WEBSITE_PUBLIC_GIFT_DESC: 'Faites plaisir à vos proches avec une carte cadeau.',
    WEBSITE_PUBLIC_PRICE_FROM: 'À partir de',
    // Ligne sans prix (type NONE) dans la barre de panier : forme courte, comme le récap du tunnel.
    WEBSITE_PUBLIC_PRICE_TO_DETERMINE: 'À déterminer',
    WEBSITE_PUBLIC_DURATION_MINUTES: 'min',
    WEBSITE_PUBLIC_PACKS_SECTION: 'Disponible en pack',
    WEBSITE_PUBLIC_PRICES: 'Tarifs',
    // Promotions du site (cartes, fiche, bandeau haut, section Promotion) : libellés, montants et dates
    // viennent du serveur, ces textes ne font que les assembler.
    WEBSITE_PUBLIC_PROMOTION_INSTEAD_OF: 'au lieu de',
    WEBSITE_PUBLIC_PROMOTION_CONDITION_NEW_CUSTOMER: '1ʳᵉ résa',
    WEBSITE_PUBLIC_PROMOTION_CONDITION_TAGS: 'pour certains clients',
    WEBSITE_PUBLIC_PROMOTION_CONDITION_HOURS: 'à certaines heures',
    WEBSITE_PUBLIC_PROMOTION_CONDITION_MEMBERS: 'avec {names}',
    WEBSITE_PUBLIC_PROMOTION_CONDITION_SOME_MEMBERS: 'avec certains membres',
    WEBSITE_PUBLIC_PROMOTION_CONDITION_PLACE: 'selon le lieu',
    WEBSITE_PUBLIC_PROMOTION_UNTIL: 'jusqu’au {date}',
    WEBSITE_PUBLIC_PROMOTION_HEADLINE: '{label} : {value}',
    WEBSITE_PUBLIC_PROMOTION_OFFER: 'Offre en cours',
    WEBSITE_PUBLIC_PROMOTION_AUTOMATIC: 'Remise appliquée automatiquement à la réservation',
    WEBSITE_PUBLIC_PROMOTION_FOR_NEW_CUSTOMERS: 'Pour votre première réservation',
    WEBSITE_PUBLIC_PROMOTION_FOR_TAGGED_CUSTOMERS: 'Réservée à certains clients',
    WEBSITE_PUBLIC_PROMOTION_VALID_HOURS: 'Valable {hours}',
    WEBSITE_PUBLIC_PROMOTION_WITH_MEMBERS: 'Avec {names}',
    WEBSITE_PUBLIC_PROMOTION_WITH_SOME_MEMBERS: 'Avec certains membres de l’équipe',
    WEBSITE_PUBLIC_PROMOTION_SOME_PLACES: 'Dans certains lieux',
    WEBSITE_PUBLIC_PROMOTION_WITH_CODE: 'Avec le code',
    WEBSITE_PUBLIC_PROMOTION_COPY: 'Copier',
    WEBSITE_PUBLIC_PROMOTION_COPY_ARIA: 'Copier le code {code}',
    WEBSITE_PUBLIC_PROMOTION_COPIED: 'Copié',
    WEBSITE_PUBLIC_PROMOTION_DAYS_LEFT: 'Plus que {count} jours',
    WEBSITE_PUBLIC_PROMOTION_LAST_DAY: 'Dernier jour',
    WEBSITE_PUBLIC_PROMOTION_DAYS_REMAINING_ONE: '{count} j restant',
    WEBSITE_PUBLIC_PROMOTION_DAYS_REMAINING_OTHER: '{count} j restants',
    WEBSITE_PUBLIC_PROMOTION_HOURS_REMAINING_ONE: '{count} h restante',
    WEBSITE_PUBLIC_PROMOTION_HOURS_REMAINING_OTHER: '{count} h restantes',
    WEBSITE_PUBLIC_PROMOTION_MINUTES_REMAINING_ONE: '{count} min restante',
    WEBSITE_PUBLIC_PROMOTION_MINUTES_REMAINING_OTHER: '{count} min restantes',
    // Section « Offres du moment » : une carte par promotion mise en avant.
    WEBSITE_PUBLIC_PROMOTION_OFFERS_TITLE: 'Offres du moment',
    WEBSITE_PUBLIC_PROMOTION_ALL_YEAR: 'Toute l’année',
    WEBSITE_PUBLIC_PROMOTION_NEW_CUSTOMERS_CHIP: 'Nouveaux clients',
    WEBSITE_PUBLIC_PROMOTION_TAGGED_CUSTOMERS_CHIP: 'Clients privilégiés',
    WEBSITE_PUBLIC_PROMOTION_TARGETS: 'Prestations concernées',
    WEBSITE_PUBLIC_PROMOTION_ALL_PRESTATIONS: 'Toutes les prestations',
    WEBSITE_PUBLIC_PROMOTION_MORE_PRESTATIONS: '+ {count} prestations',
    WEBSITE_PUBLIC_PROMOTION_MORE_TARGETS: '+ {count} autres',
    WEBSITE_PUBLIC_PROMOTION_BOOK_WITH_CODE: 'Réserver avec le code',
    WEBSITE_PUBLIC_PROMOTION_SEE_SLOTS: 'Voir les créneaux',
    WEBSITE_PUBLIC_CHOOSE_TIME: 'Choisir un créneau',
    WEBSITE_PUBLIC_REMOVE: 'Supprimer',
    WEBSITE_PUBLIC_PRESTATION_SINGULAR: 'prestation',
    WEBSITE_PUBLIC_PRESTATION_PLURAL: 'prestations',
    WEBSITE_PUBLIC_404_TITLE: 'Page introuvable',
    WEBSITE_PUBLIC_404_MESSAGE: "La page que vous recherchez n'existe pas ou a été déplacée.",
    WEBSITE_PUBLIC_404_BACK_HOME: "Retour à l'accueil",
    // Page servie quand le site est dépublié (layout custom-websites, cf. SiteUnavailablePage).
    WEBSITE_PUBLIC_OFFLINE_TITLE: 'Site momentanément hors ligne',
    WEBSITE_PUBLIC_OFFLINE_MESSAGE: 'Ce site n’est pas disponible pour le moment. Revenez un peu plus tard !',
    // Page servie quand aucun site n'existe à cette adresse.
    WEBSITE_PUBLIC_UNKNOWN_SITE_TITLE: 'Site introuvable',
    WEBSITE_PUBLIC_UNKNOWN_SITE_MESSAGE: 'Aucun site n’est publié à cette adresse.',
    WEBSITE_PUBLIC_ERROR_TITLE: 'Une erreur est survenue',
    WEBSITE_PUBLIC_ERROR_MESSAGE: "Un problème inattendu s'est produit. Vous pouvez réessayer ou revenir à l'accueil.",
    WEBSITE_PUBLIC_ERROR_RETRY: 'Réessayer',
    WEBSITE_PUBLIC_ERROR_BACK_HOME: "Retour à l'accueil",

    WEBSITE_BUILDER_MAIN_TITLE: 'Titre principal',
    WEBSITE_BUILDER_MAIN_TITLE_PLACEHOLDER: 'Saisissez un titre accrocheur',

    WEBSITE_BUILDER_MAIN_SUBTITLE: 'Sous-titre',
    WEBSITE_BUILDER_MAIN_SUBTITLE_PLACEHOLDER: "Un complément d'info",

    WEBSITE_BUILDER_VARIANT_FAQ_COLLAPSIBLE: 'Questions / réponses repliables',
    WEBSITE_BUILDER_VARIANT_FAQ_OPEN: 'Questions / réponses toujours ouvertes',

    WEBSITE_BUILDER_FAQ_TITLE: 'Titre',
    WEBSITE_BUILDER_FAQ_TITLE_PLACEHOLDER: 'Ex. : Questions fréquentes',

    WEBSITE_BUILDER_FAQ_ITEMS: 'Liste des questions',
    WEBSITE_BUILDER_FAQ_QUESTION: 'Question',
    WEBSITE_BUILDER_FAQ_QUESTION_PLACEHOLDER: 'Ex. : Comment se déroule la prestation ?',

    WEBSITE_BUILDER_FAQ_ANSWER: 'Réponse',
    WEBSITE_BUILDER_FAQ_ANSWER_PLACEHOLDER: 'Saisissez la réponse à la question',

    WEBSITE_BUILDER_FAQ_ALLOW_MULTIPLE_OPEN: 'Autoriser plusieurs réponses ouvertes',

    WEBSITE_BUILDER_PAGES_NAVIGATION_TITLE: 'Navigation du site',
    WEBSITE_BUILDER_PAGES_NAVIGATION_DESCRIPTION: 'Réorganiser le menu et gérer les pages.',
    WEBSITE_BUILDER_LEGAL_PAGES: 'Pages légales',
    WEBSITE_BUILDER_LEGAL_PAGES_DESC:
      'Pages générées automatiquement. Cliquez pour les consulter et modifier leur contenu.',
    WEBSITE_BUILDER_PAGE_TITLE: 'Nom de la page',
    WEBSITE_BUILDER_PAGE_SLUG: 'Lien de la page',
    WEBSITE_BUILDER_PAGE_EXTERNAL_URL: 'Adresse du lien',
    WEBSITE_BUILDER_PAGE_EXTERNAL_URL_PLACEHOLDER: 'https://exemple.com',
    WEBSITE_BUILDER_SUBPAGE_ADD: 'Ajouter une sous-page',
    WEBSITE_BUILDER_PAGE_ADD: 'Ajouter une page',
    WEBSITE_BUILDER_PAGE_UPDATE: 'Modifier une page',
    WEBSITE_BUILDER_PAGE_PARENT: 'Où afficher cette page ?',
    WEBSITE_BUILDER_PAGE_PARENT_ROOT: 'Dans le menu principal',
    WEBSITE_BUILDER_PAGE_MOVE: 'Déplacer',
    WEBSITE_BUILDER_PAGE_MOVE_TITLE: 'Déplacer la page',
    WEBSITE_BUILDER_PAGE_TYPE: 'Modèle de page',
    WEBSITE_BUILDER_MENU: 'Menu',
    WEBSITE_BUILDER_LOADING: 'Chargement du builder…',
    WEBSITE_BUILDER_STYLE: 'Style',
    WEBSITE_BUILDER_STYLE_PALETTES: 'Palettes',
    WEBSITE_BUILDER_STYLE_CUSTOMIZE: 'Personnaliser',
    WEBSITE_BUILDER_STYLE_BACK_PALETTES: 'Palettes',
    WEBSITE_BUILDER_STYLE_CURRENT: 'Couleurs actuelles',
    WEBSITE_BUILDER_STYLE_GENERAL: 'Aspect général',
    WEBSITE_BUILDER_STYLE_BORDER_SQUARE: 'Carré',
    WEBSITE_BUILDER_STYLE_BORDER_SOFT: 'Arrondi',
    WEBSITE_BUILDER_STYLE_BORDER_ROUND: 'Rond',
    WEBSITE_BUILDER_STYLE_VERTICAL_SPACING: 'Espacement entre les blocs',
    WEBSITE_BUILDER_STYLE_SPACING_TIGHT: 'Serré',
    WEBSITE_BUILDER_STYLE_SPACING_STANDARD: 'Standard',
    WEBSITE_BUILDER_STYLE_SPACING_AIRY: 'Aéré',
    WEBSITE_BUILDER_STYLE_COLORS: 'Couleurs',
    WEBSITE_BUILDER_STYLE_TYPOGRAPHIES: 'Typographies',
    WEBSITE_BUILDER_STYLE_BG: 'Fond',
    WEBSITE_BUILDER_STYLE_CTA: 'Boutons',
    WEBSITE_BUILDER_STYLE_TEXT: 'Titres/Textes',
    WEBSITE_BUILDER_STYLE_ACCENT: 'Accentuation',
    WEBSITE_BUILDER_STYLE_HEADING_FONT: 'Titres',
    WEBSITE_BUILDER_STYLE_BODY_FONT: 'Textes',
    WEBSITE_BUILDER_STYLE_CONTRAST_WARNING: "Contraste insuffisant : le texte risque d'être peu lisible",
    WEBSITE_BUILDER_STYLE_DECORATIONS: 'Décorations grands écrans',
    WEBSITE_BUILDER_STYLE_DECO_NONE: 'Aucune',
    WEBSITE_BUILDER_STYLE_DECO_DOTS: 'Points',
    WEBSITE_BUILDER_STYLE_DECO_CURVES: 'Courbes',
    WEBSITE_BUILDER_STYLE_DECO_DIAMONDS: 'Losanges',
    WEBSITE_BUILDER_STYLE_DECO_WAVES: 'Vagues',
    WEBSITE_BUILDER_STYLE_DECO_LINES: 'Lignes',
    WEBSITE_BUILDER_STYLE_DECO_CROSSES: 'Croix',
    WEBSITE_BUILDER_UPDATE_NOT_SAVE: 'changement non publié',
    WEBSITE_BUILDER_UPDATES_NOT_SAVED: 'changements non publiés',
    WEBSITE_BUILDER_SAVING: 'Sauvegarde…',
    WEBSITE_BUILDER_SAVED: 'Sauvegardé',
    WEBSITE_BUILDER_SAVE_ERROR: 'Erreur de sauvegarde',
    WEBSITE_BUILDER_READ_ONLY: 'Lecture seule : les modifications ne sont pas enregistrées',
    WEBSITE_BUILDER_UNPUBLISHED_CHANGES_LABEL:
      '{count, plural, one {{count} modification non publiée} other {{count} modifications non publiées}}',
    WEBSITE_BUILDER_UNPUBLISHED_CHANGES_TITLE: 'Modifications non publiées',
    WEBSITE_BUILDER_REVERT_GROUP_TOOLTIP: 'Annuler ces modifications',
    WEBSITE_BUILDER_UNPUBLISHED_CHANGES_EMPTY: 'Aucune modification en attente.',
    WEBSITE_BUILDER_CHANGE_EXPAND: 'Voir le détail',
    WEBSITE_BUILDER_CHANGE_COLLAPSE: 'Masquer le détail',
    WEBSITE_BUILDER_CHANGE_SCOPE_THEME: 'Thème du site',
    WEBSITE_BUILDER_CHANGE_SCOPE_SHARED: 'En-tête et pied de page',
    WEBSITE_BUILDER_CHANGE_SCOPE_PAGE: 'Page « {name} »',
    WEBSITE_BUILDER_CHANGE_THEME_COLORS: 'Couleurs',
    WEBSITE_BUILDER_CHANGE_THEME_TYPOGRAPHY: 'Typographie',
    WEBSITE_BUILDER_CHANGE_THEME_LAYOUT: 'Style et mise en page',
    WEBSITE_BUILDER_CHANGE_PAGES_STRUCTURE: 'Pages du site (ajout, suppression, ordre)',
    WEBSITE_BUILDER_CHANGE_SUBPAGES_STRUCTURE: 'Sous-pages de « {name} »',
    WEBSITE_BUILDER_CHANGE_PAGE_META: 'Titre, adresse et SEO',
    WEBSITE_BUILDER_CHANGE_PAGE_OVERRIDES: 'Contenus par prestation, catégorie ou zone',
    WEBSITE_BUILDER_CHANGE_COMPONENT_ORDER: 'Ordre des blocs',
    WEBSITE_BUILDER_CHANGE_COMPONENT_FALLBACK: 'Bloc',
    WEBSITE_BUILDER_CHANGE_INITIAL_DRAFT: 'Première version du site',
    WEBSITE_BUILDER_PUBLISH: 'Publier',
    WEBSITE_BUILDER_PUBLISH_TITLE: 'Publication',
    WEBSITE_BUILDER_PUBLISH_AGAIN: 'Publier à nouveau',
    WEBSITE_BUILDER_PUBLISH_CHANGES_COUNT:
      '{count, plural, one {{count} changement non publié} other {{count} changements non publiés}}',
    WEBSITE_BUILDER_PUBLISH_BLOCKED_BY_ERRORS: '⚠️ Corrigez les blocs en erreur (bordure orange) avant de publier.',
    WEBSITE_BUILDER_PUBLISH_ONLINE: 'En ligne',
    WEBSITE_BUILDER_PUBLISH_PUBLISHED_AT: 'Publié {date}',
    WEBSITE_BUILDER_PUBLISH_MANAGE_DOMAINS: 'Gérer les domaines',
    WEBSITE_BUILDER_PUBLISH_UNPUBLISH: 'Dépublier le site',
    WEBSITE_BUILDER_PUBLISH_NO_DOMAIN_HINT:
      'Votre site est accessible sur {subdomain}. Configurez un domaine personnalisé pour une adresse professionnelle.',
    WEBSITE_BUILDER_PUBLISH_CONFIGURE_DOMAIN: 'Configurer un domaine',
    WEBSITE_BUILDER_PUBLISH_DEFAULT_SUBDOMAIN: 'Sous-domaine par défaut',
    WEBSITE_BUILDER_PUBLISH_GROUP_TRACKING: 'Suivi et Analytics',
    WEBSITE_BUILDER_SETTINGS: 'Paramètres',
    WEBSITE_BUILDER_SETTINGS_TAB_GENERAL: 'Général',
    WEBSITE_BUILDER_SETTINGS_TAB_TRACKING: 'Tracking',
    WEBSITE_BUILDER_SETTINGS_TAB_SEO: 'SEO / GEO',
    WEBSITE_BUILDER_SETTINGS_TRACKING: 'Suivi et Analytics',
    WEBSITE_BUILDER_SETTINGS_TRACKING_DESC:
      'Configurez vos outils de suivi. Un bandeau de consentement aux cookies sera automatiquement affiché sur votre site.',
    WEBSITE_BUILDER_SETTINGS_GOOGLE_LABEL: 'ID de suivi Google',
    WEBSITE_BUILDER_SETTINGS_GOOGLE_PLACEHOLDER: 'GTM-XXXXXXX, G-XXXXXXXXXX, AW-XXXXXXXXX…',
    WEBSITE_BUILDER_SETTINGS_GOOGLE_HELP:
      'Collez votre identifiant Google : Tag Manager (GTM-), Analytics 4 (G-), Google Ads (AW-) ou Universal Analytics (UA-). Le bon script sera chargé automatiquement.',
    WEBSITE_BUILDER_SETTINGS_META_PIXEL_LABEL: 'ID Pixel Meta (Facebook)',
    WEBSITE_BUILDER_SETTINGS_META_PIXEL_PLACEHOLDER: '123456789012345',
    WEBSITE_BUILDER_SETTINGS_META_PIXEL_HELP: 'Identifiant numérique de votre Pixel Meta (15-16 chiffres)',
    WEBSITE_BUILDER_SETTINGS_TIKTOK_PIXEL_LABEL: 'ID Pixel TikTok',
    WEBSITE_BUILDER_SETTINGS_TIKTOK_PIXEL_PLACEHOLDER: 'D1XXXXXXXXXXXXXXXXXX',
    WEBSITE_BUILDER_SETTINGS_TIKTOK_PIXEL_HELP:
      'Identifiant de votre Pixel TikTok (lettres et chiffres, disponible dans TikTok Ads Manager > Outils > Événements)',
    WEBSITE_BUILDER_SETTINGS_BRANDING: 'Identité du site',
    WEBSITE_BUILDER_SETTINGS_BRANDING_DESC:
      "Personnalisez le titre, la description et le favicon affichés dans l'onglet du navigateur et sur les réseaux sociaux.",
    WEBSITE_BUILDER_SETTINGS_FAVICON_LABEL: 'Favicon',
    WEBSITE_BUILDER_SETTINGS_FAVICON_PLACEHOLDER: 'Cliquez ou déposez une image',
    WEBSITE_BUILDER_SETTINGS_FAVICON_HELP:
      "Image carrée qui apparaît dans l'onglet du navigateur. Format recommandé : PNG ou SVG, minimum 512×512 px.",
    WEBSITE_BUILDER_SETTINGS_TITLE_LABEL: 'Titre du site',
    WEBSITE_BUILDER_SETTINGS_TITLE_PLACEHOLDER: 'Mon entreprise',
    WEBSITE_BUILDER_SETTINGS_TITLE_HELP: "Titre affiché dans l'onglet du navigateur et les résultats de recherche.",
    WEBSITE_BUILDER_SETTINGS_DESC_LABEL: 'Description du site',
    WEBSITE_BUILDER_SETTINGS_DESC_PLACEHOLDER: 'Une brève description de votre activité (150-160 caractères).',
    WEBSITE_BUILDER_SETTINGS_DESC_HELP:
      'Utilisée par les moteurs de recherche et lors du partage sur les réseaux sociaux.',
    WEBSITE_BUILDER_COMPONENT_FLOATING_CONTACT: 'Bouton de contact flottant',
    WEBSITE_BUILDER_COMPONENT_DESC_FLOATING_CONTACT:
      'Bouton rond fixe en bas à droite (WhatsApp ou appel) pour vous contacter en un clic.',
    WEBSITE_BUILDER_VARIANT_FLOATING_CONTACT_WHATSAPP: 'WhatsApp',
    WEBSITE_BUILDER_VARIANT_FLOATING_CONTACT_PHONE: 'Téléphone',
    WEBSITE_BUILDER_FLOATING_CONTACT_PHONE: 'Numéro à contacter',
    WEBSITE_BUILDER_FLOATING_CONTACT_PHONE_PLACEHOLDER: '06 12 34 56 78',
    WEBSITE_PUBLIC_CONTACT_WHATSAPP: 'Contacter sur WhatsApp',
    WEBSITE_PUBLIC_CONTACT_PHONE: 'Appeler',
    WEBSITE_PUBLIC_COOKIE_TITLE: 'Ce site utilise des cookies',
    WEBSITE_PUBLIC_COOKIE_DESC:
      'Nous utilisons des cookies pour améliorer votre expérience et analyser le trafic. Ces cookies seront activés uniquement si vous donnez votre consentement.',
    WEBSITE_PUBLIC_COOKIE_ANALYTICS: "Mesure d'audience",
    WEBSITE_PUBLIC_COOKIE_ANALYTICS_DESC: 'Nous aide à comprendre comment vous utilisez le site.',
    WEBSITE_PUBLIC_COOKIE_MARKETING: 'Publicité',
    WEBSITE_PUBLIC_COOKIE_MARKETING_DESC:
      'Permet de mesurer les performances des campagnes. Si vous acceptez, l’e-mail et le téléphone que vous saisissez sur ce site peuvent être transmis aux services publicitaires.',
    WEBSITE_PUBLIC_COOKIE_ACCEPT_ALL: 'Tout accepter',
    WEBSITE_PUBLIC_COOKIE_REJECT_ALL: 'Tout refuser',
    WEBSITE_PUBLIC_COOKIE_CUSTOMIZE: 'Gérer les préférences',
    WEBSITE_PUBLIC_COOKIE_SAVE: 'Enregistrer mes choix',
    WEBSITE_PUBLIC_COOKIE_MANAGE: 'Gérer les cookies',
    WEBSITE_PUBLIC_COOKIE_LEARN_MORE: 'En savoir plus',
    WEBSITE_PUBLIC_COOKIE_POLICY_DETAILS_TITLE: 'Cookies que nous utilisons',
    WEBSITE_PUBLIC_COOKIE_POLICY_ESSENTIAL_TITLE: 'Cookies strictement nécessaires',
    WEBSITE_PUBLIC_COOKIE_POLICY_ESSENTIAL_DESC:
      "Ces cookies sont indispensables au fonctionnement du site : session, panier de réservation, préférences d'affichage. Ils ne nécessitent pas votre consentement et ne peuvent pas être désactivés.",
    WEBSITE_PUBLIC_COOKIE_POLICY_ESSENTIAL_RETENTION: 'durée de la session (jusqu’à 13 mois maximum).',
    WEBSITE_PUBLIC_COOKIE_POLICY_ANALYTICS_TITLE: "Cookies de mesure d'audience",
    WEBSITE_PUBLIC_COOKIE_POLICY_ANALYTICS_DESC:
      "Nous utilisons ces cookies pour comprendre comment les visiteurs utilisent notre site (pages consultées, durée de visite, appareil, navigateur) afin d'améliorer son contenu et son ergonomie. Ils sont déposés uniquement après votre consentement.",
    WEBSITE_PUBLIC_COOKIE_POLICY_ANALYTICS_RETENTION: "jusqu'à 13 mois.",
    WEBSITE_PUBLIC_COOKIE_POLICY_ADS_TITLE: 'Cookies publicitaires',
    WEBSITE_PUBLIC_COOKIE_POLICY_ADS_DESC:
      "Nous utilisons ces cookies pour mesurer l'efficacité de nos campagnes marketing, afficher des publicités pertinentes et limiter leur répétition. Ils sont déposés uniquement après votre consentement.",
    WEBSITE_PUBLIC_COOKIE_POLICY_ADS_USER_DATA:
      "Si vous acceptez ces cookies, l'adresse e-mail et le numéro de téléphone que vous saisissez sur ce site (formulaire de contact, demande de rappel, réservation, inscription à la newsletter) peuvent être transmis à ces services publicitaires pour mesurer les résultats de nos campagnes. Ils ne leur sont jamais transmis si vous refusez les cookies publicitaires.",
    WEBSITE_PUBLIC_COOKIE_POLICY_OTHER_TOOLS: "d'autres outils installés par l'éditeur du site",
    WEBSITE_PUBLIC_COOKIE_POLICY_ADS_RETENTION: "jusqu'à 13 mois.",
    WEBSITE_PUBLIC_COOKIE_POLICY_PROVIDERS: 'Services utilisés',
    WEBSITE_PUBLIC_COOKIE_POLICY_RETENTION: 'Durée de conservation',
    WEBSITE_PUBLIC_COOKIE_POLICY_TRANSFER: 'Transfert hors UE',
    WEBSITE_PUBLIC_COOKIE_POLICY_TRANSFER_DESC:
      'les données peuvent être transférées aux États-Unis dans le cadre de clauses contractuelles types approuvées par la Commission Européenne.',
    BINDING_PRO_LEGAL_NAME: 'Raison sociale',
    BINDING_PRO_SIRET: 'SIRET',
    WEBSITE_BUILDER_COMPONENT_HEADER_HERO: 'Bannière principale',
    WEBSITE_BUILDER_COMPONENT_HEADER_MENU: 'Menu de navigation',
    WEBSITE_BUILDER_COMPONENT_FOOTER: 'Pied de page',
    WEBSITE_BUILDER_COMPONENT_CALL_TO_ACTION: "Appel à l'action",
    WEBSITE_BUILDER_COMPONENT_FAQ: 'Questions fréquentes',
    WEBSITE_BUILDER_COMPONENT_NEWSLETTER_SUBSCRIPTION: 'Newsletter',
    WEBSITE_BUILDER_COMPONENT_CONTACT_FORM: 'Formulaire de contact',
    WEBSITE_BUILDER_COMPONENT_CALLBACK_REQUEST: 'Demande de rappel',
    WEBSITE_BUILDER_COMPONENT_DESC_CONTACT_FORM:
      'Un formulaire de contact dont vous choisissez les champs. Les messages vous sont envoyés par email et notification.',
    WEBSITE_BUILDER_COMPONENT_DESC_CALLBACK_REQUEST:
      'Un formulaire court pour être rappelé. Les demandes vous sont envoyées par email et notification.',
    WEBSITE_BUILDER_COMPONENT_PRESTATION_LISTING: 'Liste des prestations',
    WEBSITE_BUILDER_COMPONENT_PRESTATION_DETAIL: 'Détail prestation',
    WEBSITE_BUILDER_COMPONENT_NEWS_LISTING: 'Liste des actualités',
    WEBSITE_BUILDER_COMPONENT_NEWS_HIGHLIGHT: 'Actualités à la une',
    WEBSITE_BUILDER_COMPONENT_NEWS_DETAIL: 'Détail actualité',
    WEBSITE_BUILDER_COMPONENT_TEXT_BLOCK: 'Bloc de texte',
    WEBSITE_BUILDER_COMPONENT_TEAM_LISTING: "L'équipe",
    WEBSITE_BUILDER_COMPONENT_CONTACT_INFO: 'Contact',
    WEBSITE_BUILDER_COMPONENT_PRESTATION_HIGHLIGHT: 'Prestations mises en avant',
    WEBSITE_BUILDER_COMPONENT_PACK_LISTING: 'Packs',
    WEBSITE_BUILDER_PACK_LISTING_TITLE: 'Titre',
    WEBSITE_BUILDER_PACK_LISTING_BUY: 'Acheter le pack',
    WEBSITE_BUILDER_PACK_LISTING_VIEW: 'Voir le pack',
    WEBSITE_BUILDER_PACK_LISTING_CONTENTS: 'Ce pack comprend',
    WEBSITE_BUILDER_PACK_LISTING_CLOSE: 'Fermer',
    WEBSITE_BUILDER_PACK_LISTING_EMPTY_HINT:
      'Aucun pack pour le moment. Créez vos packs depuis votre tableau de bord pour les afficher ici.',
    WEBSITE_BUILDER_COMPONENT_BOOKING_WIDGET: 'Réservation en ligne',
    WEBSITE_BUILDER_COMPONENT_GIFT_CARD: 'Cartes cadeaux & packs',
    WEBSITE_BUILDER_BOOKING_WIDGET_PRESTATION_FILTER: 'Prestations proposées',
    WEBSITE_BUILDER_BOOKING_WIDGET_CATEGORY_FILTER: 'Catégories proposées',
    WEBSITE_BUILDER_BOOKING_WIDGET_PLACE_FILTER: 'Lieux proposés',
    WEBSITE_BUILDER_BOOKING_WIDGET_PRESELECT: 'Prestations pré-sélectionnées',
    WEBSITE_BUILDER_PRESTATION_HIGHLIGHT_TITLE: 'Titre',
    WEBSITE_BUILDER_PRESTATION_HIGHLIGHT_FILTER: 'Prestations à afficher',
    WEBSITE_BUILDER_NEWS_HIGHLIGHT_TITLE: 'Titre',
    WEBSITE_BUILDER_NEWS_HIGHLIGHT_FILTER: 'Articles à afficher',
    WEBSITE_BUILDER_NEWS_HIGHLIGHT_FILTER_PLACEHOLDER: `Les ${NEWS_HIGHLIGHT_MAX_ITEMS} derniers articles publiés`,
    WEBSITE_BUILDER_NEWS_HIGHLIGHT_TAG: 'Thématique (mode automatique)',
    WEBSITE_BUILDER_NEWS_HIGHLIGHT_TAG_PLACEHOLDER: 'Toutes les thématiques',
    WEBSITE_BUILDER_NEWS_HIGHLIGHT_SHOW_ALL_LINK: 'Afficher le lien « Voir toutes les actualités »',
    WEBSITE_BUILDER_NEWS_HIGHLIGHT_EMPTY_HINT:
      'Aucun article publié pour le moment. Publiez vos actualités depuis le menu « Publications » pour les afficher ici.',
    WEBSITE_BUILDER_NEWS_HIGHLIGHT_NO_BLOG_PAGE_HINT:
      'La page « Actualités » est désactivée : activez-la pour que ce bloc apparaisse sur votre site.',

    WEBSITE_BUILDER_CONTACT_SELECTED_PLACES: 'Lieux à afficher',
    WEBSITE_BUILDER_CONTACT_SHOW_PHONE: 'Afficher "Appeler"',
    WEBSITE_BUILDER_CONTACT_SHOW_EMAIL: 'Afficher "Message"',
    WEBSITE_BUILDER_CONTACT_SHOW_SOCIAL: 'Afficher les réseaux sociaux',
    WEBSITE_BUILDER_CONTACT_TRAVEL_INFO: 'Informations complémentaires',
    WEBSITE_BUILDER_VARIANT_CONTACT_MAP: 'Carte',
    WEBSITE_BUILDER_VARIANT_CONTACT_SPLIT_MAP: 'Carte multi-lieux',
    WEBSITE_BUILDER_VARIANT_CONTACT_COMPACT: 'Compact',
    WEBSITE_BUILDER_CONTACT_SHOW_CALLBACK: 'Afficher "Être rappelé"',
    WEBSITE_BUILDER_CONTACT_ACTION_CALL: 'Appeler',
    WEBSITE_BUILDER_CONTACT_ACTION_EMAIL: 'Message',
    WEBSITE_BUILDER_CONTACT_ACTION_MESSAGE: 'Écrire un message',
    WEBSITE_BUILDER_CONTACT_ACTION_CALLBACK: 'Être rappelé',
    WEBSITE_BUILDER_CONTACT_MESSAGE_SEND: 'Envoyer',
    WEBSITE_BUILDER_CONTACT_CALLBACK_SEND: 'Être rappelé(e)',
    WEBSITE_BUILDER_CONTACT_MESSAGE_FIELDS: 'Champs du formulaire « Message »',
    WEBSITE_BUILDER_CONTACT_CALLBACK_FIELDS: 'Champs du formulaire « Rappel »',
    WEBSITE_BUILDER_CONTACT_BADGE_TRAVELING: 'Se déplace chez vous',
    WEBSITE_BUILDER_CONTACT_BADGE_PHONE: 'Disponible par téléphone',
    WEBSITE_BUILDER_CONTACT_BADGE_VIDEO: 'Disponible en visio',
    WEBSITE_BUILDER_CONTACT_HOURS_TITLE: "Horaires d'ouverture",
    WEBSITE_BUILDER_CONTACT_HOURS_CLOSED: 'Fermé',
    WEBSITE_BUILDER_CONTACT_HOURS_ALL_DAY: 'Ouvert 24h/24',
    WEBSITE_BUILDER_CONTACT_HOURS_EXCEPTIONS_TITLE: 'Fermetures exceptionnelles',
    WEBSITE_BUILDER_CONTACT_HOURS_DAY_MONDAY: 'Lundi',
    WEBSITE_BUILDER_CONTACT_HOURS_DAY_TUESDAY: 'Mardi',
    WEBSITE_BUILDER_CONTACT_HOURS_DAY_WEDNESDAY: 'Mercredi',
    WEBSITE_BUILDER_CONTACT_HOURS_DAY_THURSDAY: 'Jeudi',
    WEBSITE_BUILDER_CONTACT_HOURS_DAY_FRIDAY: 'Vendredi',
    WEBSITE_BUILDER_CONTACT_HOURS_DAY_SATURDAY: 'Samedi',
    WEBSITE_BUILDER_CONTACT_HOURS_DAY_SUNDAY: 'Dimanche',
    WEBSITE_BUILDER_CONTACT_SOCIAL_LABEL: 'Suivez-nous',
    WEBSITE_BUILDER_CONTACT_PHONE_TEXT: 'Vous pouvez nous joindre directement sur ce numéro :',
    WEBSITE_BUILDER_CONTACT_EMAIL_TEXT: 'Envoyez-nous un email :',
    WEBSITE_BUILDER_CONTACT_NO_PHONE: 'Aucun numéro de téléphone disponible.',
    WEBSITE_BUILDER_CONTACT_NO_EMAIL: 'Aucune adresse email disponible.',
    WEBSITE_BUILDER_CONTACT_LOADING: 'Chargement...',
    WEBSITE_BUILDER_CONTACT_CALLBACK_SOON: 'Cette fonctionnalité sera bientôt disponible.',
    WEBSITE_BUILDER_CLOSE: 'Fermer',
    WEBSITE_BUILDER_ALL_PLACES: 'Tous les lieux',

    WEBSITE_BUILDER_ALL_CATEGORIES: 'Toutes les catégories',
    WEBSITE_BUILDER_PRESTATION_CATEGORY_FILTER: 'Filtrer par catégorie',
    WEBSITE_BUILDER_PRESTATION_ITEMS_PER_PAGE: 'Nombre de prestations affichées',
    WEBSITE_BUILDER_PRESTATION_SHOW_PRICE: 'Afficher le prix',
    WEBSITE_BUILDER_PRESTATION_SHOW_DESCRIPTION: 'Afficher la description',
    WEBSITE_BUILDER_PRESTATION_SHOW_DURATION: 'Afficher la durée',
    WEBSITE_BUILDER_PRESTATION_SHOW_SUPPLEMENTS: 'Afficher les suppléments',
    WEBSITE_BUILDER_PRESTATION_SHOW_BOOKING: 'Afficher le bouton de réservation',
    WEBSITE_BUILDER_NEWS_SHOW_SIDEBAR: 'Afficher la sidebar catégories',

    WEBSITE_BUILDER_VARIANT_GRID: 'Grille',
    WEBSITE_BUILDER_VARIANT_LIST: 'Liste',
    WEBSITE_BUILDER_VARIANT_FEATURED: 'À la une',
    WEBSITE_BUILDER_VARIANT_DEFAULT: 'Par défaut',
    WEBSITE_BUILDER_VARIANT_SIDEBAR: 'Avec barre latérale',

    // text-block
    WEBSITE_BUILDER_TEXT_BLOCK_TITLE: 'Titre',
    WEBSITE_BUILDER_TEXT_BLOCK_CONTENT: 'Contenu',
    WEBSITE_BUILDER_TEXT_BLOCK_CONTENT_RIGHT: 'Contenu colonne droite',
    WEBSITE_BUILDER_TEXT_BLOCK_IMAGE: 'Image',
    WEBSITE_BUILDER_TEXT_BLOCK_IMAGE_POSITION: "Position de l'image",
    WEBSITE_BUILDER_TEXT_BLOCK_IMAGE_LEFT: 'Image à gauche',
    WEBSITE_BUILDER_TEXT_BLOCK_IMAGE_RIGHT: 'Image à droite',
    WEBSITE_BUILDER_VARIANT_TEXT_SINGLE_COLUMN: 'Une colonne',
    WEBSITE_BUILDER_VARIANT_TEXT_TWO_COLUMNS: 'Deux colonnes',
    WEBSITE_BUILDER_VARIANT_TEXT_WITH_IMAGE: 'Avec image',

    // team-listing
    WEBSITE_BUILDER_TEAM_TITLE: 'Titre de la section',
    WEBSITE_BUILDER_TEAM_SHOW_EXPERTISE: "Afficher les domaines d'expertise",
    WEBSITE_BUILDER_TEAM_SHOW_CAREER: 'Afficher le parcours',
    WEBSITE_BUILDER_TEAM_EMPTY: 'Aucun membre à afficher',
    WEBSITE_BUILDER_VARIANT_TEAM_CAROUSEL: 'Carousel',
    WEBSITE_BUILDER_VARIANT_TEAM_GRID: 'Grille',
    WEBSITE_BUILDER_VARIANT_TEAM_LIST: 'Liste',

    // testimonials
    WEBSITE_BUILDER_COMPONENT_TESTIMONIALS: 'Témoignages',
    WEBSITE_BUILDER_TESTIMONIALS_TITLE: 'Titre de la section',
    WEBSITE_BUILDER_TESTIMONIALS_TITLE_PLACEHOLDER: 'Ce que disent nos clients',
    WEBSITE_BUILDER_TESTIMONIALS_ITEMS: 'Témoignages',
    WEBSITE_BUILDER_TESTIMONIAL_TEXT: 'Témoignage',
    WEBSITE_BUILDER_TESTIMONIAL_TEXT_PLACEHOLDER: 'Écrivez le témoignage ici...',
    WEBSITE_BUILDER_TESTIMONIAL_AUTHOR_NAME: 'Nom',
    WEBSITE_BUILDER_TESTIMONIAL_AUTHOR_NAME_PLACEHOLDER: 'Prénom Nom',
    WEBSITE_BUILDER_TESTIMONIAL_AUTHOR_ROLE: 'Fonction ou contexte',
    WEBSITE_BUILDER_TESTIMONIAL_AUTHOR_ROLE_PLACEHOLDER: 'Ex : Dirigeant PME, Maman de 2 enfants...',
    WEBSITE_BUILDER_TESTIMONIAL_AUTHOR_PHOTO: 'Photo',
    WEBSITE_BUILDER_TESTIMONIAL_VIDEO_REF: 'Vidéo (remplace le texte si renseignée)',
    WEBSITE_BUILDER_TESTIMONIAL_VIDEO_ORIENTATION: 'Format de la vidéo',
    WEBSITE_BUILDER_VIDEO_ORIENTATION_LANDSCAPE: 'Paysage (16:9)',
    WEBSITE_BUILDER_VIDEO_ORIENTATION_PORTRAIT: 'Portrait (9:16)',
    WEBSITE_BUILDER_TESTIMONIAL_RATING: 'Note (1 à 5 étoiles)',
    WEBSITE_BUILDER_VARIANT_TESTIMONIALS_CAROUSEL: 'Carrousel',
    WEBSITE_BUILDER_VARIANT_TESTIMONIALS_GRID: 'Grille (colonnes régulières)',
    WEBSITE_BUILDER_VARIANT_TESTIMONIALS_WALL: 'Mur (mosaïque)',
    WEBSITE_BUILDER_VARIANT_TESTIMONIALS_HIGHLIGHT: 'Mis en avant',
    WEBSITE_BUILDER_TESTIMONIALS_EMPTY: 'Aucun témoignage à afficher',
    WEBSITE_BUILDER_TESTIMONIAL_RATING_SUFFIX: 'sur 5',
    WEBSITE_BUILDER_COMPONENT_GOOGLE_REVIEWS: 'Avis Google',
    WEBSITE_BUILDER_GOOGLE_REVIEWS_TITLE: 'Titre de la section',
    WEBSITE_BUILDER_GOOGLE_REVIEWS_TITLE_PLACEHOLDER: 'Ce que disent nos clients sur Google',
    WEBSITE_BUILDER_GOOGLE_REVIEWS_SOURCES: 'Fiches Google à afficher',
    WEBSITE_BUILDER_GOOGLE_REVIEWS_MIN_RATING: 'Note minimale affichée',
    WEBSITE_BUILDER_GOOGLE_REVIEWS_MIN_RATING_ALL: 'Tous les avis',
    WEBSITE_BUILDER_GOOGLE_REVIEWS_MAX_ITEMS: 'Nombre d’avis affichés',
    WEBSITE_BUILDER_GOOGLE_REVIEWS_SHOW_SUMMARY: 'Afficher la note globale',
    WEBSITE_BUILDER_VARIANT_GOOGLE_REVIEWS_CAROUSEL: 'Carrousel',
    WEBSITE_BUILDER_VARIANT_GOOGLE_REVIEWS_GRID: 'Grille (colonnes régulières)',
    WEBSITE_BUILDER_VARIANT_GOOGLE_REVIEWS_WALL: 'Mur (mosaïque)',
    WEBSITE_BUILDER_GOOGLE_REVIEWS_RATING_SUFFIX: 'sur 5',
    WEBSITE_BUILDER_GOOGLE_REVIEWS_COUNT_LABEL: 'avis Google',
    WEBSITE_BUILDER_GOOGLE_REVIEWS_ANONYMOUS_AUTHOR: 'Client Google',
    WEBSITE_BUILDER_GOOGLE_REVIEWS_EMPTY_HINT:
      'Aperçu réservé à l’éditeur : vos vrais avis Google apparaîtront ici automatiquement une fois votre fiche d’établissement Google connectée.',
    WEBSITE_BUILDER_COOKIE_POLICY_DETAILS_EMPTY_HINT:
      'Le détail des cookies se remplira tout seul ici une fois un outil de suivi (Google Analytics, Meta Pixel…) ajouté dans les paramètres du site. Ce message n’est visible que par vous dans l’éditeur : le bloc reste masqué pour vos visiteurs tant qu’aucun suivi n’est actif.',

    // key-figures
    WEBSITE_BUILDER_COMPONENT_KEY_FIGURES: 'Chiffres clés',
    WEBSITE_BUILDER_KEY_FIGURES_TITLE: 'Titre de la section',
    WEBSITE_BUILDER_KEY_FIGURES_TITLE_PLACEHOLDER: 'Nos résultats en chiffres',
    WEBSITE_BUILDER_KEY_FIGURES_ITEMS: 'Chiffres',
    WEBSITE_BUILDER_KEY_FIGURE_VALUE: 'Valeur',
    WEBSITE_BUILDER_KEY_FIGURE_VALUE_PLACEHOLDER: 'Ex : +500, 98%, 12 ans',
    WEBSITE_BUILDER_KEY_FIGURE_LABEL: 'Libellé',
    WEBSITE_BUILDER_KEY_FIGURE_ICON: 'Icône',
    WEBSITE_BUILDER_KEY_FIGURE_LABEL_PLACEHOLDER: 'Ex : clients accompagnés',
    WEBSITE_BUILDER_VARIANT_KEY_FIGURES_COLUMNS: 'Colonnes',
    WEBSITE_BUILDER_VARIANT_KEY_FIGURES_BANNER: 'Bandeau',
    WEBSITE_BUILDER_VARIANT_KEY_FIGURES_CARD: 'Cartes',

    // methodology
    WEBSITE_BUILDER_COMPONENT_METHODOLOGY: 'Méthodologie',
    WEBSITE_BUILDER_METHODOLOGY_TITLE: 'Titre de la section',
    WEBSITE_BUILDER_METHODOLOGY_TITLE_PLACEHOLDER: 'Notre méthode',
    WEBSITE_BUILDER_METHODOLOGY_SUBTITLE: 'Sous-titre',
    WEBSITE_BUILDER_METHODOLOGY_SUBTITLE_PLACEHOLDER: 'Découvrez comment nous travaillons',
    WEBSITE_BUILDER_METHODOLOGY_ITEMS: 'Étapes',
    WEBSITE_BUILDER_METHODOLOGY_STEP_TITLE: "Titre de l'étape",
    WEBSITE_BUILDER_METHODOLOGY_STEP_TITLE_PLACEHOLDER: 'Ex : Premier contact',
    WEBSITE_BUILDER_METHODOLOGY_STEP_DESCRIPTION: 'Description',
    WEBSITE_BUILDER_METHODOLOGY_STEP_ICON: 'Icône',
    WEBSITE_BUILDER_METHODOLOGY_STEP_DESCRIPTION_PLACEHOLDER: 'Décrivez brièvement cette étape...',
    WEBSITE_BUILDER_VARIANT_METHODOLOGY_VERTICAL: 'Verticale',
    WEBSITE_BUILDER_VARIANT_METHODOLOGY_HORIZONTAL: 'Horizontale',
    WEBSITE_BUILDER_VARIANT_METHODOLOGY_CARDS: 'Cartes',

    // photo-gallery
    WEBSITE_BUILDER_COMPONENT_PHOTO_GALLERY: 'Galerie photos',
    WEBSITE_BUILDER_PHOTO_GALLERY_TITLE: 'Titre de la section',
    WEBSITE_BUILDER_PHOTO_GALLERY_TITLE_PLACEHOLDER: 'Nos réalisations',
    WEBSITE_BUILDER_PHOTO_GALLERY_ITEMS: 'Photos',
    WEBSITE_BUILDER_PHOTO_GALLERY_IMAGE: 'Image',
    WEBSITE_BUILDER_PHOTO_GALLERY_CAPTION: 'Légende',
    WEBSITE_BUILDER_PHOTO_GALLERY_CAPTION_PLACEHOLDER: 'Décrivez cette photo...',
    WEBSITE_BUILDER_VARIANT_PHOTO_GALLERY_MASONRY: 'Mosaïque',
    WEBSITE_BUILDER_VARIANT_PHOTO_GALLERY_CAROUSEL: 'Carrousel',

    // simple-photo
    WEBSITE_BUILDER_COMPONENT_SIMPLE_PHOTO: 'Photo',
    WEBSITE_BUILDER_SIMPLE_PHOTO_IMAGE: 'Image',
    WEBSITE_BUILDER_SIMPLE_PHOTO_CAPTION: 'Légende',
    WEBSITE_BUILDER_SIMPLE_PHOTO_CAPTION_PLACEHOLDER: 'Décrivez cette photo...',
    WEBSITE_BUILDER_SIMPLE_PHOTO_EMPTY_PREVIEW: 'Ajoutez une image pour afficher ce bloc',
    WEBSITE_BUILDER_VARIANT_SIMPLE_PHOTO_STANDARD: 'Standard',
    WEBSITE_BUILDER_VARIANT_SIMPLE_PHOTO_SMALL: 'Petite',
    WEBSITE_BUILDER_VARIANT_SIMPLE_PHOTO_FULL: 'Pleine largeur',

    // before-after
    WEBSITE_BUILDER_COMPONENT_BEFORE_AFTER: 'Avant / Après',
    WEBSITE_BUILDER_BEFORE_AFTER_TITLE: 'Titre de la section',
    WEBSITE_BUILDER_BEFORE_AFTER_TITLE_PLACEHOLDER: 'Nos transformations',
    WEBSITE_BUILDER_BEFORE_AFTER_ITEMS: 'Comparaisons',
    WEBSITE_BUILDER_BEFORE_AFTER_BEFORE_IMAGE: 'Image avant',
    WEBSITE_BUILDER_BEFORE_AFTER_AFTER_IMAGE: 'Image après',
    WEBSITE_BUILDER_BEFORE_AFTER_CAPTION: 'Légende',
    WEBSITE_BUILDER_BEFORE_AFTER_CAPTION_PLACEHOLDER: 'Décrivez cette transformation...',
    WEBSITE_BUILDER_BEFORE_AFTER_LABEL_BEFORE: 'Avant',
    WEBSITE_BUILDER_BEFORE_AFTER_LABEL_AFTER: 'Après',
    WEBSITE_BUILDER_BEFORE_AFTER_SLIDER_HINT: 'Le slider interactif est disponible sur le site publié',
    WEBSITE_BUILDER_VARIANT_BEFORE_AFTER_SLIDER: 'Curseur interactif',
    WEBSITE_BUILDER_VARIANT_BEFORE_AFTER_SIDE_BY_SIDE: 'Côte à côte',
    WEBSITE_BUILDER_VARIANT_BEFORE_AFTER_GALLERY: 'Galerie',

    // specialties
    WEBSITE_BUILDER_COMPONENT_SPECIALTIES: 'Spécialités',
    WEBSITE_BUILDER_SPECIALTIES_TITLE: 'Titre de la section',
    WEBSITE_BUILDER_SPECIALTIES_TITLE_PLACEHOLDER: "Nos domaines d'expertise",
    WEBSITE_BUILDER_SPECIALTIES_ITEMS: 'Spécialités',
    WEBSITE_BUILDER_SPECIALTY_NAME: 'Nom',
    WEBSITE_BUILDER_SPECIALTY_NAME_PLACEHOLDER: 'Ex : Gestion du stress, Burn-out...',
    WEBSITE_BUILDER_SPECIALTY_DESCRIPTION: 'Description',
    WEBSITE_BUILDER_SPECIALTY_ICON: 'Icône',
    WEBSITE_BUILDER_SPECIALTY_DESCRIPTION_PLACEHOLDER: 'Décrivez brièvement ce domaine...',
    WEBSITE_BUILDER_VARIANT_SPECIALTIES_TAGS: 'Tags',

    // promotion
    WEBSITE_BUILDER_COMPONENT_PROMOTION: 'Promotion',
    WEBSITE_BUILDER_PROMOTION_TITLE: "Titre de l'offre",
    WEBSITE_BUILDER_PROMOTION_TITLE_PLACEHOLDER: 'Offre spéciale -20%',
    WEBSITE_BUILDER_PROMOTION_DESCRIPTION: 'Description',
    WEBSITE_BUILDER_PROMOTION_DESCRIPTION_PLACEHOLDER: 'Profitez de notre offre exceptionnelle...',
    WEBSITE_BUILDER_PROMOTION_CODE: 'Code promo',
    WEBSITE_BUILDER_PROMOTION_CODE_PLACEHOLDER: 'Ex : PROMO20',
    WEBSITE_BUILDER_PROMOTION_EXPIRATION: "Date d'expiration",
    WEBSITE_BUILDER_PROMOTION_CTA_LABEL: 'Texte du bouton',
    WEBSITE_BUILDER_PROMOTION_CTA_LABEL_PLACEHOLDER: 'En profiter',
    WEBSITE_BUILDER_PROMOTION_CTA_HREF: 'Lien du bouton',
    WEBSITE_BUILDER_PROMOTION_IMAGE: 'Image',
    WEBSITE_BUILDER_PROMOTION_EXPIRED: 'Offre terminée',
    WEBSITE_BUILDER_PROMOTION_COUNTDOWN_DAYS: 'j',
    WEBSITE_BUILDER_PROMOTION_COUNTDOWN_HOURS: 'h',
    WEBSITE_BUILDER_PROMOTION_COUNTDOWN_MINUTES: 'min',
    WEBSITE_BUILDER_PROMOTION_COUNTDOWN_SECONDS: 's',
    WEBSITE_BUILDER_VARIANT_PROMOTION_BANNER: 'Bandeau',
    WEBSITE_BUILDER_VARIANT_PROMOTION_CARD: 'Carte',
    WEBSITE_BUILDER_VARIANT_PROMOTION_SPLIT: 'Image + texte',
    WEBSITE_BUILDER_VARIANT_PROMOTION_CURRENT_OFFERS: 'Offres du moment',
    WEBSITE_BUILDER_PROMOTION_OFFERS_TITLE: 'Titre de la section',
    WEBSITE_BUILDER_PROMOTION_OFFERS_TITLE_PLACEHOLDER: 'Offres du moment',
    WEBSITE_BUILDER_PROMOTION_OFFERS_DESCRIPTION: 'Introduction',
    WEBSITE_BUILDER_PROMOTION_OFFERS_DESCRIPTION_PLACEHOLDER: 'Profitez de nos offres en cours',
    WEBSITE_BUILDER_PROMOTION_OFFERS_EMPTY:
      'Aucune promotion mise en avant en ce moment : cette section est masquée pour vos visiteurs. Elle affiche automatiquement les promotions actives cochées « Mettre en avant sur le site » (Communication › Promotions).',

    // top header
    WEBSITE_BUILDER_COMPONENT_TOP_HEADER: 'Bandeau supérieur',
    WEBSITE_BUILDER_COMPONENT_DESC_TOP_HEADER:
      'Un bandeau au-dessus du menu pour une promo, un compte à rebours ou un CTA',
    WEBSITE_BUILDER_TOP_HEADER_MESSAGE: 'Message',
    WEBSITE_BUILDER_TOP_HEADER_MESSAGE_PLACEHOLDER: 'Livraison offerte dès 50€ !',
    WEBSITE_BUILDER_TOP_HEADER_COUNTDOWN_DATE: 'Date de fin du compte à rebours',
    WEBSITE_BUILDER_TOP_HEADER_CTA_LABEL: 'Texte du bouton',
    WEBSITE_BUILDER_TOP_HEADER_CTA_LABEL_PLACEHOLDER: 'En profiter',
    WEBSITE_BUILDER_TOP_HEADER_CTA_HREF: 'Lien du bouton',
    WEBSITE_BUILDER_TOP_HEADER_DISMISSIBLE: 'Permettre la fermeture par le visiteur',
    WEBSITE_BUILDER_VARIANT_TOP_HEADER_SIMPLE: 'Simple',
    WEBSITE_BUILDER_VARIANT_TOP_HEADER_COUNTDOWN: 'Compte à rebours',
    WEBSITE_BUILDER_VARIANT_TOP_HEADER_PROMO: 'Promo',
    // Promotion liée (bandeau haut, section Promotion) : le contenu vient d'une promotion mise en avant.
    WEBSITE_BUILDER_LINKED_PROMOTION: 'Promotion liée',
    WEBSITE_BUILDER_LINKED_PROMOTION_PLACEHOLDER: 'Choisir une promotion mise en avant',
    WEBSITE_BUILDER_LINKED_PROMOTION_UNAVAILABLE:
      'La promotion liée n’est pas annoncée sur votre site (terminée, en pause, épuisée ou pas encore commencée) : ce bloc est masqué pour vos visiteurs.',
    INPUT_OPTION_LINKED_PROMOTION_NONE: 'Aucune promotion liée',
    INPUT_OPTION_LINKED_PROMOTION_INACTIVE: '{label} (non annoncée sur le site)',
    INPUT_OPTION_LINKED_PROMOTION_DELETED: 'Promotion supprimée',
    INPUT_OPTION_LINKED_PROMOTION_CURRENT: 'Promotion actuelle',
    INPUT_ERROR_LINKED_PROMOTIONS_LOAD: 'Impossible de charger les promotions.',
    INPUT_HINT_LINKED_PROMOTION: 'Le contenu vient de la promotion : un champ rempli ci-dessous le remplace.',
    INPUT_HINT_LINKED_PROMOTION_EMPTY:
      'Aucune promotion mise en avant : cochez « Mettre en avant sur le site » dans Communication › Promotions.',

    // quote
    WEBSITE_BUILDER_COMPONENT_QUOTE: 'Citation',
    WEBSITE_BUILDER_QUOTE_TEXT: 'Citation',
    WEBSITE_BUILDER_QUOTE_TEXT_PLACEHOLDER: 'Saisissez votre citation...',
    WEBSITE_BUILDER_QUOTE_AUTHOR_NAME: 'Auteur',
    WEBSITE_BUILDER_QUOTE_AUTHOR_NAME_PLACEHOLDER: "Nom de l'auteur",
    WEBSITE_BUILDER_QUOTE_AUTHOR_ROLE: 'Fonction',
    WEBSITE_BUILDER_QUOTE_AUTHOR_ROLE_PLACEHOLDER: 'Ex : Fondateur, Coach, Client',
    WEBSITE_BUILDER_QUOTE_AUTHOR_PHOTO: "Photo de l'auteur",
    WEBSITE_BUILDER_VARIANT_QUOTE_FRAMED: 'Encadré',
    WEBSITE_BUILDER_VARIANT_QUOTE_LARGE_TEXT: 'Grande typographie',
    WEBSITE_BUILDER_VARIANT_QUOTE_CARD: 'Carte avec photo',

    // partner logos
    WEBSITE_BUILDER_COMPONENT_PARTNER_LOGOS: 'Logos partenaires',
    WEBSITE_BUILDER_PARTNER_LOGOS_TITLE: 'Titre de la section',
    WEBSITE_BUILDER_PARTNER_LOGOS_TITLE_PLACEHOLDER: 'Ils nous font confiance',
    WEBSITE_BUILDER_PARTNER_LOGOS_ITEMS: 'Partenaires',
    WEBSITE_BUILDER_PARTNER_LOGO_NAME: 'Nom du partenaire',
    WEBSITE_BUILDER_PARTNER_LOGO_NAME_PLACEHOLDER: "Ex : Nom de l'entreprise",
    WEBSITE_BUILDER_PARTNER_LOGO_IMAGE: 'Logo',
    WEBSITE_BUILDER_PARTNER_LOGO_WEBSITE: 'Lien vers le site web',
    WEBSITE_BUILDER_VARIANT_PARTNER_LOGOS_SCROLLING: 'Défilant',
    WEBSITE_BUILDER_VARIANT_PARTNER_LOGOS_GRID: 'Grille',

    // certifications
    WEBSITE_BUILDER_COMPONENT_CERTIFICATIONS: 'Certifications & labels',
    WEBSITE_BUILDER_CERTIFICATIONS_TITLE: 'Titre de la section',
    WEBSITE_BUILDER_CERTIFICATIONS_TITLE_PLACEHOLDER: 'Nos certifications',
    WEBSITE_BUILDER_CERTIFICATIONS_ITEMS: 'Certifications',
    WEBSITE_BUILDER_CERTIFICATION_NAME: 'Nom de la certification',
    WEBSITE_BUILDER_CERTIFICATION_NAME_PLACEHOLDER: 'Ex : ISO 9001, Label Qualiopi',
    WEBSITE_BUILDER_CERTIFICATION_IMAGE: 'Image ou logo',
    WEBSITE_BUILDER_CERTIFICATION_DESCRIPTION: 'Description',
    WEBSITE_BUILDER_CERTIFICATION_DESCRIPTION_PLACEHOLDER: 'Décrivez cette certification...',
    WEBSITE_BUILDER_CERTIFICATION_YEAR: "Année d'obtention",
    WEBSITE_BUILDER_CERTIFICATION_YEAR_PLACEHOLDER: 'Ex : 2024',
    WEBSITE_BUILDER_VARIANT_CERTIFICATIONS_BADGES: 'Badges',
    WEBSITE_BUILDER_VARIANT_CERTIFICATIONS_DETAILED: 'Détaillé',

    // vod player (api.video + YouTube)
    WEBSITE_BUILDER_COMPONENT_VOD_PLAYER: 'Vidéo',
    WEBSITE_BUILDER_VOD_PLAYER_VIDEO_REF: 'Vidéo',
    WEBSITE_BUILDER_VOD_PLAYER_VIDEO_REF_PLACEHOLDER: 'Uploade une vidéo ou colle une URL YouTube',
    WEBSITE_BUILDER_VOD_PLAYER_OR: 'ou',
    WEBSITE_BUILDER_VOD_PLAYER_YOUTUBE_PLACEHOLDER: 'Colle une URL YouTube (youtube.com/watch?v=… ou youtu.be/…)',
    WEBSITE_BUILDER_VOD_PLAYER_YOUTUBE_CTA: 'Utiliser cette URL YouTube',
    WEBSITE_BUILDER_VOD_PLAYER_TITLE: 'Titre de la section',
    WEBSITE_BUILDER_VOD_PLAYER_TITLE_PLACEHOLDER: 'Ex : Découvrez notre univers',
    WEBSITE_BUILDER_VOD_PLAYER_DESCRIPTION: 'Description',
    WEBSITE_BUILDER_VOD_PLAYER_DESCRIPTION_PLACEHOLDER: 'Présentez votre vidéo...',
    WEBSITE_BUILDER_VOD_PLAYER_AUTOPLAY: 'Lecture automatique',
    WEBSITE_BUILDER_VOD_PLAYER_MUTED: 'Muet',
    WEBSITE_BUILDER_VOD_PLAYER_LOOP: 'Lecture en boucle',
    WEBSITE_BUILDER_VOD_PLAYER_CONTROLS: 'Afficher les contrôles',
    WEBSITE_BUILDER_VOD_PLAYER_NO_VIDEO: 'Aucune vidéo sélectionnée.',
    WEBSITE_BUILDER_VOD_PLAYER_UPLOAD_CTA: 'Choisir une vidéo',
    WEBSITE_BUILDER_VOD_PLAYER_UPLOADING: 'Envoi en cours…',
    WEBSITE_BUILDER_VOD_PLAYER_UPLOAD_TITLE_PLACEHOLDER: 'Titre de la vidéo (optionnel, sinon nom du fichier)',
    WEBSITE_BUILDER_VOD_PLAYER_REPLACE: 'Remplacer',
    WEBSITE_BUILDER_VOD_PLAYER_REMOVE: 'Supprimer',
    PRESTATION_VIDEO_ADD_UPLOAD: 'Importer un fichier',
    PRESTATION_VIDEO_ADD_YOUTUBE: 'Lien YouTube',
    PRESTATION_VIDEO_YOUTUBE_DIALOG_TITLE: 'Ajouter une vidéo YouTube',
    PRESTATION_VIDEO_LIMIT_REACHED: 'Limite de {max} vidéos atteinte.',
    WEBSITE_BUILDER_VARIANT_VOD_PLAYER_FULL_WIDTH: 'Pleine largeur',
    WEBSITE_BUILDER_VARIANT_VOD_PLAYER_WITH_TEXT: 'Avec texte',
    WEBSITE_BUILDER_VARIANT_VOD_PLAYER_BACKGROUND_HERO: 'Hero vidéo (fond)',

    // comparison table
    WEBSITE_BUILDER_COMPONENT_COMPARISON_TABLE: 'Tableau comparatif',
    WEBSITE_BUILDER_COMPONENT_COOKIE_POLICY_DETAILS: 'Détails des cookies (auto)',
    WEBSITE_BUILDER_COMPARISON_TABLE_TITLE: 'Titre de la section',
    WEBSITE_BUILDER_COMPARISON_TABLE_TITLE_PLACEHOLDER: 'Comparez nos offres',
    WEBSITE_BUILDER_COMPARISON_TABLE_COLUMNS: 'Colonnes',
    WEBSITE_BUILDER_COMPARISON_COLUMN_TITLE: 'Nom de la formule',
    WEBSITE_BUILDER_COMPARISON_COLUMN_TITLE_PLACEHOLDER: 'Ex : Essentiel, Premium',
    WEBSITE_BUILDER_COMPARISON_COLUMN_SUBTITLE: 'Sous-titre',
    WEBSITE_BUILDER_COMPARISON_COLUMN_SUBTITLE_PLACEHOLDER: 'Ex : À partir de 49€/mois',
    WEBSITE_BUILDER_COMPARISON_COLUMN_HIGHLIGHTED: 'Mettre en avant (recommandé)',
    WEBSITE_BUILDER_COMPARISON_COLUMN_CTA_LABEL: 'Bouton',
    WEBSITE_BUILDER_COMPARISON_COLUMN_CTA_PLACEHOLDER: 'Ex : Choisir',
    WEBSITE_BUILDER_COMPARISON_COLUMN_CTA_HREF: 'Lien du bouton',
    WEBSITE_BUILDER_COMPARISON_TABLE_ROWS: 'Critères',
    WEBSITE_BUILDER_COMPARISON_ROW_LABEL: 'Critère',
    WEBSITE_BUILDER_COMPARISON_ROW_LABEL_PLACEHOLDER: 'Ex : Durée, Nombre de séances',
    WEBSITE_BUILDER_COMPARISON_ROW_VALUE: 'Valeur (✓, ✗ ou texte)',
    WEBSITE_BUILDER_COMPARISON_ROW_VALUES: 'Valeurs : une par formule, dans l’ordre des colonnes',
    WEBSITE_BUILDER_COMPARISON_TABLE_RECOMMENDED: 'Recommandé',
    WEBSITE_BUILDER_COMPARISON_TABLE_YES: 'Oui',
    WEBSITE_BUILDER_COMPARISON_TABLE_NO: 'Non',
    WEBSITE_BUILDER_VARIANT_COMPARISON_TABLE_TABLE: 'Tableau',
    WEBSITE_BUILDER_VARIANT_COMPARISON_TABLE_CARDS: 'Cartes',

    // instagram feed
    WEBSITE_BUILDER_COMPONENT_INSTAGRAM_FEED: 'Feed Instagram',
    WEBSITE_BUILDER_INSTAGRAM_FEED_TITLE: 'Titre de la section',
    WEBSITE_BUILDER_INSTAGRAM_FEED_TITLE_PLACEHOLDER: 'Suivez-nous sur Instagram',
    WEBSITE_BUILDER_INSTAGRAM_FEED_HANDLE: "Nom d'utilisateur Instagram",
    WEBSITE_BUILDER_INSTAGRAM_FEED_HANDLE_PLACEHOLDER: '@mon_compte',
    WEBSITE_BUILDER_INSTAGRAM_FEED_ITEMS: 'Posts',
    WEBSITE_BUILDER_INSTAGRAM_POST_URL: 'URL du post',
    WEBSITE_BUILDER_INSTAGRAM_POST_URL_PLACEHOLDER: 'https://www.instagram.com/p/...',
    WEBSITE_BUILDER_VARIANT_INSTAGRAM_FEED_GRID: 'Grille',

    // area list — page hub /lieux
    WEBSITE_BUILDER_COMPONENT_AREA_LIST: 'Liste de zones',
    WEBSITE_BUILDER_AREA_LIST_TITLE: 'Titre de la section',
    WEBSITE_BUILDER_AREA_LIST_TITLE_PLACEHOLDER: 'Nos zones d’intervention',
    WEBSITE_BUILDER_AREA_LIST_SELECTED_AREAS: 'Zones avec une sous-page',
    WEBSITE_BUILDER_AREA_LIST_EMPTY_PREVIEW:
      'Les zones d’intervention seront listées ici une fois renseignées dans les paramètres SEO.',
    WEBSITE_BUILDER_VARIANT_AREA_LIST_GRID: 'Grille',
    WEBSITE_BUILDER_VARIANT_AREA_LIST_LIST: 'Liste',
    WEBSITE_BUILDER_ALL_AREAS: 'Toutes les zones',

    // sub-pages list — liste dynamique des sous-pages d'une page parent
    WEBSITE_BUILDER_COMPONENT_SUB_PAGES_LIST: 'Liste des sous-pages',
    WEBSITE_BUILDER_COMPONENT_DESC_SUB_PAGES_LIST:
      'Liste automatiquement les sous-pages de cette page sous forme de cartes, liste ou grille.',
    WEBSITE_BUILDER_SUB_PAGES_LIST_TITLE: 'Titre de la section',
    WEBSITE_BUILDER_SUB_PAGES_LIST_TITLE_PLACEHOLDER: 'Découvrez nos pages',
    WEBSITE_BUILDER_SUB_PAGES_LIST_EMPTY_PREVIEW:
      'Les sous-pages de cette page seront listées ici. Ajoutez des sous-pages pour les voir apparaître automatiquement.',
    WEBSITE_BUILDER_VARIANT_SUB_PAGES_LIST_CARDS: 'Cartes',
    WEBSITE_BUILDER_VARIANT_SUB_PAGES_LIST_LIST: 'Liste',
    WEBSITE_BUILDER_VARIANT_SUB_PAGES_LIST_GRID: 'Grille',
    WEBSITE_PAGE_NOT_FOUND: 'Aucune page trouvée.',

    // places page tab in builder
    WEBSITE_BUILDER_PLACES_TAB_HUB: 'Page d’accueil',
    WEBSITE_BUILDER_PLACES_TAB_AREAS: 'Pages par zone',
    WEBSITE_BUILDER_PLACES_AREA_STATUS_EDITED: 'Édité',
    WEBSITE_BUILDER_PLACES_AREA_STATUS_DRAFT_EMPTY: 'Brouillon (vide)',
    WEBSITE_BUILDER_PLACES_AREA_EDIT_BUTTON: 'Éditer',
    WEBSITE_BUILDER_PLACES_AREA_CLEAR_BUTTON: 'Supprimer le contenu',
    WEBSITE_BUILDER_PLACES_NO_AREAS_HELP:
      'Vous n’avez aucune zone d’intervention configurée. Ajoutez-en dans les paramètres SEO.',
    WEBSITE_BUILDER_PLACES_PUBLISH_WARNING_EMPTY:
      'Aucune zone n’a de contenu rédigé. La page « Lieux » sera vide à la publication.',

    // component picker — categories
    WEBSITE_BUILDER_CATEGORY_HERO: 'En-tête',
    WEBSITE_BUILDER_CATEGORY_SERVICES: 'Services',
    WEBSITE_BUILDER_CATEGORY_MARKETING: 'Marketing',
    WEBSITE_BUILDER_CATEGORY_SOCIAL_PROOF: 'Preuve sociale',
    WEBSITE_BUILDER_CATEGORY_CONTENT: 'Contenu',
    WEBSITE_BUILDER_CATEGORY_MEDIA: 'Médias',
    WEBSITE_BUILDER_CATEGORY_LISTING: 'Listes',

    // component picker — misc
    WEBSITE_BUILDER_CATEGORY_OTHER: 'Autres',
    WEBSITE_BUILDER_ADD_COMPONENT: 'Ajouter un composant',
    WEBSITE_BUILDER_CLICK_TO_EDIT: 'Cliquez pour modifier',

    // icon picker — categories
    WEBSITE_BUILDER_ICON_PICKER_PLACEHOLDER: 'Choisir une icône',
    WEBSITE_BUILDER_ICON_PICKER_SEARCH: 'Rechercher une icône...',
    WEBSITE_BUILDER_ICON_PICKER_ALL: 'Toutes',
    WEBSITE_BUILDER_ICON_PICKER_NO_RESULTS: 'Aucune icône trouvée',
    WEBSITE_BUILDER_ICON_PICKER_REMOVE: "Supprimer l'icône",
    WEBSITE_BUILDER_ICON_CATEGORY_GENERAL: 'Général',
    WEBSITE_BUILDER_ICON_CATEGORY_HEALTH: 'Santé & bien-être',
    WEBSITE_BUILDER_ICON_CATEGORY_BUSINESS: 'Business',
    WEBSITE_BUILDER_ICON_CATEGORY_COMMUNICATION: 'Communication',
    WEBSITE_BUILDER_ICON_CATEGORY_TIME: 'Temps',
    WEBSITE_BUILDER_ICON_CATEGORY_LOCATION: 'Lieu',
    WEBSITE_BUILDER_ICON_CATEGORY_CREATIVE: 'Créatif',
    WEBSITE_BUILDER_ICON_CATEGORY_EDUCATION: 'Éducation',
    WEBSITE_BUILDER_ICON_CATEGORY_FOOD: 'Restauration',
    WEBSITE_BUILDER_ICON_CATEGORY_NATURE: 'Nature',

    // component picker — default values
    WEBSITE_BUILDER_DEFAULT_HERO_SUBTITLE: 'Bienvenue',
    WEBSITE_BUILDER_DEFAULT_AREA_LIST_TITLE: "Zones d'intervention",
    WEBSITE_BUILDER_DEFAULT_SUB_PAGES_LIST_TITLE: 'À découvrir',
    WEBSITE_BUILDER_MANAGE_ZONES: 'Gérer les zones',
    WEBSITE_BUILDER_ZONES_TITLE: "Zones d'intervention",
    WEBSITE_BUILDER_ZONES_DESC: 'Choisissez une zone pour éditer sa page dédiée (ex. /lieux/lyon).',
    WEBSITE_BUILDER_ZONES_EMPTY_LIST: 'Aucune zone activée. Ajoutez vos zones dans les paramètres SEO.',
    WEBSITE_BUILDER_ZONE_HAS_CONTENT: 'Page rédigée',
    WEBSITE_BUILDER_ZONE_EMPTY: 'Pas encore de contenu',
    WEBSITE_BUILDER_AREA_DETAIL_EMPTY:
      'Cette zone n’a pas encore de contenu. Ajoutez-le depuis le panneau Pages → Gérer les zones.',
    // Badge d'un bloc hérité du gabarit sur une vue virtuelle prestation/catégorie (édition on-page)
    WEBSITE_BUILDER_INHERITED_FROM_TEMPLATE: 'Hérité du gabarit',
    WEBSITE_BUILDER_PAGE_SEO_EDIT: 'Titre & SEO',
    WEBSITE_BUILDER_PAGE_SEO_TITLE: 'Titre & SEO',
    WEBSITE_BUILDER_PAGE_SEO_EDIT_HINT: 'Modifier',
    WEBSITE_BUILDER_PAGE_SEO_MODE_LABEL: 'Personnalisation',
    WEBSITE_BUILDER_PAGE_SEO_MODE_AUTO: 'Automatique',
    WEBSITE_BUILDER_PAGE_SEO_MODE_TITLE: 'Titre',
    WEBSITE_BUILDER_PAGE_SEO_MODE_FULL: 'Complète',
    WEBSITE_BUILDER_PAGE_SEO_HEADING_LABEL: 'Titre affiché (H1)',
    WEBSITE_BUILDER_PAGE_SEO_HEADING_PLACEHOLDER: 'Ex. Coaching sportif à Lyon',
    WEBSITE_BUILDER_PAGE_SEO_META_TITLE_LABEL: 'Titre SEO',
    WEBSITE_BUILDER_PAGE_SEO_META_TITLE_PLACEHOLDER: 'Affiché sur Google',
    WEBSITE_BUILDER_PAGE_SEO_META_DESC_LABEL: 'Description SEO',
    WEBSITE_BUILDER_PAGE_SEO_META_DESC_PLACEHOLDER: 'Résumé affiché sur Google (~150 caractères)',
    WEBSITE_BUILDER_DEFAULT_TEXT_BLOCK_TITLE: 'Titre de la section',
    WEBSITE_BUILDER_DEFAULT_TEXT_BLOCK_CONTENT: 'Rédigez votre contenu ici.',
    WEBSITE_BUILDER_DEFAULT_CTA_TEXT: "Prêt à passer à l'action ?",
    WEBSITE_BUILDER_DEFAULT_CTA_LABEL: 'Prendre contact',
    WEBSITE_BUILDER_DEFAULT_FAQ_TITLE: 'Questions fréquentes',
    WEBSITE_BUILDER_DEFAULT_FAQ_Q1: 'Première question ?',
    WEBSITE_BUILDER_DEFAULT_FAQ_A1: 'Réponse à la première question.',
    WEBSITE_BUILDER_DEFAULT_FAQ_Q2: 'Deuxième question ?',
    WEBSITE_BUILDER_DEFAULT_FAQ_A2: 'Réponse à la deuxième question.',
    WEBSITE_BUILDER_DEFAULT_FAQ_Q3: 'Troisième question ?',
    WEBSITE_BUILDER_DEFAULT_FAQ_A3: 'Réponse à la troisième question.',
    WEBSITE_BUILDER_DEFAULT_TESTIMONIALS_TITLE: 'Témoignages clients',
    WEBSITE_BUILDER_DEFAULT_GOOGLE_REVIEWS_TITLE: 'Avis Google',
    WEBSITE_BUILDER_DEFAULT_TESTIMONIAL_1_TEXT: 'Un service de grande qualité, je recommande vivement !',
    WEBSITE_BUILDER_DEFAULT_TESTIMONIAL_1_AUTHOR: 'Jean D.',
    WEBSITE_BUILDER_DEFAULT_TESTIMONIAL_2_TEXT: 'Très satisfait de la prestation, résultat impeccable.',
    WEBSITE_BUILDER_DEFAULT_TESTIMONIAL_2_AUTHOR: 'Marie L.',
    WEBSITE_BUILDER_DEFAULT_KEY_FIGURES_TITLE: 'En chiffres',
    WEBSITE_BUILDER_DEFAULT_KEY_FIGURE_1_VALUE: '500+',
    WEBSITE_BUILDER_DEFAULT_KEY_FIGURE_1_LABEL: 'Clients satisfaits',
    WEBSITE_BUILDER_DEFAULT_KEY_FIGURE_2_VALUE: '98%',
    WEBSITE_BUILDER_DEFAULT_KEY_FIGURE_2_LABEL: 'Taux de satisfaction',
    WEBSITE_BUILDER_DEFAULT_KEY_FIGURE_3_VALUE: '10 ans',
    WEBSITE_BUILDER_DEFAULT_KEY_FIGURE_3_LABEL: "D'expérience",
    WEBSITE_BUILDER_DEFAULT_METHODOLOGY_TITLE: 'Comment ça se passe',
    WEBSITE_BUILDER_DEFAULT_METHODOLOGY_1_TITLE: 'Écoute',
    WEBSITE_BUILDER_DEFAULT_METHODOLOGY_1_DESC: 'Analyse de vos besoins et objectifs',
    WEBSITE_BUILDER_DEFAULT_METHODOLOGY_2_TITLE: 'Planification',
    WEBSITE_BUILDER_DEFAULT_METHODOLOGY_2_DESC: 'Élaboration du plan personnalisé',
    WEBSITE_BUILDER_DEFAULT_METHODOLOGY_3_TITLE: 'Réalisation',
    WEBSITE_BUILDER_DEFAULT_METHODOLOGY_3_DESC: 'Mise en oeuvre rigoureuse et suivi',
    WEBSITE_BUILDER_DEFAULT_GALLERY_TITLE: 'Galerie photos',
    WEBSITE_BUILDER_DEFAULT_GALLERY_CAPTION_1: 'Photo 1',
    WEBSITE_BUILDER_DEFAULT_GALLERY_CAPTION_2: 'Photo 2',
    WEBSITE_BUILDER_DEFAULT_GALLERY_CAPTION_3: 'Photo 3',
    WEBSITE_BUILDER_DEFAULT_BEFORE_AFTER_TITLE: 'Réalisations',
    WEBSITE_BUILDER_DEFAULT_BEFORE_AFTER_CAPTION_1: 'Projet 1',
    WEBSITE_BUILDER_DEFAULT_SPECIALTIES_TITLE: 'Spécialités',
    WEBSITE_BUILDER_DEFAULT_SPECIALTY_1_NAME: 'Spécialité 1',
    WEBSITE_BUILDER_DEFAULT_SPECIALTY_2_NAME: 'Spécialité 2',
    WEBSITE_BUILDER_DEFAULT_SPECIALTY_3_NAME: 'Spécialité 3',
    WEBSITE_BUILDER_DEFAULT_SPECIALTY_DESC: 'Description de la spécialité',
    WEBSITE_BUILDER_DEFAULT_PROMOTION_TITLE: 'Offre spéciale',
    WEBSITE_BUILDER_DEFAULT_PROMOTION_DESC: "Profitez de l'offre du moment",
    WEBSITE_BUILDER_DEFAULT_PROMOTION_CTA: 'En profiter',
    WEBSITE_BUILDER_DEFAULT_NEWSLETTER_TITLE: 'Restez informé',
    WEBSITE_BUILDER_DEFAULT_NEWSLETTER_DESC: "Recevez les actualités et offres exclusives de '{{pro:name}}'",
    WEBSITE_BUILDER_DEFAULT_NEWSLETTER_BUTTON: "S'abonner",
    WEBSITE_BUILDER_DEFAULT_NEWSLETTER_CONSENT:
      'En vous inscrivant, vous acceptez de recevoir des communications par email.',
    WEBSITE_BUILDER_DEFAULT_CONTACT_FORM_TITLE: 'Prendre contact',
    WEBSITE_BUILDER_DEFAULT_CONTACT_FORM_DESC:
      'Une question ? Laissez un message, une réponse vous sera apportée rapidement.',
    WEBSITE_BUILDER_DEFAULT_CONTACT_FORM_BUTTON: 'Envoyer',
    WEBSITE_BUILDER_DEFAULT_CALLBACK_REQUEST_TITLE: 'Être rappelé(e)',
    WEBSITE_BUILDER_DEFAULT_CALLBACK_REQUEST_DESC: 'Laissez vos coordonnées pour être rappelé(e) dès que possible.',
    WEBSITE_BUILDER_DEFAULT_CALLBACK_REQUEST_BUTTON: 'Être rappelé(e)',
    WEBSITE_BUILDER_DEFAULT_FORM_FIELD_NAME: 'Nom',
    WEBSITE_BUILDER_DEFAULT_FORM_FIELD_EMAIL: 'Email',
    WEBSITE_BUILDER_DEFAULT_FORM_FIELD_PHONE: 'Téléphone',
    WEBSITE_BUILDER_DEFAULT_FORM_FIELD_MESSAGE: 'Message',
    WEBSITE_BUILDER_DEFAULT_FORM_FIELD_SUBJECT: 'Objet',
    WEBSITE_BUILDER_DEFAULT_FORM_FIELD_CALLBACK_TIME: 'Moment pour être rappelé',
    WEBSITE_BUILDER_DEFAULT_CALLBACK_TIME_NO_PREF: 'Sans préférence',
    WEBSITE_BUILDER_DEFAULT_CALLBACK_TIME_MORNING1: 'Le matin avant 9h',
    WEBSITE_BUILDER_DEFAULT_CALLBACK_TIME_MORNING2: 'Entre 9h et 12h',
    WEBSITE_BUILDER_DEFAULT_CALLBACK_TIME_MIDDAY: 'Entre 12h et 14h',
    WEBSITE_BUILDER_DEFAULT_CALLBACK_TIME_AFTERNOON: 'Entre 14h et 18h',
    WEBSITE_BUILDER_DEFAULT_CALLBACK_TIME_EVENING: 'Le soir après 18h',
    WEBSITE_BUILDER_DEFAULT_FORM_CONSENT: "J'accepte d'être recontacté(e) au sujet de ma demande.",
    WEBSITE_BUILDER_DEFAULT_TEAM_TITLE: "L'équipe de '{{pro:name}}'",
    WEBSITE_BUILDER_DEFAULT_PRESTATION_HIGHLIGHT_TITLE: 'Incontournables',
    WEBSITE_BUILDER_DEFAULT_NEWS_HIGHLIGHT_TITLE: 'Nos actualités',
    WEBSITE_BUILDER_DEFAULT_PACK_LISTING_TITLE: 'Packs',
    WEBSITE_BUILDER_DEFAULT_QUOTE_TEXT: 'Un accompagnement à votre écoute et un travail de qualité, à chaque étape.',
    WEBSITE_BUILDER_DEFAULT_QUOTE_ROLE: '',
    WEBSITE_BUILDER_DEFAULT_PARTNER_LOGOS_TITLE: 'Partenaires et références',
    WEBSITE_BUILDER_DEFAULT_CERTIFICATIONS_TITLE: 'Certifications',
    WEBSITE_BUILDER_DEFAULT_CERTIFICATION_1_NAME: 'Certification qualité',
    WEBSITE_BUILDER_DEFAULT_CERTIFICATION_2_NAME: 'Label professionnel',
    WEBSITE_BUILDER_DEFAULT_INSTAGRAM_FEED_TITLE: 'À suivre sur Instagram',
    WEBSITE_BUILDER_DEFAULT_COMPARISON_TABLE_TITLE: 'Comparer les offres',
    WEBSITE_BUILDER_DEFAULT_COMPARISON_COL_1: 'Essentiel',
    WEBSITE_BUILDER_DEFAULT_COMPARISON_COL_2: 'Premium',
    WEBSITE_BUILDER_DEFAULT_COMPARISON_ROW_1_LABEL: 'Durée',
    WEBSITE_BUILDER_DEFAULT_COMPARISON_ROW_1_VAL_1: '30 min',
    WEBSITE_BUILDER_DEFAULT_COMPARISON_ROW_1_VAL_2: '60 min',
    WEBSITE_BUILDER_DEFAULT_COMPARISON_ROW_2_LABEL: 'Suivi personnalisé',
    WEBSITE_BUILDER_DEFAULT_COMPARISON_ROW_2_VAL_1: '✗',
    WEBSITE_BUILDER_DEFAULT_COMPARISON_ROW_2_VAL_2: '✓',
    WEBSITE_BUILDER_DEFAULT_TOP_HEADER_MESSAGE: 'Découvrez les prestations',
    WEBSITE_BUILDER_DEFAULT_TOP_HEADER_CTA_LABEL: 'En profiter',
    WEBSITE_BUILDER_DEFAULT_VOD_PLAYER_TITLE: "Découvrez l'univers en vidéo",
    WEBSITE_BUILDER_DEFAULT_VOD_PLAYER_DESCRIPTION: 'Présentez votre activité en vidéo.',

    // component picker — descriptions
    WEBSITE_BUILDER_COMPONENT_DESC_HEADER_HERO: 'Grande bannière visuelle en haut de page',
    WEBSITE_BUILDER_COMPONENT_DESC_PRESTATION_HIGHLIGHT: 'Mettez en avant vos prestations phares',
    WEBSITE_BUILDER_COMPONENT_DESC_BOOKING_WIDGET: 'Permettez la réservation en ligne',
    WEBSITE_BUILDER_COMPONENT_DESC_GIFT_CARD: 'Vendez cartes cadeaux et packs en ligne',
    WEBSITE_BUILDER_COMPONENT_DESC_TEXT_BLOCK: 'Bloc de texte libre et personnalisable',
    WEBSITE_BUILDER_COMPONENT_DESC_NEWSLETTER_SUBSCRIPTION: "Formulaire d'inscription à votre newsletter",
    WEBSITE_BUILDER_COMPONENT_DESC_CALL_TO_ACTION: "Bouton d'action pour inciter vos visiteurs",
    WEBSITE_BUILDER_COMPONENT_DESC_FAQ: 'Section de questions-réponses fréquentes',
    WEBSITE_BUILDER_COMPONENT_DESC_TESTIMONIALS:
      'Affichez des témoignages clients que vous saisissez vous-même (les avis Google ne sont pas encore pris en charge)',
    WEBSITE_BUILDER_COMPONENT_DESC_GOOGLE_REVIEWS:
      'Affichez automatiquement vos avis Google, synchronisés depuis votre fiche Google (plusieurs établissements possibles)',
    WEBSITE_BUILDER_COMPONENT_DESC_KEY_FIGURES: "Présentez vos chiffres clés en un coup d'oeil",
    WEBSITE_BUILDER_COMPONENT_DESC_METHODOLOGY: 'Décrivez votre processus étape par étape',
    WEBSITE_BUILDER_COMPONENT_DESC_PHOTO_GALLERY: 'Galerie de photos de vos réalisations',
    WEBSITE_BUILDER_COMPONENT_DESC_SIMPLE_PHOTO: 'Une photo seule avec légende optionnelle',
    WEBSITE_BUILDER_COMPONENT_DESC_BEFORE_AFTER: 'Comparez visuellement avant et après',
    WEBSITE_BUILDER_COMPONENT_DESC_SPECIALTIES: "Listez vos domaines d'expertise",
    WEBSITE_BUILDER_COMPONENT_DESC_PROMOTION: 'Mettez en avant une offre promotionnelle',
    WEBSITE_BUILDER_COMPONENT_DESC_PRESTATION_LISTING: 'Liste complète de vos prestations',
    WEBSITE_BUILDER_COMPONENT_DESC_NEWS_LISTING: 'Liste de vos actualités et articles',
    WEBSITE_BUILDER_COMPONENT_DESC_NEWS_HIGHLIGHT: 'Vos derniers articles, ou une sélection, sur n’importe quelle page',
    WEBSITE_BUILDER_COMPONENT_DESC_TEAM_LISTING: 'Présentez les membres de votre équipe',
    WEBSITE_BUILDER_COMPONENT_DESC_CONTACT_INFO: 'Coordonnées et formulaire de contact',
    WEBSITE_BUILDER_COMPONENT_DESC_QUOTE: 'Mettez en avant une citation inspirante',
    WEBSITE_BUILDER_COMPONENT_DESC_PARTNER_LOGOS: 'Affichez les logos de vos partenaires et clients',
    WEBSITE_BUILDER_COMPONENT_DESC_CERTIFICATIONS: 'Mettez en avant vos certifications et labels de qualité',
    WEBSITE_BUILDER_COMPONENT_DESC_COMPARISON_TABLE: 'Comparez vos offres ou formules côte à côte',
    WEBSITE_BUILDER_COMPONENT_DESC_COOKIE_POLICY_DETAILS:
      'Sections dynamiques listant les cookies selon les outils de tracking activés dans les paramètres du site',
    WEBSITE_BUILDER_COMPONENT_DESC_INSTAGRAM_FEED: 'Affichez vos derniers posts Instagram',

    WEBSITE_BUILDER_DETAIL_TEMPLATE: 'Page détail prestation',

    WEBSITE_BUILDER_SHARED_COMPONENT_LABEL: 'Partagé entre les pages',

    WEBSITE_BUILDER_INSPECTOR_TITLE: 'Configuration',
    EMAIL_BUILDER_TEMPLATES: 'Modèles',
    EMAIL_BUILDER_CHOOSE_TEMPLATE: 'Choisir un modèle',
    // Noms et descriptions des modèles de campagne (clés dérivées de l'id, cf. `emailTemplateTranslationKey`).
    EMAIL_TEMPLATE_EMAIL_SIMPLE_NAME: 'Email simple',
    EMAIL_TEMPLATE_EMAIL_SIMPLE_LABEL: 'Un message personnel, sans image : direct et efficace',
    EMAIL_TEMPLATE_RDV_EN_LIGNE_NAME: 'Réservation en ligne',
    EMAIL_TEMPLATE_RDV_EN_LIGNE_LABEL: 'Annoncez la prise de rendez-vous en ligne 24h/24',
    EMAIL_TEMPLATE_CRENEAUX_DISPONIBLES_NAME: 'Créneaux disponibles',
    EMAIL_TEMPLATE_CRENEAUX_DISPONIBLES_LABEL: 'Des places se sont libérées cette semaine : remplissez votre planning',
    EMAIL_TEMPLATE_RDV_EN_LIGNE_PAS_A_PAS_NAME: 'Réserver en 3 étapes',
    EMAIL_TEMPLATE_RDV_EN_LIGNE_PAS_A_PAS_LABEL: 'La réservation en ligne expliquée en 3 images',
    EMAIL_TEMPLATE_NEWSLETTER_NAME: 'Newsletter',
    EMAIL_TEMPLATE_NEWSLETTER_LABEL: 'Structure complète pour vos nouvelles régulières',
    EMAIL_TEMPLATE_NEWSLETTER_MAGAZINE_NAME: 'Le Mag',
    EMAIL_TEMPLATE_NEWSLETTER_MAGAZINE_LABEL:
      'Grande couverture, sommaire, 3 rubriques en zigzag : la newsletter magazine',
    EMAIL_TEMPLATE_NEWSLETTER_EDITO_NAME: 'L’Édito',
    EMAIL_TEMPLATE_NEWSLETTER_EDITO_LABEL: 'Un mot personnel en ouverture, puis l’actualité en images',
    EMAIL_TEMPLATE_NEWSLETTER_3_ACTUS_NAME: '3 actus',
    EMAIL_TEMPLATE_NEWSLETTER_3_ACTUS_LABEL: 'Trois nouvelles en zigzag, chacune avec sa photo et son lien',
    EMAIL_TEMPLATE_NEWSLETTER_SAISON_NAME: 'Newsletter de saison',
    EMAIL_TEMPLATE_NEWSLETTER_SAISON_LABEL: 'Grand visuel de saison, conseil, offre et prestation phare',
    EMAIL_TEMPLATE_NEWSLETTER_BIEN_ETRE_NAME: 'Lettre bien-être',
    EMAIL_TEMPLATE_NEWSLETTER_BIEN_ETRE_LABEL: 'Douce et aérée : un rituel, une respiration, une invitation',
    EMAIL_TEMPLATE_NEWSLETTER_COULISSES_NAME: 'Les coulisses',
    EMAIL_TEMPLATE_NEWSLETTER_COULISSES_LABEL: 'Fond sombre et photos : ce qui se passe derrière la porte',
    EMAIL_TEMPLATE_BIENVENUE_NAME: 'Bienvenue',
    EMAIL_TEMPLATE_BIENVENUE_LABEL: 'Souhaitez la bienvenue à vos nouveaux clients',
    EMAIL_TEMPLATE_FIDELISATION_NAME: 'Vous nous manquez',
    EMAIL_TEMPLATE_FIDELISATION_LABEL: 'Réveillez les clients que vous n’avez pas vus depuis un moment',
    EMAIL_TEMPLATE_MERCI_CONFIANCE_NAME: 'Merci pour votre confiance',
    EMAIL_TEMPLATE_MERCI_CONFIANCE_LABEL: 'Un message sincère de remerciement à vos clients fidèles',
    EMAIL_TEMPLATE_AVIS_GOOGLE_NAME: 'Votre avis compte',
    EMAIL_TEMPLATE_AVIS_GOOGLE_LABEL: 'Demandez un avis en ligne à vos clients satisfaits',
    EMAIL_TEMPLATE_PARRAINAGE_NAME: 'Parrainage',
    EMAIL_TEMPLATE_PARRAINAGE_LABEL: 'Transformez vos clients en ambassadeurs',
    EMAIL_TEMPLATE_ANNIVERSAIRE_CLIENT_NAME: 'Joyeux anniversaire',
    EMAIL_TEMPLATE_ANNIVERSAIRE_CLIENT_LABEL: 'Une attention le jour de l’anniversaire de vos clients',
    EMAIL_TEMPLATE_VOUS_NOUS_MANQUEZ_PHOTO_NAME: 'Vous nous manquez (en images)',
    EMAIL_TEMPLATE_VOUS_NOUS_MANQUEZ_PHOTO_LABEL: 'Photo du lieu à côté du mot, et l’attention présentée comme un bon',
    EMAIL_TEMPLATE_PARRAINAGE_DUO_NAME: 'Parrainage en images',
    EMAIL_TEMPLATE_PARRAINAGE_DUO_LABEL: 'Parrain et filleul côte à côte, chacun son avantage',
    EMAIL_TEMPLATE_PROMOTION_NAME: 'Offre spéciale',
    EMAIL_TEMPLATE_PROMOTION_LABEL: 'Mettez en avant une remise ou une offre limitée',
    EMAIL_TEMPLATE_VENTES_FLASH_NAME: 'Vente flash',
    EMAIL_TEMPLATE_VENTES_FLASH_LABEL: 'Une promotion très courte pour créer l’urgence',
    EMAIL_TEMPLATE_OFFRE_DECOUVERTE_NAME: 'Offre découverte',
    EMAIL_TEMPLATE_OFFRE_DECOUVERTE_LABEL: 'Donnez envie aux nouveaux clients de franchir la porte',
    EMAIL_TEMPLATE_HEURES_CREUSES_NAME: 'Heures creuses',
    EMAIL_TEMPLATE_HEURES_CREUSES_LABEL: 'Remplissez vos créneaux calmes avec un petit avantage',
    EMAIL_TEMPLATE_PRESTATION_A_LA_UNE_NAME: 'Prestation à la une',
    EMAIL_TEMPLATE_PRESTATION_A_LA_UNE_LABEL: 'Mettez une prestation en vedette, avec prix et bouton Réserver',
    EMAIL_TEMPLATE_TOP_PRESTATIONS_NAME: 'Top 3 des prestations',
    EMAIL_TEMPLATE_TOP_PRESTATIONS_LABEL: 'Vos 3 prestations phares, avec prix, durée et bouton Réserver',
    EMAIL_TEMPLATE_COUPON_BIENVENUE_NAME: 'Coupon de bienvenue',
    EMAIL_TEMPLATE_COUPON_BIENVENUE_LABEL: 'Un code promo présenté comme un vrai bon de réduction',
    EMAIL_TEMPLATE_BLACK_FRIDAY_NAME: 'Black Friday',
    EMAIL_TEMPLATE_BLACK_FRIDAY_LABEL: 'Votre offre Black Friday, prête à partir',
    EMAIL_TEMPLATE_PROMO_MAGAZINE_NAME: 'Promo magazine',
    EMAIL_TEMPLATE_PROMO_MAGAZINE_LABEL: 'Couverture, deux offres illustrées côte à côte, bouton par offre',
    EMAIL_TEMPLATE_FORFAITS_NAME: 'Nos forfaits',
    EMAIL_TEMPLATE_FORFAITS_LABEL: 'Trois fiches forfaits avec prix, chacune son bouton',
    EMAIL_TEMPLATE_OFFRE_DUO_NAME: 'Offre duo',
    EMAIL_TEMPLATE_OFFRE_DUO_LABEL: 'Venez à deux : photo, offre encadrée, bouton',
    EMAIL_TEMPLATE_SERVICES_PROPOSES_NAME: 'Nos services',
    EMAIL_TEMPLATE_SERVICES_PROPOSES_LABEL: 'Présentez l’ensemble de ce que vous proposez',
    EMAIL_TEMPLATE_NOUVEAUX_SERVICES_NAME: 'Nouveauté',
    EMAIL_TEMPLATE_NOUVEAUX_SERVICES_LABEL: 'Annoncez une nouvelle prestation',
    EMAIL_TEMPLATE_NOUVEAUX_HORAIRES_NAME: 'Nouveaux horaires',
    EMAIL_TEMPLATE_NOUVEAUX_HORAIRES_LABEL: 'Informez vos clients d’un changement d’horaires',
    EMAIL_TEMPLATE_CONGES_FERMETURE_NAME: 'Congés / fermeture',
    EMAIL_TEMPLATE_CONGES_FERMETURE_LABEL: 'Prévenez d’une fermeture et invitez à réserver avant ou après',
    EMAIL_TEMPLATE_DEMENAGEMENT_NAME: 'Nouvelle adresse',
    EMAIL_TEMPLATE_DEMENAGEMENT_LABEL: 'Annoncez un déménagement ou un nouveau local',
    EMAIL_TEMPLATE_NOUVELLE_RECRUE_NAME: 'Nouveau membre de l’équipe',
    EMAIL_TEMPLATE_NOUVELLE_RECRUE_LABEL: 'Présentez une nouvelle personne dans l’équipe',
    EMAIL_TEMPLATE_EVENEMENT_ATELIER_NAME: 'Événement / atelier',
    EMAIL_TEMPLATE_EVENEMENT_ATELIER_LABEL: 'Invitez vos clients à un événement, un atelier, des portes ouvertes',
    EMAIL_TEMPLATE_NOUVEAUX_PRODUITS_NAME: 'Nouveautés en boutique',
    EMAIL_TEMPLATE_NOUVEAUX_PRODUITS_LABEL: 'Présentez de nouveaux produits en vente chez vous',
    EMAIL_TEMPLATE_NOUVEAUTE_EN_IMAGES_NAME: 'Nouveauté en images',
    EMAIL_TEMPLATE_NOUVEAUTE_EN_IMAGES_LABEL: 'La nouveauté racontée en 2 images, puis la fiche prestation',
    EMAIL_TEMPLATE_EQUIPE_EN_PHOTOS_NAME: 'L’équipe en photos',
    EMAIL_TEMPLATE_EQUIPE_EN_PHOTOS_LABEL: 'Présentez chaque membre avec sa photo et sa spécialité',
    EMAIL_TEMPLATE_AVANT_APRES_NAME: 'Avant / après',
    EMAIL_TEMPLATE_AVANT_APRES_LABEL: 'Deux photos côte à côte pour montrer le résultat',
    EMAIL_TEMPLATE_VOEUX_NOUVELLE_ANNEE_NAME: 'Bonne année',
    EMAIL_TEMPLATE_VOEUX_NOUVELLE_ANNEE_LABEL: 'Vos vœux de nouvelle année, chaleureux et sans vente',
    EMAIL_TEMPLATE_SAINT_VALENTIN_NAME: 'Saint-Valentin',
    EMAIL_TEMPLATE_SAINT_VALENTIN_LABEL: 'Une offre ou une attention pour la fête des amoureux',
    EMAIL_TEMPLATE_PRINTEMPS_NAME: 'Printemps',
    EMAIL_TEMPLATE_PRINTEMPS_LABEL: 'Le retour des beaux jours : une bonne raison de prendre soin de soi',
    EMAIL_TEMPLATE_FETE_DES_MERES_NAME: 'Fête des mères',
    EMAIL_TEMPLATE_FETE_DES_MERES_LABEL: 'Une idée cadeau toute trouvée pour la fête des mères',
    EMAIL_TEMPLATE_FETE_DES_PERES_NAME: 'Fête des pères',
    EMAIL_TEMPLATE_FETE_DES_PERES_LABEL: 'Une idée cadeau pour la fête des pères',
    EMAIL_TEMPLATE_ETE_VACANCES_NAME: 'Avant l’été',
    EMAIL_TEMPLATE_ETE_VACANCES_LABEL: 'Préparez l’été avec vos clients (et remplissez juin)',
    EMAIL_TEMPLATE_RENTREE_NAME: 'Rentrée',
    EMAIL_TEMPLATE_RENTREE_LABEL: 'Relancez vos clients à la rentrée',
    EMAIL_TEMPLATE_FETES_FIN_ANNEE_NAME: 'Fêtes de fin d’année',
    EMAIL_TEMPLATE_FETES_FIN_ANNEE_LABEL: 'Invitez à réserver avant les fêtes, quand les plannings se remplissent',
    EMAIL_TEMPLATE_NOEL_MAGAZINE_NAME: 'Noël magazine',
    EMAIL_TEMPLATE_NOEL_MAGAZINE_LABEL: 'Couverture de Noël, idées cadeaux côte à côte, offre et carte cadeau',
    EMAIL_TEMPLATE_ETE_MAGAZINE_NAME: 'Été magazine',
    EMAIL_TEMPLATE_ETE_MAGAZINE_LABEL: 'Visuel solaire, conseils d’été en images, horaires d’été',
    EMAIL_TEMPLATE_SAINT_VALENTIN_DUO_NAME: 'Saint-Valentin en images',
    EMAIL_TEMPLATE_SAINT_VALENTIN_DUO_LABEL: 'Pour elle, pour lui : deux idées illustrées côte à côte',
    EMAIL_TEMPLATE_CARTE_CADEAU_GENERIQUE_NAME: 'Offrez un moment',
    EMAIL_TEMPLATE_CARTE_CADEAU_GENERIQUE_LABEL: 'Faites connaître vos cartes cadeaux, toute l’année',
    EMAIL_TEMPLATE_CARTE_CADEAU_NOEL_NAME: 'Carte cadeau de Noël',
    EMAIL_TEMPLATE_CARTE_CADEAU_NOEL_LABEL: 'Vendez des cartes cadeaux pour Noël',
    EMAIL_TEMPLATE_CARTE_CADEAU_FETE_DES_MERES_NAME: 'Carte cadeau fête des mères',
    EMAIL_TEMPLATE_CARTE_CADEAU_FETE_DES_MERES_LABEL: 'Une carte cadeau pour la fête des mères',
    EMAIL_TEMPLATE_CARTE_CADEAU_SAINT_VALENTIN_NAME: 'Carte cadeau Saint-Valentin',
    EMAIL_TEMPLATE_CARTE_CADEAU_SAINT_VALENTIN_LABEL: 'Une carte cadeau pour la Saint-Valentin',
    EMAIL_TEMPLATE_CARTE_CADEAU_DERNIERE_MINUTE_NAME: 'Cadeau de dernière minute',
    EMAIL_TEMPLATE_CARTE_CADEAU_DERNIERE_MINUTE_LABEL: 'Pour les retardataires : la carte cadeau arrive par email',
    EMAIL_TEMPLATE_CARTE_CADEAU_MODE_EMPLOI_NAME: 'Carte cadeau, mode d’emploi',
    EMAIL_TEMPLATE_CARTE_CADEAU_MODE_EMPLOI_LABEL: 'Comment offrir en 3 images : choisir, personnaliser, envoyer',
    EMAIL_TEMPLATE_CATEGORY_ESSENTIELS: 'Essentiels',
    EMAIL_TEMPLATE_CATEGORY_ESSENTIELS_DESC: 'Les basiques à avoir sous la main toute l’année.',
    EMAIL_TEMPLATE_CATEGORY_NEWSLETTERS: 'Newsletters',
    EMAIL_TEMPLATE_CATEGORY_NEWSLETTERS_DESC: 'Des formats magazine, riches en images, pour vos nouvelles régulières.',
    EMAIL_TEMPLATE_CATEGORY_FIDELISATION: 'Fidélisation & relation',
    EMAIL_TEMPLATE_CATEGORY_FIDELISATION_DESC: 'Garder le lien, remercier, faire revenir.',
    EMAIL_TEMPLATE_CATEGORY_PROMOTIONS: 'Promotions & offres',
    EMAIL_TEMPLATE_CATEGORY_PROMOTIONS_DESC: 'Remplir le planning avec une offre claire.',
    EMAIL_TEMPLATE_CATEGORY_ACTUALITES: 'Actualités de l’établissement',
    EMAIL_TEMPLATE_CATEGORY_ACTUALITES_DESC: 'Horaires, congés, équipe, nouveautés, événements.',
    EMAIL_TEMPLATE_CATEGORY_SAISONNIER: 'Saisonnier & fêtes',
    EMAIL_TEMPLATE_CATEGORY_SAISONNIER_DESC: 'Un email prêt pour chaque temps fort du calendrier.',
    EMAIL_TEMPLATE_CATEGORY_CARTES_CADEAUX: 'Cartes cadeaux',
    EMAIL_TEMPLATE_CATEGORY_CARTES_CADEAUX_DESC: 'Faire connaître et vendre vos cartes cadeaux.',
    EMAIL_BUILDER_INSPECTOR_EMPTY: 'Cliquez sur un élément de votre email pour le modifier',
    EMAIL_BUILDER_PREVIEW_CUSTOMER: 'Prévisualiser avec un client',
    EMAIL_BUILDER_PREVIEW_SEARCH: 'Rechercher un client pour l’aperçu',
    EMAIL_BUILDER_PREVIEW_EMPTY: 'Aucun client trouvé',
    EMAIL_BUILDER_PREVIEW_HELP:
      'Cet aperçu ne change pas les destinataires et n’envoie aucun email. Une information personnalisée absente ou archivée est remplacée par du vide à l’envoi.',
    EMAIL_BUILDER_PREVIEW_EXAMPLE:
      'Sans client sélectionné, les noms et les champs entre guillemets sont des exemples.',
    EMAIL_BUILDER_PREVIEW_LOADING: 'Chargement de l’aperçu du client…',
    EMAIL_BUILDER_PREVIEW_ERROR: 'Impossible de charger ce client. L’aperçu utilise des exemples ; réessayez.',
    EMAIL_BUILDER_PREVIEW_SUBJECT: 'Aperçu de l’objet : {subject}',
    WEBSITE_BUILDER_INSPECTOR_EMPTY: 'Cliquez sur un élément de votre site pour le modifier',
    WEBSITE_BUILDER_INSPECTOR_EDIT_PRESTATION: 'Modifier la prestation',
    WEBSITE_BUILDER_INSPECTOR_EDIT_CATEGORY: 'Modifier la catégorie',
    WEBSITE_BUILDER_INSPECTOR_EDIT_ARTICLE: "Modifier l'article",
    WEBSITE_BUILDER_INSPECTOR_TEAM_HINT:
      "Les photos, descriptions et expertises affichées ici proviennent de la fiche de chaque membre de votre équipe. Elles ne se modifient pas depuis l'éditeur du site.",
    WEBSITE_BUILDER_INSPECTOR_MANAGE_TEAM: 'Gérer les membres de mon équipe',

    WEBSITE_BUILDER_BINDING_LINKED_TO: 'Lié à :',
    WEBSITE_BUILDER_BINDING_UNLINK: 'Dissocier',
    WEBSITE_BUILDER_BINDING_PICTURES_ORDER_HINT: "L'ordre des photos se règle depuis Entreprise > Photos & Logo.",
    WEBSITE_BUILDER_BINDING_LINK: 'Lier à une donnée',

    BINDING_PRO_NAME: 'Nom du professionnel',
    BINDING_PRO_DESCRIPTION: 'Présentation du professionnel',
    BINDING_PRO_PHONE: 'Téléphone',
    BINDING_PRO_EMAIL: 'Email de contact',
    BINDING_PRO_FULL_ADDRESS: 'Adresse complète',
    BINDING_PRO_CITY: 'Ville',
    BINDING_PRO_ZIP: 'Code postal',
    BINDING_PRO_BOOKING: 'Page de réservation',
    BINDING_PRO_GIFT_CARD: 'Page d’achat de carte cadeau',
    BINDING_PRO_GOOGLE_REVIEW: 'Lien « écrire un avis » Google',
    BINDING_GROUP_BOOKING: 'Réservation',
    BINDING_GROUP_GENERAL: 'Général',
    BINDING_GROUP_CONTACT: 'Contact',
    BINDING_GROUP_ADDRESS: 'Adresse',
    BINDING_PRO_LOGO: 'Logo',
    BINDING_PRO_PICTURES: "Photos de l'établissement",
    BINDING_PRO_FIRST_PICTURE: "1ʳᵉ photo de l'établissement",
    BINDING_GROUP_MEDIA: 'Médias',
    BINDING_GROUP_PAGES: 'Pages du site',
    BINDING_GROUP_CATEGORIES: 'Catégories',
    BINDING_GROUP_PRESTATIONS: 'Prestations',
    BINDING_GROUP_NEWS: 'Articles',
    WEBSITE_BUILDER_LINK_SELECTOR_PLACEHOLDER: 'Sélectionner un lien interne',
    RICH_TEXT_LINK_BINDING: 'Variable dynamique',
    RICH_TEXT_FULLSCREEN_TITLE: 'Éditeur en plein écran',
    RICH_TEXT_LINK_INTERNAL_PAGE: 'Page du site',
    RICH_TEXT_ALIGN_LEFT: 'Aligner à gauche',
    RICH_TEXT_ALIGN_CENTER: 'Centrer',
    RICH_TEXT_ALIGN_RIGHT: 'Aligner à droite',

    // ─── Email Builder — Component labels ─────────────────────────────
    EMAIL_BUILDER_COMPONENT_HEADER: 'En-tête',
    EMAIL_BUILDER_COMPONENT_TWO_COLUMNS: 'Deux colonnes',
    EMAIL_BUILDER_COMPONENT_TEXT: 'Texte',
    EMAIL_BUILDER_COMPONENT_BUTTON: 'Bouton',
    EMAIL_BUILDER_COMPONENT_IMAGE: 'Image',
    EMAIL_BUILDER_COMPONENT_DIVIDER: 'Séparateur',
    EMAIL_BUILDER_COMPONENT_SOCIAL: 'Réseaux sociaux',
    EMAIL_BUILDER_COMPONENT_PRESTATION: 'Prestation',
    EMAIL_BUILDER_COMPONENT_FOOTER: 'Pied de page',
    EMAIL_BUILDER_COMPONENT_QR: 'QR code',
    EMAIL_BUILDER_COMPONENT_HERO: 'Bandeau de couverture',
    EMAIL_BUILDER_COMPONENT_THREE_COLUMNS: 'Trois colonnes',
    EMAIL_BUILDER_COMPONENT_STAT: 'Chiffre clé',
    EMAIL_BUILDER_COMPONENT_DEADLINE: 'Date limite',
    EMAIL_BUILDER_COMPONENT_PROMO_CODE: 'Code promo',

    // ─── Email Builder — Variant labels ───────────────────────────────
    EMAIL_BUILDER_VARIANT_LOGO_LEFT: 'Logo à gauche',
    EMAIL_BUILDER_VARIANT_LOGO_CENTER: 'Logo centré',
    EMAIL_BUILDER_VARIANT_IMAGE_LEFT: 'Image à gauche',
    EMAIL_BUILDER_VARIANT_IMAGE_RIGHT: 'Image à droite',
    EMAIL_BUILDER_VARIANT_DEFAULT: 'Par défaut',
    EMAIL_BUILDER_VARIANT_CALLOUT: 'Encadré',
    EMAIL_BUILDER_VARIANT_FRAMED: 'Cadre',
    EMAIL_BUILDER_VARIANT_FULL_WIDTH: 'Pleine largeur',
    EMAIL_BUILDER_VARIANT_LEFT: 'Aligné à gauche',
    EMAIL_BUILDER_VARIANT_CENTER: 'Centré',
    EMAIL_BUILDER_VARIANT_RIGHT: 'Aligné à droite',
    EMAIL_BUILDER_VARIANT_CENTERED: 'Centré',
    EMAIL_BUILDER_VARIANT_LINE: 'Ligne',
    EMAIL_BUILDER_VARIANT_SPACE: 'Espace',
    EMAIL_BUILDER_VARIANT_SIMPLE: 'Simple',
    EMAIL_BUILDER_VARIANT_FILLED: 'Rempli',
    EMAIL_BUILDER_VARIANT_CARD: 'Carte',
    EMAIL_BUILDER_VARIANT_INLINE: 'En ligne',
    EMAIL_BUILDER_VARIANT_COMPLET: 'Complet',
    EMAIL_BUILDER_VARIANT_TRANSACTIONAL: 'Transactionnel',
    EMAIL_BUILDER_VARIANT_TALL: 'Haut',
    EMAIL_BUILDER_VARIANT_COMPACT: 'Compact',
    EMAIL_BUILDER_VARIANT_IMAGES: 'Avec images',
    EMAIL_BUILDER_VARIANT_TEXT_ONLY: 'Texte seul',
    EMAIL_BUILDER_VARIANT_SINGLE: 'Un chiffre',
    EMAIL_BUILDER_VARIANT_ROW: 'Trois chiffres',
    EMAIL_BUILDER_VARIANT_BANNER: 'Bandeau plein',
    EMAIL_BUILDER_VARIANT_OUTLINE: 'Contour',

    // ─── Email Builder — Page chrome ──────────────────────────────────
    EMAIL_BUILDER_TITLE: 'Email Builder',
    EMAIL_BUILDER_DESC: 'Éditeur de contenu email',
    EMAIL_BUILDER_LOADING: 'Chargement du builder email…',
    EMAIL_BUILDER_LABEL_FROM: 'De',
    EMAIL_BUILDER_LABEL_TO: 'À',
    EMAIL_BUILDER_SENDER_ADDRESS_LABEL: 'Adresse d’expédition',
    EMAIL_BUILDER_SENDER_ADDRESS_HINT: 'Commune à toutes vos campagnes : adresse {brand} ou votre propre domaine.',
    EMAIL_BUILDER_SENDER_ADDRESS_SETTINGS_LINK: 'Changer l’adresse d’expédition',

    // ─── Email Builder — Field labels ─────────────────────────────────
    EMAIL_BUILDER_HEADER_LOGO: 'Logo',
    EMAIL_BUILDER_HEADER_LOGO_ALT: 'Texte alternatif du logo',
    EMAIL_BUILDER_HEADER_LOGO_ALT_PLACEHOLDER: 'Ex. : Logo de mon entreprise',
    EMAIL_BUILDER_HEADER_LOGO_SIZE: 'Taille du logo',
    EMAIL_BUILDER_HEADER_LOGO_SIZE_SMALL: 'Petit',
    EMAIL_BUILDER_HEADER_LOGO_SIZE_MEDIUM: 'Moyen',
    EMAIL_BUILDER_HEADER_LOGO_SIZE_LARGE: 'Grand',
    EMAIL_BUILDER_TWO_COLUMNS_IMAGE: 'Image',
    EMAIL_BUILDER_TWO_COLUMNS_IMAGE_ALT: 'Texte alternatif',
    EMAIL_BUILDER_TWO_COLUMNS_IMAGE_ALT_PLACEHOLDER: "Description de l'image",
    EMAIL_BUILDER_TWO_COLUMNS_TEXT: 'Texte',
    EMAIL_BUILDER_TWO_COLUMNS_TEXT_PLACEHOLDER: 'Saisissez votre texte ici...',
    EMAIL_BUILDER_TEXT_CONTENT: 'Contenu',
    EMAIL_BUILDER_TEXT_CONTENT_PLACEHOLDER: 'Saisissez votre texte ici...',
    EMAIL_BUILDER_BUTTON_LABEL: 'Texte du bouton',
    EMAIL_BUILDER_BUTTON_LABEL_PLACEHOLDER: 'Ex. : Prendre rendez-vous',
    EMAIL_BUILDER_BUTTON_URL: 'Lien du bouton',
    EMAIL_BUILDER_BUTTON_URL_PLACEHOLDER: 'https://...',
    EMAIL_BUILDER_IMAGE_URL: "URL de l'image",
    EMAIL_BUILDER_IMAGE_ALT: 'Texte alternatif',
    EMAIL_BUILDER_IMAGE_ALT_PLACEHOLDER: "Description de l'image",
    EMAIL_BUILDER_IMAGE_LINK: 'Lien au clic',
    EMAIL_BUILDER_DIVIDER_COLOR: 'Couleur du séparateur',
    EMAIL_BUILDER_PRESTATION_ID: 'Prestation',
    EMAIL_BUILDER_PRESTATION_SHOW_PRICE: 'Afficher le prix',
    EMAIL_BUILDER_PRESTATION_SHOW_DURATION: 'Afficher la durée',
    EMAIL_BUILDER_PRESTATION_CTA_LABEL: 'Texte du bouton',
    EMAIL_BUILDER_PRESTATION_CTA_URL: 'Lien du bouton',
    EMAIL_BUILDER_FOOTER_COMPANY_NAME: "Nom de l'entreprise",
    EMAIL_BUILDER_FOOTER_ADDRESS: 'Adresse',
    EMAIL_BUILDER_FOOTER_UNSUBSCRIBE_LABEL: 'Texte de désinscription',
    EMAIL_BUILDER_HERO_IMAGE: 'Image de fond',
    EMAIL_BUILDER_HERO_TITLE: 'Titre',
    EMAIL_BUILDER_HERO_TITLE_PLACEHOLDER: 'Ex. : Nos nouveautés de printemps',
    EMAIL_BUILDER_HERO_SUBTITLE: 'Sous-titre',
    EMAIL_BUILDER_HERO_SUBTITLE_PLACEHOLDER: 'Une phrase pour accompagner le titre',
    EMAIL_BUILDER_COLUMN_1_IMAGE: 'Image de la colonne 1',
    EMAIL_BUILDER_COLUMN_1_TITLE: 'Titre de la colonne 1',
    EMAIL_BUILDER_COLUMN_1_TEXT: 'Texte de la colonne 1',
    EMAIL_BUILDER_COLUMN_2_IMAGE: 'Image de la colonne 2',
    EMAIL_BUILDER_COLUMN_2_TITLE: 'Titre de la colonne 2',
    EMAIL_BUILDER_COLUMN_2_TEXT: 'Texte de la colonne 2',
    EMAIL_BUILDER_COLUMN_3_IMAGE: 'Image de la colonne 3',
    EMAIL_BUILDER_COLUMN_3_TITLE: 'Titre de la colonne 3',
    EMAIL_BUILDER_COLUMN_3_TEXT: 'Texte de la colonne 3',
    EMAIL_BUILDER_COLUMN_TITLE_PLACEHOLDER: 'Ex. : Étape 1',
    EMAIL_BUILDER_COLUMN_TEXT_PLACEHOLDER: 'Une ligne pour la décrire',
    EMAIL_BUILDER_STAT_VALUE_1: 'Chiffre 1',
    EMAIL_BUILDER_STAT_LABEL_1: 'Légende 1',
    EMAIL_BUILDER_STAT_VALUE_2: 'Chiffre 2',
    EMAIL_BUILDER_STAT_LABEL_2: 'Légende 2',
    EMAIL_BUILDER_STAT_VALUE_3: 'Chiffre 3',
    EMAIL_BUILDER_STAT_LABEL_3: 'Légende 3',
    EMAIL_BUILDER_STAT_VALUE_PLACEHOLDER: 'Ex. : -20 %',
    EMAIL_BUILDER_STAT_LABEL_PLACEHOLDER: 'Ex. : sur votre prochain rendez-vous',
    EMAIL_BUILDER_DEADLINE_LABEL: 'Mention',
    EMAIL_BUILDER_DEADLINE_LABEL_PLACEHOLDER: 'Ex. : Jusqu’au',
    EMAIL_BUILDER_DEADLINE_DATE: 'Date limite',
    EMAIL_BUILDER_DEADLINE_DATE_PLACEHOLDER: 'Ex. : 31 décembre',
    EMAIL_BUILDER_DEADLINE_NOTE: 'Précision',
    EMAIL_BUILDER_DEADLINE_NOTE_PLACEHOLDER: 'Ex. : sur présentation de cet email',
    EMAIL_BUILDER_PROMO_CODE_TITLE: 'Titre',
    EMAIL_BUILDER_PROMO_CODE_TITLE_PLACEHOLDER: 'Ex. : Votre code promo',
    EMAIL_BUILDER_PROMO_CODE_CODE: 'Code',
    EMAIL_BUILDER_PROMO_CODE_CODE_PLACEHOLDER: 'Ex. : NOEL15',
    EMAIL_BUILDER_PROMO_CODE_NOTE: 'Précision',
    EMAIL_BUILDER_PROMO_CODE_NOTE_PLACEHOLDER: 'Ex. : valable sur toutes les prestations',
    EMAIL_BUILDER_PROMO_CODE_CTA_LABEL: 'Texte du bouton',
    EMAIL_BUILDER_PROMO_CODE_CTA_LABEL_PLACEHOLDER: 'Ex. : Réserver',
    EMAIL_BUILDER_PROMO_CODE_CTA_URL: 'Lien du bouton (le code y est ajouté)',

    // ─── Email Builder — Empty block placeholders (builder only) ──────
    EMAIL_BUILDER_PLACEHOLDER_HEADER: 'Ajoutez votre logo',
    EMAIL_BUILDER_PLACEHOLDER_IMAGE: 'Ajoutez une image',
    EMAIL_BUILDER_PLACEHOLDER_TEXT: 'Ajoutez votre texte',
    EMAIL_BUILDER_PLACEHOLDER_BUTTON: 'Configurez votre bouton',
    EMAIL_BUILDER_PLACEHOLDER_TWO_COLUMNS: 'Ajoutez une image et un texte',
    EMAIL_BUILDER_PLACEHOLDER_PRESTATION: 'Sélectionnez une prestation',
    EMAIL_BUILDER_PLACEHOLDER_SOCIAL: 'Ajoutez vos réseaux sociaux',
    EMAIL_BUILDER_PLACEHOLDER_HERO: 'Ajoutez une image et un titre',
    EMAIL_BUILDER_PLACEHOLDER_THREE_COLUMNS: 'Remplissez vos trois colonnes',
    EMAIL_BUILDER_PLACEHOLDER_STAT: 'Saisissez votre chiffre clé',
    EMAIL_BUILDER_PLACEHOLDER_DEADLINE: 'Indiquez la date limite',
    EMAIL_BUILDER_PLACEHOLDER_PROMO_CODE: 'Choisissez la promotion de la campagne',
    EMAIL_BUILDER_MANAGE_SOCIAL: 'Gérer mes réseaux sociaux',
    EMAIL_BUILDER_LINK_NOTICE_TITLE: 'Lien de l’email',
    EMAIL_BUILDER_LINK_NOTICE_OPEN: 'Cette page sera ouverte :',
    EMAIL_BUILDER_LINK_NOTICE_EMPTY: 'Ce lien n’a pas encore d’URL. Modifiez le bloc pour en ajouter une.',
    EMAIL_BUILDER_LINK_NOTICE_CTA: 'Ouvrir le lien',

    // ─── Email Builder — Binding labels ───────────────────────────────
    BINDING_CUSTOMER_FIRST_NAME: 'Prénom du client',
    BINDING_CUSTOMER_LAST_NAME: 'Nom du client',
    BINDING_CUSTOMER_PROMO_CODE: 'Code promo du client',
    BINDING_GROUP_CUSTOMER: 'Client',
    BINDING_PROMO_CODE: 'Code de la promotion',
    BINDING_PROMO_LABEL: 'Libellé de la promotion',
    BINDING_PROMO_VALUE: 'Remise de la promotion',
    BINDING_PROMO_ENDS_AT: 'Fin de la promotion',
    BINDING_GROUP_PROMOTION: 'Promotion',
    // Valeurs d'exemple de l'aperçu tant qu'aucune promotion n'est choisie.
    BINDING_PROMO_SAMPLE_CODE: 'NOEL15',
    BINDING_PROMO_SAMPLE_LABEL: 'Black Week',
    BINDING_PROMO_SAMPLE_VALUE: '−20 %',
    BINDING_PROMO_SAMPLE_ENDS_AT: '30 novembre',
    // Constructeur d'email du CRM (campagnes Propelsia) : variables du destinataire et de la marque.
    BINDING_CRM_RECIPIENT_FIRST_NAME: 'Prénom',
    BINDING_CRM_RECIPIENT_LAST_NAME: 'Nom',
    BINDING_CRM_RECIPIENT_BUSINESS_NAME: 'Nom du commerce',
    BINDING_CRM_RECIPIENT_CITY: 'Ville',
    BINDING_GROUP_CRM_RECIPIENT: 'Destinataire',
    BINDING_CRM_BRAND_NAME: 'Nom de la marque',
    BINDING_CRM_BRAND_LOGO: 'Logo de la marque',
    BINDING_CRM_BRAND_EMAIL: 'Email de l’équipe',
    BINDING_CRM_BRAND_LINK: 'Lien vers l’application',
    BINDING_INSERT_VARIABLE: 'Insérer une variable',

    BINDING_APPOINTMENT_DATETIME: 'Date et heure du rendez-vous',
    BINDING_APPOINTMENT_DATE: 'Date du rendez-vous',
    BINDING_APPOINTMENT_PRESTATIONS: 'Prestations du rendez-vous',
    BINDING_APPOINTMENT_LOCATION: 'Lieu du rendez-vous',
    BINDING_APPOINTMENT_MEETING_LINK: 'Lien visio',
    BINDING_APPOINTMENT_PHONE_NUMBER: 'Numéro de téléphone',
    BINDING_APPOINTMENT_MEETING_LINK_BLOCK: 'Ligne lien visio (si renseigné)',
    BINDING_APPOINTMENT_PHONE_NUMBER_BLOCK: 'Ligne téléphone (si renseigné)',
    BINDING_APPOINTMENT_INSTRUCTIONS_BLOCK: 'Bloc instructions (si renseignées)',
    BINDING_APPOINTMENT_PREVIOUS_DATETIME_BLOCK: 'Ligne ancienne date (si reprogrammé)',
    BINDING_APPOINTMENT_MANAGE_URL: 'Lien de gestion du rendez-vous',
    BINDING_GROUP_APPOINTMENT: 'Rendez-vous',
    // Éléments du récap de réservation (emails client de confirmation, demande, modification, rappel).
    BINDING_APPOINTMENT_TEAM_MEMBER_BLOCK: 'Membre (« Avec … », si un membre est réservé)',
    BINDING_APPOINTMENT_PRESTATIONS_DETAIL_BLOCK: 'Prestations et suppléments, avec leurs prix',
    BINDING_APPOINTMENT_DISCOUNT_BLOCK: 'Remise (si une remise s’applique)',
    BINDING_APPOINTMENT_TOTAL_BLOCK: 'Total après remise',
    BINDING_APPOINTMENT_VOUCHER_BLOCK: 'Carte cadeau ou bon utilisé (si utilisé)',
    BINDING_PAYMENT_AMOUNT_BLOCK: 'Montant payé (si un paiement a été reçu)',
    BINDING_APPOINTMENT_REMAINING_AMOUNT_BLOCK: 'Reste à régler (s’il reste un montant dû)',
    BINDING_APPOINTMENT_CANCELLATION_POLICY_BLOCK: 'Conditions d’annulation',
    BINDING_APPOINTMENT_MANAGE_LINK_BLOCK: 'Lien « Gérer mon rendez-vous »',
    BINDING_GROUP_BOOKING_RECAP: 'Récapitulatif de la réservation',
    BINDING_REVIEW_URL: 'Lien pour laisser un avis',
    BINDING_GROUP_REVIEW: 'Avis',
    BINDING_VOUCHER_CODE: 'Code du bon cadeau',
    BINDING_VOUCHER_CODE_HTML: 'Code de la carte (grand format, centré)',
    BINDING_VOUCHER_RECIPIENT: 'Destinataire (« Pour … », si la carte est offerte)',
    BINDING_VOUCHER_GIFT_MESSAGE: 'Message cadeau (si un message a été saisi)',
    BINDING_VOUCHER_AMOUNT: 'Montant du bon cadeau',
    BINDING_VOUCHER_EXPIRATION: 'Date d’expiration du bon cadeau',
    BINDING_VOUCHER_QR: 'QR code de la carte cadeau',
    BINDING_VOUCHER_DOWNLOAD: 'Bouton de téléchargement du PDF',
    BINDING_VOUCHER_ITEMS: 'Contenu acheté (prestations / pack + suppléments)',
    BINDING_VOUCHER_VALUE: 'Valeur (montant, ou contenu sans prix pour un pack/prestation)',
    BINDING_VOUCHER_CARD_VALUE: 'Valeur en grand format (montant, ou contenu sans prix pour un pack/prestation)',
    BINDING_VOUCHER_CARD_TITLE:
      'Titre de la carte (« Carte cadeau », ou « Votre forfait » pour un forfait acheté pour soi)',
    BINDING_VOUCHER_USED_AMOUNT: 'Montant utilisé / rechargé',
    BINDING_VOUCHER_REMAINING_AMOUNT: 'Solde restant du bon cadeau',
    BINDING_GROUP_VOUCHER: 'Bon cadeau',
    BINDING_PAYMENT_AMOUNT: 'Montant du paiement',
    BINDING_PAYMENT_URL: 'Lien de la page de paiement sécurisée',
    BINDING_PAYMENT_REQUEST_SUMMARY: 'Phrase de la demande (paiement, empreinte ou carte en garantie)',
    BINDING_PAYMENT_DETAILS_BLOCK: 'Détails de la demande (objet, rendez-vous, description, si renseignés)',
    BINDING_PAYMENT_PRESTATIONS_BLOCK: 'Prestations de la demande et total (si elle en contient)',
    BINDING_GROUP_PAYMENT: 'Paiement',

    GEO_EDITOR_MY_POSITION: 'Ma position',
    GEO_EDITOR_SELECT_EDIT: 'Sélectionner / Éditer',
    GEO_EDITOR_POINT: 'Point',
    GEO_EDITOR_HOLE: 'Faire un trou',
    GEO_EDITOR_POLYGON: 'Polygone',
    GEO_EDITOR_CIRCLE: 'Cercle',
    GEO_EDITOR_RECTANGLE: 'Rectangle',
    GEO_EDITOR_CLEAR_ALL: 'Tout effacer',
    INPUT_TITLE_EXPERTISE_DOMAINS: "Domaines d'expertise",
    INPUT_PLACEHOLDER_EXPERTISE_DOMAIN: "Ajouter un domaine d'expertise",
    INPUT_TITLE_CAREER_PATH: 'Parcours professionnel',
    INPUT_PLACEHOLDER_CAREER_NAME: 'Nom',
    INPUT_PLACEHOLDER_START_YEAR: 'Année de début',
    INPUT_PLACEHOLDER_END_YEAR: 'Année de fin',

    FILTER_TTTLE_UPDATED_AT: 'Date de la dernière modification',
    FILTER_TTTLE_CREATED_AT: 'Date de création',
    FILTER_TITLE_CUSTOMER_SINCE: 'Client depuis',
    FILTER_TITLE_ADDED_AT: "Date d'ajout",
    FILTER_PLACEHOLDER_DATE: 'Ajouter une date',

    FILTER_TITLE_PLACE_TYPE: 'Type de lieu',
    FILTER_PLACEHOLDER_PLACE_TYPE: 'Choisir un type de lieu',

    FILTER_TITLE_PRICE_RANGE: 'Plage de prix',
    FILTER_PLACEHOLDER_PRICE_RANGE: 'Choisir une plage de prix',

    FILTER_TTTLE_ACCEPTED_MARKETING_EMAIL: 'Accepte les emails marketing',
    FILTER_PLACEHOLDER_ACCEPTED_MARKETING_EMAIL: 'Choisir Non/Oui',

    FILTER_TTTLE_ACCEPTED_MARKETING_SMS: 'Accepte les SMS marketing',
    FILTER_PLACEHOLDER_ACCEPTED_MARKETING_SMS: 'Choisir Non/Oui',

    FILTER_TTTLE_TAGS: 'Tags',
    FILTER_PLACEHOLDER_TAGS: 'Choisir des tags',

    FILTER_TITLE_SUPPLEMENTS: 'Suppléments',
    FILTER_PLACEHOLDER_SUPPLEMENTS: 'Filtrer par supplément',
    FILTER_PLACEHOLDER_PRO_PRESTATION_SEARCH: 'Rechercher par nom ou description...',
    FILTER_TITLE_DURATION: 'Durée (minutes)',
    FILTER_PLACEHOLDER_DURATION: 'Min / Max',
    FILTER_TITLE_PRICE: 'Prix (€)',
    FILTER_PLACEHOLDER_PRICE: 'Min / Max',

    FILTER_TITLE_AMOUNT: 'Montant (€)',
    FILTER_PLACEHOLDER_AMOUNT: 'Min / Max',

    FILTER_TITLE_PRO_PAYMENT_STATUS: 'Statut du paiement',
    FILTER_PLACEHOLDER_PRO_PAYMENT_STATUS: 'Choisir un statut',
    FILTER_TITLE_PRO_PAYMENT_TYPE: 'Type de paiement',
    FILTER_PLACEHOLDER_PRO_PAYMENT_TYPE: 'Choisir un type',
    FILTER_TITLE_PRO_PAYMENT_ORIGIN: 'Origine du paiement',
    FILTER_PLACEHOLDER_PRO_PAYMENT_ORIGIN: 'Choisir une origine',
    FILTER_TITLE_PRO_PAYMENT_CUSTOMER: 'Client',
    FILTER_PLACEHOLDER_PRO_PAYMENT_CUSTOMER: 'Rechercher un client',

    FILTER_TITLE_VOUCHER_STATUS: 'Statut du bon',
    FILTER_PLACEHOLDER_VOUCHER_STATUS: 'Choisir un statut',
    FILTER_TITLE_VOUCHER_TYPE: 'Type de bon',
    FILTER_PLACEHOLDER_VOUCHER_TYPE: 'Choisir un type',
    FILTER_TITLE_VOUCHER_PRESTATION: 'Prestation',
    FILTER_PLACEHOLDER_VOUCHER_PRESTATION: 'Choisir une prestation',
    FILTER_TITLE_VOUCHER_SUPPLEMENT: 'Supplément',
    FILTER_PLACEHOLDER_VOUCHER_SUPPLEMENT: 'Choisir un supplément',

    // Tri des listes (menu « Trier », cf. filter/sort.ts) : critères + sens par type de valeur.
    SORT_MENU_TITLE: 'Trier par',
    SORT_DIRECTION_DATE_DESC: 'du plus récent au plus ancien',
    SORT_DIRECTION_DATE_ASC: 'du plus ancien au plus récent',
    SORT_DIRECTION_TEXT_ASC: 'de A à Z',
    SORT_DIRECTION_TEXT_DESC: 'de Z à A',
    SORT_DIRECTION_NUMBER_DESC: 'du plus élevé au plus bas',
    SORT_DIRECTION_NUMBER_ASC: 'du plus bas au plus élevé',
    SORT_DIRECTION_RATING_DESC: "meilleures notes d'abord",
    SORT_DIRECTION_RATING_ASC: "moins bonnes notes d'abord",
    SORT_FIELD_DEFAULT: 'Par défaut',
    SORT_FIELD_MANUAL: 'Ordre personnalisé',
    SORT_FIELD_CREATED_AT: 'Date de création',
    SORT_FIELD_ADDED_AT: "Date d'ajout",
    SORT_FIELD_CUSTOMER_SINCE: 'Client depuis',
    SORT_FIELD_LASTNAME: 'Nom',
    SORT_FIELD_FIRSTNAME: 'Prénom',
    SORT_FIELD_CUSTOMER_NAME: 'Nom du client',
    SORT_FIELD_PAID_AT: 'Date de paiement',
    SORT_FIELD_AMOUNT: 'Montant',
    SORT_FIELD_EXPIRATION_DATE: "Date d'expiration",
    SORT_FIELD_REMAINING_AMOUNT: 'Solde restant',
    SORT_FIELD_PURCHASE_DATE: "Date d'achat",
    SORT_FIELD_REVIEW_DATE: "Date de l'avis",
    SORT_FIELD_RATING: 'Note',
    SORT_FIELD_SENT_DATE: "Date d'envoi",
    SORT_FIELD_PUBLISHED_AT: 'Date de publication',
    SORT_FIELD_TITLE: 'Titre',
    SORT_FIELD_NAME: 'Nom',
    SORT_FIELD_PRICE: 'Prix',
    SORT_FIELD_QUANTITY: 'Quantité',
    SORT_DRAG_DISABLED_HINT: 'Repassez en « Ordre personnalisé » pour réorganiser par glisser-déposer.',

    INPUT_PLACEHOLDER_PLANNING_NAME: 'Ajouter un nom de disponibilité',
    INPUT_TITLE_PLANNING_NAME: 'Nom de la disponibilité',

    INPUT_PLACEHOLDER_PLANNING_PLACES: 'Ajouter des lieux de rendez-vous',
    INPUT_TITLE_PLANNING_PLACES: 'Lieu des rendez-vous',

    INPUT_PLACEHOLDER_PLANNING_TEAM_MEMBERS: 'Ajouter des membres (aucun : salle ou équipement en libre-service)',
    INPUT_TITLE_PLANNING_TEAM_MEMBERS: 'Membres par défaut',

    INPUT_PLACEHOLDER_PLANNING_RESTRICTED_TAGS: 'Sélectionner les tags clients autorisés',
    INPUT_TITLE_PLANNING_RESTRICTED_TAGS: 'Réserver uniquement à certains clients (tags)',

    INPUT_PLACEHOLDER_PLANNING_SLOTS: 'Ajouter des plages horaires',
    INPUT_TITLE_PLANNING_SLOTS: 'Plages hebdomadaires',

    INPUT_PLACEHOLDER_PLANNING_RECURRENCE: 'Choisir la récurrence',
    INPUT_TITLE_PLANNING_RECURRENCE: 'Récurrence des plages horaires',

    INPUT_PLACEHOLDER_PLANNING_START_DATE: 'Choisir la date de début',
    INPUT_TITLE_PLANNING_START_DATE: 'Débute',

    INPUT_PLACEHOLDER_PLANNING_END_DATE: 'Choisir la date de fin (laisser vide pour indéfini)',
    INPUT_TITLE_PLANNING_END_DATE: 'Se termine',

    INPUT_PLACEHOLDER_PLANNING_SPECIFIC_DATES: 'Ajouter des disponibilités spécifiques',
    INPUT_TITLE_PLANNING_SPECIFIC_DATES: 'Disponibilités à des dates précises',

    INPUT_TITLE_PLANNING_PRESTATION_MODE: 'Prestations disponibles sur ce créneau',
    INPUT_PLACEHOLDER_PLANNING_PRESTATION_MODE: 'Choisir les prestations',

    INPUT_PLACEHOLDER_BOOKING_START_DATE: 'Choisir la date de début',
    INPUT_PLACEHOLDER_BOOKING_END_DATE: 'Choisir la date de fin',

    ...GenreTypeTranslation['fr-FR'],
    ...OnboardingIntentionTranslation['fr-FR'],
    ...TrialVoieTranslation['fr-FR'],
    ...TrialSegmentTranslation['fr-FR'],
    ...TrialRelanceMomentTranslation['fr-FR'],
    ...PackTypeTranslation['fr-FR'],
    ...VoucherTypeTranslation['fr-FR'],
    ...SiteEventTranslation['fr-FR'],
    ...VoucherUsageSourceTranslation['fr-FR'],
    ...VoucherUsageKindTranslation['fr-FR'],
    ...PriceTypeTranslation['fr-FR'],
    ...PrestationTypeTranslation['fr-FR'],
    ...PrestationPaymentTypeTranslation['fr-FR'],
    ...PrestationPaymentAmountModeTranslation['fr-FR'],
    ...AppointmentTypeTranslation['fr-FR'],
    ...RideTripLegTranslation['fr-FR'],
    ...UnsubscribeReasonTranslation['fr-FR'],
    ...UnsubscribeReasonTranslation['fr-FR'],
    ...PlaceKindTranslation['fr-FR'],
    ...MemberAssignmentStrategyTranslation['fr-FR'],
    ...BookingCustomFieldTypeTranslation['fr-FR'],
    ...ProCustomerCustomFieldTypeTranslation['fr-FR'],
    ...NotificationTypeTranslation['fr-FR'],
    ...NotificationThemeTranslation['fr-FR'],
    ...AvailabilityPrestationModeTranslation['fr-FR'],
    ...PageTypeTranslation['fr-FR'],
    ...BookingRecurrenceTranslation['fr-FR'],
    ...RecurrenceRuleLabelTranslation['fr-FR'],
    ...ReservationStatusTranslation['fr-FR'],
    ...BookingSourceTranslation['fr-FR'],
    ...ReservationCancelScopeTranslation['fr-FR'],
    ...AgendaViewEnumTranslation['fr-FR'],
    ...AgendaGroupByEnumTranslation['fr-FR'],
    ...ProNewsStatusTranslation['fr-FR'],
    ...RidePricingPreferenceTranslation['fr-FR'],
    ...RideDistanceBandsModeTranslation['fr-FR'],
    ...TeamMemberRoleTranslation['fr-FR'],
    ...ProfessionalAccessStatusTranslation['fr-FR'],
    ...CalendarSyncProviderTranslation['fr-FR'],
    ...CalendarSyncDirectionTranslation['fr-FR'],
    ...CalendarSyncStatusTranslation['fr-FR'],
    ...CalendarEventSyncStatusTranslation['fr-FR'],
    ...SeoScopeTranslation['fr-FR'],
    ...SeoScoreGroupTranslation['fr-FR'],
    ...SeoScoreGradeTranslation['fr-FR'],
    ...SeoRuleStatusTranslation['fr-FR'],
    ...SeoRuleTranslation['fr-FR'],
    ...SeoKeywordStatusTranslation['fr-FR'],
    ...SeoKeywordSourceTranslation['fr-FR'],
    ...SeoBriefStatusTranslation['fr-FR'],
    ...SeoArticleStatusTranslation['fr-FR'],
    ...SeoLinkDirectionTranslation['fr-FR'],
    ...SeoQaIssueKindTranslation['fr-FR'],
    ...SeoBacklinkModeTranslation['fr-FR'],
    ...SeoBacklinkOriginTranslation['fr-FR'],
    ...SeoBacklinkAcceleratorStatusTranslation['fr-FR'],
    ...SeoBacklinkStatusTranslation['fr-FR'],
    ...SeoBacklinkTargetFamilyTranslation['fr-FR'],
    ...SeoProfileGapTranslation['fr-FR'],
    ...SeoUnwritableReasonTranslation['fr-FR'],
    ...ActivityRecommendationSourceTranslation['fr-FR'],
    ...ServiceAreaTypeTranslation['fr-FR'],
    ...AccessStateTranslation['fr-FR'],
    ...AccessLevelTranslation['fr-FR'],
    ...ProPaymentStatusTranslation['fr-FR'],
    ...ProPaymentOriginTranslation['fr-FR'],
    ...VoucherStatusTranslation['fr-FR'],
    ...GoogleReviewStatusTranslation['fr-FR'],
    ...GoogleReserveStatusTranslation['fr-FR'],
    ...GoogleFeedRunStatusTranslation['fr-FR'],
    FILTER_TITLE_GOOGLE_REVIEW_LOCATION: 'Lieu',
    FILTER_PLACEHOLDER_GOOGLE_REVIEW_LOCATION: 'Tous les lieux',
    INPUT_PLACEHOLDER_REVIEW_AUTO_REPLY:
      'Réponses & suggestions automatiques (option Réponses IA) : publie les réponses aux avis positifs commentés, pré-rédige les autres à valider',
    INPUT_TITLE_REVIEW_REPLY_TONE: 'Consignes de ton pour les réponses IA',
    INPUT_PLACEHOLDER_REVIEW_REPLY_TONE: 'Ex : vouvoiement, signature « L’équipe »…',
    FILTER_TITLE_GOOGLE_REVIEW_STATUS: 'Statut',
    FILTER_PLACEHOLDER_GOOGLE_REVIEW_STATUS: 'Tous les statuts',
    FILTER_TITLE_GOOGLE_REVIEW_RATING: 'Note',
    FILTER_PLACEHOLDER_GOOGLE_REVIEW_RATING: 'Toutes les notes',
    GOOGLE_REVIEW_RATING_1: '1 étoile',
    GOOGLE_REVIEW_RATING_2: '2 étoiles',
    GOOGLE_REVIEW_RATING_3: '3 étoiles',
    GOOGLE_REVIEW_RATING_4: '4 étoiles',
    GOOGLE_REVIEW_RATING_5: '5 étoiles',
  },
  [UNSUB_OFFER_TRANSLATE_KEY]: UnsubscribeOfferReasonTranslation['fr-FR'],
  [UNSUB_OFFER_TEXT_TRANSLATE_KEY]: UnsubscribeOfferReasonTextTranslation['fr-FR'],
  [GOOGLE_TRANSLATE_KEY]: SyncGmbStatusTranslation['fr-FR'],
  [GMB_PUSH_SKIP_REASON_TRANSLATE_KEY]: GmbPushSkipReasonTranslation['fr-FR'],
  [TRANSLATE_KEY_RIDE_PRICING_PREFERENCE]: {
    SHORTEST_TIME: 'Temps le plus court',
    SHORTEST_DISTANCE: 'Distance la plus courte',
    LONGEST_TIME: 'Temps le plus long',
    LONGEST_DISTANCE: 'Distance la plus longue',
  },
  COLORS: ColorsTranslation['fr-FR'],
  LOGIN_PAGE: {
    WELCOME: 'Bon retour',
    WELCOME_TITLE: 'Connectez-vous à votre espace',
    WELCOME_SUBTITLE: 'et reprenez là où vous vous étiez arrêté.',
    BUTTON_CONNEXION_WITH_GOOGLE: 'Connexion avec Google',
    BUTTON_CONNEXION_WITH_APPLE: 'Connexion avec Apple',
    BUTTON_CONNEXION_WITH_FACEBOOK: 'Connexion avec Facebook',
    BACK_NO_ACCOUNT: "Vous n'avez pas de compte ?",
    BUTTON_CREATE_ACCOUNT_NOW: 'Créez en un maintenant',
  },
  AUTH_BRAND_PANEL: {
    RATING_VALUE: '4,6/5',
    REGISTER_HEADLINE: 'Tout votre business, piloté par Pulse.',
    REGISTER_SUBTITLE:
      'Site web, réservation, paiement, fidélisation, avis Google : un seul outil, et Pulse le pilote pour vous.',
    LOGIN_HEADLINE: 'Content de vous revoir.',
    LOGIN_SUBTITLE: 'Votre activité tourne même quand vous êtes occupé : Pulse garde un œil sur le reste.',
    AFFILIATE_HEADLINE: 'Recommandez, on s’occupe du reste.',
    AFFILIATE_SUBTITLE:
      'Votre lien de parrainage attribue chaque inscription. Suivez vos filleuls, vos commissions et vos versements au même endroit.',
    CARD_BOOKING_TITLE: 'Nouvelle réservation',
    CARD_BOOKING_SUBTITLE: 'Marie L. - demain 14h30, depuis Google',
    CARD_PAYMENT_TITLE: 'Acompte encaissé',
    CARD_PAYMENT_SUBTITLE: 'Réservation de Marie L.',
    CARD_PAYMENT_AMOUNT: '+25 €',
    CARD_PULSE_TITLE: '12 clients à relancer',
    CARD_PULSE_BADGE: 'SMS prêt',
    CARD_AFFILIATE_CLICKS_TITLE: '18 personnes ont suivi votre lien',
    CARD_AFFILIATE_CLICKS_SUBTITLE: 'Ces 7 derniers jours',
    CARD_AFFILIATE_COMMISSION_TITLE: 'Commission générée',
    CARD_AFFILIATE_COMMISSION_SUBTITLE: 'Institut Élise - abonnement souscrit',
    CARD_AFFILIATE_COMMISSION_AMOUNT: '+45 €',
    CARD_AFFILIATE_PAYOUT_TITLE: 'Versement envoyé',
    CARD_AFFILIATE_PAYOUT_SUBTITLE: 'Sur votre compte, le 5 du mois',
    CARD_AFFILIATE_PAYOUT_AMOUNT: '+180 €',
    SECTOR_BEAUTY: 'Beauté',
    SECTOR_WELLNESS: 'Bien-être',
    SECTOR_COACHING: 'Coaching',
    SECTOR_SPORT: 'Sport',
    SECTOR_VTC: 'VTC',
  },
  // SMS du quiz d'avant-inscription (lus côté backend par `tLocalized`, namespace figé).
  PUBLIC_LEAD_QUIZ: {
    ACCESS_SMS: `${PROJECT_CONFIG.brand_string} : votre démo et votre espace sont prêts. Ouvrez ce lien pour entrer (sans mot de passe) : {url}`,
    KNOWN_PHONE_SMS: `${PROJECT_CONFIG.brand_string} : ce numéro a déjà un compte. Votre lien de connexion : {url}`,
  },
  REGISTER_PAGE: {
    // ─── Mode quiz (onboarding v4, écran 7) ───
    QUIZ_TITLE: 'Votre démo est prête',
    QUIZ_SUBTITLE: "Où vous l'envoie-t-on ?",
    QUIZ_REASSURANCE:
      '7 jours gratuits, tout compris, sans carte bancaire. Vous entrez tout de suite dans votre espace.',
    QUIZ_FIRSTNAME_LABEL: 'Prénom',
    QUIZ_FIRSTNAME_PLACEHOLDER: 'Votre prénom',
    // Nom de l'activité et ville ne sont plus demandés au quiz : ils arrivent ici, avec le prénom.
    QUIZ_BUSINESS_NAME_LABEL: 'Nom de votre activité',
    QUIZ_BUSINESS_NAME_PLACEHOLDER: 'Salon, institut, cabinet… ou votre prénom',
    QUIZ_CITY_LABEL: 'Votre ville',
    QUIZ_CITY_PLACEHOLDER: 'Montpellier',
    QUIZ_SUBMIT: 'Recevoir ma démo et mes accès',
    QUIZ_IN_APP_BROWSER_HINT:
      'Vous êtes dans un navigateur intégré : ouvrez le SMS que vous allez recevoir pour continuer dans Safari ou Chrome.',
    ERROR_PHONE_ALREADY_USED_LOGIN_LINK_SENT:
      'Ce numéro a déjà un compte. On vient de vous envoyer votre lien de connexion par SMS.',
    ERROR_FIRSTNAME_REQUIRED: 'Indiquez votre prénom.',
    // Continuité avec la LP : le CTA d'arrivée dit « Essayer gratuitement » (cf.
    // `website/src/lib/signup.ts` SIGNUP_LABEL + SIGNUP_REASSURANCE). La page reprend la même
    // promesse (essai, gratuit, sans CB) plutôt qu'un neutre « Créez votre compte » qui
    // ressemble à un mur administratif après un clic « essayer ».
    TITLE: 'Démarrez votre essai gratuit',
    REASSURANCE_TRIAL: `${TRIAL_DURATION_DAYS} jours offerts`,
    REASSURANCE_NO_CARD: 'Sans carte bancaire',
    REASSURANCE_FAST: 'Prêt en 5 minutes',
    REASSURANCE_UNDER_CTA: 'Sans carte bancaire · annulable à tout moment',
    // Témoignages Trustpilot RÉELS affichés en tête du formulaire (`SignupReviewCard`),
    // un par verticale (`?vertical=` propagé par la vitrine) : un avis d'esthéticienne
    // ne parle pas à un chauffeur VTC. `DEFAULT` = home, pub, accès direct.
    // ⚠️ Citations réelles : ne jamais les réécrire ni inventer d'auteur/date.
    REVIEW_RATING_LABEL: 'Avis 5 étoiles sur Trustpilot',
    REVIEW_QUOTE: '« Mes clients réservent depuis Google et j’en gagne de nouveaux, sans commission. »',
    REVIEW_AUTHOR: 'Yasso',
    REVIEW_AUTHOR_META: 'Chauffeur indépendant · avis du 24 nov. 2025',
    REVIEW_BEAUTE_QUOTE:
      '« J’ai eu de nouvelles clientes et j’ai vraiment vu un changement de mon chiffre d’affaires. »',
    REVIEW_BEAUTE_AUTHOR: 'Corinne B.',
    REVIEW_BEAUTE_AUTHOR_META: 'Indépendante · avis du 7 oct. 2025',
    REVIEW_BIEN_ETRE_QUOTE: '« J’ai optimisé mon référencement et généré de nouvelles réservations chaque jour. »',
    REVIEW_BIEN_ETRE_AUTHOR: 'Dorothée M.',
    REVIEW_BIEN_ETRE_AUTHOR_META: 'Centre de bien-être · avis du 10 sept. 2025',
    BUSINESS_NAME_LABEL: 'Nom de votre entreprise',
    BUSINESS_NAME_PLACEHOLDER: 'Institut Élise',
    NO_BUSINESS_NAME_LINK: "Je n'ai pas encore de nom commercial",
    HAS_BUSINESS_NAME_LINK: "J'ai déjà un nom commercial",
    FIRSTNAME_LABEL: 'Prénom',
    FIRSTNAME_PLACEHOLDER: 'Alex',
    LASTNAME_LABEL: 'Nom',
    LASTNAME_PLACEHOLDER: 'Dupont',
    CITY_LABEL: 'Ville',
    CITY_PLACEHOLDER: 'Lyon',
    PHONE_LABEL: 'Téléphone',
    PHONE_PLACEHOLDER: '06 12 34 56 78',
    ERROR_PHONE_INVALID: 'Ce numéro ne semble pas valide. Utilisez le format international, ex. +33612345678.',
    EMAIL_LABEL: 'Email',
    EMAIL_PLACEHOLDER: 'vous@exemple.com',
    EMAIL_SUBADDRESSING_HELP: 'Utilisez votre adresse email principale (pas de « + » dans la partie avant le @).',
    // Click-wrap : le clic sur « Essayer gratuitement » vaut acceptation, pas de case.
    LEGAL_IMPLICIT:
      "En démarrant votre essai, vous acceptez les <cgu>conditions générales d'utilisation</cgu> et les <cgv>conditions générales de vente</cgv>, et vous nous autorisez à retrouver vos informations publiques (fiche Google, site, pages de réservation) pour préparer votre espace : vous validez tout avant usage. Consultez notre <privacy>politique de confidentialité</privacy>.",
    // ⚠️ Doit rester MOT POUR MOT le libellé du CTA de la vitrine
    // (`website/src/lib/signup.ts` SIGNUP_LABEL) : on ne peut pas l'importer d'ici (la LP
    // ne dépend pas de `@cfixe/shared` pour ça), donc les deux se resynchronisent à la main.
    // Le visiteur a cliqué « Essayer gratuitement » sur la LP ; retrouver le MÊME mot sur le
    // bouton qui valide le formulaire confirme qu'il est au bout du même geste — un libellé
    // différent lit comme une étape administrative de plus.
    SUBMIT: 'Essayer gratuitement',
    ALREADY_HAVE_ACCOUNT: 'Vous avez déjà un compte ?',
    GO_TO_LOGIN: 'Connectez-vous',
    ERROR_EMAIL_ALREADY_USED: 'Un compte existe déjà avec cet email. Connectez-vous pour y accéder.',
    ERROR_EMAIL_SUBADDRESSING:
      'Les adresses email avec « + » ne sont pas acceptées. Utilisez votre adresse principale.',
    ERROR_EMAIL_INVALID: "Cet email n'a pas l'air valide. Vérifiez l'orthographe et réessayez.",
    ERROR_EMAIL_REQUIRED: 'Renseignez votre email pour démarrer votre essai.',
    ERROR_PHONE_REQUIRED: 'Renseignez votre numéro de téléphone.',
    ERROR_BUSINESS_NAME_REQUIRED: 'Renseignez le nom de votre entreprise.',
    ERROR_NAMES_REQUIRED: 'Renseignez votre prénom et votre nom.',
    ERROR_CITY_REQUIRED: 'Renseignez votre ville.',
    ERROR_CAPTCHA_FAILED:
      "On n'a pas pu vérifier que vous n'êtes pas un robot. Réessayez dans un instant. Si ça persiste, rechargez la page.",
    // Tunnel preview→compte (« on finalise ensemble ») : le lead arrive depuis Pulse, on ne
    // lui redemande que l'email + le téléphone (nom/ville déjà connus). Deux variantes de copy :
    // PREVIEW prête (un site a vraiment été généré) vs SANS preview (close direct / lancement —
    // « récupérer votre site » serait faux, rien n'a été préparé).
    TUNNEL_TITLE: 'Votre site est prêt',
    TUNNEL_TITLE_NO_PREVIEW: 'On finalise ensemble',
    TUNNEL_SUBMIT: 'Créer mon compte',
    TUNNEL_COMPLETE_INFO: 'Il nous manque une dernière info pour finaliser votre inscription.',
  },
  RESUME_ONBOARDING: {
    START_TITLE: 'Configurez votre espace en quelques minutes',
    START_DESCRIPTION:
      'Nous vous guidons pas à pas : réservation, site, équipe, prestations. Vous pouvez vous arrêter et reprendre quand vous voulez.',
    CTA_START: 'Commencer',
    RESUME_TITLE: 'Reprenez votre configuration',
    RESUME_DESCRIPTION: "Vous êtes à l'étape {position} sur {total}. Continuez là où vous vous êtes arrêté(e).",
    CTA_RESUME: 'Reprendre',
  },
  // Bandeau « prochaine étape » (toutes les pages de l'app, pendant l'essai) — même source
  // que l'email J1 de relance (`GET /app/trial-relance/progress`).
  TRIAL_NEXT_STEP_BANNER: {
    WIZARD_ONE_STEP: 'Terminez votre configuration : il reste 1 étape · {days} j d’essai',
    WIZARD_MANY_STEPS: 'Terminez votre configuration : il reste {count} étapes · {days} j d’essai',
    WIZARD_CTA: 'Reprendre',
    STEP_CTA: 'J’y vais',
  },
  // Relance des essais : sous-actions (bandeau A.5), étages, boutons. Les emails/SMS sont
  // rendus côté backend (trial-relance.content.ts), pas ici.
  TRIAL_RELANCE: {
    TASK_WIZARD_RESUME: 'Terminez votre configuration',
    CTA_RESUME: 'Reprendre',
    TASK_CATALOG_PRICES: 'Ajoutez vos prix sur vos prestations',
    TASK_CATALOG_DURATIONS: 'Confirmez la durée de vos prestations',
    TASK_CATALOG_DESCRIPTIONS: 'Écrivez une description pour vos prestations',
    TASK_CATALOG_PHOTOS: 'Ajoutez une vraie photo par prestation',
    TASK_CATALOG_CATEGORIES: 'Organisez vos prestations par catégorie',
    TASK_CATALOG_DESCRIPTIONS_PHOTOS: 'Ajoutez descriptions et photos à vos prestations',
    TASK_WEBSITE_PAGE_ADDED: 'Ajoutez une page à votre site',
    TASK_WEBSITE_COMPONENT: 'Personnalisez un bloc de votre site',
    TASK_WEBSITE_THEME: 'Choisissez vos couleurs et votre thème',
    TASK_WEBSITE_BRANDING: 'Ajoutez votre logo et vos photos',
    TASK_WEBSITE_BUILDER_VISITED: 'Ouvrez l’éditeur de votre site',
    TASK_AGENDA_HOURS_CHECK: 'Vérifiez vos horaires',
    TASK_WEBSITE_PUBLISH: 'Publiez votre site · 10 secondes',
    TASK_AGENDA_HOURS: 'Ajustez vos horaires à votre vraie semaine',
    TASK_AGENDA_TEAM_PLACES: 'Réglez les disponibilités par membre et par lieu',
    TASK_AGENDA_SLOT_PARAMS: 'Réglez vos créneaux, délais et temps de battement',
    TASK_AGENDA_GOOGLE_SYNC: 'Synchronisez votre Google Agenda',
    TASK_PAYMENTS_STRIPE: 'Activez les paiements en ligne',
    TASK_PAYMENTS_DEPOSIT: 'Activez l’acompte contre les rendez-vous non honorés',
    TASK_AGENDA_FIRST_APPOINTMENT: 'Ajoutez votre premier rendez-vous',
    TASK_CUSTOMERS_IMPORT: 'Importez vos clients · 2 minutes',
    TASK_CUSTOMERS_TAGS: 'Organisez vos clients avec des tags',
    STAGE_SITE_1: 'Catalogue',
    STAGE_SITE_2: 'Design',
    STAGE_SITE_3: 'Agenda et publication',
    STAGE_RESA_1: 'Agenda',
    STAGE_RESA_2: 'Catalogue et paiement',
    STAGE_RESA_3: 'Premier rendez-vous',
    STAGE_4: 'Clients et marketing',
    CTA_GO: 'J’y vais',
    CTA_OPEN_SITE: 'Ouvrir le site',
    CTA_PUBLISH: 'Publier',
    CTA_CHECK_HOURS: 'Vérifier',
    CTA_SET_HOURS: 'Régler',
    CTA_ACTIVATE_PAYMENTS: 'Activer',
    CTA_ACTIVATE_DEPOSIT: 'Activer',
    CTA_ADD_APPOINTMENT: 'Ajouter',
    CTA_IMPORT: 'Importer',
    CTA_ORGANIZE: 'Organiser',
  },
  SET_PASSWORD_NUDGE: {
    CARD_TITLE: 'Sécurisez votre compte',
    CARD_DESCRIPTION:
      "Vous n'avez pas encore défini de mot de passe. Sans ça, vous devrez passer par « mot de passe oublié » à chaque reconnexion.",
    CARD_CTA: 'Définir mon mot de passe',
    DIALOG_TITLE: 'Définissez votre mot de passe',
    DIALOG_DESCRIPTION:
      'Choisissez un mot de passe robuste : il vous servira à vous reconnecter sans passer par votre email.',
    PASSWORD_LABEL: 'Mot de passe',
    PASSWORD_PLACEHOLDER: '••••••••',
    PASSWORD_HELP: '8 caractères minimum, dont une majuscule, une minuscule, un chiffre et un caractère spécial.',
    PASSWORD_INVALID: 'Le mot de passe ne respecte pas les règles ci-dessus.',
    SUBMIT: 'Enregistrer',
    CANCEL: 'Plus tard',
    SUCCESS: 'Mot de passe défini ✅',
    ERROR_ALREADY_SET: 'Un mot de passe est déjà défini sur ce compte. Rechargez la page si le message persiste.',
  },
  LEGAL_PAGES: {
    CGU_TITLE: "Conditions générales d'utilisation",
    CGV_TITLE: 'Conditions générales de vente',
    PRIVACY_TITLE: 'Politique de confidentialité',
    LAST_UPDATED: 'Dernière mise à jour : à venir.',
    PLACEHOLDER_CONTENT:
      'Cette page est en cours de rédaction par notre équipe juridique. Elle sera publiée prochainement.',
  },
  FORGOTTEN_PASSWORD_PAGE: {
    TITLE: 'Entrez votre adresse email pour recevoir un lien de réinitialisation',
    BUTTON_RESET_MY_PASS: 'Réinitialiser mon mot de passe',
  },
  SUCCESS_EMAIL_FORGOTTEN_PASSWORD_PAGE: {
    TITLE: 'Email envoyé !',
    VERIFY_EMAIL_INBOX: 'Vérifiez votre boite email et cliquez sur le lien pour réinitialiser votre mot de passe',
  },
  SET_FORGOTTEN_PASSWORD_PAGE: {
    TITLE: 'Nouveau mot de passe',
    ENTER_YOUR_NEW_PASSWORD: 'Renseigner votre nouveau mot de passe',
    BUTTON_CHANGE_PASSWORD: 'Changer le mot de passe',
    ERROR_DIFFERENT_PASSWORD: 'Les mots de passe ne correspondent pas',
    BUTTON_ASK_NEW_LINK_RESET: 'Pas de souci, vous pouvez en demander un nouveau en cliquant ici 👈',
    BUTTON_REQUEST_NEW_LINK: 'Demander un nouveau lien',
  },
  PASSWORD_RECOVERED_PAGE: {
    TITLE: 'Mot de passe mis à jour',
    YOU_CAN_CONNECT: 'Vous pouvez retourner sur la page de connexion',
  },
  PROFESSIONAL_APP_EMAIL_PAGE: {
    TITLE: 'Emails professionnels',
    SECTION_TITLE: 'Boîtes mail',
    DESCRIPTION:
      'Créez des adresses email sur votre domaine et consultez-les depuis votre application mail habituelle (Gmail, Apple Mail, Outlook…).',
    // Menu « Emails pro » = webmail (Roundcube brandé, ouvert dans un nouvel onglet).
    WEBMAIL_TITLE: 'Emails pro',
    WEBMAIL_NO_MAILBOX_TITLE: 'Aucune boîte mail active',
    WEBMAIL_NO_MAILBOX_DESCRIPTION:
      "Créez d'abord une boîte mail depuis Site → Domaine et emails, puis revenez ici pour la consulter.",
    WEBMAIL_CREATE_CTA: 'Créer une boîte mail',
    // Webmail (Roundcube) — ouvert dans un nouvel onglet (pas d'iframe, pas de SSO).
    WEBMAIL_OPEN_TITLE: 'Votre webmail',
    WEBMAIL_OPEN_DESCRIPTION: 'Consultez et envoyez vos emails directement depuis votre espace.',
    WEBMAIL_OPEN_NEW_TAB: 'Ouvrir mon webmail',
    CREATE_MAILBOX: 'Créer une boîte mail',
    CREATE: 'Créer',
    CANCEL: 'Annuler',
    MAILBOXES_TITLE: 'Vos boîtes mail',
    NO_MAILBOXES: "Vous n'avez pas encore de boîte mail. Créez-en une sur l'un de vos domaines.",
    QUOTA_REMAINING: '{count} boîte(s) restante(s) dans votre plan',
    QUOTA_UNLIMITED: 'Boîtes mail illimitées',
    // Formulaire de création
    DOMAIN_LABEL: 'Domaine',
    DOMAIN_PLACEHOLDER: 'Choisissez un domaine',
    NO_DOMAIN_AVAILABLE: "Vous n'avez aucun domaine. Ajoutez d'abord un domaine à votre site.",
    LOCAL_PART_LABEL: "Nom de l'adresse",
    LOCAL_PART_PLACEHOLDER: 'contact',
    DISPLAY_NAME_LABEL: "Nom d'affichage (optionnel)",
    DISPLAY_NAME_PLACEHOLDER: 'Ex. Salon de Léa',
    ADDRESS_PREVIEW: 'Adresse : {email}',
    // Révélation du mot de passe (une seule fois)
    PASSWORD_TITLE: 'Boîte créée',
    PASSWORD_REGENERATED_TITLE: 'Nouveau mot de passe',
    PASSWORD_WARNING:
      'Copiez ce mot de passe maintenant : il ne sera plus affiché. Vous pourrez le changer à tout moment.',
    PASSWORD_NEXT_STEP:
      'Connectez-vous au webmail ou ajoutez cette adresse dans votre application mail avec ces identifiants.',
    PASSWORD_LABEL: 'Mot de passe',
    ADDRESS_LABEL: 'Adresse email',
    DONE: 'Terminé',
    // Réglages de connexion
    SETTINGS_TITLE: 'Réglages de connexion',
    SETTINGS_DESCRIPTION: 'Utilisez ces paramètres pour ajouter votre adresse dans votre application mail.',
    IMAP_SERVER: 'Serveur entrant (IMAP)',
    SMTP_SERVER: 'Serveur sortant (SMTP)',
    PORT: 'Port',
    USERNAME: 'Identifiant',
    USERNAME_HINT: "L'identifiant est votre adresse email complète.",
    COPY: 'Copier',
    COPIED: 'Copié',
    // Lien vers la documentation de configuration (les réglages détaillés vivent dans la doc)
    SETTINGS_DOC_HINT:
      'Retrouvez les réglages de connexion (IMAP/SMTP) et les instructions pas à pas pour Gmail, Apple Mail et Outlook dans notre documentation.',
    SETTINGS_DOC_LINK: 'Voir le guide de configuration',
    // Actions par boîte
    OPEN_WEBMAIL: 'Ouvrir le webmail',
    MAILBOX_ACTIONS_MENU: 'Actions de la boîte mail',
    CHANGE_PASSWORD: 'Changer le mot de passe',
    CHANGE_PASSWORD_DESCRIPTION:
      "Un nouveau mot de passe sera défini pour {email}. L'ancien cessera immédiatement de fonctionner : vous devrez le remplacer dans votre application mail et sur le webmail.",
    CHANGE_PASSWORD_SUBMIT_GENERATE: 'Générer un nouveau mot de passe',
    CHANGE_PASSWORD_SUBMIT_CUSTOM: 'Changer le mot de passe',
    PASSWORD_CHANGED_SUCCESS: 'Mot de passe mis à jour.',
    // Choix du mot de passe (création + changement)
    CUSTOM_PASSWORD_TOGGLE: 'Choisir mon propre mot de passe',
    CUSTOM_PASSWORD_GENERATED_HINT:
      'Sans action de votre part, un mot de passe simple et sûr sera généré et affiché une seule fois.',
    CUSTOM_PASSWORD_RULE_HINT: 'Au moins {min} caractères. Évitez un mot de passe déjà utilisé ailleurs.',
    PASSWORD_SHOW: 'Afficher le mot de passe',
    PASSWORD_HIDE: 'Masquer le mot de passe',
    DELETE_MAILBOX: 'Supprimer',
    DELETE_CONFIRM_TITLE: 'Supprimer cette boîte mail ?',
    DELETE_CONFIRM_DESCRIPTION:
      'La boîte {email} sera supprimée définitivement. Les emails qu’elle contient ne seront plus accessibles.',
    DELETE_CONFIRM: 'Supprimer définitivement',
    // Upsell
    UPSELL_TITLE: 'Passez à un plan supérieur pour vos emails pro',
    UPSELL_DESCRIPTION: 'Créez des adresses email sur votre propre domaine, incluses dans votre abonnement.',
    UPSELL_BENEFIT_1: 'Des adresses sur votre nom de domaine',
    UPSELL_BENEFIT_2: 'Compatibles Gmail, Apple Mail et Outlook',
    UPSELL_BENEFIT_3: 'DNS et anti-spam configurés automatiquement',
  },
  PROFESSIONAL_APP_WEBSITE_PAGE: {
    TITLE: 'Site internet',
    TAB_OVERVIEW: 'Récap',
    TAB_SETTINGS: 'Paramètres',
    TAB_DOMAIN: 'Domaine & emails',
    DOMAIN_PAGE_SUBTITLE:
      'Voici toutes les adresses web de votre site. La première que vous ajoutez devient l’adresse principale ; les suivantes redirigent automatiquement vers elle.',
    // ── Statuts d'activation d'un domaine ──
    DOMAIN_STATUS_FREE: 'Gratuit',
    DOMAIN_STATUS_ONLINE: 'En ligne',
    DOMAIN_STATUS_PAYMENT_PENDING: 'Paiement en attente',
    DOMAIN_STATUS_ORDER_FAILED: "Erreur d'achat",
    DOMAIN_STATUS_TRANSFER_IN_PROGRESS: 'Transfert en cours',
    DOMAIN_STATUS_MANUAL_ACTION: 'Action manuelle requise',
    DOMAIN_STATUS_TRANSFER_FAILED: 'Transfert échoué',
    DOMAIN_STATUS_CONFIGURING: 'Configuration en cours',
    DOMAIN_STATUS_PENDING: 'En attente',
    // ── Aide / actions selon le statut d'activation ──
    DOMAIN_HELP_CONFIGURING:
      'Activation en cours : réservation du domaine, configuration DNS puis mise en ligne sécurisée (HTTPS). Cela peut prendre quelques minutes.',
    DOMAIN_HELP_TRANSFER_IN_PROGRESS:
      'Transfert en cours : la migration du domaine depuis votre registraire actuel peut prendre plusieurs jours. Vous n’avez rien à faire en attendant, votre site reste accessible.',
    DOMAIN_HELP_MANUAL_ACTION:
      "Une action de votre part est nécessaire pour finaliser le transfert. Communiquez le code d'autorisation ci-dessous à votre registraire actuel, ou contactez le support.",
    DOMAIN_HELP_ORDER_FAILED:
      "L'activation a échoué. Vérifiez le domaine puis réessayez ; si le problème persiste, contactez le support.",
    DOMAIN_HELP_AUTH_CODE: "Code d'autorisation (auth code) :",
    DOMAIN_RETRY: 'Réessayer',
    // ── Liste des domaines ──
    DOMAIN_BADGE_PRIMARY: 'Principal',
    DOMAIN_BADGE_REDIRECT: 'Redirection',
    DOMAIN_DESC_PRIMARY: 'Adresse principale de votre site',
    DOMAIN_DESC_REDIRECT: 'Redirige automatiquement vers {target}',
    DOMAIN_DESC_SUBDOMAIN_MAIN: `Adresse principale de votre site, offerte par ${PROJECT_CONFIG.brand_string}`,
    DOMAIN_DESC_SUBDOMAIN_FALLBACK: `Adresse gratuite fournie par ${PROJECT_CONFIG.brand_string}`,
    DOMAIN_ADD_BUTTON: 'Ajouter un domaine',
    DOMAIN_MENU_SET_PRIMARY: 'Définir comme principal',
    DOMAIN_DELETE: 'Supprimer',
    DOMAIN_MENU_DEACTIVATE: 'Désactiver le renouvellement',
    // ── Renouvellement annuel ──
    DOMAIN_RENEWAL_AUTO_LINE: 'Renouvellement auto le {date} · {price_ht} HT ({price_ttc} TTC)/an',
    // Variante sans tarif de DOMAIN_RENEWAL_AUTO_LINE, pour la WebView mobile :
    // l'échéance reste une information utile, le montant serait un prix affiché
    // dans l'app (App Review 3.1.3(f)).
    DOMAIN_RENEWAL_AUTO_LINE_NO_PRICE: 'Renouvellement auto le {date}',
    DOMAIN_RENEWAL_FREE: 'Renouvellement offert',
    DOMAIN_RENEWAL_BADGE_UNPAID: 'Paiement en échec',
    DOMAIN_RENEWAL_BADGE_DUNNING: 'Relance en cours',
    // Renouvellement payé par prélèvement SEPA, lancé mais pas encore encaissé.
    DOMAIN_RENEWAL_BADGE_PROCESSING: 'Prélèvement en cours',
    DOMAIN_DEACTIVATE_TITLE: 'Retirer {domain} ?',
    DOMAIN_DEACTIVATE_DESC:
      'Ce domaine ne pointera plus vers votre site et son renouvellement annuel ne sera plus facturé. Le domaine reste votre propriété chez le registrar.',
    DOMAIN_DEACTIVATE_CONFIRM: 'Retirer le domaine',
    // ── Domaine en attente de paiement (PAYMENT_PENDING) ──
    DOMAIN_PAY_NOW: 'Payer maintenant',
    // Achat déjà réglé par prélèvement SEPA, lancé mais pas encore encaissé : aucun second paiement.
    DOMAIN_SEPA_DEBIT_IN_PROGRESS_TITLE: 'Prélèvement SEPA en cours',
    DOMAIN_SEPA_DEBIT_IN_PROGRESS_DESC:
      'Le paiement de ce domaine est en cours de prélèvement : il sera activé dès l’encaissement, sous 2 à 5 jours ouvrés.',
    // ── Annulation d'une commande de domaine impayée (PAYMENT_PENDING) ──
    DOMAIN_CANCEL_ORDER_MENU: 'Annuler la commande',
    DOMAIN_CANCEL_ORDER_TITLE: 'Annuler la commande de {domain} ?',
    DOMAIN_CANCEL_ORDER_DESC:
      "Ce domaine n'a pas encore été payé : rien n'a été commandé. L'annulation libère votre site et invalide le paiement en attente. Vous pourrez le commander à nouveau plus tard.",
    DOMAIN_CANCEL_ORDER_CONFIRM: 'Annuler la commande',
    // ── Modale d'ajout ──
    DOMAIN_ADD_MODAL_TITLE: 'Ajouter un domaine',
    DOMAIN_ADD_AS_PRIMARY_HINT: 'Ce domaine deviendra l’adresse principale de votre site.',
    DOMAIN_ADD_AS_REDIRECT_HINT: 'Ce domaine redirigera automatiquement vers votre adresse principale ({target}).',
    DOMAIN_SEARCH_PLACEHOLDER: 'Tapez le domaine que vous voulez (ex : mon-salon.fr)',
    DOMAIN_NONE_SUGGESTED: 'Commencez à taper pour voir les domaines disponibles',
    DOMAIN_INCLUDED: 'Inclus dans votre formule',
    DOMAIN_PRICE_PER_YEAR: '{price_ht} HT ({price_ttc} TTC)/an',
    DOMAIN_TRANSFERABLE: 'Vous le possédez déjà ? Transférez-le',
    DOMAIN_UNAVAILABLE: 'Déjà pris',
    DOMAIN_PREMIUM: 'Domaine premium, tarif sur devis',
    DOMAIN_PREMIUM_CONTACT: 'Nous contacter',
    DOMAIN_CHOOSE: 'Choisir',
    DOMAIN_TRANSFER: 'Transférer',
    DOMAIN_BACK: 'Retour',
    // ── Transfert ──
    DOMAIN_TRANSFER_TITLE: 'Transférer {domain}',
    DOMAIN_TRANSFER_HINT:
      "Vous possédez déjà ce domaine ailleurs. Pour le rapatrier, récupérez le code d'autorisation (code EPP/Auth) auprès de votre fournisseur actuel et assurez-vous que le domaine est déverrouillé.",
    DOMAIN_TRANSFER_MANUAL_TITLE: 'Transfert interne nécessaire',
    DOMAIN_TRANSFER_MANUAL_DESC:
      'Ce domaine est déjà chez notre partenaire technique. Un transfert interne est nécessaire : notre équipe va vous contacter pour le finaliser.',
    DOMAIN_TRANSFER_AUTH_PLACEHOLDER: "Code d'autorisation (EPP/Auth)",
    DOMAIN_TRANSFER_START: 'Lancer le transfert',
    DOMAIN_TRANSFER_LOADING: 'Transfert…',
    // ── Définir comme principal ──
    DOMAIN_SET_PRIMARY_TITLE: 'Faire de {domain} votre adresse principale ?',
    DOMAIN_SET_PRIMARY_SEO_TITLE: 'À savoir avant de changer',
    DOMAIN_SET_PRIMARY_SEO_DESC:
      "Changer d'adresse principale peut temporairement impacter votre référencement Google. Gardez l'ancienne adresse en redirection pour que vos anciens liens continuent de fonctionner.",
    DOMAIN_SET_PRIMARY_KEEP_REDIRECT: 'Garder {domain} en redirection (recommandé)',
    DOMAIN_SET_PRIMARY_CONFIRM: 'Définir comme principal',
    // ── Récap (Overview) ──
    OVERVIEW_NO_DOMAIN: 'Aucun domaine',
    OVERVIEW_MANAGE_DOMAIN: 'Gérer le domaine',
    OVERVIEW_VIEW_SITE: 'Voir le site',
    OVERVIEW_STATUS_ONLINE: 'En ligne',
    OVERVIEW_STATUS_DRAFT: 'Brouillon',
    OVERVIEW_PUBLISHED_AT: 'Publié le {date}',
    // ── Dépublication du site ──
    UNPUBLISH_DIALOG_TITLE: 'Dépublier {domain} ?',
    UNPUBLISH_DIALOG_DESC: 'Votre site va être mis hors ligne immédiatement. Voici précisément ce que cela implique :',
    UNPUBLISH_CONSEQ_OFFLINE:
      'Le site ne sera plus accessible : vos visiteurs verront une page « site momentanément hors ligne ».',
    UNPUBLISH_CONSEQ_SEO:
      'Il disparaîtra progressivement des résultats Google, ce qui peut impacter durablement votre référencement.',
    UNPUBLISH_CONSEQ_KEPT:
      'Rien n’est supprimé : votre contenu, vos réglages et votre domaine restent intacts (dépublier ne résilie pas votre domaine ni son renouvellement).',
    UNPUBLISH_CONSEQ_REPUBLISH: 'Vous pourrez remettre le site en ligne à tout moment en cliquant sur « Publier ».',
    UNPUBLISH_CONFIRM: 'Dépublier le site',
    UNPUBLISH_SUCCESS_TOAST: 'Votre site est hors ligne.',
    STATS_SECTION_TITLE: 'Statistiques de fréquentation',
    STAT_VISITORS: 'Visiteurs',
    STAT_PAGE_VIEWS: 'Pages vues',
    STAT_BOUNCE_RATE: 'Taux de rebond',
    STAT_AVG_DURATION: 'Durée moy.',
    STAT_GOOGLE_CLICKS: 'Clics Google',
    STAT_IMPRESSIONS: 'Impressions',
    STAT_CTR: 'CTR',
    STAT_AVG_POSITION: 'Position moy.',
    STATS_TOP_PAGES: 'Pages les plus visitées',
    STATS_TOP_KEYWORDS: 'Mots-clés Google',
    STATS_TRAFFIC_TITLE: 'Fréquentation',
    STATS_EMPTY: 'Aucune donnée sur cette période.',
    STATS_NOT_PUBLISHED: 'Publiez votre site pour commencer à mesurer sa fréquentation.',
    STATS_TOP_PAGES_EMPTY: 'Aucune page consultée sur cette période.',
    STATS_TOP_KEYWORDS_EMPTY: 'Aucun mot-clé sur cette période.',
    STAT_DURATION_MIN_SEC: '{m} min {s} s',
    STAT_DURATION_SEC: '{s} s',
    SETTINGS_SAVED: 'Réglages enregistrés',
    SETTINGS_CARD_BRANDING_TITLE: 'Général',
    SETTINGS_CARD_BRANDING_SUBTITLE: 'Titre, description et favicon de votre site',
    SETTINGS_CARD_SEO_TITLE: 'Référencement (SEO / GEO)',
    SETTINGS_CARD_SEO_SUBTITLE: 'Périmètre géographique et zones desservies',
    SETTINGS_CARD_TRACKING_TITLE: 'Statistiques & tracking',
    SETTINGS_CARD_TRACKING_SUBTITLE: 'Google Analytics et Meta Pixel',
    SETTINGS_CARD_TRACKING_LOCKED_SUBTITLE: 'Disponible avec le plan Pro : cliquez pour passer au plan supérieur',
    SETTINGS_CARD_REDIRECTS_TITLE: 'Redirections',
    SETTINGS_CARD_REDIRECTS_SUBTITLE: 'Rediriger une ancienne adresse vers une page ou un lien',
    SETTINGS_CARD_SCRIPTS_TITLE: 'Scripts personnalisés',
    SETTINGS_CARD_SCRIPTS_SUBTITLE: 'Injecter des scripts tiers sur votre site (analytics, widgets…)',
    SETTINGS_CARD_SCRIPTS_LOCKED_SUBTITLE: 'Disponible avec le plan Max : cliquez pour passer au plan supérieur',
    SETTINGS_SCRIPTS_MODAL_DESC:
      'Ajoutez des scripts tiers à votre site : outil de mesure d’audience, widget de chat, module d’avis… Les scripts soumis au consentement ne se chargent qu’après acceptation des cookies par vos visiteurs.',
    SETTINGS_SCRIPTS_ADD: 'Ajouter un script',
    SETTINGS_SCRIPTS_EMPTY: 'Aucun script pour le moment.',
    SETTINGS_SCRIPTS_MAX_REACHED: 'Nombre maximum de scripts atteint ({max}).',
    SETTINGS_SCRIPTS_LABEL_LABEL: 'Nom du script',
    SETTINGS_SCRIPTS_LABEL_PLACEHOLDER: 'Ex. Google Analytics, Widget avis…',
    SETTINGS_SCRIPTS_KIND_EXTERNAL: 'Fichier externe',
    SETTINGS_SCRIPTS_KIND_INLINE: 'Code intégré',
    SETTINGS_SCRIPTS_SRC_LABEL: 'Adresse du script (https)',
    SETTINGS_SCRIPTS_SRC_PLACEHOLDER: 'https://exemple.com/script.js',
    SETTINGS_SCRIPTS_SNIPPET_LABEL: 'Code JavaScript',
    // ⚠️ Pas de chevrons (`<head>`, `<script>`…) dans ces messages : next-intl les
    // parse comme des tags rich-text ICU → message invalide, la clé brute s'affiche.
    SETTINGS_SCRIPTS_SNIPPET_PLACEHOLDER: 'Collez ici le code fourni par votre outil (sans balise script)',
    SETTINGS_SCRIPTS_SNIPPET_COUNT: '{count} / {max} caractères',
    SETTINGS_SCRIPTS_POSITION_LABEL: 'Emplacement',
    SETTINGS_SCRIPTS_POSITION_HEAD: 'En-tête de page (head)',
    SETTINGS_SCRIPTS_POSITION_BODY_END: 'Fin de page (avant la fin du body)',
    SETTINGS_SCRIPTS_CONSENT_LABEL: 'Consentement cookies',
    SETTINGS_SCRIPTS_CONSENT_NECESSARY: 'Essentiel (toujours chargé)',
    SETTINGS_SCRIPTS_CONSENT_ANALYTICS: 'Statistiques (après consentement)',
    SETTINGS_SCRIPTS_CONSENT_MARKETING: 'Marketing (après consentement)',
    SETTINGS_SCRIPTS_CONSENT_HELP:
      'Les scripts « Statistiques » et « Marketing » ne se chargent qu’après acceptation de la catégorie par le visiteur (bannière cookies). Réservez « Essentiel » aux scripts sans traceur.',
    SETTINGS_SCRIPTS_ASYNC_LABEL: 'Chargement async',
    SETTINGS_SCRIPTS_DEFER_LABEL: 'Chargement defer',
    SETTINGS_SCRIPTS_PIXEL_DETECTED:
      'Ce code ressemble à un pixel Google ou Meta. Configurez-le plutôt dans « Statistiques & tracking » (raccourci en bas de la fenêtre) : champs dédiés, consentement géré automatiquement, et pas de risque de double installation.',
    // Raccourcis croisés entre les modales Tracking et Scripts.
    SETTINGS_TRACKING_GOTO_SCRIPTS: 'Besoin d’injecter un autre script (chat, avis, widget…) ? Scripts personnalisés',
    SETTINGS_SCRIPTS_GOTO_TRACKING: 'Pour Google Analytics, GTM ou le pixel Meta : Statistiques & tracking',
    TRACKING_INVALID_GOOGLE_ID: 'Identifiant Google invalide (formats acceptés : GTM-XXXX, G-XXXX, AW-XXXX, UA-XXXX).',
    TRACKING_INVALID_META_PIXEL_ID: 'Identifiant Meta Pixel invalide : il ne contient que des chiffres.',
    TRACKING_INVALID_TIKTOK_PIXEL_ID:
      'Identifiant Pixel TikTok invalide : lettres et chiffres uniquement (8-32 caractères).',
    TRACKING_INVALID_ADS_LABEL:
      'Libellé de conversion Google Ads invalide : lettres, chiffres, tirets et tirets bas uniquement.',
    TRACKING_GOOGLE_IDS_TITLE: 'Identifiants Google',
    TRACKING_GOOGLE_IDS_HELP:
      'Conteneur Google Tag Manager (GTM-…), Google Analytics 4 (G-…) ou Google Ads (AW-…). Jusqu’à {max} identifiants : par exemple votre conteneur et celui de votre agence.',
    TRACKING_GOOGLE_ID_ADD: 'Ajouter un identifiant',
    TRACKING_GOOGLE_ID_REMOVE: 'Retirer cet identifiant',
    TRACKING_ADS_LABELS_TITLE: 'Conversions Google Ads',
    TRACKING_ADS_LABELS_HELP:
      'Pour chaque action à compter, collez le libellé de conversion fourni par Google Ads (la partie après le « / » de la valeur send_to). Sans libellé, Google Ads n’enregistre rien pour cette action. Si une agence gère vos conversions dans Google Tag Manager, laissez ces champs vides.',
    TRACKING_ADS_LABEL_PLACEHOLDER: 'Ex. AbC-D_efGh1IjKlMnOp',
    TRACKING_AGENCY_TITLE: 'Vous passez par une agence ?',
    TRACKING_AGENCY_HELP:
      'Votre site envoie déjà les événements de conversion (formulaire envoyé, rendez-vous confirmé, clic sur votre numéro…) : votre agence n’a aucun code à faire ajouter. Transmettez-lui la page de référence.',
    TRACKING_AGENCY_DOC_LINK: 'Événements de suivi : la référence pour les agences',
    SETTINGS_SCRIPTS_INVALID_LABEL: 'Donnez un nom à ce script (100 caractères max).',
    SETTINGS_SCRIPTS_INVALID_SRC: 'Une URL https:// valide est requise.',
    SETTINGS_SCRIPTS_INVALID_SNIPPET: 'Le code est vide ou contient une balise script interdite.',
    SETTINGS_SCRIPTS_SNIPPET_TOO_LARGE: 'Le code dépasse la taille maximale autorisée.',
    DNS_ZONE_MENU_LABEL: 'Zone DNS',
    DNS_ZONE_LOCKED_SUBTITLE: 'Disponible avec le plan Max',
    DNS_ZONE_MODAL_TITLE: 'Zone DNS',
    DNS_ZONE_MODAL_DESC:
      'Gérez les enregistrements DNS de votre domaine. Les enregistrements marqués d’un cadenas sont gérés automatiquement par la plateforme.',
    DNS_ZONE_TABLE_TYPE: 'Type',
    DNS_ZONE_TABLE_NAME: 'Nom',
    DNS_ZONE_TABLE_VALUE: 'Valeur',
    DNS_ZONE_TABLE_TTL: 'TTL',
    DNS_ZONE_RECORD_COUNT: '{count} / {max} enregistrements',
    DNS_ZONE_EMPTY: 'Aucun enregistrement dans cette zone.',
    DNS_ZONE_LEGACY_SPF_BADGE: 'SPF (obsolète)',
    DNS_ZONE_LOCK_SITE_ROUTING: 'Routage de votre site, géré automatiquement par la plateforme.',
    DNS_ZONE_LOCK_MAIL_MANAGED:
      'Géré par votre hébergement email. Désactivez vos boîtes mail pour reprendre la main sur cet enregistrement.',
    DNS_ZONE_LOCK_DKIM: 'Clé de signature email (DKIM), générée et renouvelée automatiquement.',
    DNS_ZONE_LOCK_GSC: 'Vérification Google Search Console, à conserver pour vos statistiques Google.',
    DNS_ZONE_LOCK_CAMPAIGN_SENDER:
      'Expéditeur de vos campagnes e-mail sur ce domaine (signature DKIM, preuve de propriété, SPF) : géré automatiquement. Retirez le domaine expéditeur depuis les paramètres de communication pour libérer ces enregistrements.',
    DNS_ZONE_LOCK_UNSUPPORTED: 'Ce type d’enregistrement n’est pas modifiable depuis cette interface.',
    DNS_ZONE_ADD_RECORD: 'Ajouter un enregistrement',
    DNS_ZONE_EDIT_RECORD: 'Modifier l’enregistrement',
    DNS_ZONE_DELETE_RECORD: 'Supprimer l’enregistrement',
    DNS_ZONE_DELETE_CONFIRM_TITLE: 'Supprimer cet enregistrement ?',
    DNS_ZONE_DELETE_CONFIRM_DESC:
      'Cette action est immédiate et peut impacter le fonctionnement de services liés à votre domaine.',
    DNS_ZONE_FORM_TYPE_LABEL: 'Type',
    DNS_ZONE_FORM_SUBDOMAIN_LABEL: 'Nom (sous-domaine)',
    DNS_ZONE_FORM_SUBDOMAIN_PLACEHOLDER: 'Vide = domaine racine (@)',
    DNS_ZONE_FORM_TARGET_LABEL: 'Valeur',
    DNS_ZONE_FORM_PRIORITY_LABEL: 'Priorité',
    DNS_ZONE_FORM_TTL_LABEL: 'TTL (durée de cache)',
    DNS_ZONE_TTL_5MIN: '5 minutes',
    DNS_ZONE_TTL_1H: '1 heure (recommandé)',
    DNS_ZONE_TTL_12H: '12 heures',
    DNS_ZONE_TTL_24H: '24 heures',
    DNS_ZONE_INVALID_TARGET: 'Valeur invalide pour ce type d’enregistrement.',
    DNS_ZONE_CAA_WARNING:
      'Un enregistrement CAA restreint les autorités autorisées à émettre vos certificats HTTPS. Autorisez toujours « letsencrypt.org » (0 issue letsencrypt.org), utilisé pour le certificat de votre site, sinon son renouvellement échouera.',
    DNS_ZONE_INVALID_SUBDOMAIN: 'Sous-domaine invalide.',
    DNS_ZONE_PROPAGATION_NOTE:
      'Modifications enregistrées : la propagation prend de quelques minutes à quelques heures selon le TTL.',
    DNS_ZONE_MAIL_HINT:
      'Aucune boîte mail hébergée sur ce domaine : vous pouvez ajouter ici les enregistrements de votre messagerie externe (Office 365, Google Workspace…). Un domaine ne peut avoir qu’une seule messagerie à la fois.',
    DNS_ZONE_MX_FORM_HINT:
      'Un enregistrement MX indique où arrivent les emails de votre domaine. Recopiez exactement la valeur donnée par votre messagerie (Office 365, Google Workspace…) : une erreur ici et vous ne recevez plus d’emails.',
    DNS_ZONE_DMARC_STRICT_WARNING:
      'Une politique DMARC « reject » ou « quarantine » fait rejeter ou classer en spam les emails non signés. Assurez-vous que votre messagerie a bien ses enregistrements SPF et DKIM en place avant de l’activer.',
    DNS_ZONE_SPF_EXISTS_INLINE:
      'Votre domaine a déjà une règle SPF. Modifiez celle qui existe (crayon) plutôt que d’en ajouter une seconde : deux règles SPF annulent toute protection.',
    DNS_ZONE_SPF_LEGACY_INLINE:
      'Votre domaine porte encore une ancienne règle SPF (type « SPF ») qui ne peut pas être modifiée ici. Supprimez-la d’abord (corbeille), puis ajoutez votre nouvelle règle : deux règles SPF annulent toute protection.',
    DNS_ZONE_DELETE_MX_WARNING:
      'Vous supprimez un enregistrement MX : sans lui, les emails envoyés à votre domaine ne seront plus reçus.',
    DNS_ZONE_DELETE_SPF_WARNING:
      'Vous supprimez la règle SPF de votre domaine : vos emails risquent d’arriver en spam.',
    MAIL_CHECK_BUTTON: 'Vérifier ma messagerie',
    MAIL_CHECK_TITLE: 'État de votre messagerie',
    MAIL_CHECK_PROVIDER_PLATFORM: `Vos emails sont reçus par ${PROJECT_CONFIG.brand_string}.`,
    MAIL_CHECK_PROVIDER_EXTERNAL: 'Vos emails sont reçus par une messagerie externe.',
    MAIL_CHECK_PROVIDER_NONE: 'Aucune messagerie n’est configurée sur ce domaine : il ne reçoit pas d’emails.',
    MAIL_CHECK_PROVIDER_MIXED:
      'Vos emails sont dirigés vers plusieurs messageries à la fois : la réception est aléatoire. Gardez une seule messagerie.',
    MAIL_CHECK_ITEM_MX: 'Réception des emails',
    MAIL_CHECK_ITEM_SPF: 'Autorisation d’envoi (SPF)',
    MAIL_CHECK_ITEM_DMARC: 'Protection anti-usurpation (DMARC)',
    MAIL_CHECK_ITEM_DKIM: 'Signature des emails (DKIM)',
    MAIL_CHECK_STATUS_OK: 'OK',
    MAIL_CHECK_STATUS_WARNING: 'À vérifier',
    MAIL_CHECK_STATUS_MISSING: 'Manquant',
    MAIL_CHECK_STATUS_ERROR: 'Problème',
    MAIL_CHECK_DETAIL_MX_NOT_PROPAGATED:
      'La configuration est enregistrée mais pas encore visible partout : patientez quelques heures.',
    MAIL_CHECK_DETAIL_MX_MIXED: 'Plusieurs messageries sont déclarées en même temps.',
    MAIL_CHECK_DETAIL_MX_NONE: 'Aucun enregistrement MX : ce domaine ne reçoit pas d’emails.',
    MAIL_CHECK_DETAIL_MX_EXTERNAL: 'Les emails arrivent sur votre messagerie externe.',
    MAIL_CHECK_DETAIL_MX_PLATFORM: `Les emails arrivent sur vos boîtes ${PROJECT_CONFIG.brand_string}.`,
    MAIL_CHECK_DETAIL_SPF_MISSING: 'Aucune règle SPF : vos emails risquent d’arriver en spam.',
    MAIL_CHECK_DETAIL_SPF_MULTIPLE: 'Plusieurs règles SPF : elles s’annulent. Gardez-en une seule.',
    MAIL_CHECK_DETAIL_SPF_NOT_PROPAGATED: 'Règle SPF enregistrée mais pas encore visible partout.',
    MAIL_CHECK_DETAIL_SPF_PLATFORM_INCLUDE_MISSING: `La règle SPF n’autorise pas ${PROJECT_CONFIG.brand_string} à envoyer vos emails.`,
    MAIL_CHECK_DETAIL_SPF_CAMPAIGN_INCLUDE_MISSING:
      'La règle SPF n’autorise pas encore l’envoi de vos campagnes e-mail.',
    MAIL_CHECK_DETAIL_SPF_OK: 'Les serveurs autorisés à envoyer vos emails sont déclarés.',
    MAIL_CHECK_DETAIL_DMARC_MISSING: 'Aucune politique DMARC : conseillée pour éviter l’usurpation de votre domaine.',
    MAIL_CHECK_DETAIL_DMARC_INVALID: 'La politique DMARC est mal formée.',
    MAIL_CHECK_DETAIL_DMARC_NOT_PROPAGATED: 'Politique DMARC enregistrée mais pas encore visible partout.',
    MAIL_CHECK_DETAIL_DMARC_OK: 'Politique DMARC en place.',
    MAIL_CHECK_DETAIL_DKIM_NONE: 'Aucune clé de signature : vos emails ne sont pas signés.',
    MAIL_CHECK_DETAIL_DKIM_NOT_PROPAGATED: 'Clé de signature enregistrée mais pas encore visible partout.',
    MAIL_CHECK_DETAIL_DKIM_OK: 'Vos emails sont signés.',
    MAIL_CHECK_DETAIL_MAIL_PROVISIONING: `Vos boîtes ${PROJECT_CONFIG.brand_string} sont en cours de mise en place : la configuration s’écrit automatiquement, patientez quelques minutes avant de revérifier.`,
    MAIL_CHECK_FAILED: 'La vérification n’a pas pu aboutir. Réessayez dans quelques minutes.',
    REDIRECTS_MODAL_DESC:
      'Redirigez une ancienne adresse de votre site vers une page existante ou un site externe, ou créez un lien court à partager qui renvoie vers une adresse externe (réseaux sociaux, prise de RDV…).',
    REDIRECTS_TAB_REDIRECTS: 'Redirections',
    REDIRECTS_TAB_SHORTLINKS: 'Raccourcis',
    REDIRECTS_REDIRECTS_HELP:
      'Faites pointer une ancienne adresse de votre site vers une page existante ou vers un site externe (redirection permanente).',
    REDIRECTS_SHORTLINKS_HELP: 'Créez une adresse courte à partager qui renvoie vers un lien externe.',
    REDIRECTS_REDIRECTS_EMPTY: 'Aucune redirection pour le moment.',
    REDIRECTS_SHORTLINKS_EMPTY: 'Aucun raccourci pour le moment.',
    REDIRECTS_ADD_RULE: 'Ajouter une redirection',
    REDIRECTS_CREATE_SHORTLINK: 'Créer un raccourci',
    REDIRECTS_DESTINATION_EMPTY: '(destination à définir)',
    REDIRECTS_DESTINATION_MISSING: 'Destination supprimée',
    REDIRECTS_DESTINATION_MISSING_HELP:
      'La destination de cette redirection a été supprimée : l’ancienne adresse ne redirige plus et affiche une page introuvable. Choisissez une nouvelle destination ou supprimez la règle.',
    REDIRECTS_DESTINATION_MISSING_HELP_SERVICES:
      'La destination de cette redirection a été supprimée. En attendant, les visiteurs sont renvoyés vers votre page de prestations. Choisissez une nouvelle destination ou supprimez la règle.',
    REDIRECTS_DESTINATION_MISSING_HELP_BLOG:
      'La destination de cette redirection a été supprimée. En attendant, les visiteurs sont renvoyés vers vos actualités. Choisissez une nouvelle destination ou supprimez la règle.',
    REDIRECTS_LIMIT_REACHED:
      'Vous avez atteint la limite de {max} redirections et raccourcis. Supprimez-en pour en ajouter de nouveaux.',
    REDIRECTS_COPY: 'Copier le lien',
    REDIRECTS_CUSTOM_DOMAIN_NOTE: `Les redirections fonctionnent uniquement sur votre nom de domaine personnalisé (par ex. votre-domaine.fr), pas sur l’adresse gratuite en .${PROJECT_CONFIG.websites_root_domain}.`,
    REDIRECTS_NO_DOMAIN_WARNING:
      'Vous n’avez pas encore de domaine personnalisé actif. Les redirections et raccourcis ne seront pas actifs tant qu’un domaine n’est pas connecté.',
    REDIRECTS_CONNECT_DOMAIN_CTA: 'Connecter un domaine',
    REDIRECTS_EXTERNAL_PERMANENT_HINT:
      'Redirection permanente vers un site externe : le référencement de cette adresse lui est transféré et les navigateurs la mémorisent. Pour un lien temporaire que vous pourrez repointer, préférez un raccourci.',
    REDIRECTS_SOURCE_LABEL: 'Adresse à rediriger',
    REDIRECTS_SOURCE_PLACEHOLDER: '/ancienne-page',
    REDIRECTS_DESTINATION_LABEL: 'Rediriger vers',
    REDIRECTS_DESTINATION_PLACEHOLDER: '/nouvelle-page ou https://…',
    REDIRECTS_SHORTEN_URL_LABEL: 'Lien à raccourcir',
    REDIRECTS_SHORTEN_URL_PLACEHOLDER: 'https://… (collez votre lien)',
    REDIRECTS_SHORT_LINK_LABEL: 'Votre lien court',
    REDIRECTS_ENABLED_LABEL: 'Active',
    REDIRECTS_DELETE_RULE: 'Supprimer la redirection',
    REDIRECTS_COLLISION_WARNING:
      'Cette adresse correspond à une page existante de votre site : la redirection prendra le dessus sur cette page.',
    REDIRECTS_QR_MODAL_TITLE: 'QR code du lien',
    REDIRECTS_QR_MODAL_DESC:
      'Scannez ce QR code avec un smartphone ou téléchargez-le pour vos supports de communication (flyers, affiches, cartes de visite).',
    REDIRECTS_QR_LINK_FIELD_LABEL: 'Lien encodé dans le QR code',
    REDIRECTS_QR_DOWNLOAD: 'Télécharger le QR code (PNG)',
    REDIRECTS_QR_OPEN: 'Tester le lien',
    REDIRECTS_QR_NEED_DOMAIN: 'Un domaine personnalisé actif est requis pour générer le QR code.',
    REDIRECTS_QR_NEED_DESTINATION: 'Renseignez la destination pour générer le QR code.',
    REDIRECTS_QR_RULE_DISABLED: 'Activez cette règle pour générer le QR code.',
    REDIRECTS_QR_UNSAVED_WARNING: 'Ce lien ne sera actif qu’une fois vos modifications enregistrées.',
    REDIRECTS_COPY_FAILED: 'Impossible de copier le lien.',
  },
  SEO_SCOPE_PAGE: {
    TITLE: 'Périmètre géographique',
    SUBTITLE: 'Choisissez si votre activité est locale (ancrée géographiquement) ou nationale.',
    CARD_LOCAL_TITLE: 'Je travaille localement',
    CARD_LOCAL_BULLET_1: 'Je reçois mes clients ou me déplace dans une zone',
    CARD_LOCAL_BULLET_2: 'Optimisé pour les pros ancrés dans une zone (ville, département, région)',
    CARD_LOCAL_RECOMMENDED_FOR: 'Recommandé pour : coiffeur, ostéo, coach, restaurant…',
    CARD_LOCAL_RECOMMENDED_BADGE: 'Recommandé',
    CARD_NATIONAL_TITLE: 'Je travaille en national',
    CARD_NATIONAL_BULLET_1: 'Je vends en ligne sans ancrage géographique',
    CARD_NATIONAL_BULLET_2: 'Ou chaîne avec plusieurs points de vente',
    CARD_NATIONAL_RECOMMENDED_FOR: 'Recommandé pour : SaaS, B2B national, e-commerce…',
    CARD_NATIONAL_WARNING_HINT: 'Lire le warning avant de sélectionner',
    SELECT_BUTTON: 'Sélectionner',
    CURRENT_SCOPE_LABEL: 'Périmètre actuel',
    CHANGE_SCOPE_BUTTON: 'Modifier le périmètre',
    SECTION_SERVICE_AREAS_TITLE: 'Zones ciblées',
    SECTION_SERVICE_AREAS_HELP:
      'Ajoutez les zones (villes, départements ou régions) où vous proposez votre activité. La première est votre zone principale.',
    SECTION_SERVICE_AREAS_QUESTION: 'Sur quelles villes voulez-vous être trouvé sur Google ?',
    SECTION_SERVICE_AREAS_BENEFIT:
      'Chaque ville ajoutée crée une page optimisée pour le référencement local. La première est votre zone principale.',
    SUGGESTION_LABEL: 'Suggestion',
    ADD_YOUR_CITY_CHIP: 'Ajouter {city} (votre ville)',
    SCOPE_ACTIVE_LOCAL: 'Activité locale',
    SCOPE_ACTIVE_NATIONAL: 'Activité nationale',
    SECTION_PRO_PLACES_TITLE: 'Lieux physiques',
    SECTION_PRO_PLACES_HELP:
      'Activez « Page dédiée » pour publier une page lieu indexée séparément (recommandé pour les chaînes).',
    COLUMN_PUBLISH_DEDICATED_PAGE: 'Page dédiée publiée',
    ADD_AREA_PLACEHOLDER: 'Rechercher une zone…',
    SUGGESTION_FROM_PRO_PLACE: '(votre adresse)',
    PRIMARY_BADGE: 'Principale',
    REMOVE_AREA_BUTTON: 'Supprimer',
    LIMIT_REACHED: 'Limite atteinte.',
    DUPLICATE_AREA: 'Cette zone est déjà dans votre liste.',
    AREA_TYPE_CITY: 'Ville',
    AREA_TYPE_DEPARTMENT: 'Département',
    AREA_TYPE_REGION: 'Région',
    NATIONAL_LABEL_HINT: 'Le périmètre national couvre {country}.',
    MANAGE_AREAS_BUTTON: 'Gérer les zones',
    MANAGE_AREAS_MODAL_TITLE: 'Gérer mes zones d’intervention',
  },
  SEO_SCOPE_WARNING_NATIONAL: {
    TITLE: 'Passer votre site en référencement national',
    INTRO: 'Avant de continuer, voici ce que ça change :',
    CONSEQUENCE_1: 'Votre site ne sera plus optimisé pour les recherches dans votre ville et votre région.',
    CONSEQUENCE_2:
      'Vous risquez de ne plus apparaître dans les résultats Google liés à votre localisation (Maps inclus).',
    CONSEQUENCE_3:
      'Vos villes ciblées seront mises de côté (vous les retrouverez si vous repassez en local plus tard).',
    WARNING_TITLE: 'Être bien référencé au niveau national est beaucoup plus difficile qu’au niveau local.',
    WARNING_BODY:
      'Si vous recevez vos clients dans un lieu précis ou si vous vous déplacez dans une zone, vous risquez de perdre votre référencement actuel sans rien gagner au niveau national.',
    RECOMMENDED_IF_TITLE: 'À choisir uniquement si :',
    RECOMMENDED_IF_1: 'Vous vendez en ligne, partout, sans lieu précis',
    RECOMMENDED_IF_2: 'Vous avez plusieurs établissements (chacun garde sa page locale)',
    RECOMMENDED_IF_3: 'Vous travaillez avec des entreprises partout en France',
    CONFIRM_INSTRUCTION: 'Pour confirmer, tapez « JE CONFIRME » ci-dessous :',
    CONFIRM_TEXT: 'JE CONFIRME',
    CONFIRM_PLACEHOLDER: 'Tapez JE CONFIRME pour activer le bouton',
    CANCEL_BUTTON: 'Annuler',
    CONFIRM_BUTTON: 'Passer en national',
    SUCCESS_TOAST: 'Mode national activé. Vos établissements gardent leurs pages locales si elles étaient publiées.',
  },
  SEO_SCOPE_WARNING_LOCAL: {
    TITLE: 'Repasser en SEO local',
    BODY_1: 'Vos villes ciblées précédemment seront ré-appliquées.',
    BODY_2: 'Le balisage JSON-LD redevient LocalBusiness.',
    CANCEL_BUTTON: 'Annuler',
    CONFIRM_BUTTON: 'Confirmer',
  },
  PROFESSIONAL_APP_SEO_ARTICLES_PAGE: {
    TITLE: 'Articles SEO',
    INTRO:
      'Chaque mois, nous vous proposons des sujets d’articles pour votre site. Validez ceux qui vous plaisent : les articles sont rédigés, puis vous les relisez avant qu’ils ne soient programmés. Rien n’est publié sans votre validation.',
    HIDDEN_FEATURE_BANNER: 'Fonctionnalité en test : visible uniquement avec l’activation.',
    TOPICS_TITLE: 'Sujets du mois',
    TOPICS_MONTH: 'Sujets proposés pour {month}',
    TOPICS_QUOTA: '{count} dates de publication en {month} ({days} à {hour} h).',
    TOPICS_EMPTY: 'Aucun sujet proposé pour le moment.',
    TOPICS_PROPOSE_BUTTON: 'Proposer des sujets',
    TOPICS_PROPOSE_STARTED: 'La recherche de sujets est lancée, revenez dans quelques minutes.',
    TOPICS_PROPOSE_ALREADY_PENDING:
      'Une recherche de sujets est déjà en cours, vos sujets arrivent dans quelques minutes.',
    TOPICS_PROPOSING: 'Recherche de sujets en cours…',
    TOPICS_PROPOSAL_LIMIT_HINT: `Vos ${SEO_CLIENT_DISCOVERIES_PER_MONTH_MAX} recherches de sujets du mois sont utilisées. Besoin d’autres sujets ? Écrivez au support.`,
    TOPICS_MANUAL_LIMIT_HINT: `Vos ${SEO_CLIENT_MANUAL_TOPICS_PER_MONTH_MAX} sujets libres du mois sont utilisés.`,
    TOPICS_MANUAL_LABEL: 'Un sujet en tête ?',
    TOPICS_MANUAL_PLACEHOLDER: 'Ex. : prix d’un balayage à Lyon',
    TOPICS_MANUAL_ADD: 'Ajouter ce sujet',
    TOPICS_MANUAL_HINT: 'Votre sujet est analysé puis rejoint la liste ci-dessus en une ou deux minutes.',
    TOPICS_MANUAL_ADDED: 'Sujet ajouté : il rejoint la liste dès que son analyse est terminée.',
    TOPICS_MANUAL_PENDING: 'Analyse en cours…',
    TOPIC_MANUAL_WHY: 'Sujet que vous avez proposé.',
    TOPIC_MANUAL_SUPPORTS_PAGE: 'Votre page {page} aborde déjà ce sujet : l’article la complétera.',
    TOPICS_PROPOSED_HEADING: 'Sujets proposés',
    TOPICS_DECIDED_HEADING: 'Déjà lancés ce mois-ci',
    TOPICS_YES: 'Oui',
    TOPICS_NO: 'Non',
    TOPICS_REJECTED_LABEL: 'Refusé',
    TOPICS_UNWRITABLE_LABEL: 'Écarté par la rédaction',
    TOPICS_UNDO: 'Annuler',
    TOPICS_WHY: 'Pourquoi ? (facultatif)',
    TOPICS_REJECT_PLACEHOLDER: 'Ex. : nous ne faisons plus cette prestation',
    TOPICS_REASON_HINT: 'Votre raison nous aide à mieux viser les prochains sujets.',
    TOPICS_REASON_SAVE: 'Enregistrer',
    TOPICS_REASON_SAVED: 'Merci, c’est noté.',
    TOPICS_PROGRESS: '{selected} / {total} sujets choisis',
    TOPICS_PROGRESS_EXTRA: '{selected} sujets choisis pour {total} dates : les suivants attendront le mois d’après.',
    TOPICS_LAUNCH_BUTTON:
      '{count, plural, =0 {Valider et lancer la rédaction} one {Valider et lancer la rédaction (# article)} other {Valider et lancer la rédaction (# articles)}}',
    TOPICS_ASK_MORE_BUTTON: 'Demander d’autres sujets',
    TOPICS_WRITING_HEADING: 'Articles en cours de rédaction',
    ENGINE_DISCOVER_TITLE: 'Recherche de vos sujets {of_month}',
    ENGINE_REFILL_TITLE: 'Recherche d’autres sujets {of_month}',
    ENGINE_DISCOVER_STEP_1: 'Lecture de votre site et de vos prestations',
    ENGINE_DISCOVER_STEP_2: 'Analyse de ce que vos clients cherchent sur Google',
    ENGINE_DISCOVER_STEP_3: 'Étude des sites concurrents',
    ENGINE_DISCOVER_STEP_4: 'Sélection des sujets les plus prometteurs',
    ENGINE_DISCOVER_HINT:
      'Quelques minutes. Vous pouvez fermer cette fenêtre : si votre tri n’est pas terminé d’ici {minutes} minutes, nous vous écrivons.',
    ENGINE_WRITE_TITLE:
      '{total, plural, one {Rédaction en cours : {done} / # article} other {Rédaction en cours : {done} / # articles}}',
    ENGINE_WRITE_STEP_1: 'Analyse des pages les mieux placées sur Google',
    ENGINE_WRITE_STEP_2: 'Plan de l’article et mots-clés',
    ENGINE_WRITE_STEP_3: 'Rédaction dans votre ton',
    ENGINE_WRITE_STEP_4: 'Relecture qualité et choix des images',
    ENGINE_WRITE_HINT:
      'Comptez environ une heure. Vous pouvez fermer cette fenêtre : nous vous prévenons dès que vos articles sont prêts à relire.',
    TOPICS_LAUNCH_HINT_CHOOSE:
      '{count, plural, one {Choisissez encore # sujet pour remplir vos dates {of_month}. Dites oui ou non à chaque sujet : vous pourrez ensuite lancer ou en demander d’autres.} other {Choisissez encore # sujets pour remplir vos dates {of_month}. Dites oui ou non à chaque sujet : vous pourrez ensuite lancer ou en demander d’autres.}}',
    TOPICS_LAUNCH_HINT_REFILLING:
      'Nous cherchons d’autres sujets pour compléter vos dates : quelques minutes, vous pourrez lancer juste après.',
    TOPICS_LAUNCH_HINT_SHORT:
      '{count, plural, one {Il manque # sujet pour remplir vos dates {of_month} : demandez d’autres sujets, vos refus guident la recherche. La rédaction ne démarre qu’avec toutes vos dates pourvues.} other {Il manque # sujets pour remplir vos dates {of_month} : demandez d’autres sujets, vos refus guident la recherche. La rédaction ne démarre qu’avec toutes vos dates pourvues.}}',
    TOPICS_LAUNCH_HINT_SHORT_NO_BUDGET:
      '{count, plural, one {Il manque # sujet pour remplir vos dates {of_month} et vos recherches du mois sont utilisées : ajoutez un sujet libre, ou écrivez-nous pour en demander d’autres.} other {Il manque # sujets pour remplir vos dates {of_month} et vos recherches du mois sont utilisées : ajoutez un sujet libre, ou écrivez-nous pour en demander d’autres.}}',
    TOPICS_LAUNCH_HINT_SHORT_SUPPORT:
      '{count, plural, one {Il manque # sujet pour remplir vos dates {of_month} et vos recherches et sujets libres du mois sont utilisés : écrivez-nous, nous vous en proposerons d’autres.} other {Il manque # sujets pour remplir vos dates {of_month} et vos recherches et sujets libres du mois sont utilisés : écrivez-nous, nous vous en proposerons d’autres.}}',
    TOPICS_LAUNCH_HINT_ALL_REJECTED: 'Aucun sujet retenu : demandez-en d’autres, vos refus guident la recherche.',
    TOPICS_LAUNCH_HINT_ALL_REJECTED_NO_BUDGET:
      'Aucun sujet retenu et vos recherches du mois sont utilisées : ajoutez un sujet libre, ou écrivez-nous pour en demander d’autres.',
    TOPICS_LAUNCH_HINT_ALL_REJECTED_SUPPORT:
      'Aucun sujet retenu et vos recherches et sujets libres du mois sont utilisés : écrivez-nous, nous vous en proposerons d’autres.',
    TOPICS_LAUNCH_HINT_SEARCHING: 'Nous cherchons de nouveaux sujets : quelques minutes, vous choisirez juste après.',
    TOPICS_LAUNCH_HINT_READY: 'Tout est choisi : lancez la rédaction, vos articles seront prêts à relire dans l’heure.',
    TOPICS_LAUNCH_HINT_NOTHING: 'Dites oui aux sujets qui vous plaisent, non aux autres.',
    TOPICS_LAUNCHED:
      '{count, plural, one {C’est parti : # article est en cours de rédaction.} other {C’est parti : # articles sont en cours de rédaction.}}',
    TOPICS_CARRIED_OVER:
      '{count, plural, one {# sujet gardé pour le mois suivant.} other {# sujets gardés pour le mois suivant.}}',
    TOPIC_PRIORITY_HIGH: 'Priorité forte',
    TOPIC_PRIORITY_MEDIUM: 'Bonne priorité',
    TOPIC_PRIORITY_LOW: 'À envisager',
    ARTICLES_TITLE: 'Articles à relire',
    ARTICLES_EMPTY: 'Aucun article rédigé pour le moment.',
    ARTICLE_OPEN_PUBLICATION: 'Relire dans le blog',
    ARTICLE_VALIDATE_BUTTON: 'Valider et programmer',
    ARTICLE_VALIDATED: 'Article programmé le {date}.',
    ARTICLE_WORDS: '{count} mots',
    ARTICLE_SCHEDULED_AT: 'Programmé le {date}',
    ARTICLE_PUBLISHED_AT: 'Publié',
    ARTICLE_QA_FAILED: 'Contrôle qualité à revoir',
    CANCEL: 'Annuler',
    CONFIRM: 'Confirmer',
    ACTION_DONE_TOPICS: 'Sujets validés depuis votre e-mail : la rédaction démarre.',
    ACTION_TOPICS_SAVED:
      'Vos sujets sont enregistrés, mais il en manque encore pour remplir vos dates : complétez-les ici, la rédaction démarrera une fois toutes vos dates pourvues.',
    ACTION_DONE_ARTICLES: 'Articles validés depuis votre e-mail : ils sont programmés.',
    ACTION_EXPIRED: 'Ce lien a expiré. Validez directement ici.',
    ACTION_INVALID: 'Ce lien n’est pas valable. Validez directement ici.',
    ACTION_FAILED: 'La validation depuis votre e-mail n’a pas abouti. Réessayez ici.',
    SETTINGS_TITLE: 'Réglages de vos articles',
    SETTINGS_SAVED: 'Réglages enregistrés. Ils s’appliquent aux prochains sujets et articles.',
    // ── Carte du mois (onglet Suivi) : « créneau » ne parle pas aux pros, on dit « date » ──
    PACK_TITLE: 'Vos articles {of_month}',
    // Mois en cours sans aucun article (premier mois du pack, ou aucun sujet validé) : ses dates
    // libres ne seront jamais prises, on ne les montre pas.
    PACK_TITLE_EMPTY: 'Vos articles',
    PACK_EMPTY_MONTH:
      'Aucun article prévu en {month} : vos prochains articles paraîtront en {next_month}, dès que vous aurez choisi vos sujets.',
    PACK_SUBTITLE:
      'Un article paraît sur votre blog chaque {days} à {hour} h. Vous le relisez et le validez avant : rien ne part sans vous.',
    PACK_ARTICLES: 'Dates de publication',
    PACK_USED: '{used} / {total} dates prises',
    PACK_LOST: '{count, plural, one {# date passée sans article} other {# dates passées sans article}}',
    PACK_CTA_TO_REVIEW: '{count, plural, one {# article à valider} other {# articles à valider}}',
    PACK_CTA_TO_REVIEW_HINT: 'Validez avant la date prévue : sinon l’article glisse à la prochaine date libre.',
    PACK_CTA_CHOOSE_TOPICS: 'Trier mes sujets {of_month}',
    PACK_CTA_COMPLETE_TOPICS: 'Compléter mes sujets {of_month}',
    PACK_CTA_VIEW_TOPICS: 'Voir mes sujets {of_month}',
    PACK_CTA_LAUNCH_TOPICS: 'Lancer la rédaction {of_month}',
    PHASE_PROFILE_INCOMPLETE:
      'Votre profil est trop incomplet pour lancer le pack : complétez-le, puis configurez vos articles.',
    PHASE_NOT_ONBOARDED: 'Votre pack attend sa configuration : sujets et lien partenaire démarrent juste après.',
    PHASE_TO_REVIEW:
      '{count, plural, one {# article à valider : relisez-le pour qu’il parte à sa date.} other {# articles à valider : relisez-les pour qu’ils partent à leur date.}}',
    PHASE_WRITING:
      'Rédaction en cours : {done} / {total} articles {of_month} rédigés. Comptez environ une heure, nous vous prévenons dès qu’ils sont prêts.',
    PHASE_DISCOVERING:
      'Recherche de vos sujets {of_month} en cours : nous étudions votre activité et ce que vos clients cherchent sur Google. Quelques minutes.',
    PHASE_REFILLING: 'Nous cherchons d’autres sujets {of_month} pour compléter vos dates. Quelques minutes.',
    PHASE_CHOOSING:
      'Sujets {of_month} : {done} / {total} choisis. La rédaction démarre dès que chacune de vos dates a son sujet.',
    PHASE_READY_TO_LAUNCH: 'Vous avez un sujet pour chaque date {of_month} : lancez la rédaction.',
    PHASE_WAITING_PROPOSALS: 'Les sujets {of_month} vous seront proposés le 10 du mois.',
    PHASE_DISCOVERY_EMPTY:
      'Notre recherche de sujets {of_month} n’a rien donné de pertinent pour votre activité. Notre équipe est prévenue et relance la recherche pour vous.',
    PHASE_ALL_SET: 'Toutes vos dates {of_month} sont pourvues.',
    PACK_CTA_CHOOSE_TOPICS_HINT:
      '{count, plural, =0 {Toutes les dates {of_month} sont prises.} one {# date libre en {month}.} other {# dates libres en {month}.}}',
    PACK_NEXT_NO_TOPICS: 'Les sujets {of_month} vous seront proposés le 10 du mois.',
    PACK_NEXT_PROPOSE: 'Proposer des sujets maintenant',
    PACK_NEXT_PROPOSAL_LIMIT_HINT:
      'Vos recherches de sujets pour {month} sont toutes utilisées. Besoin d’autres sujets ? Écrivez au support.',
    PACK_NEXT_PROPOSING_HINT:
      'Nous étudions votre activité et les recherches de vos clients : vos sujets {of_month} arrivent dans quelques minutes.',
    PACK_SLOT_PUBLISHED: 'Publié',
    PACK_SLOT_SCHEDULED: 'Programmé',
    PACK_SLOT_TO_REVIEW: 'À valider',
    PACK_SLOT_MISSED: 'Non validé à temps',
    PACK_SLOT_LOST: 'Passée sans article',
    PACK_SLOT_FREE: 'Libre',
    PACK_SLOT_IN_PRODUCTION: 'En cours de rédaction',
    PACK_TEASER_TITLE: 'Faites remonter votre site sur Google et dans les IA',
    PACK_TEASER_TEXT:
      'Avec la formule Max, nous rédigeons 2 articles par semaine pour votre blog, et chaque mois un site partenaire publie un article avec un lien vers le vôtre. Vous relisez, vous validez, nous faisons le reste.',
    PACK_TEASER_CTA: 'Découvrir la formule Max',
    // ── Modale de choix des sujets ─────────────────────────────────────────
    TOPICS_MODAL_TITLE: 'Vos sujets {of_month}',
    TOPICS_MODAL_INTRO:
      '{remaining, plural, =0 {Toutes les dates {of_month} sont prises : les sujets gardés attendront le mois d’après.} one {Dites oui ou non à chaque sujet. Dès que vous avez # sujet pour votre date {of_month}, lancez la rédaction.} other {Dites oui ou non à chaque sujet. Dès que vous avez # sujets pour vos # dates {of_month}, lancez la rédaction : les articles sont écrits en une fois.}}',
    TOPICS_MODAL_TEXT:
      '{remaining, plural, =0 {Toutes les dates {of_month} sont prises : les sujets cochés resteront en réserve.} one {Choisissez jusqu’à # sujet : chaque sujet validé est rédigé puis prend une date {of_month}.} other {Choisissez jusqu’à # sujets : chaque sujet validé est rédigé puis prend une date {of_month}.}}',
    // ── Lien du mois (backlink inclus) ────────────────────────────────────
    BACKLINK_PENDING: 'Le lien {of_month} est en préparation.',
    BACKLINK_ANCHOR: 'Texte du lien : « {anchor} »',
    BACKLINK_TARGET: 'Page de votre site : {url}',
    BACKLINK_PUBLISHED_AT: 'Publié le {date}',
    BACKLINK_NONE_YET: 'Votre premier lien arrive ce mois-ci.',
    BACKLINK_FIRST_UPCOMING:
      'Votre premier lien partenaire sera commandé début {month}, avec vos premiers articles : le pack démarre le mois qui suit son activation.',
    // Lien commandé au partenaire, pas encore en ligne (statuts ORDERED / IN_PROGRESS).
    BACKLINK_ORDERED: 'Le lien {of_month} est commandé : un site partenaire rédige l’article.',
    BACKLINK_EXPECTED: 'Publication prévue en {month}',
    BACKLINK_TARGET_REPLACED: 'Page remplacée par votre accueil (la page prévue ne répondait pas).',
    BACKLINK_SOURCE_PENDING: 'Site partenaire en cours de sélection',
    // Mode B : article rédigé pour le site partenaire, à relire avant commande (7 jours).
    BACKLINK_REVIEW_BUTTON: 'Relire et valider',
    BACKLINK_REVIEW_DUE: 'À valider avant le {date}',
    BACKLINK_REVIEW_TITLE: 'Relisez l’article avant son envoi au site partenaire',
    BACKLINK_REVIEW_TEXT:
      'Cet article sera publié tel quel sur le site partenaire, avec le lien vers votre page. Retouchez le titre ou le texte si besoin, puis validez. Sans validation avant le {date}, le lien du mois est perdu.',
    BACKLINK_REVIEW_RULES:
      'Règles du partenaire : entre {min} et {max} mots, au moins {h2} intertitres, pas plus de {links} liens, et le lien vers votre page avec le texte « {anchor} » doit rester en place.',
    BACKLINK_REVIEW_TITLE_LABEL: 'Titre de l’article',
    BACKLINK_REVIEW_BODY_LABEL: 'Texte de l’article',
    BACKLINK_REVIEW_WORDS: '{count} mots',
    BACKLINK_REVIEW_VALIDATE: 'Valider et envoyer au partenaire',
    BACKLINK_REVIEW_VALIDATED: 'Article validé : il part chez le partenaire.',
    BACKLINK_EXPIRED_TEXT: 'Cet article n’a pas été validé à temps : le lien de ce mois n’a pas été commandé.',
    // Espace référencement (modale à onglets de la page du blog)
    SPACE_TITLE: 'Référencement',
    SPACE_DESCRIPTION: 'Vos articles mois par mois, vos backlinks et vos réglages.',
    TAB_ARTICLES: 'Articles',
    TAB_BACKLINKS: 'Backlinks',
    TAB_SETTINGS: 'Réglages',
    BANNER_TITLE: 'Référencement · {month}',
    BANNER_OPEN: 'Articles, backlinks et réglages',
    BANNER_NOT_ONBOARDED: 'Votre pack attend sa configuration : sujets et lien partenaire démarrent juste après.',
    TIMELINE_TITLE: 'Mois par mois',
    TIMELINE_CURRENT: 'Mois en cours',
    TIMELINE_NEXT: 'Mois prochain',
    TIMELINE_TOPICS_PROPOSED: '{count, plural, one {# sujet à choisir} other {# sujets à choisir}}',
    // Mois suivant : les « oui » (retenus, pas encore lancés) et les sujets pas encore tranchés.
    TIMELINE_TOPICS_SELECTED: '{count, plural, one {# sujet retenu} other {# sujets retenus}}',
    TIMELINE_TOPICS_UNDECIDED: '{count, plural, one {# sujet à trier} other {# sujets à trier}}',
    TIMELINE_TOPICS_VALIDATED: '{count, plural, one {# sujet validé} other {# sujets validés}}',
    TIMELINE_TOPICS_REJECTED: '{count, plural, one {# sujet refusé} other {# sujets refusés}}',
    TIMELINE_NO_SLOT: 'Aucun article ce mois-ci.',
    // Onglet Backlinks, trois blocs dans l'ordre : vos liens (données, explication repliée sous le
    // titre), le choix de relecture (réglage), puis les offres.
    BACKLINKS_TITLE: 'Vos liens partenaires',
    BACKLINKS_TEXT:
      'Un lien par mois, inclus dans votre pack : un site partenaire publie chez lui un article qui parle de votre activité et renvoie vers une page de votre site.',
    BACKLINKS_HELP_TOGGLE: 'Pourquoi ces liens comptent',
    BACKLINKS_HELP_WHAT:
      'Un backlink est un lien posé sur un autre site qui renvoie vers le vôtre. Pour Google comme pour les assistants IA (ChatGPT, Gemini…), c’est une recommandation : plus des sites sérieux parlent de vous, plus vous avez de chances d’être proposé quand quelqu’un cherche ce que vous faites.',
    BACKLINKS_HELP_INDEXED:
      '« Vu par les moteurs » veut dire que Google ou Bing a déjà repéré le lien : il compte pour votre visibilité, dans les résultats de recherche comme dans les réponses des assistants IA.',
    // Mode de rédaction des articles partenaires (réglage `backlink_mode`, choisi dans cet onglet).
    BACKLINK_MODE_TITLE: 'Qui relit l’article avant sa publication ?',
    BACKLINK_MODE_TEXT:
      'C’est le site partenaire qui rédige l’article et le publie chez lui. Une fois en ligne, il ne peut plus être modifié. À vous de dire si vous voulez le relire avant.',
    BACKLINK_MODE_AUTO_TEXT:
      'Le partenaire rédige et publie sans attendre votre relecture. C’est le plus efficace : le lien est en ligne dès que l’article paraît.',
    BACKLINK_MODE_AUTO_ACK:
      'Je fais confiance au partenaire : je ne pourrai pas modifier le contenu de l’article une fois publié sur son site.',
    BACKLINK_MODE_REVIEW_TEXT:
      'Le partenaire vous envoie l’article : vous le relisez et le validez avant qu’il le publie.',
    BACKLINK_MODE_REVIEW_WARNING:
      'Moins efficace : l’article attend votre validation, et chaque relecture vous prend du temps. Un article non validé à temps peut décaler le lien du mois.',
    BACKLINK_MODE_SAVED: 'Votre choix est enregistré.',
    BACKLINK_MODE_CHOOSE: 'Choisissez une option pour enregistrer.',
    BACKLINK_INDEXED: 'Vu par les moteurs',
    // Seconde carte : liens entrants constatés dans les index des moteurs (source jamais nommée, plan Bing D1).
    EXTERNAL_BACKLINKS_TITLE: 'Les liens qui pointent déjà vers votre site',
    EXTERNAL_BACKLINKS_TEXT:
      'D’après les index des moteurs de recherche, mis à jour chaque semaine. La liste n’est pas exhaustive : les moteurs ne voient pas tous les liens.',
    EXTERNAL_BACKLINKS_COLLECTING:
      'Nous collectons les liens vers votre site. Revenez dans quelques jours : la première lecture prend un peu de temps.',
    EXTERNAL_BACKLINKS_NONE: 'Aucun lien vers votre site n’a encore été repéré par les moteurs.',
    EXTERNAL_BACKLINKS_STAT_DOMAINS: '{count, plural, one {site référent} other {sites référents}}',
    EXTERNAL_BACKLINKS_STAT_LINKS: '{count, plural, one {lien} other {liens}}',
    EXTERNAL_BACKLINKS_STAT_NEW: '{count, plural, one {nouveau ce mois} other {nouveaux ce mois}}',
    EXTERNAL_BACKLINKS_LAST_SYNC: 'Mis à jour le {date}',
    EXTERNAL_BACKLINKS_FILTER_ALL: 'Tous',
    EXTERNAL_BACKLINKS_FILTER_NEW: 'Nouveaux',
    EXTERNAL_BACKLINKS_FILTER_LOST: 'Perdus',
    EXTERNAL_BACKLINKS_HOST_LINKS: '{count, plural, one {# lien} other {# liens}}',
    EXTERNAL_BACKLINKS_FIRST_SEEN: 'Repéré le {date}',
    EXTERNAL_BACKLINKS_BADGE_NEW: 'Nouveau',
    EXTERNAL_BACKLINKS_BADGE_LOST: 'Perdu',
    EXTERNAL_BACKLINKS_SHOW_ALL: 'Voir tous les liens ({count})',
    EXTERNAL_BACKLINKS_SHOW_LESS: 'Réduire',
    EXTERNAL_BACKLINKS_EMPTY_FILTER: 'Aucun lien dans cette catégorie.',
    SETTINGS_TAB_TEXT: 'Ces consignes guident le choix de vos sujets et la rédaction de vos articles.',
    SETTINGS_LIST_INSTRUCTIONS_WARNING:
      'Certaines lignes ressemblent à des consignes de rédaction : elles seront suivies comme consignes, pas comme sujets.',
    SETTINGS_LIST_INSTRUCTIONS_MOVE: 'Déplacer vers les consignes de rédaction',
    SETTINGS_LIST_INSTRUCTIONS_OVERFLOW:
      'Les consignes de rédaction dépasseraient {max} caractères : raccourcissez-les avant de déplacer ces lignes.',
    SETTINGS_AUTHOR_NONE: 'Votre établissement, au nom de l’équipe',
    SETTINGS_AUTHOR_HINT_MEMBER:
      'Les articles sont signés {name} et parlent en « je ». Le persona ci-dessous se construit sur cette personne.',
    SETTINGS_AUTHOR_HINT_NONE:
      'Les articles parlent au nom de votre établissement, en « nous », sans signature. Choisissez un membre pour qu’ils soient signés de lui et écrits en « je ».',
    SETTINGS_AUTHOR_CHANGE_RESETS:
      'Changer d’auteur remet le persona à zéro : il est régénéré pour le prochain article.',
    SETTINGS_PUBLISH_DAYS_LABEL: 'Jours et heure de publication',
    SETTINGS_PUBLISH_AT: 'à',
    SETTINGS_PUBLISH_HOUR_OPTION: '{hour} h',
    // Rythme inclus (2 par semaine) ; l'option « Doubler mes articles » passe à 4. Le remplacement du
    // plus ancien jour quand on en coche un de trop se voit à l'usage, on ne l'explique pas.
    SETTINGS_PUBLISH_DAYS_INCLUDED:
      '{count, plural, one {# article par semaine inclus dans votre abonnement.} other {# articles par semaine inclus dans votre abonnement.}} Besoin de plus ? L’option « Doubler mes articles » est dans l’onglet Articles.',
    SETTINGS_PUBLISH_DAYS_DOUBLED: '{count} articles par semaine avec votre option « Doubler mes articles ».',
    // ── Parcours de première activation (`seo/bienvenue`) : 4 écrans, le pack ne démarre qu'à la fin ──
    ONBOARDING_TITLE: 'Bienvenue dans votre pack référencement',
    ONBOARDING_DESCRIPTION: 'Quatre questions pour que vos premiers articles vous ressemblent.',
    ONBOARDING_STEP: 'Étape {step} sur {total}',
    ONBOARDING_BLOCKED_HINT:
      'Votre pack démarre à la fin de ce parcours : premiers sujets d’articles, puis premier lien partenaire.',
    ONBOARDING_BANNER_CTA: 'Configurer en 2 minutes',
    ONBOARDING_BANNER_CTA_PROFILE: 'Compléter mon profil',
    // Activation bloquée tant que le profil est trop vide (`profile_gaps`).
    PROFILE_INCOMPLETE_TITLE: 'Complétez votre profil pour démarrer',
    PROFILE_INCOMPLETE_TEXT:
      'Vos articles et vos concurrents se trouvent à partir de votre métier, de vos prestations et de votre ville. Sans eux, nous proposerions des sujets qui ne vous concernent pas. Votre pack démarrera dès que ces informations seront remplies.',
    PROFILE_INCOMPLETE_FIX: 'Compléter',
    PROFILE_INCOMPLETE_REFRESH: 'J’ai complété mon profil',
    ONBOARDING_LATER: 'Plus tard',
    ONBOARDING_BACK: 'Retour',
    ONBOARDING_NEXT: 'Continuer',
    ONBOARDING_FINISH: 'Lancer mes premiers sujets',
    ONBOARDING_SKIP_STEP: 'Passer cette étape',
    // Écran 1 : qui signe.
    ONBOARDING_AUTHOR_TITLE: 'Qui signe vos articles ?',
    ONBOARDING_AUTHOR_TEXT:
      'Un membre de l’équipe : les articles parlent en « je » et prennent sa voix. L’établissement : ils parlent en « nous ». Vous pourrez changer plus tard dans les réglages.',
    ONBOARDING_AUTHOR_ESTABLISHMENT_DESC: 'Les articles parlent au nom de l’équipe, en « nous », sans signature.',
    ONBOARDING_AUTHOR_MEMBER_DESC: 'Les articles sont signés de cette personne et écrits en « je ».',
    // Écran 2 : concurrents.
    ONBOARDING_COMPETITORS_TITLE: 'Qui sont vos concurrents ?',
    ONBOARDING_COMPETITORS_TEXT:
      'Nous lisons ce qu’ils publient pour vous proposer des sujets qu’ils traitent et pas vous. Ils ne sont jamais cités dans vos articles.',
    ONBOARDING_COMPETITORS_FOUND:
      'Trouvés sur Google autour de {area} pour vos prestations : décochez ceux qui ne sont pas des concurrents.',
    ONBOARDING_COMPETITORS_FOUND_NO_AREA:
      'Trouvés sur Google pour vos prestations : décochez ceux qui ne sont pas des concurrents.',
    ONBOARDING_COMPETITORS_NONE_FOUND:
      'Nous n’avons pas trouvé de concurrent évident. Ajoutez-en un si vous en connaissez.',
    ONBOARDING_COMPETITORS_LOADING: 'Recherche de vos concurrents…',
    ONBOARDING_COMPETITORS_ADD_LABEL: 'Un autre concurrent ?',
    ONBOARDING_COMPETITORS_ADD_PLACEHOLDER: 'Ex. : salon-dupont.fr',
    ONBOARDING_COMPETITORS_ADD: 'Ajouter',
    ONBOARDING_COMPETITORS_INVALID: 'Indiquez un nom de domaine, par exemple salon-dupont.fr.',
    ONBOARDING_COMPETITORS_SUGGESTED: 'Trouvé sur Google',
    ONBOARDING_COMPETITORS_SUGGESTED_FOR: 'Trouvé sur Google pour « {query} »',
    ONBOARDING_COMPETITORS_ADDED: 'Ajouté par vous',
    // Écran 3 : articles partenaires (réglage `backlink_mode`, exigé ici ; cartes et case = mêmes clés BACKLINK_MODE_*).
    ONBOARDING_BACKLINK_TITLE: 'Qui relit vos articles partenaires ?',
    ONBOARDING_BACKLINK_TEXT:
      'Chaque mois, un site partenaire publie chez lui un article qui renvoie vers votre site. C’est lui qui rédige et publie : une fois en ligne, l’article ne change plus. Dites-nous si vous voulez le relire avant.',
    // Écran 4 : sujets et jours.
    ONBOARDING_TOPICS_TITLE: 'De quoi parler, et quand ?',
    ONBOARDING_TOPICS_TEXT: 'Tout est facultatif : sans réponse, nous partons de vos prestations et de votre activité.',
    ONBOARDING_FOCUS_TOPICS_LABEL: 'Sujets ou prestations à mettre en avant',
    ONBOARDING_EXCLUDED_TOPICS_LABEL: 'Sujets à ne jamais aborder',
    ONBOARDING_EXCLUDED_TOPICS_PLACEHOLDER: 'Ex. :\nextensions de cils\npromotions',
    ONBOARDING_ONE_PER_LINE: 'Un par ligne.',
    // Fin.
    ONBOARDING_DONE_TITLE: 'C’est parti',
    ONBOARDING_DONE_TEXT:
      'Nous cherchons vos premiers sujets pour {month}. Vous recevrez une notification dès qu’ils sont prêts à être choisis, d’ici quelques minutes.',
    ONBOARDING_DONE_ALREADY:
      'Vos réglages sont enregistrés. Des sujets pour {month} étaient déjà en préparation : vous les trouverez dans l’onglet Articles.',
    ONBOARDING_SAVED_TOAST: 'Réglages enregistrés, vos premiers sujets arrivent.',
    // Offres du pack (seo-upsell-offers.md §3) : effet au 1er du mois suivant, jamais le nom du fournisseur.
    OFFERS_TITLE: 'Aller plus loin',
    OFFER_PRICE_MONTHLY: '{amount} HT / mois',
    OFFER_PRICE_PER_LINK_MONTHLY: '{amount} HT par lien et par mois',
    OFFER_PRICE_ONE_SHOT: '{amount} HT, payé une fois',
    OFFER_SAVED: 'C’est noté.',
    OFFER_ACTIVATE: 'Activer',
    OFFER_MODIFY: 'Modifier',
    OFFER_DEACTIVATE: 'Résilier',
    OFFER_ARTICLES_DOUBLE_TITLE: 'Doubler mes articles',
    OFFER_ARTICLES_DOUBLE_TEXT:
      '4 articles par semaine au lieu de 2, à partir du 1er {month}. Vous validez les sujets et les textes comme aujourd’hui. Sans engagement, résiliable à tout moment.',
    OFFER_ARTICLES_DOUBLE_ACTIVE: 'Option active : 4 articles par semaine.',
    OFFER_ARTICLES_DOUBLE_SCHEDULED: 'Option activée : 4 articles par semaine à partir du 1er {month}.',
    OFFER_ARTICLES_DOUBLE_ENDING: 'Option résiliée : 4 articles par semaine jusqu’à la fin {of_month}.',
    OFFER_EXTRA_BACKLINKS_TITLE: 'Liens supplémentaires',
    OFFER_EXTRA_BACKLINKS_TEXT:
      'Chaque mois, un article sur vous publié sur un site de votre secteur, avec un lien vers votre site. Choisissez combien, à partir du 1er {month}, sans engagement.',
    OFFER_EXTRA_BACKLINKS_CURRENT:
      '{count, plural, one {Option active : # lien supplémentaire par mois.} other {Option active : # liens supplémentaires par mois.}}',
    OFFER_EXTRA_BACKLINKS_NEXT:
      '{count, plural, one {À partir du 1er {month} : # lien supplémentaire par mois.} other {À partir du 1er {month} : # liens supplémentaires par mois.}}',
    OFFER_EXTRA_BACKLINKS_ENDING: 'Option résiliée : dernier mois livré, {month}.',
    OFFER_QUANTITY_LABEL: 'Combien par mois ?',
    OFFER_QUANTITY_TOTAL: '{count, plural, one {# lien : {amount} HT / mois} other {# liens : {amount} HT / mois}}',
    // Au-delà du maximum proposé : pas recommandé, mais ouvert à la discussion avec le support.
    OFFER_EXTRA_BACKLINKS_LIMIT: `Nous ne recommandons pas d’aller au-delà de {max} liens supplémentaires par mois : un rythme trop soutenu peut paraître artificiel aux moteurs. Il vous en faut davantage ? Écrivez-nous à <support>${PROJECT_CONFIG.support_email}</support>, on en discute volontiers.`,
    OFFER_ACCELERATOR_TITLE: 'Accélérateur {months} mois',
    OFFER_ACCELERATOR_TEXT:
      '{links} liens par mois pendant {months} mois, pour lancer ou relancer votre visibilité. Démarre le 1er {month}, se cumule avec vos liens supplémentaires.',
    OFFER_ACCELERATOR_CTA: 'Démarrer l’accélérateur',
    OFFER_ACCELERATOR_RECAP: '{links} liens × {months} mois = {total} liens',
    OFFER_ACCELERATOR_PENDING: 'Accélérateur à partir {of_month}.',
    OFFER_ACCELERATOR_ACTIVE: 'Accélérateur en cours : {published} liens publiés sur {total}, fin {month}.',
    OFFER_ACCELERATOR_COMPLETED: 'Accélérateur terminé : {published} liens publiés sur {total}.',
    OFFER_ACCELERATOR_CANCELLED:
      'Accélérateur interrompu ({published} liens publiés sur {total}) : votre formule Max s’est arrêtée pendant la période.',
    OFFER_ACCELERATOR_PAID: 'Paiement accepté : votre accélérateur démarre le 1er {month}.',
    OFFER_BACKLINKS_NEXT_TOTAL:
      '{count, plural, one {Le mois prochain : # lien au total, pack compris.} other {Le mois prochain : # liens au total, pack compris.}}',
    OFFER_MAX_NOTICE: 'Si votre abonnement Max s’arrête, les liens restants ne sont pas livrés ni remboursés.',
  },
  PROFESSIONAL_APP_MARKETING_PAGE: {
    SENDER_PENDING_NOTICE:
      'Votre adresse d’expédition {email} est en cours d’activation. Les campagnes e-mail envoyées d’ici là partiront automatiquement dès qu’elle sera prête.',
    SEND_DEFERRED_SENDER_PENDING_TITLE: 'Envoi programmé',
    SEND_DEFERRED_SENDER_PENDING_DESC:
      'Votre campagne partira automatiquement dès que votre adresse d’expédition sera prête.',
    TITLE: 'Communication',
    TAB_CAMPAGNES: 'Campagne marketing',
    TAB_PUBLICATIONS: 'Blog & référencement',
    TAB_PROMOTIONS: 'Promotions',
    TAB_NOTIFICATIONS: 'Messages automatiques',
    TAB_REVIEWS: 'Avis Google',
    SETTINGS_BUTTON_LABEL: 'Paramètres',
    NOTIFICATIONS_AUDIENCE_CUSTOMER: 'Client',
    NOTIFICATIONS_AUDIENCE_PRO: 'Vous',
    NOTIFICATIONS_CHANNEL_EMAIL: 'Email',
    NOTIFICATIONS_CHANNEL_SMS: 'SMS',
    NOTIFICATIONS_CHANNEL_PUSH: 'Push',
    NOTIFICATIONS_CHANNEL_IN_APP: 'In-app',
    NOTIFICATIONS_ENABLED: 'Activé',
    NOTIFICATIONS_DISABLED: 'Désactivé',
    NOTIFICATIONS_MARKETING_BADGE: 'Marketing',
    NOTIFICATIONS_REVIEW_REQUEST_WARNING_TITLE: "Conditions d'envoi des demandes d'avis",
    NOTIFICATIONS_REVIEW_REQUEST_WARNING_DESC:
      "Les demandes d'avis renvoient vers une fiche Google My Business. Tant qu'aucune fiche n'est synchronisée, aucune demande d'avis ne partira.",
    NOTIFICATIONS_REVIEW_REQUEST_WARNING_CTA: 'Configurer Google My Business',
    NOTIFICATIONS_REVIEW_REQUEST_WARNING_CTA_PLACE: 'Lier une fiche à un lieu',
    NOTIFICATIONS_REVIEW_REQUEST_WARNING_SHORT:
      "Aucune demande d'avis ne part tant qu'aucune fiche Google My Business n'est synchronisée.",
    NOTIFICATIONS_REVIEW_REQUEST_UNLINKED_SINGLE_TITLE: 'Fiche Google non liée à un lieu',
    NOTIFICATIONS_REVIEW_REQUEST_UNLINKED_SINGLE_DESC:
      "Vos demandes d'avis renvoient vers votre fiche Google My Business. Liez-la au lieu correspondant pour sécuriser cette destination.",
    NOTIFICATIONS_REVIEW_REQUEST_UNLINKED_SINGLE_SHORT:
      'Envoyées vers votre fiche Google My Business. Liez-la à un lieu pour sécuriser cette destination.',
    NOTIFICATIONS_REVIEW_REQUEST_UNLINKED_MULTIPLE_TITLE: 'Plusieurs fiches Google, aucune liée à un lieu',
    NOTIFICATIONS_REVIEW_REQUEST_UNLINKED_MULTIPLE_DESC:
      "Vous avez {count} fiches Google My Business et aucune n'est liée à un lieu : vos demandes d'avis renvoient vers l'une d'elles, choisie automatiquement. Liez chaque fiche au lieu correspondant pour choisir vous-même.",
    NOTIFICATIONS_REVIEW_REQUEST_TOP_BAR:
      '{count} fiches Google My Business, aucune liée à un lieu : choisissez vers quelle page Google My Business envoyer vos avis.',
    NOTIFICATIONS_REVIEW_REQUEST_UNLINKED_MULTIPLE_SHORT:
      "{count} fiches Google My Business, aucune liée à un lieu : la destination des demandes d'avis est choisie automatiquement.",
    NOTIFICATIONS_SEQUENCES_TITLE: 'Séquences',
    NOTIFICATIONS_ADD_SEQUENCE: 'Ajouter une séquence',
    NOTIFICATIONS_DELAY_BEFORE_MINUTES: 'Délai avant le rdv',
    NOTIFICATIONS_DELAY_AFTER_MINUTES: 'Délai après le rdv',
    NOTIFICATIONS_DELAY_IMMEDIATE: 'immédiat',
    NOTIFICATIONS_DELAY_MINUTES_SHORT: '{minutes} min',
    NOTIFICATIONS_DELAY_HOURS_SHORT: '{hours} h',
    NOTIFICATIONS_DELAY_HOURS_MINUTES_SHORT: '{hours} h {minutes}',
    NOTIFICATIONS_DELAY_DAYS_SHORT: '{days} j',
    NOTIFICATIONS_DELAY_DAYS_HOURS_SHORT: '{days} j {hours} h',
    NOTIFICATIONS_DELAY_SUMMARY_BEFORE: '{channel} {delay} avant',
    NOTIFICATIONS_DELAY_SUMMARY_AFTER: '{channel} {delay} après',
    NOTIFICATIONS_DELAY_SUMMARY_PLAIN: '{channel} {delay}',
    NOTIFICATIONS_DELAY_UNIT_MINUTES: 'minutes',
    NOTIFICATIONS_DELAY_UNIT_HOURS: 'heures',
    NOTIFICATIONS_DELAY_UNIT_DAYS: 'jours',
    NOTIFICATIONS_SAVE: 'Enregistrer',
    NOTIFICATIONS_SAVED: 'Préférences enregistrées',
    NOTIFICATIONS_BACK: 'Retour',
    NOTIFICATIONS_BELL_TITLE: 'Notifications',
    NOTIFICATIONS_BELL_UNREAD_LABEL: 'Notifications, {count} {count, plural, =1 {non lue} other {non lues}}',
    NOTIFICATIONS_EMPTY: 'Aucune notification',
    NOTIFICATIONS_VIEW_ALL: 'Tout marquer comme lu',
    NOTIFICATIONS_HISTORY_TITLE: 'Historique des notifications',
    NOTIFICATIONS_HISTORY_EMPTY: 'Aucune notification envoyée à ce client',
    NOTIFICATIONS_LOAD_MORE: 'Charger plus',
    NOTIFICATIONS_RESEND: 'Renvoyer',
    NOTIFICATIONS_RESEND_SUCCESS: "Renvoi en cours. Le résultat apparaîtra dans l'historique dans quelques secondes.",
    NOTIFICATIONS_MANAGE_PREFERENCES: 'Gérer mes notifications',
    NOTIFICATIONS_STATUS_SENT: 'Envoyée',
    NOTIFICATIONS_STATUS_DELIVERED: 'Délivrée',
    NOTIFICATIONS_STATUS_FAILED: 'Échec',
    NOTIFICATIONS_STATUS_SKIPPED: 'Ignorée',
    NOTIFICATIONS_STATUS_QUEUED: 'En attente',
    NOTIFICATIONS_CUSTOMIZE: 'Voir / Modifier',
    NOTIFICATIONS_VIEW: 'Voir',
    NOTIFICATIONS_EDIT: 'Modifier',
    NOTIFICATIONS_UPSELL_BANNER_TITLE: 'Personnalisez vos notifications',
    NOTIFICATIONS_UPSELL_BANNER_DESC:
      "Adaptez le contenu, le timing et les relances de vos messages à votre image avec l'option Marque blanche.",
    NOTIFICATIONS_UPSELL_CTA: 'Option Marque blanche',
    NOTIFICATIONS_UPSELL_LATER: 'Plus tard',
    NOTIFICATIONS_RESET: 'Réinitialiser',
    NOTIFICATIONS_USING_DEFAULT: 'Modèle par défaut',
    NOTIFICATIONS_USING_CUSTOM: 'Modèle personnalisé',
    NOTIFICATIONS_READONLY_NO_CUSTOM: 'Aucun message personnalisé. Cliquez sur « Modifier » pour en créer un.',
    NOTIFICATIONS_SHOWING_DEFAULT_TEMPLATE:
      "Vous consultez le modèle par défaut envoyé aujourd'hui. Cliquez sur « Modifier » pour le personnaliser.",
    NOTIFICATIONS_DEFAULT_TEMPLATE_PREVIEW: 'Aperçu du modèle par défaut',
    NOTIFICATIONS_EMAIL_IN_CONSTRUCTION: 'Éditeur email (en construction)',
    NOTIFICATIONS_EMAIL_IN_CONSTRUCTION_DESC:
      "L'éditeur email complet (composants drag-and-drop, styles, preview) arrive dans une prochaine itération. En attendant le modèle par défaut sera utilisé à l'envoi.",
    NOTIFICATIONS_EVENT_LABEL: 'Événement',
    NOTIFICATIONS_SEQUENCE_LABEL: 'Séquence',
    NOTIFICATIONS_CUSTOMIZE_SMS_TITLE: 'Personnaliser le SMS',
    NOTIFICATIONS_CUSTOMIZE_EMAIL_TITLE: "Personnaliser l'email",
    NOTIFICATIONS_CUSTOMIZE_PUSH_TITLE: 'Personnaliser la notification push',
    NOTIFICATIONS_SMS_PLACEHOLDER: 'Saisissez votre message SMS et insérez des variables…',
    NOTIFICATIONS_PUSH_TITLE_LABEL: 'Titre',
    NOTIFICATIONS_PUSH_BODY_LABEL: 'Corps',
    NOTIFICATIONS_PUSH_PREVIEW_TITLE: 'Titre de la notification',
    NOTIFICATIONS_PUSH_PREVIEW_BODY: 'Corps de la notification…',
    NOTIFICATIONS_EMAIL_SUBJECT_LABEL: 'Sujet',
    NOTIFICATIONS_EMAIL_BODY_LABEL: 'Contenu (HTML simple autorisé)',
    NOTIFICATIONS_EMAIL_BODY_HELP:
      'Vous pouvez utiliser <strong>, <em>, <p>, <br>, <a href>. Un en-tête et un pied automatique seront ajoutés.',
    NOTIFICATIONS_EMAIL_PREVIEW_LABEL: 'Aperçu',
    NOTIFICATIONS_CHANNEL: 'Canal',
    NOTIFICATIONS_INSERT_VARIABLE: 'Insérer une variable',
    NOTIFICATIONS_SMS_ACCENTS_AUTO_STRIPPED:
      "Les accents seront retirés automatiquement à l'envoi (« août » → « aout ») : cela évite l'encodage UCS-2 (70 car./segment au lieu de 160) et économise un SMS.",
    NOTIFICATIONS_SMS_ESTIMATION_NOTE:
      'Estimation basée sur des valeurs types (voir les exemples dans le menu @). La longueur réelle varie selon les données.',
    NOTIFICATIONS_CUSTOMER_RESTRICTION_REASON: 'Raison :',
    // Motifs de skip du guard/quota backend (notification_log.error_message).
    // Les clés miroir des tokens émis par notification-recipient-guard.service.ts
    // et notification-quota.service.ts — un token inconnu s'affiche brut.
    NOTIFICATIONS_SKIP_REASON_MISSING_EMAIL: 'adresse email manquante',
    NOTIFICATIONS_SKIP_REASON_EMAIL_BLACKLISTED: 'adresse email bloquée',
    NOTIFICATIONS_SKIP_REASON_CUSTOMER_REFUSED_EMAIL: 'le client a refusé les emails',
    NOTIFICATIONS_SKIP_REASON_MISSING_PHONE: 'numéro de téléphone manquant',
    NOTIFICATIONS_SKIP_REASON_PHONE_NOT_MOBILE: "le numéro n'est pas un mobile (SMS impossible)",
    NOTIFICATIONS_SKIP_REASON_PHONE_BLACKLISTED: 'numéro de téléphone bloqué',
    NOTIFICATIONS_SKIP_REASON_CUSTOMER_REFUSED_SMS: 'le client a refusé les SMS',
    NOTIFICATIONS_SKIP_REASON_CUSTOMER_MARKETING_SMS_DISABLED: 'SMS marketing désactivés sur la fiche client',
    NOTIFICATIONS_SKIP_REASON_INSUFFICIENT_QUOTA: 'quota de crédits insuffisant',
    NOTIFICATIONS_SKIP_REASON_MISSING_QUOTA_CONFIG: 'configuration de quota manquante',
    NOTIFICATIONS_SKIP_REASON_SENDING_BLOCKED: 'envois bloqués sur le compte',
    NOTIFICATIONS_SKIP_REASON_NOT_IN_WHITELIST: 'destinataire hors liste blanche (environnement de test)',
    NOTIFICATIONS_EMAIL_EDITOR_DESC: "Éditeur d'email personnalisé",
    NOTIFICATIONS_SMS_EDITOR_DESC: 'Éditeur de SMS personnalisé',
    NOTIFICATIONS_PUSH_EDITOR_DESC: 'Éditeur de notification push personnalisé',
    NOTIFICATIONS_EVENT_DETAIL_DESC: 'Configurer les canaux et les messages pour ce type de notification.',
    NOTIFICATIONS_VAR_GROUP_PRO: 'Pro',
    NOTIFICATIONS_VAR_GROUP_CUSTOMER: 'Client',
    NOTIFICATIONS_VAR_GROUP_APPOINTMENT: 'Rendez-vous',
    NOTIFICATIONS_VAR_GROUP_REVIEW: 'Avis',
    NOTIFICATIONS_VAR_GROUP_VOUCHER: 'Bon cadeau',
    NOTIFICATIONS_VAR_GROUP_PAYMENT: 'Paiement',
    NOTIFICATIONS_VAR_LABEL_PRO_NAME: 'Nom pro',
    NOTIFICATIONS_VAR_LABEL_PRO_PHONE: 'Téléphone pro',
    NOTIFICATIONS_VAR_LABEL_PRO_EMAIL: 'Email pro',
    NOTIFICATIONS_VAR_LABEL_PRO_ADDRESS: 'Adresse pro',
    NOTIFICATIONS_VAR_LABEL_CUSTOMER_FIRSTNAME: 'Prénom client',
    NOTIFICATIONS_VAR_LABEL_CUSTOMER_LASTNAME: 'Nom client',
    NOTIFICATIONS_VAR_LABEL_APPOINTMENT_DATETIME: 'Date + heure rdv',
    NOTIFICATIONS_VAR_LABEL_APPOINTMENT_DATE: 'Date rdv',
    NOTIFICATIONS_VAR_LABEL_APPOINTMENT_PRESTATIONS: 'Prestations',
    NOTIFICATIONS_VAR_LABEL_APPOINTMENT_LOCATION: 'Lieu',
    NOTIFICATIONS_VAR_LABEL_APPOINTMENT_MEETING_LINK: 'Lien visio',
    NOTIFICATIONS_VAR_LABEL_APPOINTMENT_PHONE_NUMBER: 'Numéro de téléphone',
    NOTIFICATIONS_VAR_LABEL_APPOINTMENT_MANAGE_URL: 'Lien gestion rdv',
    NOTIFICATIONS_VAR_LABEL_REVIEW_URL: 'Lien avis',
    NOTIFICATIONS_VAR_LABEL_VOUCHER_CODE: 'Code bon cadeau',
    NOTIFICATIONS_VAR_LABEL_VOUCHER_AMOUNT: 'Montant bon',
    NOTIFICATIONS_VAR_LABEL_VOUCHER_USED_AMOUNT: 'Montant utilisé / rechargé',
    NOTIFICATIONS_VAR_LABEL_VOUCHER_REMAINING_AMOUNT: 'Solde restant',
    NOTIFICATIONS_VAR_LABEL_PAYMENT_AMOUNT: 'Montant paiement',
    NOTIFICATIONS_VAR_LABEL_PAYMENT_URL: 'Lien de paiement',
    CREATE_ANY_CAMPAIGN: 'Créer une campagne',
    CREATE_SMS_CAMPAIGN: 'Campagne SMS',
    CREATE_EMAIL_CAMPAIGN: 'Campagne Email',
    UPSELL_TITLE: 'Fidélisez vos clients avec des campagnes',
    UPSELL_DESCRIPTION:
      'Lancez des campagnes Email et SMS ciblées pour relancer vos clients, annoncer vos promotions et remplir votre agenda.',
    UPSELL_BENEFIT_1: 'Campagnes Email et SMS illimitées vers vos segments de clients',
    UPSELL_BENEFIT_2: 'Ciblage par étiquettes et statistiques d’ouverture et de clics',
    UPSELL_BENEFIT_3: 'Planification à l’avance et envois automatisés',
    DELETE_PRO_CAMPAIGN_SMS_MODAL_TITLE: 'Supprimer la campagne SMS',
    DELETE_PRO_CAMPAIGN_SMS_MODAL_TEXT: 'Êtes-vous sûr de vouloir supprimer cette campagne SMS ?',
    DELETE_PRO_CAMPAIGN_EMAIL_MODAL_TITLE: 'Supprimer la campagne Email',
    DELETE_PRO_CAMPAIGN_EMAIL_MODAL_TEXT: 'Êtes-vous sûr de vouloir supprimer cette campagne Email ?',
    SAVE_DRAFT: 'Enregistrer le brouillon',
    CREATE_EMAIL_NEXT: 'Créer et éditer le contenu',
    DRAFT: 'Brouillon',
    SCHEDULED: 'Planifiée',
    SENDING: "En cours d'envoi",
    TREAT_SENDING: "En cours d'envoi",
    SENT: 'Envoyée',
    EDIT_EMAIL_CONTENT: 'Editer',
    SEE_CAMPAIGN_CONTENT: 'Voir',
    SEND_CAMPAIGN: 'Envoyer',
    SEND_TEST_CAMPAIGN: 'Envoyer un test',
    SEND_TEST_CAMPAIGN_TITLE: 'Envoyer un test',
    VERIFY_RENDER_OR_TEST: 'Vérifier le rendu / Envoyer un test',
    SEND_TEST_CAMPAIGN_HINT:
      "Les variables client (prénom, nom…) affichent des valeurs d'exemple. Ce test consomme 1 crédit, comme un envoi réel.",
    SEND_TEST_CAMPAIGN_SUCCESS_TITLE: 'Test envoyé',
    SEND_TEST_CAMPAIGN_SUCCESS_EMAIL:
      "L'email de test a bien été envoyé à <b>{recipient}</b>. Il peut mettre quelques minutes à arriver : pensez à vérifier vos courriers indésirables.",
    SEND_TEST_CAMPAIGN_SUCCESS_SMS: 'Le SMS de test a bien été envoyé au <b>{recipient}</b>.',
    SEND_TEST_CAMPAIGN_RECIPIENT_PLACEHOLDER_EMAIL: 'votre@email.com',
    SEND_TEST_CAMPAIGN_RECIPIENT_PLACEHOLDER_SMS: '06 12 34 56 78',
    NO_EMAIL_CONTENT_CONFIGURED: 'Aucun contenu email configuré',
    SCHEDULE_CAMPAIGN: 'Programmer',
    UNSCHEDULE_CAMPAIGN: 'Déprogrammer',
    UNSCHEDULE_CAMPAIGN_CONFIRM_TITLE: 'Déprogrammer la campagne',
    UNSCHEDULE_CAMPAIGN_CONFIRM_TEXT: 'La campagne repassera en brouillon.',
    ALERT_TITLE_SEND_CAMPAIGN: 'Envoi campagne',
    ALERT_TEXT_CONFIRM_SEND_CAMPAIGN: `{count, plural, =0 {Aucun destinataire pour les tags sélectionnés.} one {En confirmant, la campagne sera envoyée à un 1 destinataire et entraînera un coût de {cost} {channel}.} other {En confirmant, la campagne sera envoyée aux # destinataires et entraînera un coût de {cost} {channel}.}}`,
    EMAIL_CAMPAIGN_STATS_CLICK: 'cliques',
    EMAIL_CAMPAIGN_STATS_OPEN: 'ouvertures',
    EMAIL_CAMPAIGN_STATS_DELIVERED: 'délivrés',
    ESTIMATION_NO_SELECT_TAGS: 'Sélectionnez au moins un tag saisissez le message pour estimer le coût de la campagne.',
    ESTIMATION_TAGS_SELECTED_NO_RECIPIENT: 'Pas de destinataire correspondant aux tags sélectionnés.',
    SMS_ESTIMATION_TAGS_DETAILS_RECIPIENT: 'destinataire(s) pour',
    SMS_ESTIMATION_TAGS_DETAILS_CREDIT: 'crédit(s)',
    ESTIMATION_TOTAL_CREDITS: 'Nombre total de crédit(s):',
    INPUT_TITLE_PRO_SMS_TRACK_LINKS: 'Suivre les clics sur les liens',
    INPUT_TOOLTIP_PRO_SMS_TRACK_LINKS:
      "Lorsque le suivi est activé, vos liens seront raccourcis pour permettre le suivi des clics. L'URL visible dans le SMS sera modifiée.",
    SMS_ENCODING_GSM7_LABEL: 'Standard',
    SMS_ENCODING_GSM7_TOOLTIP: 'Encodage standard (GSM-7) : 160 caractères par SMS',
    SMS_ENCODING_UCS2_LABEL: 'Spéciaux',
    SMS_ENCODING_UCS2_TOOLTIP:
      'Votre message contient des caractères spéciaux (Unicode) : la limite passe à 70 caractères par SMS',
    SMS_UCS2_WARNING:
      "Votre message contient des caractères spéciaux qui réduisent la capacité de 160 à 70 caractères par SMS. Cela peut augmenter le coût d'envoi.",
    SMS_UCS2_WARNING_LINK: 'Voir les caractères concernés',
    SMS_EMOJI_REMOVED_WARNING:
      "Les emojis ne passent pas par SMS : ils seront retirés de votre message à l'envoi, comme dans l'aperçu.",
    SMS_AUTO_REPLACE_LABEL: 'Remplacer automatiquement les caractères spéciaux',
    SMS_MESSAGE_TOO_LONG: 'Message trop long',
    SMS_PREVIEW_LABEL: 'Aperçu du message envoyé',
    SMS_NO_PRICE_TITLE: 'Aucun pays SMS autorisé',
    SMS_NO_PRICE_DESC: 'Sélectionne au moins un pays pour pouvoir estimer le coût et envoyer des campagnes SMS.',
    SMS_GO_TO_SUBSCRIPTION: 'Configurer les pays autorisés',
    ERROR_PLANIFIED_NO_RECIPIENT_TO_SEND:
      "Aucun destinataire trouvé lors de l'envoi. Vérifiez vos tags et fiches client pour envoyer cette campagne.",
    ERROR_PLANIFIED_INSUFFICIENT_SMS_QUOTA:
      "Crédit SMS insuffisant pour l'envoi de la campagne. Veuillez recharger votre compte SMS en cliquant ici.",
    ERROR_PLANIFIED_INSUFFICIENT_EMAIL_QUOTA:
      "Crédit Email insuffisant pour l'envoi de la campagne. Veuillez recharger votre compte Email en cliquant ici.",
    ERROR_PLANIFIED_CAMPAIGN_PROMO_BINDING_MISMATCH:
      "La promotion jointe à cette campagne n'est plus utilisable (en pause, supprimée, terminée ou épuisée), ou le message cite une promotion sans en avoir de jointe, ou une promotion à codes personnels sans sa variable de code, ou la variable « Code promo du client » sans promotion à codes personnels jointe (retirez la variable, ou joignez une promotion à codes personnels) : cette campagne n'est pas partie. Modifiez-la puis relancez-la.",
    ERROR_PLANIFIED_PROVIDER_SEND_FAILED:
      "L'envoi a été refusé par notre prestataire d'envoi : cette campagne n'est pas partie et aucun crédit n'a été consommé. Relancez-la, et contactez le support si le refus se répète.",
    ERROR_SENDING_UNCONFIRMED:
      'L’envoi de cette campagne n’a pas pu être confirmé par notre prestataire : les messages sont peut-être partis et les crédits correspondants restent décomptés pour l’instant. Pour éviter un double envoi, elle ne peut pas être relancée. Son issue est en cours de vérification : si rien n’est parti, la campagne redeviendra un brouillon et vos crédits vous seront rendus. Si elle reste dans cet état, contactez le support.',
    ERROR_PLANIFIED_SENDING_BLOCKED_DURING_TRIAL:
      "Les campagnes marketing sont indisponibles pendant l'essai ou tant que le compte n'est pas régularisé. Choisissez une formule pour les activer.",
    ERROR_DATE_TRIED: 'Tentative le',
    UNSUBSCRIBE_EMAIL_TEXT: 'Si vous ne souhaitez plus recevoir ces e-mails, ',
    UNSUBSCRIBE_EMAIL_LINK: 'cliquez ici pour vous désabonner',
    NOT_FOUND_TITLE: '404 Introuvable',
    NOT_FOUND_TEXT: "La page que vous cherchez n'existe pas",
    UNSUBSCRIBED_SUCCESS_TITLE: 'Désabonnement réussi',
    UNSUBSCRIBED_SUCCESS_TEXT: 'Vous ne recevrez plus de campagnes marketing par email de notre part.',
    RELOAD_TITLE: 'Recharger crédit',
    NOT_ENOUGH_CREDITS_TITLE: 'Crédit insuffisant',
    NOT_ENOUGH_CREDITS_DESC:
      'Votre crédit est insuffisant pour envoyer cette campagne. Veuillez recharger votre compte.',
    CHECK_QUOTA: 'Consulter quota',
    ALL_CUSTOMERS_TAG: 'Tous les clients',
    CREATE_PUBLICATION: 'Créer une publication',
    DELETE_PUBLICATION_TITLE: 'Supprimer la publication',
    DELETE_PUBLICATION_TEXT: 'Êtes-vous sûr de vouloir supprimer cette publication ?',
    EMPTY_PUBLICATIONS_TITLE: 'Créez votre première publication',
    EMPTY_PUBLICATIONS_TEXT: 'Publiez des actualités sur votre site professionnel pour informer vos clients.',
    NEWS_TAG_CARD_TITLE: 'Catégories',
    ADD_NEWS_TAG: 'Ajouter une catégorie',
    EDIT_NEWS_TAG: 'Modifier la catégorie',
    MANAGE_NEWS_TAGS: 'Gérer les catégories',
    MANAGE_NEWS_TAGS_DESCRIPTION:
      'Renommez, recolorez ou supprimez vos catégories. Les articles ne sont jamais supprimés avec elles.',
    NO_NEWS_TAGS: 'Aucune catégorie pour le moment.',
    NO_NEWS_TAGS_HINT: 'Créez vos rubriques (« Conseils », « Coulisses »…) avant de rédiger vos articles.',
    NEWS_TAG_ARTICLES_COUNT: '{count, plural, =0 {Aucun article} one {# article} other {# articles}}',
    BACK_TO_NEWS_TAGS: 'Retour aux catégories',
    ALL_NEWS_TAGS: 'Toutes les catégories',
    DELETE_NEWS_TAG_TITLE: 'Supprimer la catégorie',
    DELETE_NEWS_TAG_TEXT: 'Êtes-vous sûr de vouloir supprimer cette catégorie ?',
    DELETE_NEWS_TAG_TEXT_IN_USE:
      '{count, plural, one {# article utilise cette catégorie et la perdra} other {# articles utilisent cette catégorie et la perdront}}. Les articles eux-mêmes ne sont pas supprimés. Continuer ?',
    PUBLICATION_TO_REVIEW: 'À valider',
    PUBLICATION_PLANNED_AT: 'prévu le {date}',
    PUBLICATION_SEO_ORIGIN: 'Rédigé pour vous',
    SEO_SCORE_TIPS_COUNT: '{count, plural, one {# conseil} other {# conseils}}',
    SEO_SCORE_SHOW_TIPS: 'Voir les conseils',
    SEO_SCORE_HIDE_TIPS: 'Masquer les conseils',
    SEO_SCORE_PANEL_TITLE: 'Note SEO / GEO de cet article',
    SEO_SCORE_EMPTY: 'La note apparaîtra dès les premières lignes de l’article.',
    SEO_SCORE_PANEL_TEXT:
      'Note indicative calculée sur le texte, la structure, la lisibilité, les liens et les images. Elle se met à jour pendant que vous écrivez ; ce n’est pas une garantie de position sur Google ni dans les réponses des assistants IA.',
    SEO_SCORE_NO_KEYWORD:
      'Renseignez un mot-clé cible dans les paramètres avancés pour évaluer aussi le ciblage de l’article.',
    SEO_SCORE_TIPS_TITLE: 'Ce qui ferait progresser la note',
    SEO_SCORE_ALL_GOOD: 'Rien à signaler : les règles évaluées sont toutes respectées.',
    SEO_SCORE_CTA_TOO_MANY:
      'Trop d’appels à l’action ({count}) : gardez-en un ou deux dans tout l’article, FAQ comprise.',
    SEO_SCORE_CTA_NONE:
      'Aucun appel à l’action : terminez par une invitation, par exemple « Vous pouvez réserver en ligne ».',
    SEO_SCORE_TIP_SPOTTED: 'Repéré ici :',
    STATUS_FILTER_ALL: 'Tous',
    STATUS_FILTER_TO_REVIEW: 'À valider',
    STATUS_FILTER_SCHEDULED: 'Programmés',
    STATUS_FILTER_PUBLISHED: 'Publiés',
    STATUS_FILTER_DRAFT: 'Brouillons',
    STATUS_FILTER_ARCHIVED: 'Archivés',
    PUBLICATION_DRAFT: 'Brouillon',
    PUBLICATION_SCHEDULED: 'Planifiée',
    PUBLICATION_PUBLISHED: 'Publiée',
    PUBLICATION_ARCHIVED: 'Archivée',
    PUBLISH_PUBLICATION: 'Publier',
    PUBLISH_CONFIRM_TITLE: 'Publier la publication',
    PUBLISH_CONFIRM_TEXT: 'Êtes-vous sûr de vouloir publier cette publication ? Elle sera visible par vos clients.',
    PUBLISH_CONFIRM_TEXT_WITH_GMB:
      'Cette publication sera visible par vos clients et postée sur vos fiches Google My Business.',
    PUBLISH_CONFIRM_TEXT_WITH_GMB_NO_ACCOUNT:
      'Vous avez activé le partage Google mais aucun compte Google n’est connecté. L’article sera visible sur votre site mais ne pourra pas être posté sur Google.',
    PUBLISH_CONFIRM_TEXT_WITH_GMB_NO_LOCATION:
      'Vous avez activé le partage Google mais aucune fiche d’établissement n’est exploitable sur votre compte connecté. L’article sera visible sur votre site mais ne pourra pas être posté sur Google.',
    GMB_DISTRIBUTION_PENDING: 'GMB en attente',
    GMB_DISTRIBUTION_SENDING: 'GMB en cours',
    GMB_DISTRIBUTION_SENT: 'GMB envoyé',
    GMB_DISTRIBUTION_ERROR: 'GMB erreur',
    GMB_DISTRIBUTION_NO_ACCOUNT: 'GMB non connecté',
    GMB_DISTRIBUTION_NO_LOCATION: 'GMB sans fiche exploitable',
    GMB_DISTRIBUTION_STUCK: 'GMB interrompu',
    RETRY_GMB_DISTRIBUTION: 'Republier sur Google My Business',
    RETRY_GMB_SUCCESS: 'Publication Google relancée avec succès',
    RETRY_GMB_FAILED: 'La republication sur Google a de nouveau échoué. Consultez le statut de la publication.',
    RETRY_GMB_NO_ACCOUNT:
      'Aucun compte Google connecté. Connectez votre compte Google My Business depuis vos paramètres d’intégration.',
    RETRY_GMB_NO_LOCATION:
      'Votre compte Google est bien connecté mais aucune fiche d’établissement n’est exploitable. Relancez la synchronisation depuis vos paramètres d’intégration.',
    SCHEDULE_PUBLICATION: 'Programmer la publication',
    UNSCHEDULE_PUBLICATION: 'Déprogrammer',
    UNSCHEDULE_CONFIRM_TITLE: 'Déprogrammer la publication',
    UNSCHEDULE_CONFIRM_TEXT: 'La publication repassera en brouillon.',
    UNPUBLISH_PUBLICATION: 'Dépublier',
    UNPUBLISH_CONFIRM_TITLE: 'Dépublier la publication',
    UNPUBLISH_CONFIRM_TEXT: 'La publication ne sera plus visible par vos clients.',
  },
  PROFESSIONAL_APP_CUSTOMER_PAGE: {
    TITLE: 'Clients',
    CUSTOM_FIELDS_TITLE: 'Champs personnalisés',
    CUSTOM_FIELDS_MANAGE: 'Gérer les champs personnalisés',
    CUSTOM_FIELDS_MANAGE_LEAVE_TITLE: 'Quitter cette fiche ?',
    CUSTOM_FIELDS_MANAGE_LEAVE_TEXT:
      'Les modifications non enregistrées de cette fiche seront perdues. Enregistrez-la d’abord pour les garder.',
    CUSTOM_FIELDS_MANAGE_LEAVE_CONFIRM: 'Quitter la fiche',
    CUSTOM_FIELDS_LABEL_REQUIRED: 'Saisissez un nom pour chaque champ avant d’enregistrer.',
    CUSTOM_FIELDS_TYPE_LABEL: 'Type de réponse',
    CUSTOM_FIELDS_OPTION_NUMBER: 'Choix {number}',
    CUSTOM_FIELDS_ADD_OPTION: 'Ajouter un choix',
    CUSTOM_FIELDS_ADD_FIELD: 'Ajouter un champ',
    CUSTOM_FIELDS_ROW_PENDING_SHORT: 'Non enregistré',
    CUSTOM_FIELDS_REMOVE_DRAFT: 'Retirer le brouillon',
    CUSTOM_FIELDS_LIMIT: 'Vous pouvez utiliser au maximum {count} champs actifs.',
    CUSTOM_FIELDS_RESTORED: 'Champ restauré',
    CUSTOM_FIELDS_RESTORE_FAILED: 'Impossible de restaurer ce champ. Réessayez.',
    CUSTOM_FIELDS_ARCHIVED_TITLE: 'Champs archivés',
    CUSTOM_FIELDS_ARCHIVED_HELP:
      'Les valeurs saisies sont conservées. Restaurez un champ pour les retrouver dans les fiches clients.',
    CUSTOM_FIELDS_RESTORE: 'Restaurer',
    CUSTOM_FIELDS_SAVE_PARTIAL:
      '{count} champ(s) enregistré(s) pendant cet essai. Les autres modifications sont conservées : corrigez les erreurs puis réessayez.',
    CUSTOM_FIELDS_DISCARD_DRAFT: 'Abandonner le brouillon',
    CUSTOM_FIELDS_LEAVE_TITLE: 'Abandonner le brouillon ?',
    CUSTOM_FIELDS_LEAVE_TEXT: 'Vos modifications non enregistrées seront perdues.',
    CUSTOM_FIELDS_LEAVE_CONFIRM: 'Abandonner le brouillon',
    CUSTOM_FIELDS_SAVING: 'Enregistrement en cours…',
    CUSTOM_FIELDS_PENDING:
      'Modifications non enregistrées. Votre brouillon est conservé si vous changez de page dans cette session.',
    CUSTOM_FIELDS_DRAFT_RESTORED: 'Votre brouillon a été retrouvé. Vous pouvez le reprendre et l’enregistrer.',
    CUSTOM_FIELDS_PREVIOUS_CHOICE: '{value} (ancien choix)',
    CUSTOM_FIELDS_SELECT_PLACEHOLDER: 'Choisir une réponse',
    CUSTOM_FIELDS_CLEAR: 'Effacer la réponse du champ « {label} »',
    CUSTOM_FIELDS_CLEAR_SHORT: 'Effacer',
    CUSTOM_FIELDS_DESCRIPTION:
      'Ajoutez vos propres informations aux fiches clients (allergies, préférences, numéro de dossier…). Elles se remplissent à la main, se reprennent à l’import et deviennent des variables dans vos campagnes email.',
    CUSTOM_FIELDS_LABEL_PLACEHOLDER: 'Nom du champ',
    CUSTOM_FIELDS_OPTIONS_LABEL: 'Choix proposés',
    CUSTOM_FIELDS_OPTIONS_EMPTY: 'Ajoutez au moins un choix non vide avant d’enregistrer.',
    CUSTOM_FIELDS_OPTION_PLACEHOLDER: 'Intitulé du choix',
    CUSTOM_FIELDS_OPTION_REMOVE_ARIA: 'Supprimer ce choix',
    CUSTOM_FIELDS_OPTION_REMOVE_TITLE: 'Supprimer ce choix ?',
    CUSTOM_FIELDS_OPTION_REMOVE_TEXT:
      'À l’enregistrement, les fiches clients qui ont la réponse « {label} » la perdront définitivement. Pour seulement corriger l’intitulé, modifiez-le plutôt : les réponses sont conservées.',
    CUSTOM_FIELDS_OPTION_REMOVE_CONFIRM: 'Supprimer le choix',
    CUSTOM_FIELDS_OPTION_LABEL_REQUIRED: 'Donnez un intitulé à ce choix, ou supprimez-le.',
    CUSTOM_FIELDS_EMPTY: 'Aucun champ personnalisé pour l’instant.',
    CUSTOM_FIELDS_EMPTY_HINT: 'Ajoutez un premier champ : il apparaîtra sur toutes vos fiches clients.',
    CUSTOM_FIELDS_ACTIVE_TITLE: 'Champs actifs',
    CUSTOM_FIELDS_COUNT: '{count} {count, plural, one {champ} other {champs}} sur {max}',
    CUSTOM_FIELDS_UNNAMED: 'Champ sans nom',
    CUSTOM_FIELDS_FIX_BEFORE_SAVE: 'Complétez les champs signalés pour pouvoir enregistrer.',
    CUSTOM_FIELDS_READ_ONLY: 'Vous pouvez consulter ces champs, mais pas les modifier.',
    CUSTOM_FIELDS_LOADING: 'Chargement des champs personnalisés…',
    CUSTOM_FIELDS_LOAD_FAILED: 'Impossible de charger les champs personnalisés',
    CUSTOM_FIELDS_SAVED: 'Champs personnalisés enregistrés',
    CUSTOM_FIELDS_SAVE_FAILED: 'Impossible d’enregistrer les champs personnalisés',
    CUSTOM_FIELDS_ARCHIVED: 'Champ archivé',
    CUSTOM_FIELDS_ARCHIVE_FAILED: 'Impossible d’archiver ce champ',
    CUSTOM_FIELDS_ARCHIVE_TITLE: 'Archiver ce champ ?',
    CUSTOM_FIELDS_ARCHIVE_TEXT:
      'Le champ « {label} » disparaîtra des fiches clients et des variables de campagne. Les valeurs déjà saisies sont conservées et réapparaîtront si vous le restaurez.',
    CUSTOM_FIELDS_ARCHIVE_CONFIRM: 'Archiver',
    CUSTOM_FIELDS_CANCEL: 'Annuler',
    CUSTOM_FIELDS_INLINE_ADD: 'Ajouter une information',
    CUSTOM_FIELDS_INLINE_LABEL: 'Nom de l’information',
    CUSTOM_FIELDS_INLINE_LABEL_PLACEHOLDER: 'Ex : Allergies',
    CUSTOM_FIELDS_INLINE_VALUE: 'Valeur pour ce client',
    CUSTOM_FIELDS_INLINE_HELP: 'Ce champ apparaîtra sur toutes vos fiches clients.',
    CUSTOM_FIELDS_INLINE_SELECT_HINT: 'Pour proposer une liste de choix, passez par Clients → Champs personnalisés.',
    CUSTOM_FIELDS_INLINE_CREATE: 'Créer le champ',
    CUSTOM_FIELDS_INLINE_CREATE_FAILED: 'Impossible de créer ce champ. Réessayez.',
    CUSTOM_FIELDS_INLINE_ARCHIVED_TWIN:
      'Le champ archivé « {label} » porte déjà ce nom. Restaurez-le pour retrouver les réponses déjà enregistrées.',
    CUSTOM_FIELDS_RESTORED_KEPT:
      'Ce champ reste inchangé tant que vous ne saisissez rien ici : une réponse enregistrée avant son archivage est conservée.',
    CUSTOM_FIELDS_TYPE_CHANGE_TITLE: 'Changer le type de ce champ ?',
    CUSTOM_FIELDS_TYPE_CHANGE_TEXT:
      'À l’enregistrement, les réponses déjà saisies sur vos fiches clients seront converties au nouveau type lorsque c’est possible. Celles qui ne sont pas compatibles seront définitivement supprimées : cette action est irréversible.',
    CUSTOM_FIELDS_TYPE_CHANGE_CONFIRM: 'Changer le type',
    CUSTOM_FIELDS_VALUE_REJECTED: 'La valeur « {value} » ne convient pas à ce champ. Corrigez-la puis réessayez.',
    CUSTOM_FIELDS_NUMBER_INVALID:
      '« {value} » n’est pas un nombre valide. Utilisez uniquement des chiffres, avec une virgule pour les décimales (ex : 12,5).',
    CUSTOMER_SINCE: 'Client depuis',
    TAG_CARD_TITLE: 'Tags',
    ADD_TAG: 'Ajouter un tag',
    ADD_SPECIFIC_TAG: 'Ajouter le tag',
    ADD_SPECIFIC_CUSTOMER: 'Créer le client',
    ADD_ANY_CUSTOMER: 'Ajouter un client',
    DELETE_CUSTOMER_MODAL_TITLE: 'Supprimer le client',
    DELETE_CUSTOMER_MODAL_TEXT: 'Êtes-vous sûr de vouloir supprimer ce client ?',
    EMPTY_STATE_TITLE: 'Ajoutez vos premiers clients',
    EMPTY_STATE_TEXT:
      "Vous n'avez pas encore de clients. Cliquez sur le bouton ci-dessous pour en ajouter, afin de pouvoir gérer leurs rendez-vous et envoyer des campagnes marketing.",
    INVITE_CUSTOMERS_MODAL_TITLE: 'Inviter des clients',
    INVITE_CUSTOMERS_SEARCH_PLACEHOLDER: 'Rechercher client ou clé',
    INVITE_CUSTOMERS_ALL_CUSTOMERS: 'Tous les clients',
    INVITE_CUSTOMERS_SUBMIT_BUTTON: 'Inviter mes clients',
    INVITE_CUSTOMERS_DESCRIPTION: `Invitez vos clients à découvrir et réserver vos prestations sur ${PROJECT_CONFIG.brand_string}.\nUn SMS sera envoyé aux clients sélectionnés.`,
    INVITE_CUSTOMERS_MESSAGE_PREVIEW_TITLE: 'MESSAGES',
    INVITE_CUSTOMERS_MESSAGE_PREVIEW_TIME: 'Il y a 1min',
    INVITE_CUSTOMERS_MESSAGE_PREVIEW_CONTENT: `{company_name} vous invite à découvrir sa page ${PROJECT_CONFIG.brand_string}, vous pouvez désormais prendre RDV 24h/24, 7j/7 :`,
    INVITE_CUSTOMERS_LOADING: 'Chargement...',
    INVITE_CUSTOMERS_NO_RESULT: 'Aucun client trouvé',
    EDIT_TAG: 'Modifier',
    EDIT_TAG_TITLE: 'Modifier le tag',
    DELETE_TAG: 'Supprimer',
    DELETE_TAG_TITLE: 'Supprimer le tag',
    DELETE_TAG_TEXT: 'Êtes-vous sûr(e) de vouloir supprimer ce tag ? Il sera retiré de tous les clients associés.',
    SMART_TAG_LABEL: 'Tags systèmes',
    TAG_GROUP_CUSTOM: 'Tags personnalisés',
    TAG_GROUP_SMART: 'Tags systèmes',
    TAG_GROUP_PROPELSIA: `Tags ${PROJECT_CONFIG.brand_string}`,
    TAG_AUTOMATIC_BADGE: 'Géré automatiquement par le système. Non modifiable.',
    BAN_CUSTOMER: 'Bloquer ce client',
    UNBAN_CUSTOMER: 'Débloquer ce client',
    BAN_CUSTOMER_CONFIRM_TITLE: 'Bloquer ce client',
    BAN_CUSTOMER_CONFIRM_TEXT:
      'Ce client ne pourra plus prendre rendez-vous tant que vous ne le débloquez pas. Continuer ?',
    CUSTOMER_BLOCKED_BADGE: 'Bloqué',
    CUSTOMER_BLOCKED_DESC: 'Ce client ne peut pas prendre de rendez-vous tant que le tag « Bloqué » est appliqué.',
    DETAIL_TAB_INFO: 'Infos',
    DETAIL_TAB_APPOINTMENTS: 'Rendez-vous',
    DETAIL_TAB_SALES: 'Ventes',
    DETAIL_TAB_NOTIFICATIONS: 'Notifications',
    DETAIL_CTA_CALL: 'Appeler',
    DETAIL_CTA_EMAIL: 'Email',
    DETAIL_APPOINTMENTS_LOADING: 'Chargement des rendez-vous...',
    DETAIL_APPOINTMENTS_EMPTY: 'Aucun rendez-vous trouvé pour ce client.',
    DETAIL_APPOINTMENTS_DATE: 'Date',
    DETAIL_APPOINTMENTS_STATUS: 'Statut',
    DETAIL_APPOINTMENT_NO_SHOW_BADGE: 'Non présenté',
    DETAIL_APPOINTMENTS_PRESTATION: 'Prestation',
    DETAIL_APPOINTMENTS_PRICE: 'Prix',
    DETAIL_APPOINTMENTS_UPCOMING: 'À venir',
    DETAIL_APPOINTMENTS_PAST: 'Passés',
    DETAIL_APPOINTMENTS_EMPTY_SECTION: 'Aucun rendez-vous dans cette section.',
    DETAIL_APPOINTMENTS_OPEN_IN_AGENDA: "Ouvrir dans l'agenda",
    DETAIL_APPOINTMENTS_COMING_SOON: 'Les rendez-vous de ce client seront bientôt affichés ici.',
    DETAIL_SALES_TOTAL_SPENT: 'Total dépensé',
    DETAIL_SALES_TOTAL_SPENT_HINT: 'Net des remboursements',
    // Compte les ventes ENCAISSÉES qui composent le total affiché juste au-dessus — pas les lignes
    // de la liste, qui incluent aussi les empreintes bancaires non capturées.
    DETAIL_SALES_COUNT: '{count, plural, one {# vente encaissée} other {# ventes encaissées}}',
    DETAIL_SALES_EMPTY: 'Aucune vente pour ce client',
    // Ne promet QUE ce qui est réellement listé : les bons créés par le pro (offerts, vendus au
    // comptoir) n'ont pas de paiement rattaché et restent consultables depuis la page Ventes.
    DETAIL_SALES_EMPTY_DESC:
      'Les paiements encaissés en ligne et les empreintes bancaires en cours pour ce client apparaîtront ici.',
    DETAIL_SALES_PRESTATIONS: 'Prestations',
    DETAIL_SALES_OPEN: 'Voir le paiement',
    DETAIL_SALES_GIFT_CARD: 'Carte cadeau',
    DETAIL_SALES_GIFT_CARD_OPEN: 'Voir la carte cadeau',
  },
  PROFESSIONAL_APP_CUSTOMER_MERGE: {
    BANNER_TITLE: '{count, plural, one {# doublon probable détecté} other {# doublons probables détectés}}',
    BANNER_DESCRIPTION:
      'Des fiches clients semblent désigner la même personne. Vérifiez-les et fusionnez-les pour regrouper leur historique.',
    BANNER_ACTION: 'Vérifier',
    MODAL_TITLE: 'Doublons probables',
    MODAL_SUBTITLE:
      'Rien n’est fusionné sans votre confirmation. Chaque proposition indique pourquoi les deux fiches se ressemblent.',
    EMPTY_TITLE: 'Aucun doublon détecté',
    EMPTY_TEXT: 'Aucune fiche de votre base ne semble désigner la même personne qu’une autre.',
    // Deux causes distinctes, deux messages : la capacité dépassée est une vraie
    // limite (des doublons peuvent manquer), les blocs écartés sont voulus.
    PARTIAL_SCAN_HINT:
      'Votre base dépasse la capacité d’analyse : seules les fiches les plus anciennes ont été comparées, des doublons peuvent manquer.',
    IGNORED_BLOCKS_HINT:
      'Les fiches sans email ni téléphone exploitables (lignes d’import incomplètes) n’ont pas été rapprochées par ressemblance de nom.',
    RECORD_A: 'Fiche A',
    RECORD_B: 'Fiche B',
    OLDEST_HINT: 'la plus ancienne',
    RECORD_CUSTOMER_SINCE: 'Client depuis le {date}',
    RECORD_STATS:
      '{appointments, plural, =0 {aucun RDV} one {# RDV} other {# RDV}} · {sales, plural, =0 {aucune vente} one {# vente} other {# ventes}}',
    SIMILARITY: 'Ressemblance {percent} %',
    GROUP_TRUNCATED: 'Groupe partiel : seules les {count} premières fiches sont affichées.',
    COMPARE_ACTION: 'Comparer et fusionner',
    NOT_DUPLICATE_ACTION: 'Ce n’est pas un doublon',
    NOT_DUPLICATE_DONE: 'Cette paire ne vous sera plus proposée.',
    NOT_DUPLICATE_UNDO: 'Annuler',
    PREVIEW_TITLE: 'Aperçu de la fusion',
    PREVIEW_SUBTITLE:
      'La fiche conservée garde ses informations ; ses champs vides sont complétés depuis l’autre fiche. Choisissez, champ par champ, la valeur à conserver — ou modifiez-la. Les tags sont toujours réunis.',
    KEEP_THIS_RECORD: 'Conserver cette fiche',
    KEPT_RECORD: 'Fiche conservée',
    SWAP_HINT: 'Quelle fiche garder ? La plus ancienne est proposée par défaut.',
    MOVED_NOTHING: 'Aucun historique à rattacher : la fiche archivée n’a ni rendez-vous ni vente.',
    PICK_HINT:
      'Pour chaque information, la valeur retenue est encadrée : cliquez sur l’autre pour la remplacer, ou modifiez-la.',
    SECTION_IDENTITY: 'Identité',
    SECTION_CONTACT: 'Contact',
    SECTION_PREFERENCES: 'Préférences et notes',
    SECTION_CUSTOM_FIELDS: 'Champs personnalisés',
    FIELD_PICK_AUTO: 'Par défaut',
    FIELD_PICK_BOTH: 'Les deux',
    FIELD_EDIT: 'Modifier',
    FIELD_STATE_EDITED: 'Modifié',
    FIELD_STATE_PICKED: 'Choix manuel',
    FIELD_TAGS_ALWAYS_MERGED: 'toujours réunis',
    // Un refus vient du client (désinscription, plainte, STOP), jamais du pro :
    // il n'est donc pas arbitrable, et l'écran dit pourquoi.
    FIELD_CONSENT_CUSTOMER_REFUSED: 'le client s’est désinscrit — non modifiable',
    MOVED_TITLE: 'Rattaché à la fiche conservée',
    MOVED_APPOINTMENTS: '{count, plural, =0 {aucun rendez-vous} one {# rendez-vous} other {# rendez-vous}}',
    MOVED_SALES: '{count, plural, =0 {aucune vente} one {# vente} other {# ventes}}',
    MOVED_VOUCHERS: '{count, plural, =0 {aucune carte cadeau} one {# carte cadeau} other {# cartes cadeaux}}',
    MOVED_NOTIFICATIONS: '{count, plural, =0 {aucun message} one {# message} other {# messages}}',
    INVALID_EMAIL_HINT: 'Email invalide',
    INVALID_PHONE_HINT: 'Numéro invalide — format international (+33…)',
    // Le rôle (« archivée » / « conservée ») précède le nom : deux fiches en
    // doublon portent souvent des noms quasi identiques (« T. Bernard » et
    // « Thomas Bernard »), et sans ce repère la phrase se lit à l'envers.
    IMPACT_TEXT:
      'Les rendez-vous, ventes, cartes cadeaux et notifications de la fiche archivée ({absorbed}) seront rattachés à la fiche conservée ({survivor}). Cette action est irréversible.',
    CONSENT_HINT: 'Un refus de communication est toujours conservé : la fusion ne réabonne jamais un client.',
    FIELD_TAGS: 'Tags',
    FIELD_MARKETING_EMAIL: 'Emails marketing acceptés',
    FIELD_MARKETING_SMS: 'SMS marketing acceptés',
    VALUE_EMPTY: '—',
    MERGE_ACTION: 'Fusionner',
    CONFIRM_TITLE: 'Fusionner ces deux fiches ?',
    CONFIRM_TEXT:
      'L’historique de la fiche archivée ({absorbed}) sera rattaché à la fiche conservée ({survivor}). Cette action est irréversible.',
    MERGE_SUCCESS: 'Fiches fusionnées',
    MERGE_SUCCESS_DESC:
      'L’historique de la fiche archivée ({absorbed}) a été rattaché à la fiche conservée ({survivor}).',
    DETAIL_HINT_TITLE: 'Cette fiche ressemble à {name}',
    DETAIL_HINT_MORE: '{count, plural, one {et # autre fiche} other {et # autres fiches}}',
    CREATE_HINT_EMAIL: 'Un client existe déjà avec cet email : {name}.',
    CREATE_HINT_PHONE: 'Un client existe déjà avec ce numéro : {name}.',
    CREATE_HINT_OPEN: 'Ouvrir la fiche existante',
    CREATE_HINT_CONTINUE: 'Vous pouvez tout de même créer une nouvelle fiche.',
    REDIRECTED_FROM_MERGED: 'Cette fiche a été fusionnée : vous avez été redirigé vers la fiche conservée.',
    LOADING_PREVIEW: 'Préparation de l’aperçu…',
    // Séparateur inséré entre les deux commentaires lors de la fusion (lu côté
    // backend via MAPPED_TRANSLATION + .replace — pas d'ICU côté backend).
    COMMENT_SEPARATOR: '--- Fiche #{id} fusionnée le {date} ---',
  },
  PRO_ACCOUNT_SWITCH: {
    TITLE: 'Changer de compte pro',
    DESCRIPTION: 'Sélectionnez le compte pro sur lequel vous souhaitez basculer.',
    SWITCHING: 'Changement de compte…',
    SINGLE_ACCOUNT: 'Vous n’avez qu’un seul compte pro pour le moment.',
    CREATE_COMPANY_CTA: 'Créer une entreprise',
    CREATE_COMPANY_TITLE: 'Créer une nouvelle entreprise',
    CREATE_COMPANY_DESCRIPTION:
      'Pour une autre activité : autre marque, autre SIRET ou autre site. Pour un deuxième lieu de la même activité, ajoutez plutôt un lieu à votre entreprise actuelle.',
    CREATE_COMPANY_BILLING_NOTICE:
      'Cette entreprise est payante dès sa création, sans période d’essai. Elle a son propre abonnement et ses propres factures.',
    CREATE_COMPANY_BUSINESS_NAME: 'Nom commercial',
    CREATE_COMPANY_BUSINESS_NAME_PLACEHOLDER: 'Ex. Institut Léa',
    CREATE_COMPANY_CITY: 'Ville',
    CREATE_COMPANY_CITY_PLACEHOLDER: 'Rechercher une ville',
    CREATE_COMPANY_PHONE: 'Téléphone',
    CREATE_COMPANY_SUBMIT: 'Créer et choisir une formule',
    CREATE_COMPANY_NEEDS_OWNER_SESSION:
      'Basculez d’abord sur une entreprise dont vous êtes propriétaire pour en créer une nouvelle.',
    PENDING_ACTIVATION_TITLE: 'Une entreprise attend son activation',
    PENDING_ACTIVATION_DESC:
      'L’entreprise « {name} » n’a pas encore été activée. Finalisez-la en choisissant une formule, ou abandonnez-la pour en créer une autre.',
    PENDING_ACTIVATION_FINALIZE: 'Finaliser',
    PENDING_ACTIVATION_ABANDON: 'Abandonner',
    PASSWORD_REQUIRED_TITLE: 'Connexion par mot de passe requise',
    PASSWORD_REQUIRED_DESC_RELOGIN:
      'Vous êtes connecté par un lien. Pour créer une entreprise, reconnectez-vous avec votre mot de passe.',
    PASSWORD_REQUIRED_DESC_SET_PASSWORD:
      'Pour créer une entreprise, définissez d’abord un mot de passe depuis votre tableau de bord, puis reconnectez-vous avec.',
    PASSWORD_REQUIRED_RELOGIN: 'Me reconnecter',
    BADGE_PENDING_ACTIVATION: 'À activer',
    PENDING_ACTIVATION_MOBILE_HINT: 'À finaliser depuis le web',
  },
  PROFESSIONAL_APP_TEAM_PAGE: {
    TITLE: 'Équipe',
    ADD_TEAM_MEMBER: "Ajouter un membre d'équipe",
    DELETE_TEAM_TITLE: "Supprimer le membre d'équipe",
    DELETE_TEAM_TEXT: "Êtes-vous sûr de vouloir supprimer ce membre d'équipe ?",
    STATUS_PENDING: 'Accès en attente',
    RESEND_INVITATION: "Renvoyer l'invitation",
    INVITATION_RESENT: 'Invitation renvoyée.',
    BADGE_AGENDA: 'Agenda',
    BADGE_ACCOUNT: 'Accès',
    CONFIRM_DOWNGRADE_TITLE: 'Confirmer la modification',
    CONFIRM_REMOVE_ACCOUNT:
      "L'accès à l'application sera retiré. La personne ne pourra plus se connecter, mais l'historique reste préservé.",
    CONFIRM_REMOVE_AGENDA:
      "Le membre n'apparaîtra plus dans le planning ni dans le booking. Les disponibilités configurées sont conservées.",
    REORDER_SUCCESS: "Ordre de l'équipe mis à jour.",
    LOGIN_EMAIL_PENDING: 'Nouvel email en attente : {email}',
    LOGIN_EMAIL_CHANGE_SENT:
      "Un lien de confirmation a été envoyé à {email}. L'email de connexion changera quand la personne l'aura confirmé avec son mot de passe.",
    LOGIN_EMAIL_CHANGE_APPLIED: "Email mis à jour : l'invitation a été renvoyée à {email}.",
    CANCEL_LOGIN_EMAIL_CHANGE: 'Annuler',
    LOGIN_EMAIL_CHANGE_CANCELLED: "Changement d'email annulé.",
  },
  SUBSCRIPTION_LIMITS: {
    LIMIT_REACHED_TITLE_TEAM_MEMBER: "Limite de membres d'équipe atteinte",
    // Constat (limite pile atteinte / dépassée), puis une phrase d'action alignée sur le bouton
    // réellement affiché (place en plus, plan supérieur ou formules) : jamais une option absente.
    LIMIT_REACHED_DESCRIPTION_TEAM_MEMBER:
      '{limit, plural, one {Votre abonnement inclut # membre d’équipe, déjà utilisé.} other {Votre abonnement inclut # membres d’équipe, tous déjà utilisés.}}',
    LIMIT_REACHED_DESCRIPTION_OVER_TEAM_MEMBER:
      '{limit, plural, one {Votre équipe compte {used} membres, au-delà du # membre inclus dans votre abonnement.} other {Votre équipe compte {used} membres, au-delà des # inclus dans votre abonnement.}}',
    LIMIT_REACHED_ACTION_ADDON_TEAM_MEMBER: 'Ajoutez une place supplémentaire pour agrandir votre équipe.',
    LIMIT_REACHED_ACTION_UPGRADE_TEAM_MEMBER: 'Passez au plan {plan} pour agrandir votre équipe.',
    LIMIT_REACHED_ACTION_VIEW_PLANS_TEAM_MEMBER: 'Consultez les formules pour agrandir votre équipe.',
    LIMIT_REACHED_TITLE_GMB: 'Limite de fiches Google atteinte',
    LIMIT_REACHED_DESCRIPTION_GMB:
      '{limit, plural, one {Votre abonnement inclut # fiche Google, déjà connectée.} other {Votre abonnement inclut # fiches Google, toutes déjà connectées.}}',
    LIMIT_REACHED_DESCRIPTION_OVER_GMB:
      '{limit, plural, one {Vous avez connecté {used} fiches Google, au-delà de la # incluse dans votre abonnement.} other {Vous avez connecté {used} fiches Google, au-delà des # incluses dans votre abonnement.}}',
    LIMIT_REACHED_ACTION_ADDON_GMB: 'Ajoutez une fiche supplémentaire pour en synchroniser davantage.',
    LIMIT_REACHED_ACTION_UPGRADE_GMB: 'Passez au plan {plan} pour en synchroniser davantage.',
    LIMIT_REACHED_ACTION_VIEW_PLANS_GMB: 'Consultez les formules pour en synchroniser davantage.',
    LIMIT_REACHED_ADDON_CTA_EXTRA_USER: 'Ajouter une place utilisateur ({price}/mois)',
    LIMIT_REACHED_ADDON_CTA_EXTRA_GMB: 'Ajouter une fiche Google ({price}/mois)',
    LIMIT_REACHED_UPGRADE_CTA: 'Passer au plan {plan}',
    LIMIT_REACHED_VIEW_PLANS: 'Voir les plans',
    LIMIT_REACHED_LATER: 'Plus tard',
    QUOTA_BADGE_UPGRADE: 'Augmenter',
  },
  TEAM_INVITATION_EMAIL: {
    CTA_NEW_ACCOUNT: 'définir mon mot de passe',
    CTA_EXISTING_ACCOUNT: "accepter l'invitation",
  },
  ACCEPT_INVITATION_PAGE: {
    TITLE: "Accepter l'invitation",
    SUBTITLE_NEW_ACCOUNT:
      '{pro_name} vous invite à rejoindre son équipe. Définissez votre mot de passe pour activer votre compte.',
    SUBTITLE_EXISTING_ACCOUNT:
      '{pro_name} vous invite à rejoindre son équipe. Saisissez le mot de passe de votre compte pour accepter.',
    SUBMIT_ACCEPT: "Accepter l'invitation",
    SUBMIT_SET_PASSWORD: 'Définir mon mot de passe et accepter',
    INVALID_OR_EXPIRED: "Ce lien d'invitation est invalide ou a expiré.",
    BACK_TO_LOGIN: 'Retour à la connexion',
    PASSWORD_LABEL: 'Mot de passe',
  },
  // Écrans « changer une adresse email » : les deux flux (contact de l'établissement, connexion)
  // partagent l'état « en attente » ; chacun a son écran de demande.
  EMAIL_CHANGE: {
    CURRENT_LABEL: 'Adresse actuelle',
    EDIT: 'Modifier',
    SUBMIT: 'Envoyer le lien de confirmation',
    REQUEST_SENT: 'Lien de confirmation envoyé à {email}.',
    PENDING_TITLE: 'En attente de confirmation',
    PENDING_TEXT:
      "Un lien a été envoyé à {email}. Il expire le {expires}. Tant qu'il n'est pas confirmé, l'adresse actuelle reste utilisée.",
    RESEND: 'Renvoyer le lien',
    RESENT: 'Lien renvoyé.',
    CANCEL_REQUEST: 'Annuler la demande',
    CANCELLED: 'Demande annulée.',
    STRIPE_REMINDER:
      'Votre compte de paiement Stripe a sa propre adresse email : pensez à la mettre à jour vous-même dans votre espace Stripe.',
    STRIPE_REMINDER_CTA: 'Voir mon compte de paiement',
  },
  CONTACT_EMAIL_PAGE: {
    TITLE: 'Email de contact',
    SUBTITLE:
      "L'adresse qui reçoit vos factures et les notifications de vos rendez-vous, et qui s'affiche sur votre site.",
    FORM_HINT:
      "Un lien de confirmation sera envoyé à la nouvelle adresse. Rien ne change tant qu'il n'a pas été ouvert, et l'adresse actuelle sera prévenue.",
    ROLE_RESTRICTED: "Seul le propriétaire de l'établissement ({owner_name}) peut modifier l'email de contact.",
    ROLE_RESTRICTED_NO_NAME: "Seul le propriétaire de l'établissement peut modifier l'email de contact.",
  },
  CHANGE_EMAIL_PAGE: {
    TITLE: "Changer l'email de connexion",
    SUBTITLE: "L'adresse avec laquelle vous vous connectez, pour tous vos établissements.",
    FORM_HINT:
      'Un lien de confirmation sera envoyé à la nouvelle adresse : il vous demandera votre mot de passe actuel. Votre adresse actuelle sera prévenue.',
    NO_PASSWORD:
      "Votre compte n'a pas encore de mot de passe. Définissez-en un avant de changer votre email de connexion.",
  },
  EMAIL_CHANGE_CONFIRM_PAGE: {
    TITLE: 'Confirmer la nouvelle adresse',
    SUBTITLE_CONTACT: "L'email de contact de {pro_name} va devenir {email}.",
    SUBTITLE_LOGIN: 'Votre email de connexion va devenir {email}. Saisissez votre mot de passe actuel pour confirmer.',
    SUBTITLE_RECOVERY: "L'adresse de récupération de votre compte va devenir {email}.",
    SUBMIT: 'Confirmer',
    SUCCESS_TITLE: 'Adresse confirmée',
    SUCCESS_CONTACT: "L'email de contact est désormais {email}.",
    SUCCESS_LOGIN: 'Connectez-vous désormais avec {email}.',
    SUCCESS_RECOVERY: 'En cas de mot de passe oublié, le lien de réinitialisation arrivera sur {email}.',
    INVALID_OR_EXPIRED: 'Ce lien est invalide, a expiré ou a déjà été utilisé.',
    GO_TO_APP: "Aller sur l'application",
  },
  EMAIL_CHANGE_CANCEL_PAGE: {
    TITLE: "Annuler le changement d'adresse",
    SUBTITLE_CONTACT: "Une demande vise à remplacer l'email de contact de {pro_name} par {email}.",
    SUBTITLE_LOGIN: 'Une demande vise à remplacer votre email de connexion par {email}.',
    SUBTITLE_RECOVERY: "Une demande vise à remplacer l'adresse de récupération de votre compte par {email}.",
    HINT: "Si vous n'êtes pas à l'origine de cette demande, annulez-la puis changez votre mot de passe.",
    SUBMIT: 'Annuler la demande',
    SUCCESS: "La demande est annulée : l'adresse actuelle est conservée.",
    INVALID_OR_EXPIRED: 'Ce lien est invalide, a expiré, ou la demande a déjà été confirmée ou annulée.',
  },
  RECOVERY_EMAIL_PAGE: {
    TITLE: 'Adresse de récupération',
    SUBTITLE: `Une adresse personnelle et externe (Gmail, Outlook…) pour récupérer votre compte. Obligatoire si vous vous connectez avec une boîte hébergée par ${PROJECT_CONFIG.brand_string} : le « mot de passe oublié » arrive alors ici, jamais sur la boîte.`,
    NONE: 'Aucune adresse de récupération',
    ADD: 'Ajouter',
    REMOVE: 'Supprimer',
    REMOVED: 'Adresse de récupération supprimée.',
    REMOVE_CONFIRM_TITLE: "Supprimer l'adresse de récupération ?",
    REMOVE_CONFIRM_TEXT: 'Le « mot de passe oublié » repartira vers votre email de connexion.',
    REMOVE_BLOCKED: `Obligatoire tant que vous vous connectez avec une boîte hébergée par ${PROJECT_CONFIG.brand_string}.`,
    REQUIRED_WARNING: `Vous vous connectez avec une boîte hébergée par ${PROJECT_CONFIG.brand_string} : ajoutez une adresse de récupération, sinon un mot de passe oublié ne pourra pas être réinitialisé.`,
    FORM_HINT:
      "Un lien de confirmation sera envoyé à cette adresse. Tant qu'il n'est pas confirmé, l'adresse actuelle reste utilisée.",
    NO_PASSWORD:
      "Votre compte n'a pas encore de mot de passe. Définissez-en un avant d'ajouter une adresse de récupération.",
  },
  CHANGE_PASSWORD_PAGE: {
    TITLE: 'Changer mon mot de passe',
    SUBTITLE: 'Saisissez votre mot de passe actuel puis votre nouveau mot de passe.',
    SUBMIT: 'Changer mon mot de passe',
    SUCCESS: 'Mot de passe modifié avec succès.',
  },
  PROFESSIONAL_APP_TEAM_ESTABLISHMENT: {
    TITLE: 'Entreprise',

    SECTION_TITLE_INFORMATION: 'Informations',

    TITLE_PROFILE: "Profil de l'établissement",
    SUBTITLE_PROFILE: 'Modifier les informations de votre établissement',

    TITLE_TEAM: 'Équipe',
    SUBTITLE_TEAM: 'Gérer votre équipe',

    TITLE_MEDIA: 'Photos & Logo',
    SUBTITLE_MEDIA: 'Gérer le logo et les photos de votre établissement',

    TITLE_PLACE: 'Lieux',
    SUBTITLE_PLACE: 'Paramétrer votre adresses et vos visios',

    TITLE_CONTACT_EMAIL: 'Email de contact',
    SUBTITLE_CONTACT_EMAIL: 'Factures, notifications de rendez-vous et email affiché sur votre site',

    SECTION_TITLE_PARAMETERS: 'Paramètres',

    TITLE_BOOKING_PARAMETERS: 'Paramètres des RDV',

    TITLE_SYNC_GOOGLE: 'Compte Google Business Profile',
    SUBTITLE_SYNC_GOOGLE: "Gérer votre fiche d'établissement Google",
    TITLE_GOOGLE_RESERVE: 'Réserver avec Google',
    SUBTITLE_GOOGLE_RESERVE: 'Recevoir des réservations directement depuis vos fiches Google',

    TITLE_RIDE_CONFIG: 'Configuration courses',
    SUBTITLE_RIDE_CONFIG: 'Gérer vos véhicules, tarifs et zones de trajet',

    TITLE_PULSE_AI: 'Pulse & voix de marque',
    SUBTITLE_PULSE_AI: 'Le contexte et les consignes que Pulse respecte en rédigeant',

    TITLE_MATERIEL: 'Matériel',
    SUBTITLE_MATERIEL: 'Équipements partagés entre plusieurs prestations ou lieux',

    SECTION_TITLE_PAYMENT: 'Paiements',

    TITLE_SHARE_PAYMENT: 'Compte de paiement',
    SUBTITLE_SHARE_PAYMENT: 'Gérer votre compte Stripe, vos virements et votre solde',

    SECTION_TITLE_SUBSCRIPTION: 'Abonnement',

    TITLE_MY_SUBSCRIPTION: 'Mon abonnement',
    SUBTITLE_MY_SUBSCRIPTION: 'Gérer votre abonnement et consulter vos factures',

    TITLE_MY_PAYMENT_METHOD: 'Mes moyens de paiement',
    SUBTITLE_MY_PAYMENT_METHOD: 'Gérer vos moyens de paiement',

    UPSERT_TITLE_ESTABLISHMENT: "Profil de l'établissement",
    UPSERT_TITLE_BOOKING_PARAMETERS: 'Paramètres des rendez-vous',
    UPSERT_TITLE_MEDIA: 'Photos & Logo',
    UPSERT_SECTION_TITLE_ACTIVITIES: 'Activités',
  },
  PROFESSIONAL_APP_EQUIPMENT_PAGE: {
    TITLE: 'Matériel',
    COMING_SOON_TITLE: 'Bientôt disponible',
    COMING_SOON_DESC:
      'La gestion du matériel partagé entre prestations sera ajoutée prochainement. Tu seras notifié dès son arrivée.',
  },
  PROFESSIONAL_APP_PAYMENT_METHOD_PAGE: {
    TITLE: 'Moyens de paiement',
    EMPTY_TITLE: 'Aucun moyen de paiement enregistré',
    EMPTY_DESCRIPTION: 'Ajoutez une carte ou un mandat SEPA pour configurer votre moyen de paiement par défaut.',
    DEFAULT: 'Défaut',
    CARD_ACRONYM: 'CB',
    SEPA_ACRONYM: 'SEPA',
    DELETE_PAYMENT_METHOD_MODAL_TITLE: 'Supprimer ce moyen de paiement',
    DELETE_PAYMENT_METHOD_MODAL_TEXT: 'Êtes-vous sûr de vouloir supprimer ce moyen de paiement ?',
    SET_AS_DEFAULT: 'Définir par défaut',
    // Bouton unique « Ajouter » : choix de la carte (Stripe) ou du mandat SEPA (GoCardless).
    ADD_PAYMENT_METHOD_BUTTON: 'Ajouter un moyen de paiement',
    ADD_CARD_OPTION: 'Carte bancaire',
    ADD_SEPA_MANDATE_OPTION: 'Prélèvement SEPA',
    ADD_PAYMENT_METHOD_TITLE: 'Ajouter une carte bancaire',
    // ── Mandat SEPA (GoCardless) ──
    SEPA_MANDATE_INACTIVE: 'Mandat inactif',
    // Retour du parcours de signature : le mandat n'apparaît qu'une fois confirmé par GoCardless.
    SEPA_MANDATE_PENDING: 'Enregistrement de votre mandat SEPA en cours…',
    SEPA_MANDATE_ADDED: 'Mandat SEPA ajouté : il devient votre moyen de paiement par défaut.',
    SEPA_MANDATE_NOT_FOUND_YET:
      'Votre mandat n’apparaît pas encore. S’il a bien été signé, il s’affichera dans quelques instants : actualisez la page.',
    // Sortie du parcours GoCardless sans signer (`sepa_exit=1`) : aucune attente.
    SEPA_MANDATE_EXITED:
      'Ajout du mandat SEPA interrompu : vous avez quitté GoCardless sans signer. Vous pouvez recommencer quand vous le souhaitez.',
  },
  PROFESSIONAL_APP_STRIPE_CONNECT_PAGE: {
    TITLE: 'Compte de paiement',
    ACCOUNT_SECTION_TITLE: 'Mon compte Stripe',
    PAYOUTS_SECTION_TITLE: 'Mes virements',
    LAST_PAYOUT_LABEL: 'Dernier virement',
    NEXT_PAYOUT_LABEL: 'Prochain virement',
    NO_PAYOUT_YET: 'Aucun virement reçu pour le moment',
    NO_UPCOMING_PAYOUT: 'Aucun virement programmé',
    BALANCE_AVAILABLE_LABEL: 'Solde disponible',
    BALANCE_PENDING_LABEL: 'Solde en attente',
    PAYOUT_INTERVAL_LABEL: 'Fréquence des virements',
    OVERVIEW_UNAVAILABLE: 'Les informations de virement sont momentanément indisponibles.',
    SNAPSHOT_DISCLAIMER: 'Données fournies en temps réel par Stripe.',
    ...StripeConnectPayoutStatusTranslation['fr-FR'],
    ...StripeConnectPayoutIntervalTranslation['fr-FR'],
  },
  CALENDAR_PAGE: {
    // Aide sous le réglage « Attribution quand le client n'a pas de préférence » (onglet Calendrier).
    MEMBER_ASSIGNMENT_STRATEGY_HINT:
      'L’ordre de votre équipe décide qui reçoit le rendez-vous en mode « Par priorité », et départage les membres à charge égale en mode « Équilibré ». C’est aussi l’ordre affiché aux clients.',
    MEMBER_ASSIGNMENT_TEAM_ORDER_LINK: 'Cliquez ici pour modifier l’ordre de l’équipe',
    // Confirmation quand ce lien quitterait l'onglet Calendrier avec des modifications non enregistrées.
    BOOKING_PARAMS_UNSAVED_TITLE: 'Modifications non enregistrées',
    BOOKING_PARAMS_UNSAVED_DESC:
      'Vous avez modifié les paramètres de réservation sans les enregistrer. Que voulez-vous faire avant d’aller sur la page Équipe ?',
    BOOKING_PARAMS_UNSAVED_SAVE_AND_LEAVE: 'Enregistrer et continuer',
    BOOKING_PARAMS_UNSAVED_LEAVE: 'Quitter sans enregistrer',
    // Ligne de prestation d'un RDV facturé pour plusieurs personnes : le suffixe rappelle le
    // multiplicateur, la sous-ligne détaille « N × prix unitaire » sous le total de la ligne.
    PRESTATION_PARTY_SIZE_SUFFIX: '{count, plural, one {# personne} other {# personnes}}',
    PRESTATION_UNIT_BREAKDOWN: '{count} × {price}',
    // Stepper « Personnes » d'une ligne de prestation (agenda pro). Volontairement non plafonné :
    // la capacité de la séance n'est qu'un repère, seules les gardes serveur refusent.
    PRESTATION_PARTY_SIZE_LABEL: 'Personnes',
    PRESTATION_PARTY_SIZE_DECREASE: 'Retirer une personne',
    PRESTATION_PARTY_SIZE_INCREASE: 'Ajouter une personne',
    PRESTATION_QUANTITY_DECREASE: 'Retirer un exemplaire',
    PRESTATION_QUANTITY_INCREASE: 'Ajouter un exemplaire',
    // Stepper de quantité d'un supplément « au choix » (peignoir, produit…) sur une ligne de prestation.
    SUPPLEMENT_QUANTITY_DECREASE: 'Diminuer la quantité de « {name} »',
    SUPPLEMENT_QUANTITY_INCREASE: 'Augmenter la quantité de « {name} »',
    PRESTATION_SESSION_CAPACITY_HINT: 'Capacité de la séance : {capacity}',
    PRESTATION_SESSION_CAPACITY_EXCEEDED: 'Au-delà de la capacité de la séance ({capacity})',
    APPOINTMENT_FORM_TAB_INFO: 'Rendez-vous',
    APPOINTMENT_FORM_TAB_COUPON: 'Coupon',
    RECURRENCE_PICKER_LABEL: 'Récurrence',
    RECURRENCE_PRESET_NONE: 'Ne se répète pas',
    RECURRENCE_PRESET_CUSTOM: 'Personnalisé…',
    RECURRENCE_CUSTOM_TITLE: 'Récurrence personnalisée',
    RECURRENCE_REPEAT_EVERY: 'Répéter tous les',
    RECURRENCE_UNIT_DAYS: '{count, plural, one {jour} other {jours}}',
    RECURRENCE_UNIT_WEEKS: '{count, plural, one {semaine} other {semaines}}',
    RECURRENCE_UNIT_MONTHS: 'mois',
    RECURRENCE_UNIT_YEARS: '{count, plural, one {an} other {ans}}',
    RECURRENCE_REPEAT_ON_LABEL: 'Répéter le',
    RECURRENCE_MONTHLY_MODE_LABEL: 'Jour du mois',
    RECURRENCE_END_LABEL: 'Fin',
    RECURRENCE_END_NEVER: 'Jamais',
    RECURRENCE_END_UNTIL: 'Le',
    RECURRENCE_END_AFTER_COUNT: 'Après',
    RECURRENCE_END_OCCURRENCES: '{count, plural, one {occurrence} other {occurrences}}',
    RECURRENCE_PREVIEW_TITLE: 'Prochaines dates',
    RECURRENCE_PREVIEW_LOADING: 'Calcul des prochaines dates…',
    RECURRENCE_PREVIEW_EMPTY: 'Aucune occurrence à venir',
    RECURRENCE_PREVIEW_ERROR: 'Impossible de calculer l’aperçu',
    RECURRENCE_PREVIEW_AND_MORE: 'et suivantes…',
    RECURRENCE_VALIDATION_UNTIL_AFTER_PREVIOUS: 'La date de fin doit être postérieure à la date de début',
    RECURRENCE_VALIDATION_COUNT_RANGE: 'Entre {min} et {max} occurrences',
    RECURRENCE_VALIDATION_WEEKDAY_REQUIRED: 'Sélectionnez au moins un jour',
    APPOINTMENT_DETAIL_TITLE: 'Détail du rendez-vous',
    APPOINTMENT_EDIT_TITLE: 'Modifier le rendez-vous',
    APPOINTMENT_EDIT_LOADING: 'Chargement du rendez-vous...',
    APPOINTMENT_EDIT_MULTI_SLOT_NOTICE:
      'Cette réservation contient {count, plural, one {# créneau} other {# créneaux}}. Modifier l’heure ici ne déplacera que ce créneau.',
    APPOINTMENT_EDIT_RESCHEDULE_RESERVATION_CTA: 'Reprogrammer toute la réservation',
    APPOINTMENT_EDIT_SHIFT_FOLLOWING_TITLE: 'Décaler les créneaux suivants ?',
    APPOINTMENT_EDIT_SHIFT_FOLLOWING_INTRO:
      'Vous avez modifié l’horaire de ce créneau. Décaler aussi du même écart {count, plural, one {le créneau suivant} other {les # créneaux suivants}} de la réservation ?',
    APPOINTMENT_EDIT_SHIFT_FOLLOWING_WARNING:
      'Attention : cela peut chevaucher des rendez-vous existants, notamment sur l’agenda d’un autre membre.',
    APPOINTMENT_EDIT_SHIFT_FOLLOWING_CONFIRM: 'Décaler {count, plural, one {le suivant} other {les # suivants}}',
    APPOINTMENT_EDIT_SHIFT_FOLLOWING_DECLINE: 'Non, ce créneau seulement',
    APPOINTMENT_EDIT_SHIFT_FOLLOWING_SUCCESS: 'Les créneaux suivants ont été décalés.',
    APPOINTMENT_EDIT_EXTERNAL_BLOCK_TITLE: 'Événement externe non modifiable',
    APPOINTMENT_EDIT_EXTERNAL_BLOCK_DESCRIPTION:
      "Cet événement vient d'un agenda externe. Pour le modifier, utilisez l'agenda source.",
    APPOINTMENT_DETAIL_TAB_DETAILS: 'Détails',
    APPOINTMENT_DETAIL_TAB_CUSTOMER: 'Client',
    APPOINTMENT_DETAIL_TAB_ITEMS: 'Prestations',
    APPOINTMENT_DETAIL_TAB_PAYMENT: 'Paiement',
    APPOINTMENT_DETAIL_CUSTOM_FIELDS_HEADING: 'Informations complémentaires',
    APPOINTMENT_DETAIL_TIME_LABEL: 'Horaire',
    APPOINTMENT_DETAIL_START_DATE_LABEL: 'Date de début',
    APPOINTMENT_DETAIL_END_DATE_LABEL: 'Date de fin',
    APPOINTMENT_DETAIL_DATE_LABEL: 'Date',
    APPOINTMENT_DETAIL_PRICE_LABEL: 'Prix',
    APPOINTMENT_DETAIL_CUSTOMER_LABEL: 'Client',
    APPOINTMENT_DETAIL_VIEW_CUSTOMER: 'Voir la fiche client',
    APPOINTMENT_DETAIL_CUSTOMER_SEARCH: 'Rechercher un client...',
    APPOINTMENT_DETAIL_CUSTOMER_NO_MATCH: 'Aucun client trouvé.',
    APPOINTMENT_DETAIL_ADD_CUSTOMER: 'Ajouter un client',
    APPOINTMENT_DETAIL_ADD_CUSTOMER_SUCCESS: 'Client associé au rendez-vous.',
    APPOINTMENT_DETAIL_EMAIL_LABEL: 'Email',
    APPOINTMENT_DETAIL_PHONE_LABEL: 'Téléphone',
    APPOINTMENT_DETAIL_PRESTATIONS_LABEL: 'Prestations',
    APPOINTMENT_DETAIL_PRESTATION_COUNT: '{count, plural, one {# prestation} other {# prestations}}',
    APPOINTMENT_DETAIL_REMAINING_ON_SITE: 'Reste à encaisser {amount}',
    APPOINTMENT_DETAIL_PROMO_CODE: 'Code promo {code}',
    APPOINTMENT_DETAIL_PROMO_CODE_WITH_DISCOUNT: 'Code promo {code} · −{amount}',
    APPOINTMENT_DETAIL_PROMO_CODE_RESTORED: 'Utilisation restituée',
    // Tuile Prix : remise totale (prix normal − total) sous le nombre de prestations.
    APPOINTMENT_DETAIL_PRICE_DISCOUNT: 'remise {amount}',
    // Bloc « Montant » (remise depuis l'agenda, lot 1 Promotions) : lignes au prix normal, remises, total.
    APPOINTMENT_AMOUNT_SECTION_TITLE: 'Montant',
    APPOINTMENT_AMOUNT_TOTAL: 'Total',
    APPOINTMENT_AMOUNT_TOTAL_UNKNOWN: 'À définir',
    APPOINTMENT_AMOUNT_LINE_PRICE_UNKNOWN: 'Sur devis',
    APPOINTMENT_AMOUNT_DISCOUNT: 'Remise',
    APPOINTMENT_AMOUNT_DISCOUNT_WITH_REASON: 'Remise · {reason}',
    APPOINTMENT_AMOUNT_DISCOUNT_AUTHOR: 'par {name}, le {date}',
    APPOINTMENT_AMOUNT_DISCOUNT_DATE: 'le {date}',
    APPOINTMENT_AMOUNT_PROMO_CODE: 'Remise {code}',
    APPOINTMENT_AMOUNT_PROMO_CODE_HINT: 'code promo du client',
    APPOINTMENT_AMOUNT_ADJUSTMENT_DISCOUNT: 'Remise manuelle',
    APPOINTMENT_AMOUNT_ADJUSTMENT_SURCHARGE: 'Majoration manuelle',
    APPOINTMENT_AMOUNT_ADJUSTMENT_HINT: 'montant saisi à la main',
    APPOINTMENT_AMOUNT_ADD_DISCOUNT: 'Ajouter une remise',
    APPOINTMENT_AMOUNT_REMOVE_DISCOUNT: 'Retirer la remise',
    APPOINTMENT_AMOUNT_REMOVE_ADJUSTMENT: 'Retirer le montant saisi à la main',
    APPOINTMENT_AMOUNT_REMOVE_ADJUSTMENT_CONFIRM_TITLE: 'Retirer le montant saisi à la main ?',
    APPOINTMENT_AMOUNT_REMOVE_ADJUSTMENT_CONFIRM_TEXT:
      'Le total reprendra le prix des prestations, code promo et remises compris. Le montant saisi ne sera pas gardé.',
    APPOINTMENT_AMOUNT_DISCOUNT_REMOVED: 'Remise retirée.',
    APPOINTMENT_AMOUNT_ADJUSTMENT_REMOVED: 'Le total suit de nouveau les prestations.',
    // Formulaire d'édition : prestations modifiées, pas encore enregistrées.
    APPOINTMENT_AMOUNT_PENDING_RECALC:
      'Montant recalculé pour les prestations choisies, appliqué à l’enregistrement : une remise en % suit les prestations, une remise en montant est gardée.',
    // Formulaire d'édition : une ligne sans prix ferme (sur devis, « à partir de ») — le pro fixe le prix réel,
    // base des remises ; le champ reste visible pour le corriger (majoration comprise).
    APPOINTMENT_AMOUNT_FINAL_PRICE_LABEL: 'Prix final',
    APPOINTMENT_AMOUNT_FINAL_PRICE_HINT:
      'Prix réel de la prestation, une fois connu : il devient le total du rendez-vous et les remises s’y appliquent.',
    // Popover (feuille sur mobile) « Ajouter une remise ».
    APPOINTMENT_DISCOUNT_DIALOG_TITLE: 'Ajouter une remise',
    APPOINTMENT_DISCOUNT_AMOUNT_LABEL: 'Montant de la remise',
    APPOINTMENT_DISCOUNT_RATE_LABEL: 'Taux de la remise',
    APPOINTMENT_DISCOUNT_REASON_LABEL: 'Motif',
    APPOINTMENT_DISCOUNT_NOTE_LABEL: 'Précisez (facultatif)',
    APPOINTMENT_DISCOUNT_PREVIEW_NEW_TOTAL: 'Nouveau total',
    APPOINTMENT_DISCOUNT_PREVIEW_INSTEAD_OF: 'au lieu de {amount}',
    APPOINTMENT_DISCOUNT_PREVIEW_DISCOUNT: 'Remise {amount}',
    APPOINTMENT_DISCOUNT_EXCEEDS: 'La remise ne peut pas dépasser le montant restant ({amount}).',
    APPOINTMENT_DISCOUNT_INVALID_RATE: 'Le taux doit être compris entre 1 et 100 %.',
    APPOINTMENT_DISCOUNT_APPLY: 'Appliquer la remise',
    APPOINTMENT_DISCOUNT_APPLIED: 'Remise appliquée.',
    // Onglets du popover (lot 2) : une promotion du pro, ou une remise libre.
    APPOINTMENT_DISCOUNT_TAB_PROMOTION: 'Promotion',
    APPOINTMENT_DISCOUNT_TAB_FREE: 'Remise libre',
    APPOINTMENT_PROMOTION_AUTO_HINT: 'Appliquée automatiquement aux réservations en ligne',
    APPOINTMENT_PROMOTION_CODE_HINT: 'Code {code}',
    APPOINTMENT_PROMOTION_UNTIL: 'jusqu’au {date}',
    APPOINTMENT_PROMOTION_EMPTY: 'Aucune promotion active. Créez-en une dans Communication › Promotions.',
    APPOINTMENT_PROMOTION_ALREADY_APPLIED:
      'La promotion « {label} » est déjà appliquée : une seule promotion par réservation.',
    APPOINTMENT_PROMOTION_APPLY: 'Appliquer la promotion',
    APPOINTMENT_PROMOTION_APPLIED: 'Promotion appliquée.',
    APPOINTMENT_PROMOTION_LOAD_ERROR: 'Impossible de charger les promotions.',
    // Ligne du bloc Montant : promotion posée depuis l'agenda, ou promotion automatique de la réservation en ligne.
    APPOINTMENT_AMOUNT_PROMOTION: 'Promotion « {label} »',
    APPOINTMENT_AMOUNT_PROMOTION_AUTHOR: 'promotion appliquée par {name}, le {date}',
    APPOINTMENT_AMOUNT_PROMOTION_DATE: 'promotion appliquée le {date}',
    APPOINTMENT_AMOUNT_PROMOTION_ONLINE_HINT: 'promotion de la réservation en ligne',
    APPOINTMENT_DETAIL_RESOURCES_LABEL: 'Ressources',
    APPOINTMENT_DETAIL_RIDE_LABEL: 'Trajet',
    APPOINTMENT_DETAIL_RIDE_PASSENGERS_LABEL: 'Passagers',
    APPOINTMENT_DETAIL_RIDE_LUGGAGE_LABEL: 'Bagages',
    APPOINTMENT_DETAIL_RIDE_SMALL_LUGGAGE_LABEL: 'Petits bagages',
    APPOINTMENT_DETAIL_RIDE_LARGE_LUGGAGE_LABEL: 'Grands bagages',
    APPOINTMENT_DETAIL_RIDE_EMPTY: 'Aucun trajet renseigné',
    APPOINTMENT_DETAIL_RIDE_PICKUP_LABEL: 'Départ',
    APPOINTMENT_DETAIL_RIDE_DROPOFF_LABEL: 'Arrivée',
    APPOINTMENT_DETAIL_RIDE_DISTANCE_VALUE: '{distance, number, ::.#} km',
    APPOINTMENT_DETAIL_RIDE_DURATION_VALUE:
      '{hours, plural, =0 {{minutes} min} other {{minutes, plural, =0 {{hours} h} other {{hours} h {minutes} min}}}}',
    APPOINTMENT_DETAIL_RIDE_PASSENGER_COUNT: '{count, plural, one {# passager} other {# passagers}}',
    APPOINTMENT_DETAIL_RIDE_LUGGAGE_COUNT: '{count, plural, =0 {Aucun bagage} one {# bagage} other {# bagages}}',
    APPOINTMENT_DETAIL_RIDE_SMALL_LUGGAGE_COUNT:
      '{count, plural, =0 {Aucun petit bagage} one {# petit bagage} other {# petits bagages}}',
    APPOINTMENT_DETAIL_RIDE_LARGE_LUGGAGE_COUNT:
      '{count, plural, =0 {Aucun grand bagage} one {# grand bagage} other {# grands bagages}}',
    // Course multi-véhicules : le trajet est commun, seuls les véhicules diffèrent.
    APPOINTMENT_DETAIL_RIDE_VEHICLES_LABEL: 'Véhicules de la réservation ({count})',
    APPOINTMENT_DETAIL_RIDE_VEHICLE_POSITION: 'Véhicule {index}',
    APPOINTMENT_DETAIL_RIDE_VEHICLE_CURRENT_BADGE: 'Ce véhicule',
    APPOINTMENT_DETAIL_RIDE_VEHICLE_TO_ASSIGN: 'À attribuer',
    APPOINTMENT_DETAIL_RIDE_DRIVER_EMPTY: 'Chauffeur à affecter',
    APPOINTMENT_DETAIL_RIDE_PASSENGERS_WITH_GROUP: '{count} (groupe : {total})',
    APPOINTMENT_DETAIL_NO_CUSTOMER: 'Client non renseigné',
    APPOINTMENT_DETAIL_SECTION_NOTES_LOCATION: 'Notes & lieu',
    APPOINTMENT_DETAIL_PLACE_LABEL: 'Lieu',
    APPOINTMENT_DETAIL_SECTION_ACTIONS: 'Actions',
    APPOINTMENT_DETAIL_ACTION_EMAIL: 'Email',
    APPOINTMENT_DETAIL_ACTION_CALL: 'Appeler',
    APPOINTMENT_DETAIL_ACTION_RESCHEDULE: 'Reprogrammer',
    APPOINTMENT_DETAIL_ACTION_CONFIRM: 'Confirmer la réservation',
    APPOINTMENT_DETAIL_CONFIRM_SUCCESS: 'La réservation a bien été confirmée.',
    APPOINTMENT_DETAIL_ACTION_NO_SHOW: 'Client non présenté',
    APPOINTMENT_DETAIL_ACTION_NO_SHOW_UNDO: 'Retirer « non présenté »',
    APPOINTMENT_DETAIL_NO_SHOW_BADGE: 'Non présenté',
    APPOINTMENT_DETAIL_NO_SHOW_CONFIRM_TITLE: 'Marquer ce client comme non présenté ?',
    APPOINTMENT_DETAIL_NO_SHOW_CONFIRM_DESCRIPTION:
      'Le rendez-vous reste dans votre agenda mais ne compte plus comme une visite. Aucun email ne sera envoyé au client. La demande d’avis encore programmée est annulée et ne sera pas reprogrammée si vous retirez ce marquage.',
    APPOINTMENT_DETAIL_NO_SHOW_CONFIRM_TITLE_RESERVATION: 'Marquer cette réservation comme non présentée ?',
    APPOINTMENT_DETAIL_NO_SHOW_CONFIRM_DESCRIPTION_RESERVATION:
      'Cette réservation compte {count} rendez-vous : tous seront marqués non présentés. Ils restent dans votre agenda mais ne comptent plus comme des visites. Le total et les paiements de la réservation ne changent pas. Aucun email ne sera envoyé au client. Les demandes d’avis encore programmées sont annulées et ne seront pas reprogrammées si vous retirez ce marquage.',
    APPOINTMENT_DETAIL_NO_SHOW_SUCCESS_RESERVATION: 'La réservation a été marquée non présentée.',
    APPOINTMENT_DETAIL_NO_SHOW_SUCCESS: 'Le client a été marqué non présenté.',
    APPOINTMENT_DETAIL_NO_SHOW_UNDO_SUCCESS: 'Le marquage « non présenté » a été retiré.',
    APPOINTMENT_DETAIL_NO_SHOW_CAPTURE_PROMPT_TITLE: 'Prélever ce client ?',
    APPOINTMENT_DETAIL_NO_SHOW_CAPTURE_PROMPT_TEXT:
      'Une empreinte bancaire ou une carte enregistrée est encore utilisable pour ce rendez-vous. Vous pouvez prélever des frais de non-présentation maintenant, ou plus tard depuis vos paiements.',
    APPOINTMENT_DETAIL_NO_SHOW_CAPTURE_CTA: 'Prélever',
    APPOINTMENT_DETAIL_PENDING_RESCHEDULE_TITLE: 'Déplacement demandé par le client',
    APPOINTMENT_DETAIL_PENDING_RESCHEDULE_TEXT:
      'Horaire validé précédemment : {date}. Si le nouveau créneau ne vous convient pas, utilisez « Modifier » pour revenir à cet horaire puis confirmez. Annuler supprimerait la réservation du client.',
    APPOINTMENT_DETAIL_RESCHEDULE_MODAL_TITLE: 'Reprogrammer le rendez-vous',
    APPOINTMENT_DETAIL_RESCHEDULE_MODAL_DESCRIPTION:
      'Choisissez un nouveau créneau parmi les disponibilités autour de ce rendez-vous.',
    APPOINTMENT_DETAIL_RESCHEDULE_CONFIRM_MODAL_TITLE: 'Confirmer le nouveau créneau',
    APPOINTMENT_DETAIL_RESCHEDULE_CONFIRM_MODAL_DESCRIPTION:
      'Vérifiez le changement avant de reprogrammer ce rendez-vous.',
    APPOINTMENT_DETAIL_RESCHEDULE_CURRENT_SLOT_LABEL: 'Créneau actuel',
    APPOINTMENT_DETAIL_RESCHEDULE_NEW_SLOT_LABEL: 'Nouveau créneau',
    APPOINTMENT_DETAIL_RESCHEDULE_CONFIRM: 'Valider ce créneau',
    APPOINTMENT_DETAIL_RESCHEDULE_SUCCESS: 'Le rendez-vous a bien été reprogrammé.',
    APPOINTMENT_DETAIL_RESERVATION_SECTION_TITLE: 'Réservation',
    APPOINTMENT_DETAIL_RESERVATION_SLOT_COUNT: '{count, plural, one {# créneau} other {# créneaux}}',
    APPOINTMENT_DETAIL_RESERVATION_CURRENT_SLOT_BADGE: 'Ce créneau',
    APPOINTMENT_DETAIL_ASSIGNED_MEMBERS_EMPTY: 'Aucun membre assigné',
    APPOINTMENT_DETAIL_RESCHEDULE_RESERVATION_WARNING:
      'Cette réservation contient {count, plural, one {# créneau} other {# créneaux}} : tous les créneaux seront déplacés.',
    APPOINTMENT_DETAIL_RESCHEDULE_RESERVATION_OTHER_MEMBERS: "Des créneaux d'autres membres sont inclus : {names}.",
    APPOINTMENT_DETAIL_RESCHEDULE_RESERVATION_SUCCESS: 'La réservation a bien été reprogrammée.',
    APPOINTMENT_DETAIL_RESCHEDULE_ALREADY_STARTED: 'Ce rendez-vous a déjà commencé.',
    APPOINTMENT_DETAIL_CANCEL_RESERVATION_WARNING:
      'Cette réservation contient {count, plural, one {# créneau} other {# créneaux}} : tous les créneaux seront annulés.',
    APPOINTMENT_DETAIL_CANCEL_RESERVATION_OTHER_MEMBERS: "Des créneaux d'autres membres sont inclus : {names}.",
    AGENDA_MULTI_SLOT_SHIFT_TITLE: 'Déplacer toute la réservation ?',
    AGENDA_MULTI_SLOT_SHIFT_INTRO:
      'Ce rendez-vous fait partie d’une réservation de {count, plural, one {# créneau} other {# créneaux}}. Tout le bloc sera décalé ensemble :',
    AGENDA_MULTI_SLOT_SHIFT_CONFIRM: 'Déplacer {count, plural, one {le créneau} other {les # créneaux}}',
    AGENDA_MULTI_SLOT_SHIFT_INTRO_PARTIAL:
      'Ce rendez-vous fait partie d’une réservation de {total, plural, one {# créneau} other {# créneaux}}. Les créneaux des autres membres restent en place, {count, plural, one {le vôtre sera décalé} other {vos # créneaux seront décalés}} :',
    AGENDA_MULTI_SLOT_SHIFT_SUCCESS_PARTIAL: 'Vos créneaux ont bien été déplacés.',
    AGENDA_MULTI_SLOT_SHIFT_OPEN_DETAIL: 'Ouvrir le détail',
    AGENDA_MULTI_SLOT_SHIFT_SUCCESS: 'La réservation a bien été déplacée.',
    APPOINTMENT_DETAIL_EMAIL_UNAVAILABLE: 'Email non renseigné',
    APPOINTMENT_DETAIL_PHONE_UNAVAILABLE: 'Téléphone non renseigné',
    APPOINTMENT_DETAIL_RESERVATION_DATE_LABEL: 'Date de réservation',
    APPOINTMENT_DETAIL_CANCELLATION_DATE_LABEL: "Date d'annulation",
    APPOINTMENT_DETAIL_NO_SHOW_DATE_LABEL: 'Marqué non présenté le',
    APPOINTMENT_DETAIL_CUSTOMER_CANCELLATION_REASON_LABEL: 'Motif donné par le client',
    APPOINTMENT_DETAIL_NO_CANCELLATION_REASON: 'Aucun motif renseigné',
    EXTERNAL_BLOCK_TITLE: 'Événement externe',
    EXTERNAL_BLOCK_SOURCE_GOOGLE: 'Google Calendar',
    EXTERNAL_BLOCK_SOURCE_OUTLOOK: 'Outlook',
    EXTERNAL_BLOCK_SOURCE_APPLE: 'Apple Calendar',
    EXTERNAL_BLOCK_SOURCE_UNKNOWN: 'Agenda externe',
    EXTERNAL_BLOCK_INFO:
      "Cet événement vient d'un agenda externe. Pour le modifier, déplacez-le ou supprimez-le directement dans l'agenda source : il sera mis à jour ici automatiquement.",
    EXTERNAL_BLOCK_FIELD_WHEN: 'Quand',
    EXTERNAL_BLOCK_FIELD_MEMBER: 'Membre',
    EXTERNAL_BLOCK_FIELD_DESCRIPTION: 'Description',
    EXTERNAL_BLOCK_CLOSE: 'Fermer',
    ADD: 'Ajouter',
    TODAY: "Aujourd'hui",
    TOMORROW: 'Demain',
    YESTERDAY: 'Hier',
    GO_TO_DATE: 'Aller à une date',
    SHARE: 'Partager',
    SHARE_AGENDA_TITLE: "Partager l'agenda",
    SHARE_AGENDA_COMING_SOON: "Le partage de l'agenda sera bientôt disponible.",
    SHARE_BOOKING_TITLE: 'Partager votre réservation en ligne',
    SHARE_BOOKING_DESC: 'Configurez puis copiez le lien à partager avec vos clients.',
    SHARE_BOOKING_CREATE_LINK: 'Créer un lien',
    SHARE_BOOKING_FILTERS: 'Que proposer ?',
    SHARE_BOOKING_FILTERS_HINT: 'Laissez vide pour tout proposer.',
    SHARE_BOOKING_PRESTATIONS: 'Prestations',
    SHARE_BOOKING_PLACES: 'Lieux',
    SHARE_BOOKING_MEMBERS: 'Membres',
    SHARE_BOOKING_ALL: 'Tout',
    SHARE_BOOKING_DEFAULT_APPEARANCE: 'Apparence par défaut',
    SHARE_BOOKING_DEFAULT_APPEARANCE_HINT: 'Ces couleurs sont utilisées par défaut sur votre page de réservation.',
    SHARE_BOOKING_OVERRIDE_APPEARANCE: "Personnaliser l'apparence pour ce lien",
    SHARE_BOOKING_ACCENT: 'Couleur principale',
    SHARE_BOOKING_BG: 'Couleur de fond',
    SHARE_BOOKING_TEXT: 'Couleur du texte',
    SHARE_BOOKING_RADIUS: 'Arrondi des angles',
    SHARE_BOOKING_RADIUS_NONE: 'Net',
    SHARE_BOOKING_RADIUS_SOFT: 'Doux',
    SHARE_BOOKING_RADIUS_ROUND: 'Arrondi',
    SHARE_BOOKING_SAVE: 'Enregistrer',
    SHARE_BOOKING_SAVING: 'Enregistrement...',
    SHARE_BOOKING_SAVED: 'Apparence par défaut enregistrée.',
    SHARE_BOOKING_SAVE_FAILED: "Échec de l'enregistrement.",
    SHARE_BOOKING_TAB_LINK: 'Lien',
    SHARE_BOOKING_TAB_CODE: "Code d'intégration",
    SHARE_BOOKING_CODE_SOON: 'Le code à intégrer sur votre site sera disponible prochainement.',
    SHARE_BOOKING_SNIPPET: 'Code à coller sur votre site',
    SHARE_BOOKING_SNIPPET_HINT:
      'Copiez ces deux morceaux de code et collez-les sur votre site (WordPress, Wix, site custom...).',
    SHARE_BOOKING_SNIPPET_MODE_INLINE: 'Tunnel intégré dans la page',
    SHARE_BOOKING_SNIPPET_MODE_MODAL: 'Bouton qui ouvre une modale',
    SHARE_BOOKING_SNIPPET_COPIED: 'Code copié !',
    SHARE_BOOKING_SNIPPET_STEP1_TITLE: 'Intégration du widget',
    SHARE_BOOKING_SNIPPET_STEP1_HINT:
      "Ajoutez ce morceau de code à l'emplacement où vous souhaitez afficher la réservation.",
    SHARE_BOOKING_SNIPPET_STEP2_TITLE: 'Intégration du script',
    SHARE_BOOKING_SNIPPET_STEP2_HINT: "Ajoutez ce morceau de code dans la page, peu importe l'emplacement.",
    SHARE_BOOKING_SNIPPET_STEP2_WARNING:
      "Chaque type de widget a son propre script : si vous affichez à la fois la réservation et la carte cadeau sur la même page, ajoutez les deux scripts. En revanche, si vous répétez plusieurs fois le même widget, son script n'est à ajouter qu'une seule fois.",
    SHARE_BOOKING_SNIPPET_STEP3_TITLE: 'Testez',
    SHARE_BOOKING_SNIPPET_STEP3_HINT:
      "Ouvrez la page que vous venez d'éditer et vérifiez que le widget s'affiche correctement.",
    SHARE_BOOKING_LINK: 'Lien à partager',
    SHARE_BOOKING_COPY: 'Copier le lien',
    SHARE_BOOKING_COPIED: 'Lien copié !',
    SHARE_BOOKING_COPY_FAILED: 'Échec de la copie du lien.',
    SHARE_BOOKING_OPEN: 'Ouvrir',
    SHARE_BOOKING_RESET: 'Réinitialiser',
    SHARE_BOOKING_SCOPE_PLANNING: 'Selon la disponibilité',
    SHARE_BOOKING_NO_RESTRICTION: 'Aucune restriction',
    SHARE_BOOKING_OPEN_ON_DATE: 'Ouvrir le calendrier sur le {date}',
    SHARE_BOOKING_OPEN_ON_DATE_HINT:
      'Le client peut toujours choisir un autre jour. Sans effet si la date est passée quand il ouvre le lien.',
    SHARE_BOOKING_PREFILLED_HINT: "Périmètre pré-rempli depuis le planning « {name} ». Vous pouvez l'ajuster.",
    SHARE_BOOKING_LOADING: 'Chargement...',
    SHARE_BOOKING_ERROR: 'Impossible de charger les informations.',
    SETTINGS_TITLE: 'Paramètres de réservation',
    SETTINGS_TAB_DISPLAY: 'Affichage',
    SETTINGS_TAB_CALENDAR: 'Calendrier',
    SETTINGS_TAB_CUSTOM_FIELDS: 'Formulaire',
    SETTINGS_TAB_INSTRUCTIONS: 'Instructions',
    SETTINGS_TAB_SYNC: 'Synchronisation',
    CUSTOM_FIELDS_TITLE: 'Formulaire avant réservation',
    CUSTOM_FIELDS_DESCRIPTION:
      'Ajoutez des questions posées au client au moment de la réservation (motif du rendez-vous, allergies, etc.).',
    CUSTOM_FIELDS_LOADING: 'Chargement…',
    CUSTOM_FIELDS_EMPTY: 'Aucune question pour le moment.',
    CUSTOM_FIELDS_LOAD_FAILED: 'Échec du chargement des champs.',
    CUSTOM_FIELDS_NEW_LABEL_PLACEHOLDER: 'Intitulé du nouveau champ',
    CUSTOM_FIELDS_LABEL_PLACEHOLDER: 'Question posée au client',
    CUSTOM_FIELDS_OPTIONS_LABEL: 'Choix proposés au client',
    CUSTOM_FIELDS_OPTIONS_EMPTY: 'Aucun choix pour le moment. Ajoutez-en au moins un.',
    CUSTOM_FIELDS_OPTION_PLACEHOLDER: 'Ex : Première visite',
    CUSTOM_FIELDS_OPTION_ADD: 'Ajouter un choix',
    CUSTOM_FIELDS_OPTION_REMOVE_ARIA: 'Supprimer ce choix',
    CUSTOM_FIELDS_REQUIRED: 'Champ obligatoire',
    CUSTOM_FIELDS_PRESTATIONS_LABEL: 'Prestations concernées',
    CUSTOM_FIELDS_PRESTATIONS_PLACEHOLDER: 'Toutes les prestations',
    CUSTOM_FIELDS_PRESTATIONS_HINT:
      'Laissez vide pour ne pas limiter par prestation. Sinon, il ne s’affichera que si l’une des prestations sélectionnées est dans le panier.',
    CUSTOM_FIELDS_PRESTATIONS_GROUP_OTHER: 'Autres',
    CUSTOM_FIELDS_PLACES_LABEL: 'Lieux concernés',
    CUSTOM_FIELDS_PLACES_PLACEHOLDER: 'Tous les lieux',
    CUSTOM_FIELDS_PLACES_HINT:
      'Laissez vide pour ne pas limiter par lieu. Sinon, il ne s’affichera que pour les réservations tenues dans l’un des lieux sélectionnés (visio et téléphone compris). Combiné à des prestations, la réservation doit correspondre aux deux. Les réservations sans lieu, comme les courses, n’affichent pas les champs limités à des lieux.',
    CUSTOM_FIELDS_SAVE: 'Enregistrer',
    CUSTOM_FIELDS_ADD: 'Ajouter',
    CUSTOM_FIELDS_ARCHIVE_ARIA: 'Archiver',
    CUSTOM_FIELDS_ARCHIVE_TITLE: 'Archiver ce champ ?',
    CUSTOM_FIELDS_ARCHIVE_TEXT: 'Le champ "{label}" ne sera plus proposé lors des nouvelles réservations.',
    CUSTOM_FIELDS_ARCHIVE_CONFIRM: 'Archiver',
    CUSTOM_FIELDS_CANCEL: 'Annuler',
    CUSTOM_FIELDS_SAVED: 'Champ enregistré.',
    CUSTOM_FIELDS_SAVE_FAILED: "Échec de l'enregistrement.",
    CUSTOM_FIELDS_ARCHIVED: 'Champ archivé.',
    CUSTOM_FIELDS_ARCHIVE_FAILED: "Échec de l'archivage.",
    CUSTOM_FIELDS_CREATED: 'Champ ajouté.',
    CUSTOM_FIELDS_CREATE_FAILED: "Échec de l'ajout.",
    INSTRUCTIONS_TITLE: 'Instructions après réservation',
    INSTRUCTIONS_DESCRIPTION:
      'Ajoutez des sections envoyées au client après sa réservation (préparation, lieu, accès, justificatifs…). Seules les sections correspondant aux prestations et au lieu de la réservation sont incluses.',
    INSTRUCTIONS_LOADING: 'Chargement…',
    INSTRUCTIONS_EMPTY: 'Aucune section pour le moment.',
    INSTRUCTIONS_LOAD_FAILED: 'Échec du chargement des instructions.',
    INSTRUCTIONS_TITLE_LABEL: 'Titre de la section (optionnel)',
    INSTRUCTIONS_TITLE_PLACEHOLDER: 'Ex : Avant votre rendez-vous',
    INSTRUCTIONS_CONTENT_LABEL: 'Contenu',
    INSTRUCTIONS_CONTENT_PLACEHOLDER: 'Indications, consignes, informations utiles…',
    INSTRUCTIONS_CONTENT_TOO_LONG: 'Ce contenu est trop long : raccourcissez-le pour pouvoir enregistrer la section.',
    INSTRUCTIONS_ATTACHMENTS_LABEL: 'Pièces jointes (PDF ou image, max 10 Mo, 5 fichiers)',
    INSTRUCTIONS_ATTACHMENTS_ADD: 'Ajouter un fichier',
    INSTRUCTIONS_ATTACHMENTS_REMOVE_ARIA: 'Supprimer ce fichier',
    INSTRUCTIONS_ATTACHMENTS_UPLOADING: 'Envoi en cours…',
    INSTRUCTIONS_ATTACHMENTS_TOO_LARGE: 'Le fichier dépasse 10 Mo.',
    INSTRUCTIONS_ATTACHMENTS_INVALID_TYPE: 'Format non pris en charge (PDF, JPG, PNG ou WEBP).',
    INSTRUCTIONS_ATTACHMENTS_LIMIT_REACHED: 'Maximum 5 pièces jointes par section.',
    INSTRUCTIONS_ATTACHMENTS_UPLOAD_FAILED: "Échec de l'envoi du fichier.",
    INSTRUCTIONS_PRESTATIONS_LABEL: 'Prestations concernées',
    INSTRUCTIONS_PRESTATIONS_PLACEHOLDER: 'Toutes les prestations',
    INSTRUCTIONS_PRESTATIONS_HINT:
      'Laissez vide pour ne pas limiter par prestation. Sinon, elle ne sera incluse que si l’une des prestations sélectionnées est réservée.',
    INSTRUCTIONS_PLACES_LABEL: 'Lieux concernés',
    INSTRUCTIONS_PLACES_PLACEHOLDER: 'Tous les lieux',
    INSTRUCTIONS_PLACES_HINT:
      'Laissez vide pour ne pas limiter par lieu. Sinon, elle ne sera incluse que pour les réservations tenues dans l’un des lieux sélectionnés (visio et téléphone compris). Combinée à des prestations, la réservation doit correspondre aux deux. Les réservations sans lieu, comme les courses, ne reçoivent pas les sections limitées à des lieux.',
    INSTRUCTIONS_SAVE: 'Enregistrer',
    INSTRUCTIONS_ADD: 'Ajouter une section',
    INSTRUCTIONS_ARCHIVE_ARIA: 'Archiver',
    INSTRUCTIONS_ARCHIVE_TITLE: 'Archiver cette section ?',
    INSTRUCTIONS_ARCHIVE_TEXT: 'Cette section ne sera plus envoyée aux prochaines réservations.',
    INSTRUCTIONS_ARCHIVE_CONFIRM: 'Archiver',
    INSTRUCTIONS_CANCEL: 'Annuler',
    INSTRUCTIONS_SAVED: 'Instructions enregistrées.',
    INSTRUCTIONS_SAVE_FAILED: "Échec de l'enregistrement.",
    INSTRUCTIONS_ARCHIVED: 'Section archivée.',
    INSTRUCTIONS_ARCHIVE_FAILED: "Échec de l'archivage.",
    INSTRUCTIONS_CREATED: 'Section ajoutée.',
    INSTRUCTIONS_CREATE_FAILED: "Échec de l'ajout.",
    APPOINTMENT_DETAIL_INSTRUCTIONS_HEADING: 'Instructions',
    APPOINTMENT_DETAIL_INSTRUCTIONS_ATTACHMENTS: 'Pièces jointes',
    SETTINGS_DEFAULT_VIEW_LABEL: 'Vue par défaut',
    SETTINGS_SYNC_COMING_SOON: 'La synchronisation du calendrier sera bientôt disponible.',
    UPDATE_BOOKING_ALERT_TITLE: 'Modifier le rendez-vous',
    UPDATE_BOOKING_ALERT_TEXT: 'Êtes-vous sûr de vouloir modifier ce rendez-vous ?',
    // Déplacement d'un rendez-vous remisé hors des conditions de sa promotion (lot 4) : la remise est conservée.
    PROMOTION_MOVE_TITLE: 'Déplacer le rendez-vous ?',
    PROMOTION_MOVE_OUTSIDE_HOURS:
      'Le nouvel horaire ({date} · {time}) est en dehors des heures de la promotion « {name} ». La remise de {amount} est conservée.',
    PROMOTION_MOVE_OUTSIDE_DATES:
      'Le nouvel horaire ({date} · {time}) est en dehors des dates de la promotion « {name} ». La remise de {amount} est conservée.',
    PROMOTION_MOVE_CONFIRM: 'Déplacer',
    CANCELLED_EVENT_BADGE: 'Annulé',
    NO_SHOW_EVENT_BADGE: 'Non présenté',
    WAITING_CONFIRMATION_EVENT_BADGE: 'En attente de confirmation',
    EVENT_STATUS_PENDING_BADGE: 'En attente',
    EVENT_RIDE_VEHICLE_TO_ASSIGN_BADGE: 'Véhicule à attribuer',
    // Sans ce repère, les N cartes d'un même trajet sont indiscernables sur l'agenda.
    EVENT_RIDE_VEHICLE_POSITION_BADGE: 'Véhicule {index}/{count}',
    EVENT_PICTO_RIDE: 'Course',
    EVENT_PICTO_GROUP: 'Rendez-vous de groupe',
    EVENT_PICTO_PAYMENT: 'Paiement associé',
    EVENT_PICTO_DISCOUNT: 'Remise sur ce rendez-vous',
    MULTI_STAFF_BADGE: '+{count}',
    MULTI_STAFF_BADGE_TOOLTIP: '{count} autre(s) intervenant(s) sur ce rendez-vous',
    MULTI_STAFF_SELECTED_COUNT: '{count, plural, one {# intervenant sélectionné} other {# intervenants sélectionnés}}',
    GROUP_SESSION_BADGE_TOOLTIP:
      '{count, plural, one {# participant sur cette séance} other {# participants sur cette séance}}',
    GROUP_SESSION_PARTICIPANT_COUNT: '{count, plural, one {# participant} other {# participants}}',
    GROUP_SESSION_PARTY_SIZE: '×{count}',
    GROUP_SESSION_CAPACITY_BADGE: '{count}/{capacity}',
    GROUP_SESSION_CAPACITY_BADGE_TOOLTIP:
      '{count, plural, one {# participant} other {# participants}} sur {capacity} places',
    GROUP_SESSION_PARTICIPANT_COUNT_WITH_CAPACITY:
      '{count, plural, one {# participant} other {# participants}} · {capacity} places',
    GROUP_SESSION_MORE_CLIENTS: '{count, plural, one {+# autre client} other {+# autres clients}}',
    GROUP_SESSION_EXPORT_LIST: 'Télécharger la liste',
    GROUP_SESSION_EXPORT_CUSTOMER: 'Client',
    GROUP_SESSION_EXPORT_PHONE: 'Téléphone',
    GROUP_SESSION_EXPORT_EMAIL: 'Email',
    GROUP_SESSION_EXPORT_PARTY_SIZE: 'Personnes',
    GROUP_SESSION_EXPORT_STATUS: 'Statut',
    GROUP_SESSION_EXPORT_ATTENDANCE: 'Présence',
    GROUP_SESSION_EXPORT_STATUS_CONFIRMED: 'Confirmé',
    GROUP_SESSION_EXPORT_FILENAME_FALLBACK: 'seance',
    APPOINTMENT_WAITING_CONFIRMATION_BANNER: 'Ce rendez-vous doit être confirmé.',
    APPOINTMENT_CANCELLED_BY_PRO_BANNER: 'Ce rendez-vous a été annulé par vous.',
    APPOINTMENT_CANCELLED_BY_CUSTOMER_BANNER: 'Ce rendez-vous a été annulé par le client.',
    DELETE_APPOINTMENT: 'Annuler le rendez-vous',
    DELETE_APPOINTMENT_CONFIRM_TITLE: 'Annuler le rendez-vous ?',
    DELETE_APPOINTMENT_CONFIRM_TEXT: 'Le rendez-vous sera marqué comme annulé.',
    DELETE_APPOINTMENT_PAYMENT_WARNING:
      "L'annulation du rendez-vous ne déclenche pas automatiquement le remboursement du paiement associé.",
    DELETE_APPOINTMENT_REASON_LABEL: "Motif d'annulation",
    DELETE_APPOINTMENT_REASON_PLACEHOLDER: 'Expliquez la raison de cette annulation au client.',
    DELETE_APPOINTMENT_REFUND_PAYMENT_TOGGLE: 'Rembourser le paiement ({amount})',
    // Retrait d'un véhicule : sa PART du paiement (prorata calculé backend), jamais tout le paiement.
    DELETE_APPOINTMENT_REFUND_VEHICLE_TOGGLE: 'Rembourser la part de ce véhicule ({amount})',
    // Paiement ajouté par le pro (lien, partage…) : hors politique d'annulation, son net encaissé en ligne.
    DELETE_APPOINTMENT_REFUND_EXTRA_PAYMENT_TOGGLE: 'Rembourser « {label} » ({amount})',
    DELETE_APPOINTMENT_EXTRA_PAYMENT_DEFAULT_LABEL: 'Paiement du {date}',
    DELETE_APPOINTMENT_RESTORE_VOUCHER_TOGGLE: 'Restituer le bon utilisé ({code} · {amount})',
    PURGE_APPOINTMENT: 'Supprimer le rendez-vous',
    PURGE_APPOINTMENT_CONFIRM_TITLE: 'Supprimer le rendez-vous ?',
    PURGE_APPOINTMENT_CONFIRM_TEXT:
      'Le rendez-vous annulé sera retiré définitivement de votre agenda. Cette action est irréversible.',
    CONFIRM_BOOKING: 'Confirmer le rendez-vous',
    UPDATE_RECURRING_APPOINTMENT_TITLE: 'Modifier le rendez-vous récurrent',
    DELETE_RECURRING_APPOINTMENT_TITLE: 'Annuler le rendez-vous récurrent',
    AVAILABILITIES_SHORT: 'Dispos',
    AVAILABILITIES: 'Disponibilités',
    AVAILABILITIES_MENU_PLANNING: 'Gérer mes disponibilités',
    AVAILABILITIES_MENU_ADD_UNAVAILABILITY: 'Ajouter une indisponibilité',
    RESOURCES_FILTER_ALL: 'Toutes',
    RESOURCES_FILTER_VEHICLE: 'Véhicules',
    RESOURCES_FILTER_ROOM: 'Salles',
    RESOURCES_FILTER_EQUIPMENT: 'Matériel',
    RESOURCES_FILTER_TRIGGER: 'Ressources',
    RESOURCES_FILTER_SEARCH_PLACEHOLDER: 'Rechercher une ressource…',
    RESOURCES_FILTER_EMPTY: 'Aucune ressource trouvée.',
    TEAM_MEMBERS_FILTER_TRIGGER: 'Équipe',
    TEAM_MEMBERS_FILTER_SEARCH_PLACEHOLDER: 'Rechercher un membre…',
    TEAM_MEMBERS_FILTER_EMPTY: 'Aucun membre trouvé.',
    EMPTY_SELECTION_TITLE: 'Aucune sélection',
    EMPTY_SELECTION_DESCRIPTION: 'Sélectionnez au moins un membre ou une ressource pour afficher l’agenda.',
    OWN_AGENDA_UNLINKED_TITLE: 'Aucun membre associé',
    OWN_AGENDA_UNLINKED_DESCRIPTION:
      'Votre compte n’est associé à aucun membre de l’équipe. Demandez à un responsable de faire le lien pour accéder à votre agenda.',
    OWN_AGENDA_DISABLED_TITLE: 'Votre agenda est désactivé',
    OWN_AGENDA_DISABLED_DESCRIPTION:
      'Votre agenda personnel n’est pas activé. Demandez à un responsable de l’activer depuis la gestion de l’équipe.',
    RESOURCE_SATURATED: '{name} est saturée à ce créneau',
    PIVOT_VIEW_MEMBERS: 'Vue équipe',
    PIVOT_VIEW_RESOURCES: 'Vue ressources',
    OTHER: 'autre',
    OTHERS: 'autres',
    DAILY_VIEW: 'Jour',
    DAILY_3: '3 jours',
    WEEKLY_VIEW: 'Semaine',
    MONTHLY_VIEW: 'Mois',
    PLANNING_VIEW: 'Planning',
    CHOOSE_BY_SLOT: 'Créneau choisi',
    CHOOSE_BY_AVAILABILITY: 'Selon mes dispos',
    START: 'Début',
    END: 'Fin',
    CUSTOMER_LABEL: 'Client',
    CUSTOMER_SEARCH_PLACEHOLDER: 'Rechercher un client...',
    CUSTOMER_SEARCH_EMPTY: 'Aucun client trouvé',
    ADD_CUSTOMER_QUICK: 'Nouveau client',
    PRESTATION_LABEL: 'Prestations',
    LINKED_SUPPLEMENTS_LABEL: 'Suppléments liés',
    LINKED_SUPPLEMENTS_PLACEHOLDER: 'Choisir des suppléments...',
    PRESTATION_SEARCH_PLACEHOLDER: 'Rechercher une prestation...',
    PRESTATION_SEARCH_EMPTY: 'Aucune prestation trouvée',
    APPOINTMENT_END_REAPPLY_PRESTATIONS_DURATION_WITH_VALUE: 'Appliquer {duration} selon vos prestations',
    APPOINTMENT_END_MODE_DURATION: 'Durée',
    APPOINTMENT_END_MODE_END_DATE: 'Heure de fin',
    APPOINTMENT_DURATION_LABEL: 'Durée du rendez-vous',
    APPOINTMENT_DURATION_CUSTOM_LABEL: 'Personnaliser',
    APPOINTMENT_ESTIMATED_END_LABEL: 'Fin estimée',
    APPOINTMENT_CALCULATED_DURATION_LABEL: 'Durée calculée',
    APPOINTMENT_DURATION_ALL_DAY: 'Toute la journée',
    APPOINTMENT_DURATION_PREVIOUS_OPTIONS: 'Durées précédentes',
    APPOINTMENT_DURATION_NEXT_OPTIONS: 'Durées suivantes',
    APPOINTMENT_AGENDA_BUFFER_WITH_VALUE: 'dont {duration} de battement',
    // Temps de battement : inclus dans la fin saisie, il bloque l'agenda après la fin vue par le client.
    APPOINTMENT_DURATION_WITH_BUFFER: '{duration} + {buffer} de battement',
    APPOINTMENT_DURATION_WITH_BUFFER_MANUAL: '{duration} dont {buffer} de battement · fin client {time}',
    APPOINTMENT_BUFFER_REMOVE_ACTION: 'Sans battement',
    APPOINTMENT_BUFFER_RESTORE_ACTION: '+ {buffer} de battement',
    APPOINTMENT_TEAM_MEMBER_REQUIRED: 'Sélectionnez au moins un membre de l’équipe.',
    APPOINTMENT_NAME_PLACEHOLDER: 'Titre du rendez-vous (optionnel)',
    APPOINTMENT_NAME_LABEL: 'Titre',
    APPOINTMENT_NOTE_PLACEHOLDER: 'Ajouter une note...',
    APPOINTMENT_NOTE_LABEL: 'Note',
    APPOINTMENT_BUSY: 'Occupé',
    APPOINTMENT_NOT_BUSY: 'Disponible',
    APPOINTMENT_BLOCK_SLOT_TITLE: 'Bloquer le créneau de rendez-vous',
    APPOINTMENT_BUSY_OPTION: 'Oui, ne sera plus réservable en ligne',
    APPOINTMENT_NOT_BUSY_OPTION: 'Non, sera toujours réservable',
    PLACE_LABEL: 'Lieu',
    APPOINTMENT_CUSTOMER_ADDRESS_LABEL: 'Adresse du rendez-vous',
    APPOINTMENT_OPEN_DIRECTIONS_LABEL: 'Itinéraire',
    LINKED_RESOURCES_LABEL: 'Ressources mobilisées',
    LINKED_RESOURCES_EMPTY: 'Aucune ressource liée',
    LINKED_RESOURCE_MOBILITY_LABEL: 'Mobilité',
    GROUP_BY_LABEL: 'Grouper par',
    GROUP_BY_TEAM_MEMBER: 'Par membre',
    GROUP_BY_RESOURCE: 'Par ressource',
    GROUP_BY_SELF_SERVICE_PRESTATION: 'Par prestation libre-service',
    GROUP_BY_NO_COLUMN: 'Aucun élément sélectionné',
    GROUP_BY_RESOURCE_SELECTOR_PLACEHOLDER: 'Choisir des ressources',
    GROUP_BY_SELF_SERVICE_SELECTOR_PLACEHOLDER: 'Choisir des prestations libre-service',
    GROUP_BY_NO_RESOURCE_AVAILABLE: 'Aucune ressource disponible',
    GROUP_BY_NO_SELF_SERVICE_AVAILABLE: 'Aucune prestation libre-service',
    TEAM_MEMBER_LABEL: 'Membre',
    DISPLAY_SETTINGS_TITLE: "Paramètres d'affichage",
    DISPLAY_SETTINGS_DESCRIPTION: "Personnalisez l'affichage de votre agenda.",
    DISPLAY_SLOT_DURATION_LABEL: "Durée d'un créneau affiché",
    DISPLAY_SLOT_DURATION_OPTION: '{count} minutes',
    DISPLAY_FIRST_HOUR_LABEL: 'Première heure affichée',
    DISPLAY_DONE: 'Terminé',
    NEW_EVENT: 'Nouvel événement',
    EVENTS_COUNT: '{count, plural, one {# événement} other {# événements}}',
    NO_EVENT_PLANNED: 'Aucun événement prévu',
    NO_EVENT_PLANNED_HINT_MOBILE: 'Appuyez sur "{buttonLabel}"',
    NO_EVENT_PLANNED_HINT_DESKTOP: 'Cliquez sur "{buttonLabel}" pour créer un nouvel événement',
    NO_DAY_TO_DISPLAY: 'Aucun jour à afficher',
    NO_DAY_TO_DISPLAY_DESCRIPTION: 'La période sélectionnée ne contient aucun jour',
    ONGOING: 'En cours',
    ENDS_ON: 'Se termine le',
    STARTED_ON: 'Débuté le',
    WEEKDAY_SHORT_MONDAY: 'Lun',
    WEEKDAY_SHORT_TUESDAY: 'Mar',
    WEEKDAY_SHORT_WEDNESDAY: 'Mer',
    WEEKDAY_SHORT_THURSDAY: 'Jeu',
    WEEKDAY_SHORT_FRIDAY: 'Ven',
    WEEKDAY_SHORT_SATURDAY: 'Sam',
    WEEKDAY_SHORT_SUNDAY: 'Dim',
    DURATION_LABEL: 'Durée {duration}',
    AND_X_OTHERS: '• +{count} autres',
    AVAIL_DETAIL_PLANNING: 'Planning',
    AVAIL_DETAIL_EDIT_PLANNING: 'Modifier le planning',
    AVAIL_DETAIL_WORK_HOURS: 'Horaire de travail',
    AVAIL_DETAIL_AVAILABLE: 'Disponible',
    AVAIL_DETAIL_UNAVAILABLE_SLOT: 'Indisponible sur ce créneau',
    AVAIL_DETAIL_SHARE_CALENDAR: 'Partager le calendrier',
    AVAIL_DETAIL_OPEN_BOOKING_PAGE: 'Ouvrir la page de réservation',
    AVAIL_DETAIL_SHARE: 'Partager',
    AVAIL_DETAIL_SHARE_RESTRICTED_HINT:
      'Ce créneau est réservé aux clients portant certains tags : un client non tagué pourra parcourir le tunnel mais sera refusé à la confirmation.',
    AVAIL_DETAIL_SHARE_NOT_BOOKABLE_HINT:
      "Ce planning n'est pas réservable en ligne : le lien n'affichera aucun créneau. Ouvrez « Modifier le planning » pour en connaître la raison.",
    AVAIL_DETAIL_SHARE_NO_SLUG_HINT: "Votre page de réservation n'est pas encore configurée.",
    AVAIL_DETAIL_SHARE_PLANNING_GONE: "Ce planning n'existe plus : le lien proposera toute votre offre.",
    AVAIL_DETAIL_BOOKING_LINK_UNAVAILABLE: 'Impossible de préparer le lien de réservation pour ce planning.',
    AVAILABILITY_PICKER_MISSING_PREREQUISITES:
      'Sélectionnez au moins une prestation et un lieu pour voir les disponibilités.',
    AVAILABILITY_PICKER_PREVIOUS_WEEK: 'Semaine précédente',
    AVAILABILITY_PICKER_NEXT_WEEK: 'Semaine suivante',
    AVAILABILITY_PICKER_NO_SLOTS: 'Aucun créneau disponible',
    AVAILABILITY_PICKER_FOR_PLACE_LABEL: 'Disponibilités pour {place}',
    AVAILABILITY_PICKER_CHANGE_PLACE_CTA: 'Modifier',
    AVAILABILITY_PICKER_SELECT_DATE: 'Sélectionnez une date',
    AVAILABILITY_PICKER_REMAINING_PLACES: '{count, plural, one {# place} other {# places}}',
    AVAILABILITY_PICKER_SLOT_FULL: 'Complet',
    APPOINTMENT_UNTITLED_LABEL: 'Rendez-vous',
    RESERVATION_PRICE_LABEL: 'Montant',
    RESERVATION_PRICE_OVERRIDE_PLACEHOLDER: 'Calculé automatiquement',
    // Réservation multi-créneaux : le champ « Montant » porte le total de TOUTE la réservation,
    // et la sous-ligne rappelle ce que vaut le créneau ouvert.
    RESERVATION_TOTAL_LABEL: 'Total de la réservation',
    SESSION_OVERBOOKING_CONFIRM_TITLE: 'Cette séance est complète',
    SESSION_OVERBOOKING_CONFIRM_TEXT:
      'Toutes les places de cette séance sont déjà réservées. Vous pouvez tout de même ajouter ce rendez-vous si vous savez pouvoir l’accueillir.',
    SESSION_OVERBOOKING_CONFIRM_CTA: 'Ajouter quand même',
    RESOURCE_OVERBOOKING_CONFIRM_TITLE: 'Ressource déjà occupée',
    RESOURCE_OVERBOOKING_CONFIRM_TEXT:
      'Une ressource nécessaire à ce rendez-vous (salle, cabine, matériel…) est déjà réservée sur ce créneau. Vous pouvez tout de même l’enregistrer si vous savez pouvoir l’accueillir : la ressource sera comptée en surréservation.',
    RESOURCE_OVERBOOKING_CONFIRM_CTA: 'Enregistrer quand même',
    RESOURCE_PARTY_SIZE_CONFIRM_TITLE: 'Groupe plus grand que la ressource',
    RESOURCE_PARTY_SIZE_CONFIRM_TEXT:
      'Ce groupe dépasse la capacité d’une ressource nécessaire à ce rendez-vous (salle, cabine, matériel…). Vous pouvez tout de même l’enregistrer si vous savez pouvoir l’accueillir.',
    RESOURCE_PARTY_SIZE_CONFIRM_CTA: 'Enregistrer quand même',
    // Annulation d'une réservation à plusieurs créneaux : portée explicite.
    DELETE_APPOINTMENT_SCOPE_THIS_SLOT: 'Ce créneau uniquement',
    DELETE_APPOINTMENT_SCOPE_RESERVATION: 'Toute la réservation ({count, plural, one {# créneau} other {# créneaux}})',
    /* Course multi-véhicules : la portée partielle est le VÉHICULE entier (aller + retour) —
       « Ce créneau uniquement » dissocierait les deux trajets, ce que le backend refuse. */
    DELETE_APPOINTMENT_SCOPE_VEHICLE: 'Retirer ce véhicule (aller + retour)',
    DELETE_APPOINTMENT_SCOPE_RESERVATION_VEHICLES:
      'Annuler toute la réservation ({count, plural, one {# véhicule} other {# véhicules}})',
    APPOINTMENT_EDIT_REMOVE_SLOT_CTA: 'Retirer ce créneau',
    APPOINTMENT_EDIT_REMOVE_SLOT_TITLE: 'Retirer ce créneau de la réservation ?',
    APPOINTMENT_EDIT_REMOVE_SLOT_TEXT:
      'La réservation reste active avec ses {count, plural, one {# autre créneau} other {# autres créneaux}} et son montant est recalculé.',
    APPOINTMENT_EDIT_REMOVE_SLOT_SUCCESS: 'Créneau retiré de la réservation',
    // Aperçu d'un rendez-vous multi-prestations : une prestation = un créneau consécutif.
    APPOINTMENT_CHAIN_PREVIEW_TITLE: '{count, plural, one {# créneau} other {# créneaux consécutifs}}',
    APPOINTMENT_CHAIN_PREVIEW_HINT: 'Chaque prestation occupera son propre créneau, dans une seule réservation.',
    APPOINTMENT_CHAIN_RECURRENCE_HINT:
      'Les prestations d’un rendez-vous récurrent sont regroupées dans un seul créneau par occurrence.',
    APPOINTMENT_SLOT_PRICE_WITH_VALUE: 'Montant de ce créneau : {price}',
    RIDE_DETAILS_SECTION_TITLE: 'Trajet',
    RIDE_PICKUP_ADDRESS_LABEL: 'Adresse de prise en charge',
    RIDE_PICKUP_ADDRESS_PLACEHOLDER: 'Rechercher une adresse de départ',
    RIDE_DROPOFF_ADDRESS_LABEL: 'Adresse de destination',
    RIDE_DROPOFF_ADDRESS_PLACEHOLDER: 'Rechercher une adresse de destination',
    RIDE_ESTIMATED_PRICE_LABEL: 'Prix estimé',
    RIDE_APPLY_ESTIMATED_PRICE: 'Appliquer',
    RIDE_ESTIMATED_DISTANCE_LABEL: 'Distance estimée',
    RIDE_DISTANCE_VALUE: '{distance} km',
    RIDE_ESTIMATED_DURATION_LABEL: 'Durée estimée',
    RIDE_CALCULATING: 'Calcul en cours...',
    RIDE_SWAP_ADDRESSES: 'Inverser aller / retour',
    RIDE_VEHICLE_LABEL: 'Véhicule',
    RIDE_VEHICLE_AUTO: 'Automatique (premier véhicule compatible)',
    RIDE_VEHICLE_PASSENGER_RANGE: '{min}-{max} passagers',
    /* Course multi-véhicules : on édite le prix d'UN véhicule ; le total de la réservation est
       leur somme, recalculée par le backend — d'où son affichage en lecture seule. */
    RIDE_VEHICLE_PRICE_LABEL: 'Prix de ce véhicule',
    RIDE_RESERVATION_TOTAL_READONLY:
      'Total de la réservation ({count, plural, one {# véhicule} other {# véhicules}}) : {total}',
    RIDE_OUTBOUND_LABEL: 'Aller',
    RIDE_RETURN_LABEL: 'Retour',
    RIDE_TRIP_TYPE_LOCKED_HINT:
      'Le type de trajet ne peut pas être modifié après création. Pour le changer, annulez et recréez la course.',
    ADD_APPOINTMENT_BUTTON: 'Rendez-vous',
    ADD_RIDE_APPOINTMENT_BUTTON: 'Course',
    CUSTOMER_DETAILS_NO_PHONE: 'Aucun téléphone renseigné',
    MARK_UNAVAILABLE_CONFIRM_TITLE: 'Marquer ce créneau comme indisponible ?',
    MARK_UNAVAILABLE_CONFIRM_TEXT_NO_APPOINTMENTS:
      "Aucun rendez-vous n'est prévu sur ce créneau. Souhaitez-vous le marquer comme indisponible ?",
    MARK_UNAVAILABLE_CONFIRM_TEXT_WITH_APPOINTMENTS: 'Les membres suivants ont des rendez-vous sur ce créneau :',
    MARK_UNAVAILABLE_MEMBER_APPOINTMENTS:
      '{firstname} {lastname} : {count, plural, one {# rendez-vous} other {# rendez-vous}}',
    MARK_UNAVAILABLE_CANCEL_QUESTION: 'Souhaitez-vous également annuler ces rendez-vous ?',
    MARK_UNAVAILABLE_CONFIRM_LABEL: 'Marquer indisponible',
    MARK_UNAVAILABLE_CONFIRM_LABEL_AND_CANCEL: 'Marquer indisponible et annuler',
    MARK_UNAVAILABLE_SCOPE_TEXT:
      'Choisissez si vous souhaitez bloquer uniquement le membre cliqué, plusieurs membres, ou toute la disponibilité.',
    MARK_UNAVAILABLE_SCOPE_SINGLE_LABEL: 'Bloquer seulement {memberName}',
    MARK_UNAVAILABLE_SCOPE_SINGLE_HINT: 'Seul ce membre deviendra indisponible sur ce créneau.',
    MARK_UNAVAILABLE_SCOPE_MULTIPLE_LABEL: 'Bloquer plusieurs membres',
    MARK_UNAVAILABLE_SCOPE_MULTIPLE_HINT: 'Sélectionnez les membres à rendre indisponibles sur ce créneau.',
    MARK_UNAVAILABLE_SCOPE_ALL_LABEL: 'Bloquer tous les membres',
    MARK_UNAVAILABLE_SCOPE_ALL_HINT: 'Toute la disponibilité sera rendue indisponible sur ce créneau.',
    MARK_AVAILABLE_CONFIRM_TITLE: 'Rendre ce créneau disponible ?',
    MARK_AVAILABLE_CONFIRM_TEXT: 'Ce créneau sera de nouveau réservable par vos clients.',
    MARK_AVAILABLE_CONFIRM_LABEL: 'Rendre disponible',
    MARK_AVAILABLE_SCOPE_TEXT:
      'Ce créneau fait partie d’un segment d’indisponibilité plus large. Choisissez ce que vous souhaitez débloquer.',
    MARK_AVAILABLE_SCOPE_FULL_LABEL: 'Débloquer tout le segment',
    MARK_AVAILABLE_SCOPE_FULL_HINT: 'Segment complet : {timeRange}',
    MARK_AVAILABLE_SCOPE_SELECTED_LABEL: 'Débloquer seulement cette portion',
    MARK_AVAILABLE_SCOPE_SELECTED_HINT: 'Le reste du segment restera bloqué.',
    MARK_AVAILABLE_MEMBER_STEP_LABEL: 'Membres concernés',
    MARK_AVAILABLE_SCOPE_STEP_LABEL: 'Portion à débloquer',
    MARK_AVAILABLE_MEMBER_SCOPE_TEXT:
      'Choisissez si vous souhaitez rétablir la disponibilité pour certains membres ou pour toute la disponibilité.',
    MARK_AVAILABLE_MEMBER_SCOPE_SELECTED_LABEL: 'Rétablir certains membres',
    MARK_AVAILABLE_MEMBER_SCOPE_SELECTED_HINT:
      'Sélectionnez les membres à rendre de nouveau disponibles sur ce créneau.',
    MARK_AVAILABLE_MEMBER_SCOPE_ALL_LABEL: 'Rétablir tous les membres',
    MARK_AVAILABLE_MEMBER_SCOPE_ALL_HINT: 'Tous les membres concernés redeviendront disponibles sur ce créneau.',
    RANGE_UNAVAIL_TOOLBAR_BUTTON: 'Indisponibilité',
    RANGE_UNAVAIL_TITLE: 'Gérer ma disponibilité',
    RANGE_UNAVAIL_ACTION_MARK_UNAVAILABLE: 'Bloquer',
    RANGE_UNAVAIL_ACTION_RESTORE: 'Débloquer',
    RANGE_UNAVAIL_PERIOD_LABEL: 'Période',
    RANGE_UNAVAIL_PRESET_TODAY: "Aujourd'hui",
    RANGE_UNAVAIL_PRESET_TOMORROW: 'Demain',
    RANGE_UNAVAIL_PRESET_THIS_WEEK: 'Cette semaine',
    RANGE_UNAVAIL_PRESET_NEXT_WEEK: 'Semaine prochaine',
    RANGE_UNAVAIL_PRESET_CUSTOM: 'Personnalisé',
    RANGE_UNAVAIL_START_LABEL: 'Du',
    RANGE_UNAVAIL_END_LABEL: 'Au',
    RANGE_UNAVAIL_MEMBER_LABEL: 'Membres concernés',
    RANGE_UNAVAIL_MEMBER_ALL_LABEL: 'Sélectionner tous les membres',
    RANGE_UNAVAIL_PREVIEW_AFFECTED: '{count, plural, one {# planning concerné} other {# plannings concernés}}',
    RANGE_UNAVAIL_PREVIEW_APPOINTMENTS:
      '{count, plural, =0 {Aucun rendez-vous impacté} one {# rendez-vous impacté} other {# rendez-vous impactés}}',
    RANGE_UNAVAIL_PREVIEW_EXISTING:
      '{count, plural, =0 {Aucune indisponibilité existante} one {# indisponibilité existante sera supprimée} other {# indisponibilités existantes seront supprimées}}',
    RANGE_UNAVAIL_BLOCKED_CHUNKS_TITLE: 'Créneaux déjà bloqués',
    RANGE_UNAVAIL_BLOCKED_CHUNKS_EMPTY: 'Aucun créneau bloqué trouvé.',
    RANGE_UNAVAIL_BLOCKED_CHUNKS_GROUP_COUNT:
      '{count, plural, one {# planning bloqué sur ce créneau} other {# plannings bloqués sur ce créneau}}',
    RANGE_UNAVAIL_BLOCKED_CHUNKS_MORE:
      '{count, plural, one {# autre créneau bloqué non affiché} other {# autres créneaux bloqués non affichés}}',
    RANGE_UNAVAIL_NEXT_BLOCKED_CHUNK_TITLE: 'Prochain créneau bloqué',
    RANGE_UNAVAIL_NEXT_BLOCKED_CHUNK_HINT: 'Ce créneau est proposé automatiquement pour un déblocage rapide.',
    RANGE_UNAVAIL_CANCEL_APPOINTMENTS_LABEL: 'Annuler également les rendez-vous concernés',
    RANGE_UNAVAIL_CANCEL_APPOINTMENTS_HINT:
      "Vous pourrez choisir d'annuler les rendez-vous concernés à l'étape suivante.",
    RANGE_UNAVAIL_CANCEL_APPOINTMENTS_TITLE: 'Annuler les rendez-vous ?',
    RANGE_UNAVAIL_CANCEL_APPOINTMENTS_DESCRIPTION:
      '{count, plural, one {# rendez-vous est concerné par cette indisponibilité.} other {# rendez-vous sont concernés par cette indisponibilité.}} Souhaitez-vous les annuler ?',
    RANGE_UNAVAIL_CANCEL_APPOINTMENTS_CONFIRM: 'Annuler les rendez-vous',
    RANGE_UNAVAIL_CANCEL_APPOINTMENTS_KEEP: 'Conserver les rendez-vous',
    RANGE_UNAVAIL_CANCELLATION_REASON_LABEL: "Motif d'annulation (optionnel)",
    RANGE_UNAVAIL_CANCELLATION_REASON_PLACEHOLDER: 'Communiqué aux clients',
    RANGE_UNAVAIL_RESTORE_DISCLAIMER: 'Les rendez-vous précédemment annulés ne seront pas restaurés automatiquement.',
    RANGE_UNAVAIL_CONFIRM_MARK: "Confirmer l'indisponibilité",
    RANGE_UNAVAIL_CONFIRM_MARK_NO_APPOINTMENTS:
      'Aucun rendez-vous ne sera impacté. Confirmer la mise en indisponibilité ?',
    RANGE_UNAVAIL_CONFIRM_RESTORE: 'Restaurer la disponibilité',
    RANGE_UNAVAIL_INVALID_RANGE: 'La date de fin doit être après la date de début.',
    RANGE_UNAVAIL_MEMBER_SELECTION_REQUIRED: 'Sélectionnez au moins un membre pour continuer.',
    RANGE_UNAVAIL_SUCCESS_MARKED: 'Indisponibilité enregistrée.',
    RANGE_UNAVAIL_SUCCESS_RESTORED: 'Disponibilité restaurée.',
    AVAIL_DETAIL_UNAVAILABLE: 'Indisponible',
    AVAIL_DETAIL_MAKE_AVAILABLE: 'Rendre disponible',
    VOUCHER_USE_BUTTON: 'Utiliser un coupon',
    VOUCHER_SEARCH_TITLE: 'Utiliser un coupon sur ce rendez-vous',
    VOUCHER_SEARCH_EMPTY: 'Aucun coupon trouvé',
    VOUCHER_USE_AMOUNT_LABEL: 'Montant à utiliser',
    VOUCHER_USE_AMOUNT_PLACEHOLDER: 'Saisir un montant',
    VOUCHER_USE_MAX: 'Maximum',
    VOUCHER_USE_PREVIEW_REMAINING: 'Reste après utilisation',
    VOUCHER_USE_PRESTATIONS_LABEL: 'Quantité à déduire par prestation',
    VOUCHER_USE_REMAINING_LABEL: 'restant',
    VOUCHER_USE_SELECTED_TOTAL: 'Total sélectionné',
    VOUCHER_USE_CANCEL: 'Annuler',
    VOUCHER_USE_CONFIRM: "Confirmer l'utilisation",
    VOUCHER_USE_LOADING: 'Utilisation...',
    VOUCHER_USE_SUCCESS: 'Coupon utilisé avec succès',
    VOUCHER_USE_ERROR: "Impossible d'utiliser ce coupon",
    VOUCHER_USE_INVALID_AMOUNT: 'Montant invalide',
    VOUCHER_USE_NOTHING_TO_USE: 'Aucun montant ou prestation sélectionné',
    VOUCHER_INCOMPATIBLE_WARNING: 'Ce coupon ne contient aucune prestation correspondant à ce rendez-vous',
    VOUCHER_PREFILLED_INFO: 'Les quantités ont été pré-remplies selon les prestations du rendez-vous',
    VOUCHER_SECTION_TITLE: 'Coupons',
    VOUCHER_SECTION_LOADING: 'Chargement des coupons liés...',
    VOUCHER_SECTION_ASSOCIATED_COUNT: '{count, plural, one {# coupon lié} other {# coupons liés}}',
    VOUCHER_SECTION_EMPTY: 'Aucun coupon utilisé sur ce rendez-vous',
    VOUCHER_SECTION_LOAD_ERROR: 'Impossible de charger les coupons liés à ce rendez-vous',
    VOUCHER_SECTION_USED_AT: 'Utilisé le',
    VOUCHER_SECTION_USED_AMOUNT: 'Montant utilisé',
    VOUCHER_SECTION_USED_ITEMS: 'Prestations utilisées',
    VOUCHER_SECTION_VIEW_DETAILS: 'Voir le coupon',
    APPOINTMENT_DETAIL_FINANCIAL_SECTION_TITLE: 'Paiement & coupons',
    APPOINTMENT_FORM_TAB_PAYMENT: 'Paiement',
    PAYMENT_SECTION_TITLE: 'Paiement',
    PAYMENT_SECTION_SUBTITLE: 'Paiement lié à ce rendez-vous',
    PAYMENT_SECTION_LOADING: 'Chargement du paiement...',
    PAYMENT_SECTION_LOAD_ERROR: 'Impossible de charger le paiement lié à ce rendez-vous',
    PAYMENT_SECTION_EMPTY_TITLE: 'Aucun paiement lié',
    PAYMENT_SECTION_EMPTY_DESCRIPTION: "Ce rendez-vous n'a pas de paiement associé pour le moment.",
    PAYMENT_SECTION_DECLARE_MANUAL_PAID: 'Déclarer payé',
    PAYMENT_SECTION_DECLARE_MANUAL_PAID_SUCCESS: 'Le paiement manuel a bien été associé à ce rendez-vous.',
    PAYMENT_SECTION_DECLARE_MANUAL_PAID_DIALOG_TITLE: 'Déclarer un paiement reçu',
    PAYMENT_SECTION_DECLARE_MANUAL_PAID_DIALOG_DESCRIPTION:
      'Indiquez le montant encaissé hors ligne (espèces, chèque, terminal…). Il sera associé à ce rendez-vous.',
    PAYMENT_SECTION_DECLARE_MANUAL_PAID_AMOUNT_PLACEHOLDER: 'Montant encaissé',
    PAYMENT_SECTION_CREATE_LINK_PAYER_LABEL: 'Payeur',
    PAYMENT_SECTION_PAYER: 'Payeur : {name}',
    PAYMENT_SECTION_UNLINK: 'Détacher du rendez-vous',
    PAYMENT_SECTION_UNLINK_CONFIRM_TITLE: 'Détacher ce paiement du rendez-vous ?',
    PAYMENT_SECTION_UNLINK_CONFIRM_TEXT:
      "Le paiement n'est pas annulé : il reste dans vos ventes, mais ne compte plus dans l'encaissé de ce rendez-vous.",
    PAYMENT_SECTION_UNLINK_SUCCESS: 'Le paiement a été détaché de ce rendez-vous.',
    // Lien encore en attente : le détacher l'annule (il ne doit plus être payable).
    PAYMENT_SECTION_UNLINK_CONFIRM_TEXT_PENDING:
      'Le lien de paiement sera annulé : votre client ne pourra plus le régler. Il restera visible dans vos ventes.',
    PAYMENT_SECTION_UNLINK_SUCCESS_PENDING: 'Le lien de paiement a été annulé et détaché de ce rendez-vous.',
    // Montants de la RÉSERVATION, tous paiements confondus (calculés backend).
    PAYMENT_SECTION_COLLECTED: 'Encaissé',
    PAYMENT_SECTION_COLLECTED_WITH_AMOUNT: 'Encaissé {amount}',
    PAYMENT_SECTION_RESERVATION_REMAINING: 'Reste à encaisser',
    // Réservation remisée : prix normal, remises et total au-dessus de l'encaissé.
    PAYMENT_SECTION_GROSS_TOTAL: 'Prix normal',
    PAYMENT_SECTION_DISCOUNTS: 'Remises',
    PAYMENT_SECTION_NET_TOTAL: 'Total',
    // Fiche paiement des ventes : coupons utilisés sur la réservation, sous le total après remise.
    PAYMENT_SECTION_VOUCHERS: 'Coupons utilisés',
    PAYMENT_SECTION_CREATE_LINK: 'Créer un lien de paiement',
    PAYMENT_SECTION_CREATE_LINK_DIALOG_TITLE: 'Créer un lien de paiement pour ce rendez-vous',
    PAYMENT_SECTION_CREATE_LINK_DIALOG_DESCRIPTION:
      'Indiquez le montant à demander au client. Un lien de paiement sera généré et associé à ce rendez-vous.',
    PAYMENT_SECTION_CREATE_LINK_AMOUNT_LABEL: 'Montant',
    PAYMENT_SECTION_CREATE_LINK_AMOUNT_PLACEHOLDER: 'Montant à demander',
    PAYMENT_SECTION_CREATE_LINK_SUBMIT: 'Créer le lien',
    PAYMENT_SECTION_CREATE_LINK_SUCCESS: 'Le lien de paiement a bien été créé.',
    PAYMENT_SECTION_STRIPE_REQUIRED_CTA: 'Solution de paiement',
    PAYMENT_SECTION_CREATED_AT: 'Créé le',
    PAYMENT_SECTION_PAID_AT: 'Payé le',
    PAYMENT_SECTION_VIEW_DETAILS: 'Voir le paiement',
  },
  PROFESSIONAL_APP_PLACE_PAGE: {
    TITLE: 'Lieux',
    TAB_INFORMATION: 'Informations',
    TAB_ROOMS_AND_SEATS: 'Salles & postes',
    // « Synchronisation » laissait croire à un échange bidirectionnel, et entrait en
    // collision avec la page compte /establishment/gmb qui porte déjà ce nom.
    TAB_GOOGLE_SYNC: 'Fiche Google',
    ADD_PLACE: 'Ajouter un lieu',
    ADD_ADDRESS: 'Ajouter une adresse',
    ADD_GEOJSON: 'Ajouter une zone',
    AREA_LABEL: 'Zone géographique',
    DELETE_PLACE_TITLE: 'Supprimer le lieu',
    DELETE_PLACE_TEXT: 'Êtes-vous sûr de vouloir supprimer ce lieu ?',
    SYNC_GMB: 'Synchronisation',
    SYNC_NEW_GOOGLE_ACCOUNT: 'Synchroniser compte Google supplémentaire',
    SYNC_GOOGLE_ACCOUNT_WITH_THIS_PLACE: 'Lier à Google',
    SYNCED_GMB_OK: 'Synchronisé',
    ASSOCIATED_GMB_PLACE: 'Associé',
    OR_SELECT_EXISTING_GOOGLE_LOCATION: 'Où choisir un lieu déjà synchronisé',
    ALREADY_LINKED_GOOGLE_LOCATION: 'Attention : cette fiche Google est déjà associée à votre lieu',
    ALERT_TITLE_CHANGE_GMB_LINK: 'Changement fiche Google My Business',
    ALERT_TEXT_CONFIRM_CHANGE_GMB_LINK: 'En confirmant, la fiche Google My Business sera désormais associée au lieu',
    UNSYNC_GOOGLE_MODAL_TITLE: 'Dissocier la fiche Google My Business',
    UNSYNC_GOOGLE_MODAL_TEXT: 'Êtes-vous sûr de vouloir dissocier la fiche Google My Business de ce lieu ?',
    UNSYNC_GOOGLE_MODAL_DELETE_BUTTON_LABEL: 'Dissocier',
    NO_GOOGLE_LOCATIONS_FOUND: 'Aucun compte Google synchronisé',
    NO_GOOGLE_LOCATIONS_DESCRIPTION:
      'synchroniser votre compte Google My Business pour lier votre fiche Google à ce lieu, et collecter des avis auprès de vos clients.',
    DEFAULT_PLACE_BADGE: 'Lieu par défaut',
    SET_AS_DEFAULT: 'Définir par défaut',
    GMB_UNLINKED_TUTO_TITLE: '{count} fiches Google My Business à répartir sur vos lieux',
    // Le repli décrit ici est celui de `resolveReviewUrl` côté backend : sans aucune fiche
    // liée, il en retient une automatiquement plutôt que de ne rien envoyer.
    GMB_UNLINKED_TUTO_FALLBACK:
      "Vos demandes d'avis partent quand même : à défaut de liaison, une de vos fiches est retenue automatiquement pour tous vos lieux. Vous ne choisissez donc pas la ou les fiches vers lesquelles vos liens d'avis renvoient.",
    GMB_UNLINKED_TUTO_INTRO: 'Pour décider vous-même, lieu par lieu :',
    GMB_UNLINKED_TUTO_STEP_1: '1. Repérez le lieu concerné dans la liste ci-dessous.',
    GMB_UNLINKED_TUTO_STEP_2:
      "2. Sur sa ligne, cliquez sur l'icône Google (sur mobile : ouvrez le menu d'actions, puis « {action} »).",
    GMB_UNLINKED_TUTO_STEP_3: '3. Sélectionnez la fiche correspondant à ce lieu, puis « {link_action} ».',
    GMB_UNLINKED_TUTO_OUTRO:
      "Une fois la liaison faite, c'est vous qui décidez : les demandes d'avis de chaque lieu renvoient vers la fiche que vous lui avez associée.",
  },
  EQUIPMENT_PAGE: {
    TITLE: 'Matériel',
    SUBTITLE: 'Équipements partagés entre plusieurs prestations ou lieux.',
    ADD_EQUIPMENT_BUTTON: 'Ajouter du matériel',
    EMPTY_TITLE: 'Aucun matériel',
    EMPTY_DESCRIPTION: 'Ajoutez du matériel partagé pour gérer leur disponibilité.',
    UNITS_COUNT: '{count, plural, one {# unité} other {# unités}}',
    EXCLUSIVE_LABEL: 'privatisé par RDV',
    SHARED_LABEL: 'partagé',
    LINKED_PRESTATIONS: '{count, plural, one {# prestation} other {# prestations}}',
    NO_LINKED_PRESTATIONS: 'Aucune prestation liée',
    LINKED_PLACES: '{count, plural, one {# lieu} other {# lieux}}',
    NO_LINKED_PLACES: 'Aucun lieu lié',
    NAME_LABEL: 'Nom',
    NAME_PLACEHOLDER: 'Ex. Cabine n°1, Tapis de yoga, Casque',
    DESCRIPTION_LABEL: 'Description',
    DESCRIPTION_PLACEHOLDER: 'Précisions internes (optionnel)',
    QUANTITY_LABEL: "Nombre d'unités disponibles",
    PRESTATIONS_LABEL: 'Prestations utilisant ce matériel',
    PRESTATIONS_PLACEHOLDER: 'Sélectionner des prestations',
    PLACES_LABEL: 'Lieux où ce matériel est disponible',
    PLACES_PLACEHOLDER: 'Sélectionner des lieux',
    DIALOG_TITLE_CREATE: 'Ajouter du matériel',
    DIALOG_TITLE_EDIT: 'Modifier le matériel',
    DELETE_TITLE: 'Supprimer ce matériel',
    DELETE_TEXT: 'Êtes-vous sûr de vouloir supprimer ce matériel ?',
  },
  VEHICLE_PAGE: {
    TITLE: 'Véhicules',
    SUBTITLE:
      'Votre flotte pour les courses. Liez chaque véhicule à vos prestations « Course » du catalogue : une réservation n’occupe qu’un véhicule libre de la flotte.',
    ADD_VEHICLE_BUTTON: 'Ajouter un véhicule',
    ADDON_UPSELL_TITLE: 'Activez le calculateur de courses',
    ADDON_UPSELL_DESCRIPTION:
      'La configuration des courses (véhicules, tarifs, zones) est une option à activer sur votre abonnement.',
    ADDON_UPSELL_CTA: 'Activer l’option',
    EMPTY_TITLE: 'Aucun véhicule',
    EMPTY_DESCRIPTION:
      'Ajoutez un véhicule, définissez son tarif, puis liez-le à une prestation « Course » de votre catalogue pour le proposer à la réservation.',
    LINKED_PRESTATIONS: '{count, plural, one {# prestation} other {# prestations}}',
    NO_LINKED_PRESTATIONS: 'Aucune prestation liée',
    LINKED_PLACES: '{count, plural, one {# lieu} other {# lieux}}',
    NO_LINKED_PLACES: 'Aucun lieu lié',
    NO_PRICING_WARNING: 'Aucun tarif — non réservable en ligne',
    NAME_LABEL: 'Nom',
    NAME_PLACEHOLDER: 'Ex. Berline, Van premium',
    DESCRIPTION_LABEL: 'Description',
    DESCRIPTION_PLACEHOLDER: 'Précisions internes (optionnel)',
    QUANTITY_LABEL: 'Nombre de véhicules',
    CAPACITY_LABEL: 'Places disponibles par véhicule',
    PAX_MIN_LABEL: 'Passagers minimum',
    PAX_MAX_LABEL: 'Passagers maximum',
    FLEET_SIZE_LABEL: '{count, plural, one {# véhicule} other {# véhicules}}',
    PRESTATIONS_LABEL: 'Prestations utilisant ce véhicule',
    PRESTATIONS_PLACEHOLDER: 'Sélectionner des prestations',
    PLACES_LABEL: 'Lieux où ce véhicule est disponible',
    PLACES_PLACEHOLDER: 'Sélectionner des lieux',
    DIALOG_TITLE_CREATE: 'Ajouter un véhicule',
    DIALOG_TITLE_EDIT: 'Modifier le véhicule',
    DELETE_TITLE: 'Supprimer ce véhicule',
    DELETE_TEXT: 'Êtes-vous sûr de vouloir supprimer ce véhicule ?',
    PASSENGERS_RANGE: '{min}-{max} passagers',
    PASSENGERS: 'passagers',
    LUGGAGE: 'bagages',
    SMALL_LUGGAGE: 'petits bagages',
    LARGE_LUGGAGE: 'grands bagages',
    LUGGAGE_RANGE: '{min}-{max} bagages',
  },
  PLACE_CAPACITY_BLOCK: {
    SECTION_TITLE: 'Salles et postes',
    SECTION_HELP: 'Définissez, pour chaque espace, combien de personnes il accueille et s’il se réserve en entier.',
    ADD_ROOM_BUTTON: 'Ajouter une salle ou un poste',
    EMPTY_LABEL: 'Aucune salle pour le moment.',
    UNITS_COUNT: '{count, plural, one {# unité} other {# unités}}',
    EXCLUSIVE_DESCRIPTION:
      '{count, plural, one {# personne par unité} other {# personnes par unité}} · privatisée par RDV',
    SHARED_DESCRIPTION: '{count, plural, one {# personne en parallèle} other {# personnes en parallèle}} · partagée',
    DIALOG_TITLE_CREATE: 'Ajouter une salle ou un poste',
    DIALOG_TITLE_EDIT: 'Modifier la salle ou le poste',
    NAME_LABEL: 'Nom',
    NAME_PLACEHOLDER: 'Ex. Salle Yoga, Cabine soin, Box 1',
    DESCRIPTION_LABEL: 'Description',
    DESCRIPTION_PLACEHOLDER: 'Précisions internes (optionnel)',
    PRESTATIONS_LABEL: 'Prestations utilisant cet espace',
    PRESTATIONS_PLACEHOLDER: 'Sélectionner des prestations',
    DELETE_TITLE: 'Supprimer cet espace',
    DELETE_TEXT: 'Êtes-vous sûr de vouloir supprimer cet espace ?',
    SAVE: 'Enregistrer',
    EDIT: 'Modifier',
    DELETE: 'Supprimer',
  },
  [SUBSCRIPTION_LABEL_TRANSLATE_KEY]: {
    ...SubscriptionLabelTranslation['fr-FR'],
  },
  [SUBSCRIPTION_DESCRIPTION_TRANSLATE_KEY]: {
    ...SubscriptionDescriptionTranslation['fr-FR'],
  },
  [RELOAD_PRODUCT_LABEL_TRANSLATE_KEY]: {
    ...ReloadLabelTranslation['fr-FR'],
  },
  [RELOAD_PRODUCT_DESCRIPTION_TRANSLATE_KEY]: {
    ...ReloadDescriptionTranslation['fr-FR'],
  },
  PROFESSIONAL_APP_COMMUNICATION_SETTINGS_PAGE: {
    MODAL_TITLE: 'Paramètres communication',
    SMS_MARKETING_SENDER_SECTION_TITLE: 'Nom de l’expéditeur des SMS de campagne',
    SMS_MARKETING_SENDER_SECTION_DESC:
      'Nom affiché à vos clients comme expéditeur de vos campagnes SMS. Laissez vide pour utiliser le nom de votre établissement.',
    SMS_SENDER_SECTION_TITLE: 'Nom de l’expéditeur des SMS automatiques',
    SMS_SENDER_SECTION_DESC:
      'Nom affiché à vos clients comme expéditeur des messages automatiques (rappels de rendez-vous, notifications).',
    SMS_SENDER_PLACEHOLDER: 'Entreprise',
    SMS_SENDER_HELP: '3 à 11 caractères alphanumériques sans espace ni accent, commence par une lettre.',
    SMS_SENDER_WHITE_LABEL_ONLY: 'La personnalisation est disponible avec l’option marque blanche.',
    SMS_COUNTRIES_SELECTED_COUNT: '{count, plural, one {# pays sélectionné} other {# pays sélectionnés}}',
    SMS_COUNTRIES_NONE_SELECTED: 'Aucun pays sélectionné',
    EMAIL_SENDER_SECTION_TITLE: 'Nom de l’expéditeur email',
    EMAIL_SENDER_SECTION_DESC:
      'Nom affiché à vos clients comme expéditeur des emails (campagnes et messages automatiques).',
    EMAIL_SENDER_PLACEHOLDER: 'Mon Établissement',
    // Adresse d'expédition des campagnes e-mail (domaine du pro)
    SENDER_DOMAIN_SECTION_TITLE: 'Adresse d’expédition de vos e-mails',
    SENDER_DOMAIN_SECTION_DESC:
      'L’adresse qui apparaît comme expéditeur de toutes vos campagnes e-mail. Le nom affiché et l’adresse de réponse se règlent sur chaque campagne.',
    SENDER_DOMAIN_OPTION_DEFAULT: 'Adresse {brand}',
    SENDER_DOMAIN_OPTION_OWN: 'Mon domaine',
    SENDER_DOMAIN_OPTION_OWN_SUMMARY: 'Vos clients voient votre nom de domaine. Nous configurons tout pour vous.',
    SENDER_DOMAIN_OPTION_OWN_DESC:
      'Nous configurons votre domaine pour vous (signature DKIM, SPF, preuve de propriété) : aucune manipulation technique de votre côté.',
    SENDER_DOMAIN_UPSELL:
      'L’envoi depuis votre propre domaine est disponible avec l’option {addon}. Vos campagnes partent pour l’instant de votre adresse {brand}.',
    SENDER_DOMAIN_UPSELL_CTA: 'Option {addon}',
    SENDER_DOMAIN_SELECT_LABEL: 'Choisissez le domaine',
    SENDER_DOMAIN_SELECT_PLACEHOLDER: 'Sélectionner un domaine…',
    SENDER_DOMAIN_NO_ELIGIBLE:
      'Aucun domaine éligible : il faut un domaine acheté ou transféré chez nous, actif sur votre site.',
    SENDER_DOMAIN_CHANGE_DOMAIN_HELP: 'Un seul domaine d’expédition à la fois.',
    SENDER_DOMAIN_LOCAL_PART_LABEL: 'Adresse d’expédition',
    SENDER_DOMAIN_LOCAL_PART_PLACEHOLDER: 'contact',
    SENDER_DOMAIN_LOCAL_PART_HELP:
      'Minuscules, chiffres, points, tirets. Modifiable à tout moment. Les réponses de vos clients arrivent sur votre adresse de réponse.',
    SENDER_DOMAIN_LOCAL_PART_INVALID:
      'Adresse invalide : lettres minuscules, chiffres, « . », « _ » et « - » uniquement.',
    SENDER_DOMAIN_LOCAL_PART_REQUIRED:
      'Saisissez l’adresse d’expédition pour enregistrer, ou revenez à votre adresse {brand}.',
    SENDER_DOMAIN_EFFECTIVE_LABEL: 'Vos campagnes partent de',
    SENDER_DOMAIN_STATE_PENDING:
      'Activation de votre domaine en cours : automatique, jusqu’à 48 h. Les campagnes envoyées d’ici là partiront dès qu’il sera prêt.',
    SENDER_DOMAIN_STATE_ACTIVE: 'Votre domaine est prêt : vos campagnes partent bien de cette adresse.',
    SENDER_DOMAIN_STATE_ERROR:
      'Votre domaine n’a pas pu être activé. Notre équipe est prévenue et s’en occupe ; en attendant, vos campagnes partent de votre adresse {brand}.',
    SMS_COUNTRIES_SECTION_TITLE: 'Pays acceptés et tarifs SMS',
    SMS_COUNTRIES_SECTION_DESC:
      'Sélectionnez les pays vers lesquels vous autorisez l’envoi de SMS. Le tarif s’applique pour chaque SMS envoyé.',
    SMS_COUNTRIES_PLACEHOLDER: 'Sélectionner les pays…',
    SMS_COUNTRIES_GROUP_POPULAR: 'Pays populaires',
    SMS_COUNTRIES_GROUP_OTHER: 'Autres pays',
    SAVED: 'Modifications enregistrées',
  },
  PROFESSIONAL_APP_SUBSCRIPTION_PAGE: {
    TITLE: 'Mon abonnement',
    FORMULA: 'Formule',
    BUTTON_PICK_FORMULA: 'Choisir ce forfait',
    BUTTON_CURRENT_FORMULA: 'Forfait actuel',
    DISCLAIMER_NO_ENGAGEMENT: 'Facture mensuelle, sans engagement.',
    DISCLAIMER_WITH_ENGAGEMENT: "Facture mensuelle, avec engagement d'un an.",
    VAT_FREE: 'HT',

    TOGGLE_SOLO: 'Solo',
    TOGGLE_TEAM: 'Équipe',
    TOGGLE_NO_COMMITMENT: 'Sans engagement',
    TOGGLE_COMMITMENT_12M: 'Engagement 12 mois',
    COMMITMENT_DEFERRED_TOOLTIP:
      "Vous êtes engagé(e) : le passage à 'Sans engagement' prendra effet à la fin de votre période d'engagement. Vous continuerez à payer votre tarif actuel jusqu'à cette date.",
    BADGE_BEST_PRICE: 'Meilleur prix',
    FEATURE_COMING_SOON: 'Bientôt',
    ...PlanTaglineTranslation['fr-FR'],
    INCLUDED_USERS: '{count, plural, =1 {1 utilisateur} other {# utilisateurs}} inclus',
    CAPABILITIES_COMPARISON_TITLE: 'Comparatif détaillé',
    FOOTNOTE_QUOTAS: 'Selon les quotas mensuels listés plus bas.',

    MARKETING_GROUP_BOOKING: 'Réservation en ligne',
    MARKETING_GROUP_SITE: 'Site internet',
    MARKETING_GROUP_GMB: 'Fiche Google',
    MARKETING_GROUP_MARKETING: 'Marketing & CRM',
    MARKETING_GROUP_PAYMENTS: 'Paiement en ligne',
    MARKETING_GROUP_TEAM: 'Équipe',
    MARKETING_GROUP_PULSE: 'Pulse (IA)',
    MARKETING_GROUP_SEO: 'Boost SEO',
    MARKETING_GROUP_DEV: 'Développeur',
    MARKETING_GROUP_QUOTAS: 'Quotas mensuels',
    MARKETING_GROUP_SUPPORT: 'Support',
    MARKETING_GROUP_STATS: 'Statistiques',

    FEATURE_BOOKING_ALL_CHANNELS: 'Réservations tous canaux (site, fiche Google, widget)',
    FEATURE_PLACES_UNLIMITED: 'Lieux illimités',
    FEATURE_GROUP_BOOKING: 'Réservations de groupe / sessions / ateliers',
    FEATURE_EMAIL_REMINDER: 'Email de confirmation et rappel',
    FEATURE_SMS_REMINDER: 'SMS de rappel',

    FEATURE_WEBSITE_INCLUDED: 'Site internet personnalisable inclus',
    FEATURE_GOOGLE_SYNC: 'Synchronisation avec votre fiche Google',
    FEATURE_FR_DOMAIN_INCLUDED: 'Nom de domaine .fr inclus',
    FEATURE_PREMIUM_COMPONENTS: 'Composants & thèmes premium',
    FEATURE_ANALYTICS_TRACKING: 'Analytics avancé (Pixel, GTM, conversions)',
    FEATURE_CUSTOM_SCRIPTS: 'Injection de scripts personnalisés',
    FEATURE_DNS_CUSTOM_ZONES: 'Zones DNS personnalisées',

    FEATURE_GMB_CONNECTED: 'Fiches Google connectées',
    FEATURE_GOOGLE_REVIEWS_AUTO: 'Collecte automatique des avis Google',
    FEATURE_AI_REVIEW_REPLY: 'Réponses IA aux avis Google',

    FEATURE_CUSTOMER_BASE: 'Fiches clients + segmentation',
    FEATURE_EMAIL_CAMPAIGNS: 'Campagnes email',
    FEATURE_SMS_CAMPAIGNS: 'Campagnes SMS',
    FEATURE_CAMPAIGN_STATS: 'Statistiques avancées campagnes',
    FEATURE_STATS_DASHBOARD: "Tableau de bord d'activité (30 jours)",
    FEATURE_ADVANCED_STATS: 'Historique 12 mois, comparaison, analyse par prestation, export',
    FEATURE_TEAM_STATS: "Analyse par membre et par lieu, taux d'occupation, heures de pointe",

    FEATURE_COMMISSION_CFIXE: `Commission ${PROJECT_CONFIG.brand_string}`,
    COMMISSION_CFIXE_VALUE: '0 %',
    FEATURE_PAYMENT_AT_BOOKING: 'Paiement à la réservation (acompte ou total)',
    FEATURE_GIFT_CARDS: 'Cartes cadeaux',
    FEATURE_PAYMENT_LINKS: 'Liens de paiement',
    FEATURE_CB_IMPRINT: 'Empreinte bancaire',
    FEATURE_INSTALLMENTS: 'Paiement en plusieurs fois',

    FEATURE_TEAM_MEMBERS: "Membres d'équipe inclus",
    FEATURE_TEAM_MEMBER_AGENDA: 'Agenda dédié par membre',
    FEATURE_TEAM_MEMBER_APP_ACCESS: 'Accès appli web et mobile',
    FEATURE_PRO_EMAIL: 'Boîtes email pro / utilisateur',

    FEATURE_PULSE_REGULAR_GUIDANCE: 'Accompagnement régulier par Pulse',
    FEATURE_PULSE_TRANSCRIPTION: 'Transcription vocale illimitée',
    FEATURE_PULSE_WELCOME_BOOST: 'Boost de bienvenue 30 jours',

    FEATURE_SEO_ARTICLES: "Rédaction d'articles SEO",
    SEO_ARTICLES_MAX: '2 articles / semaine',
    FEATURE_SEO_BACKLINKS: 'Backlinks',
    SEO_BACKLINKS_MAX: '1 / mois',

    FEATURE_API_MCP: 'API & MCP',
    FEATURE_WEBHOOKS: 'Webhooks',

    FEATURE_QUOTA_SMS: 'SMS (rappel + marketing)',
    FEATURE_QUOTA_EMAILS: 'Emails (rappel + marketing)',
    FEATURE_QUOTA_PULSE: 'Messages Pulse / utilisateur',
    FEATURE_TOPUP_SMS: 'Crédit SMS supplémentaire (one-shot)',
    FEATURE_TOPUP_EMAILS: 'Crédit emails supplémentaire (one-shot)',
    TOPUP_SMS_PRICE: '9 € HT pour 100 SMS',
    TOPUP_EMAILS_PRICE: '5 € HT pour 1 000 emails',

    FEATURE_HELP_CENTER: "Centre d'aide + tutos vidéo",
    FEATURE_HELP_CHATBOT: "Chatbot d'aide",
    FEATURE_HUMAN_CHAT: 'Chat humain',
    HUMAN_CHAT_BUSINESS_HOURS: 'Heures ouvrées',
    HUMAN_CHAT_PRIORITY: 'Prioritaire',
    FEATURE_GROUP_VIDEO: 'Visio en groupe',
    FEATURE_ONE_ON_ONE_VIDEO: 'Visio 1:1 mensuelle',
    ONE_ON_ONE_VIDEO_PRO_MULTI: 'Pro MULTI',

    QUOTA_UNLIMITED: 'Illimité',
    QUOTA_PER_USER_SUFFIX: '/ utilisateur',

    UPCOMING_INVOICES_SECTION_TITLE: 'Mes prochaines factures',
    UPCOMING_INVOICES_PERIOD: 'Période',
    UPCOMING_INVOICES_AMOUNT: 'Montant',
    UPCOMING_INVOICES_STATUS: 'Statut',
    UPCOMING_INVOICES_LINES_COUNT: '{count} lignes (abonnement + options)',
    NO_UPCOMING_INVOICES: 'Aucune facture prévue.',
    SUBSCRIPTION_ENDS_ON: 'Votre abonnement prend fin le {date}.',
    BADGE_TRIAL: 'Essai gratuit',
    BADGE_CANCELABLE: 'Sans engagement',
    BADGE_ENGAGED: 'Engagé',

    // ── Récap domaines (renouvellement annuel) ──
    DOMAINS_RENEWAL_SECTION_TITLE: 'Domaines',
    DOMAINS_RENEWAL_LINE: 'Renouvellement le {date} · {price_ht} HT ({price_ttc} TTC)/an',
    DOMAINS_RENEWAL_FREE: 'Renouvellement offert',
    DOMAINS_RENEWAL_MANAGE: 'Gérer les domaines',
    DOMAINS_RENEWAL_UNPAID_BADGE: 'Paiement en échec',
    // Renouvellement payé par prélèvement SEPA, lancé mais pas encore encaissé.
    DOMAINS_RENEWAL_PROCESSING_BADGE: 'Prélèvement en cours',

    ADDONS_SECTION_TITLE: 'Mes options',
    ...AddonLabelTranslation['fr-FR'],
    ...AddonDescriptionTranslation['fr-FR'],
    ADDON_PRICE_MONTHLY: '{amount} HT / mois',
    ADDON_PRICE_YEARLY: 'Facturé annuellement',
    ADDON_PRICE_PER_UNIT_MONTHLY: '{amount} HT / mois par unité',
    ADDON_ACTIVATE: 'Activer',
    ADDON_DOMAIN_ACTIVATE_CTA: 'Activer un nom de domaine',
    ADDON_DOMAIN_MANAGE_CTA: 'Gérer les domaines',
    ADDON_REACTIVATE: 'Réactiver',
    ADDON_DEACTIVATE: 'Désactiver',
    ADDON_PENDING_DEACTIVATION: 'Désactivation prévue le {date}',
    ADDON_MODIFY: 'Modifier',
    ADDON_ACTIVE_BADGE: 'Activée',
    ADDON_STARTS_ON: 'À partir du {date}',
    ADDON_QTY_BADGE: '× {qty}',
    ADDON_UPGRADE_REQUIRED: 'Disponible avec {plan}',
    ADDON_UPGRADE_BUTTON: 'Passer à {plan}',
    ADDON_PLAN_WITH_SIZE: '{plan} {size}',
    SIZE_SOLO_LABEL: 'Solo',
    SIZE_TEAM_LABEL: 'Équipe',
    ADDON_NOT_ELIGIBLE_NOTICE:
      "Non disponible dans votre plan actuel : l'option restera active jusqu'à son désengagement.",

    // Modale d'activation/désactivation/modification d'option
    ADDON_MODAL_TITLE_ACTIVATE: 'Activer : {label}',
    ADDON_MODAL_TITLE_MODIFY: 'Modifier : {label}',
    ADDON_MODAL_TITLE_DEACTIVATE: 'Désactiver : {label}',
    ADDON_MODAL_QUANTITY_LABEL: 'Quantité supplémentaire',
    ADDON_MODAL_QUANTITY_HINT: 'Au-delà de ce qui est déjà inclus dans votre plan.',
    ADDON_MODAL_DEBIT_TODAY: 'Débité aujourd’hui',
    ADDON_MODAL_PROMO_DISCOUNT: 'Remise appliquée',
    ADDON_MODAL_NEW_MONTHLY_FROM: 'Nouveau total mensuel',
    ADDON_MODAL_EFFECT_DATE: "Prise d'effet : {date}",
    ADDON_MODAL_NEXT_INVOICE: 'Première ligne sur votre facture du {date}',
    // Options facturées au 1er du mois suivant (pack référencement) : jamais de prorata ni de débit.
    ADDON_MODAL_DISCLAIMER_NEXT_MONTH:
      "Rien n'est débité aujourd'hui. L'option prend effet le {date}, au prix plein et sans prorata ; elle apparaît sur votre facture du {invoice_date}. Sans engagement : résiliable à tout moment, effet à la fin de la période déjà facturée.",
    ADDON_MODAL_DISCLAIMER_NEXT_MONTH_DECREASE:
      "Rien n'est débité aujourd'hui. La nouvelle quantité s'applique à partir du {date}, à la fin de la période déjà facturée : ce qui est facturé est livré.",
    PLAN_CHANGE_ADDONS_DEACTIVATED:
      '{count, plural, one {L’option « {codes} » n’est pas disponible avec cette formule : elle sera désactivée à la fin de la période en cours.} other {Ces options ne sont pas disponibles avec cette formule et seront désactivées à la fin de la période en cours : {codes}.}}',
    ADDON_MODAL_DEACTIVATE_NOTICE:
      "L'option reste active jusqu'à votre prochaine facture du {date}, puis sera retirée.",
    ADDON_MODAL_DISCLAIMER_ACTIVATE:
      "Activation immédiate. Un prorata du mois en cours est débité aujourd'hui sur votre moyen de paiement par défaut. Le nouveau total mensuel (abonnement + options) s'applique à partir du {date}.",
    ADDON_MODAL_DISCLAIMER_ACTIVATE_NO_DEBIT:
      "Activation immédiate, sans débit aujourd'hui : l'option est déjà couverte pour la période en cours. Le total mensuel (abonnement + options) s'applique à partir du {date}.",
    ADDON_MODAL_DISCLAIMER_ACTIVATE_DISCOUNT_COVERED:
      "Activation immédiate, sans débit aujourd'hui : le prorata du mois en cours est entièrement couvert par votre remise. Le nouveau total mensuel (abonnement + options) s'applique à partir du {date}.",
    ADDON_MODAL_DISCLAIMER_DEACTIVATE: "Pas de débit aujourd'hui. La modification prend effet le {date}.",
    ADDON_MODAL_REQUIRES_PM:
      "Aucun moyen de paiement par défaut enregistré. Ajoutez-en un avant de confirmer pour qu'on puisse débiter le prorata.",
    ADDON_MODAL_CONFIRM: 'Confirmer',
    ADDON_MODAL_CANCEL: 'Annuler',

    // Modale « vos options » à la première souscription (avant la page de paiement)
    CHECKOUT_OPTIONS_TITLE: 'Vos options',
    CHECKOUT_OPTIONS_SUBTITLE:
      'Ajoutez dès maintenant les options dont vous avez besoin. Vous pourrez les modifier à tout moment depuis « Mes options ».',
    CHECKOUT_OPTIONS_PLAN_LINE: 'Forfait {plan} {size}',
    CHECKOUT_OPTION_TRIAL_BADGE: 'Activée pendant votre essai',
    CHECKOUT_OPTIONS_TOTAL: 'Total mensuel',
    CHECKOUT_OPTIONS_TOTAL_VAT_FREE: 'HT',
    CHECKOUT_OPTIONS_CONTINUE: 'Continuer vers le paiement',

    // Détail de la prochaine facture (card compacte en haut)
    NEXT_INVOICE_BREAKDOWN_TITLE: 'Détail de ma prochaine facture',
    NEXT_INVOICE_TOTAL: 'Total',
    NEXT_INVOICE_NEXT_DATE: 'Prochaine facturation le {date}',
    NEXT_INVOICE_TRIAL: 'Période d’essai en cours : pas de débit avant le {date}.',
    NEXT_INVOICE_LINE_PLAN: 'Plan {plan}',
    CURRENT_MONTHLY_PRICE: 'Tarif actuel',
    TTC_SUFFIX: 'TTC',
    HT_SUFFIX: 'HT',

    // Engagement
    ENGAGED_UNTIL: 'Engagé jusqu’au {date}',
    NO_COMMITMENT: 'Sans engagement',

    // Plan change confirmation modal
    PLAN_CHANGE_TITLE: 'Confirmer le changement de plan',
    PLAN_CHANGE_CURRENT: 'Plan actuel',
    PLAN_CHANGE_NEW: 'Nouveau plan',
    PLAN_CHANGE_QUOTAS_TITLE: 'Quotas inclus',
    PLAN_CHANGE_QUOTA_SMS: 'SMS / mois',
    PLAN_CHANGE_QUOTA_EMAILS: 'Emails / mois',
    PLAN_CHANGE_QUOTA_USERS: 'Utilisateurs inclus',
    PLAN_CHANGE_QUOTA_GMB: 'Fiches Google',
    PLAN_CHANGE_PRORATA_INFO:
      'Le changement prend effet immédiatement. Le prorata est facturé sur votre moyen de paiement par défaut. Au prochain renouvellement, vous serez facturé du nouveau prix complet.',
    PLAN_CHANGE_DOWNGRADE_WARNING:
      'Vous passez à un plan inférieur. Le changement prend effet à votre prochaine échéance, vérifiez que vos usages restent compatibles avec les quotas réduits.',
    PLAN_CHANGE_DEFERRED_INFO:
      "Le changement prendra effet à la date d'effet indiquée. Aucun débit n'est effectué aujourd'hui ; vous continuez à profiter de votre offre actuelle jusqu'à cette date.",
    PLAN_CHANGE_SWITCH_TO_COMMITTED_TITLE: 'Vous voulez en profiter tout de suite ?',
    PLAN_CHANGE_SWITCH_TO_COMMITTED_DESC:
      "Passez à ce plan en engagement 12 mois pour un effet immédiat, avec un tarif réduit et un éventuel prorata facturé aujourd'hui.",
    PLAN_CHANGE_SWITCH_TO_COMMITTED_CTA: 'Activer maintenant',
    PLAN_AVAILABLE_FROM: 'Possible à partir du {date}',
    BUTTON_SCHEDULE_FORMULA: 'Programmer ce changement',
    EARLY_BREAK_FEE_LINK: 'ou rompre l’engagement maintenant pour {amount_tax_free} HT ({amount} TTC)',
    EARLY_BREAK_FEE_DESC:
      'Indemnité forfaitaire de rupture anticipée : {months} mois restants × {monthly_price} × 50%. Une fois réglée, le changement prend effet immédiatement et l’engagement est levé.',
    EARLY_BREAK_FEE_CONFIRM_TITLE: 'Rompre l’engagement maintenant ?',
    EARLY_BREAK_FEE_CONFIRM_DESC:
      'Vous allez être débité(e) de {amount} pour solder votre engagement (50% des {months} mois restants). Le changement de plan sera appliqué immédiatement et l’engagement levé. Cette opération est irréversible.',
    EARLY_BREAK_FEE_CONFIRM_CTA: 'Payer {amount} et rompre l’engagement',
    EARLY_BREAK_FEE_CANCEL_CTA: 'Annuler',
    EARLY_BREAK_FEE_UNSUB_LINK: 'ou résilier maintenant pour {amount_tax_free} HT ({amount} TTC)',
    EARLY_BREAK_FEE_UNSUB_CONFIRM_TITLE: 'Résilier maintenant ?',
    EARLY_BREAK_FEE_UNSUB_CONFIRM_DESC:
      'Vous allez être débité(e) de {amount} pour solder votre engagement (50% des {months} mois restants). Votre abonnement sera résilié immédiatement et vous perdrez l’accès au service. Cette opération est irréversible.',
    EARLY_BREAK_FEE_UNSUB_CONFIRM_CTA: 'Payer {amount} et résilier',
    PLAN_SIZE_SOLO: 'Solo',
    PLAN_SIZE_TEAM: 'Équipe',
    PLAN_COMMITMENT_YEARLY: 'Engagement 12 mois',
    PLAN_COMMITMENT_MONTHLY: 'Sans engagement',
    PLAN_CHANGE_PRORATA_LABEL: 'Prorata sur ce mois',
    PLAN_CHANGE_DEBIT_TODAY: 'Débité aujourd’hui',
    PLAN_CHANGE_THEN_MONTHLY_FROM_NEXT: 'Puis chaque mois',
    PLAN_CHANGE_NEW_MONTHLY_FROM: 'Nouveau tarif mensuel',
    PLAN_CHANGE_EFFECTIVE_DATE: "Date d'effet",
    PLAN_CHANGE_EFFECTIVE_NOW: 'Immédiatement',
    PLAN_CHANGE_COMMITMENT_DURATION: 'Engagement',
    PLAN_CHANGE_COMMITMENT_MONTHS: '{months} mois',
    PLAN_CHANGE_COMMITMENT_END_DATE: "Fin d'engagement",
    PLAN_CHANGE_CONFIRM: 'Confirmer le changement',
    PLAN_CHANGE_PROMO_APPLIED: 'Remise « {label} » : −{amount} HT/mois',
    PLAN_CHANGE_LIMIT_OVERAGE_TITLE: 'Vos usages dépassent les limites du plan visé',
    PLAN_CHANGE_LIMIT_OVERAGE_DESC:
      'Avant de basculer, supprimez les ressources en surplus listées ci-dessous (ou choisissez un plan supérieur).',
    PLAN_CHANGE_LIMIT_OVERAGE_TEAM_MEMBER: 'Utilisateurs : {used} actifs · {target_limit} inclus dans le plan visé',
    PLAN_CHANGE_LIMIT_OVERAGE_GMB: 'Fiches Google : {used} connectées · {target_limit} incluses dans le plan visé',
    PLAN_CURRENT_BADGE: 'Plan actuel',
    PLAN_UPGRADE_FROM: 'depuis {from}',
    PLAN_DOWNGRADE_FROM: 'depuis {from}',
    PLAN_VAT_FREE_SHORT: 'HT',

    // Quota upsell
    QUOTA_WARNING_TITLE: 'Vous approchez de votre limite mensuelle',
    QUOTA_LIMIT_TITLE: 'Limite mensuelle atteinte',
    QUOTA_WARNING_DESC: 'Anticipez en rechargeant ou en passant à un plan supérieur.',
    QUOTA_LIMIT_DESC: 'Rechargez en crédits ou passez à un plan supérieur pour continuer.',
    QUOTA_UPGRADE_PLAN: 'Améliorer mon plan',

    // Moyen de paiement
    PM_LABEL: 'Moyen de paiement',
    PM_MISSING: 'Aucun moyen de paiement enregistré',
    PM_MISSING_WARNING: 'Ajoutez un moyen de paiement pour ne pas perdre votre abonnement',
    PM_CHANGE: 'Modifier',
    PM_ADD: 'Ajouter',
    PM_EXPIRING_SOON: 'Carte expire bientôt, pensez à la renouveler',
    PM_EXPIRED: 'Carte expirée',
    PM_CARD_FORMAT: '{brand} •••• {last4} (exp. {month}/{year})',
    PM_SEPA_FORMAT: 'SEPA •••• {last2}',
    // Mandat SEPA que plus aucun prélèvement ne vise (annulé, expiré, rejeté…).
    PM_SEPA_INACTIVE: 'Mandat SEPA inactif',

    // Codes promo
    PROMO_SECTION_TITLE: 'Codes promo actifs',
    PROMO_SECTION_EMPTY: 'Aucun code promo actif',
    PROMO_ADD_BUTTON: 'Ajouter un code',
    PROMO_FOREVER: 'À vie',
    PROMO_UNTIL: "jusqu'au",
    PROMO_STACKABLE_BADGE: 'Cumulable',
    PROMO_MODAL_TITLE: 'Saisir un code promo',
    PROMO_MODAL_INPUT_LABEL: 'Votre code',
    PROMO_MODAL_INPUT_PLACEHOLDER: 'Ex : MIGRATE2026',
    PROMO_MODAL_PREVIEW_TITLE: 'Ce que ça change pour vous',
    PROMO_MODAL_BEFORE: 'Votre tarif',
    PROMO_MODAL_AFTER: 'Après',
    PROMO_MODAL_MONTHLY_SAVINGS: 'Économie / mois',
    PROMO_MODAL_DURATION: 'Durée',
    PROMO_MODAL_CONFIRM: 'Activer le code',
    PROMO_MODAL_CHECKING: 'Vérification…',
    PROMO_PLAN_CHANGE_VOID_WARNING:
      '⚠️ Ce changement va désactiver définitivement {count} code(s) promo : {codes}. La remise associée sera perdue.',
    PROMO_PLAN_CHANGE_VOID_WARNING_SINGULAR:
      '⚠️ Ce changement va désactiver définitivement le code promo {codes}. La remise associée sera perdue.',

    // Page factures
    INVOICES_PAGE_TITLE: 'Mes factures',
    INVOICES_TAB_PAST: 'Émises',
    INVOICES_TAB_UPCOMING: 'À venir',
    INVOICES_PAST_EMPTY: 'Aucune facture émise pour le moment.',
    INVOICES_UPCOMING_EMPTY: 'Aucune facture à venir.',
    INVOICES_COL_DATE: 'Date',
    INVOICES_COL_PERIOD: 'Période',
    INVOICES_COL_LABEL: 'Libellé',
    INVOICES_COL_AMOUNT: 'Montant',
    INVOICES_COL_STATUS: 'Statut',
    INVOICES_COL_ACTIONS: 'Actions',
    INVOICES_DOWNLOAD_PDF: 'Télécharger',
    INVOICES_OPEN_HOSTED: 'Voir',
    INVOICES_BACK: 'Retour à mon abonnement',

    // Danger zone
    DANGER_ZONE_TITLE: 'Désabonnement',
    UNSUB_DIALOG_TITLE: 'Désabonnement',
    UNSUB_FEEDBACK_THANKS: 'Nous vous remercions pour votre retour',
    DANGER_ZONE_DESCRIPTION:
      'Vous pouvez résilier votre abonnement à tout moment. Vous garderez l’accès jusqu’à la fin de la période en cours.',

    ONLINE_BOOKING_SECTION_TITLE: 'Réservation en ligne 24/7',
    FEATURE_ONLINE_BOOKING: 'Système de réservation avancé',
    FEATURE_ONLINE_BOOKING_WIDGET: 'Intégration de la réservation à votre site internet',
    FEATURE_GOOGLE_BOOK_REDIRECT_BUTTON: 'Réservation directe depuis votre fiche Google',
    FEATURE_BOOKING_SMS_REMIND: 'SMS de rappel',
    ATTRACT_SECTION_TITLE: 'Attirez plus de visiteurs',
    FEATURE_WEBSITE_AND_DOMAIN: 'Création de votre site avec nom de domaine',
    FEATURE_SEO: 'Référencement naturel (SEO) optimisé',
    FEATURE_SYNC_GBM: 'Synchronisation avec votre fiche Google',
    FEATURE_REVIEW_COLLECT: 'Collecte des avis sur votre fiche Google',
    CUSTOMER_SECTION_TITLE: 'Connaissez vos clients et mesurez votre succès',
    FEATURE_CRM_CUSTOMER: 'Création de fiche clients avec suivi et historique des rendez-vous',
    FEATURE_CUSTOMER_STATS: 'Statistique du trafic et des interactions',
    CUSTOMER_LOYALTY_SECTION_TITLE: 'Fidélisez vos clients',
    FEATURE_SEGMENT_CUSTOMER: 'Segmentez votre clientèle par intérêts ou besoin pour des actions marketing',
    FEATURE_CAMPAIGN_AND_NEWS: 'Campagne emailing et SMS : informez vos clients de vos offres, promos, newsletters',
    FEATURE_MEASURE_CAMPAIGN_IMPACT: 'Mesurez les impacts de vos campagnes avec des statistiques',
    PAYMENT_SECTION_TITLE: 'Paiement en ligne',
    FEATURE_PAYMENT_TOTALLY_OR_DEPOSIT: 'Paiement à la réservation (acompte ou total)',
    FEATURE_CUSTOMER_PAYMENT_LINK: 'Simplifiez vos transactions avec la création de lien de paiement en 2 clics',
    FEATURE_IMPRINT: "Capture d'empreinte bancaire à la réservation",
    SUPPORT_SECTION_TITLE: 'Support client',
    FEATURE_ONLINE_TUTORIEL: 'Tutoriels complets en ligne',
    FEATURE_LIVE_CHAT: 'Chat avec des conseillers en live',
    FEATURE_VISIO_SUPPORT: 'Rendez-vous visio avec conseiller',
    SUBSCRIPTION: 'Abonnement',
    SUBSCRIPTION_MONTHLY: 'Flex',
    SUBSCRIPTION_YEARLY: 'Annuel',
    CURRENT_SUBSCRIPTION: 'Plan actuel',
    SUBSCRIPTION_EMAIL_QUOTA_TITLE: 'Email',
    SUBSCRIPTION_CHANGE_FORMULA: 'Changer de formule',
    SUBSCRIPTION_RESUB_FORMULA: 'Reprendre une formule',
    SUBSCRIPTION_TOP_UP_CREDIT: 'Recharger',
    SUBSCRIPTION_SMS_QUOTA_TITLE: 'SMS',
    SUBSCRIPTION_MONTHLY_USAGE_TEXT: 'Utilisation ce mois-ci',
    ADDITIONAL_CREDIT: 'Crédit(s) supplémentaire restant(s)',

    YEARLY_SAVING_AMOUNT: "Économisez jusqu'à {amount} par an avec l'abonnement annuel",
    BUTTON_INVOICES: 'Facturation',
    BUTTON_UNSUB: 'Résilier mon abonnement',
    INVOICE: 'Facture',

    CONTACT_BEFORE_UNSUB: "Être recontacté d'ici 24h",
    CONTACT_ACKNOWLEDGEMENT: 'Nous allons prendre contact avec vous sous 24h 😇',
    OFFER_APPLIED: 'Votre offre a été appliquée, la promotion sera effective sur vos prochaines factures.',
    UNSUB_ACKNOWLEDGEMENT: 'Votre désabonnement a été pris en compte 😢',
    UNSUB_BREAK_FEE_SEPA_PENDING:
      'Les frais de rupture sont prélevés par SEPA : encaissement sous quelques jours ouvrés.',
    UNSUB_ANYWAY: 'Se désabonner quand même',
    UNSUB_ANYWAY_AT_DATE: 'Résilier à compter du {date}',
    OFFER_EXPIRATION: "Offre valable jusqu'au {date}",
    NEXT_MONTHLY_PAYMENT: 'Prochaine mensualité le',
    END_TRIAL_PERIOD: "Fin de la période d'essai le",
    END_SUB_TRIAL_PERIOD: "Votre abonnement prendra fin avec votre période d'essai le",
    END_SUB_PERIOD: 'Votre abonnement prendra fin le',
    GIFTED: 'Offert',
    NEXT_SUBSCRIPTION_PAYMENT: "Passage d'abonnement vers",
    PENDING_PLAN_CHANGE_BANNER: 'Votre plan passera de {current_plan} à {target_plan} le {date}.',
    PENDING_PLAN_CHANGE_CANCEL: 'Annuler ce changement',
    PAST_DUE_BANNER_TITLE: 'Paiement en échec',
    PAST_DUE_BANNER_DESC:
      'Votre dernier prélèvement a échoué et votre compte est gelé. Vérifiez votre moyen de paiement ci-dessous, puis régularisez pour réactiver votre compte immédiatement.',
    PAST_DUE_BANNER_CTA: 'Régulariser maintenant',
    REGULARIZE_SUCCESS: 'Paiement accepté : votre compte est réactivé.',
    PAYMENT_AT_RISK_BANNER_TITLE: 'Un prélèvement a échoué',
    PAYMENT_AT_RISK_BANNER_DESC:
      'Le prélèvement de votre abonnement a été refusé. Vérifiez votre moyen de paiement ci-dessous, puis relancez le paiement. Sans action, la réservation en ligne de votre établissement sera suspendue.',
    PAYMENT_AT_RISK_BANNER_DESC_AMOUNT: 'Solde impayé : {amount}.',
    PAYMENT_AT_RISK_BANNER_CTA: 'Payer maintenant',
    PAY_OUTSTANDING_SUCCESS: 'Paiement accepté : tout est rentré dans l’ordre.',
    // ── Prélèvement SEPA (GoCardless) : lancé = ni payé ni impayé, encaissé sous quelques jours ouvrés ──
    PENDING_SEPA_DEBIT_TITLE: 'Prélèvement SEPA en cours',
    PENDING_SEPA_DEBIT_DESC: 'Prélèvement de {amount} lancé le {date} : encaissement sous quelques jours ouvrés.',
    PAY_OUTSTANDING_SEPA_PENDING: 'Prélèvement SEPA relancé : confirmation sous quelques jours ouvrés.',
    // Compte gelé : le prélèvement lancé ne dégèle qu'à son encaissement (une carte ajoutée ensuite
    // n'y change rien tant qu'il est en cours) — la carte se propose AVANT de régulariser.
    REGULARIZE_SEPA_PENDING:
      'Prélèvement SEPA lancé : votre compte sera réactivé dès son encaissement, sous quelques jours ouvrés.',
    PAST_DUE_SEPA_HINT:
      'Votre moyen de paiement par défaut est un mandat SEPA : la régularisation réactivera votre compte à l’encaissement du prélèvement, sous quelques jours ouvrés. Pour une réactivation immédiate, ajoutez une carte bancaire.',
    PAST_DUE_ADD_CARD_CTA: 'Ajouter une carte',
    ADDON_SEPA_DEBIT_LAUNCHED:
      'Option enregistrée : le prélèvement SEPA du prorata est lancé et sera encaissé sous quelques jours ouvrés.',
    PLAN_CHANGE_SEPA_DEBIT_LAUNCHED:
      'Formule mise à jour : le prélèvement SEPA est lancé et sera encaissé sous quelques jours ouvrés.',
  },

  CRM_EMAIL_BUILDER: {
    STANDALONE_TITLE: 'Éditeur d’email',
    STANDALONE_DESCRIPTION: 'Cette page s’ouvre uniquement depuis le back-office.',
    WAITING_FOR_HOST: 'Chargement de l’éditeur…',
    // Email de départ d'une campagne ou d'une étape de séquence neuve (rendu par le backend).
    DEFAULT_TEXT_CONTENT:
      'Bonjour {{customer:first_name}},<br><br>Écrivez ici votre message.<br><br>À bientôt,<br>L’équipe {{pro:name}}',
    DEFAULT_BUTTON_LABEL: 'Ouvrir {{pro:name}}',
    // Suffixe du nom d'une campagne dupliquée.
    CAMPAIGN_COPY_SUFFIX: '(copie)',
  },

  PUBLIC_CHAT: {
    HEADER_TITLE: '{brand}',
    HEADER_SUBTITLE: 'Discute avec notre agent',
    SCROLL_TO_BOTTOM: 'Revenir en bas',
    HEADER_LOGIN_LINK: "J'ai déjà un compte",
    WELCOME: `Hello, moi c'est Pulse 👋 Mon job chez ${PROJECT_CONFIG.brand_string} : remplir ton agenda et te rendre visible, sans dépendre des plateformes.\n\nPour commencer : tu fais quoi comme métier ?`,
    PLACEHOLDER: 'Écris ton message…',
    SEND_MESSAGE: 'Envoyer',
    THINKING_TITLE: "L'assistant réfléchit",
    THINKING_DESCRIPTION: 'Je prépare une réponse',
    UNAVAILABLE: 'Petit souci de connexion. Réessaie dans quelques secondes ?',
    FOOTER_DISCLAIMER: "Tu parles à Pulse, notre IA. Un humain de l'équipe peut prendre le relais à tout moment.",
    // Bulle de progression pendant la génération de la preview (waouh v2 §3.3).
    // Étapes posées par le backend aux jalons RÉELS du job — jamais de délai chiffré.
    PREVIEW_STAGE_LOOKUP: 'Je retrouve ta fiche Google…',
    PREVIEW_STAGE_PHOTOS: 'Je récupère tes photos…',
    PREVIEW_STAGE_REVIEWS: 'Je rassemble tes avis…',
    PREVIEW_STAGE_ASSEMBLY: 'Je compose ton site : tes prestations, ta palette…',
    PREVIEW_STAGE_ENRICHING: "J'enrichis encore ton site en arrière-plan…",
  },

  DOCS_AUTH: {
    REDIRECTING: 'Redirection vers la documentation…',
    ERROR: 'Impossible d’accéder à la documentation. Veuillez réessayer.',
    COOKIE_BLOCKED:
      'Votre navigateur n’a pas conservé votre accès à la documentation. Vérifiez que les cookies ne sont pas bloqués pour ce site (sur Safari : Réglages › Confidentialité), puis réessayez.',
    BACK_TO_SUPPORT: 'Retour au support',
  },
  ACCOUNT_PAGE: {
    TITLE: 'Mon compte',
    SUBTITLE: 'Vos identifiants et les documents liés à votre compte.',
    CHANGE_PASSWORD_TITLE: 'Changer le mot de passe',
    CHANGE_PASSWORD_DESCRIPTION: 'Mettez à jour le mot de passe de connexion à votre espace.',
    CHANGE_EMAIL_TITLE: "Changer l'email de connexion",
    CHANGE_EMAIL_DESCRIPTION: "L'adresse avec laquelle vous vous connectez, confirmée par un lien.",
    RECOVERY_EMAIL_TITLE: 'Adresse de récupération',
    RECOVERY_EMAIL_DESCRIPTION: 'Reçoit le « mot de passe oublié » si vous vous connectez avec une boîte pro hébergée.',
    LEGAL_DOCUMENTS_TITLE: 'Documents légaux',
    LEGAL_DOCUMENTS_DESCRIPTION: 'CGU, CGV et documents que vous avez acceptés.',
    REFERRAL_TITLE: 'Parrainage',
    REFERRAL_DESCRIPTION: 'Votre lien ambassadeur, vos filleuls et vos commissions.',
    MOBILE_APP_TITLE: 'Application mobile',
    MOBILE_APP_DESCRIPTION: 'Installez l’app iOS ou Android et retrouvez votre espace sur votre téléphone.',
  },
  // Incitation à installer l'app mobile pro, rendue UNIQUEMENT hors WebView
  // (bandeau accueil sur navigateur mobile, page Compte). Jamais affichée dans
  // l'app elle-même.
  MOBILE_APP_INSTALL: {
    BANNER_TITLE: `L’application ${PROJECT_CONFIG.brand_string} est disponible`,
    BANNER_HINT: 'Agenda, clients et ventes dans votre poche, avec les notifications en temps réel.',
    BANNER_CTA: 'Installer l’application',
    PAGE_TITLE: 'Application mobile',
    PAGE_SUBTITLE: `Installez ${PROJECT_CONFIG.brand_string} sur votre téléphone pour gérer votre activité partout.`,
    BADGE_APP_STORE_ALT: 'Télécharger dans l’App Store',
    BADGE_GOOGLE_PLAY_ALT: 'Disponible sur Google Play',
    QR_TITLE: 'Depuis un ordinateur ?',
    QR_HINT: 'Scannez ce code avec votre téléphone : il ouvre directement la bonne boutique.',
    QR_ERROR: 'QR code indisponible.',
    QR_ALT: 'QR code vers la boutique d’applications',
    ALREADY_IN_APP: 'Vous utilisez déjà l’application.',
  },
  LEGAL_DOCUMENTS_PAGE: {
    TITLE: 'Documents légaux',
    SUBTITLE: 'Retrouvez les documents que vous avez acceptés et le contrat qui régit votre abonnement.',
    CGU_TITLE: "Conditions générales d'utilisation",
    CGU_DESCRIPTION: "Les règles d'utilisation de la Solution.",
    CGV_TITLE: 'Conditions générales de vente',
    CGV_DESCRIPTION: 'Le contrat de votre abonnement (durée, prix, résiliation).',
    DPA_TITLE: 'Accord de sous-traitance (DPA)',
    DPA_DESCRIPTION: 'Le traitement des données de vos clients, au titre du RGPD.',
    CHARTER_TITLE: "Charte d'usage acceptable",
    CHARTER_DESCRIPTION: 'Les activités et contenus interdits sur la Solution.',
    PRIVACY_TITLE: 'Politique de confidentialité',
    PRIVACY_DESCRIPTION: 'Comment nous traitons vos données personnelles.',
  },
  SUPPORT_PAGE: {
    TITLE: "Centre d'aide",
    SUBTITLE: 'Documentation, tutoriels vidéo et assistance.',

    PULSE_TITLE: 'Une question ? Demandez à Pulse',
    PULSE_DESCRIPTION: 'Votre assistant IA répond instantanément et peut agir directement dans votre espace.',
    PULSE_CTA: 'Ouvrir Pulse',

    DOCS_HEADING: 'Documentation',
    DOCS_DESCRIPTION: 'Guides pas à pas, fonctionnalité par fonctionnalité, avec des démonstrations courtes.',
    DOCS_CTA: 'Ouvrir la documentation',
    DOCS_SECTIONS_LABEL: 'Accès direct',
    // Libellés des sections de la doc (help.propelsia.ai/<catégorie>), alignés sur le
    // `_meta.ts` du docs-site.
    DOCS_SECTION_ESTABLISHMENT: 'Entreprise',
    DOCS_SECTION_CATALOG: 'Catalogue',
    DOCS_SECTION_AGENDA: 'Agenda',
    DOCS_SECTION_WEBSITE: 'Site internet',
    DOCS_SECTION_CUSTOMERS: 'Clients',
    DOCS_SECTION_MARKETING: 'Communication',
    DOCS_SECTION_SALES: 'Ventes',
    DOCS_SECTION_ACCOUNT: 'Compte',

    TUTORIALS_HEADING: 'Tutoriels vidéo',
    TUTORIALS_DESCRIPTION:
      '{count, plural, one {# vidéo} other {# vidéos}} pour configurer votre espace, puis l’exploiter au quotidien.',
    TUTORIALS_PHASE_SETUP: 'Pour démarrer',
    TUTORIALS_PHASE_DAILY: 'Au quotidien',
    TUTORIALS_DURATION: '{minutes} min',
    TUTORIALS_ALL_CTA: 'Tous les tutoriels',
    TUTORIALS_PLAYLIST_CTA: 'Playlist YouTube',
    TUTORIALS_WATCH: 'Regarder le tutoriel',

    TRAINING_TITLE: 'Réservez une formation',
    TRAINING_DESCRIPTION: `Un expert ${PROJECT_CONFIG.brand_string} vous accompagne en direct pour configurer et exploiter votre espace.`,
    TRAINING_CTA: 'Réserver une formation',

    REQUESTS_HEADING: 'Demandes d’assistance',
    REQUESTS_DESCRIPTION: 'Un problème, un bug, une question précise ? Notre équipe vous répond ici et par email.',
    REQUESTS_LIST_TITLE: 'Vos demandes',
    REQUESTS_GROUP_ONGOING: 'En cours',
    REQUESTS_GROUP_RESOLVED: 'Résolues',
    REQUESTS_UNREAD: '{count, plural, one {# nouvelle réponse du support} other {# nouvelles réponses du support}}',
    REQUESTS_PREVIEW_YOU: 'Vous :',
    REQUESTS_BACK_TO_LIST: 'Mes demandes',
    REQUESTS_NEW: 'Nouvelle demande',
    REQUESTS_START: 'Faire une demande',
    REQUESTS_EMPTY: 'Aucune demande pour le moment. Décrivez votre problème, notre équipe vous répond.',
    REQUESTS_THREAD_EMPTY: 'Aucun message pour le moment.',
    REQUESTS_TITLE_FALLBACK: 'Demande d’assistance',
    REQUESTS_UNAVAILABLE: 'Les demandes d’assistance ne sont pas disponibles pour le moment. Écrivez-nous par email.',
    REQUESTS_RESOLVED_NOTICE: 'Cette demande est résolue. Ouvrez-en une nouvelle si besoin.',
    REQUESTS_BADGE_OPEN: 'En cours',
    REQUESTS_BADGE_RESOLVED: 'Résolue',
    REQUESTS_BADGE_AWAITING_YOU: 'Réponse reçue',
    REQUESTS_AGENT_TYPING: 'Le support est en train d’écrire…',

    // Suggestion Pulse sous une demande (triage automatique, cf. support-triage-pulse-plan.md).
    ASSIST_PENDING: 'Pulse analyse votre demande…',
    ASSIST_TITLE: 'Suggestion de Pulse',
    ASSIST_DISCLAIMER: 'Réponse générée automatiquement. Si elle vous convient, la demande sera fermée.',
    ASSIST_ACCEPT: 'Ça répond à ma question',
    ASSIST_REJECT: 'Je veux une réponse humaine',
    ASSIST_ACCEPTED: 'Demande résolue grâce à Pulse. Ouvrez une nouvelle demande si besoin.',
    ASSIST_REJECTED: 'Le support prend le relais.',
    ASSIST_REJECTED_TOGGLE: 'Voir la suggestion refusée',
    ASSIST_BADGE_SUGGESTED: 'Suggestion à lire',
    // Ajouté sous la suggestion quand Pulse a proposé une modification (carte à confirmer dans le chat).
    ASSIST_WRITE_NUDGE:
      '💡 Pulse peut appliquer cette modification pour vous : posez-lui la même question dans le chat Pulse et confirmez la carte proposée.',

    // Formulaire de nouvelle demande.
    REQUEST_FORM_TITLE: 'Nouvelle demande',
    REQUEST_FORM_SUBJECT_LABEL: 'Objet',
    REQUEST_FORM_SUBJECT_PLACEHOLDER: 'Ex. : le lien de paiement ne s’ouvre pas',
    REQUEST_FORM_DESCRIPTION_LABEL: 'Description',
    REQUEST_FORM_DESCRIPTION_PLACEHOLDER: 'Décrivez votre demande…',
    REQUEST_FORM_DESCRIPTION_HINT:
      'Précisez la page concernée, ce que vous attendiez et ce qui s’est passé. Une capture d’écran aide beaucoup.',
    // {max_files} / {max_mb} injectés depuis SUPPORT_ATTACHMENT_MAX_FILES / _MB (shared).
    REQUEST_FORM_ATTACH_HINT: 'Ajouter une capture ou un fichier ({max_files} max, {max_mb} Mo chacun)',
    REQUEST_FORM_CANCEL: 'Annuler',
    REQUEST_FORM_SUBMIT: 'Envoyer la demande',

    // Réponse dans une demande existante.
    REPLY_PLACEHOLDER: 'Répondre…',
    REPLY_SEND: 'Envoyer',
    REPLY_SHORTCUT_HINT: 'Ctrl + Entrée pour envoyer',

    ATTACH: 'Joindre un fichier',
    ATTACH_REMOVE: 'Retirer le fichier',
    ATTACH_DOWNLOAD: 'Télécharger',
    // {max} injecté depuis SUPPORT_ATTACHMENT_MAX_MB / SUPPORT_ATTACHMENT_MAX_FILES
    // (shared) — pas de valeur en dur ici, sinon le texte ment dès qu'on change la borne.
    ATTACH_TOO_LARGE: 'Fichier trop volumineux ({max} Mo maximum).',
    ATTACH_TOO_MANY: 'Vous pouvez joindre {max} fichiers maximum.',
    ATTACH_INVALID_TYPE: 'Ce type de fichier n’est pas autorisé.',
    CHAT_LIGHTBOX_COUNTER: '{current} / {total}',
    CHAT_LIGHTBOX_PREV: 'Image précédente',
    CHAT_LIGHTBOX_NEXT: 'Image suivante',

    CONTACT_EMAIL_TITLE: 'Par email',
    STATUS_TITLE: 'État des services',
    STATUS_DESCRIPTION: 'Vérifiez en temps réel si un incident est en cours.',

    // Bandeau d'accueil (HelpCenterBanner) qui pousse vers /support.
    HOME_BANNER_TITLE: 'Prenez en main votre espace en vidéo',
    HOME_BANNER_HINT:
      '{count, plural, one {# tutoriel} other {# tutoriels}} pas à pas, la documentation complète et vos demandes d’assistance, réunis dans le centre d’aide.',
    HOME_BANNER_CTA: 'Ouvrir le centre d’aide',
    HOME_BANNER_MORE: 'autres tutoriels',
  },
  MIGRATION_PROGRAM_BANNER: {
    TITLE: `Vous testez ${PROJECT_CONFIG.brand_string} en parallèle de Cfixé`,
    TEXT: `Pas besoin de vous abonner ici : on migrera votre abonnement Cfixé vers ${PROJECT_CONFIG.brand_string} le moment venu. Pour préparer votre bascule, remplissez le formulaire.`,
    CTA: 'Préparer ma bascule',
    PRICING_NOTE: `Bonne nouvelle : vos tarifs Cfixé actuels vous seront conservés après la bascule. Les tarifs ${PROJECT_CONFIG.brand_string} ci-dessous sont donnés à titre indicatif.`,
    PRICING_CTA: `Voir les tarifs ${PROJECT_CONFIG.brand_string}`,
  },
  // Tunnel obligatoire du nouveau parcours (spec onboarding v4, écrans 8 à 18 quater).
  PROFESSIONAL_APP_ONBOARDING_TUNNEL: {
    STEP_COUNTER: 'Étape {order} sur {total}',
    ADJUST_HINT: 'Vous pourrez toujours ajuster depuis votre espace.',
    BACK: 'Retour',
    CONTINUE: 'Continuer',
    SKIP_FOR_NOW: 'Ignorer pour l’instant',
    BACK_TO_PATH: 'Revenir au parcours',
    BANNER_STEP: 'Étape {order} sur {total} du parcours',
    BANNER_BACK: 'Revenir au parcours',
    STATUS_DONE: 'Fait',
    STATUS_SKIPPED: 'Ignoré pour l’instant',
    STATUS_CURRENT: 'En cours',
    STATUS_TODO: 'À faire',
    DAY_MON: 'Lundi',
    DAY_TUE: 'Mardi',
    DAY_WED: 'Mercredi',
    DAY_THU: 'Jeudi',
    DAY_FRI: 'Vendredi',
    DAY_SAT: 'Samedi',
    DAY_SUN: 'Dimanche',
    DAY_CLOSED: 'Fermé',
    // Écran 8 : la démo (spec v3 03/11 : une animation « le site prend forme », jamais le vrai site
    // à explorer, aucun prix ; le CTA reste hors de l'aperçu)
    DEMO_TITLE: '{firstname}, découvrez votre univers.',
    DEMO_TITLE_NO_NAME: 'Découvrez votre univers.',
    DEMO_SUBTITLE: 'Votre savoir-faire mérite d’être vu.',
    DEMO_PREVIEW_TITLE: 'Aperçu · {name}',
    DEMO_REVEAL_KICKER: 'Tout commence par vous',
    DEMO_REVEAL_TALENT: 'Votre talent.',
    DEMO_REVEAL_SIGNATURE: 'Votre signature.',
    DEMO_REVEAL_UNIVERSE: 'Un univers imaginé pour {name}.',
    DEMO_REVEAL_YOUR_NAME: 'Et c’est<br></br>votre nom dessus.',
    DEMO_REVEAL_PRESTATIONS:
      '{count, plural, one {Votre prestation est en place} other {Vos # prestations sont en place}}',
    DEMO_REVEAL_FORMING: 'Votre univers prend forme…',
    DEMO_REVEAL_CAPTION_SITE: 'Une première version de votre site se dessine.',
    DEMO_REVEAL_CAPTION_TILES: 'Vos prestations trouvent leur place.',
    DEMO_REVEAL_CAPTION_NAME: '{name}. Votre activité, votre univers.',
    DEMO_REVEAL_CAPTION_READY: 'Votre base est prête. À vous de la personnaliser.',
    DEMO_REVEAL_PHOTO_HINT: 'Visuels de démonstration : vos photos prendront leur place.',
    DEMO_REPLAY: 'Rejouer',
    DEMO_GAIN_BOOKING: 'Des clients qui réservent seuls, 24 h/24, rappel SMS compris.',
    DEMO_GAIN_VISIBILITY: 'Un site et une fiche Google qui vous font trouver près de chez vous.',
    DEMO_GAIN_PULSE: 'Pulse règle et rédige avec vous, maintenant et au quotidien.',
    DEMO_CTA: 'Personnaliser mon espace · {minutes} min',
    DEMO_CTA_HINT: 'Votre site prend forme. Ajoutons maintenant votre touche.',
    DEMO_TRIAL_BADGE: 'Essai Max · {days, plural, =0 {dernier jour} one {# jour} other {# jours}}',
    DEMO_WHY_TUNNEL:
      'Six étapes, dix minutes : à la fin, votre lien prend des réservations sans vous. Tout reste modifiable.',
    DEMO_IN_APP_BROWSER_HINT: 'Pour la suite, ouvrez le SMS reçu pour continuer dans votre navigateur.',
    // Étape 1 · écran 9 bis : le métier, quand le compte n'en a pas (inscription sans quiz)
    ACTIVITY_TITLE: 'Quel est votre métier ?',
    ACTIVITY_SUBTITLE: 'Un tap suffit : vos prestations, vos horaires types et votre site partent de là.',
    ACTIVITY_SEARCH_LABEL: 'Rechercher un métier',
    ACTIVITY_SEARCH_PLACEHOLDER: 'Coiffeur, naturopathe, coach sportif…',
    ACTIVITY_USE_WORDS: 'Utiliser « {text} »',
    ACTIVITY_NO_RESULT: 'Rien à ce nom. Continuez à taper, ou gardez vos mots.',
    ACTIVITY_CHOSEN_CHANGE: 'Changer',
    /** Le métier affiché reste CELUI DU PRO ; l'activité du référentiel n'est qu'un point de départ pour les prestations types (recette 31/10 : « Architecte d'intérieur » ne doit pas devenir « Conseillère en décoration d'intérieur »). */
    ACTIVITY_CHOSEN_AS:
      'Votre métier s’affichera tel quel. Pour vous proposer des prestations types, nous partons de « {label} » : vous ajustez ensuite.',
    ACTIVITY_CHOSEN_FREE: 'Métier hors référentiel : on garde vos mots, la liste de prestations partira de vous.',
    ACTIVITY_CTA: 'Continuer',
    ACTIVITY_SKIP: 'Je préciserai plus tard',
    // Étape 1 · écran 9 : ce qu'on a trouvé (détection de fond lancée à l'inscription)
    SOURCES_SEARCHING_TITLE: 'Pulse cherche ce qui existe déjà',
    SOURCES_SEARCHING_SUBTITLE:
      'Votre fiche Google, votre site, vos pages de réservation. Quelques secondes, et rien n’est écrit sans votre accord.',
    SOURCES_SEARCHING_GOOGLE: 'Fiche Google, à partir de votre numéro',
    SOURCES_SEARCHING_WEB: 'Site et pages de réservation, à partir de votre nom',
    SOURCES_SEARCHING_READ: 'Lecture des prestations, prix, photos et textes',
    SOURCES_SEARCHING_SKIP: 'Continuer sans attendre',
    SOURCES_TITLE: 'Voilà ce qu’on a trouvé. Ça vous va ?',
    SOURCES_SUBTITLE: 'Cochez ce qu’on garde ; Pulse fait le reste.',
    SOURCES_GOOGLE_TITLE: 'Votre fiche Google · {name}',
    SOURCES_SITE_TITLE: 'Votre site · {host}',
    SOURCES_BOOKING_TITLE: 'Votre outil de réservation · {host}',
    SOURCES_OTHER_TITLE: 'Une page à votre nom · {host}',
    SOURCES_GOOGLE_RATING: '{rating} sur 5',
    SOURCES_GOOGLE_REVIEWS: '{count, plural, =0 {aucun avis} one {# avis} other {# avis}}',
    SOURCES_GOOGLE_ADDRESS: 'adresse',
    SOURCES_GOOGLE_HOURS: 'horaires',
    SOURCES_PAGES: '{count, plural, one {# page lue} other {# pages lues}}',
    SOURCES_PULSE_SUMMARY:
      '« J’ai croisé ces sources : {prestations, plural, =0 {aucune prestation} one {# prestation} other {# prestations}}, {priced, plural, =0 {aucun prix} one {# prix} other {# prix}}, {photos, plural, =0 {aucune photo} one {# photo} other {# photos}}. Rien n’est écrit sans votre accord. »',
    SOURCES_CTA: 'Valider et voir mes prestations',
    SOURCES_NONE_MINE: 'Rien de tout ça n’est à moi',
    SOURCES_WEAK_HINT:
      'Trouvée par votre numéro, mais le nom et la ville ne correspondent pas : cochez-la seulement si c’est bien vous.',
    // Étape 1 · écran 11 : la liste
    OFFER_TITLE: 'Vos prestations sont prêtes.',
    OFFER_SUBTITLE: 'Validez tel quel, votre lien est prêt. Un tap sur une ligne pour ajuster un prix ou une durée.',
    /** L'étape 1 a deux écrans (liste, puis présentation) : on l'annonce, sinon le second arrive comme une sous-étape surprise. */
    OFFER_SEQUENCE: 'Ensuite, une courte présentation de vous, et l’étape est faite.',
    ABOUT_SEQUENCE: 'Dernier écran de l’étape',
    // D'où viennent LES PRIX (spec v3 03/11) : un prix lu sur une source nommée est « récupéré »,
    // tout le reste est « indicatif ». Jamais « fiche Google ou site » sans source identifiable.
    OFFER_PRICES_SOURCE: '{count, plural, one {# prix récupéré} other {# prix récupérés}} sur {source}.',
    OFFER_PRICES_SUGGESTED:
      '{count, plural, one {# prix indicatif de votre métier} other {# prix indicatifs de votre métier}} : gardez-les, ou changez-les d’un tap.',
    OFFER_QUOTE_HINT:
      '{count, plural, one {Une prestation sans prix sera affichée « sur devis ». Un tap pour en fixer un.} other {# prestations sans prix seront affichées « sur devis ». Un tap pour en fixer un.}}',
    OFFER_ROW_PRICE: '{price} €',
    OFFER_ROW_QUOTE: 'Sur devis',
    OFFER_PRICE_PLACEHOLDER: 'Sur devis',
    OFFER_NAME_LABEL: 'Nom',
    OFFER_NAME_PLACEHOLDER: 'Nom de la prestation',
    OFFER_DESCRIPTION_LABEL: 'Description',
    OFFER_DESCRIPTION_PLACEHOLDER: 'Ce que comprend la prestation, en une phrase. Facultatif.',
    OFFER_PRICE_LABEL: 'Prix (€)',
    OFFER_DURATION_LABEL: 'Durée (min)',
    OFFER_REMOVE: 'Retirer',
    OFFER_ADD: 'Ajouter une prestation',
    OFFER_EMPTY: 'Ajoutez votre première prestation : un nom, un prix, une durée.',
    OFFER_CTA: 'C’est bien ça, je valide',
    OFFER_RESTORE_DEFAULTS: 'Reprendre la liste proposée ({count})',
    OFFER_ORIGIN_DETECTION: 'Prestations lues sur {source}.',
    OFFER_ORIGIN_QUIZ: 'Ce que vous avez coché au départ.',
    OFFER_ORIGIN_DEFAULT: 'Liste type de votre métier.',
    // Retour de l'écran 10 : ce que Pulse a changé, avant → après, et ce qui n'a pas bougé.
    OFFER_PULSE_RECAP_TITLE: 'Ce que Pulse a changé',
    OFFER_PULSE_RECAP_COUNTS:
      '{changed, plural, =0 {Rien de modifié} one {# prestation modifiée} other {# prestations modifiées}} · {unchanged, plural, one {# inchangée} other {# inchangées}}{added, plural, =0 {} one { · # ajoutée} other { · # ajoutées}}{removed, plural, =0 {} one { · # retirée} other { · # retirées}}',
    OFFER_PULSE_RECAP_LINE: '{name} : {before} → {after}',
    OFFER_PULSE_RECAP_ADDED: '{name} : ajoutée ({after})',
    OFFER_PULSE_RECAP_REMOVED: '{name} : retirée',
    OFFER_PULSE_RECAP_VALUE: '{price} · {duration}',
    OFFER_PULSE_RECAP_CLOSE: 'Compris',
    // Étape 1 · écran 11 bis : l'à-propos (en-tête propre, pas la ligne « pourquoi » des prestations)
    ABOUT_TITLE: 'Présentez-vous à vos clients',
    ABOUT_SUBTITLE: 'Quelques mots sur vous, comme ça vient. Pulse en fait la page À propos de votre site.',
    /** Champ déjà rempli (phrase du quiz, texte trouvé) : on dit que c'est une proposition, et quoi en faire (spec v3 03/11). */
    ABOUT_SUBTITLE_PREFILLED:
      'Voici une première présentation. Personnalisez-la avec quelques mots sur vous, ou gardez-la pour commencer.',
    ABOUT_WHY: 'On réserve plus facilement chez quelqu’un dont on connaît l’histoire.',
    ABOUT_VOICE_CTA: 'Me présenter à voix haute',
    ABOUT_VOICE_HINT: '30 secondes suffisent, Pulse note vos mots.',
    /** Proposition déjà là : la voix COMPLÈTE le texte (ajout à la suite), elle ne le remplace pas. */
    ABOUT_VOICE_ADD_CTA: 'Ajouter quelques mots à voix haute',
    ABOUT_VOICE_ADD_HINT: 'Vos mots s’ajoutent à la suite de la proposition.',
    ABOUT_VOICE_STOP: 'J’ai fini',
    ABOUT_VOICE_RECORDING: 'Je vous écoute… parlez comme ça vient.',
    ABOUT_VOICE_TRANSCRIBING: 'Pulse note vos mots…',
    ABOUT_VOICE_EMPTY: 'Je n’ai rien entendu. Réessayez, ou écrivez-le en quelques mots.',
    ABOUT_VOICE_DONE: 'Voilà vos mots, tels quels. Complétez ou corrigez si besoin.',
    ABOUT_OR_WRITE: 'ou par écrit',
    ABOUT_PLACEHOLDER: 'Depuis quand vous exercez, votre formation, ce que vous aimez dans votre métier…',
    ABOUT_IDEAS: 'Pour démarrer',
    ABOUT_CHIP_SINCE: 'Depuis combien de temps',
    ABOUT_CHIP_SINCE_TEXT: 'Depuis … ans, ',
    ABOUT_CHIP_TRAINED: 'Ma formation',
    ABOUT_CHIP_TRAINED_TEXT: 'Ma formation : … chez …, ',
    ABOUT_CHIP_LOVE: 'Ce que j’aime dans ce métier',
    ABOUT_CHIP_LOVE_TEXT: 'Ce que j’aime, c’est ',
    ABOUT_CHIP_BEFORE: 'Avant, je faisais…',
    ABOUT_CHIP_BEFORE_TEXT: 'Avant, je faisais ',
    ABOUT_PULSE_PROMISE:
      'Pulse garde votre ton et rédige pendant que vous continuez. Le texte vous attend sur votre site, modifiable quand vous voulez.',
    ABOUT_CTA: 'Préparer ma page À propos et continuer',
    ABOUT_MIN_WORDS: 'Encore {count, plural, one {# mot} other {# mots}} et Pulse s’en occupe.',
    ABOUT_TEXT_LABEL: 'Votre présentation',
    ABOUT_PERSONALIZE_TITLE: 'Ajoutez votre touche (facultatif)',
    ABOUT_PERSONALIZE_HINT: 'Votre parcours, votre formation, ce que vous aimez : c’est ce qui vous distingue.',
    ABOUT_ORIGIN_QUIZ: 'Proposition basée sur vos mots du départ.',
    /** Spec v3 03/11 : jamais « trouvé sur vous » sans source identifiable (le texte est rédigé par l'IA). */
    ABOUT_ORIGIN_DETECTION: 'Proposition basée sur votre métier.',
    ABOUT_ORIGIN_DRAFT: 'Vos mots de la dernière fois, gardés.',
    ABOUT_LATER: 'Plus tard, on vous le rappellera',
    // Étape 2 : lieux et horaires
    PLACES_TITLE: 'Vos lieux et horaires',
    PLACES_SUBTITLE: 'Où se passent vos rendez-vous, et quand. Une semaine type est proposée pour votre métier.',
    PLACES_KIND_ESTABLISHMENT: 'Sur place',
    PLACES_KIND_ESTABLISHMENT_HINT: 'À votre adresse',
    PLACES_KIND_TRAVELING: 'En déplacement',
    PLACES_KIND_TRAVELING_HINT: 'Une ville et un rayon',
    PLACES_KIND_VIDEO: 'En visio',
    PLACES_KIND_VIDEO_HINT: 'Un lien de réunion, facultatif',
    PLACES_ESTABLISHMENT_ADDRESS: 'Votre adresse',
    PLACES_ESTABLISHMENT_ADDRESS_PLACEHOLDER: 'Numéro, rue, ville',
    PLACES_ESTABLISHMENT_NO_ADDRESS:
      'Votre ville suffit pour démarrer ; précisez la rue si vos clients viennent chez vous. Modifiable depuis « Mon établissement ».',
    PLACES_ORIGIN_QUIZ: 'Lieux cochés au départ : à garder ou à changer.',
    PLACES_ORIGIN_ACCOUNT: 'Pré-coché depuis l’adresse de votre compte.',
    DAY_PLACE_ESTABLISHMENT: 'chez vous',
    DAY_PLACE_TRAVELING: 'à domicile',
    DAY_PLACE_VIDEO: 'en visio',
    HOURS_ORDER_INVALID: 'L’heure de fermeture doit suivre l’ouverture.',
    PLACES_TRAVELING_LABEL: 'À domicile',
    PLACES_TRAVELING_CITY: 'Autour de quelle ville ?',
    PLACES_TRAVELING_CITY_PLACEHOLDER: 'Votre ville',
    PLACES_TRAVELING_RADIUS: 'Rayon : {km} km',
    PLACES_VIDEO_LABEL: 'En visio',
    PLACES_VIDEO_LINK_PLACEHOLDER: 'Lien de visio (Google Meet, Zoom…), facultatif',
    PLACES_VIDEO_LINK_HINT: 'Facultatif : vous pourrez l’ajouter plus tard depuis « Mon établissement ».',
    HOURS_TITLE: 'Votre semaine type',
    HOURS_SECTOR_HINT: 'Proposée pour votre métier. Les exceptions et vacances se règlent ensuite dans l’agenda.',
    AUTO_MESSAGES_TITLE: 'Confirmation automatique et rappel 24 h',
    AUTO_MESSAGES_HINT:
      'Vos clients reçoivent une confirmation immédiate et un rappel la veille. Rien à valider à la main.',
    HOURS_RANGE: '{start} – {end}',
    HOUR_SHORT: '{hour} h',
    HOUR_SHORT_MINUTES: '{hour} h {minutes}',
    HOURS_START: 'Ouverture',
    HOURS_END: 'Fermeture',
    PLACES_EXIT_CHECK_FAILED: 'Il manque une prestation, un lieu ou un créneau pour que le lien fonctionne.',
    PLACES_EXIT_CHECK_FAILED_TASK: 'Pour activer le lien, il manque : {task}.',
    PLACES_MISSING: 'Il manque : {field}.',
    PLACES_CTA: 'Activer mon lien',
    PLACES_BACK_TO_OFFER: 'Revenir à mes prestations',
    // Étape 3 : lien de réservation (spec v3 03/11 : montrer la victoire, aucun partage immédiat qui
    // sorte du parcours ; le test reste dans le tunnel et revient ici ; CTA « Finaliser mon espace »)
    SHARE_READY_BADGE: 'Votre réservation en ligne est prête',
    SHARE_TITLE: 'Votre prochain rendez-vous peut commencer ici.',
    SHARE_SUBTITLE: 'Votre lien de réservation est prêt, {firstname}.',
    SHARE_SUBTITLE_NO_NAME: 'Votre lien de réservation est prêt.',
    SHARE_TITLE_TESTED: 'Vous venez de recevoir votre première réservation.',
    SHARE_SUBTITLE_TESTED: 'C’était un test. La prochaine pourra être celle d’un vrai client.',
    SHARE_CARD_EYEBROW: 'Votre page de réservation',
    SHARE_COPY: 'Copier',
    SHARE_COPIED: 'Copié',
    SHARE_TEST_CTA: 'Tester comme un client',
    SHARE_TEST_HINT: '30 secondes · Retour ici après le test',
    SHARE_TEST_MODE: 'Mode test · {name}',
    SHARE_TEST_BACK: 'Revenir',
    SHARE_TEST_WAITING: 'Réservez dans le cadre avec votre propre numéro : on reconnaît le test, rien n’est compté.',
    SHARE_TEST_DONE_TITLE: 'Réservation test confirmée',
    SHARE_TEST_DONE_HINT: 'Exclue de vos chiffres · Aucun paiement',
    SHARE_LINK_IN_SPACE: 'Vous retrouverez votre lien dans votre espace pro.',
    SHARE_PROMISE_TITLE: 'Depuis votre site, sur Instagram, WhatsApp ou votre fiche Google.',
    SHARE_PROMISE_TEXT: 'Avec votre lien, vos clients réservent 24h/24, 7j/7, même quand vous êtes occupé·e.',
    SHARE_PROMISE_FOOT: 'Votre lien et les options de partage vous attendent dans votre espace pro.',
    SHARE_CTA: 'Finaliser mon espace',
    // Étape 4 : site
    WEBSITE_TITLE: 'Votre site',
    WEBSITE_SUBTITLE: 'Publiez-le tel quel avec le style de votre métier, ou ouvrez l’éditeur pour le personnaliser.',
    WEBSITE_SUBTITLE_PUBLISHED: 'Votre site est en ligne. Vous pourrez le personnaliser quand vous voulez.',
    WEBSITE_CONTINUE_PUBLISHED: 'Continuer',
    WEBSITE_PUBLISH_SECTOR_STYLE: 'Publier avec le style de mon métier',
    WEBSITE_OPEN_EDITOR: 'Ouvrir l’éditeur',
    WEBSITE_HINT: 'Une image cassée ou une accroche vide empêchent la publication : on vous le dira.',
    WEBSITE_ORIGIN: 'Vos prestations, vos textes et vos photos y sont déjà : rien à ressaisir.',
    // Étape 5 : référencement (spec v3 03/11 : deux leviers distincts, « Sur votre site » et
    // « Sur Google & Maps » ; la promesse « Une minute, et on vous trouve » est abandonnée)
    SEO_KICKER: 'Vous y êtes presque',
    SEO_TITLE: 'Faites-vous connaître près de chez vous.',
    SEO_SUBTITLE: 'Aidez vos futurs clients à vous trouver près de chez eux.',
    SEO_ON_SITE: 'Sur votre site',
    SEO_CITIES_TITLE: 'Vos villes de référence',
    SEO_CITIES_HINT: 'Ces villes guident le référencement local de votre site.',
    SEO_CITIES_ORIGIN: 'Proposées depuis vos lieux et votre ville de départ. Décochez, ou ajoutez-en.',
    SEO_CITIES_DONE: 'Ville enregistrée pour votre site',
    SEO_CITIES_FAILED: 'Impossible d’enregistrer : {cities}. Ajoutez-la depuis le champ ci-dessous.',
    SEO_CITIES_ADD_PLACEHOLDER: 'Ajouter une ville',
    SEO_ON_GOOGLE: 'Sur Google & Maps',
    SEO_GMB_TITLE: 'Votre fiche Google',
    SEO_GMB_TITLE_DETECTED: 'Votre fiche Google « {name} »',
    SEO_GMB_OPTIONAL_PILL: 'Facultatif',
    SEO_GMB_HINT: `Reliez votre fiche existante pour retrouver vos avis et vos informations dans ${PROJECT_CONFIG.brand_string}.`,
    SEO_GMB_TRIAL: 'Pendant l’essai, rien n’est modifié sur Google.',
    SEO_GMB_OPTIONAL: 'Vous pourrez aussi la connecter plus tard.',
    SEO_GMB_CONNECTED: 'Votre fiche est reliée.',
    SEO_GMB_CONNECT: 'Connecter ma fiche Google',
    SEO_GMB_MANAGE: 'Gérer ma fiche Google',
    SEO_GMB_DEFERRED: 'On vous guidera pour la créer après le parcours.',
    // Étape 6 : paiement
    // Écran vulgarisé (retour Alexandre 02/11) : on parle comme le pro — « acompte », « carte
    // enregistrée », « compte de paiement » — le mot Stripe n'apparaît qu'au moment d'ouvrir le compte.
    PAYMENT_TITLE: 'Fini les lapins ?',
    PAYMENT_SUBTITLE: 'Que demandez-vous à vos clients quand ils réservent ?',
    PAYMENT_ORIGIN: 'On vous conseille un acompte de 30 %. Vous pourrez changer d’avis à tout moment.',
    PAYMENT_PERCENT_VALUE: '{pct} %',
    PAYMENT_PERCENT_OTHER: 'Autre',
    PAYMENT_PERCENT_INVALID: 'Un nombre entre 1 et 100.',
    PAYMENT_RULE_DEPOSIT: 'Un acompte (conseillé)',
    PAYMENT_RULE_DEPOSIT_HINT: 'Ils paient une partie en réservant',
    PAYMENT_RULE_IMPRINT: 'Juste leur carte',
    PAYMENT_RULE_IMPRINT_HINT: 'Rien n’est prélevé, sauf s’ils ne viennent pas',
    PAYMENT_RULE_FREE: 'Rien',
    PAYMENT_RULE_FREE_HINT: 'Ils règlent tout sur place',
    PAYMENT_PERCENTAGE: 'Quel acompte ?',
    PAYMENT_SCOPE_ALL: 'Pour toutes mes prestations ({count})',
    PAYMENT_SCOPE_SELECTED: 'Je choisis lesquelles',
    /** Un seul CTA (spec v3 03/11) : le choix est enregistré, le compte de paiement s'ouvre depuis l'espace pro. */
    PAYMENT_FINISH: 'Terminer et découvrir mon espace',
    PAYMENT_STRIPE_PREREQ:
      'Pour encaisser en ligne, il vous faut un compte de paiement (chez Stripe, notre partenaire) : une pièce d’identité, un RIB, 3 minutes.',
    PAYMENT_STRIPE_HINT: 'Pas pressé ? En attendant, vos clients réservent sans rien payer.',
    PAYMENT_FREE_NOTE:
      'Rien à ouvrir : vos clients réservent sans payer. Si vous changez d’avis, vous pourrez demander un acompte plus tard depuis votre espace.',
    PAYMENT_STRIPE_ACTIVE: 'Votre compte de paiement est ouvert : vos clients paient en ligne selon votre choix.',
    // Coquille : compteur, pourquoi (volet B), victoire (volet A1)
    OPEN_PROGRESS: 'Voir votre parcours',
    REMAINING: 'Plus que {count, plural, one {# étape} other {# étapes}}',
    DURATION: '{minutes} min',
    WHY_MORE: 'En savoir plus',
    WHY_LESS: 'Réduire',
    NEVER_KICKER: 'Ce qu’on ne fait jamais :',
    WRITES_KICKER: 'Ce qu’on enregistre :',
    VICTORY_CONTINUE: 'Continuer',
    // Écran 13 : reprise
    RESUME_TITLE: 'Re-bonjour, {firstname}',
    RESUME_CONTEXT:
      '{days, plural, =0 {Tout à l’heure} =1 {Hier} other {Il y a # jours}}, vous vous êtes arrêté·e à « {step} ». On reprend là où vous en étiez.',
    RESUME_CONTEXT_ALL_DONE: 'Toutes les étapes sont faites : il ne reste qu’à ouvrir votre espace.',
    RESUME_KEPT: 'Tout ce que vous aviez fait est gardé.',
    RESUME_CTA: 'Reprendre : {step}',
    RESUME_MISSING: 'En cours · il manque {field}',
    RESUME_UPCOMING: 'À venir · {minutes} min',
    RESUME_DRAFT_PLACES: '« Vous m’aviez dit {km} km autour de {city}, je l’ai gardé en brouillon. On confirme ? »',
    RESUME_DRAFT_PAYMENT: '« Vous aviez choisi un acompte de {pct} %, je l’ai gardé en brouillon. On confirme ? »',
    RESUME_DRAFT_ABOUT: '« J’ai gardé vos mots : « {excerpt}… ». On continue ? »',
    RESUME_DRAFT_GENERIC: '« J’ai gardé ce que vous aviez commencé. On reprend ? »',
    RESUME_HINT: 'Vous pouvez quitter à tout moment : on vous renvoie ici, jamais au début.',
    MISSING_PRESTATIONS: 'une prestation avec un nom et une durée',
    MISSING_ABOUT: 'votre présentation (cinq mots suffisent)',
    MISSING_PLACE_KIND: 'au moins un lieu',
    MISSING_TRAVELING_CENTER: 'la ville de vos déplacements',
    MISSING_VIDEO_LINK: 'votre lien de visio',
    MISSING_OPENING_DAY: 'au moins un jour ouvert',
    MISSING_HOURS_ORDER: 'une plage horaire valide',
    MISSING_SHARE: 'un partage ou un client',
    MISSING_PUBLISH: 'la publication de votre site',
    MISSING_CITIES: 'au moins une ville',
    MISSING_GMB: 'votre fiche Google, ou « plus tard »',
    MISSING_RULE: 'ce que vos clients paient en réservant',
    MISSING_PERCENTAGE: 'le montant de l’acompte',
    MISSING_RULE_PRESTATIONS: 'les prestations concernées',
    // Écran 16 : progression
    PROGRESS_TITLE: 'Votre espace se prépare.',
    PROGRESS_SUBTITLE:
      'Six étapes, dix minutes. À la fin, votre lien prend des réservations sans vous. Tout reste modifiable.',
    PROGRESS_COUNT: '{done} / {total} étapes',
    PROGRESS_REMAINING_MINUTES: 'encore {minutes} min',
    PROGRESS_FOOTER:
      'Vous pouvez quitter et revenir : on reprend au bon endroit. Tout reste ajustable ensuite depuis votre espace.',
    PROGRESS_FINISH: 'Ouvrir mon espace',
    // Écran 18 bis : fin (volet A5)
    DONE_TITLE: 'Bravo {firstname}, c’est fait',
    DONE_SUBTITLE: 'Tout est en place. Votre espace s’ouvre.',
    DONE_DURATION: 'Terminé en {minutes} min.',
    DONE_DURATION_DAYS: 'Terminé en {days, plural, one {# jour} other {# jours}}.',
    DONE_DURATION_INSTANT: 'Déjà prêt.',
    DONE_CARD_TITLE: `Dès maintenant, ${PROJECT_CONFIG.brand_string} fait pour vous`,
    DONE_GAIN_PLACES: 'Réservations 24 h/24, confirmées et rappelées par SMS sans vous',
    DONE_GAIN_OFFER: '{count, plural, one {# prestation réservable} other {# prestations réservables}} en ligne',
    DONE_GAIN_WEBSITE: 'Votre site {host} est en ligne',
    DONE_GAIN_SEO: 'Vos villes : {cities}{gmb, select, true { · fiche Google reliée} other {}}',
    DONE_GAIN_PAYMENT:
      '{rule, select, DEPOSIT {Acompte {pct} %} BANK_IMPRINT {Empreinte bancaire} other {Règle de paiement}} sur {count, plural, one {# prestation} other {# prestations}}{stripe, select, true {} other {, actif dès que Stripe est connecté}}',
    DONE_GAIN_PULSE: 'Pulse rédige, règle et vous guide : un coup de pouce par jour',
    DONE_DEFERRED_TITLE: 'Mis de côté, on vous le reproposera',
    DONE_DEFERRED_HINT: 'Sans insister : une chose par jour, jamais le week-end.',
    /** Une seule destination (spec v3 03/11) : plus de « Voir ce qui est réglé » sur cet écran. */
    DONE_CTA: 'Accéder à mon espace',
    DONE_INCOMPLETE: 'Il reste une étape à terminer avant d’ouvrir votre espace.',
    // Écran 18 quater : récap
    RECAP_TITLE: 'Ce qui est réglé',
    RECAP_SUBTITLE: 'Tout ce que vous avez validé, en clair. Chaque ligne s’ouvre au bon endroit.',
    RECAP_EDIT: 'Modifier',
    RECAP_BACK_HOME: 'Retour à l’accueil',
    RECAP_DEFERRED_TITLE: 'Mis de côté',
    RECAP_RESUME: 'Reprendre',
    THEME_OFFER: 'Vos prestations',
    THEME_PLACES_HOURS: 'Lieux et horaires',
    THEME_ABOUT: 'Votre « à propos »',
    THEME_WEBSITE: 'Votre site',
    THEME_SEO: 'Référencement',
    THEME_PAYMENT: 'Paiement',
    // Résumé réel (victoires, fin, récap, reprise) : des valeurs, jamais de texte fixe
    SUM_OFFER:
      '{count, plural, one {# prestation} other {# prestations}}{quotes, plural, =0 {} one { (# sur devis)} other { (# sur devis)}} · {sample}',
    SUM_OFFER_NONE: 'Aucune prestation pour l’instant',
    SUM_PRESTATION_PRICED: '{name} {price} · {duration}',
    SUM_PRESTATION_QUOTE: '{name} sur devis · {duration}',
    SUM_PLACE_ESTABLISHMENT: 'Chez vous',
    SUM_PLACE_ESTABLISHMENT_CITY: 'Chez vous ({city})',
    SUM_PLACE_TRAVELING: 'À domicile',
    SUM_PLACE_TRAVELING_CITY: 'À domicile, {km} km autour de {city}',
    SUM_PLACE_VIDEO: 'En visio',
    SUM_PLACE_NONE: 'Aucun lieu',
    SUM_HOURS: '{days} j/7',
    SUM_HOURS_RANGE: '{days} j/7 · {range}',
    SUM_AUTO_CONFIRM: 'confirmation automatique',
    SUM_REMINDER: 'rappel la veille',
    SUM_ABOUT_RAW:
      'Vos mots sont gardés ({words, plural, one {# mot} other {# mots}}) · Pulse rédige votre présentation',
    SUM_ABOUT_DESCRIPTION: 'Présentation en ligne',
    SUM_ABOUT_NONE: 'À faire : dites-le en trente secondes',
    SUM_WEBSITE_STYLE: 'Style « {style} »',
    SUM_WEBSITE_PUBLISHED: 'publié · {host}',
    SUM_WEBSITE_DRAFT: 'brouillon, pas encore publié',
    SUM_SEO_NO_CITY: 'Aucune ville',
    SUM_SEO_MORE_CITIES: '+{count}',
    SUM_SEO_GMB_PUSHED: 'fiche Google synchronisée',
    SUM_SEO_GMB_LINKED: 'fiche Google reliée',
    SUM_SEO_GMB_NONE: 'fiche Google à relier',
    SUM_PAYMENT_NONE: 'Règle à choisir',
    SUM_PAYMENT_DEPOSIT: 'Acompte {pct} % sur {count, plural, one {# prestation} other {# prestations}}',
    SUM_PAYMENT_IMPRINT: 'Carte enregistrée sur {count, plural, one {# prestation} other {# prestations}}',
    SUM_PAYMENT_FREE: 'Aucun paiement à la réservation',
    SUM_PAYMENT_STRIPE_ACTIVE: 'paiement en ligne actif',
    SUM_PAYMENT_STRIPE_PENDING: 'dès que votre compte de paiement est ouvert',
    SUM_SHARE_DONE:
      'Lien partagé{customers, plural, =0 {} one { · # client enregistré} other { · # clients enregistrés}}',
  },
  /**
   * Onboarding v4, lot 7 : site par style (écrans 16 bis, 23, 25) et choix du pro qui a déjà un
   * site (§4.2). Les quatre styles sont des presets de composition (`style-presets.ts`).
   */
  PROFESSIONAL_APP_WEBSITE_STYLES: {
    PRESET_CHIC: 'Chic et sobre',
    PRESET_CHIC_DESCRIPTION: 'Élégant et aéré : grandes marges, serif, une photo par section.',
    PRESET_DOUX: 'Doux et lumineux',
    PRESET_DOUX_DESCRIPTION: 'Arrondi et chaleureux : carrousel, galerie, boutons ronds.',
    PRESET_AUDACIEUX: 'Audacieux',
    PRESET_AUDACIEUX_DESCRIPTION: 'Contrasté et dense : chiffres clés, avant / après, lignes franches.',
    PRESET_MINIMAL: 'Minimal',
    PRESET_MINIMAL_DESCRIPTION: 'Épuré : l’essentiel, noir sur blanc, la liste de vos prestations.',
    STEP_TITLE: 'Votre site, à votre image.',
    STEP_SUBTITLE: 'Votre identité, puis l’ambiance qui vous ressemble.',
    // Écran 16 bis (spec v3 03/11) : deux actions distinctes, le logo (dans le parcours) puis le style.
    LOGO_BLOCK_TITLE: '1. Ajoutez votre logo',
    LOGO_BLOCK_HINT: 'Pour que vos clients vous reconnaissent au premier regard.',
    // Le logo donne ses couleurs au site (palette de marque) ; le choix « Couleurs du style » reste offert.
    LOGO_COLORS_HINT: 'Ses couleurs habilleront votre site, ou gardez celles du style.',
    LOGO_PLACEHOLDER: 'Votre logo (PNG, JPG ou SVG)',
    LOGO_SAVED: 'Votre logo est en place.',
    LOGO_SAVING: 'Envoi de votre logo…',
    STYLE_BLOCK_TITLE: '2. Choisissez le style de votre site',
    STYLE_BLOCK_HINT: 'Couleurs, typographies, mise en page : choisissez votre ambiance.',
    CUSTOMIZE_LATER:
      'Vous pourrez personnaliser votre site à tout moment depuis votre espace pro : photos, textes, couleurs…',
    BRAND_BLOCK_TITLE: 'Logo, couleurs, photos',
    BRAND_SOURCE_LOGO: 'couleurs prises sur votre logo',
    BRAND_SOURCE_SITE: 'couleurs prises sur votre site',
    BRAND_SOURCE_CUSTOM: 'vos couleurs',
    BRAND_SOURCE_SECTOR: 'palette de votre métier',
    BRAND_PHOTOS: '{count, plural, =0 {aucune photo} one {# photo} other {# photos}}',
    BRAND_CHANGE: 'changer',
    BRAND_ADD_LOGO: 'Ajouter mon logo',
    BRAND_LOGO_PROVISIONAL: 'Logo provisoire',
    BRAND_LOGO_PROVISIONAL_HINT: 'Un monogramme à vos initiales en attendant le vôtre : remplaçable à tout moment.',
    BRAND_CONTRAST_ADJUSTED: 'On a éclairci une couleur pour que le texte reste lisible.',
    BRAND_USE_BRAND: 'Mes couleurs',
    BRAND_USE_SECTOR: 'Couleurs du style',
    APPLY_CTA: 'Appliquer « {style} » et continuer',
    APPLY_AND_OPEN: 'Appliquer et ouvrir l’éditeur',
    SELF_SETTINGS: 'Je préfère régler moi-même',
    APPLYING: 'On applique le style…',
    APPLIED_TOAST: 'Style appliqué : ajustez ce que vous voulez, puis publiez.',
    PUBLISH_REFUSED: 'Pas encore publié : {reason}',
    OPEN_EDITOR: 'Ouvrir l’éditeur',
    PREVIEW_LABEL: 'Aperçu du style {style}',
    PREVIEW_LOADING: 'Aperçu en préparation…',
    RECAP_CARD_TITLE: 'Votre site, à votre image',
    RECAP_CARD_SUBTITLE: 'Choisissez un style : logo, couleurs, photos et textes sont appliqués d’un coup.',
    RECAP_STYLE_LINE: 'Style : {style}',
    SETTINGS_CARD_TITLE: 'Style du site',
    SETTINGS_CARD_SUBTITLE_SET: 'Style : {style} · changer',
    SETTINGS_CARD_SUBTITLE_NONE: 'Choisir un style complet',
    EDITOR_SECTION: 'Styles · un template complet',
    EDITOR_SECTION_HINT:
      'Change la composition et le style global d’un coup ; les réglages ci-dessous restent modifiables.',
    EDITOR_YOUR_COLORS: 'Vos couleurs',
    EDITOR_YOUR_COLORS_HINT: 'prises sur votre logo',
    OWN_SITE_TITLE: 'Vous avez déjà un site.',
    OWN_SITE_SUBTITLE: 'Vous nous avez indiqué {host}. Deux options, et vous pourrez changer d’avis plus tard.',
    OWN_SITE_SWITCH_TITLE: `Passer sur le site ${PROJECT_CONFIG.brand_string}`,
    OWN_SITE_SWITCH_TEXT:
      'Vos prestations, vos textes et la réservation y sont déjà. Votre site actuel reste en ligne tant que vous ne rebranchez pas votre domaine.',
    OWN_SITE_KEEP_TITLE: 'Garder mon site',
    OWN_SITE_KEEP_TEXT: 'On ne publie rien. Il vous reste à ajouter le bouton Réserver sur votre site.',
    BUTTON_TITLE: 'Ajoutez le bouton Réserver',
    BUTTON_SUBTITLE: 'Collez ce lien sur votre site (bouton, menu, bio) : vos clients réservent sans vous appeler.',
    BUTTON_LINK_LABEL: 'Votre lien de réservation',
    BUTTON_HTML_LABEL: 'Extrait HTML du bouton',
    BUTTON_HTML_TEXT: 'Réserver en ligne',
    COPY: 'Copier',
    COPIED: 'Copié',
    BUTTON_DONE: 'C’est fait, je continue',
    BUTTON_LATER: 'Je le ferai plus tard',
    CHOICE_SAVED: `Choix enregistré. Vous pourrez passer sur le site ${PROJECT_CONFIG.brand_string} depuis Site internet.`,
  },
  /**
   * Volet B du plan onboarding v4 : UNE source pour ce qu'on dit de chaque étape du tunnel (gain,
   * pourquoi, « en savoir plus », ce qu'on ne fait jamais, ce qu'on enregistre, victoire chiffrée,
   * encouragement). Clés `<ÉTAPE>_<FACETTE>` (cf. `tunnel-step-copy.ts`). Premier jet du 29/10/2026,
   * relu par Kaltouma pendant la recette. Aucun chiffre non mesuré.
   */
  PROFESSIONAL_APP_ONBOARDING_TUNNEL_COPY: {
    OFFER_GAIN: 'Vos prestations réservables en ligne, avec leur prix et leur durée.',
    OFFER_WHY: 'Vos clients réservent une prestation précise : il nous faut un nom, un prix et une durée pour chacune.',
    OFFER_WHY_MORE:
      'Le prix et la durée servent à proposer les bons créneaux et à afficher ce que le client va payer. Une prestation sans prix est affichée « sur devis » : elle reste réservable.',
    OFFER_NEVER: 'rien n’est écrit dans votre catalogue sans vous.',
    OFFER_WRITES: 'vos prestations (nom, prix, durée) dans votre catalogue, et vos mots pour votre « à propos ».',
    OFFER_VICTORY:
      '{count, plural, =0 {Vos prestations sont en ligne} one {# prestation en ligne} other {# prestations en ligne}}',
    OFFER_CHEER: 'Première étape, la plus longue : après, tout va vite.',
    PLACES_HOURS_GAIN: 'Confirmation automatique et rappel la veille : ça réserve sans vous.',
    PLACES_HOURS_WHY:
      'On ne propose que vos vrais créneaux, et chaque client reçoit une confirmation puis un rappel la veille.',
    PLACES_HOURS_WHY_MORE:
      'Vos lieux disent où vos clients vous retrouvent (chez vous, chez eux, en visio) ; vos horaires disent quand. Les exceptions, les vacances et les horaires par lieu se règlent ensuite dans l’agenda.',
    PLACES_HOURS_NEVER: 'pas de réservation hors de vos horaires.',
    PLACES_HOURS_WRITES: 'vos lieux, votre semaine type, et les messages automatiques (confirmation, rappel).',
    PLACES_HOURS_VICTORY: 'Vos créneaux sont ouverts : vos clients peuvent réserver en ligne',
    PLACES_HOURS_CHEER: 'Deux minutes, et votre lien prend des réservations.',
    SHARE_GAIN: 'Vos clients prévenus : les premières réservations sans un message.',
    SHARE_WHY: 'Un lien que personne ne connaît ne réserve pas : vos clients actuels sont les premiers à l’utiliser.',
    SHARE_WHY_MORE:
      'Le message est prêt, vous choisissez à qui l’envoyer. Vos clients enregistrés ici reçoivent ensuite la confirmation et le rappel de leurs rendez-vous.',
    SHARE_NEVER: 'on n’envoie rien à vos clients : c’est vous.',
    SHARE_WRITES: 'les clients que vous saisissez, et le fait que votre lien a été partagé.',
    SHARE_VICTORY:
      '{customers, plural, =0 {Votre lien de réservation est prêt à partager} one {Votre lien de réservation est prêt à partager · # client enregistré} other {Votre lien de réservation est prêt à partager · # clients enregistrés}}',
    SHARE_CHEER: 'Un partage suffit. Le reste peut attendre.',
    WEBSITE_GAIN: 'Votre site montre vos prestations et prend les réservations, même la nuit.',
    WEBSITE_WHY: 'Votre site montre vos prestations et prend les réservations, même la nuit.',
    WEBSITE_WHY_MORE:
      'Il est déjà rempli avec vos prestations, vos textes et vos photos. Publier avec le style de votre métier prend une minute ; vous pourrez le personnaliser ensuite, autant de fois que vous voulez.',
    WEBSITE_NEVER: 'rien n’est publié sans votre accord.',
    WEBSITE_WRITES: `la publication de votre site sur votre adresse ${PROJECT_CONFIG.websites_root_domain}.`,
    WEBSITE_VICTORY: 'Site publié : {host}',
    WEBSITE_CHEER: 'Une minute, et votre site est en ligne.',
    SEO_GAIN: 'Vos villes et votre fiche Google : on vous trouve.',
    SEO_WHY: 'Vos villes et votre fiche Google, c’est ce qui vous fait trouver par celles qui ne vous connaissent pas.',
    SEO_WHY_MORE:
      'Vos villes nourrissent les pages locales de votre site. Votre fiche Google reliée reçoit vos horaires, vos prestations et votre lien de réservation, et reste à jour toute seule.',
    SEO_NEVER: 'on ne crée pas de fiche et on ne change pas son nom.',
    SEO_WRITES: 'vos villes, et la liaison de votre fiche Google si vous la connectez.',
    SEO_VICTORY:
      '{count, plural, =0 {Votre référencement local est réglé} other {Votre site est optimisé pour les recherches à {cities}}}',
    SEO_CHEER: 'Vous y êtes presque.',
    PAYMENT_GAIN: 'Un acompte ou une carte enregistrée à la réservation, encaissés en ligne pour vous.',
    PAYMENT_WHY: 'Un acompte ou une carte enregistrée, c’est moins de rendez-vous oubliés.',
    PAYMENT_WHY_MORE:
      'Vous choisissez maintenant ce que vos clients paient en réservant. Ça démarre dès que votre compte de paiement est ouvert (une pièce d’identité, un RIB, trois minutes), tout de suite ou plus tard.',
    PAYMENT_NEVER: 'vos clients ne paient rien tant que votre compte de paiement n’est pas ouvert.',
    PAYMENT_WRITES: 'votre choix, appliqué à vos prestations dès que votre compte de paiement est ouvert.',
    PAYMENT_VICTORY:
      '{rule, select, DEPOSIT {Acompte de {pct} % : réglé} BANK_IMPRINT {Carte enregistrée à la réservation : réglé} FREE {Réservation sans paiement : réglé} other {Paiement : réglé}}',
    PAYMENT_CHEER: 'Dernière étape. Votre espace s’ouvre juste après.',
  },
  // Pulse dans le tunnel et après (onboarding v4, lot 5 : écran 10, sorties « le dire à Pulse »,
  // champ Pulse de l'accueil, errance). Textes codés en premier jet, relus en recette.
  PROFESSIONAL_APP_ONBOARDING_PULSE: {
    CHAT_KICKER: 'Étape {order} sur {total} · avec Pulse',
    CHAT_TITLE_OFFER: 'Pulse cadre votre offre',
    CHAT_TITLE_STEP: 'Dites-le à Pulse',
    CHAT_SUBTITLE_OFFER: 'Il pose les bonnes questions, à l’écrit ou à voix haute, et rédige en parallèle.',
    CHAT_SUBTITLE_STEP: 'Il prépare, vous montre le récapitulatif, vous confirmez.',
    /** Étape 2 : Pulse remplit l'écran (brouillon), c'est « Activer mon lien » qui enregistre. */
    CHAT_SUBTITLE_PLACES: 'Il remplit l’écran pour vous. Vous vérifiez, puis vous activez votre lien.',
    CHAT_OPENING_PLACES:
      'Je vous écoute. Je prépare vos lieux et vos horaires sur l’écran ; rien n’est enregistré avant « Activer mon lien ».',
    CHAT_OPENING_OFFER:
      'Dites-moi vos prestations phares, leur prix et le temps que vous y passez. Si vous ne savez pas, dites-le : je propose une valeur à confirmer.',
    CHAT_OPENING_STEP: 'Je vous écoute. Je prépare la modification et vous la validez d’un tap.',
    CHAT_PLACEHOLDER: 'Répondez ici…',
    CHAT_SEND: 'Envoyer',
    CHAT_VOICE: 'Répondre à voix haute',
    CHAT_VOICE_STOP: 'Arrêter',
    CHAT_VOICE_HINT: 'Pulse écoute, note et rédige pendant que vous parlez.',
    CHAT_VOICE_TRANSCRIBING: 'Pulse note vos mots…',
    CHAT_VOICE_EMPTY: 'Je n’ai rien entendu. Écrivez votre réponse, c’est aussi bien.',
    CHAT_FLYER: 'Photo d’un flyer',
    CHAT_FLYER_HINT: 'Une photo de votre carte, flyer ou menu : Pulse en lit les prestations et les prix.',
    CHAT_FLYER_MESSAGE: 'Voici mon flyer : lis les prestations, les prix et les durées.',
    CHAT_ATTACHMENT_REMOVE: 'Retirer la photo',
    CHAT_CHIP_DONT_KNOW: 'Je ne sais pas',
    /** Écran 10 : une réponse qui colle à la question d'ouverture (recette 03/11 : « En plus d'une prestation » / « Seul aussi » n'y répondaient pas). */
    CHAT_CHIP_KEEP_LIST: 'Garde ma liste telle quelle',
    CHAT_CHIP_THATS_ALL: 'C’est tout',
    CHAT_CHIP_GO: 'Go',
    CHAT_WRITING_COUNT: '{count, plural, one {# texte prêt} other {# textes prêts}}',
    CHAT_STATUS_WRITING_PENDING: 'Pulse rédige au fil de vos réponses',
    CHAT_STATUS_LIST:
      '{count, plural, =0 {Votre liste est vide pour l’instant} one {# prestation dans votre liste} other {# prestations dans votre liste}}',
    CHAT_DONE_OFFER: 'Voir mes prestations prêtes',
    CHAT_BACK_STEP: 'Revenir à l’étape',
    CHAT_UNAVAILABLE: 'Pulse est momentanément indisponible. Vous pouvez continuer sans lui.',
    CHAT_NEVER: 'Rien n’est écrit sans votre accord : Pulse remplit votre liste, vous la validez.',
    CHAT_NEVER_PLACES:
      'Rien n’est enregistré sans vous : Pulse remplit l’écran, vous vérifiez puis activez votre lien.',
    CHAT_NEVER_STEP: 'Rien n’est enregistré sans votre accord : Pulse prépare, vous confirmez d’un tap.',
    CHAT_THINKING: 'Pulse réfléchit…',
    CHAT_HISTORY_LOADING: 'Je reprends notre conversation…',
    OFFER_TALK_TO_PULSE: 'Je préfère en parler avec Pulse',
    /** Le pro ne connaît pas encore Pulse (recette 03/11) : on nomme le besoin, pas l'outil. */
    OFFER_ADJUST_WITH_PULSE: 'Besoin d’aide pour ajuster',
    PLACES_TELL_PULSE: 'Un autre lieu, un tarif de déplacement, des vacances ? Dites-le à Pulse',
    PLACES_TELL_PULSE_PROMPT: 'J’ai une précision sur mes lieux ou mes horaires : ',
    PAYMENT_TELL_PULSE: 'Acompte, carte enregistrée, compte de paiement : Pulse m’explique',
    PAYMENT_TELL_PULSE_PROMPT:
      'Explique-moi simplement, pour mes clients, la différence entre un acompte et une carte enregistrée, et à quoi sert le compte de paiement Stripe.',
    HOME_ASK_TITLE: 'Demandez à Pulse',
    HOME_ASK_HINT: 'Il prépare, vous dites « go ».',
    HOME_ASK_PLACEHOLDER: '« Je ferme le mercredi après-midi »…',
    HOME_ASK_CTA: 'Demander',
    HOME_EXAMPLE_CLOSE: 'Je ferme le mercredi après-midi',
    HOME_EXAMPLE_DEPOSIT: 'Mets un acompte de 50 % sur ma prestation phare',
    HOME_EXAMPLE_PHOTO: 'Change ma photo de couverture',
    HOME_EXAMPLE_PRIORITY: 'Aide-moi pour : {priority}',
    WANDER_TITLE: 'Vous cherchez quelque chose ?',
    WANDER_HINT: 'Dites-le à Pulse, il vous y emmène ou le fait pour vous.',
    WANDER_CTA: 'Demander à Pulse',
    WANDER_DISMISS: 'Non merci',
  },
  // Accueil « une chose à la fois » après le tunnel (spec v4, écrans 20 et 18 ter).
  PROFESSIONAL_APP_HOME_V2: {
    // Bloc du jour (écrans 18 ter / 20) : la nouvelle d'abord, puis la priorité et son gain.
    DAY_KICKER: 'Jour {day} · une seule chose aujourd’hui',
    NEWS_BOOKING: '{firstname} a réservé le {when}{outside, select, true {, en dehors de vos horaires} other {}}.',
    NEWS_SOMEONE: 'Un client',
    MAIN_CTA: 'Je m’en occupe · {minutes} min',
    SEE_RECAP: 'Voir ce qui est réglé',
    GAIN_SUBSCRIBE: 'Gardez tout ça après l’essai : le site, le lien, Pulse et tout ce qui est réglé.',
    GAIN_FIRST_APPOINTMENTS: 'Vos rendez-vous déjà pris cette semaine, dans l’agenda : les rappels partent seuls.',
    GAIN_BLOG: 'Un article rédigé par Pulse, et Google a une raison de plus de vous montrer.',
    GAIN_CALENDAR_SYNC: 'Vos deux agendas ne se marchent plus dessus.',
    GAIN_IMPORT_CUSTOMERS: 'Vos clients dans votre fichier : rappels et relances sans ressaisie.',
    GAIN_CUSTOMIZE_SITE: 'Votre logo, vos couleurs, un style : votre site vous ressemble.',
    GAIN_HOLIDAYS: 'Pas de réservation un jour où vous n’êtes pas là.',
    PRIORITY_META: '{page} · {minutes} min',
    PRIORITY_DURATION: '{minutes} min',
    ALL_DONE_TITLE: 'Tout est en place',
    ALL_DONE_HINT: 'Votre espace tourne sans vous. Pulse reste là pour ajuster.',
    NEXT_TITLE: 'Et maintenant · {done} sur {total} {done, plural, one {faite} other {faites}}',
    MORE: '{count, plural, one {# autre, quand vous voulez} other {# autres, quand vous voulez}}',
    // « Votre semaine » (écrans 16 ter et 20) : objectifs tant qu'il ne s'est rien passé, jamais trois zéros.
    WEEK_TITLE_REAL: 'Votre semaine, en vrai',
    WEEK_TITLE_GOALS: 'Votre semaine, objectifs',
    WEEK_SINCE: '7 derniers jours',
    WEEK_SWITCHED: 'Première réservation en ligne reçue : les vrais chiffres remplacent les objectifs.',
    WEEK_BOOKINGS: 'réservations en ligne',
    WEEK_BOOKINGS_GOAL_SUB: 'après le partage à vos clients',
    WEEK_BOOKINGS_REAL_SUB: 'sans un message · objectif {goal}',
    WEEK_OUTSIDE: 'hors de vos horaires',
    WEEK_OUTSIDE_GOAL_SUB: 'prise le soir ou le dimanche, sans vous',
    WEEK_OUTSIDE_REAL_SUB: 'pendant que vous n’y étiez pas',
    WEEK_TIME: 'de téléphone en moins',
    WEEK_TIME_GOAL_SUB: 'rappels compris',
    WEEK_TIME_REAL_SUB: 'confirmations et rappels partis seuls',
    WEEK_TIME_MINUTES: '{minutes} min',
    WEEK_TIME_HOURS: '{hours} h{minutes, plural, =0 {} other { #}}',
    WEEK_GOALS_FOOT:
      'Des objectifs atteignables la première semaine. Dès votre première réservation, les vrais chiffres les remplacent.',
    // Dock « priorité du jour » (mode libre, écran 24)
    DOCK_KICKER: 'Votre priorité du jour · {order} / {total}',
    DOCK_PILL: 'Priorité du jour · {order} / {total}',
    DOCK_HERE: 'Vous regardez « {page} » : c’est la priorité {order} sur {total}.',
    DOCK_CTA: 'Faire ma priorité du jour',
    DOCK_LATER: 'Plus tard, je continue à regarder',
    // Carte « bravo » du dock : la priorité affichée vient d'être faite (rafraîchi après chaque écriture).
    DOCK_DONE_TITLE: 'Bravo, c’est fait !',
    DOCK_DONE_LINE: '{label} · {done} / {total}',
    DOCK_DONE_NEXT: 'Et maintenant : {label}',
    DOCK_DONE_ALL: 'Tout est en place. Votre espace tourne sans vous.',
    DEFERRED_LINE:
      '{count, plural, one {# chose ignorée pendant le parcours} other {# choses ignorées pendant le parcours}}',
    DEFERRED_ABOUT: 'Votre présentation',
    DEFERRED_SHARE_LINK: 'Partager votre lien de réservation',
    DEFERRED_WEBSITE_STYLE: 'Personnaliser votre site',
    DEFERRED_FICHE_GOOGLE: 'Créer et relier votre fiche Google',
    DEFERRED_STRIPE: 'Ouvrir votre compte de paiement',
    DEFERRED_LOGO_PHOTOS: 'Votre logo et vos photos',
    SIDEBAR_BLOCK: 'Et maintenant',
    SIDEBAR_COUNT: '{done} / {total}',
  },
  PROFESSIONAL_APP_ONBOARDING_PAGE: {
    WELCOME_TITLE: `Bienvenue sur ${PROJECT_CONFIG.brand_string} !`,
    BETA_BADGE: 'Bêta',
    CONFIGURATION_TITLE: 'Configuration',
    CONFIGURATION_PROGRESS: '{current}/{max} étapes complétées',
    PLACES_TITLE: 'Ajouter vos lieux de rendez-vous',
    PLACES_DESCRIPTION: 'Renseignez les adresses où vous recevez vos clients',
    PRESTATIONS_TITLE: 'Ajouter vos prestations au catalogue',
    PRESTATIONS_DESCRIPTION: 'Créez votre catalogue de services avec durées et tarifs',
    ADD_BUTTON: 'Ajouter',
    VIEW_BUTTON: 'Voir',
    FEATURES_TITLE: 'Essayer ces fonctionnalités',
  },
  PROFESSIONAL_APP_ONBOARDING_WIZARD: {
    DATA_CONSENT_TITLE: 'Gagnez du temps : on remplit votre profil pour vous',
    DATA_CONSENT_SUBTITLE:
      'Avec votre accord, nous utilisons les infos publiques de votre activité (site, fiche Google, plateformes de réservation…) pour préremplir votre profil. Vous pourrez tout modifier ensuite.',
    DATA_CONSENT_PRIVACY:
      'Nous ne récupérons que des données publiques de votre activité, à votre demande. <privacy>Politique de confidentialité</privacy>.',
    DATA_CONSENT_OPTIONAL_HINT: 'Optionnel : pour une détection plus précise, ajoutez votre site ou des photos :',
    DATA_CONSENT_URL_LABEL: 'Lien de votre site ou de votre fiche en ligne',
    DATA_CONSENT_URL_PLACEHOLDER: 'https://…',
    DATA_CONSENT_PHOTOS_LABEL: 'Photos (carte de visite, flyer, capture d’écran…)',
    DATA_CONSENT_PHOTOS_PLACEHOLDER: 'Ajouter des images',
    DATA_CONSENT_ACCEPT: 'Oui, récupérez mes infos',
    DATA_CONSENT_DECLINE: 'Non, je remplis moi-même',
    ENTRY_TITLE: `Bienvenue chez ${PROJECT_CONFIG.brand_string} 👋`,
    ENTRY_SUBTITLE: "Avant de construire votre site, dites-nous ce qui compte le plus pour vous aujourd'hui.",
    INTENTION_RESERVATION_TITLE: '📅 Avoir un agenda de réservation',
    INTENTION_RESERVATION_DESC:
      'Mes clients réservent en ligne, je gère mon planning sans Excel ni téléphone qui sonne.',
    INTENTION_SITE_VISIBILITE_TITLE: '🌐 Avoir un site avec référencement optimisé',
    INTENTION_SITE_VISIBILITE_DESC:
      'Être visible sur Google et accueillir mes clients sur une vitrine professionnelle (avec réservation incluse).',
    INTENTION_LES_DEUX_TITLE: '⚖️ Les deux comptent autant',
    INTENTION_LES_DEUX_DESC: 'Un site qui me rend visible et qui permet la réservation directe.',
    CONTINUE: 'Continuer',
    BACK: '← Retour',
    STEP_LABEL: 'Étape {order} · {name}',
    STEP_IDENTITY: 'Identité',
    STEP_TEAM: 'Équipe',
    STEP_PRESTATIONS: 'Prestations',
    STEP_BOOKING: 'Réservation',
    FIELD_REQUIRED: 'requis',
    SKIP_ONBOARDING: 'Passer pour l’instant',
    MISSING_TO_CONTINUE: 'Pour continuer, complétez : {fields}.',
    TEAM_TITLE: 'Vous travaillez seul·e ou en équipe ?',
    TEAM_SUBTITLE: 'Ça nous aide à configurer le bon planning de réservation.',
    TEAM_SOLO_TITLE: '👤 Je travaille seul·e',
    TEAM_SOLO_DESC: 'Un seul planning, mes RDV à moi.',
    TEAM_GROUP_TITLE: '👥 Je suis en équipe',
    TEAM_GROUP_DESC: 'Plusieurs personnes prennent des RDV.',
    TEAM_SIZE_LABEL: 'Vous êtes combien ?',
    TEAM_SIZE_HELPER: 'Vous pourrez ajouter les membres un à un depuis votre tableau de bord.',
    TEAM_YOUR_NAME_LABEL: 'Votre nom',
    TEAM_YOUR_NAME_HELPER: 'Il apparaît sur vos rendez-vous et votre fiche en ligne.',
    TEAM_YOUR_NAME_REQUIRED: 'Indiquez au moins votre prénom pour continuer.',
    TEAM_MEMBERS_LABEL: 'Qui compose votre équipe ?',
    TEAM_MEMBERS_HELPER:
      'Ajoutez les personnes qui prennent des RDV. Vous pourrez compléter chaque profil (photo, agenda, accès) depuis votre tableau de bord.',
    TEAM_MEMBER_FIRSTNAME_PLACEHOLDER: 'Prénom',
    TEAM_MEMBER_LASTNAME_PLACEHOLDER: 'Nom (optionnel)',
    TEAM_ADD_MEMBER: 'Ajouter une personne',
    TEAM_MEMBER_REQUIRED: 'Ajoutez au moins une personne avec un prénom.',
    TEAM_INFO:
      "On crée pour l'instant un agenda partagé. Vous pourrez ensuite paramétrer un agenda par membre depuis votre tableau de bord.",
    IDENTITY_CORE_TITLE: 'Votre identité',
    IDENTITY_CORE_SUBTITLE: 'Vérifiez vos infos et indiquez vos activités : on a pré-rempli ce qu’on a pu.',
    IDENTITY_LOGO_LABEL: 'Logo (optionnel)',
    IDENTITY_LOGO_PLACEHOLDER: 'Ajouter votre logo',
    IDENTITY_NAME_LABEL: 'Nom commercial',
    IDENTITY_NAME_PLACEHOLDER: 'Ex : Institut Élise',
    IDENTITY_ACTIVITIES_LABEL: 'Vos activités',
    IDENTITY_ACTIVITIES_HELP: 'Choisissez entre 1 et 5 activités. La première est votre activité principale.',
    IDENTITY_SMART_RIDE_LABEL: 'Calculateur de courses',
    IDENTITY_SMART_RIDE_HELP:
      'Activez le calcul d’itinéraire et la tarification au kilomètre. Désactivez-le si vous proposez uniquement des trajets ou forfaits fixes.',
    IDENTITY_CITY_LABEL: 'Ville principale',
    IDENTITY_CITY_PLACEHOLDER: 'Ex : Lyon 6e',
    IDENTITY_PHONE_LABEL: 'Téléphone pro',
    IDENTITY_PHONE_PLACEHOLDER: '06 12 34 56 78',
    IDENTITY_PHONE_INVALID: 'Format attendu : indicatif international, ex. +33 6 12 34 56 78.',
    IDENTITY_PRESENCE_TITLE: 'Vous avez déjà une présence en ligne ?',
    IDENTITY_PRESENCE_SUBTITLE:
      "Donnez-nous ce que vous avez, on s'en sert pour préparer votre site sans que vous ayez à tout ressaisir.",
    IDENTITY_WEBSITE_LABEL: 'Mon site actuel',
    IDENTITY_GMB_LABEL: 'Ma fiche Google My Business',
    IDENTITY_INSTAGRAM_LABEL: 'Mon Instagram',
    IDENTITY_OTHER_LABEL: 'Un autre lien',
    IDENTITY_PRESENCE_INFO:
      'On analyse ces liens pendant les prochaines étapes pour récupérer vos prestations, photos et infos automatiquement.',
    DETECTION_SCANNING_TITLE: 'On prépare tout pour vous…',
    DETECTION_SCANNING_SUBTITLE:
      'On recherche votre établissement en ligne pour récupérer vos prestations, photos et horaires. Pas besoin d’attendre : continuez, on pré-remplit la suite dès que c’est prêt.',
    DETECTION_SCANNING_WAIT: 'Analyse en cours…',
    DETECTION_SCANNING_CONTINUE: 'Continuer sans attendre',
    DETECTION_NO_MATCH_TITLE: 'Construisons votre espace ensemble',
    DETECTION_NO_MATCH_SUBTITLE:
      "On n'a pas trouvé d'informations publiques sur votre activité. Pas d'inquiétude : vous allez renseigner votre profil au fil des prochaines étapes.",
    DETECTION_SCAN_MSG_1: 'Je parcours votre lien…',
    DETECTION_SCAN_MSG_2: 'Je repère vos prestations et vos horaires…',
    DETECTION_SCAN_MSG_3: 'Je lis vos images…',
    DETECTION_SCAN_MSG_4: 'Je prépare votre espace…',
    DETECTION_FOUND_TITLE: 'On a trouvé {name} !',
    DETECTION_FOUND_SUBTITLE:
      'Voici ce qu’on a trouvé pour préparer votre espace. Vous ajusterez chaque élément aux étapes suivantes.',
    DETECTION_ADDRESS_LABEL: 'Adresse trouvée',
    DETECTION_REVIEWS_COUNT: '{count} avis',
    DETECTION_PRESTATIONS_LABEL: '{count} prestations détectées',
    DETECTION_HOURS_LABEL: 'Horaires détectés',
    DETECTION_HOURS_HELP: 'On pré-remplit vos jours d’ouverture, modifiables à l’étape Réservation.',
    DETECTION_PHOTOS_LABEL: '{count} photos récupérées',
    DETECTION_WEBSITE_LABEL: 'Site web trouvé',
    PRESTATIONS_TITLE: 'Vos prestations',
    PRESTATIONS_SUBTITLE:
      "Listez vos prestations principales. Vous pourrez en ajouter d'autres et compléter les détails (durée, prix, photos) après.",
    PRESTATIONS_DETECTED_SUBTITLE:
      'On a récupéré ces prestations en ligne et les a ajoutées à votre catalogue. Vous pourrez tout affiner (nom, durée, prix, photos) depuis votre tableau de bord.',
    PRESTATIONS_DEFAULTS_SUBTITLE:
      'Voici des prestations typiques de votre métier pour démarrer. Personnalisez-les, supprimez celles qui ne vous correspondent pas, ou ajoutez les vôtres. Tout reste modifiable ensuite.',
    PRESTATIONS_VARIANTS_COUNT: '{count, plural, one {# formule} other {# formules}}',
    PRESTATIONS_NAME_LABEL: 'Nom de la prestation',
    PRESTATIONS_NAME_PLACEHOLDER: 'Ex : Coupe femme',
    PRESTATIONS_NAME_HELPER: "Vous pourrez ajouter d'autres prestations et compléter les détails après.",
    PRESTATIONS_TREE_CATEGORY_ROOT: 'Mes prestations',
    PRESTATIONS_CATEGORY_LABEL: 'Nom de la catégorie',
    PRESTATIONS_CATEGORY_PLACEHOLDER: 'Ex : Coiffure',
    PRESTATIONS_CATEGORY_REMOVE: 'Retirer cette catégorie',
    PRESTATIONS_ADD_CATEGORY: 'Ajouter une catégorie',
    PRESTATIONS_LEAF_HINT:
      'Une prestation est un service précis (ex : Coupe femme). Regroupez-les dans des catégories (ex : Coiffure).',
    PRESTATIONS_ADD_ANOTHER: 'Ajouter une prestation',
    PRESTATIONS_REMOVE: 'Retirer cette prestation',
    PRESTATIONS_EDIT: 'Modifier',
    PRESTATIONS_SELECT_AT_LEAST_ONE: 'Sélectionnez au moins une prestation pour continuer.',
    PRESTATIONS_NAME_REQUIRED_HINT: 'Saisissez le nom d’au moins une prestation (3 caractères minimum).',
    PRESTATIONS_INFO:
      'Pas besoin de tarif ni de durée maintenant. Une durée standard sera appliquée pour votre métier, et vous pourrez tout ajuster depuis votre tableau de bord.',
    BOOKING_LOC_TITLE: 'Où se passent vos RDV ?',
    BOOKING_LOC_SUBTITLE: "Cochez tout ce qui s'applique. Vos clients verront ces options sur votre site.",
    BOOKING_LOC_ONSITE_TITLE: '🏪 Sur place',
    BOOKING_LOC_ONSITE_DESC: 'Mon cabinet, mon institut, ma boutique…',
    BOOKING_LOC_HOME_TITLE: '🚗 En déplacement',
    BOOKING_LOC_HOME_DESC: 'Je me déplace chez le client (domicile, entreprise, etc.)',
    BOOKING_LOC_VIDEO_TITLE: '💻 En visio',
    BOOKING_LOC_VIDEO_DESC: 'Rendez-vous à distance par visioconférence',
    BOOKING_LOC_PHONE_TITLE: '📞 Par téléphone',
    BOOKING_LOC_PHONE_DESC: 'Consultations téléphoniques',
    BOOKING_LOC_REQUIRED: 'Sélectionnez au moins une modalité de rendez-vous.',
    BOOKING_HOURS_TITLE: "Vos horaires d'ouverture",
    BOOKING_HOURS_SUBTITLE: 'On a pré-rempli un planning type pour votre métier. Ajustez si besoin.',
    BOOKING_HOURS_VALIDATE_SUBTITLE: 'Voici les horaires qu’on a trouvés. Validez ou modifiez-les.',
    BOOKING_HOURS_EDIT: 'Modifier',
    BOOKING_HOURS_CLOSED: 'Fermé',
    BOOKING_HOURS_START: 'Ouverture',
    BOOKING_HOURS_END: 'Fermeture',
    BOOKING_HOURS_ADD_BREAK: 'Ajouter une coupure',
    BOOKING_HOURS_REMOVE_RANGE: 'Supprimer cette plage',
    BOOKING_GENERATE: 'Générer mon site →',
    DAY_MON: 'Lundi',
    DAY_TUE: 'Mardi',
    DAY_WED: 'Mercredi',
    DAY_THU: 'Jeudi',
    DAY_FRI: 'Vendredi',
    DAY_SAT: 'Samedi',
    DAY_SUN: 'Dimanche',
    PHOTOS_TITLE: 'Vos photos',
    PHOTOS_SUBTITLE:
      'On a récupéré ces photos en ligne. Retirez celles que vous ne voulez pas afficher sur votre site.',
    PHOTOS_REMOVE: 'Retirer cette photo',
    PHOTOS_GENERATE: 'Générer mon site →',
    GENERATION_TITLE: 'Nous préparons votre site…',
    // Variante « réservation uniquement » (intention RESERVATION) : l'écran de fin parle
    // d'agenda (DONE_BOOKING_TITLE), donc la génération doit être cohérente — pas « site ».
    GENERATION_BOOKING_TITLE: 'Nous préparons votre agenda…',
    GENERATION_SUBTITLE: 'Quelques secondes…',
    DONE_TITLE: 'Votre site est prêt !',
    DONE_SUBTITLE: 'Découvrez-le. Vous pourrez le peaufiner et le publier quand vous vous sentirez prêt·e.',
    DONE_PREVIEW_OPEN: 'Cliquez pour voir et personnaliser votre site',
    DONE_PREVIEW_FALLBACK: 'Votre site',
    DONE_BANNER_TITLE: '🟡 Site en attente de publication',
    DONE_BANNER_TEXT:
      "Votre site n'est pas encore visible sur Google. Vous pourrez le publier depuis votre tableau de bord, quand vous serez prêt·e.",
    DONE_DASHBOARD_BUTTON: 'Aller à mon tableau de bord',
    DONE_VIEW_SITE_BUTTON: 'Voir et personnaliser mon site',
    DONE_RECAP_TITLE: 'Ce qu’on a préparé pour vous',
    DONE_RECAP_PRESTATIONS: '{count} prestation(s) ajoutée(s)',
    DONE_RECAP_PHOTOS: '{count} photo(s) récupérée(s)',
    DONE_RECAP_HOURS: 'Horaires d’ouverture pré-remplis',
    DONE_NEXT_TITLE: 'Pour aller plus loin',
    DONE_NEXT_COMPLETE_PRESTATIONS: 'Compléter mes prestations (photos, prix, durées)',
    // Variante « réservation uniquement » (intention RESERVATION) : on a quand
    // même généré le site, mais la fin d'onboarding renvoie vers l'agenda.
    DONE_BOOKING_TITLE: 'Votre agenda est prêt !',
    DONE_BOOKING_SUBTITLE: 'Configurez vos disponibilités et commencez à recevoir des réservations.',
    DONE_BOOKING_CARD_TITLE: 'Mon agenda de réservation',
    DONE_BOOKING_CARD_OPEN: 'Cliquez pour gérer vos disponibilités et vos rendez-vous',
    DONE_VIEW_AGENDA_BUTTON: 'Configurer mon agenda',
    DONE_BOOKING_SITE_LINK: 'Un site a aussi été préparé pour vous : y jeter un œil',
    // Valeurs par défaut écrites en base par le wizard 4.B (`upsertOpeningHours`).
    // Affichées dans les listings agenda / lieux / sélecteurs — JAMAIS de string
    // hardcodée côté backend, même pour des « placeholders » techniques.
    DEFAULT_PLACE_LABEL: 'Mon établissement',
    DEFAULT_PLACE_LABEL_TRAVELING: 'En déplacement',
    DEFAULT_PLACE_LABEL_PHONE: 'Par téléphone',
    DEFAULT_PLACE_LABEL_VIDEO: 'En visio',
    DEFAULT_AVAILABILITY_NAME: "Horaires d'ouverture",
    // Dispo posée par la migration v1 pour les pros VTC (formules Course ouvertes 24h/24).
    DEFAULT_RIDE_AVAILABILITY_NAME: 'Courses (24h/24)',
    // Migration v1 (VTC) : véhicule sans nom / forfait de zone. `{index}` et `{vehicle}` sont
    // interpolés côté backend (ride.mapper.ts), pas d'ICU ici.
    DEFAULT_VEHICLE_NAME: 'Véhicule {index}',
    DEFAULT_RIDE_ZONE_NAME: 'Forfait {vehicle} n°{index}',
    DEFAULT_TEAM_MEMBER_FIRSTNAME: 'Moi',
    DEFAULT_CATALOG_CATEGORY: 'Prestations',
  },
  MIGRATION_V1_PAGE: {
    TITLE: 'Importer depuis Cfixe v1',
    SUBTITLE:
      'Récupérez votre profil, votre site, votre catalogue, vos clients et vos campagnes depuis votre ancienne app en quelques minutes.',
    LOGIN_TITLE: 'Connectez-vous à votre compte Cfixe v1',
    LOGIN_DESCRIPTION:
      "Pour récupérer vos données, on a besoin de vous connecter à votre ancien compte. Vos identifiants ne sont conservés que le temps de l'import (10 minutes max).",
    LOGIN_EMAIL_LABEL: 'Email Cfixe v1',
    LOGIN_EMAIL_PLACEHOLDER: 'votre.email@exemple.fr',
    LOGIN_PASSWORD_LABEL: 'Mot de passe',
    LOGIN_CTA: 'Se connecter à Cfixe v1',
    LOGIN_FORGOT_PASSWORD_HINT: "Mot de passe oublié ? Réinitialisez-le sur l'ancienne app avant de revenir ici.",
    PREVIEW_TITLE: 'Choisissez ce que vous voulez importer',
    PREVIEW_DESCRIPTION:
      "Profil, catalogue, clients et site web sont importés d'office. Vous pouvez choisir d'ajouter aussi votre abonnement, vos campagnes marketing et votre fiche Google.",
    PREVIEW_ITEMS_IMPORTED: '{count, plural, one {# élément déjà importé} other {# éléments déjà importés}}',
    PREVIEW_REIMPORT_BUTTON: 'Re-importer',
    PREVIEW_START_CTA: "Lancer l'import",
    RUNNING_TITLE: 'Import en cours…',
    DONE_TITLE: 'Import terminé !',
    DONE_FINISH_CTA: 'Terminer et retourner au tableau de bord',
    BLOCK_PROFILE_LABEL: 'Profil',
    BLOCK_PROFILE_DESCRIPTION: 'Identité, adresse, logo, photos, équipe',
    BLOCK_WEBSITE_LABEL: 'Site web',
    BLOCK_WEBSITE_DESCRIPTION: 'Pages, thème et contenus (importés en brouillon)',
    BLOCK_CATALOG_LABEL: 'Catalogue',
    BLOCK_CATALOG_DESCRIPTION: 'Catégories, prestations, prix, lieux, paramètres de réservation',
    BLOCK_CUSTOMERS_LABEL: 'Clients & tags',
    BLOCK_CUSTOMERS_DESCRIPTION: 'Fiches clients et étiquettes',
    BLOCK_APPOINTMENTS_LABEL: 'Historique des rendez-vous',
    BLOCK_APPOINTMENTS_DESCRIPTION:
      'RDV passés et futurs (les disponibilités ne sont pas migrées, à reconfigurer côté agenda)',
    BLOCK_GIFT_CARDS_PAYMENTS_LABEL: 'Cartes cadeau & paiements clients',
    BLOCK_GIFT_CARDS_PAYMENTS_DESCRIPTION:
      'Bons cadeaux, leurs utilisations et l’historique des paiements clients (l’abonnement est migré séparément par notre équipe)',
    BLOCK_MARKETING_LABEL: 'Marketing',
    BLOCK_MARKETING_DESCRIPTION: 'Campagnes email, SMS et actualités',
    BLOCK_GMB_LABEL: 'Google My Business',
    BLOCK_GMB_DESCRIPTION: 'Synchronisation de votre fiche Google (mise en pause après import)',
    STATUS_QUEUED: 'En attente',
    STATUS_RUNNING: 'En cours…',
    STATUS_DONE: 'Terminé',
    STATUS_ERROR: 'Erreur',
    STATUS_SKIPPED: 'Non sélectionné',
    STATUS_IMPORTED_COUNT: '{count, plural, one {# élément} other {# éléments}}',
    MESSAGE_WEBSITE_IMPORTED_AS_DRAFT:
      'Votre site est importé en brouillon : relisez-le et publiez-le quand vous voulez depuis « Mon site ».',
    MESSAGE_GMB_IMPORTED_AS_STOPPED:
      'Votre fiche Google est importée mais la synchro est en pause. Notre équipe va la réactiver après vérification.',
    MESSAGE_GMB_REFRESH_TOKEN_MISSING:
      "On n'a pas pu récupérer votre autorisation Google : vous pourrez reconnecter votre fiche depuis « Intégrations ».",
    MESSAGE_BLOCK_NOT_IMPLEMENTED: 'Bloc non disponible sur cet environnement.',
  },
  ACTIVITY_PICKER: {
    HEADER_RECOMMENDED: 'Recommandé pour vous',
    HEADER_CATEGORIES: 'Catégories',
    SEARCH_PLACEHOLDER: 'Rechercher une activité…',
    SEARCH_CLEAR: 'Effacer la recherche',
    SEARCH_NO_RESULT: 'Aucune activité ne correspond.',
    SELECTED_HINT: '1 à 3 recommandé, {max} max',
    EMPTY_SELECTION: 'Ajoutez votre première activité',
    EMPTY_SELECTION_HINT: 'Touchez une suggestion ci-dessous ou recherchez votre métier pour l’ajouter.',
    BUTTON_ADD: 'Ajouter',
    BUTTON_REMOVE: 'Retirer',
    BUTTON_EXPLORE: 'Explorer les activités',
    BUTTON_HIDE_EXPLORE: 'Masquer les activités',
    BUTTON_EDIT_LABEL: 'Personnaliser le libellé',
    BUTTON_RESET_LABEL: 'Revenir au libellé officiel',
    CUSTOM_LABEL_HELP: 'Affichez votre métier comme vous voulez que vos clients le voient.',
    OFFICIAL_LABEL_PREFIX: 'Libellé officiel',
    PRIMARY_BADGE: 'Principale',
    MAX_REACHED_TOOLTIP: "Maximum {max} activités. Retirez-en une avant d'en ajouter une autre.",
    LOAD_ERROR: "Impossible de charger le catalogue d'activités. Réessayez dans un instant.",
  },
  PROFESSIONAL_APP_ONBOARDING_SCORE: {
    TITLE: 'Configurez votre compte',
    SUBTITLE: 'Votre score progresse au fil de ce que vous configurez.',
    GLOBAL_SCORE_LABEL: 'Progression',
    STATE_PREVIEW: 'Aperçu',
    STATE_ONLINE: 'En ligne',
    STATE_OPTIMIZED: 'Optimisé',
    // États de progression par famille — vocabulaire neutre (≠ publication site).
    FAMILY_PROGRESS_TODO: 'À démarrer',
    FAMILY_PROGRESS_IN_PROGRESS: 'En cours',
    FAMILY_PROGRESS_DONE: 'Complété',
    FAMILY_DRILL_CTA: 'Voir le détail',
    WIZARD_RESUME_CTA: "Reprendre l'onboarding",
    NO_ACTIONS_LEFT: 'Tout est configuré dans cette catégorie. ✨',
    DETAIL_SUBRUBRIQUES_TITLE: 'Catégories',
    DETAIL_ACTIONS_TITLE: 'À configurer',
    DETAIL_CLOSE: 'Fermer',
    ACTION_OPEN: 'Configurer',
    ACTION_OPT_OUT: 'Je ne veux pas proposer',
    BADGE_DONE: 'Fait',
    BADGE_OPTED_OUT: 'Désactivé',
    CRITICALITY_BLOCKING_HARD: 'Essentiel',
    CRITICALITY_BLOCKING_DEFAULT: 'Recommandé',
    CRITICALITY_DEFERRED: 'Optionnel',
    NUDGE_HINT: 'Prochaine étape recommandée',
    NUDGE_DISMISS: 'Masquer',
    // Toujours libellé : un « +25 % » nu se lit comme un gain d'argent (cf. relances d'essai).
    NUDGE_IMPACT: '+{impact} % de progression',
    PUBLICATION_BANNER_TITLE: 'Votre site est prêt à être publié',
    PUBLICATION_BANNER_TEXT:
      'Publiez-le pour le rendre visible sur Google et les annuaires. Vous pourrez toujours le modifier après.',
    PUBLICATION_BANNER_CTA: 'Publier mon site',
    PUBLICATION_MODAL_TITLE: 'Publier votre site',
    PUBLICATION_MODAL_READY_TITLE: "Votre site est prêt, c'est parti ! 🚀",
    PUBLICATION_MODAL_READY_TEXT:
      "Score global {score} %. Tout l'essentiel est configuré. Une fois publié, votre site sera référencé sur Google et accessible depuis votre domaine.",
    PUBLICATION_MODAL_PARTIAL_TITLE: 'Vous pouvez publier dès maintenant',
    PUBLICATION_MODAL_PARTIAL_TEXT:
      "Score global {score} %. Quelques éléments restent optionnels : vous pouvez les compléter après publication, ils n'empêchent pas la mise en ligne.",
    PUBLICATION_MODAL_CONFIRM: 'Publier',
    PUBLICATION_MODAL_CANCEL: 'Plus tard',
    PUBLICATION_MODAL_SUCCESS: 'Votre site est en ligne. 🎉',
    // ─── Bandeau « site en ligne » (après publication) ───────────────────────
    ONLINE_BANNER_TITLE: 'Site en ligne',
    ONLINE_BANNER_VIEW: 'Voir mon site',
    ONLINE_BANNER_COPY: 'Copier le lien',
    ONLINE_BANNER_SHARE: 'Partager',
    ONLINE_BANNER_COPIED: 'Lien copié ✓',
    // ─── État optimisé (tout configuré → composant minimisé) ─────────────────
    OPTIMIZED_MINIMIZED_TITLE: 'Configuration optimisée · 100 %',
    OPTIMIZED_SHOW_DETAIL: 'Voir le détail',
    OPTIMIZED_HIDE_DETAIL: 'Masquer le détail',
    // ─── Familles ────────────────────────────────────────────────────────────
    ONBOARDING_FAMILY_COMPANY: 'Mon entreprise',
    ONBOARDING_FAMILY_CATALOG: 'Mon catalogue',
    ONBOARDING_FAMILY_AGENDA: 'Mon agenda',
    ONBOARDING_FAMILY_PAYMENTS: 'Paiements',
    ONBOARDING_FAMILY_WEBSITE: 'Mon site',
    ONBOARDING_FAMILY_CUSTOMERS: 'Mes clients',
    ONBOARDING_FAMILY_COMMUNICATION: 'Communication',
    ONBOARDING_FAMILY_INTEGRATIONS: 'Intégrations',
    // ─── Sous-rubriques ──────────────────────────────────────────────────────
    ONBOARDING_SUBRUBRIQUE_AGENDA_GOOGLE_SYNC: 'Sync Google Calendar',
    ONBOARDING_SUBRUBRIQUE_AGENDA_HOURS: "Horaires d'ouverture",
    ONBOARDING_SUBRUBRIQUE_AGENDA_SETTINGS: 'Paramètres',
    ONBOARDING_SUBRUBRIQUE_AGENDA_WORKSHOPS: 'Ateliers',
    ONBOARDING_SUBRUBRIQUE_CATALOG_GIFT_CARDS: 'Cartes cadeaux',
    ONBOARDING_SUBRUBRIQUE_CATALOG_PACKS: 'Packs / formules',
    ONBOARDING_SUBRUBRIQUE_CATALOG_PRESTATIONS: 'Prestations',
    ONBOARDING_SUBRUBRIQUE_COMMUNICATION_INVITATIONS: 'Invitations clients',
    ONBOARDING_SUBRUBRIQUE_COMMUNICATION_AUTOMATIC_MESSAGES: 'Messages automatiques',
    ONBOARDING_SUBRUBRIQUE_COMPANY_EQUIPMENT: 'Équipement',
    ONBOARDING_SUBRUBRIQUE_COMPANY_MEDIA: 'Médias',
    ONBOARDING_SUBRUBRIQUE_COMPANY_PLACES: 'Lieux',
    ONBOARDING_SUBRUBRIQUE_COMPANY_PROFILE: 'Profil',
    ONBOARDING_SUBRUBRIQUE_COMPANY_SETTINGS: 'Paramètres',
    ONBOARDING_SUBRUBRIQUE_COMPANY_TEAM: 'Équipe',
    ONBOARDING_SUBRUBRIQUE_CUSTOMERS_BASE: 'Base clients',
    ONBOARDING_SUBRUBRIQUE_CUSTOMERS_TAGS: 'Tags',
    ONBOARDING_SUBRUBRIQUE_INTEGRATIONS_WIDGETS: 'Widgets',
    ONBOARDING_SUBRUBRIQUE_PAYMENTS_CONDITIONS: 'Conditions',
    ONBOARDING_SUBRUBRIQUE_PAYMENTS_STRIPE_ACCOUNT: 'Compte Stripe',
    ONBOARDING_SUBRUBRIQUE_WEBSITE_CUSTOMIZE: 'Personnalisation',
    ONBOARDING_SUBRUBRIQUE_WEBSITE_DOMAIN: 'Nom de domaine',
    ONBOARDING_SUBRUBRIQUE_WEBSITE_PUBLISH: 'Publication',
    // ─── Tâches ──────────────────────────────────────────────────────────────
    ONBOARDING_TASK_AGENDA_GOOGLE_SYNC_CONNECT: 'Connecter Google Calendar',
    ONBOARDING_TASK_AGENDA_HOURS_OPENING_HOURS: 'Confirmer vos horaires',
    ONBOARDING_TASK_AGENDA_HOURS_TEAM_AVAILABILITY: 'Configurer les dispos par membre',
    ONBOARDING_TASK_AGENDA_SETTINGS_REVIEW: 'Vérifier les paramètres',
    ONBOARDING_TASK_AGENDA_WORKSHOPS_SETUP: 'Configurer les ateliers',
    ONBOARDING_TASK_CATALOG_GIFT_CARDS_SETUP: 'Activer les cartes cadeaux',
    ONBOARDING_TASK_CATALOG_PACKS_CREATE: 'Créer vos packs',
    ONBOARDING_TASK_CATALOG_PRESTATIONS_COMPLETE: 'Compléter les prestations',
    ONBOARDING_TASK_CATALOG_PRESTATIONS_CREATE: 'Créer une prestation',
    ONBOARDING_TASK_CATALOG_PRESTATIONS_REAL_PHOTOS: 'Ajouter des photos réelles',
    ONBOARDING_TASK_CATALOG_PRESTATIONS_SEO_DESCRIPTIONS: 'Écrire des descriptions SEO',
    ONBOARDING_TASK_COMMUNICATION_INVITE_CLIENTS: 'Inviter vos clients',
    ONBOARDING_TASK_COMPANY_EQUIPMENT_ADD: "Ajouter de l'équipement",
    ONBOARDING_TASK_COMPANY_MEDIA_LOGO: 'Ajouter votre logo',
    ONBOARDING_TASK_COMPANY_MEDIA_PHOTOS: 'Ajouter des photos',
    ONBOARDING_TASK_COMPANY_PLACES_DETAILS: 'Préciser vos lieux',
    ONBOARDING_TASK_COMPANY_PLACES_LOCATION_TYPES: 'Définir vos lieux de RDV',
    ONBOARDING_TASK_COMPANY_PROFILE_BUSINESS_NAME: 'Renseigner votre nom commercial',
    ONBOARDING_TASK_COMPANY_PROFILE_CITY: 'Indiquer votre ville',
    ONBOARDING_TASK_COMPANY_PROFILE_COMPLETE: 'Compléter votre profil',
    ONBOARDING_TASK_COMPANY_PROFILE_GMB: 'Lien Google My Business',
    ONBOARDING_TASK_COMPANY_PROFILE_INSTAGRAM: 'Lien Instagram',
    ONBOARDING_TASK_COMPANY_PROFILE_ACTIVITIES: 'Choisir vos activités',
    ONBOARDING_TASK_COMPANY_PROFILE_OTHER_LINK: 'Autre lien',
    ONBOARDING_TASK_COMPANY_PROFILE_PHONE: 'Ajouter votre téléphone',
    ONBOARDING_TASK_COMPANY_PROFILE_SCOPE: 'Périmètre géographique',
    ONBOARDING_TASK_COMPANY_PROFILE_SERVICE_AREAS: 'Indiquer vos villes',
    ONBOARDING_TASK_COMPANY_PROFILE_WEBSITE_URL: 'Site actuel',
    ONBOARDING_TASK_COMPANY_SETTINGS_LEGAL: 'Compléter vos infos légales',
    ONBOARDING_TASK_COMPANY_TEAM_MEMBER_PROFILES: "Compléter les profils de l'équipe",
    ONBOARDING_TASK_COMPANY_TEAM_STRUCTURE: "Structurer l'équipe",
    ONBOARDING_TASK_CUSTOMERS_BASE_IMPORT: 'Importer votre base clients',
    ONBOARDING_TASK_CUSTOMERS_TAGS_ORGANIZE: 'Organiser par tags',
    ONBOARDING_TASK_ENTRY_INTENTION: 'Choisir votre intention',
    ONBOARDING_TASK_INTEGRATIONS_BOOKING_WIDGET: 'Widget de réservation',
    ONBOARDING_TASK_INTEGRATIONS_GIFT_CARD_WIDGET: 'Widget cartes cadeaux',
    ONBOARDING_TASK_INTEGRATIONS_REVIEWS_WIDGET: 'Widget avis',
    ONBOARDING_TASK_PAYMENTS_CONDITIONS_CONFIGURE: 'Configurer vos conditions de paiement',
    ONBOARDING_TASK_PAYMENTS_STRIPE_CREATE_ACCOUNT: 'Créer un compte Stripe',
    ONBOARDING_TASK_WEBSITE_CUSTOM_DOMAIN: 'Domaine personnalisé',
    ONBOARDING_TASK_WEBSITE_CUSTOMIZE: 'Personnaliser le site',
    ONBOARDING_TASK_WEBSITE_PUBLISH: 'Publier le site',
    // ─── Tâches du tunnel obligatoire (parcours V2) ──────────────────────────
    ONBOARDING_TASK_COMMUNICATION_AUTOMATIC_MESSAGES: 'Confirmation automatique et rappel 24 h',
    ONBOARDING_TASK_COMMUNICATION_SHARE_LINK: 'Partager votre lien de réservation',
    ONBOARDING_TASK_COMPANY_PROFILE_GMB_PUSH_DONE: 'Synchroniser votre fiche Google',
    ONBOARDING_TASK_PAYMENTS_CONDITIONS_RULE: 'Choisir votre règle de paiement',
    // ─── Étapes du tunnel obligatoire ────────────────────────────────────────
    ONBOARDING_TUNNEL_STEP_OFFER: 'Votre offre',
    ONBOARDING_TUNNEL_STEP_PLACES_HOURS: 'Vos lieux et horaires',
    ONBOARDING_TUNNEL_STEP_SHARE: 'Votre lien de réservation',
    ONBOARDING_TUNNEL_STEP_WEBSITE: 'Personnaliser votre site',
    ONBOARDING_TUNNEL_STEP_SEO: 'Optimiser votre référencement',
    ONBOARDING_TUNNEL_STEP_PAYMENT: 'Sécuriser vos réservations',
    // ─── Accueil « Et maintenant » (après le tunnel) ─────────────────────────
    ONBOARDING_HOME_PRIORITY_SUBSCRIBE: "S'abonner",
    ONBOARDING_HOME_PRIORITY_FIRST_APPOINTMENTS: 'Ajouter vos premiers rendez-vous',
    ONBOARDING_HOME_PRIORITY_BLOG: 'Optimiser votre référencement avec le blog',
    ONBOARDING_HOME_PRIORITY_CALENDAR_SYNC: 'Synchroniser Google Agenda',
    ONBOARDING_HOME_PRIORITY_IMPORT_CUSTOMERS: 'Importer vos clients',
    ONBOARDING_HOME_PRIORITY_CUSTOMIZE_SITE: 'Personnaliser votre site',
    ONBOARDING_HOME_PRIORITY_HOLIDAYS: 'Jours fériés et disponibilités',
    // Pages du menu, sous-titre des lignes « Et maintenant » (écran 18 ter : « Agenda · 3 min »).
    ONBOARDING_HOME_PAGE_SUBSCRIPTION: 'Entreprise › Abonnement',
    ONBOARDING_HOME_PAGE_AGENDA: 'Agenda',
    ONBOARDING_HOME_PAGE_BLOG: 'Communication › Blog',
    ONBOARDING_HOME_PAGE_CALENDAR_SYNC: 'Agenda › Synchronisation',
    ONBOARDING_HOME_PAGE_CUSTOMERS_IMPORT: 'Clients › Import',
    ONBOARDING_HOME_PAGE_WEBSITE: 'Site internet',
    ONBOARDING_HOME_PAGE_AVAILABILITIES: 'Agenda › Disponibilités',
  },
  PROFESSIONAL_APP_CATALOG_PAGE: {
    TITLE: 'Catalogue',
    FILTER_TITLE: 'Catégories',
    // Réservabilité en ligne d'une prestation (P3, § 7.8) : badge de la liste et encart de la fiche.
    ...ProPrestationBookabilityTranslation['fr-FR'],
    BOOKABILITY_ADD_TO_PLANNING: 'Ajouter à un planning',
    BOOKABILITY_SEE_PLANNINGS: 'Voir les plannings',
    BOOKABILITY_NOT_IN_TUNNEL_TITLE: 'Cette prestation n’apparaît pas dans votre tunnel',
    BOOKABILITY_NOT_IN_TUNNEL_NO_PLANNING:
      'Aucun planning ne la couvre : vos clients ne peuvent pas la réserver en ligne.',
    BOOKABILITY_NOT_IN_TUNNEL_NO_MEMBER:
      'Aucun membre de vos plannings ne peut la réaliser : vos clients ne peuvent pas la réserver en ligne.',
    ADD_CATEGORY_BUTTON: 'Ajouter une catégorie',
    EDIT_CATEGORY_BUTTON: 'Modifier la catégorie',
    ADD_PRESTATION_TITLE: 'Ajouter une prestation',
    MANAGE_SUPPLEMENT: 'Gérer les suppléments',
    MANAGE_EQUIPMENT: 'Gérer les équipements',
    SUPPLEMENTS_BUTTON: 'Suppléments',
    EQUIPMENT_BUTTON: 'Matériel',
    EMPTY_STATE_TITLE: 'Ajoutez vos premières prestations',
    EMPTY_STATE_TEXT:
      "Vous n'avez pas encore de prestations. Cliquez sur le bouton ci-dessous pour en ajouter, afin de pouvoir gérer vos rendez-vous et permettre à vos clients de réserver en ligne.",
    DELETE_PRESTATION_TITLE: 'Supprimer la prestation',
    DELETE_PRESTATION_TEXT: 'Êtes-vous sûr de vouloir supprimer cette prestation ?',
    TAB_PRESTATIONS: 'Prestations',
    TAB_PACKS: 'Packs',
    TAB_GIFT_CARDS: 'Cartes cadeaux',
    ALL_CATEGORIES: 'Toutes les catégories',
    ADD_CATEGORY_TITLE: 'Ajouter une catégorie',
    EDIT_CATEGORY: 'Modifier',
    EDIT_CATEGORY_TITLE: 'Modifier la catégorie',
    ADD_PRESTATION_TO_CATEGORY: 'Ajouter une prestation',
    EMPTY_CATEGORY_TEXT: 'Aucune prestation dans cette catégorie pour le moment.',
    DELETE_CATEGORY: 'Supprimer',
    DELETE_CATEGORY_TITLE: 'Supprimer la catégorie',
    DELETE_CATEGORY_TEXT:
      'Êtes-vous sûr de vouloir supprimer cette catégorie ? Elle ne doit contenir aucune prestation.',
    CANCEL_DELAY_HINT: 'Dans votre cas {hours}h',
    CANCEL_DELAY_HINT_CLICK: 'Cliquer pour modifier',
    ADD_PACK_TITLE: 'Nouveau Pack',
    EDIT_PACK_TITLE: 'Pack - Modification',
    DELETE_PACK_TITLE: 'Supprimer le pack',
    DELETE_PACK_TEXT: 'Êtes-vous sûr de vouloir supprimer ce pack ?',
    VOUCHER_IMPACT_WARNING_TITLE: 'Impact sur des bons en cours',
    VOUCHER_IMPACT_WARNING_TEXT:
      '{count} bon(s) encore actif(s) dépendent de cet élément du catalogue. La modification reste autorisée, mais certaines utilisations pourront nécessiter un traitement manuel.',
    VOUCHER_IMPACT_WARNING_CONFIRM: 'Continuer malgré cet impact',
    VOUCHER_IMPACT_WARNING_SEE_VOUCHERS: 'Voir les bons concernés',
    VOUCHER_IMPACT_WARNING_UPDATE_WITH_SYNC: 'Mettre à jour et synchroniser les bons',
    VOUCHER_IMPACT_WARNING_UPDATE_WITHOUT_SYNC: 'Mettre à jour sans les bons',
    VOUCHER_SYNC_TITLE: 'Mettre à jour les bons',
    VOUCHER_SYNC_TEXT:
      'Certains bons ouverts référencent une version antérieure de cet élément. On peut resynchroniser ce qui est sûr (nom, couleur). Les durées vendues qui n’existent plus resteront à traiter manuellement.',
    VOUCHER_SYNC_CONFIRM: 'Resynchroniser',
    VOUCHER_SYNC_LATER: 'Plus tard',
    VOUCHER_SYNC_RESULT: '{synced} bon(s) resynchronisé(s).',
    VOUCHER_SYNC_RESULT_MANUAL: '{manual} bon(s) restent à traiter manuellement.',
    DUPLICATE_PACK: 'Dupliquer le pack',
    PACK_INACTIVE: 'Désactivé',
    EMPTY_STATE_PACK_PROMO_TITLE: 'Vends plus en une seule vente',
    EMPTY_STATE_PACK_PROMO_TEXT:
      "Un pack vous permet de proposer un lot de prestations à tarif avantageux. C'est idéal pour fidéliser, encaisser plus d'un coup et faire revenir vos clients.",
    STRIPE_REQUIRED_TITLE: 'Augmentez vos revenus avec les packs de fidélité',
    STRIPE_REQUIRED_DESCRIPTION:
      'Transformez vos clients en clients fidèles. Activez les packs en quelques clics et commencez à voir les résultats immédiatement.',
    STRIPE_REQUIRED_SOCIAL_PROOF_1:
      "Comme des milliers de commerces, vendez des packs et profitez d'un levier puissant pour fidéliser vos clients et augmenter votre chiffre d'affaires.",
    STRIPE_REQUIRED_WHAT_TITLE: `Pourquoi choisir les packs ${PROJECT_CONFIG.brand_string} ?`,
    STRIPE_REQUIRED_WHAT_ITEM_1: 'Encaissez davantage grâce aux offres groupées',
    STRIPE_REQUIRED_WHAT_ITEM_1_DESC: 'Vos clients achètent plus souvent et en plus grande quantité',
    STRIPE_REQUIRED_WHAT_ITEM_2: 'Des clients qui reviennent plus régulièrement',
    STRIPE_REQUIRED_WHAT_ITEM_2_DESC: 'Récompensez la fidélité avec des offres exclusives',
    STRIPE_REQUIRED_WHAT_ITEM_3: 'Créez des combos à prix attractifs',
    STRIPE_REQUIRED_WHAT_ITEM_3_DESC: 'Augmentez votre panier moyen immédiatement',
    ...STRIPE_REQUIRED_COMMON,
    STRIPE_REQUIRED_STEP_2_TITLE: 'Créer vos packs',
    STRIPE_REQUIRED_STEP_2_DESC: 'Configurez vos offres groupées avec des prix personnalisés.',
    STRIPE_REQUIRED_STEP_3_DESC: 'Vos clients réservent en utilisant leurs packs.',
    STRIPE_REQUIRED_CTA_TITLE: 'Prêt à démarrer ?',
    MEMBER_BUFFER_TITLE: 'Temps de battement par membre',
    MEMBER_BUFFER_SUBTITLE: 'Laissez vide pour utiliser la valeur par défaut.',
    MEMBER_BUFFER_MIN: 'min',
    MEMBER_BUFFER_DEFAULT_LABEL: 'Par défaut : {value} min',
    MEMBER_BUFFER_SUMMARY: '{name}: {value}min',
    SUPPLEMENTS_COUNT: '+{count} options',
    PRICE_LINE_QUOTE_NOT_BOOKABLE_HINT:
      'Cette prestation sera visible sur votre site mais ne sera pas réservable en ligne.',
  },
  PROFESSIONAL_APP_CATALOG_SUPPLEMENT_PAGE: {
    TITLE: 'Suppléments',
    ADD_SUPPLEMENT_TITLE: 'Ajouter un supplément',
    DELETE_SUPPLEMENT_MODAL_TITLE: 'Supprimer le supplément',
    DELETE_SUPPLEMENT_MODAL_TEXT: 'Êtes-vous sûr de vouloir supprimer ce supplément ?',
    VOUCHER_IMPACT_WARNING_TITLE: 'Impact sur des bons en cours',
    VOUCHER_IMPACT_WARNING_TEXT:
      '{count} bon(s) encore actif(s) dépendent de ce supplément. La modification reste autorisée, mais certaines utilisations pourront nécessiter un traitement manuel.',
    VOUCHER_IMPACT_WARNING_CONFIRM: 'Continuer malgré cet impact',
    VOUCHER_IMPACT_WARNING_SEE_VOUCHERS: 'Voir les bons concernés',
  },
  PROFESSIONAL_APP_SYNC_GOOGLE_PAGE: {
    TITLE: 'Google My Business',
    EMPTY_TITLE: 'Aucun compte Google My Business connecté',
    EMPTY_DESCRIPTION: 'Ajoutez un compte Google My Business pour synchroniser vos fiches établissement.',
    EMAIL_VERIFIED: 'Email vérifié',
    EMAIL_NOT_VERIFIED: 'Email non vérifié',
    GOOGLE_PLACE_LINKED: 'Fiche Google',
    LINKED_TO_YOUR_PLACE: 'lié à votre lieu',
    LINKED_TO_YOUR_PLACES: 'lié à vos lieux',
    GOOGLE_LOCATIONS_MORE_COUNT: '+{count} autres',
    ALERT_TITLE_DELETE_GOOGLE_ACCOUNT: 'Dissocier le compte Google',
    ALERT_TEXT_DELETE_GOOGLE_ACCOUNT:
      'Êtes-vous sûr de vouloir dissocier ce compte Google ? Les lieux associés seront dissociés.',
    ALERT_TEXT_DELETE_GOOGLE_ACCOUNT_WITH_COUNT: `Êtes-vous sûr de vouloir dissocier ce compte Google ? {count, plural, =0 {Aucun lieu n'est concerné.} one {# lieu sera dissocié.} other {# lieux seront dissociés.}}`,
    ADD_GOOGLE_ACCOUNT_GMB: 'Ajouter un compte Google My Business',
    GOOGLE_ACCOUNT_AVATAR_ALT: 'Avatar du compte Google {name}',
    GOOGLE_RESERVE_CTA_TITLE: 'Réserver avec Google',
    GOOGLE_RESERVE_CTA_SUBTITLE: 'Ajoutez un bouton de réservation directement sur vos fiches Google',
  },
  GOOGLE_OAUTH_CALLBACK: {
    LOADING_TITLE: 'Association en cours',
    LOADING_DESCRIPTION: 'Connexion de votre compte Google à votre établissement…',
    SUCCESS_TITLE: 'Compte Google associé',
    SUCCESS_DESCRIPTION: 'Votre compte Google a été associé avec succès.',
    SUCCESS_REDIRECTING: 'Redirection vers votre établissement…',
    ERROR_TITLE: 'Erreur d’association',
    ERROR_CANCELLED: 'L’autorisation a été annulée auprès de Google.',
    ERROR_EXPIRED: 'Le lien d’autorisation a expiré. Veuillez relancer la connexion.',
    ERROR_GENERIC: 'Une erreur est survenue lors de l’association de votre compte Google.',
    ACTION_RETURN: 'Retourner à l’application',
    ACTION_RETRY: 'Réessayer',
  },
  CALENDAR_OAUTH_CALLBACK: {
    LOADING_TITLE: 'Association en cours',
    LOADING_DESCRIPTION: 'Connexion de votre Google Agenda à votre planning…',
    SUCCESS_TITLE: 'Google Agenda associé',
    SUCCESS_DESCRIPTION: 'Votre Google Agenda a été associé avec succès.',
    SUCCESS_REDIRECTING: 'Redirection vers votre planning…',
    ERROR_TITLE: 'Erreur d’association',
    ERROR_CANCELLED: 'L’autorisation a été annulée auprès de Google.',
    ERROR_EXPIRED: 'Le lien d’autorisation a expiré. Veuillez relancer la connexion.',
    ERROR_GENERIC: 'Une erreur est survenue lors de l’association de votre Google Agenda.',
    ACTION_RETURN: 'Retourner au planning',
  },
  PROFESSIONAL_APP_REVIEWS_PAGE: {
    TITLE: 'Avis Google',
    EMPTY_TITLE: 'Aucun avis pour le moment',
    EMPTY_DESCRIPTION: 'Les avis de vos fiches Google liées apparaîtront ici dès la prochaine synchronisation.',
    EMPTY_NO_GMB_TITLE: 'Connectez votre compte Google',
    EMPTY_NO_GMB_DESCRIPTION: 'Pour suivre et répondre à vos avis, connectez d’abord votre compte Google.',
    EMPTY_NO_GMB_CTA: 'Connecter un compte Google',
    EMPTY_NO_LINK_TITLE: 'Liez une fiche à un lieu',
    EMPTY_NO_LINK_DESCRIPTION:
      'Votre compte Google est connecté. Liez une fiche Google à l’un de vos lieux pour récupérer ses avis.',
    EMPTY_NO_LINK_CTA: 'Gérer mes lieux',
    REPLY_PLACEHOLDER: 'Rédigez votre réponse…',
    GENERATE_AI: 'Générer une réponse',
    REGENERATE_AI: 'Régénérer',
    PUBLISH: 'Publier la réponse',
    IGNORE: 'Ignorer',
    AUTO_REPLY_BADGE: 'Réponse automatique',
    REPLIED_ON: 'Répondu le {date}',
    REPLY_WITH_AI: 'Répondre avec l’aide de l’IA',
    SUGGESTION_SUCCESS: 'Suggestion générée',
    SUGGESTION_ERROR: 'Impossible de générer la suggestion',
    PUBLISH_SUCCESS: 'Réponse publiée sur Google',
    PUBLISH_ERROR: 'La publication de la réponse a échoué',
    IGNORE_SUCCESS: 'Avis ignoré',
    IGNORE_ERROR: 'Impossible d’ignorer cet avis',
    REPLY_EMPTY_ERROR: 'La réponse ne peut pas être vide',
    // (Le bloc PUSH_* vivait ici du temps où les opt-ins étaient un formulaire à enregistrer.
    // Il est remplacé par le namespace GMB_SYNC, propre à l'onglet Fiche Google.)
    SETTINGS_SECTION_TITLE: 'Réglages des avis',
    SETTINGS_BUTTON: 'Réglages',
    AUTO_REPLY_ACTIVE_BADGE: 'Réponse automatique activée',
    SETTINGS_AUTO_REPLY_LABEL: 'Réponse automatique aux avis positifs sans commentaire',
    SETTINGS_AUTO_REPLY_HELP:
      'Publie automatiquement un remerciement aux avis 4-5★ qui n’ont pas de texte (modèle prédéfini, sans IA).',
    SETTINGS_TONE_LABEL: 'Consignes de ton pour les réponses IA',
    SETTINGS_TONE_PLACEHOLDER: 'Ex : vouvoiement, signature « L’équipe »…',
    SETTINGS_SAVE_BUTTON: 'Enregistrer',
    SETTINGS_SAVE_SUCCESS: 'Réglages enregistrés',
    SETTINGS_SAVE_ERROR: 'Échec de l’enregistrement',
  },
  PROFESSIONAL_APP_STATISTICS_PAGE: {
    TITLE: 'Statistiques',
    STATS_PERIOD_TODAY: "Aujourd'hui",
    STATS_PERIOD_WEEK: 'Cette semaine',
    STATS_PERIOD_7D: '7 jours',
    STATS_PERIOD_30D: '30 jours',
    STATS_PERIOD_3MO: '3 mois',
    STATS_PERIOD_6MO: '6 mois',
    STATS_PERIOD_12MO: '12 mois',
    SOURCE_UNKNOWN: 'Non renseigné',
    BREAKDOWN_UNASSIGNED_MEMBER: 'Sans membre',
    BREAKDOWN_UNASSIGNED_PLACE: 'Sans lieu',
    // ── Onglets et période ──
    TAB_ACTIVITY: 'Activité',
    TAB_CUSTOMERS: 'Clients',
    TAB_SALES: 'Ventes',
    TAB_REVIEWS: 'Avis Google',
    TAB_CAMPAIGNS: 'Campagnes',
    PERIOD_CUSTOM: 'Personnalisé',
    PERIOD_CUSTOM_FROM: 'Du',
    PERIOD_CUSTOM_TO: 'au',
    PERIOD_APPLY: 'Appliquer',
    PERIOD_LOCKED_BENEFIT: 'Suivez votre année',
    PERIOD_LOCKED_DESCRIPTION:
      'Avec la formule Pro, remontez jusqu’à 12 mois en arrière et choisissez vos propres dates.',
    WINDOW_LABEL: 'Du {start} au {end}',
    PREVIOUS_WINDOW_LABEL: 'vs {start} – {end}',
    COMPARE_PILL: 'Comparer',
    COMPARE_INFO: 'Compare avec la période précédente de même durée.',
    COMPARE_LOCKED_BENEFIT: 'Comparez vos périodes',
    COMPARE_LOCKED_DESCRIPTION:
      'Avec la formule Pro, voyez d’un coup d’œil si votre activité progresse d’une période à l’autre.',
    // ── KPI ──
    STAT_HONORED: 'RDV honorés',
    STAT_HONORED_INFO: 'Rendez-vous passés de la période qui ont eu lieu (ni annulés, ni marqués client non présenté).',
    STAT_NO_SHOW: 'Non présentés',
    STAT_NO_SHOW_INFO:
      'Rendez-vous passés de la période marqués « client non présenté » depuis la fiche du rendez-vous.',
    STAT_NO_SHOW_RATE: '{rate} % des visites passées',
    STAT_CANCELLED: 'Annulés',
    STAT_CANCELLED_INFO:
      'Rendez-vous de la période annulés, par vous ou par le client. Les rendez-vous annulés puis purgés de l’agenda restent comptés ; les demandes jamais confirmées sont comptées à part.',
    STAT_CANCELLED_DETAIL: '{pro} par vous · {customer} par le client',
    STAT_EXPIRED_REQUESTS: 'Demandes expirées',
    STAT_EXPIRED_REQUESTS_INFO: 'Demandes de rendez-vous passées sans avoir été confirmées.',
    STAT_BOOKINGS_CREATED: 'Réservations prises',
    STAT_BOOKINGS_CREATED_INFO:
      'Réservations enregistrées sur la période, quel que soit leur statut aujourd’hui. Une réservation peut couvrir plusieurs rendez-vous.',
    STAT_UPCOMING: 'RDV à venir',
    STAT_UPCOMING_INFO: 'Rendez-vous confirmés ou en attente à partir de maintenant, sur les 12 prochains mois.',
    STAT_UPCOMING_TO_CONFIRM: '{count} à confirmer',
    STAT_PLANNED: 'RDV prévus',
    STAT_PLANNED_INFO: 'Rendez-vous de la semaine non annulés, passés et à venir, clients non présentés compris.',
    STAT_PLANNED_NO_SHOW: 'dont {count} non présentés',
    STAT_REVENUE_PLANNED: 'CA prévu',
    STAT_REVENUE_PLANNED_INFO:
      'Valeur au prix réservé des rendez-vous confirmés de la période, acomptes compris, hors clients non présentés. Ce n’est pas ce qui reste à encaisser.',
    STAT_REMAINING_TO_COLLECT: 'Reste à encaisser (RDV à venir)',
    STAT_REMAINING_TO_COLLECT_INFO:
      'Valeur au prix réservé des rendez-vous confirmés à venir (12 mois), déduction faite de ce qui est déjà encaissé ou couvert par un bon. Calculé à l’instant présent.',
    STAT_REMAINING_TO_CONFIRM: '+ {amount} de demandes en attente',
    STAT_COLLECTED: 'CA net encaissé',
    STAT_COLLECTED_INFO:
      'Paiements encaissés sur la période (en ligne ou déclarés payés), remboursements déduits. TTC, frais Stripe non déduits. Les règlements hors plateforme ne sont pas comptés.',
    STAT_REFUNDED: '{amount} remboursés',
    STAT_PAYMENTS_COUNT: '{count, plural, =0 {aucun paiement} one {# paiement} other {# paiements}}',
    STAT_AVERAGE_BASKET: 'Panier moyen',
    STAT_AVERAGE_BASKET_INFO:
      'CA net encaissé divisé par le nombre de paiements de la période (hors paiements intégralement remboursés).',
    STAT_NEW_CUSTOMERS: 'Nouveaux clients',
    STAT_NEW_CUSTOMERS_INFO: 'Fiches clients entrées dans votre base sur la période (date « client depuis »).',
    STAT_OCCUPANCY: 'Taux d’occupation',
    STAT_OCCUPANCY_INFO:
      'Part de vos heures d’ouverture occupée par des rendez-vous, sur la partie passée de la période, comptée par membre. Les blocages importés d’agendas externes comptent comme occupés.',
    OCCUPANCY_UNAVAILABLE: 'Non calculé : aucune heure d’ouverture sur la période, ou période de plus de 3 mois.',
    HAS_UNPRICED_INFO: 'Certains rendez-vous sans prix connu ne sont pas comptés.',
    // ── Sections ──
    SECTION_STATUSES: 'Répartition des rendez-vous',
    SECTION_TIMESERIES: 'Évolution',
    SECTION_HEATMAP: 'Heures de pointe',
    SECTION_SOURCES: 'Provenance des réservations',
    SECTION_FIRST_VISITS: 'Première visite vs déjà venus',
    SECTION_INACTIVE: 'Clients à relancer',
    SECTION_TOP_CUSTOMERS: 'Meilleurs clients',
    SECTION_BY_ORIGIN: 'Encaissé par origine',
    SECTION_VOUCHERS: 'Cartes cadeaux',
    SECTION_BREAKDOWN: 'Analyse détaillée',
    SECTION_REVIEWS_DISTRIBUTION: 'Répartition des notes',
    SECTION_REVIEWS_SERIES: 'Nouveaux avis',
    SECTION_REVIEWS_PLACES: 'Par fiche Google',
    SECTION_CAMPAIGNS: 'Vos campagnes',
    SERIES_HONORED: 'RDV honorés',
    SERIES_BOOKINGS: 'Réservations prises',
    SERIES_REVENUE: 'CA net',
    SERIES_FIRST_VISIT: 'Première visite',
    SERIES_RETURNING: 'Déjà venus',
    SERIES_NEW_REVIEWS: 'Nouveaux avis',
    SERIES_NO_SHOW: 'Non présentés',
    SERIES_CANCELLED: 'Annulés',
    SERIES_EXPIRED: 'Demandes expirées',
    PARTIAL_BUCKET_HINT: 'Période partielle',
    GROUP_SESSION_INFO: 'Chaque participant d’une séance de groupe compte pour un rendez-vous.',
    SOURCES_INFO:
      'Canal par lequel la réservation a été prise. Le canal précis est suivi depuis le 2 octobre 2026 ; avant, les réservations en ligne sont regroupées sous « Réservation en ligne ».',
    HEATMAP_INFO:
      'Répartition de vos rendez-vous par jour de la semaine et par heure sur la période. Plus la case est foncée, plus le créneau est demandé.',
    HEATMAP_HOUR: '{hour}h',
    HEATMAP_CELL: '{day} à {hour}h : {count, plural, one {# rendez-vous} other {# rendez-vous}}',
    WEEKDAY_SHORT_1: 'Lun',
    WEEKDAY_SHORT_2: 'Mar',
    WEEKDAY_SHORT_3: 'Mer',
    WEEKDAY_SHORT_4: 'Jeu',
    WEEKDAY_SHORT_5: 'Ven',
    WEEKDAY_SHORT_6: 'Sam',
    WEEKDAY_SHORT_7: 'Dim',
    // ── Clients ──
    STAT_ACTIVE_CUSTOMERS: 'Clients venus',
    STAT_ACTIVE_CUSTOMERS_INFO: 'Clients avec au moins une visite honorée sur la période.',
    STAT_REBOOKING_RATE: 'Taux de re-réservation',
    STAT_REBOOKING_RATE_INFO: 'Part des clients venus sur la période qui ont déjà un prochain rendez-vous programmé.',
    INACTIVE_INFO:
      'Clients sans rendez-vous à venir, selon l’ancienneté de leur dernière visite — vos meilleures cibles de relance. Mêmes tranches que vos tags automatiques « Pas de rendez-vous depuis… ».',
    INACTIVE_30_90: '30 à 90 jours',
    INACTIVE_90_180: '90 à 180 jours',
    INACTIVE_180_PLUS: 'Plus de 180 jours',
    INACTIVE_CTA: 'Relancer',
    TOP_CUSTOMERS_INFO:
      'Vos 5 clients les plus fidèles depuis le début (visites honorées), avec leur CA encaissé sur les formules Pro et Max.',
    TOP_CUSTOMERS_VISITS: '{count, plural, one {# visite} other {# visites}}',
    TOP_CUSTOMERS_LAST_VISIT: 'Dernière visite le {date}',
    TOP_CUSTOMERS_EMPTY: 'Pas encore de client classé',
    // ── Ventes ──
    VOUCHERS_INFO:
      'Axe séparé du CA : la vente d’une carte cadeau est déjà comptée dans le CA encaissé au moment du paiement — ces montants ne s’additionnent pas.',
    VOUCHER_SOLD: 'Vendues',
    VOUCHER_SOLD_MANUAL: 'dont {count} créées manuellement',
    VOUCHER_CONSUMED: 'Consommées',
    VOUCHER_CONSUMED_USAGES: '{count, plural, one {# utilisation} other {# utilisations}}',
    VOUCHER_OUTSTANDING: 'À consommer',
    VOUCHER_OUTSTANDING_INFO: 'Solde restant des cartes actives non expirées : service déjà encaissé, encore dû.',
    VOUCHER_OUTSTANDING_SESSIONS: '+ {count} séances restantes',
    VOUCHER_EXPIRED: 'Expirées non utilisées',
    VOUCHER_EXPIRED_COUNT: '{count, plural, one {# carte} other {# cartes}}',
    BY_ORIGIN_INFO:
      'Réservation : paiements liés à un rendez-vous. Carte cadeau : ventes de cartes. Vente directe : liens de paiement et encaissements déclarés.',
    // ── Analyse détaillée ──
    BREAKDOWN_INFO:
      'Rendez-vous honorés de la période et leur valeur au prix réservé, par dimension. Ce n’est pas l’encaissé. Les membres se partagent la valeur à parts égales.',
    BREAKDOWN_COL_LABEL: 'Libellé',
    BREAKDOWN_COL_HONORED: 'Honorés',
    BREAKDOWN_COL_NO_SHOW: 'Non présentés',
    BREAKDOWN_COL_CANCELLED: 'Annulés',
    BREAKDOWN_COL_VALUE: 'Valeur réservée',
    BREAKDOWN_COL_SHARE: 'Part',
    BREAKDOWN_EMPTY: 'Aucun rendez-vous sur cette période',
    // ── Avis Google ──
    REVIEWS_AVERAGE: 'Note moyenne',
    REVIEWS_AVERAGE_INFO:
      'Moyenne de vos fiches Google, pondérée par le nombre d’avis de chacune. Synchronisée toutes les 12 heures.',
    REVIEWS_TOTAL: 'Avis au total',
    REVIEWS_NEW: 'Nouveaux avis',
    REVIEWS_RECENT_RATING: 'Note des avis récents',
    REVIEWS_REPLY_RATE: 'Taux de réponse',
    REVIEWS_REPLY_RATE_INFO:
      'Part de vos avis notés ayant une réponse publiée. Répondre aux avis améliore votre visibilité locale.',
    REVIEWS_TO_REPLY: 'À répondre',
    REVIEWS_STARS: '{stars, plural, one {# étoile} other {# étoiles}}',
    REVIEWS_NOT_CONNECTED_TITLE: 'Connectez votre fiche Google',
    REVIEWS_NOT_CONNECTED_DESCRIPTION: 'Recevez vos avis, répondez-leur et suivez votre note moyenne directement ici.',
    REVIEWS_NOT_CONNECTED_CTA: 'Connecter ma fiche Google',
    REVIEWS_PLACES_LOCKED_BENEFIT: 'Suivez chaque établissement',
    REVIEWS_PLACES_LOCKED_DESCRIPTION:
      'Avec la formule Pro, comparez la note et le nombre d’avis de chacune de vos fiches Google.',
    REVIEWS_MANAGE: 'Gérer mes avis',
    // ── Campagnes ──
    CAMPAIGNS_SENT: 'Campagnes envoyées',
    CAMPAIGNS_SENT_DETAIL: '{email} email · {sms} SMS',
    CAMPAIGNS_RECIPIENTS: 'Destinataires',
    CAMPAIGNS_DELIVERED: 'Délivrés',
    CAMPAIGNS_OPEN_RATE: 'Taux d’ouverture',
    CAMPAIGNS_CLICK_RATE: 'Taux de clic',
    CAMPAIGNS_RATES_INFO:
      'Ouvertures et clics tels que remontés par Mailjet et AllMySMS, de quelques minutes à un jour après l’envoi. Les ouvertures n’existent pas en SMS.',
    CAMPAIGNS_CREDITS_EMAIL: 'Crédits email',
    CAMPAIGNS_CREDITS_SMS: 'Crédits SMS',
    CAMPAIGNS_CREDITS_INFO: 'Emails et SMS débités par vos campagnes sur la période, recrédits déduits.',
    CAMPAIGNS_UNSUBSCRIBES: 'Désinscriptions',
    CAMPAIGNS_UNSUBSCRIBES_DETAIL: '{email} email · {sms} SMS',
    CAMPAIGNS_UNSUBSCRIBES_INFO:
      'Clients qui se sont désinscrits de vos messages sur la période (lien de désinscription email, STOP SMS).',
    CAMPAIGNS_COUNTERS_SINCE: 'Ouvertures et clics disponibles pour les campagnes envoyées depuis le {date}.',
    CAMPAIGNS_COL_NAME: 'Campagne',
    CAMPAIGNS_COL_SENT: 'Envoyée le',
    CAMPAIGNS_COL_RECIPIENTS: 'Destinataires',
    CAMPAIGNS_COL_DELIVERED: 'Délivrés',
    CAMPAIGNS_COL_OPEN: 'Ouvertures',
    CAMPAIGNS_COL_CLICK: 'Clics',
    CAMPAIGNS_COL_BOOKINGS: 'Réservations',
    CAMPAIGNS_COL_REVENUE: 'CA',
    CAMPAIGNS_NOT_SYNCED: 'Pas encore disponible',
    CAMPAIGNS_EMPTY: 'Aucune campagne envoyée sur cette période',
    CAMPAIGNS_EMPTY_CTA: 'Créer une campagne',
    CAMPAIGNS_LOCKED_BENEFIT: 'Faites revenir vos clients par email et SMS',
    CAMPAIGNS_LOCKED_DESCRIPTION:
      'Avec la formule Pro, envoyez des campagnes email et SMS et suivez leurs résultats ici.',
    CAMPAIGNS_ATTRIBUTION_LOCKED_BENEFIT: 'Sachez ce que rapportent vos campagnes',
    CAMPAIGNS_ATTRIBUTION_LOCKED_DESCRIPTION:
      'Avec la formule Pro, voyez les réservations et le chiffre d’affaires que chaque campagne vous apporte.',
    CAMPAIGNS_ATTRIBUTION_INFO:
      'Réservations prises en suivant un lien de la campagne, et chiffre d’affaires encaissé sur ces réservations.',
    // ── Verrous (formulés en bénéfice) ──
    LOCKED_TITLE_PRO: 'Disponible avec la formule Pro',
    LOCKED_TITLE_MAX: 'Disponible avec la formule Max',
    TEASER_COLLECTED: 'Encaissez en ligne dès la réservation',
    TEASER_COLLECTED_DESCRIPTION:
      'Avec la formule Pro, acomptes et paiements en ligne alimentent votre chiffre d’affaires encaissé et votre panier moyen.',
    TEASER_VOUCHERS: 'Vendez des cartes cadeaux toute l’année',
    TEASER_VOUCHERS_DESCRIPTION:
      'Avec la formule Pro, vendez des cartes cadeaux en ligne et suivez ce qu’il reste à consommer.',
    TEASER_PRESTATIONS: 'Vos prestations qui rapportent le plus',
    TEASER_PRESTATIONS_DESCRIPTION:
      'Avec la formule Pro, sachez quelles prestations remplissent votre agenda et ce qu’elles valent.',
    TEASER_TEAM: 'Pilotez votre équipe et vos lieux',
    TEASER_TEAM_DESCRIPTION:
      'Avec la formule Max : chiffres par membre et par lieu, taux d’occupation et heures de pointe.',
    TEASER_EXPORT: 'Exportez vos chiffres',
    TEASER_EXPORT_DESCRIPTION:
      'Avec la formule Pro, téléchargez vos statistiques en CSV pour votre comptable ou votre tableur.',
    TEASER_CTA: 'Changer de formule',
    TEASER_WEBVIEW_HINT: 'Le changement de formule se fait depuis le site web.',
    PLAN_BADGE_PRO: 'Pro',
    PLAN_BADGE_MAX: 'Max',
    // ── Nudges ──
    NUDGE_CTA_UPGRADE: 'Découvrir la formule {plan}',
    NUDGE_CTA_SETTINGS: 'Régler mes prestations',
    NUDGE_CTA_CAMPAIGN: 'Relancer ces clients',
    NUDGE_CTA_REVIEWS: 'Répondre avec Pulse',
    NUDGE_CTA_TEAM: 'Ajouter un membre',
    NUDGE_CTA_GOOGLE: 'Connecter ma fiche Google',
    NUDGE_DISMISS: 'Masquer',
    // ── Export, états ──
    EXPORT_CSV: 'Exporter en CSV',
    EXPORT_FILE_PREFIX: 'statistiques',
    EXPORT_PERIOD_HEADER: 'Période du {start} au {end}',
    STATS_LOAD_ERROR: 'Impossible de charger ces statistiques.',
    RETRY: 'Réessayer',
    EMPTY: 'Pas encore de données sur cette période',
    STAT_INFO_BUTTON: 'Voir la définition',
    OCCUPANCY_DETAIL: '{busy} occupées sur {open} d’ouverture',
    CAMPAIGN_TYPE_EMAIL: 'Email',
    CAMPAIGN_TYPE_SMS: 'SMS',
    TOP_CUSTOMERS_REVENUE_LOCKED: 'CA avec la formule Pro',
    PERIOD_CUSTOM_HINT: 'Jusqu’à 12 mois, fin au plus tard aujourd’hui.',
    ...StatsBreakdownDimensionTranslation['fr-FR'],
    ...StatsNudgeCodeTranslation['fr-FR'],
    ...StatsNudgeRemedyTranslation['fr-FR'],
  },

  PROFESSIONAL_APP_HOME_WIDGETS: {
    TODAY_TITLE: "Aujourd'hui",
    TODAY_COUNT: '{count, plural, =0 {Aucun rendez-vous} one {# rendez-vous} other {# rendez-vous}}',
    TODAY_GROUP_SESSIONS: '{count, plural, one {dont # séance de groupe} other {dont # séances de groupe}}',
    TODAY_NO_SHOW: '{count, plural, one {dont # non présenté} other {dont # non présentés}}',
    TODAY_NEXT: 'Prochain à {time} · {label}',
    TODAY_TO_CONFIRM: '{count, plural, one {# à confirmer} other {# à confirmer}}',
    TODAY_CTA: 'Voir mon agenda',
    WEEK_TITLE: 'Cette semaine',
    WEEK_PLANNED: 'RDV prévus',
    WEEK_PLANNED_NO_SHOW: '{count, plural, one {dont # non présenté} other {dont # non présentés}}',
    WEEK_REVENUE: 'CA prévu',
    WEEK_REVENUE_INFO:
      'Valeur de vos rendez-vous confirmés de la semaine, acomptes compris, hors clients non présentés. Ce n’est pas ce qui reste à encaisser.',
    WEEK_CTA: 'Voir mes statistiques',
    TO_HANDLE_TITLE: 'À traiter',
    TO_HANDLE_CONFIRMATIONS:
      '{count, plural, one {# demande de rendez-vous à confirmer} other {# demandes de rendez-vous à confirmer}}',
    TO_HANDLE_REVIEWS: '{count, plural, one {# avis Google à répondre} other {# avis Google à répondre}}',
    TO_HANDLE_CONTACTS:
      '{count, plural, one {# demande de contact ou de devis} other {# demandes de contact ou de devis}}',
    TO_HANDLE_EMPTY: 'Rien à traiter pour le moment.',
  },

  PROFESSIONAL_APP_SALES_PAGE: {
    TITLE: 'Mes ventes',
    STRIPE_CONNECT_TITLE: 'Recevoir des paiements',
    STRIPE_CONNECT_SUBTITLE: 'Connectez votre compte Stripe pour recevoir les paiements de vos clients directement.',
    STRIPE_CONNECT_NOT_CREATED_TITLE: 'Configurez votre compte de paiement',
    STRIPE_CONNECT_NOT_CREATED_DESCRIPTION:
      'Pour recevoir des paiements de vos clients, connectez un compte Stripe. La configuration prend quelques minutes.',
    STRIPE_CONNECT_PARTNER_BADGE: 'Partenaire officiel Stripe',
    STRIPE_CONNECT_STRIPE_TEXT: 'stripe',
    STRIPE_CONNECT_HERO_TAGLINE: "Encaissez vos clients dès aujourd'hui - c'est court, rapide et facile",
    STRIPE_CONNECT_HERO_SUBTITLE: `Stripe Connect est la solution de paiement de référence, utilisée par des millions de plateformes dans le monde. En tant que partenaire officiel Stripe, ${PROJECT_CONFIG.brand_string} vous offre une intégration fluide et 100\u202f% sécurisée.`,
    STRIPE_CONNECT_FEATURE_PAYMENTS: 'Paiements en ligne',
    STRIPE_CONNECT_FEATURE_PAYMENTS_DESC: `Acceptez les cartes bancaires de vos clients directement sur ${PROJECT_CONFIG.brand_string}.`,
    STRIPE_CONNECT_FEATURE_SECURE: 'Sécurité maximale',
    STRIPE_CONNECT_FEATURE_SECURE_DESC: 'Certifié PCI\u202fDSS niveau\u202f1, la norme la plus élevée du secteur.',
    STRIPE_CONNECT_FEATURE_PAYOUTS: 'Virements automatiques',
    STRIPE_CONNECT_FEATURE_PAYOUTS_DESC: 'Recevez vos fonds directement sur votre compte bancaire.',
    STRIPE_CONNECT_LEARN_MORE: 'En savoir plus sur Stripe Connect',
    STRIPE_CONNECT_BUTTON_CREATE: 'Connecter mon compte Stripe',
    STRIPE_CONNECT_BUTTON_CONTINUE: "Continuer l'inscription",
    STRIPE_CONNECT_BUTTON_DASHBOARD: 'Accéder au tableau de bord Stripe',
    STRIPE_CONNECT_STATUS_ACTIVE: 'Actif',
    STRIPE_CONNECT_STATUS_ONBOARDING_PENDING: 'Inscription en cours',
    STRIPE_CONNECT_STATUS_RESTRICTED: 'Action requise',
    STRIPE_CONNECT_STATUS_DISABLED: 'Inactif',
    STRIPE_CONNECT_CHARGES_ENABLED: 'Paiements activés',
    STRIPE_CONNECT_CHARGES_DISABLED: 'Paiements inactifs',
    STRIPE_CONNECT_PAYOUTS_ENABLED: 'Virements activés',
    STRIPE_CONNECT_PAYOUTS_DISABLED: 'Virements inactifs',
    STRIPE_CONNECT_REQUIREMENTS_DESCRIPTION:
      'Des informations supplémentaires sont nécessaires pour activer vos paiements et commencer à encaisser vos clients.',
  },
  // Page Marketing › Promotions (lot 2, maquettes validées) : liste par onglet, éditeur en trois sections,
  // tableau « Codes actifs ». Montants et dates formatés par le serveur.
  PROFESSIONAL_APP_PROMOTIONS_PAGE: {
    TITLE: 'Promotions',
    NEW_PROMOTION: 'Nouvelle promotion',
    TAB_ACTIVE: 'Actives',
    TAB_ENDED: 'Terminées et archivées',
    TAB_DRAFT: 'Brouillons',
    TAB_CODES: 'Codes actifs',
    TAB_WITH_COUNT: '{label} · {count}',
    TAB_EMPTY: 'Aucune promotion dans cet onglet.',
    EMPTY_TITLE: 'Aucune promotion pour l’instant',
    EMPTY_TEXT: 'Partez d’un modèle, vous pourrez tout modifier.',
    TEMPLATE_DISCOVERY_TITLE: 'Offre découverte',
    // `amount` : montant du modèle formaté dans la devise du pro (10,00 € · 10,00 $US).
    TEMPLATE_DISCOVERY_TEXT: '−{amount} sur la première réservation, par code',
    TEMPLATE_HAPPY_HOURS_TITLE: 'Happy hours',
    TEMPLATE_HAPPY_HOURS_TEXT: '−15 % automatiquement sur certains créneaux',
    TEMPLATE_DATED_TITLE: 'Opération à dates',
    TEMPLATE_DATED_TEXT: '−20 % automatiquement du … au …',
    CREATE_BLANK: 'Créer une promotion vide',
    TYPE_AUTO: 'Automatique',
    TYPE_CODE: 'Code {code}',
    TYPE_PERSONAL_CODES: 'Codes personnels',
    VALUE_PERCENT: '−{value} %',
    VALUE_AMOUNT: '−{amount}',
    PERIOD_FROM_TO: 'Du {from} au {to}',
    PERIOD_SINCE: 'Depuis le {from}',
    SCOPE_ALL: 'Toutes les prestations',
    SCOPE_PRESTATIONS: '{count, plural, one {# prestation} other {# prestations}}',
    SCOPE_CATEGORIES: '{count, plural, one {# catégorie} other {# catégories}}',
    PLACES_ALL: 'Tous les lieux',
    PLACES_COUNT: '{count, plural, one {# lieu} other {# lieux}}',
    HOURS_SOME: 'À certaines heures',
    PER_CUSTOMER: '{count} par client',
    USAGES_UNLIMITED: '{count, plural, =0 {0 utilisation} one {# utilisation} other {# utilisations}} · illimité',
    USAGES_LIMITED: '{count, plural, =0 {0 utilisation} one {# utilisation} other {# utilisations}} / {max}',
    PAUSE_SWITCH_LABEL: 'Promotion active',
    ACTIONS_LABEL: 'Actions de la promotion',
    ACTION_EDIT: 'Modifier',
    ACTION_DUPLICATE: 'Dupliquer',
    ACTION_USAGES: 'Voir les utilisations',
    ACTION_COPY_LINK: 'Copier le lien de réservation avec le code',
    ACTION_ARCHIVE: 'Archiver',
    ACTION_DELETE: 'Supprimer',
    LINK_COPIED: 'Lien copié.',
    DUPLICATED: 'Promotion dupliquée en brouillon.',
    PAUSED: 'Promotion mise en pause.',
    RESUMED: 'Promotion réactivée.',
    ARCHIVED: 'Promotion archivée.',
    DELETED: 'Promotion supprimée.',
    ARCHIVE_CONFIRM_TITLE: 'Archiver cette promotion ?',
    ARCHIVE_CONFIRM_TEXT:
      'Elle ne s’applique plus et passe dans « Terminées et archivées ». Ses utilisations restent consultables.',
    DELETE_CONFIRM_TITLE: 'Supprimer ce brouillon ?',
    DELETE_CONFIRM_TEXT: 'Le brouillon et sa configuration seront supprimés.',
    EDITOR_NEW_TITLE: 'Nouvelle promotion',
    EDITOR_EDIT_TITLE: 'Modifier la promotion',
    SECTION_WHAT: '1 · Quoi',
    SECTION_WHEN: '2 · Quand et pour qui',
    SECTION_HOW: '3 · Comment',
    FIELD_PUBLIC_LABEL: 'Libellé affiché aux clients',
    FIELD_PUBLIC_LABEL_PLACEHOLDER: 'Black Week',
    FIELD_INTERNAL_NAME: 'Nom interne (facultatif)',
    FIELD_INTERNAL_NAME_PLACEHOLDER: 'Black Week novembre 2026',
    FIELD_DISCOUNT: 'Remise',
    FIELD_INCLUDE_SUPPLEMENTS: 'Inclure les suppléments dans la remise',
    FIELD_SCOPE: 'Prestations concernées',
    FIELD_SCOPE_PLACEHOLDER: 'Choisir des prestations ou des catégories',
    PREVIEW_TITLE: 'Aperçu (prix calculés par le serveur)',
    PREVIEW_MORE: '{count, plural, one {+ # autre prestation} other {+ # autres prestations}}',
    PREVIEW_EMPTY: 'Aucune prestation à prix fixe dans ce périmètre.',
    FIELD_START: 'Début',
    FIELD_END: 'Fin (facultatif)',
    FIELD_SOME_HOURS: 'Seulement à certaines heures',
    FIELD_DAYS_HINT: 'Aucun jour choisi : tous les jours.',
    FIELD_TIME_FROM: 'De',
    FIELD_TIME_TO: 'à',
    ADD_TIME_WINDOW: 'Ajouter une plage horaire',
    REMOVE_TIME_WINDOW: 'Retirer la plage horaire',
    FIELD_PLACES: 'Lieux',
    PLACES_OPTION_ALL: 'Tous',
    PLACES_OPTION_SOME: 'Certains lieux',
    FIELD_PLACES_PLACEHOLDER: 'Choisir des lieux',
    FIELD_WINDOW_BASIS: 'Les dates s’appliquent à',
    FIELD_WINDOW_BASIS_HINT:
      'La date du rendez-vous pour des happy hours ou une Black Week sur place ; la date de réservation pour une offre vendue du 24 au 30 nov. et utilisée plus tard.',
    FIELD_SOME_MEMBERS: 'Restreindre à certains membres',
    FIELD_SOME_MEMBERS_HINT:
      'La remise s’applique si le rendez-vous est attribué à l’un d’eux, choisi par le client ou attribué automatiquement.',
    MEMBERS_COUNT: '{count, plural, one {# membre} other {# membres}}',
    FIELD_HIGHLIGHT_ON_SITE: 'Mettre en avant sur le site',
    FIELD_HIGHLIGHT_ON_SITE_HINT:
      'Prix barré et badge sur les prestations concernées ; la promotion peut aussi être reprise par le bandeau et la section Promotion du site.',
    FIELD_HIGHLIGHT_ON_SITE_PERSONAL_HINT: 'Des codes personnels ne s’affichent jamais sur le site.',
    SUMMARY_HIGHLIGHTED: 'Mise en avant sur le site',
    ACTION_HIGHLIGHT: 'Mettre en avant sur le site',
    ACTION_UNHIGHLIGHT: 'Retirer du site',
    HIGHLIGHTED: 'Promotion mise en avant sur le site.',
    UNHIGHLIGHTED: 'Promotion retirée du site.',
    ERROR_MEMBERS_REQUIRED: 'Choisissez au moins un membre.',
    FIELD_CUSTOMERS: 'Clients',
    FIELD_TAGS_PLACEHOLDER: 'Choisir des tags',
    FIELD_LIMITS: 'Limites (facultatif)',
    FIELD_MAX_USES: 'Utilisations max',
    FIELD_MAX_PER_CUSTOMER: 'Par client',
    FIELD_MIN_CART: 'Panier minimum',
    FIELD_UNLIMITED_PLACEHOLDER: 'Illimité',
    OVERLAP_WARNING:
      '« {labels} » s’applique aussi à une partie de ces prestations : un client ne profite que de la plus avantageuse.',
    HOW_AUTO_TEXT: 'Appliquée dès que les conditions sont remplies, sans code.',
    HOW_CODE_TEXT:
      'Le client saisit le code (ou suit votre lien avec ?code=). Codes personnels possibles pour une campagne.',
    FIELD_CODE: 'Code',
    FIELD_CODE_PLACEHOLDER: 'BIENVENUE10',
    CODE_AVAILABLE: '✓ disponible',
    CODE_USED_BY_PROMOTION: 'déjà utilisé par une autre promotion',
    CODE_USED_BY_VOUCHER: 'déjà utilisé par une carte cadeau',
    FIELD_PERSONAL_CODES: 'Codes personnels (un code par client, pour une campagne)',
    FIELD_PERSONAL_PREFIX: 'Préfixe des codes (facultatif)',
    FIELD_RESTORE_ON_CANCEL: 'Rendre l’utilisation au client s’il annule dans les délais',
    SUMMARY_HOW_AUTO: 'Automatique',
    SUMMARY_HOW_PERSONAL: 'Codes personnels',
    SAVE_DRAFT: 'Enregistrer en brouillon',
    ACTIVATE: 'Activer la promotion',
    SAVE: 'Enregistrer',
    SAVED: 'Promotion enregistrée.',
    LOCKED_HINT: 'Cette promotion a déjà servi : remise, périmètre, déclenchement et code ne se modifient plus.',
    ERROR_LABEL_REQUIRED: 'Donnez un libellé à la promotion.',
    ERROR_VALUE_INVALID: 'La remise doit être supérieure à zéro (100 % au plus).',
    ERROR_SCOPE_EMPTY: 'Choisissez au moins une prestation.',
    ERROR_END_BEFORE_START: 'La fin doit être après le début.',
    ERROR_TAGS_REQUIRED: 'Choisissez au moins un tag.',
    ERROR_CODE_REQUIRED: 'Saisissez le code de la promotion.',
    CODES_COL_CODE: 'Code',
    CODES_COL_PROMOTION: 'Promotion',
    CODES_COL_FROM: 'Du',
    CODES_COL_TO: 'Au',
    CODES_COL_USAGES: 'Utilisations',
    CODES_COL_STATUS: 'Statut',
    CODES_EMPTY: 'Aucune promotion par code pour le moment.',
    EXTEND_7_DAYS: 'Prolonger de 7 jours',
    EXTENDED: 'Promotion prolongée de 7 jours.',
    DATES_SAVED: 'Dates mises à jour.',
    UPGRADE_HINT:
      'Créer une promotion est réservé à l’offre PRO : vous pouvez mettre en pause ou archiver celles qui existent.',
    READ_ONLY_HINT: 'Lecture seule : votre rôle ou votre offre ne permet pas d’enregistrer cette promotion.',
  },
  PROFESSIONAL_APP_PROMOTION_PAGE: {
    ...ProPromoCodeKindTranslation['fr-FR'],
    ...ProPromoCodeDistributionTranslation['fr-FR'],
    ...ProPromoCodeTriggerTranslation['fr-FR'],
    ...ProPromoCodeStatusTranslation['fr-FR'],
    ...ProPromoCodeCustomerScopeTranslation['fr-FR'],
    ...ProPromotionDisplayStatusTranslation['fr-FR'],
    TITLE: 'Codes promo',
    ADD_PROMO_TITLE: 'Nouveau code promo',
    EDIT_PROMO_TITLE: 'Modifier le code promo',
    DELETE_PROMO_TITLE: 'Supprimer le code promo',
    DELETE_PROMO_TEXT: 'Ce code promo ne pourra plus être utilisé par vos clients. Cette action est irréversible.',
    EMPTY_STATE_TITLE: 'Aucun code promo',
    EMPTY_STATE_TEXT: 'Créez votre premier code promo pour offrir une réduction à vos clients.',
    COPY_CODE: 'Copier le code',
    CODE_COPIED: 'Code copié',
    FIELD_VALID_UNTIL: 'Valide jusqu’au',
    BADGE_ACTIVE: 'Actif',
    BADGE_INACTIVE: 'Inactif',
    DISCOUNT_PERCENT_LABEL: '-{value} %',
    DISCOUNT_AMOUNT_LABEL: '-{amount}',
    USAGES_LABEL: 'Utilisations',
    USAGES_TITLE: 'Utilisations du code',
    USAGES_EMPTY: 'Aucune utilisation pour le moment.',
    USAGES_LOAD_ERROR: 'Impossible de charger les utilisations.',
    PROMO_LOAD_ERROR: 'Impossible de charger ce code promo.',
    LOAD_MORE: 'Voir plus',
    USAGE_RESTORED: 'Restituée',
    PERSONAL_CODES_TITLE: 'Codes personnels',
    PERSONAL_CODES_EMPTY: 'Aucun code personnel généré pour ce code.',
    PERSONAL_CODES_LOAD_ERROR: 'Impossible de charger les codes personnels.',
    PERSONAL_CODE_USED: 'Utilisé',
    PERSONAL_CODE_UNUSED: 'Non utilisé',
    PERSONAL_CODE_CAMPAIGN: 'Campagne',
    LOCKED_AFTER_USE_HINT: 'Le type, la valeur et le ciblage ne sont plus modifiables car ce code a déjà été utilisé.',
    // Sans le plan PRO (downgrade) : action de ligne qui remplace la modale d'édition.
    DEACTIVATE_PROMO_ACTION: 'Désactiver',
    DEACTIVATE_PROMO_TITLE: 'Désactiver le code promo',
    DEACTIVATE_PROMO_TEXT:
      'Vos clients ne pourront plus utiliser ce code. Votre abonnement actuel ne permet pas de le réactiver ensuite.',
  },
  // Happy hours d'un code promo rendues au client final (cf. `formatPromoHappyHours`) :
  // jours ISO, plages horaires en heure du pro, et phrase du refus « hors créneau ».
  PROMO_HAPPY_HOURS: {
    DAY_1: 'le lundi',
    DAY_2: 'le mardi',
    DAY_3: 'le mercredi',
    DAY_4: 'le jeudi',
    DAY_5: 'le vendredi',
    DAY_6: 'le samedi',
    DAY_7: 'le dimanche',
    EVERY_DAY: 'tous les jours',
    LIST_SEPARATOR: ', ',
    LIST_LAST_SEPARATOR: ' et ',
    WINDOW_LAST_SEPARATOR: ' ou ',
    TIME_FORMAT: '{hours}h{minutes}',
    TIME_RANGE: 'de {start} à {end}',
    DAYS_AND_TIMES: '{days}, {times}',
    OUTSIDE_HOURS_MESSAGE:
      '🚫 Ce code promo est valable uniquement {windows}. Choisissez un rendez-vous qui commence dans ces horaires pour en profiter.',
    // Report d'un rendez-vous déjà remisé : la remise ne survit pas à un créneau hors happy hours.
    RESCHEDULE_OUTSIDE_HOURS_MESSAGE:
      '🚫 Votre code promo est valable uniquement {windows}. Pour conserver votre remise, choisissez un nouveau rendez-vous qui commence dans ces horaires.',
  },
  PROFESSIONAL_APP_CUSTOMER_IMPORT: {
    IMPORT_BUTTON: 'Importer des clients',
    WIZARD_TITLE: 'Importer des clients',
    STEP_UPLOAD: 'Fichier',
    STEP_MAPPING: 'Colonnes',
    STEP_PREVIEW: 'Vérification',
    STEP_RUN: 'Import',
    UPLOAD_TITLE: 'Importez votre fichier de clients',
    UPLOAD_SUBTITLE: 'Formats acceptés : CSV et Excel (XLSX), 10 Mo et 20 000 lignes maximum.',
    UPLOAD_DROPZONE: 'Glissez votre fichier ici ou cliquez pour parcourir',
    UPLOAD_TEMPLATE_LINK: 'Télécharger le modèle CSV',
    UPLOAD_SUPPORTED_FIELDS:
      'Champs supportés : prénom, nom, email, téléphone, date de naissance, client depuis, adresse, civilité, commentaire, tags et consentements.',
    UPLOAD_IN_PROGRESS: 'Analyse du fichier…',
    MAPPING_TITLE: 'Associez vos colonnes',
    MAPPING_SUBTITLE: 'Vérifiez la correspondance détectée entre les colonnes de votre fichier et les fiches clients.',
    MAPPING_COLUMN: 'Colonne du fichier',
    MAPPING_SAMPLES: 'Exemples',
    MAPPING_TARGET: 'Champ cible',
    MAPPING_CUSTOM_FIELD_OPTION: '{label} (champ personnalisé)',
    OPTIONS_TITLE: 'Options d’import',
    OPTION_DUPLICATE_STRATEGY: 'En cas de doublon avec votre base',
    OPTION_DUPLICATE_SKIP: 'Ignorer la ligne (ne rien modifier)',
    OPTION_DUPLICATE_UPDATE: 'Compléter la fiche existante',
    OPTION_MATCH_KEYS: 'Clé de rapprochement',
    OPTION_MATCH_EMAIL: 'Email',
    OPTION_MATCH_PHONE: 'Téléphone',
    OPTION_MATCH_EMAIL_AND_PHONE: 'Email ET téléphone',
    OPTION_CREATE_TAGS: 'Créer automatiquement les tags manquants',
    PREVIEW_TITLE: 'Vérifiez avant de lancer',
    PREVIEW_SUBTITLE: 'Aperçu des premières lignes après formatage automatique.',
    DRY_RUN_IN_PROGRESS: 'Analyse des lignes…',
    DRY_RUN_NEW: '{count} nouveaux clients',
    DRY_RUN_UPDATE: '{count} mises à jour',
    DRY_RUN_DUPLICATE: '{count} doublons ignorés',
    DRY_RUN_ERROR: '{count} lignes non importables',
    CUSTOM_VALUES_REJECTED_TITLE: 'Des réponses personnalisées ne seront pas importées',
    CUSTOM_VALUES_REJECTED_HELP:
      'Les fiches valides pourront être importées, mais les réponses refusées seront écartées. Consultez les avertissements ci-dessous et revenez à l’étape Colonnes pour corriger la correspondance, ou corrigez votre fichier.',
    CUSTOM_VALUE_EXPECTED_TYPE: 'Type attendu : {type}.',
    CUSTOM_VALUE_EXPECTED_OPTIONS: 'Choix acceptés : {options}.',
    CUSTOM_VALUE_MIN: 'Minimum : {value}.',
    CUSTOM_VALUE_MAX: 'Maximum : {value}.',
    DRY_RUN_NEW_TAGS: '{count} nouveaux tags seront créés',
    NO_MATCH_KEY_WARNING:
      '{count} lignes sans email ni téléphone seront créées en doublon si vous ré-importez ce fichier.',
    ROW_ERRORS_TITLE: 'Lignes en erreur ou ignorées',
    ROW_NUMBER: 'Ligne {number}',
    LAUNCH_IMPORT: 'Lancer l’import',
    BACK: 'Retour',
    NEXT: 'Continuer',
    RUNNING_TITLE: 'Import en cours…',
    RUNNING_SUBTITLE: 'Vous pouvez fermer cette fenêtre, l’import continue en arrière-plan.',
    RUNNING_PROGRESS: '{processed} / {total} lignes traitées',
    RESULT_TITLE: 'Import terminé',
    RESULT_FAILED_TITLE: 'L’import a échoué',
    RESULT_CREATED: 'Clients créés',
    RESULT_UPDATED: 'Fiches mises à jour',
    RESULT_SKIPPED: 'Lignes ignorées',
    RESULT_ERRORS: 'Lignes en erreur',
    DOWNLOAD_REPORT: 'Télécharger le rapport d’erreurs',
    HISTORY_TITLE: 'Historique des imports',
    HISTORY_LINK: 'Voir l’historique des imports',
    HISTORY_EMPTY: 'Aucun import pour le moment.',
    HISTORY_FILE: 'Fichier',
    HISTORY_DATE: 'Date',
    HISTORY_STATUS: 'Statut',
    HISTORY_COUNTS: 'Résultat',
    HISTORY_COUNTS_VALUE: '{created} créés · {updated} MAJ · {skipped} ignorés · {errors} erreurs',
    CANCEL_IMPORT: 'Annuler l’import',
  },
  PROFESSIONAL_APP_VOUCHER_PAGE: {
    TITLE: 'Cartes cadeaux',
    ADD_VOUCHER_TITLE: 'Ajouter une carte',
    FILTER_TITLE: 'Filtrer',
    SETTINGS_BUTTON: 'Paramètres des cartes cadeaux',
    SETTINGS_TITLE: 'Paramètres des cartes cadeaux',
    DELETE_VOUCHER_TITLE: 'Annuler la carte',
    DELETE_VOUCHER_TEXT: 'Êtes-vous sûr de vouloir annuler cette carte cadeau ?',
    USE_VOUCHER_TITLE: 'Utiliser un bon',
    EMPTY_STATE_PROMO_TITLE: 'Transformez vos prestations en idée cadeau',
    EMPTY_STATE_PROMO_TEXT:
      "Les cartes cadeaux permettent à vos clients d'offrir vos services à leurs proches. C'est un excellent levier pour attirer de nouveaux clients.",
    STRIPE_REQUIRED_TITLE: 'Augmentez vos revenus avec les cartes cadeaux',
    STRIPE_REQUIRED_DESCRIPTION:
      "Proposez une vraie idée cadeau. Les cartes cadeaux attirent de nouveaux clients et génèrent des ventes supplémentaires toute l'année.",
    STRIPE_REQUIRED_SOCIAL_PROOF_1:
      "Comme des milliers de commerces, vendez des cartes cadeaux et profitez d'un levier puissant pour attirer de nouveaux clients et augmenter vos ventes.",
    STRIPE_REQUIRED_WHAT_TITLE: `Pourquoi les cartes cadeaux ${PROJECT_CONFIG.brand_string} ?`,
    STRIPE_REQUIRED_WHAT_ITEM_1: 'Une idée cadeau simple et utile',
    STRIPE_REQUIRED_WHAT_ITEM_1_DESC: 'Vos clients offrent vos services en toute confiance',
    STRIPE_REQUIRED_WHAT_ITEM_2: 'Attirez de nouveaux clients',
    STRIPE_REQUIRED_WHAT_ITEM_2_DESC: 'Les destinataires découvrent votre activité naturellement',
    STRIPE_REQUIRED_WHAT_ITEM_3: "Ventes supplémentaires toute l'année",
    STRIPE_REQUIRED_WHAT_ITEM_3_DESC: 'Chaque année, de nombreuses cartes cadeaux sont offertes',
    ...STRIPE_REQUIRED_COMMON,
    STRIPE_REQUIRED_STEP_2_TITLE: 'Paramétrez vos cartes',
    STRIPE_REQUIRED_STEP_2_DESC: 'Paramétrez vos offres cadeaux avec montants ou prestations.',
    STRIPE_REQUIRED_STEP_3_DESC: 'Vos clients achètent directement des cartes cadeaux en quelques clics.',
    STRIPE_REQUIRED_CTA_TITLE: 'Prêt à attirer de nouveaux clients ?',
    ...VoucherStatusTranslation['fr-FR'],
    ...VoucherUnusableReasonTranslation['fr-FR'],
    ...ProPaymentStatusTranslation['fr-FR'],
    TAB_SALES: 'Paiements',
    TAB_GIFT_CARDS: 'Cartes cadeaux',
    TAB_PROMOTIONS: 'Codes promo',
    TAB_PACKS: 'Packs vendus',
    PACKS_EMPTY_TITLE: 'Aucun pack vendu',
    PACKS_EMPTY_TEXT: 'Les packs achetés par vos clients apparaîtront ici.',
    PACKS_EMPTY_CTA: 'Gérer mes packs',
    COPY_CODE: 'Copier le code',
    COPIED: 'Copié',
    CODE_COPIED: 'Code copié',
    COPY_ERROR: 'Impossible de copier le code',
    AMOUNT_USAGE: 'Montant utilisé',
    PRESTATIONS_LIST: 'Prestations',
    MANUAL_USE_BUTTON: 'Utiliser manuellement',
    DOWNLOAD_PDF: 'Télécharger le PDF',
    DETAIL_PDF_PENDING: 'PDF en cours de génération…',
    RECHARGE_BUTTON: 'Recharger',
    RECHARGE_TITLE: 'Recharger le coupon',
    RECHARGE_AMOUNT_LABEL: 'Montant à ajouter',
    RECHARGE_AMOUNT_PLACEHOLDER: 'Montant à créditer',
    RECHARGE_CURRENT_REMAINING: 'Solde actuel',
    RECHARGE_PRESTATIONS_LABEL: 'Quantités à ajouter',
    RECHARGE_REMAINING_LABEL: 'restant',
    RECHARGE_CANCEL: 'Annuler',
    RECHARGE_CONFIRM: 'Recharger',
    RECHARGE_LOADING: 'Rechargement…',
    RECHARGE_INVALID_AMOUNT: 'Veuillez saisir un montant valide à ajouter.',
    RECHARGE_NOTHING_TO_ADD: 'Veuillez saisir au moins une quantité à ajouter.',
    RECHARGE_SUCCESS: 'Le coupon a été rechargé.',
    RECHARGE_ERROR: 'Le rechargement du coupon a échoué.',
    MANUAL_USE_TITLE: 'Utilisation manuelle du coupon',
    MANUAL_USE_LOADING: 'Utilisation...',
    MANUAL_USE_SUCCESS: 'Coupon utilisé avec succès',
    MANUAL_USE_ERROR: "Impossible d'utiliser ce coupon",
    MANUAL_USE_ONLY_ACTIVE: 'Seuls les coupons actifs peuvent être utilisés',
    MANUAL_USE_SINGLE_USE_PARTIAL_WARNING: "Attention il s'agit d'un coupon à usage unique déjà utilisé",
    MANUAL_USE_NOTHING_TO_USE: 'Aucun montant ou prestation à utiliser',
    MANUAL_USE_INVALID_AMOUNT: 'Montant invalide à utiliser',
    MANUAL_USE_AMOUNT_LABEL: 'Montant à utiliser',
    MANUAL_USE_AMOUNT_PLACEHOLDER: 'Saisir un montant',
    MANUAL_USE_MAX: 'Maximum',
    MANUAL_USE_PREVIEW_TITLE: 'Aperçu après utilisation',
    MANUAL_USE_PREVIEW_REMAINING: 'Reste après utilisation',
    MANUAL_USE_PRESTATIONS_LABEL: 'Quantité à déduire par prestation',
    MANUAL_USE_REMAINING_LABEL: 'restant',
    MANUAL_USE_SELECTED_TOTAL: 'Total sélectionné',
    MANUAL_USE_CANCEL: 'Annuler',
    MANUAL_USE_CONFIRM: "Confirmer l'utilisation",
    MANUAL_USE_CONFIRM_ANYWAY: 'Utiliser quand même',
    MANUAL_USE_UNUSABLE_HINT: 'Vous pouvez quand même l’utiliser.',
    MANUAL_USE_NOT_ALLOWED: 'Votre rôle ne permet pas d’utiliser un coupon.',
    MANUAL_USE_NETWORK_RETRY: 'La connexion a été interrompue. Vérifiez le solde du coupon avant de réessayer.',
    MANUAL_USE_VIEW_DETAILS: 'Voir la fiche',
    SCAN_BUTTON: 'Scanner un coupon',
    SCAN_TITLE: 'Scanner un coupon',
    SCAN_DESCRIPTION: 'Présentez le QR code du coupon devant la caméra, ou saisissez son code ou le nom du client.',
    SCAN_CAMERA_STARTING: 'Ouverture de la caméra…',
    SCAN_CAMERA_SCANNING: 'Visez le QR code du coupon.',
    SCAN_CAMERA_DENIED:
      'L’accès à la caméra a été refusé. Autorisez-le dans les réglages du navigateur (icône à gauche de l’adresse) ou du téléphone, puis réessayez. Vous pouvez aussi saisir le code.',
    SCAN_CAMERA_NOT_FOUND: 'Aucune caméra n’est disponible sur cet appareil. Saisissez le code du coupon.',
    SCAN_CAMERA_BUSY: 'La caméra est déjà utilisée par une autre application. Fermez-la puis réessayez.',
    SCAN_CAMERA_INSECURE:
      'La caméra n’est disponible que sur une connexion sécurisée (https). Saisissez le code du coupon.',
    SCAN_CAMERA_UNSUPPORTED: 'Ce navigateur ne permet pas d’utiliser la caméra. Saisissez le code du coupon.',
    SCAN_CAMERA_UNKNOWN: 'La caméra n’a pas pu démarrer. Réessayez ou saisissez le code du coupon.',
    SCAN_DECODER_UNAVAILABLE: 'Le scanner n’a pas pu démarrer. Réessayez ou saisissez le code du coupon.',
    SCAN_CAMERA_PAUSED: 'Caméra en pause.',
    SCAN_RESUME: 'Reprendre la caméra',
    SCAN_RETRY: 'Réessayer',
    SCAN_HINT_NOTHING_DETECTED:
      'Aucun QR code détecté : rapprochez ou éloignez le coupon, améliorez la lumière, ou saisissez le code.',
    SCAN_UNRECOGNIZED: 'Ce QR code n’est pas celui d’un coupon. Saisissez le code imprimé.',
    SCAN_GIFT_CARD_PDF: 'Ce QR code ne contient pas le code du coupon. Saisissez le code imprimé sur la carte.',
    SCAN_OTHER_ESTABLISHMENT_HINT:
      'Ce coupon vient peut-être d’un autre de vos établissements : changez d’établissement puis réessayez.',
    SCAN_LOOKING_UP: 'Recherche du coupon…',
    SCAN_LOOKUP_ERROR: 'Impossible de rechercher ce coupon.',
    SCAN_MANUAL_LABEL: 'Code du coupon ou nom du client',
    SCAN_MANUAL_PLACEHOLDER: 'Ex. ABCDE-FGHJK-MNPQR-STUVW-XYZ23 ou Marie Dupont',
    SCAN_MANUAL_SUBMIT: 'Rechercher',
    SCAN_SEARCH_RESULTS: 'Coupons utilisables pour « {query} »',
    SCAN_SEARCH_NO_RESULT: 'Aucun coupon utilisable ne correspond à « {query} ».',
    SCAN_SEARCH_GIFT_FOR: 'Offert à {name}',
    SCAN_SEARCH_REMAINING: 'Solde {amount}',
    SCAN_SEARCH_EXPIRES: 'Valable jusqu’au {date}',
    SCAN_SEARCH_HIDDEN_UNUSABLE:
      '{count, plural, one {# coupon non utilisable masqué (épuisé, expiré ou annulé)} other {# coupons non utilisables masqués (épuisés, expirés ou annulés)}}',
    SCAN_OPEN_NATIVE: 'Ouvrir le scanner',
    SCAN_NATIVE_UNAVAILABLE: 'Le scanner n’est pas disponible sur cet appareil. Saisissez le code du coupon.',
    SCAN_NATIVE_PERMISSION_DENIED:
      'L’accès à l’appareil photo est refusé. Autorisez-le dans les Réglages du téléphone, ou saisissez le code du coupon.',
    SCAN_NATIVE_ERROR: 'Le scan n’a pas abouti. Réessayez ou saisissez le code du coupon.',
    DETAIL_TAB_INFO: 'Informations',
    DETAIL_TAB_HISTORY: "Historique d'utilisation",
    DETAIL_INFO_TYPE: 'Type',
    DETAIL_INFO_MULTIPLE_USAGE: 'Usage multiple',
    DETAIL_INFO_EXPIRATION: "Date d'expiration",
    DETAIL_INFO_CREATED_AT: 'Créé le',
    DETAIL_INFO_INITIAL_AMOUNT: 'Montant initial',
    DETAIL_INFO_REMAINING_AMOUNT: 'Montant restant',
    DETAIL_INFO_USAGE_PERCENT: 'Utilisé',
    DETAIL_INFO_PACK: 'Pack',
    DETAIL_GIFT_SECTION: 'Informations cadeau',
    DETAIL_GIFT_RECIPIENT: 'Destinataire',
    DETAIL_GIFT_EMAIL: 'Email cadeau',
    DETAIL_GIFT_PHONE: 'Téléphone cadeau',
    DETAIL_GIFT_MESSAGE: 'Message cadeau',
    LIST_GIFT_BUYER: 'Acheté par',
    LIST_GIFT_RECIPIENT: 'Offert à',
    DETAIL_HISTORY_EMPTY: 'Aucune utilisation enregistrée',
    DETAIL_HISTORY_AMOUNT: 'Montant déduit',
    DETAIL_HISTORY_RECHARGE_AMOUNT: 'Montant rechargé',
    DETAIL_HISTORY_QUANTITY: 'Quantité déduite',
    DETAIL_HISTORY_APPOINTMENT: 'Rendez-vous n°',
    DETAIL_HISTORY_APPOINTMENT_LINK: 'Voir le rendez-vous',
    DETAIL_HISTORY_CANCELLED_BADGE: 'Utilisation annulée',
    DETAIL_HISTORY_CANCELLED_AT: 'Annulée le',
    TAB_SHOP_SETTINGS: 'Paramètres boutique',
    SHOP_SETTINGS_TITLE: 'Paramètres de la boutique en ligne',
    SHOP_SETTINGS_DESCRIPTION: 'Configurez les options de vente de cartes cadeaux sur votre site internet.',
    SHARE_LINK_TITLE: 'Lien du tunnel d’achat',
    SHARE_LINK_HINT: 'Partagez ce lien pour que vos clients achètent une carte cadeau.',
    SHARE_LINK_COPY: 'Copier le lien',
    SHARE_LINK_COPIED: 'Lien copié !',
    EMBED_TITLE: 'Intégrer sur votre site',
    EMBED_HINT: 'Générez un lien partageable ou le code à coller sur votre site pour vendre des cartes cadeaux.',
    EMBED_APPEARANCE_HINT: 'Personnalisez les couleurs et l’arrondi du tunnel de carte cadeau.',
    EMBED_SNIPPET_STEP1_HINT: 'Ajoutez ce code à l’emplacement où vous souhaitez afficher l’achat de carte cadeau.',
    EMBED_COPY: 'Copier le code',
    EMBED_COPIED: 'Code copié !',
    CUSTOMIZE_CARD_TITLE: 'Apparence de la carte cadeau (PDF)',
    CUSTOMIZE_CARD_HINT:
      'Personnalisez le PDF envoyé à l’acheteur et au destinataire (logo, textes, couleurs, QR code).',
    CUSTOMIZE_CARD_BUTTON: 'Personnaliser la carte',
    CARD_EDITOR_TITLE: 'Personnaliser la carte cadeau',
    CARD_EDITOR_DESC: 'Éditez le PDF de carte cadeau envoyé à vos clients.',
    CARD_EDITOR_COMPONENT_QR: 'QR code',
    CARD_EDITOR_COMPONENT_VALUE: 'Contenu de la carte',
    CARD_EDITOR_TEMPLATES: 'Modèles',
    CARD_EDITOR_CHOOSE_TEMPLATE: 'Choisir un modèle de carte',
    // Modèles de carte cadeau (clés dérivées de l'id, cf. `giftCardTemplateTranslationKey`).
    GIFT_CARD_TEMPLATE_GC_CLASSIQUE_NAME: 'Classique',
    GIFT_CARD_TEMPLATE_GC_CLASSIQUE_LABEL: 'Sobre et élégante, en noir et blanc : va avec tous les logos',
    GIFT_CARD_TEMPLATE_GC_CLASSIQUE_OCCASION: 'Toute occasion',
    GIFT_CARD_TEMPLATE_GC_NOIR_ET_OR_NAME: 'Noir & or',
    GIFT_CARD_TEMPLATE_GC_NOIR_ET_OR_LABEL: 'Fond noir, lettrage doré : l’effet « coffret de luxe »',
    GIFT_CARD_TEMPLATE_GC_NOIR_ET_OR_OCCASION: 'Toute occasion, premium',
    GIFT_CARD_TEMPLATE_GC_BIEN_ETRE_NAME: 'Bien-être',
    GIFT_CARD_TEMPLATE_GC_BIEN_ETRE_LABEL: 'Vert sauge et sable : douceur, calme, nature',
    GIFT_CARD_TEMPLATE_GC_BIEN_ETRE_OCCASION: 'Spa, massage, soins, bien-être',
    GIFT_CARD_TEMPLATE_GC_NOEL_NAME: 'Noël',
    GIFT_CARD_TEMPLATE_GC_NOEL_LABEL: 'Vert sapin et rouge : la carte de Noël',
    GIFT_CARD_TEMPLATE_GC_NOEL_OCCASION: 'Noël et fêtes de fin d’année',
    GIFT_CARD_TEMPLATE_GC_SAINT_VALENTIN_NAME: 'Saint-Valentin',
    GIFT_CARD_TEMPLATE_GC_SAINT_VALENTIN_LABEL: 'Rose poudré et framboise : pour la fête des amoureux',
    GIFT_CARD_TEMPLATE_GC_SAINT_VALENTIN_OCCASION: 'Saint-Valentin, anniversaire de couple',
    GIFT_CARD_TEMPLATE_GC_FETE_DES_MERES_NAME: 'Fête des mères',
    GIFT_CARD_TEMPLATE_GC_FETE_DES_MERES_LABEL: 'Rose tendre et or rose : tout en douceur',
    GIFT_CARD_TEMPLATE_GC_FETE_DES_MERES_OCCASION: 'Fête des mères',
    GIFT_CARD_TEMPLATE_GC_FETE_DES_PERES_NAME: 'Fête des pères',
    GIFT_CARD_TEMPLATE_GC_FETE_DES_PERES_LABEL: 'Bleu nuit et cuivre : élégant et masculin',
    GIFT_CARD_TEMPLATE_GC_FETE_DES_PERES_OCCASION: 'Fête des pères',
    GIFT_CARD_TEMPLATE_GC_ANNIVERSAIRE_NAME: 'Anniversaire',
    GIFT_CARD_TEMPLATE_GC_ANNIVERSAIRE_LABEL: 'Violet et corail : festive et joyeuse',
    GIFT_CARD_TEMPLATE_GC_ANNIVERSAIRE_OCCASION: 'Anniversaire',
    GIFT_CARD_TEMPLATE_GC_MERCI_NAME: 'Merci',
    GIFT_CARD_TEMPLATE_GC_MERCI_LABEL: 'Bleu ciel et marine : pour remercier quelqu’un',
    GIFT_CARD_TEMPLATE_GC_MERCI_OCCASION: 'Remerciement, départ, collègue',
    GIFT_CARD_TEMPLATE_GC_PRINTEMPS_NAME: 'Printemps',
    GIFT_CARD_TEMPLATE_GC_PRINTEMPS_LABEL: 'Pastel vert d’eau et pêche : frais et léger',
    GIFT_CARD_TEMPLATE_GC_PRINTEMPS_OCCASION: 'Printemps, Pâques, renouveau',
    GIFT_CARD_TEMPLATE_GC_BORDEAUX_NAME: 'Bordeaux chic',
    GIFT_CARD_TEMPLATE_GC_BORDEAUX_LABEL: 'Bordeaux profond et crème : chaleureux et raffiné',
    GIFT_CARD_TEMPLATE_GC_BORDEAUX_OCCASION: 'Toute occasion, automne-hiver',
    GIFT_CARD_TEMPLATE_GC_PHOTO_NAME: 'Avec votre photo',
    GIFT_CARD_TEMPLATE_GC_PHOTO_LABEL: 'Votre propre photo d’établissement en bandeau : la carte à votre image',
    GIFT_CARD_TEMPLATE_GC_PHOTO_OCCASION: 'Toute occasion',
    CARD_EDITOR_CHOOSE_TEMPLATE_HINT:
      'Le modèle remplace votre carte actuelle dans l’éditeur. Rien ne change tant que vous n’avez pas enregistré.',
    CARD_EDITOR_RESET: "Revenir au modèle d'origine",
    CARD_EDITOR_RESET_CONFIRM_TITLE: "Revenir au modèle d'origine ?",
    CARD_EDITOR_RESET_CONFIRM_TEXT:
      'Votre personnalisation sera remplacée par le modèle proposé par défaut. Rien ne change tant que vous n’avez pas enregistré.',
    CARD_EDITOR_RESET_CONFIRM: 'Revenir au modèle',
    CARD_EDITOR_PREVIEW_PDF: 'Aperçu PDF',
    CARD_EDITOR_PREVIEW_PDF_TITLE: 'Aperçu du PDF',
    CARD_EDITOR_PREVIEW_PDF_OPEN: 'Ouvrir le PDF dans un nouvel onglet',
    CARD_EDITOR_QR_REQUIRED_TITLE: 'Le QR code est obligatoire',
    CARD_EDITOR_QR_REQUIRED_TEXT: 'Déplacez-le ou changez sa légende : le destinataire le scanne pour réserver.',
    // Données d'exemple de l'aperçu PDF (générées côté serveur, cf. VoucherService.previewGiftCardPdf).
    CARD_PREVIEW_SAMPLE_RECIPIENT: 'Marie',
    CARD_PREVIEW_SAMPLE_MESSAGE: 'Joyeux anniversaire !',
    CARD_PREVIEW_SAMPLE_PRESTATION: 'Massage relaxant',
    SHOP_SETTINGS_SECTION_AMOUNT: 'Montant libre',
    SHOP_SETTINGS_SECTION_PRESTATIONS: 'Prestations',
    SHOP_SETTINGS_PRESTATION_MODE_LABEL: "Permettre l'achat de prestation(s)",
    SHOP_SETTINGS_PRESTATION_MODE_NONE: 'Aucune prestation',
    SHOP_SETTINGS_PRESTATION_MODE_ALL: 'Toutes les prestations',
    SHOP_SETTINGS_PRESTATION_MODE_SELECTED: 'Sélection de prestations',
    SHOP_SETTINGS_SECTION_PACKS: 'Packs',
    SHOP_SETTINGS_ALLOW_PACKS: "Permettre l'achat de packs",
    SHOP_SETTINGS_SECTION_VALIDITY: 'Validité et utilisation',
    SHOP_SETTINGS_VALIDITY_MONTHS: 'Durée de validité après achat (en mois)',
    SHOP_SETTINGS_MULTIPLE_USAGE: 'Les bons sont utilisables en plusieurs fois',
    SHOP_SETTINGS_RESTORE_VOUCHER_ON_CANCEL: 'Restituer le bon si le client annule sa réservation',
    SHOP_SETTINGS_RESTORE_VOUCHER_ON_CANCEL_HINT:
      "Si activé, le bon est re-crédité lorsque l'annulation a lieu avant le délai d'annulation. Si désactivé, le bon n'est jamais restitué. Sans effet sur les réservations déjà confirmées.",
    TERMS_SECTION_TITLE: 'Conditions de vente (CGV)',
    TERMS_SECTION_DESC: 'PDF affiché et à accepter par l’acheteur avant le paiement (facultatif).',
    TERMS_UPLOAD: 'Ajouter un PDF',
    TERMS_REPLACE: 'Remplacer',
    TERMS_REMOVE: 'Supprimer',
    TERMS_VIEW: 'Ouvrir le PDF des conditions de vente',
    TERMS_INVALID_TYPE: 'Le fichier doit être un PDF.',
    RESEND_BUTTON: 'Renvoyer l’email',
    RESEND_TITLE: 'Renvoyer la carte cadeau',
    RESEND_TARGET_RECIPIENT: 'Au destinataire',
    RESEND_TARGET_BUYER: 'À l’acheteur',
    RESEND_RECIPIENT: 'Destinataire :',
    RESEND_EMAIL_LABEL: 'Email du destinataire',
    RESEND_BUYER_HINT: 'L’email d’achat (code + PDF) sera renvoyé à l’acheteur',
    RESEND_HINT: 'La carte (code + PDF) sera renvoyée par email.',
    RESEND_CANCEL: 'Annuler',
    RESEND_CONFIRM: 'Renvoyer',
    RESEND_SUCCESS: 'Email renvoyé',
    SHOP_SETTINGS_SECTION_DISPLAY: 'Affichage',
    SHOP_SETTINGS_DISPLAY_TEXT: 'Mentions à afficher sur la carte',
    SHOP_SETTINGS_DISPLAY_TEXT_PLACEHOLDER: 'Ex: Valable dans tous nos établissements...',
    SHOP_SETTINGS_BANNER_IMAGE: 'Image de bannière',
    SHOP_SETTINGS_SAVE_SUCCESS: 'Paramètres enregistrés avec succès',
    SHOP_SETTINGS_MANAGE_PACKS: 'Gérer mes packs',
    SHOP_SETTINGS_SELECTED_COUNT: '{count} prestation(s) sélectionnée(s)',
    INPUT_TITLE_GIFT_ALLOW_AMOUNT: "Permettre l'achat d'un montant libre",
    INPUT_TITLE_GIFT_AMOUNT_MIN: 'Montant libre minimal',
    INPUT_PLACEHOLDER_GIFT_AMOUNT_MIN: 'Ex: 5€',
    INPUT_TITLE_GIFT_AMOUNT_MAX: 'Montant libre maximal',
    INPUT_PLACEHOLDER_GIFT_AMOUNT_MAX: 'Ex: 500€',
    AMOUNT_MIN_HINT: 'Montant minimum : 1 €.',
    AMOUNT_TOO_LOW: 'Le montant d’une carte cadeau doit être d’au moins 1 €.',
    AMOUNT_MAX_BELOW_MIN: 'Le montant maximal doit être supérieur ou égal au montant minimal.',
    INPUT_TITLE_GIFT_DEFAULT_VALIDITY: 'Durée de validité après achat (en mois)',
    INPUT_PLACEHOLDER_GIFT_DEFAULT_VALIDITY: 'Ex: 6',
    INPUT_TITLE_GIFT_DEFAULT_MULTIPLE_USAGE: 'Bons utilisables en plusieurs fois',
    INPUT_TITLE_GIFT_RESTORE_VOUCHER_ON_CANCEL: "Restituer le bon en cas d'annulation par le client",
  },
  PROFESSIONAL_APP_PRO_PAYMENT_PAGE: {
    TITLE: 'Demandes de paiement',
    CREATE_PAYMENT_REQUEST: 'Nouvelle demande',
    AMOUNT_LABEL: 'Montant',
    AMOUNT_PLACEHOLDER: 'Ex: 50,00',
    DESCRIPTION_LABEL: 'Description (optionnel)',
    DESCRIPTION_PLACEHOLDER: 'Ex: Consultation du 25 mars',
    SELECT_CUSTOMER: 'Sélectionner un client',
    LINK_TO_APPOINTMENT: 'Lier à un rendez-vous (optionnel)',
    SELECT_APPOINTMENT: 'Sélectionner un rendez-vous',
    SEND_PAYMENT_REQUEST: 'Créer la demande',
    PAYMENT_LINK_COPIED: 'Lien de paiement copié !',
    COPY_LINK: 'Copier le lien',
    SHARE_LINK_TITLE: 'Partager le lien de paiement',
    SHARE_LINK_SECTION_TITLE: 'Lien de paiement client',
    SHARE_LINK_HINT:
      'Envoyez ce lien au client, ou présentez-lui le QR code : il le scanne avec son téléphone pour payer.',
    SHARE_LINK_OPEN: 'Ouvrir',
    SHARE_LINK_ACTION: 'Partager le lien',
    SHARE_LINK_QR_ALT: 'QR code du lien de paiement',
    // Envoi du lien au client (notification « Demande de paiement » des messages automatiques).
    SEND_LINK_SECTION_TITLE: 'Envoyer au client',
    SEND_LINK_EMAIL: 'Envoyer par email',
    SEND_LINK_SMS: 'Envoyer par SMS',
    SEND_LINK_EMAIL_SUCCESS: 'Lien envoyé par email à {contact}.',
    SEND_LINK_SMS_SUCCESS: 'Lien envoyé par SMS au {contact}.',
    SEND_LINK_NO_EMAIL: "Ce client n'a pas d'adresse email.",
    SEND_LINK_NO_PHONE: "Ce client n'a pas de numéro de téléphone.",
    SEND_LINK_LAST_SENT_EMAIL: 'Envoyé par email le {date}',
    SEND_LINK_LAST_SENT_SMS: 'Envoyé par SMS le {date}',
    SEND_LINK_DISABLED: "L'envoi du lien au client est désactivé dans vos messages automatiques.",
    SEND_LINK_EDIT_MESSAGE: 'Modifier le message envoyé',
    SEND_LINK_ENABLE: "Activer l'envoi",
    MODIFY_AMOUNT: 'Modifier le montant',
    MODIFY_AMOUNT_TITLE: 'Modifier le montant du paiement',
    MODIFY_AMOUNT_DESCRIPTION:
      'Le client verra immédiatement le nouveau montant sur le lien de paiement. Cette action est uniquement disponible tant que le paiement est en attente.',
    MODIFY_AMOUNT_CONFIRM: 'Mettre à jour',
    MODIFY_AMOUNT_SUCCESS: 'Montant du paiement mis à jour.',
    CAPTURE_PAYMENT: 'Encaisser le paiement',
    CAPTURE_PAYMENT_TITLE: "Encaisser l'empreinte bancaire",
    CAPTURE_PAYMENT_SUCCESS: 'Paiement encaissé avec succès.',
    CAPTURE_PAYMENT_CONFIRM: 'Confirmer l’encaissement',
    CAPTURE_AUTHORIZED_MAX_LABEL: 'Montant maximum autorisé',
    CAPTURE_CUSTOM_AMOUNT_PLACEHOLDER: 'Ex: 25,00',
    CAPTURE_CUSTOM_AMOUNT_PLACEHOLDER_MAX: 'Maximum {amount}',
    CAPTURE_AMOUNT_EXCEEDS: 'Le montant dépasse le montant maximum autorisé',
    CAPTURE_OPTION_LATE_CANCEL: "Pénalité d'annulation tardive",
    CAPTURE_OPTION_FULL: 'Prélever la totalité',
    CAPTURE_BOOKING_POLICY_TITLE: 'Ce rendez-vous est lié à une réservation',
    CAPTURE_BOOKING_TOO_EARLY:
      "Il est encore tôt pour prélever : selon votre politique d'annulation, le client peut annuler sans frais jusqu'au {date}.",
    CAPTURE_BOOKING_DEADLINE_PASSED:
      "Le délai d'annulation est dépassé (depuis le {date}). Vous pouvez prélever l'empreinte si le client a annulé tardivement ou ne s'est pas présenté.",
    REFUND_PAYMENT: 'Rembourser',
    REFUND_PAYMENT_TITLE: 'Rembourser le paiement',
    REFUND_PAYMENT_SUCCESS: 'Remboursement effectué avec succès.',
    REFUND_PAYMENT_CONFIRM: 'Confirmer le remboursement',
    REFUND_OPTION_FULL: 'Montant total restant',
    REFUND_OPTION_BOOKING_POLICY: "Rembourser selon ma politique d'annulation",
    REFUND_OPTION_EXCL_STRIPE: 'Hors frais bancaires',
    REFUND_OPTION_EXCL_CFIXE: `Hors frais ${PROJECT_CONFIG.brand_string}`,
    REFUND_OPTION_CUSTOM: 'Montant libre',
    REFUND_CUSTOM_AMOUNT_LABEL: 'Montant à rembourser',
    REFUND_CUSTOM_AMOUNT_PLACEHOLDER: 'Ex: 25,00',
    REFUND_CUSTOM_AMOUNT_PLACEHOLDER_MAX: 'Maximum {amount}',
    REFUND_AMOUNT_EXCEEDS: 'Le montant dépasse le montant remboursable',
    REFUND_STRIPE_FEE_WARNING:
      'Le montant remboursé dépasse le montant hors frais bancaires. Les frais bancaires non couverts seront à votre charge.',
    REFUND_BOOKING_POLICY_WARNING: 'Ce rendez-vous est lié à une réservation',
    REFUND_BOOKING_POLICY_CURRENT_ALLOWED:
      "Selon votre politique d'annulation, le client peut actuellement être remboursé jusqu'à {amount}.",
    REFUND_BOOKING_POLICY_DETAILS: "Jusqu'au {date} : {amountInTime}. Après cette date : {amountOutTime}.",
    REFUND_STRIPE_FEE_LABEL: 'Frais Stripe',
    REFUND_APPLICATION_FEE_LABEL: `Frais ${PROJECT_CONFIG.brand_string}`,
    PAYMENT_FEES_LABEL: 'Frais déduits',
    PAYMENT_FEES_SUMMARY: `Stripe : {stripeFee} · ${PROJECT_CONFIG.brand_string} : {applicationFee}`,
    PAYMENT_FEES_SUMMARY_MANUAL: `Aucun frais Stripe · ${PROJECT_CONFIG.brand_string} : {applicationFee}`,
    PAYMENT_FEES_STRIPE_UNAVAILABLE: 'non disponibles',
    PAYMENT_FEES_OPEN_EXPLANATION: 'Comprendre les frais déduits',
    PAYMENT_FEES_EXPLANATION_TITLE: 'Pourquoi y a-t-il des frais ?',
    PAYMENT_FEES_EXPLANATION_STRIPE:
      'Les frais Stripe correspondent au traitement et à la sécurisation du paiement. Leur montant peut varier selon le moyen de paiement, le type de carte, son pays d’émission et la devise utilisée.',
    PAYMENT_FEES_EXPLANATION_PROPELSIA_ZERO: `${PROJECT_CONFIG.brand_string} ne prélève aucune commission sur vos encaissements.`,
    PAYMENT_FEES_EXPLANATION_PROPELSIA_WITH_FEE: `Le montant prélevé par ${PROJECT_CONFIG.brand_string} pour ce paiement est indiqué dans le détail des frais.`,
    PAYMENT_FEES_VIEW_STRIPE_PRICING: 'Consulter les tarifs Stripe',
    REFUND_ALREADY_REFUNDED_LABEL: 'Déjà remboursé',
    AMOUNT_WITH_REFUND: 'dont {amount} remboursé',
    CANCEL_PAYMENT: 'Annuler la demande',
    CANCEL_PAYMENT_CONFIRM: 'Êtes-vous sûr de vouloir annuler cette demande de paiement ?',
    CANCEL_OR_RELEASE_PAYMENT: "Annuler ou libérer l'empreinte",
    CANCEL_OR_RELEASE_PAYMENT_CONFIRM:
      "Êtes-vous sûr de vouloir annuler cette demande de paiement ou libérer l'empreinte bancaire associée ?",
    STRIPE_CONNECT_REQUIRED: 'Vous devez configurer Stripe Connect pour recevoir des paiements',
    // Bandeau « soft » du même modèle que les cartes cadeaux : la liste des paiements
    // reste consultable (encaissements manuels, historique), seul l'encaissement en
    // ligne est indisponible tant que Stripe n'est pas activé.
    STRIPE_REQUIRED_CONNECT_BUTTON: 'Connecter mon compte Stripe',
    STRIPE_INACTIVE_NOTICE_TITLE: 'Paiements en ligne non activés',
    STRIPE_INACTIVE_NOTICE_TEXT:
      "Vous pouvez consulter vos paiements et déclarer des encaissements sur place dès maintenant. En revanche, vos clients ne pourront pas payer en ligne tant que vous n'aurez pas activé les paiements avec Stripe.",
    COMMISSION_LABEL: 'Commission plateforme',
    NET_AMOUNT_LABEL: 'Montant net',
    DETAIL_TITLE: 'Détail du paiement',
    DETAIL_NAME_LABEL: 'Nom',
    DETAIL_EMAIL_LABEL: 'Email',
    DETAIL_DESCRIPTION_LABEL: 'Description',
    DETAIL_PRESTATIONS_LABEL: 'Prestations',
    DETAIL_CREATED_AT_LABEL: 'Créé le',
    DETAIL_PAID_AT_LABEL: 'Payé le',
    // Statut de virement ESTIMÉ (date de disponibilité des fonds + calendrier de virement
    // du compte Stripe Connect) : non affiché quand le backend ne sait pas l'estimer.
    // « Envoyé » et non « reçu » : la banque peut mettre quelques jours ouvrés à créditer le virement.
    PAYOUT_LABEL: 'Virement',
    PAYOUT_STATUS_PAID_OUT: 'Virement envoyé à votre banque (estimation)',
    PAYOUT_STATUS_NOT_PAID_OUT: 'Virement à venir (estimation)',
    PAYOUT_ESTIMATE_HINT:
      "Estimation d'après la date de disponibilité des fonds et la fréquence de virement de votre compte Stripe. Votre banque peut mettre quelques jours ouvrés à créditer le virement ; le suivi réel est dans Entreprise › Comptes de paiements.",
    DETAIL_FINANCIAL_SECTION: 'Détails financiers',
    DETAIL_CAPTURED_LABEL: 'Montant initial',
    DETAIL_REFUNDABLE_LABEL: 'Montant remboursable',
    DETAIL_STILL_CAPTURED_LABEL: 'Encore encaissé',
    DETAIL_CANCEL_SUCCESS: 'Demande de paiement annulée.',
    DETAIL_VIEW_CUSTOMER: 'Voir la fiche',
    DETAIL_RESERVATION_LABEL: 'Réservation',
    DETAIL_VIEW_RESERVATION: 'Voir la réservation',
    DETAIL_VOUCHER_LABEL: 'Coupon',
    DETAIL_VIEW_VOUCHER: 'Voir le coupon',
    // Vente d'une réservation remisée (promotion, remise libre) : badge de la ligne, détail des montants de la fiche.
    DISCOUNT_BADGE: 'Remise',
    DETAIL_AMOUNTS_SECTION: 'Montants de la réservation',
    REFUND_CANCEL_VOUCHER_LABEL: 'Annuler aussi le coupon associé',
    REFUND_RESTORE_USED_VOUCHER_LABEL: 'Restituer aussi le bon utilisé ({code})',
    REFUND_RESTORE_USED_VOUCHER_LABEL_WITH_AMOUNT: 'Restituer aussi le bon utilisé ({code} · {amount})',
    REFUND_REMOVED_VEHICLE_LABEL: 'Ce remboursement correspond à un véhicule retiré',
    REFUND_REMOVED_VEHICLE_HELP:
      'Le reste à encaisser sera recalculé : nouveau total de la course moins ce que le client aura payé après ce remboursement.',
    REFUND_VOUCHER_CANCEL_FAILED: "Remboursement effectué, mais l'annulation du coupon a échoué.",
    NO_PAYMENTS: 'Aucune demande de paiement',
    NO_PAYMENTS_DESC: 'Créez votre première demande de paiement pour encaisser vos clients.',
    FILTER_TITLE: 'Filtrer par statut',
    CUSTOMER_LABEL: 'Client',
    TYPE_LABEL: 'Type',
    DATE_PAY_LABEL: 'Date de paiement',
    STATUS_LABEL: 'Statut',
    ACTIONS_LABEL: 'Actions',
    DETAILS_TAB: 'Détails',
    HISTORY_TAB: 'Historique',
    HISTORY_NO_EVENTS: 'Aucun événement',
    HISTORY_EVENT_DETAIL: 'Détail',
    RETRY_CAPTURE_SUCCESS: 'Prélèvement effectué avec succès.',
    ...ProPaymentTypeTranslation['fr-FR'],
    ...ProPaymentStatusTranslation['fr-FR'],
    ...ProPaymentOriginTranslation['fr-FR'],
    ...ProPaymentEventTypeTranslation['fr-FR'],
  },
  PRO_PAYMENT_PUBLIC_PAGE: {
    INVALID_PAYMENT_LINK: 'Lien de paiement invalide',
    PAY_TO: 'Payer à',
    PAYMENT_FOR: 'Paiement pour',
    PAY_NOW: 'Payer maintenant',
    PAYMENT_SUCCESS: 'Paiement effectué avec succès !',
    PAYMENT_SUCCESS_DESC:
      'Merci ! Votre paiement a bien été pris en compte et le professionnel vient d’être informé du règlement.',
    PAYMENT_EXPIRED: 'Ce lien de paiement a expiré',
    PAYMENT_EXPIRED_DESC: 'Veuillez contacter le professionnel pour obtenir un nouveau lien.',
    PAYMENT_ALREADY_PAID: 'Ce paiement a déjà été effectué',
    PAYMENT_CANCELLED: 'Ce paiement a été annulé',
    LOADING: 'Chargement...',
    ERROR_GENERIC: 'Une erreur est survenue',
    LINK_NOT_PAYABLE: "Ce lien de paiement n'est plus valable : le rendez-vous a été annulé.",
    BANK_IMPRINT_CARD_NOTICE:
      'Votre carte sera enregistrée pour garantir votre rendez-vous. En cas de non-présentation, le montant pourra être prélevé.',
    ORDER_SUMMARY: 'Détail de la commande',
    TOTAL: 'Total à payer',
    EXPIRES_AT: 'Lien valable jusqu’au',
    SECURE_PAYMENT: 'Paiement sécurisé via Stripe',
    QUANTITY_SHORT: 'Qté',
    PAYMENT_VERIFYING: 'Vérification du paiement en cours...',
    // Retour de redirection Stripe (Klarna…) : issue du paiement vue depuis l'URL, confirmée par le backend.
    PAYMENT_REDIRECT_FAILED:
      'Le paiement a échoué ou a été annulé. Vous pouvez choisir un autre moyen de paiement ou réessayer.',
    PAYMENT_REDIRECT_PENDING:
      'Votre paiement est en cours de validation. Vous recevrez une confirmation dès qu’il sera finalisé.',
    PAYMENT_REDIRECT_EXPIRED:
      "Ce paiement n'est plus valable. Si vous avez été débité, vous serez remboursé automatiquement.",
    PAYMENT_REDIRECT_UNVERIFIED:
      "La confirmation de votre paiement prend plus de temps que prévu. Nous continuons à vérifier : avant de réessayer, vérifiez auprès de votre banque que vous n'avez pas été débité.",
  },
  GIFT_CARD_PUBLIC_PAGE: {
    TITLE: 'Carte cadeau',
    SUBTITLE: 'Offrez ou achetez une carte cadeau',
    POWERED_BY: 'Propulsé par',
    // État vide convivial du tunnel quand aucun achat de carte cadeau n'est possible.
    UNAVAILABLE_TITLE: 'Pas de carte cadeau pour le moment',
    UNAVAILABLE_DESC:
      'Ce professionnel ne propose pas encore de carte cadeau à l’achat. N’hésitez pas à revenir bientôt !',
    // Variante scope pack (page « Packs ») : copie adaptée, le tunnel est réutilisé tel quel.
    UNAVAILABLE_TITLE_PACK: 'Pas de pack pour le moment',
    UNAVAILABLE_DESC_PACK:
      'Ce professionnel ne propose pas encore de pack à l’achat. N’hésitez pas à revenir bientôt !',
    LOADING: 'Chargement...',
    ERROR_GENERIC: 'Une erreur est survenue, veuillez réessayer.',
    CHOOSE_TYPE: 'Que souhaitez-vous offrir ?',
    TYPE_AMOUNT: 'Un montant',
    TYPE_PRESTATION: 'Des prestations',
    TYPE_PACK: 'Un pack',
    AMOUNT_LABEL: 'Montant',
    AMOUNT_CUSTOM: 'Autre montant',
    AMOUNT_RANGE: 'Montant autorisé',
    SELECT_PRESTATION: 'Choisissez une ou plusieurs prestations',
    SELECT_PACK: 'Choisissez un pack',
    VALIDITY_NOTICE: 'Valable {months} mois à compter de l’achat',
    TERMS_ACCEPT: 'J’accepte les conditions de vente',
    TERMS_READ: 'lire les conditions',
    CHOOSE: 'Choisir',
    SELECTED: 'Sélectionné',
    REMOVE: 'Supprimer',
    QUANTITY: 'Quantité',
    IS_GIFT_QUESTION: 'C’est un cadeau ?',
    RECIPIENT_NAME: 'Nom du destinataire',
    RECIPIENT_EMAIL: 'Email du destinataire',
    RECIPIENT_PHONE: 'Téléphone du destinataire (optionnel)',
    GIFT_MESSAGE: 'Votre message (optionnel)',
    GIFT_SEND_DATE: 'Date d’envoi (optionnel)',
    BUYER_SECTION: 'Vos coordonnées',
    BUYER_FIRSTNAME: 'Prénom',
    BUYER_LASTNAME: 'Nom',
    BUYER_EMAIL: 'Email',
    BUYER_PHONE: 'Téléphone (optionnel)',
    INVALID_EMAIL: 'Email invalide',
    TOTAL: 'Total',
    CONTINUE: 'Continuer',
    // Étapes du tunnel (parcours en 2 étapes : sélection → coordonnées + cadeau → paiement)
    STEP_SELECTION_TITLE: 'Votre carte cadeau',
    STEP_SELECTION_TITLE_PACK: 'Votre pack',
    STEP_DETAILS_TITLE: 'Vos informations',
    STEP_PAYMENT_TITLE: 'Paiement',
    BACK: 'Retour',
    GO_TO_PAYMENT: 'Continuer vers le paiement',
    INVALID_RECIPIENT_EMAIL: 'Email du destinataire invalide',
    // Mini-panier
    SUMMARY_TITLE: 'Votre sélection',
    AMOUNT_LINE_LABEL: 'Carte cadeau',
    FOR_RECIPIENT: 'Pour',
    ITEM_SINGULAR: 'article',
    ITEM_PLURAL: 'articles',
    SHOW_DETAIL: 'Voir le détail',
    HIDE_DETAIL: 'Masquer le détail',
    CLOSE: 'Fermer',
    // Réassurance + paiement Stripe inline
    PAY_NOW: 'Payer',
    SECURE_PAYMENT: 'Paiement sécurisé',
    PAYMENT_METHODS_ACCEPTED: 'Moyens de paiement acceptés',
    PAYMENT_FINALIZING: 'Validation du paiement…',
    // Affiché si la confirmation du paiement n'arrive pas dans le délai imparti (webhook en retard) :
    // on n'affirme pas que le paiement est réglé, on invite à patienter / réessayer la vérification.
    PAYMENT_VERIFYING: 'Vérification du paiement en cours, cela peut prendre quelques instants…',
    // Retour de redirection Stripe (Klarna…) : issue du paiement vue depuis l'URL, confirmée par le backend.
    PAYMENT_REDIRECT_FAILED:
      'Le paiement a échoué ou a été annulé. Vous pouvez choisir un autre moyen de paiement ou réessayer.',
    PAYMENT_REDIRECT_PENDING:
      'Votre paiement est en cours de validation. Vous recevrez une confirmation dès qu’il sera finalisé.',
    PAYMENT_REDIRECT_EXPIRED:
      'Votre commande a expiré pendant le paiement. Si vous avez été débité, vous serez remboursé automatiquement. Vous pouvez recommencer.',
    PAYMENT_REDIRECT_UNVERIFIED:
      "La confirmation de votre paiement prend plus de temps que prévu. Nous continuons à vérifier : avant de réessayer, vérifiez auprès de votre banque que vous n'avez pas été débité.",
    RETRY: 'Réessayer',
    PHOTO_PREVIOUS: 'Photo précédente',
    PHOTO_NEXT: 'Photo suivante',
    CONFIRM_TITLE: 'Votre carte cadeau est prête !',
    CONFIRM_TITLE_GIFT: 'Votre carte cadeau est en route !',
    CONFIRM_TITLE_PACK: 'Votre achat est confirmé !',
    CONFIRM_DESC: 'Merci pour votre achat.',
    CONFIRM_DESC_GIFT: 'Le destinataire recevra sa carte par email.',
    CONFIRM_DESC_PACK: 'Merci pour votre achat. Retrouvez votre code ci-dessous.',
    CONFIRM_RECAP_TITLE: 'Récapitulatif',
    CONFIRM_CODE: 'Code de la carte',
    CONFIRM_COPY_CODE: 'Copier le code',
    CONFIRM_CODE_COPIED: 'Copié !',
    CONFIRM_DOWNLOAD: 'Télécharger le PDF',
    CONFIRM_EXPIRES: 'Valable jusqu’au',
    CONFIRM_PENDING: 'Paiement en cours de validation...',
    CONFIRM_PDF_PENDING: 'Votre carte PDF est en cours de génération, le lien apparaîtra ici dans quelques instants.',
  },
  // Emails d'achat de bon / carte cadeau (VOUCHER_PURCHASED) — libellés résolus côté serveur par
  // binding-resolver.ts. Wording neutre pour un forfait acheté pour soi, « carte cadeau » sinon.
  // `{pro}` est remplacé par le nom du professionnel au rendu.
  VOUCHER_PURCHASE_EMAIL: {
    SUBJECT_PACK: 'Votre achat chez {pro} est confirmé',
    SUBJECT_GIFT: 'Votre carte cadeau {pro}',
    TITLE_PACK: 'Votre achat est confirmé',
    TITLE_GIFT: 'Votre carte cadeau est prête',
    ACTIVATION_NOTE: 'Votre carte cadeau est désormais active.',
    DOWNLOAD_BUTTON_GIFT: 'Voir ma carte cadeau',
    DOWNLOAD_BUTTON_PACK: 'Voir mon forfait',
  },
  // Textes du PDF de carte cadeau rendus côté serveur (bindings `{{voucher:card_title}}` /
  // `{{voucher:code_html}}`, cf. binding-resolver.ts) — repris par l'aperçu de l'éditeur.
  GIFT_CARD_PDF: {
    TITLE_GIFT: 'Carte cadeau',
    TITLE_PACK: 'Votre forfait',
    CODE_LABEL: 'Votre code',
  },
  // Ligne « en attente de validation » des emails de modification/déplacement quand le pro valide
  // chaque réservation (`confirm_every_booking`) — cf. binding-resolver.ts.
  BOOKING_AWAITING_CONFIRMATION_EMAIL: {
    CUSTOMER_NOTICE: 'Ce rendez-vous doit encore être confirmé par {pro}. Vous recevrez un email dès sa validation.',
    PRO_NOTICE:
      "Ce déplacement attend votre validation depuis votre agenda. S'il ne vous convient pas, modifiez le rendez-vous pour revenir à l'ancien horaire plutôt que de l'annuler : une annulation supprime la réservation du client.",
  },
  // Éléments du récap des emails de réservation client (binding-resolver.ts, planche 10) : montants et
  // dates formatés par le serveur, insérés à la place de {amount} / {date}.
  BOOKING_RECAP_EMAIL: {
    TEAM_MEMBER: 'Avec {names}',
    DISCOUNT_LINE: 'Remise {label}',
    MANUAL_DISCOUNT_LINE: 'Remise accordée',
    TOTAL: 'Total',
    VOUCHER_LINE: 'Réduction du bon',
    PAID: 'Payé : {amount}',
    REMAINING_ON_SITE: 'Reste sur place : {amount}',
    // Sauvegarde CB / empreinte : le reste peut être prélevé sur la carte, pas seulement réglé sur place.
    REMAINING_DUE: 'Reste à régler : {amount}',
    CANCELLATION_CANCEL_BEFORE: "En cas d'empêchement, merci d'annuler avant le {date}.",
    CANCELLATION_FREE_UNTIL: "Annulation gratuite jusqu'au {date}.",
    CANCELLATION_FEE_AFTER: "Annulation gratuite jusqu'au {date}, puis {amount} de frais d'annulation.",
    CANCELLATION_DEPOSIT_KEPT_AFTER: "Annulation gratuite jusqu'au {date}, puis l'acompte de {amount} est conservé.",
    CANCELLATION_NO_REFUND_AFTER: "Annulation gratuite jusqu'au {date}, puis aucun remboursement.",
    MANAGE_LINK: 'Gérer mon rendez-vous',
  },
  // Email PAYMENT_REQUEST (lien de paiement envoyé au client) : phrase selon le type de demande et
  // libellés des lignes de détail — cf. binding-resolver.ts ({{payment:request_summary}} / details_html).
  PAYMENT_REQUEST_EMAIL: {
    SUMMARY_FULL_PAYMENT: '{pro} vous invite à régler {amount} en ligne, sur une page de paiement sécurisée.',
    SUMMARY_BANK_IMPRINT:
      "{pro} vous demande une empreinte bancaire de {amount} en garantie. Aucun montant n'est débité à ce stade.",
    SUMMARY_CARD_SAVE:
      "{pro} vous demande d'enregistrer votre carte bancaire en garantie. Aucun montant n'est débité à ce stade.",
    DETAILS_NAME_LABEL: 'Objet',
    DETAILS_APPOINTMENT_LABEL: 'Rendez-vous',
    DETAILS_DESCRIPTION_LABEL: 'Description',
    PRESTATIONS_LABEL: 'Prestations',
  },
  EXPRESS_PAYMENT: {
    TITLE: 'Confirmer le paiement',
    DESCRIPTION: 'Payez en un clic avec votre carte enregistrée, ou choisissez un autre moyen de paiement.',
    AMOUNT_LABEL: 'Montant à payer',
    CARD_LABEL: '{brand} •••• {last4}',
    PAY_BUTTON: 'Payer avec cette carte',
    OTHER_METHOD_BUTTON: 'Choisir un autre moyen de paiement',
    PAID_SUCCESS: 'Paiement effectué, votre commande est en cours de traitement.',
    FALLBACK_HOSTED: 'Finalisez votre paiement sur la page sécurisée.',
    // Sans carte, mandat SEPA par défaut : un PRÉLÈVEMENT est lancé, l'achat est livré à l'encaissement.
    SEPA_DESCRIPTION:
      'Payez en un clic par prélèvement sur votre mandat SEPA enregistré, ou choisissez un autre moyen de paiement.',
    SEPA_PAY_BUTTON: 'Lancer le prélèvement',
  },

  PAYMENT_PAGE: {
    YOUR_COMMAND: 'Votre commande',
    VERIFY_DISCLAIMER: ' Vérifiez les détails avant de payer',
    BILLING_INFO_TITLE: 'Informations de facturation',
    BILLING_INFO_REQUIRED_REMARK: 'Requises pour établir votre facture avant le paiement',
    BILLING_INFO_COMPLETE_REMARK: 'Votre facture sera établie avec ces informations',
    BILLING_INFO_EDIT: 'Modifier',
    BILLING_INFO_SAVE: 'Enregistrer',
    BILLING_INFO_ADVANCED_LABEL: 'Informations complémentaires (optionnel)',
    BILLING_INFO_SIRET: 'N° SIRET',
    BILLING_INFO_VAT_NUMBER: 'N° TVA intracommunautaire',
    ARTICLES: 'Articles',
    PAYMENT_INFORMATIONS: 'Informations de paiement',
    PAYMENT_SECURITY_REMARK: 'Tous les paiements sont sécurisés et cryptés',
    SSL_SECURE: 'SSL Sécurisé',
    SSL_ALGO: 'Cryptage 256-bit',
    PCI_DSS: 'PCI DSS',
    CERTIFIED: 'Certifié',
    THREE_D_SECURE: '3D Secure',
    ENABLED: 'Activé',
    SUM_UP: 'Résumé',
    TAX_FREE_TOTAL: 'Total HT',
    SUBTOTAL_TAX_FREE: 'Sous-total HT',
    VAT: 'TVA',
    TOTAL_WITH_TAXES: 'Total (TTC)',
    TOTAL_TO_PAY: 'Total à payer',
    PAY: 'Payer',
    PROMO_TITLE: 'Code promo',
    PROMO_REMARK: 'Vous avez un code ? Saisissez-le avant de payer',
    PROMO_APPLIED_REMARK: 'La remise est déduite du montant à payer',
    PROMO_PLACEHOLDER: 'Votre code',
    PROMO_APPLY: 'Appliquer',
    PROMO_REMOVE: 'Retirer',
    PROMO_CHECKING: 'Vérification du code en cours',
    // « Remise HT » : ligne du détail HT (Sous-total HT − Remise HT = Total HT).
    // « Remise −X TTC » : annonce commerciale de la carte code promo, en TTC — ce que le
    // client paie réellement en moins. Les deux montants diffèrent de la TVA : sans le
    // suffixe, l'écart (−10,00 € vs −12,00 €) passe pour une incohérence.
    PROMO_DISCOUNT_LABEL: 'Remise HT',
    PROMO_DISCOUNT_APPLIED: 'Remise −{amount} TTC',
    PROMO_PREVIEW_IMPACT: '{discount} TTC de remise : vous payez {total} TTC aujourd’hui',
    PROMO_NEXT_INVOICES_FOREVER: 'Remise également appliquée à chaque échéance suivante.',
    PROMO_NEXT_INVOICES_UNTIL: 'Remise également appliquée aux échéances suivantes jusqu’au {date}.',
    REGISTER_CARD: 'Enregistrer ma carte',
    SECURITY_REASSURANCE: 'Paiement 100% sécurisé',
    CGV_LINK_TEXT: 'En procédant au paiement, vous acceptez nos <cgv>conditions générales de vente</cgv>.',
    TRIAL_PERIOD: "Période d'essai",
    DAYS_REMAINING: '{count} jours restants',
    RENEWAL_DATE: 'Renouvellement le',
    WITHOUT_COMMITMENT: 'Sans engagement',
    ENGAGEMENT: 'Engagement',
    BILLING_SUMMARY: 'Récapitulatif de facturation',
    TODAY_AMOUNT: "Aujourd'hui",
    NEXT_INVOICE: 'Prochaine facture le',
    FREE_TODAY: "Gratuit (période d'essai)",
    TRIAL_BONUS_DAYS:
      "{days, plural, =1 {1 jour d'essai restant ajouté} other {# jours d'essai restants ajoutés}} à votre 1re période.",
    PRORATA_LABEL: 'Ajustement prorata',
    PRORATA_UNTIL: "Jusqu'au",
    THEN_PER_MONTH: 'puis {price}/mois HT',
    DOWNGRADE_EFFECTIVE: 'Passage au nouveau plan le',
    RECLAIM_INFO: 'Abonnement déjà payé pour cette période',
    // ── Prélèvement SEPA (GoCardless) ──
    SEPA_MANDATE_ON_FILE: 'Mandat SEPA enregistré',
    SEPA_IBAN_ENDING: 'IBAN •••• {last2}',
    SEPA_PAY_WITH_MANDATE: 'Payer avec mon mandat SEPA',
    SEPA_USE_OTHER_ACCOUNT: 'Utiliser un autre compte bancaire',
    SEPA_PAY_BY_DEBIT: 'Payer par prélèvement SEPA',
    SEPA_REDIRECT_NOTICE: 'Vous signerez votre mandat de prélèvement sur la page sécurisée de GoCardless.',
    // Délai annoncé avant le lancement : un abonnement est livré dès le lancement du prélèvement,
    // un achat ponctuel (crédits, domaine) seulement à son encaissement.
    SEPA_SUBSCRIPTION_TIMING:
      'Votre abonnement est activé dès le lancement du prélèvement, débité sous quelques jours ouvrés.',
    SEPA_ONE_TIME_TIMING: 'Votre achat est activé à l’encaissement du prélèvement, sous 2 à 5 jours ouvrés.',
    // Prélèvement lancé (paiement PROCESSING) : ni payé ni impayé, jamais d'expiration.
    SEPA_PROCESSING_SUBSCRIPTION_DESC:
      'Votre abonnement est actif. Le prélèvement sera débité sous quelques jours ouvrés.',
    SEPA_PROCESSING_ONE_TIME_DESC:
      'Votre achat sera activé dès l’encaissement du prélèvement, sous 2 à 5 jours ouvrés.',
    // Prélèvement rejeté après son lancement (paiement ERROR) : la page n'est plus payable.
    SEPA_FAILED_TITLE: 'Prélèvement SEPA non abouti',
    SEPA_FAILED_SUBSCRIPTION_DESC:
      'Ce prélèvement n’a pas été encaissé et ce paiement ne peut plus être réglé ici. Retrouvez la situation de votre abonnement sur la page Abonnement.',
    SEPA_FAILED_ONE_TIME_DESC:
      'Ce prélèvement n’a pas été encaissé : votre achat n’est pas activé. Vous pouvez le relancer depuis votre espace.',
    // Retour de signature GoCardless : attente bornée du webhook qui lance le prélèvement.
    LOADING_SEPA_MANDATE: 'Vérification de votre mandat SEPA...',
    SEPA_RETURN_PENDING_TITLE: 'Aucun prélèvement lancé pour le moment',
    SEPA_RETURN_PENDING_DESC: 'Si vous venez de signer votre mandat, actualisez la page dans quelques instants.',
    // Sortie du parcours GoCardless sans signer (`sepa_exit=1`) : rien à attendre, la page reste payable.
    SEPA_EXIT_TITLE: 'Signature du mandat interrompue',
    SEPA_EXIT_DESC:
      'Vous avez quitté GoCardless sans signer le mandat SEPA. Vous pouvez reprendre le paiement quand vous le souhaitez.',
    LOADING_PAYMENT_DATA: 'Chargement des données de paiement...',
    LOADING_PAYMENT_ONGOING: 'Paiement en cours...',
    ERROR_LOADING_TITLE: 'Erreur de chargement',
    ERROR_LOADING_DESCRIPTION: 'Impossible de charger les détails du paiement. Veuillez réessayer.',
    RETRY: 'Réessayer',
    CARD_PAYMENT_TAB: 'Carte bancaire',
    SEPA_PAYMENT_TAB: 'Prélèvement SEPA',
    PAYMENT_SUCCESS: 'Paiement réussi !',
    PAYMENT_SUCCESS_DESC: 'Merci pour votre paiement. Vous allez recevoir une confirmation par email sous peu.',
    YOU_WILL_BE_REDIRECTED_IN_X_SECONDS: 'Vous allez être redirigé dans {seconds} secondes...',
    PROCESSING_PAYMENT: 'Traitement du paiement...',
    REDIRECT_NOW: 'Redirection immédiate',
    PROCESSING: 'Traitement en cours...',
    ...PaymentStatusTitleAlertBanner['fr-FR'],
    ...PaymentStatusDescAlertBanner['fr-FR'],
  },
  VALIDATION_ERRORS: {
    MIN_LENGTH: '✍️ Veuillez saisir au moins {min} caractères.',
    MAX_LENGTH: '✍️ Le texte ne doit pas dépasser {max} caractères.',
    REQUIRED: '⚠️ Ce champ est requis.',
    INVALID_EMAIL: "📧 L'adresse email n'est pas valide.",
    INVALID_URL: '🔗 URL invalide : doit commencer par http:// ou https://',
    INVALID_PATTERN: '✍️ Format invalide.',
    INVALID_DATE: '📅 Date invalide, merci de vérifier.',
    INVALID_TIME: '⏰ Heure invalide, merci de vérifier.',
    INVALID_PHONE: '📞 Numéro de téléphone invalide.',
    INVALID_VAT_NUMBER:
      '🧾 N° de TVA intracommunautaire invalide (ex. FR32123456789). Laissez le champ vide si vous n’en avez pas.',
    INVALID_COLOR_HEX: '🎨 Couleur invalide.',
    INVALID_PASSWORD_FORMAT:
      '🔒 Mot de passe invalide : utilisez ≥8 caractères, une majuscule, une minuscule, un chiffre et un caractère spécial.',
    INVALID_SMS_SENDER_FORMAT:
      '📤 Expéditeur SMS invalide : utilisez entre 3 et 11 caractères, sans caractères spéciaux, et commencez par une lettre.',

    MIN_VALUE: '⚖️ La valeur doit être supérieure ou égale à {min}.',
    MAX_VALUE: '⚖️ La valeur doit être inférieure ou égale à {max}.',
    EXCLUSIVE_MIN_VALUE: '⚖️ La valeur doit être strictement supérieure à {min}.',
    EXCLUSIVE_MAX_VALUE: '⚖️ La valeur doit être strictement inférieure à {max}.',
    MULTIPLE_OF: '➗ La valeur doit être un multiple de {multipleOf}.',

    MIN_ITEMS: '✅ Ajoutez au moins {min} élément(s).',
    MAX_ITEMS: '❌ Ajoutez au maximum {max} élément(s).',
    UNIQUE_ITEMS: '🔁 Les éléments en double ne sont pas autorisés.',
    CONTAINS: '🔎 Le champ doit contenir au moins un élément valide.',
    MIN_CONTAINS: '🔎 Le champ doit contenir au moins {min} élément(s) valide(s).',
    MAX_CONTAINS: '🔎 Le champ doit contenir au maximum {max} élément(s) valide(s).',

    MIN_PROPERTIES: "📦 L'objet doit contenir au moins {min} propriété(s).",
    MAX_PROPERTIES: "📦 L'objet doit contenir au maximum {max} propriété(s).",
    ADDITIONAL_PROPERTIES: '🚫 Propriétés supplémentaires non autorisées.',

    INVALID_TYPE: '⚠️ Valeur invalide.',
    INVALID_STRING: '✳️ Veuillez saisir du texte.',
    INVALID_NUMBER: '🔢 Veuillez saisir un nombre valide.',
    INVALID_INTEGER: '🔢 Veuillez saisir un nombre entier (sans décimales).',
    INVALID_BOOLEAN: '✅ Veuillez choisir Oui ou Non.',
    INVALID_ARRAY: '📚 Veuillez fournir une liste de valeurs valides.',
    INVALID_OBJECT: '🧩 Informations invalides : vérifiez les champs.',
    INVALID_SELECTION: '❌ Aucun élément sélectionné : veuillez choisir un élément dans la liste.',
    INVALID_FORMAT: '⚠️ Format invalide : veuillez vérifier la saisie.',
    MUST_BE_AFTER: '📅 La date de fin doit être postérieure à la date de début.',
    // Code promo : la valeur est vidée quand le type de remise change (cf. DynamicForm `promo_value`).
    PROMO_VALUE_REQUIRED: '⚠️ Indiquez la valeur de la remise pour le type choisi.',
  },
  [PAYMENT_STATUS_TRANSLATE_KEY]: PaymentStatusTranslation['fr-FR'],
  [TRANSLATE_KEY_LEAD_STATE]: LeadStateTranslation['fr-FR'],
  [TRANSLATE_KEY_SUPPORT_TICKET_INTENT]: SupportTicketIntentTranslation['fr-FR'],
  [TRANSLATE_KEY_SUPPORT_TICKET_AREA]: SupportTicketAreaTranslation['fr-FR'],
  [TRANSLATE_KEY_SUPPORT_TICKET_PRIORITY]: SupportTicketPriorityTranslation['fr-FR'],
  [TRANSLATE_KEY_SUPPORT_BUG_KIND]: SupportBugKindTranslation['fr-FR'],
  [TRANSLATE_KEY_SUPPORT_PULSE_STATUS]: SupportPulseStatusTranslation['fr-FR'],
  [TRANSLATE_KEY_SUPPORT_CUSTOMER_SEGMENT]: SupportCustomerSegmentTranslation['fr-FR'],
  // Les écrans admin lisent ces enums en NAMESPACE (`useTranslations(TRANSLATE_KEY_…)`) : sans
  // ces trois lignes, next-intl ne trouvait rien et affichait la clé brute
  // (« TRIAL_RELANCE_MOMENT_.TRIAL_RELANCE_MOMENT_J2 »). Le spread dans DYNAMIC_FORM plus haut
  // sert aux formulaires dynamiques et ne couvre pas cet usage.
  [TRANSLATE_KEY_TRIAL_VOIE]: TrialVoieTranslation['fr-FR'],
  [TRANSLATE_KEY_TRIAL_SEGMENT]: TrialSegmentTranslation['fr-FR'],
  [TRANSLATE_KEY_TRIAL_RELANCE_MOMENT]: TrialRelanceMomentTranslation['fr-FR'],
  [GOOGLE_REVIEW_STATUS_TRANSLATE_KEY]: GoogleReviewStatusTranslation['fr-FR'],
  [GOOGLE_RESERVE_STATUS_TRANSLATE_KEY]: GoogleReserveStatusTranslation['fr-FR'],
  [GOOGLE_FEED_RUN_STATUS_TRANSLATE_KEY]: GoogleFeedRunStatusTranslation['fr-FR'],
  [TRANSLATE_KEY_WEBSITE_DOMAIN_ACTIVATION_STATUS]: WebsiteDomainActivationStatusTranslation['fr-FR'],
  [TRANSLATE_KEY_PRO_VAT_REGIME]: ProVatRegimeTranslation['fr-FR'],
  [TRANSLATE_KEY_PRO_VAT_REGIME_MENTION]: ProVatRegimeMentionTranslation['fr-FR'],
  [TRANSLATE_KEY_NON_CONVERSION_REASON]: NonConversionReasonTranslation['fr-FR'],
  [TRANSLATE_KEY_CRM_CONSENT_CHANNEL]: CrmConsentChannelTranslation['fr-FR'],
  [TRANSLATE_KEY_CRM_CONSENT_SCOPE]: CrmConsentScopeTranslation['fr-FR'],
  [TRANSLATE_KEY_CRM_CONSENT_SOURCE]: CrmConsentSourceTranslation['fr-FR'],
  [TRANSLATE_KEY_CRM_CONTACT_STATUS]: CrmContactStatusTranslation['fr-FR'],
  [TRANSLATE_KEY_CRM_CONTACT_PURPOSE]: CrmContactPurposeTranslation['fr-FR'],
  [TRANSLATE_KEY_CRM_TASK_TYPE]: CrmTaskTypeTranslation['fr-FR'],
  [TRANSLATE_KEY_CRM_TASK_STATUS]: CrmTaskStatusTranslation['fr-FR'],
  [TRANSLATE_KEY_CRM_MAILING_LIST_REASON]: CrmMailingListReasonTranslation['fr-FR'],
  [TRANSLATE_KEY_CRM_QUEUE_ENTRY_REASON]: CrmQueueEntryReasonTranslation['fr-FR'],
  [TRANSLATE_KEY_CRM_QUEUE_ENTRY_KIND]: CrmQueueEntryKindTranslation['fr-FR'],
  [TRANSLATE_KEY_CRM_CALL_JOURNAL_KIND]: CrmCallJournalKindTranslation['fr-FR'],
  [TRANSLATE_KEY_CRM_QUEUE_ENTRY_STATUS]: CrmQueueEntryStatusTranslation['fr-FR'],
  [TRANSLATE_KEY_CRM_QUEUE_EXIT_REASON]: CrmQueueExitReasonTranslation['fr-FR'],
  [TRANSLATE_KEY_CRM_CALL_OUTCOME]: CrmCallOutcomeTranslation['fr-FR'],
  [TRANSLATE_KEY_CRM_BLOCKED_STEP]: CrmBlockedStepTranslation['fr-FR'],
  [TRANSLATE_KEY_CRM_TRAINING_OUTCOME]: CrmTrainingOutcomeTranslation['fr-FR'],
  [TRANSLATE_KEY_CRM_LIFECYCLE_STAGE]: CrmLifecycleStageTranslation['fr-FR'],
  [TRANSLATE_KEY_CRM_CALL_BLOCK_REASON]: CrmCallBlockReasonTranslation['fr-FR'],
  [TRANSLATE_KEY_CRM_LATE_REASON]: CrmLateReasonTranslation['fr-FR'],
  [TRANSLATE_KEY_CRM_CALL_INPUT_ERROR]: CrmCallInputErrorTranslation['fr-FR'],
  [TRANSLATE_KEY_CRM_REASON_SOURCE]: CrmReasonSourceTranslation['fr-FR'],
  [TRANSLATE_KEY_CRM_MESSAGE_KIND]: CrmMessageKindTranslation['fr-FR'],
  [TRANSLATE_KEY_CRM_MESSAGE_STATUS]: CrmMessageStatusTranslation['fr-FR'],
  [TRANSLATE_KEY_CRM_TRAINING_PRESENCE]: CrmTrainingPresenceTranslation['fr-FR'],
  [TRANSLATE_KEY_CRM_SESSION_KIND]: CrmSessionKindTranslation['fr-FR'],
  [TRANSLATE_KEY_CRM_CAMPAIGN_EXCLUSION_REASON]: CrmCampaignExclusionReasonTranslation['fr-FR'],
  [TRANSLATE_KEY_CRM_SEQUENCE_ANCHOR]: CrmSequenceAnchorTranslation['fr-FR'],
  [TRANSLATE_KEY_CRM_SEQUENCE_STEP_TIMING]: CrmSequenceStepTimingTranslation['fr-FR'],
  [TRANSLATE_KEY_CRM_COMMS_TRACE_KIND]: CrmCommsTraceKindTranslation['fr-FR'],
  [TRANSLATE_KEY_CRM_CAMPAIGN_STATUS]: CrmCampaignStatusTranslation['fr-FR'],
  [TRANSLATE_KEY_CRM_CAMPAIGN_TYPE]: CrmCampaignTypeTranslation['fr-FR'],
  [TRANSLATE_KEY_CRM_CAMPAIGN_ERROR]: CrmCampaignErrorTranslation['fr-FR'],
  [TRANSLATE_KEY_PROFESSIONAL_ORIGIN]: ProfessionalOriginTranslation['fr-FR'],
  [TRANSLATE_KEY_PULSE_TEXT_KIND]: PulseTextKindTranslation['fr-FR'],
  [TRANSLATE_KEY_ONBOARDING_FLOW]: OnboardingFlowTranslation['fr-FR'],
  [TRANSLATE_KEY_WEBSITE_DOMAIN_DNS_STATUS]: WebsiteDomainDnsStatusTranslation['fr-FR'],
  [TRANSLATE_KEY_PRO_MAIL_DOMAIN_STATUS]: ProMailDomainStatusTranslation['fr-FR'],
  [TRANSLATE_KEY_PRO_MAIL_MIGRATION_STATUS]: ProMailMigrationStatusTranslation['fr-FR'],
  [TRANSLATE_KEY_PRO_MAIL_MIGRATION_MAILBOX_STATUS]: ProMailMigrationMailboxStatusTranslation['fr-FR'],
  [TRANSLATE_KEY_OVH_MAIL_OFFER]: OvhMailOfferTranslation['fr-FR'],
  [TRANSLATE_KEY_MAIL_MIGRATION_CHECK]: MailMigrationCheckKeyTranslation['fr-FR'],
  [TRANSLATE_KEY_MAIL_MIGRATION_WARNING]: MailMigrationWarningKeyTranslation['fr-FR'],
  [TRANSLATE_KEY_CAMPAIGN_SENDER_DOMAIN_STATUS]: CampaignSenderDomainStatusTranslation['fr-FR'],
  [TRANSLATE_KEY_SEARCH_ENGINE]: SearchEngineTranslation['fr-FR'],
  [TRANSLATE_KEY_SEARCH_ENGINE_PROPERTY_STATUS]: SearchEnginePropertyStatusTranslation['fr-FR'],
  [TRANSLATE_KEY_PRO_MAILBOX_STATUS]: ProMailboxStatusTranslation['fr-FR'],
  [TRANSLATE_KEY_PRO_CUSTOMER_IMPORT_STATUS]: ProCustomerImportStatusTranslation['fr-FR'],
  [TRANSLATE_KEY_IMPORT_TARGET_FIELD]: ImportTargetFieldTranslation['fr-FR'],
  [TRANSLATE_KEY_IMPORT_ROW_ACTION]: ImportRowActionTranslation['fr-FR'],
  [TRANSLATE_KEY_IMPORT_ROW_ERROR]: ImportRowErrorTranslation['fr-FR'],
  [TRANSLATE_KEY_PRO_CUSTOMER_DUPLICATE_TIER]: ProCustomerDuplicateTierTranslation['fr-FR'],
  [TRANSLATE_KEY_PRO_CUSTOMER_DUPLICATE_SIGNAL]: ProCustomerDuplicateSignalTranslation['fr-FR'],
  [TRANSLATE_KEY_PRO_CUSTOMER_MERGE_WARNING]: ProCustomerMergeWarningTranslation['fr-FR'],
  [TRANSLATE_KEY_EMAIL_CHANGE_KIND]: EmailChangeKindTranslation['fr-FR'],
  [TRANSLATE_KEY_EMAIL_CHANGE_STATUS]: EmailChangeStatusTranslation['fr-FR'],
  [TRANSLATE_KEY_MESSAGE_ROLE]: MessageRoleTranslation['fr-FR'],
  [TRANSLATE_KEY_MESSAGE_CHANNEL]: MessageChannelTranslation['fr-FR'],
  [TRANSLATE_KEY_TRIGGER_RUN_STATUS]: TriggerRunStatusTranslation['fr-FR'],
  [TRANSLATE_KEY_TOOL_INVOCATION_STATUS]: ToolInvocationStatusTranslation['fr-FR'],
  [TRANSLATE_KEY_ADMIN_AUDIT_ACTION]: AdminAuditActionTranslation['fr-FR'],
  [TRANSLATE_KEY_PRO_MIGRATION_STATUS]: ProMigrationStatusTranslation['fr-FR'],
  [TRANSLATE_KEY_V1_STRIPE_CONNECT_STATUS]: V1StripeConnectStatusTranslation['fr-FR'],
  [TRANSLATE_KEY_ADMIN_ROLE]: AdminRoleTranslation['fr-FR'],
  [PRO_RESOURCE_CATEGORY_TRANSLATE_KEY]: ProResourceCategoryTranslation['fr-FR'],
  [PRO_RESOURCE_BOOKING_MODE_TRANSLATE_KEY]: ProResourceBookingModeTranslation['fr-FR'],
  ...PrestationFormatPresetTranslation['fr-FR'],
  PRESTATION_FORMAT_BLOCK: {
    SECTION_TITLE: 'Format de la prestation',
    CLIENTS_PER_BOOKING_LABEL: 'Personnes max par réservation',
    CLIENTS_PER_BOOKING_HELP: 'Nombre de clients couverts par une seule réservation.',
    CLIENTS_PER_BOOKING_PLACEHOLDER: 'Ex : 4 (une famille de 4)',
    REQUIRED_MEMBERS_LABEL: 'Membres mobilisés',
    REQUIRED_MEMBERS_PLACEHOLDER: 'Ex : 1',
    IS_PARTY_SIZE_OPEN_LABEL: 'Le client choisit la taille du groupe au booking',
    SESSION_CAPACITY_TITLE: 'Capacité du créneau',
    SESSION_CAPACITY_HELP: 'Combien de participants max sur la session ?',
    SESSION_CAPACITY_PLACEHOLDER: 'Ex : 50',
    SESSION_CAPACITY_REQUIRED: 'La capacité est obligatoire pour une prestation en mode session.',
    SELF_SERVICE_RESOURCE_REQUIRED_TITLE: 'Associez au moins un matériel ou une salle',
    SELF_SERVICE_RESOURCE_REQUIRED_TEXT:
      'En libre-service, la réservation se fait sur une ressource (matériel ou salle), sans membre de l’équipe. Sélectionnez-en au moins une dans « Matériels / salles » (Paramètres avancés).',
    LOCK_TOOLTIP_CLIENTS: 'Verrouillé par le préset sélectionné.',
    LOCK_TOOLTIP_MEMBERS: 'Verrouillé par le préset sélectionné.',
    ADVANCED_SETTINGS_TOGGLE: 'Paramètres avancés',
    PRESET_CHANGE_WARNING_TITLE: 'Modifier le format de prestation ?',
    PRESET_CHANGE_WARNING_TEXT:
      'Vous passez du format « {from} » à « {to} ». Cela peut impacter les rendez-vous à venir qui utilisent cette prestation (équipe requise, capacité, ressources). Voulez-vous continuer ?',
    PRESET_CHANGE_WARNING_CONFIRM: 'Oui, changer le format',
    PRESET_CHANGE_WARNING_CANCEL: 'Annuler',
    CONTRAST_HINT_GROUPE: '≠ Session : chaque client réserve sa propre place.',
    CONTRAST_HINT_SESSION: '≠ Groupe : une seule réservation couvre tout le monde.',
    GROUP_SIZE_WARNING_TITLE: 'Vos clients réservent-ils chacun leur place ?',
    GROUP_SIZE_WARNING_TEXT:
      'Le format Groupe correspond à une seule réservation pour {count} personnes qui viennent ensemble. Si chaque participant réserve individuellement sa place (cours collectif, afterwork, événement), choisissez plutôt le format Session.',
    GROUP_SIZE_WARNING_ACTION: 'Passer en Session',
    CLIENTS_MIN_ADJUSTED_GROUP: 'Le format Groupe requiert au moins 2 personnes. La valeur a été ajustée à 2.',
    CLIENTS_MIN_ADJUSTED: 'Une valeur minimale de 1 personne par réservation est requise.',
    MEMBERS_MIN_ADJUSTED: 'Ce format requiert au moins 2 membres d’équipe. La valeur a été ajustée à 2.',
    CLIENTS_PER_BOOKING_HELP_GROUP: 'Au moins 2 clients couverts par une même réservation.',
  },
  [TRANSLATE_KEY_AFFILIATE_REGIME]: AffiliateRegimeTranslation['fr-FR'],
  [TRANSLATE_KEY_AFFILIATE_STATUS]: AffiliateStatusTranslation['fr-FR'],
  [TRANSLATE_KEY_AFFILIATE_COMMISSION_STATUS]: AffiliateCommissionStatusTranslation['fr-FR'],
  [TRANSLATE_KEY_AFFILIATE_COMMISSION_KIND]: AffiliateCommissionKindTranslation['fr-FR'],
  [TRANSLATE_KEY_AFFILIATE_RECONCILIATION_STATE]: AffiliateReconciliationStateTranslation['fr-FR'],
  [TRANSLATE_KEY_AFFILIATE_SOURCE]: AffiliateSourceTranslation['fr-FR'],
  [TRANSLATE_KEY_AFFILIATE_REFERRAL_REVIEW_STATE]: AffiliateReferralReviewStateTranslation['fr-FR'],
  // Section « Vitrine dans le tunnel de réservation » du formulaire de prestation (type RIDE
  // uniquement — composant RideShowcaseBlock, même pattern que PRESTATION_FORMAT_BLOCK).
  PRESTATION_RIDE_SHOWCASE_BLOCK: {
    SECTION_TITLE: 'Vitrine dans le tunnel de réservation',
    SECTION_DESCRIPTION:
      'Affichez cette course comme une carte dans votre tunnel de réservation classique. Le client qui la choisit bascule vers le calculateur de course, avec cette formule présélectionnée et le trajet par défaut prérempli.',
    SHOW_IN_TUNNEL_LABEL: 'Afficher dans le tunnel de réservation',
    PICKUP_ADDRESS_LABEL: 'Adresse de départ par défaut',
    PICKUP_ADDRESS_PLACEHOLDER: "Saisissez l'adresse de départ",
    DROPOFF_ADDRESS_LABEL: "Adresse d'arrivée par défaut",
    DROPOFF_ADDRESS_PLACEHOLDER: "Saisissez l'adresse d'arrivée",
    ADDRESS_LOCKED_LABEL: 'Adresse fixe (non modifiable par le client)',
    CLEAR_ADDRESS: "Effacer l'adresse",
  },
  PRESTATION_RIDE_VEHICLES_BLOCK: {
    TITLE: 'Véhicules',
    PLACEHOLDER: 'Sélectionner les véhicules',
    HINT: 'À la création, tous vos véhicules actifs sont liés automatiquement — restreignez ici si besoin.',
  },
  // Règles de réservation en ligne propres à une prestation (délai minimum, horizon maximum ; sans
  // réglage propre, le réglage général s'applique) : bloc du formulaire de prestation
  // (BookingRulesBlock), badge de la liste du catalogue, note sous les réglages généraux
  // (BookingRuleOverridesNote). Titres des deux sélecteurs : DYNAMIC_FORM (titres des champs).
  PRESTATION_BOOKING_RULES: {
    SECTION_TITLE: 'Règles de réservation en ligne',
    SUMMARY_GENERAL: 'Comme le réglage général : {delay}, {horizon}',
    SUMMARY_CUSTOM: 'Pour cette prestation : {delay}, {horizon}',
    DELAY_PART: '{value} à l’avance minimum',
    DELAY_PART_NONE: 'aucun délai minimum',
    HORIZON_PART: 'jusqu’à {value}',
    PART_SPECIFIC: '{part} (spécifique)',
    PART_GENERAL: '{part} (réglage général)',
    DELAY_HOURS: '{count, plural, one {# heure} other {# heures}}',
    HORIZON_DAYS: '{count, plural, one {# jour} other {# jours}}',
    CUSTOMIZE_SWITCH: 'Personnaliser pour cette prestation',
    GENERAL_SETTING_OPTION: 'Réglage général ({value})',
    EDIT_GENERAL_SETTING: 'Modifier le réglage général',
    SPECIFIC_RULES_BADGE: 'Règles spécifiques',
    OVERRIDES_NOTE_MIN_DELAY:
      '{count, plural, one {# prestation a son propre délai} other {# prestations ont leur propre délai}} : {names}',
    OVERRIDES_NOTE_HORIZON:
      '{count, plural, one {# prestation a son propre horizon} other {# prestations ont leur propre horizon}} : {names}',
    OVERRIDES_NOTE_OTHERS: '{count, plural, one {# autre} other {# autres}}',
  },
  [TRANSLATE_KEY_PROMO_CODE_KIND]: PromoCodeKindTranslation['fr-FR'],
  [TRANSLATE_KEY_VOID_ON_PLAN_CHANGE]: VoidOnPlanChangeTranslation['fr-FR'],
  [TRANSLATE_KEY_PROMO_VOID_REASON]: PromoVoidReasonTranslation['fr-FR'],
  [TRANSLATE_KEY_PROMO_INELIGIBILITY]: PromoIneligibilityReasonTranslation['fr-FR'],
  [TRANSLATE_KEY_PRO_PROMO_CODE_KIND]: ProPromoCodeKindTranslation['fr-FR'],
  [TRANSLATE_KEY_PRO_PROMO_CODE_TRIGGER]: ProPromoCodeTriggerTranslation['fr-FR'],
  [TRANSLATE_KEY_PRO_PROMO_CODE_STATUS]: ProPromoCodeStatusTranslation['fr-FR'],
  [TRANSLATE_KEY_PRO_PROMO_CODE_CUSTOMER_SCOPE]: ProPromoCodeCustomerScopeTranslation['fr-FR'],
  [TRANSLATE_KEY_PRO_PROMO_CODE_WINDOW_BASIS]: ProPromoCodeWindowBasisTranslation['fr-FR'],
  [TRANSLATE_KEY_PRO_PROMOTION_DISPLAY_STATUS]: ProPromotionDisplayStatusTranslation['fr-FR'],
  [TRANSLATE_KEY_RESERVATION_DISCOUNT_REASON]: ReservationDiscountReasonTranslation['fr-FR'],
  [TRANSLATE_KEY_RESERVATION_DISCOUNT_UNAVAILABLE]: ReservationDiscountUnavailableReasonTranslation['fr-FR'],
  [TRANSLATE_KEY_PRO_PROMO_CODE_DISTRIBUTION]: ProPromoCodeDistributionTranslation['fr-FR'],
  [TRANSLATE_KEY_BOOKING_PROMO_INELIGIBILITY]: BookingPromoIneligibilityReasonTranslation['fr-FR'],
  RELOAD_COMPONENT: {
    TITLE: 'Recharger mes crédits',
    POPULARITY: 'Populaire',
    BEST_VALUE: 'Meilleur rapport',
    UNIT: 'unité',
    MONTHLY_QUOTA_LABEL: 'Quota mensuel inclus',
    CREDIT_BALANCE_LABEL: 'Crédit recharge restant',
    HT_SUFFIX: 'HT',
    PER_UNIT_SUFFIX: '/ unité',
    UNIT_SMS: 'SMS',
    UNIT_EMAIL: 'emails',
    SAVE_PERCENT: '-{percent}%',
    UPGRADE_PLAN_HINT_TITLE: "Besoin d'un quota plus élevé ?",
    UPGRADE_PLAN_HINT_DESC:
      'Passez à une formule supérieure pour augmenter votre quota mensuel et économiser sur le long terme.',
    UPGRADE_PLAN_BUTTON: 'Changer de formule',
  },
  GLOBAL_EMPTY: {
    TITLE: 'Aucun résultat',
    DESCRIPTION: "Nous n'avons trouvé aucun résultat correspondant à vos critères.",
  },
  PLANNING_MANAGE_PAGE: {
    TITLE: 'Disponibilités',
    DUPLICATE_AVAILABILITY: 'Dupliquer ces disponibilités',
    WEEKLY_SETTINGS_TITLE: 'Horaires hebdomadaires',
    WEEKLY_SUMMARY: '{days} · {recurrence}',
    WEEKLY_EMPTY_SUMMARY: 'Aucun jour sélectionné',
    WEEKLY_DATES_ONLY_SUMMARY: 'Aucun jour sélectionné · Dates ponctuelles uniquement',
    WEEKLY_INVALID_SUMMARY: 'Des horaires hebdomadaires sont à vérifier.',
    PLANNING_TAB: 'Plannings',
    SEE_PLANNING: 'Voir planning',
    ADD_PLANNING: 'Ajouter une disponibilité',
    RECURRENCE_PICKER_LABEL: 'Récurrence',
    RECURRENCE_PRESET_CUSTOM: 'Personnalisé…',
    RECURRENCE_CUSTOM_TITLE: 'Récurrence personnalisée',
    RECURRENCE_REPEAT_EVERY: 'Répéter tous les',
    RECURRENCE_UNIT_WEEKS: '{count, plural, one {semaine} other {semaines}}',
    RECURRENCE_UNIT_MONTHS: 'mois',
    RECURRENCE_WEEK_OF_MONTH_LABEL: 'Semaine du mois',
    RECURRENCE_WEEKLY_HINT: 'Les jours de la semaine restent définis par vos plages horaires ci-dessous.',
    RECURRENCE_ACTIVE_DAYS_PREVIEW_TITLE: 'Prochains jours actifs',
    RECURRENCE_PREVIEW_LOADING: 'Calcul des prochaines dates…',
    RECURRENCE_PREVIEW_ERROR: 'Impossible de calculer l’aperçu',
    RECURRENCE_PREVIEW_EMPTY: 'Aucun jour actif à venir',
    INVALID_RECURRENCE_RULE_TITLE: 'Récurrence invalide',
    INVALID_RECURRENCE_RULE_DESC: 'La règle de récurrence de ce planning est invalide ou non prise en charge.',
    HOLIDAYS_TAB: 'Jours fériés',
    HOLIDAYS_TITLE: 'Jours fériés',
    HOLIDAYS_DESCRIPTION:
      'Par défaut, les jours fériés sont fermés à la réservation. Activez ceux où vous travaillez pour que vos clients puissent réserver ce jour-là.',
    NO_HOLIDAYS: 'Aucun jour férié trouvé pour votre pays',
    HOLIDAYS_ALL_MEMBERS: 'Tous',
    HOLIDAYS_MIXED: 'Mixte',
    DELETE_PLANNING_TITLE: 'Supprimer ce planning',
    DELETE_PLANNING_TEXT: 'Êtes-vous sûr de vouloir supprimer ce planning ? Cette action est irréversible.',
    ROLE_READONLY_PLANNING_TITLE: 'Lecture seule',
    ROLE_READONLY_PLANNING_DESC:
      'Votre rôle ne permet pas de modifier les plannings. Contactez un responsable pour toute modification.',
    SHARED_PLANNING_READONLY_TITLE: 'Planning partagé (Lecture seule)',
    SHARED_PLANNING_READONLY_DESC:
      'Ce planning est partagé avec d’autres membres. Vous pouvez le consulter mais seul un responsable peut le modifier ou le supprimer.',
    CREATE_SUCCESS_TITLE: 'Planning créé',
    CREATE_SUCCESS_DESC: 'Votre planning a été créé avec succès.',
    UPDATE_SUCCESS_DESC: 'Votre planning a été mis à jour avec succès.',
    UPDATE_SUCCESS_TITLE: 'Planning mis à jour',
    DELETE_SUCCESS_DESC: 'Votre planning a été supprimé avec succès.',
    DELETE_SUCCESS_TITLE: 'Planning supprimé',
    OVERLAPPING_WITH_EXISTING_TITLE: 'Chevauchement détecté',
    OVERLAPPING_WITH_EXISTING_DESC:
      'Le planning "{existing_name}" chevauche celui que vous essayez de créer ou de mettre à jour, sur le même lieu et la même prestation. Ajustez les horaires, ou ciblez des lieux ou des prestations différents.',
    OVERLAPPING_SLOTS_TITLE: 'Créneaux en conflit',
    // Erreur 400 : le conflit est INTERNE au planning en cours d'édition — pas de nom de
    // planning à interpoler ici (le cas « autre planning » utilise OVERLAPPING_WITH_EXISTING_*).
    // Deux créneaux PEUVENT se chevaucher s'ils ne partagent ni lieu ni prestation.
    OVERLAPPING_SLOTS_DESC:
      'Deux créneaux de ce planning se chevauchent sur le même jour tout en partageant un lieu et une prestation. Attribuez-leur des lieux ou des prestations différents, ou ajustez leurs horaires.',
    OVERLAPPING_SPECIFIC_DATES_TITLE: 'Dates spécifiques en conflit',
    OVERLAPPING_SPECIFIC_DATES_DESC:
      'Deux créneaux de ce planning se chevauchent sur la même date tout en partageant un lieu et une prestation. Attribuez-leur des lieux ou des prestations différents, ou ajustez leurs horaires.',
    INVALID_SLOT_RANGE_TITLE: 'Plage horaire invalide',
    INVALID_SLOT_RANGE_DESC:
      "Le planning contient une plage horaire invalide. L'heure de fin doit être postérieure à l'heure de début.",
    INVALID_SPECIFIC_DATE_RANGE_TITLE: 'Plage de date invalide',
    INVALID_SPECIFIC_DATE_RANGE_DESC:
      'Ce planning contient une plage de date spécifique invalide. Veuillez vérifier les heures de début et de fin.',
    PLANNING_LIMIT_REACHED_TITLE: 'Limite de plannings atteinte',
    PLANNING_LIMIT_REACHED_DESC:
      "Vous avez atteint le nombre maximum de plannings autorisés. Veuillez en supprimer un avant d'en créer un nouveau.",

    // Réservabilité en ligne (règles H1-H12) : statuts + messages par code.
    ...AvailabilityBookabilityStatusTranslation['fr-FR'],
    ...AvailabilityBookabilityCodeTranslation['fr-FR'],
    SAVED_BUT_NOT_BOOKABLE_TITLE: 'Planning enregistré, mais non réservable en ligne',
    SAVED_BUT_PARTIALLY_BOOKABLE_TITLE: 'Planning enregistré, mais partiellement réservable en ligne',
    BOOKABILITY_IMPACT_TITLE:
      '{count, plural, one {Un planning n’est plus réservable en ligne} other {# plannings ne sont plus réservables en ligne}}',
    BOOKABILITY_IMPACT_SEE_PLANNINGS: 'Voir les plannings',
    RESOURCE_NO_PLACE_HINT:
      'Sans lieu associé, cette ressource contraint les réservations de tous les lieux — associez-la à ses lieux pour éviter des refus au moment du paiement.',
    RESOURCE_EXCLUSIVE_ON_HINT:
      'Chaque RDV réserve une unité entière : au plus {units} RDV en parallèle, chacun de {capacity, plural, one {# personne} other {# personnes}} maximum.',
    RESOURCE_EXCLUSIVE_OFF_HINT:
      'Les places se partagent personne par personne : jusqu’à {total, plural, one {# personne} other {# personnes}} en parallèle, tous RDV confondus.',
  },
  PROFESSIONAL_APP_RIDE_CONFIG: {
    // Page
    PAGE_TITLE: 'Configuration Tarifaire Chauffeur',
    PAGE_SUBTITLE: 'Configurez vos véhicules, tarifs et paramètres de course.',
    CARD_TITLE: 'Configuration courses',
    CARD_SUBTITLE: 'Véhicules, tarifs et paramètres',

    // Tabs
    TAB_VEHICLES: 'Véhicules & Tarification',
    TAB_ZONES: 'Zones forfaitaires',
    TAB_GLOBAL: 'Paramètres Globaux',
    TAB_GLOBAL_SETTINGS: 'Paramètres Globaux',

    // Global settings - Payment
    SECTION_PAYMENT: 'Paramètres de paiement',
    SECTION_PAYMENT_SETTINGS: 'Paramètres de paiement',
    ENABLE_RIDE_CALCULATION: 'Activer le calcul des courses',
    ENABLE_PAYMENT_CALCULATION: 'Activer le calcul des courses',
    MIN_PRICE: "Prix minimum d'une course",
    MIN_PRICE_PLACEHOLDER: 'Ex: 15',
    MIN_WAITING_MINUTES: "Temps d'attente minimum gratuit (minutes)",
    MIN_WAITING_MINUTES_PLACEHOLDER: 'Ex: 15',
    MAX_WAITING_MINUTES: "Temps d'attente maximum (minutes)",
    MAX_WAITING_MINUTES_PLACEHOLDER: 'Ex: 120',

    // Global settings - Approach fees
    SECTION_APPROACH: "Frais d'approche",
    SECTION_APPROACH_FEES: "Frais d'approche",
    ENABLE_APPROACH_FEES: "Activer les frais d'approche",
    STARTING_POINT: 'Point de départ',
    STARTING_POINT_ADDRESS: 'Adresse du point de départ',
    STARTING_POINT_PLACEHOLDER: 'Rechercher une adresse...',
    STARTING_POINT_RADIUS: 'Rayon gratuit (mètres)',
    STARTING_POINT_RADIUS_PLACEHOLDER: 'Ex: 5000',

    // Global settings - Routing
    SECTION_ROUTING: "Paramètres d'itinéraire",
    SECTION_ROUTE_SETTINGS: "Paramètres d'itinéraire",
    AVOID_TOLLS: 'Éviter les péages',
    AVOID_HIGHWAYS: 'Éviter les autoroutes',
    AVOID_FERRIES: 'Éviter les ferries',

    // Global settings - Coverage zone

    // Global settings - Overbooking
    SECTION_OVERBOOKING: 'Surbooking',
    ACCEPT_OVERBOOKING: 'Accepter les réservations quand tous les véhicules sont occupés',
    ACCEPT_OVERBOOKING_HINT:
      'La course est alors enregistrée sans véhicule attribué : vous l’attribuez ensuite depuis l’agenda (badge « Véhicule à attribuer ») en modifiant le rendez-vous quand un véhicule se libère.',

    // Global settings - Multi-véhicules
    SECTION_MULTI_VEHICLE: 'Groupes',
    MULTI_VEHICLE_ENABLED: 'Accepter les réservations de plusieurs véhicules',
    MULTI_VEHICLE_ENABLED_HINT:
      'Un groupe trop grand pour un seul véhicule est réparti automatiquement sur plusieurs véhicules, chacun avec son chauffeur, dans une seule réservation et un seul paiement. Désactivé : une seule voiture par réservation.',

    // Global settings - Pricing preference
    SECTION_PRICING_PREFERENCE: 'Préférences de tarification',
    PRICING_PREFERENCE_DESCRIPTION: "Choisissez comment le prix de la course est calculé en fonction de l'itinéraire.",

    // Global settings - Save
    SAVE_CONFIG_SUCCESS: 'Configuration enregistrée avec succès.',

    // Vehicle
    ADD_VEHICLE: 'Ajouter un véhicule',
    DEFAULT_VEHICLE_NAME: 'Nouveau véhicule',
    VEHICLE_NAME: 'Nom du véhicule',
    VEHICLE_NAME_PLACEHOLDER: 'Ex: Berline',
    PAX_MIN: 'Passagers min',
    PAX_MAX: 'Passagers max',
    PASSENGERS: 'passagers',
    LUGGAGE: 'valises',
    DELETE_VEHICLE: 'Supprimer le véhicule',
    DELETE_VEHICLE_TITLE: 'Supprimer le véhicule',
    DELETE_VEHICLE_DESCRIPTION: 'Êtes-vous sûr de vouloir supprimer ce véhicule ? Cette action est irréversible.',
    DELETE_VEHICLE_CONFIRM: 'Êtes-vous sûr de vouloir supprimer ce véhicule ? Cette action est irréversible.',
    VEHICLE_DETAILS: 'Détails du véhicule',
    VEHICLE_SUPPLEMENTS: 'Suppléments disponibles',
    VEHICLES_DESCRIPTION: 'Configurez vos véhicules et leurs tarifs.',
    SAVE_VEHICLE_SUCCESS: 'Véhicule enregistré avec succès.',
    DUPLICATE_VEHICLE: 'Dupliquer le véhicule',
    DUPLICATE_VEHICLE_SUCCESS: 'Véhicule dupliqué avec succès.',

    // Pricing tier
    PRICING_TIERS: 'Paliers tarifaires',
    PRICING_TIERS_COUNT: 'palier(s)',
    ADD_PRICING_TIER: 'Ajouter un palier tarifaire',
    DELETE_PRICING_TIER: 'Supprimer ce palier',
    DELETE_TIER_TITLE: 'Supprimer le palier tarifaire',
    DELETE_TIER_DESCRIPTION: 'Êtes-vous sûr de vouloir supprimer ce palier tarifaire ?',
    DELETE_PRICING_TIER_CONFIRM: 'Êtes-vous sûr de vouloir supprimer ce palier tarifaire ?',
    PRICING_TAB_RATES: 'Tarifs de base',
    PRICING_TAB_ZONES: 'Zones forfaitaires',
    PRICING_TAB_SCHEDULE: 'Horaires',
    BASE_RATES: 'Tarifs',
    BASE_RATE_PER_KM: 'Tarif aller (€/km)',
    BASE_RATE_KM: 'Tarif aller (€/km)',
    BASE_RATE_PLACEHOLDER: 'Saisir le tarif aller par kilomètre',
    RETURN_RATE_PER_KM: 'Tarif aller-retour (€/km)',
    RETURN_RATE_KM: 'Tarif aller-retour (€/km)',
    RETURN_RATE_PLACEHOLDER: 'Saisir le tarif aller-retour par kilomètre',
    HANDLING_FEES: 'Frais de prise en charge',
    HANDLING_FEES_PLACEHOLDER: 'Saisir les frais de prise en charge',
    WAITING_FEES_HOUR_RATE: "Frais d'attente (€/heure)",
    WAITING_FEES_PLACEHOLDER: "Saisir les frais d'attente par heure",
    APPROACH_ONE_WAY: "Frais d'approche aller (€/km)",
    APPROACH_RATE_ONE_WAY: "Frais d'approche aller (€/km)",
    APPROACH_ONE_WAY_PLACEHOLDER: "Saisir les frais d'approche aller",
    APPROACH_TWO_WAY: "Frais d'approche A/R (€/km)",
    APPROACH_RATE_TWO_WAY: "Frais d'approche A/R (€/km)",
    APPROACH_TWO_WAY_PLACEHOLDER: "Saisir les frais d'approche aller-retour",
    VEHICLE_MIN_PRICE: 'Prix minimum de ce véhicule',
    VEHICLE_MIN_PRICE_PLACEHOLDER: 'Laisser vide pour le prix minimum global',
    VEHICLE_MIN_PRICE_HINT:
      'Remplace le prix minimum de la configuration course pour ce véhicule, forfaits de zone compris.',
    DISTANCE_BANDS_TOGGLE: 'Tarif dégressif longue distance',
    DISTANCE_BANDS_GLOBAL_TOGGLE: 'Appliquer une grille à tous les véhicules',
    DISTANCE_BANDS_GLOBAL_HINT:
      "Chaque véhicule utilise cette grille, sauf s'il a sa propre grille ou si le dégressif y est désactivé (Véhicules → Paliers tarifaires).",
    DISTANCE_BANDS_GLOBAL_EMPTY:
      "Aucune grille n'est définie dans la config course : ce véhicule reste au tarif linéaire.",
    DISTANCE_BANDS_SUMMARY_ITEM: '−{pct} % au-delà de {km} km',
    DISTANCE_BANDS_DESCRIPTION:
      'Au-delà de chaque seuil, les kilomètres suivants sont facturés avec la réduction indiquée. Une course plus longue ne coûte jamais moins cher.',
    DISTANCE_BANDS_HINT: "S'applique aussi aux tarifs de nuit et de jours fériés, pas aux forfaits de zone.",
    DISTANCE_BANDS_ROW_PREFIX: 'Au-delà de',
    DISTANCE_BANDS_ROW_KM_SUFFIX: 'km →',
    DISTANCE_BANDS_ROW_DISCOUNT_SUFFIX: '% de réduction',
    DISTANCE_BANDS_KM_PLACEHOLDER: 'km',
    DISTANCE_BANDS_DISCOUNT_PLACEHOLDER: '%',
    DISTANCE_BANDS_ADD: 'Ajouter un seuil',
    DISTANCE_BANDS_REMOVE: 'Retirer ce seuil',
    DISTANCE_BANDS_INVALID:
      'Les distances et les réductions doivent augmenter d’un seuil à l’autre (ex. 50 km → 15 %, puis 150 km → 30 %). Réduction entre 1 et 99 %.',
    DISTANCE_BANDS_INCOMPLETE: 'Complétez ou retirez le seuil vide.',
    DISTANCE_BANDS_PREVIEW_TITLE: 'Aperçu pour {rate}/km (aller simple, hors frais)',
    DISTANCE_BANDS_PREVIEW_LINE: '{km} km : {price} au lieu de {original}',
    DISTANCE_BANDS_PREVIEW_LINE_FULL: '{km} km : {price} (plein tarif)',
    DISTANCE_BANDS_PREVIEW_NEED_RATE: "Renseignez le tarif aller au km pour afficher l'aperçu.",
    DISTANCE_BANDS_PREVIEW_TITLE_NO_RATE: 'Aperçu (aller simple, hors frais)',
    DISTANCE_BANDS_PREVIEW_NEED_BAND: "Complétez les seuils pour afficher l'aperçu.",
    DISTANCE_BANDS_PREVIEW_ERROR: "L'aperçu est momentanément indisponible.",
    SAVE_TIER: 'Enregistrer le palier',
    SAVE_TIER_SUCCESS: 'Palier tarifaire enregistré avec succès.',
    ALWAYS_ACTIVE: 'Toujours actif',

    // Schedule
    SCHEDULE: 'Plages horaires',
    SCHEDULE_AND_RATES: 'Horaires et tarifs',
    SCHEDULE_TITLE: 'Plages horaires actives',
    SCHEDULE_DESCRIPTION: 'Définissez quand ce palier tarifaire est applicable.',
    SCHEDULE_EMPTY: 'Ce palier est toujours actif (aucune restriction horaire).',
    PRICING_TAB_RATES_DESCRIPTION: 'Tarifs appliqués par défaut, en dehors des plages horaires spécifiques.',
    SCHEDULE_RATE_OVERRIDES: 'Tarifs sur cette plage',
    SCHEDULE_RATE_OVERRIDES_HINT: 'Laissez vide pour appliquer les tarifs de base.',
    SCHEDULE_BADGE_OUTBOUND: 'Aller',
    SCHEDULE_BADGE_RETURN: 'A/R',
    SCHEDULE_BADGE_HANDLING: 'Prise en charge',
    SCHEDULE_BADGE_WAITING: 'Attente',
    SCHEDULE_BADGE_APPROACH_ONE: 'Approche aller',
    SCHEDULE_BADGE_APPROACH_TWO: 'Approche A/R',
    SCHEDULE_BADGE_RATE: '{label} {price}',
    SCHEDULE_ZONE_OVERRIDES: 'Forfaits sur cette plage',
    SCHEDULE_ZONE_OVERRIDES_HINT:
      'Laissez vide pour appliquer le forfait du véhicule. Décochez une zone pour facturer au kilomètre sur cette plage.',
    SCHEDULE_BADGE_ZONE_PRICE: '{zone} {price}',
    SCHEDULE_BADGE_ZONE_DISABLED: '{zone} au km',
    SCHEDULE_DAY_BASE_RATES: 'Tarifs de base',
    DAY_0: 'Dim',
    DAY_1: 'Lun',
    DAY_2: 'Mar',
    DAY_3: 'Mer',
    DAY_4: 'Jeu',
    DAY_5: 'Ven',
    DAY_6: 'Sam',
    PUBLIC_HOLIDAYS: 'Fériés',
    SCHEDULE_DAY_MONDAY: 'Lundi',
    SCHEDULE_DAY_TUESDAY: 'Mardi',
    SCHEDULE_DAY_WEDNESDAY: 'Mercredi',
    SCHEDULE_DAY_THURSDAY: 'Jeudi',
    SCHEDULE_DAY_FRIDAY: 'Vendredi',
    SCHEDULE_DAY_SATURDAY: 'Samedi',
    SCHEDULE_DAY_SUNDAY: 'Dimanche',
    SCHEDULE_PUBLIC_HOLIDAYS: 'Jours fériés',
    SCHEDULE_START_HOUR: 'Début',
    SCHEDULE_END_HOUR: 'Fin',
    ADD_SCHEDULE_ENTRY: 'Ajouter une plage',
    REMOVE_SCHEDULE_ENTRY: 'Retirer',
    APPLY_GLOBAL_RATES_TO_SCHEDULE: 'Appliquer les tarifs globaux aux créneaux',

    // Zones forfaitaires réutilisables (page Zones + onglet du dialog tarifs)
    ZONES_PAGE_TITLE: 'Zones forfaitaires',
    ADD_ZONE_BUTTON: 'Ajouter une zone',
    ZONES_EMPTY_TITLE: 'Aucune zone forfaitaire',
    ZONES_EMPTY_DESCRIPTION:
      'Créez une zone (ex. Aéroport → Centre-ville) avec son prix par défaut, puis associez-la à vos véhicules.',
    ZONE_DIALOG_TITLE_CREATE: 'Nouvelle zone forfaitaire',
    ZONE_DIALOG_TITLE_EDIT: 'Modifier la zone',
    ZONE_DELETE_TITLE: 'Supprimer la zone',
    ZONE_DELETE_TEXT:
      'La zone sera supprimée et détachée de tous les véhicules qui l’utilisent. Cette action est irréversible.',
    ZONE_LINKED_VEHICLES_COUNT:
      '{count, plural, =0 {Aucun véhicule associé} one {# véhicule associé} other {# véhicules associés}}',
    ZONES_TAB_DESCRIPTION:
      'Associez des zones forfaitaires à ce véhicule. Le prix par défaut de la zone s’applique, sauf si vous le surchargez ici ou sur une plage horaire.',
    ZONES_TAB_EMPTY: 'Aucune zone forfaitaire. Créez votre premier trajet à prix fixe pour l’associer à ce véhicule.',
    ZONE_CREATED_SUCCESS: 'Zone créée et associée à ce véhicule.',
    ZONE_DEFAULT_PRICE_LABEL: 'Prix par défaut',
    ZONE_PRICE_OVERRIDE_LABEL: 'Prix pour ce véhicule',

    // Supplement
    ADD_SUPPLEMENT: 'Ajouter un supplément',
    SUPPLEMENT_NAME: 'Nom',
    SUPPLEMENT_NAME_PLACEHOLDER: 'Saisir le nom du supplément',
    SUPPLEMENT_PRICE: 'Prix',
    SUPPLEMENT_PRICE_PLACEHOLDER: 'Saisir le prix du supplément',

    // Save
    SAVE_SUCCESS_TITLE: 'Configuration enregistrée',
    SAVE_SUCCESS_DESC: 'Votre configuration tarifaire a été enregistrée avec succès.',
    SAVE_ERROR_TITLE: 'Erreur',
    SAVE_ERROR_DESC: "Impossible d'enregistrer la configuration. Veuillez réessayer.",

    // Empty states
    NO_VEHICLES: 'Aucun véhicule configuré',
    NO_VEHICLES_DESC: 'Ajoutez votre premier véhicule pour commencer à configurer vos tarifs.',
    EMPTY_VEHICLES: 'Aucun véhicule configuré',
    NO_PRICING_TIERS: 'Aucun palier tarifaire',
    NO_PRICING_TIERS_DESC: 'Ajoutez un palier pour définir les tarifs de ce véhicule.',
    EMPTY_PRICING_TIERS: 'Aucun palier tarifaire',
    NO_SCHEDULE: 'Aucune plage horaire',
    NO_SCHEDULE_DESC: "Ajoutez des plages horaires pour définir quand ces tarifs s'appliquent.",

    // Interrupteur du tunnel VTC. La politique de paiement (type + acompte) se règle désormais sur
    // chaque prestation « Course » (formulaire de prestation), plus ici.
    ENABLE_RIDE_TUNNEL: 'Activer le tunnel de réservation VTC',
    PAYMENT_POLICY_MOVED_HINT:
      'La politique de paiement (acompte, empreinte, paiement intégral…) se règle sur chaque prestation « Course », dans votre catalogue.',
  },
  // Carte affichée à la place du tunnel de résa quand la réservation en ligne est suspendue
  // (semi-gel dunning / abo gelé). Neutre : ne mentionne JAMAIS la raison. Consommée via
  // translate() par le booking-widget (sites publics, hors provider next-intl).
  BOOKING_SUSPENDED_CARD: {
    TITLE: 'La réservation en ligne est momentanément indisponible',
    DESC: 'Pour prendre rendez-vous, contactez directement l’établissement, il se fera un plaisir de vous répondre.',
    // Le numéro est un binding protégé : révélé au clic via l'endpoint captcha, jamais servi
    // en clair dans la réponse publique (anti-scraping).
    REVEAL_CTA: 'Voir le numéro',
    REVEAL_CTA_LOADING: 'Chargement…',
    CALL_CTA: 'Appeler',
  },
  // Récap du tunnel de réservation : champ unique « Code promo ou carte cadeau », lignes de remise et de
  // bon, montant du jour (spec Promotions § 8). Lus par DEFAULT_LABELS (shared-components, booking/types.ts),
  // que l'hôte peut surcharger ; hors provider next-intl.
  BOOKING_TUNNEL_CODES: {
    REMOVE_CODE: 'Retirer le code {code}',
    PROMO_CODE_KIND: 'Code promo',
    VOUCHER_CODE_KIND: 'Carte cadeau',
    DISCOUNT_LINE: 'Remise {label}',
    MANUAL_DISCOUNT_LINE: 'Remise accordée',
    VOUCHER_LINE_AMOUNT: 'Carte cadeau {code}',
    VOUCHER_LINE_PACK: 'Forfait {code}',
    VOUCHER_LINE_PRESTATION: 'Bon cadeau {code}',
    CODE_APPLIED: 'Code {code} appliqué : {amount}.',
    CODE_DROPPED: 'Le code {code} ne s’applique plus à votre sélection : il a été retiré.',
    PAY_TODAY_COVERED: 'Rien à payer en ligne : votre carte cadeau couvre ce qui est dû aujourd’hui.',
    REMAINING_ON_SITE_SENTENCE: 'Le reste, {amount}, se règle sur place.',
    // Promotion automatique (lot 2) : badge des cartes « −20 % » suivi de sa condition, rappel avant le
    // formulaire, bandeau quand la condition tombe à la validation du formulaire.
    PROMOTION_CONDITION_NEW_CUSTOMER: 'nouveaux clients',
    PROMOTION_CONDITION_TAGS: 'pour certains clients',
    PROMOTION_CONDITION_HOURS: 'à certaines heures',
    PROMOTION_CONDITION_PLACE: 'dans certains lieux',
    PROMOTION_PENDING_NEW_CUSTOMER: '{amount} nouveaux clients : vérifié avec votre email',
    PROMOTION_PENDING_TAGS: '{amount} réservé à certains clients : vérifié avec votre email',
    PROMOTION_PENDING_HOURS: '{amount} selon le créneau choisi',
    PROMOTION_PENDING_PLACE: '{amount} selon le lieu choisi',
    PROMOTION_REJECTED_NEW_CUSTOMER:
      'L’offre « {label} » est réservée aux nouveaux clients : le prix affiché est le tarif normal.',
    PROMOTION_REJECTED_TAGS:
      'L’offre « {label} » est réservée à certains clients : le prix affiché est le tarif normal.',
    PROMOTION_REJECTED_GENERIC: 'L’offre « {label} » ne s’applique pas à votre réservation : le prix a été mis à jour.',
  },
  // Navigation du tunnel de réservation (en-tête de progression, cartes, lieux, chargement).
  BOOKING_TUNNEL_NAV: {
    PROGRESS_LABEL: 'Étapes de la réservation',
    PROGRESS_COUNTER: '{step} · {index} / {total}',
    PROGRESS_COUNTER_ARIA: 'Étape {index} sur {total} : {step}',
    BACK_TO_SITE: 'Retour au site',
    RESTORED_SELECTION_TEXT: 'Vous aviez sélectionné {names} ({ago}).',
    RESTORED_SELECTION_RESUME: 'Reprendre',
    RESTORED_SELECTION_RESTART: 'Recommencer',
    RESTORED_SELECTION_ADD_QUESTION: 'Que faire de {names} ?',
    RESTORED_SELECTION_ADD: 'Ajouter à ma sélection',
    RESTORED_SELECTION_REPLACE: 'Remplacer',
    SUPPLEMENTS_SHOW_MORE_ONE: 'Voir l’autre option',
    SUPPLEMENTS_SHOW_MORE_OTHER: 'Voir les {count} autres options',
    CHOSEN: 'Choisi',
    REMOVE_FROM_SELECTION: 'Retirer {name} de la sélection',
    PLACE_GROUP_ESTABLISHMENT: 'En établissement',
    PLACE_GROUP_REMOTE: 'À distance',
    PLACE_GROUP_TRAVELING: 'À domicile',
    LOAD_ERROR: 'Impossible de charger les prestations pour le moment.',
    RETRY: 'Réessayer',
    SLOTS_LOADING: 'Chargement des créneaux…',
  },
  /* Tunnel adaptatif (spec Parcours P3) : créneau, réservabilité, devis, finalisation et confirmation. */
  BOOKING_TUNNEL_FLOW: {
    STEP_QUOTE: 'Demande de devis',
    SUMMARY_TITLE_SINGLE: 'Votre rendez-vous',
    EDIT: 'modifier',
    EDIT_ARIA: 'Modifier : {item}',
    SLOT_PLACE_LABEL: 'Lieu',
    SLOT_MEMBER_LABEL: 'Avec',
    SLOT_RESOURCE_LABEL: 'Ressource',
    MEMBER_PROMOTION_NO_PREFERENCE: 'Sans préférence : {value} si le rendez-vous est attribué à {names}.',
    DAY_PROMOTION: '{name} {value} {hours}',
    NO_SLOT_THIS_WEEK: 'Aucun créneau cette semaine.',
    NEXT_SLOT: 'Prochain créneau : {date}',
    NEXT_SLOT_SEARCHING: 'Recherche du prochain créneau…',
    NO_SLOT_UNTIL: 'Aucun créneau disponible d’ici le {date}.',
    EXIT_NO_PREFERENCE: 'Sans préférence',
    EXIT_OTHER_PLACE: 'Autre lieu',
    EXIT_REMOVE_PRESTATION: 'Retirer une prestation',
    CALL_PRO: 'Appeler',
    CALL_PRO_NAMED: 'Appeler {name}',
    CALL_PRO_LOADING: 'Affichage du numéro…',
    REQUEST_QUOTE: 'Demander un devis',
    BOOKABLE_FROM: 'Réservable à partir du {date}',
    SEE_OPTIONS: 'Voir les options',
    FULL_FOR_NOW_HINT:
      'Aucun créneau n’est libre pour le moment. Essayez sans préférence ou un autre lieu, ou contactez le professionnel.',
    NOT_BOOKABLE_ONLINE_HINT: 'Cette prestation ne se réserve pas en ligne : contactez le professionnel.',
    QUOTE_MESSAGE_LABEL: 'Votre demande (date, nombre de personnes…)',
    QUOTE_SUBMIT: 'Envoyer la demande',
    QUOTE_SENT_TITLE: 'Demande envoyée',
    QUOTE_SENT_TEXT: '{name} vous répond directement par email ou par téléphone.',
    QUOTE_SENT_TEXT_GENERIC: 'Le professionnel vous répond directement par email ou par téléphone.',
    QUOTE_BACK: 'Revenir aux prestations',
    QUOTE_FIELD_PRESTATION: 'Prestation',
    QUOTE_FIELD_FIRSTNAME: 'Prénom',
    QUOTE_FIELD_LASTNAME: 'Nom',
    QUOTE_FIELD_EMAIL: 'Email',
    QUOTE_FIELD_PHONE: 'Téléphone',
    QUOTE_FIELD_MESSAGE: 'Message',
    QUOTE_ERROR: 'La demande n’a pas pu être envoyée. Réessayez dans un instant.',
    CONTINUE_TO_PAYMENT: 'Continuer vers le paiement',
    CONFIRM_APPOINTMENT: 'Confirmer le rendez-vous',
    SEND_REQUEST: 'Envoyer ma demande',
    // Bouton du bloc paiement ({amount} formaté serveur) ; empreinte et carte enregistrée gardent un texte de confirmation.
    PAY_AMOUNT: 'Payer {amount}',
    PAY_DEPOSIT_AMOUNT: 'Payer l’acompte {amount}',
    PAY_CHOICE_TITLE: 'Paiement au choix',
    PAY_ONLINE_OPTION: 'Payer en ligne · {amount}',
    PAY_ON_SITE_OPTION: 'Payer sur place',
    TO_PAY_ON_SITE: 'À régler sur place',
    VALIDATION_NOTICE: 'Le professionnel confirme votre demande sous 24 h. Vous recevez un email dès sa réponse.',
    // Ajouté à la mention quand un paiement en ligne est débité : il l'est avant la réponse du pro (aucun
    // remboursement automatique s'il refuse, d'où rien de promis ici).
    VALIDATION_NOTICE_CHARGED_NOW: 'Le paiement est encaissé dès maintenant, sans attendre sa réponse.',
    CANCELLATION_FREE_UNTIL_DATE: 'Annulation gratuite jusqu’au {date}',
    CANCELLATION_DETAILS: 'détails',
    COUNTDOWN_RESERVED_FOR_YOU: 'Créneau réservé pour vous pendant',
    SLOT_TAKEN_NOTICE: 'Ce créneau vient d’être pris, choisissez-en un autre.',
    SLOT_RELEASED_NOTICE: 'Votre créneau a été libéré, choisissez-en un. Vos coordonnées sont gardées.',
    CUSTOMER_SUMMARY_EDIT: 'Modifier mes coordonnées',
    // Récap du panier en échec (bug 11) : affiché à la place du total, suivi de « Réessayer ».
    SUMMARY_ERROR: 'Le récapitulatif n’a pas pu être calculé.',
    CONFIRMATION_EMAIL_SENT: 'Un email de confirmation est parti à {email}',
    CONFIRMATION_PENDING_TITLE: 'Demande envoyée',
    BOOKING_CANCELLED: 'Réservation annulée',
    ITINERARY: 'Itinéraire',
    WITH_MEMBER: 'Avec {name}',
    PAID_ONLINE: 'Payé en ligne',
    SAVINGS: 'Vous avez économisé {amount}',
    ADD_TO_CALENDAR: 'Ajouter au calendrier',
    ADD_TO_GOOGLE_CALENDAR: 'Google Agenda',
    ADD_TO_ICS_CALENDAR: 'Apple, Outlook… (.ics)',
    MANAGE_BOOKING: 'Gérer mon rendez-vous',
    BOOK_ANOTHER: 'Prendre un autre rendez-vous',
  },
  /* Tunnel de réservation : libellés de l'interface, lus en minuscules par `bookingLabelsFor` (shared-components). */
  BOOKING_TUNNEL_LABELS: {
    COUNTDOWN_RESERVED_DURATION: 'réservé {minutes} minutes',
    STEP_SERVICE: 'Prestations',
    STEP_PLACE: 'Lieu',
    STEP_MEMBER: 'Praticien',
    STEP_RESOURCE: 'Ressource',
    STEP_SLOT: 'Créneau',
    STEP_CHECKOUT: 'Finalisation',
    CONTINUE: 'Continuer',
    BACK: 'Retour',
    CONFIRM: 'Confirmer la réservation',
    NO_SLOTS: 'Aucun créneau disponible cette semaine',
    TODAY: "Aujourd'hui",
    QUANTITY_LABEL: 'Nombre de personnes',
    SUPPLEMENTS_LABEL: 'Suppléments',
    DURATION_LABEL: 'Durée & tarif',
    TOTAL_LABEL: 'Total',
    SUBTOTAL_LABEL: 'Sous-total',
    PARTY_SIZE_LABEL: 'Nombre de personnes',
    PARTY_SIZE_MAX_HINT: 'Jusqu’à {count} personnes',
    PARTY_SIZE_DECREASE: 'Retirer une personne',
    PARTY_SIZE_INCREASE: 'Ajouter une personne',
    PARTY_SIZE_SUFFIX: '{count} pers.',
    SLOT_PLACES_ONE: '1 place',
    SLOT_PLACES_OTHER: '{count} places',
    SLOT_FULL: 'Complet',
    SLOT_INSUFFICIENT_PLACES: 'Pas assez de places pour {count} personnes',
    LINE_UNIT_BREAKDOWN: '{count} × {price}',
    SEARCH_PLACEHOLDER: 'Rechercher une prestation...',
    ALL_CATEGORIES: 'Tout',
    CATEGORIES_SCROLL_PREV: 'Catégories précédentes',
    CATEGORIES_SCROLL_NEXT: 'Catégories suivantes',
    WEEK_PREV: 'Semaine précédente',
    WEEK_NEXT: 'Semaine suivante',
    CHOOSE: 'Choisir',
    ADD_TO_SELECTION: 'Ajouter',
    REPLACE_SHORT: 'Remplacer',
    REPLACE_ITEM: 'Remplacer {names} par {name}',
    REPLACE_SELECTION: 'Remplacer ma sélection par {name}',
    REPLACE_REASON_SINGLE: 'Une seule prestation par réservation.',
    REPLACE_REASON_SLOT:
      '{name} ne peut pas être réservée dans le même rendez-vous que {names} : aucun créneau ne permet de les enchaîner.',
    REPLACE_REASON_PLACE: "{name} n'est proposée dans aucun lieu qui propose aussi {names}.",
    REPLACE_HINT_SLOT: 'Pas de créneau commun avec votre sélection',
    REPLACE_HINT_PLACE: 'Pas de lieu commun avec votre sélection',
    IN_SELECTION: 'Dans votre sélection',
    UNAVAILABLE_NO_SLOT: 'Aucune disponibilité',
    DURATION_UNAVAILABLE: 'Aucun créneau',
    PRESELECT_UNAVAILABLE: "La formule choisie pour {names} n'est plus disponible. Choisissez-en une autre ci-dessous.",
    PRESELECT_NOT_BOOKABLE:
      "{names} n'est pas réservable en ligne pour le moment. Choisissez une autre prestation ci-dessous ou contactez l'établissement.",
    PLACE_UNAVAILABLE_FOR_SERVICES: 'Indisponible pour votre sélection',
    PLACE_NONE_FOR_SERVICES: 'Aucun lieu ne propose cette combinaison de prestations.',
    MEMBER_NOT_FOR_SERVICE: 'Ne réalise pas cette prestation',
    MEMBER_NO_COMMON_SLOT: 'Aucun créneau avec cette combinaison',
    MEMBER_NOT_AT_PLACE: 'Indisponible dans ce lieu',
    RESOURCE_UNAVAILABLE_AT_PLACE: 'Indisponible dans ce lieu',
    SELECTION_TITLE: 'Votre sélection',
    NO_PREFERENCE: 'Sans préférence',
    CHOOSE_PLACE: 'Où souhaitez-vous votre rendez-vous ?',
    CHOOSE_MEMBER: 'Avec qui souhaitez-vous votre rendez-vous ?',
    CHOOSE_RESOURCE: 'Choisissez votre ressource',
    RESOURCE_REQUIRED: 'Veuillez choisir une ressource pour continuer',
    CHOOSE_SLOT: 'Choisissez votre créneau',
    MORNING: 'Matin',
    AFTERNOON: 'Après-midi',
    EVENING: 'Soir',
    PRICE_FROM: 'À partir de',
    ON_QUOTE: 'Sur devis',
    FREE: 'Gratuit',
    PRICE_TO_DETERMINE_SHORT: 'À déterminer',
    RIDE_BADGE: 'Course',
    RIDE_CAPACITY_PASSENGERS: 'passagers',
    RIDE_CAPACITY_SMALL_LUGGAGE: 'petits bagages',
    RIDE_CAPACITY_LARGE_LUGGAGE: 'grands bagages',
    RIDE_PRICE_FROM: 'À partir de {price}',
    RIDE_PRICE_BY_ROUTE: 'Prix selon trajet',
    RIDE_BOOK_CTA: 'Réserver ce trajet',
    ERROR_GENERIC: 'Une erreur est survenue',
    REMOVE: 'Supprimer',
    CLOSE: 'Fermer',
    PRESTATION_SINGULAR: 'prestation',
    PRESTATIONS_PLURAL: 'prestations',
    HIDE_DETAIL: 'Masquer',
    SHOW_DETAIL: 'Voir le détail',
    READ_MORE: 'Lire la suite',
    READ_LESS: 'Réduire',
    WATCH_VIDEO: 'Voir la vidéo',
    VIDEO_MODAL_TITLE: 'Vidéos',
    PHOTO_PREVIOUS: 'Photo précédente',
    PHOTO_NEXT: 'Photo suivante',
    CHOOSE_PER_SERVICE: 'Choisir par prestation',
    CHOOSE_N_MEMBERS: 'Choisissez {n} intervenants',
    PICK_N_MEMBERS_REMAINING: 'Encore {n} à choisir',
    DECREASE_QUANTITY: 'Diminuer la quantité',
    INCREASE_QUANTITY: 'Augmenter la quantité',
    CLEAR_SEARCH: 'Effacer',
    BOOKING_CONFIRMED: 'Réservation confirmée !',
    BOOKING_AWAITING_CONFIRMATION: 'Réservation en attente de confirmation',
    BOOKING_AWAITING_CONFIRMATION_MESSAGE:
      'Le professionnel doit valider votre réservation. Vous recevrez un e-mail dès qu’elle sera confirmée.',
    ADD_SUPPLEMENT: 'Ajouter',
    REMOVE_SUPPLEMENT: 'Retirer',
    CHECKOUT_TITLE: 'Finaliser votre réservation',
    YOUR_INFO: 'Vos coordonnées',
    FIRSTNAME: 'Prénom',
    LASTNAME: 'Nom',
    EMAIL: 'Email',
    PHONE: 'Téléphone',
    NOTE_LABEL: 'Notes pour le professionnel',
    NOTE_PLACEHOLDER: 'Informations utiles, demandes particulières...',
    ADDITIONAL_INFO: 'Informations complémentaires',
    VOUCHER_LABEL: 'Code promo ou carte cadeau',
    VOUCHER_APPLY: 'Appliquer',
    VOUCHER_REMOVE: 'Retirer',
    VOUCHER_PLACEHOLDER: 'Entrez votre code',
    VOUCHER_ERROR_EMPTY: 'Veuillez saisir un code.',
    // Refus NOT_ACTIVE du serveur : carte expirée, épuisée, annulée, ou encore tenue par une pré-réservation en
    // cours (la sienne, le temps que son DELETE aboutisse, ou celle d'un autre onglet) — jamais « inactive » à tort.
    VOUCHER_ERROR_EXPIRED:
      'Cette carte cadeau n’est plus utilisable : expirée, épuisée ou déjà engagée sur une réservation en cours.',
    VOUCHER_ERROR_INVALID: 'Cette carte cadeau ne peut pas être appliquée à cette réservation.',
    VOUCHER_INFO_APPLIED_PREFIX: 'Cette carte cadeau donne accès à une réduction de',
    VOUCHER_INFO_NO_REFUND_ON_CANCEL:
      "Attention : cette carte cadeau ne sera pas restituée en cas d'annulation de la réservation.",
    VOUCHER_ERROR_RETRY: 'Votre réservation a été mise à jour pendant la vérification du code. Appliquez-le à nouveau.',
    CODE_ERROR_NOT_FOUND: 'Ce code est introuvable.',
    /* Scan du QR d'une carte cadeau ou d'un lien promo (caméra du navigateur) */
    VOUCHER_SCAN_OPEN: 'Scanner un QR code',
    VOUCHER_SCAN_CLOSE: 'Fermer la caméra',
    VOUCHER_SCAN_STARTING: 'Ouverture de la caméra…',
    VOUCHER_SCAN_SCANNING: 'Placez le QR code de votre carte cadeau dans le cadre.',
    VOUCHER_SCAN_UNRECOGNIZED: "Ce QR code n'est ni une carte cadeau ni un code promo.",
    VOUCHER_SCAN_GIFT_CARD_PDF: 'Ce QR code ne contient pas le code : saisissez celui imprimé sur la carte cadeau.',
    VOUCHER_SCAN_PAUSED: 'Caméra en pause.',
    VOUCHER_SCAN_RESUME: 'Reprendre',
    VOUCHER_SCAN_RETRY: 'Réessayer',
    VOUCHER_SCAN_ERROR_DENIED:
      "L'accès à la caméra a été refusé. Autorisez-le dans les réglages de votre navigateur, ou saisissez le code.",
    VOUCHER_SCAN_ERROR_NO_CAMERA: 'Aucune caméra disponible : saisissez le code.',
    VOUCHER_SCAN_ERROR_BUSY: 'La caméra est utilisée par une autre application. Fermez-la, puis réessayez.',
    VOUCHER_SCAN_ERROR_UNAVAILABLE: "Le scanner n'a pas pu démarrer : saisissez le code.",
    PROMO_ERROR_EMPTY: 'Veuillez saisir un code promo.',
    PROMO_ERROR_EXPIRED: 'Ce code promo est expiré ou inactif.',
    PROMO_ERROR_INVALID: "Ce code n'est pas valide ou ne s'applique pas à cette réservation.",
    PROMO_ERROR_OUTSIDE_HOURS:
      "Ce code promo n'est valable que certains jours ou à certaines heures. Choisissez un créneau dans ces horaires pour en profiter.",
    PROMO_INFO_APPLIED_PREFIX: 'Ce code promo donne accès à une réduction de',
    PROMO_CONDITIONAL_NOTICE: 'La remise sera confirmée à l’étape suivante, selon les conditions du code.',
    PAYMENT_SECTION: 'Paiement',
    PAYMENT_LOCKED: 'Remplissez vos coordonnées pour accéder au paiement',
    PAYMENT_FINALIZING: 'Finalisation de votre réservation...',
    SECURE_PAYMENT: 'Paiement sécurisé',
    PAYMENT_METHODS_ACCEPTED: 'Moyens de paiement acceptés',
    PAYMENT_REDIRECT_FAILED:
      'Le paiement a échoué ou a été annulé. Vous pouvez choisir un autre moyen de paiement ou réessayer.',
    PAYMENT_REDIRECT_PENDING:
      'Votre paiement est en cours de validation par Klarna. Vous recevrez une confirmation dès finalisation.',
    PAYMENT_REDIRECT_UNVERIFIED:
      "La confirmation de votre paiement prend plus de temps que prévu. Nous continuons à vérifier : avant de réessayer, vérifiez auprès de votre banque ou de Klarna que vous n'avez pas été débité.",
    PAYMENT_REDIRECT_EXPIRED:
      'Votre réservation a expiré pendant le paiement. Si vous avez été débité, vous serez remboursé automatiquement. Vous pouvez recommencer.',
    PAYMENT_VERIFYING: 'Vérification du paiement en cours...',
    COUNTDOWN_RESERVED: 'Créneau réservé pendant',
    COUNTDOWN_EXPIRED: "Votre créneau n'est plus réservé",
    COUNTDOWN_RECHOOSE: 'Rechoisir un créneau',
    CANCELLATION_ACCEPT: "J'accepte les conditions d'annulation.",
    CANCELLATION_FREE_UNTIL: 'Remboursement intégral si annulation avant le',
    CANCELLATION_UNTIL_NO_PAYMENT: "Je m'engage à venir au rendez-vous ou à annuler avant le",
    CANCELLATION_ATTENDANCE_COMMITMENT: "Je m'engage à venir au rendez-vous ou à prévenir en cas d'empêchement.",
    CANCELLATION_NO_REFUND_AFTER_CONFIRM:
      "En cas d'annulation après confirmation, aucun remboursement ne sera effectué.",
    AMOUNT_TO_PAY: 'Montant à payer en ligne',
    REMAINING_ON_SITE: 'Reste à régler sur place',
    DISCOUNT_LABEL: 'Remise',
    REQUIRED_FIELD: 'Ce champ est requis',
    INVALID_EMAIL: 'Email invalide',
    INVALID_PHONE: 'Numéro de téléphone invalide',
    FREE_BOOKING_CONFIRM: 'Confirmer la réservation',
    PAY_ON_SITE_CONFIRM: 'Je paye sur place et m’engage à ne pas annuler',
    PAY_ONLINE_SECTION: 'Je règle en ligne',
    PAY_ON_SITE_OR_ONLINE: 'ou',
    CARD_SAVE_INFO: 'Empreinte bancaire : carte enregistrée, non débitée',
    PHONE_COUNTRY_CODE: 'Indicatif pays',
    PHONE_PLACEHOLDER: '6 12 34 56 78',
    STEP_ZONE_ADDRESS: 'Adresse',
    ZONE_ADDRESS_TITLE: 'Votre adresse',
    ZONE_ADDRESS_SUBTITLE:
      "Cette prestation se fait à votre domicile. Renseignez l'adresse pour vérifier qu'elle est dans la zone d'intervention.",
    ZONE_ADDRESS_PLACEHOLDER: 'Commencez à taper votre adresse...',
    ZONE_ADDRESS_OUTSIDE_ERROR: "Cette adresse est en dehors de la zone d'intervention du professionnel.",
    ZONE_ADDRESS_REQUIRED_ERROR: 'Veuillez sélectionner une adresse pour continuer.',
    ZONE_ADDRESS_CONTINUE: 'Continuer',
    ZONE_ADDRESS_SEARCH_HINT: 'Saisissez au moins 3 caractères',
  },
  /* Frise de paiement et de remboursement (tunnels réservation et course), lue par `DEFAULT_PAYMENT_TIMELINE_LABELS`. */
  BOOKING_TUNNEL_TIMELINE: {
    FROM_PRICE_PREFIX: 'à partir de',
    VOUCHER_INFO_APPLIED_GENERIC: 'Ce coupon est bien pris en compte pour ce panier.',
    TIMELINE_TITLE: 'Modalités de paiement',
    TIMELINE_NOW: "Aujourd'hui",
    TIMELINE_UNTIL: 'Jusqu’à la date limite',
    TIMELINE_AFTER_DEADLINE: 'Après',
    TIMELINE_NOW_NO_CANCEL: 'Annulation non remboursable',
    TIMELINE_DAY_OF: 'Le jour du rendez-vous',
    TIMELINE_FREE_CANCEL_UNTIL: 'Remboursement intégral si annulation avant le',
    TIMELINE_CANCEL_BEFORE: "Annulation possible jusqu'au",
    TIMELINE_NO_CHARGE_UNTIL: 'Si vous annulez avant le',
    TIMELINE_DEPOSIT_CHARGED: 'Acompte débité',
    TIMELINE_FULL_CHARGED: 'Paiement intégral débité',
    TIMELINE_IMPRINT_HELD: 'Empreinte bancaire enregistrée. Un débit temporaire peut apparaître sur votre compte.',
    TIMELINE_IMPRINT_CHARGEABLE: 'Après cette date, l’empreinte pourra être débitée',
    TIMELINE_IMPRINT_RELEASED: 'Empreinte libérée après la prestation',
    TIMELINE_CARD_SAVED: 'Carte enregistrée, aucun débit aujourd’hui',
    TIMELINE_BOOKING_CONFIRMED: 'Réservation en attente de confirmation',
    TIMELINE_NO_CANCEL_POSSIBLE: 'Annulation sans remboursement possible',
    TIMELINE_ATTENDANCE_COMMITMENT:
      "Aucun paiement en ligne requis. Merci d'honorer le rendez-vous ou de prévenir en cas d'empêchement.",
    TIMELINE_NO_CHARGE_AFTER_DEADLINE: 'Aucun frais d’annulation ne sera débité',
    TIMELINE_NON_REFUNDABLE: 'Aucun remboursement après cette date',
    TIMELINE_PARTIAL_REFUND_AFTER: "seront remboursés en cas d'annulation",
    TIMELINE_CANCELLATION_FEE_ATTEMPT: 'Aucun montant ne sera débité',
    TIMELINE_CANCELLATION_FEE_CAN_APPLY: 'Des frais d’annulation pourront être débités après cette date',
    TIMELINE_PAY_ON_SITE: 'Solde à régler sur place',
    TIMELINE_NOTHING_ON_SITE: 'Rien à régler sur place',
    TIMELINE_PRICE_TO_DETERMINE_ON_SITE: 'Prix à déterminer sur place',
    TIMELINE_AMOUNT_CHARGED: 'Débité',
    TIMELINE_AMOUNT_REFUNDABLE: 'Remboursé si annulation',
    TIMELINE_AMOUNT_NON_REFUNDABLE: 'Non remboursé',
    TIMELINE_AMOUNT_REMAINING: 'À payer sur place',
    TIMELINE_AMOUNT_CANCELLATION_FEE: 'Frais d’annulation potentiels',
    TIMELINE_VOUCHER_LABEL: 'Coupon',
    TIMELINE_VOUCHER_REFUND: 'Remboursement du coupon',
    TIMELINE_VOUCHER_NO_REFUND: 'Coupon non remboursé',
  },
  RIDE_PUBLIC_PAGE: {
    // Sélecteur de mode de /book/[slug] quand le pro propose prestations + trajets. Les libellés
    // du tunnel VTC lui-même vivent dans DEFAULT_RIDE_LABELS (shared-components/src/ride/types.ts),
    // pattern labels-par-props — /book est hors provider next-intl.
    // « Trajet » est neutre : convient aux taxis comme aux VTC (le terme « VTC » exclut les taxis).
    TAB_BOOKING: 'Prestations',
    TAB_BOOKING_SUBTITLE: 'Prendre rendez-vous pour une prestation',
    TAB_RIDE: 'Trajet',
    TAB_RIDE_SUBTITLE: 'Réserver un trajet avec chauffeur',
  },
  MARKDOWN_LLM: {
    PRESTATIONS_TITLE: 'Prestations',
    SEE_DETAIL_LINK: 'Voir le détail',
    SEE_CATEGORY_LINK: 'Voir la catégorie',
    NO_PRESTATION_IN_CATEGORY: 'Aucune prestation dans cette catégorie.',
    FROM_PRICE_PREFIX: 'À partir de',
    MINUTES_SHORT: 'min',
    CATEGORY_LABEL: 'Catégorie',
    PRICES_TITLE: 'Tarifs',
    NEWS_TITLE: 'Actualités',
    PUBLISHED_ON_PREFIX: 'Publié le',
    READ_ARTICLE_LINK: "Lire l'article",
    BY_AUTHOR_PREFIX: 'par',
    OUR_TEAM_FALLBACK_TITLE: 'Notre équipe',
    SPECIALTIES_LABEL: 'Spécialités',
    CAREER_LABEL: 'Parcours',
    TODAY_LABEL: "aujourd'hui",
    CONTACT_TITLE: 'Contact',
    ADDRESS_LABEL: 'Adresse',
    ACCESS_LABEL: 'Accès',
    LINKS_LABEL: 'Liens',
    OUR_LOCATIONS_TITLE: 'Nos lieux',
    HOURS_LABEL: "Horaires d'ouverture",
    HOURS_CLOSED: 'Fermé',
    HOURS_ALL_DAY: 'Ouvert 24h/24',
    HOURS_EXCEPTIONS_LABEL: 'Fermetures exceptionnelles',
    FAQ_FALLBACK_TITLE: 'FAQ',
    OFFER_LABEL: 'Offre',
    OFFER_UNTIL_PREFIX: "jusqu'au",
    OFFER_CODE_PREFIX: 'code',
    OFFERS_TITLE: 'Offres du moment',
    OFFER_ALL_PRESTATIONS: 'Toutes les prestations',
  },
  ADMIN_DASHBOARD: {
    TITLE: 'Tableau de bord admin',
    SUBTITLE: 'Santé de la production en temps réel',
    SUMMARY_HEARTBEAT_ALERTS: 'Alertes heartbeat',
    SUMMARY_INTERNAL_DOWN: 'Nos services KO',
    SUMMARY_EXTERNAL_DOWN: 'Services tiers KO',
    SUMMARY_QUEUE_FAILED: 'Jobs échoués',
    SUMMARY_ERRORS_24H: 'Erreurs 24h',
    REFRESH: 'Rafraîchir',
    LOADING: 'Chargement…',
    NO_DATA: 'Aucune donnée',
    FETCH_ERROR: 'Échec du chargement',
    HEARTBEAT_TITLE: 'Heartbeat produit',
    HEARTBEAT_SUBTITLE: 'Dernières actions utilisateurs critiques',
    EVENT_LAST_BOOKING: 'Dernier RDV',
    EVENT_LAST_CUSTOMER_PAYMENT: 'Dernier paiement client',
    EVENT_LAST_PAYMENT: 'Dernier paiement abonnement',
    EVENT_LAST_VOUCHER: 'Dernier bon cadeau',
    EVENT_LAST_PRO_SIGNUP: 'Dernière inscription pro',
    EVENT_LAST_CUSTOMER: 'Dernier nouveau client',
    EVENT_LAST_REVIEW: 'Dernier avis',
    BADGE_OK: 'OK',
    BADGE_WARN: 'Attention',
    BADGE_ALERT: 'Alerte',
    BADGE_IDLE: 'Inactif',
    PROVIDERS_TITLE: 'Services appelés',
    PROVIDERS_SUBTITLE: 'Sur les 24 dernières heures',
    PROVIDERS_INTERNAL_TITLE: 'Nos services',
    PROVIDERS_INTERNAL_SUBTITLE: 'Auto-hébergés : une panne ici est de notre ressort',
    PROVIDERS_EXTERNAL_TITLE: 'Services tiers',
    PROVIDERS_EXTERNAL_SUBTITLE: 'Fournisseurs externes : hors de notre contrôle direct',
    PROVIDERS_BADGE_OPEN: '{count, plural, one {# en panne} other {# en panne}}',
    PROVIDERS_BADGE_DEGRADED: '{count, plural, one {# dégradé} other {# dégradés}}',
    PROVIDERS_BADGE_ALL_HEALTHY: 'Tout est OK',
    PROVIDER_HEADER_NAME: 'Provider',
    PROVIDER_HEADER_STATE: 'Circuit',
    PROVIDER_HEADER_CALLS: 'Appels',
    PROVIDER_HEADER_SUCCESS_RATE: 'Succès',
    PROVIDER_HEADER_AVG_DURATION: 'Durée moy.',
    PROVIDER_HEADER_LAST_ERROR: 'Dernière erreur',
    QUEUES_TITLE: 'Files BullMQ',
    QUEUE_WAITING: 'En attente',
    QUEUE_ACTIVE: 'En cours',
    QUEUE_COMPLETED: 'Traitées',
    QUEUE_FAILED: 'Échouées',
    QUEUE_DELAYED: 'Différées',
    QUEUE_NO_FAILED_JOBS: 'Aucun job échoué',
    QUEUE_JOB_ATTEMPTS: '{count, plural, one {# tentative} other {# tentatives}}',
    QUEUE_COMPLETED_HINT: 'jobs récents conservés en file (pas un total 24h)',
    CRONS_TITLE: 'Crons',
    CRON_HEADER_NAME: 'Nom',
    CRON_HEADER_SCHEDULE: 'Fréquence',
    CRON_HEADER_LAST_RUN: 'Dernière exécution',
    CRON_HEADER_STATUS: 'Statut',
    CRON_HEADER_DURATION: 'Durée',
    NOTIFICATIONS_TITLE: 'Notifications 24h',
    NOTIFICATIONS_SUBTITLE: "Volume et taux d'échec par canal",
    NOTIFICATIONS_TOTAL: 'Total',
    NOTIFICATIONS_FAIL_RATE: "Taux d'échec",
    NOTIFICATIONS_TOP_ERRORS: 'Top erreurs',
    NOTIFICATIONS_TOP_PROS: 'Top pros par volume',
    ERRORS_TITLE: 'Dernières erreurs',
    ERROR_HEADER_WHEN: 'Quand',
    ERROR_HEADER_SOURCE: 'Source',
    ERROR_HEADER_MESSAGE: 'Message',
    DB_TITLE: 'Base de données',
    DB_SUBTITLE: 'Occupation PostgreSQL par table (statistiques internes, lignes = estimations)',
    DB_SIZE: 'Taille totale',
    DB_LIVE_ROWS: 'Lignes (estimation)',
    DB_DEAD_ROWS: 'Lignes mortes',
    DB_HEADER_TABLE: 'Table',
    DB_HEADER_TOTAL: 'Total',
    DB_HEADER_TABLE_SIZE: 'Données',
    DB_HEADER_INDEXES: 'Index',
    DB_HEADER_ROWS: 'Lignes',
    DB_HEADER_DEAD: 'Mortes',
    DB_HEADER_LAST_AUTOVACUUM: 'Dernier autovacuum',
    DB_SHOW_ALL: 'Afficher les {count} tables',
    DB_SHOW_LESS: 'Réduire',
  },
  GOOGLE_RESERVE: {
    TITLE: 'Réserver avec Google',
    SUBTITLE:
      'Affichez un bouton « Réserver » directement dans les résultats Google et sur Google Maps. Vos clients arrivent sur votre tunnel de réservation en un clic.',
    CHECKLIST_TITLE: 'Pré-requis',
    CHECKLIST_SUBTITLE: 'Tout doit être au vert pour demander l’activation.',
    CHECKLIST_ACTIVE_SUBSCRIPTION: 'Abonnement actif',
    CHECKLIST_ESTABLISHMENT_PLACE: 'Au moins un lieu de type établissement',
    CHECKLIST_ENABLED_PLACE: 'Au moins un lieu activé et prêt à être envoyé',
    CHECKLIST_PHONE: 'Numéro de téléphone renseigné',
    CHECKLIST_OPEN_AVAILABILITY: 'Des disponibilités ouvertes dans l’agenda',
    CHECKLIST_ELIGIBLE_PRESTATION: 'Au moins une prestation éligible',
    REQUEST_BUTTON: 'Demander l’activation',
    REQUEST_BUTTON_SUBSCRIPTION_HINT: 'Disponible avec un abonnement actif',
    PENDING_BANNER: 'Votre demande est en cours de revue par notre équipe.',
    PENDING_SINCE: 'Demande envoyée le {date}',
    APPROVED_BANNER: 'Votre compte est connecté à « Réserver avec Google ».',
    APPROVED_SINCE: 'Activé le {date}',
    APPROVED_HINT:
      'Vos prestations éligibles sont envoyées à Google chaque nuit. Le bouton peut mettre quelques jours à apparaître sur votre fiche.',
    REJECTED_BANNER: 'Votre demande a été refusée.',
    REJECTED_REASON_TITLE: 'Raison',
    RESUBMIT_BUTTON: 'Soumettre à nouveau',
    DISABLED_BANNER: 'Vous avez désactivé « Réserver avec Google ».',
    DISABLED_HINT:
      'La prise en compte par Google peut prendre plusieurs jours : le bouton peut rester visible sur votre fiche le temps que la désactivation se propage.',
    DISABLE_BUTTON: 'Désactiver temporairement',
    REENABLE_BUTTON: 'Réactiver',
    PRESTATIONS_TITLE: 'Vos prestations',
    PRESTATIONS_SUBTITLE:
      'La sélection est automatique : chaque prestation réservable en ligne et conforme aux règles de contenu Google est envoyée. Corrigez les points signalés pour inclure une prestation.',
    PRESTATION_ELIGIBLE: 'Envoyée à Google',
    PRESTATION_READY: 'Prête à l’envoi',
    PRESTATION_EXCLUDED: 'Non envoyée',
    PLACES_TITLE: 'Vos lieux',
    PLACES_SUBTITLE:
      'Activez « Réserver avec Google » lieu par lieu. Google associe chaque lieu à sa fiche par nom, adresse et téléphone.',
    PLACE_QUOTA: '{used} / {total} lieu(x) activé(s) avec votre abonnement',
    PLACE_QUOTA_REACHED:
      'Quota de lieux atteint pour votre abonnement. Passez à un plan supérieur pour en activer plus.',
    PLACE_ENABLE_BUTTON: 'Activer sur ce lieu',
    PLACE_DISABLE_BUTTON: 'Désactiver ce lieu',
    PLACE_EMITTED: 'Envoyé à Google',
    PLACE_READY: 'Prêt à l’envoi',
    PLACE_SKIPPED: 'Non envoyé',
    PLACE_ENABLED_BADGE: 'Activé',
    PLACE_DEFAULT_BADGE: 'Lieu principal',
    EXCLUSION_NOT_BOOKABLE: 'Aucun prix avec durée : la prestation n’est pas réservable en ligne',
    EXCLUSION_RIDE_TYPE: 'Les prestations de type trajet ne sont pas envoyées à Google',
    EXCLUSION_PRICE_NOT_DECLARABLE:
      'Prix « sur devis » : la prestation n’est pas réservable en ligne, elle ne peut pas être envoyée à Google. Un prix indéterminé (sans montant) convient, lui.',
    EXCLUSION_CONTAINS_PHONE: 'Contient un numéro de téléphone',
    EXCLUSION_CONTAINS_URL: 'Contient une adresse web',
    EXCLUSION_CONTAINS_EMAIL: 'Contient une adresse email',
    EXCLUSION_PRICE_IN_NAME: 'Le nom contient un prix',
    EXCLUSION_EXCESSIVE_CAPS: 'Trop de majuscules (évitez les mots entiers en capitales)',
    EXCLUSION_CONTAINS_EMOJI: 'Contient un emoji',
    EXCLUSION_NAME_TOO_LONG: 'Nom trop long (100 caractères maximum)',
    EXCLUSION_DESCRIPTION_TOO_LONG:
      'Description trop longue : elle sera tronquée à 5000 caractères dans le feed Google',
    EXCLUSION_PROMOTIONAL_WORDING: 'Vocabulaire promotionnel déconseillé par Google',
    EXCLUSION_ADDRESS_INCOMPLETE: 'Adresse incomplète (rue, code postal, ville et position GPS requis)',
    EXCLUSION_NOT_ENABLED: 'Lieu non activé : activez-le pour l’envoyer à Google',
    EXCLUSION_QUOTA_EXCEEDED: 'Au-delà du quota de lieux de votre abonnement',
    WARNINGS_LABEL: 'À surveiller',
  },
  // Espace affilié self-service (affiliation v2, Lot 5) — /affiliation/login + /affiliation/account.
  // Fragments de copie d'email affilié rendus par le backend (le reste de la copie vit
  // dans les templates `notification/templates/defaults/fr-FR/`). Ici parce que la phrase
  // dépend d'une donnée que seul le backend connaît : le statut réel de la commission.
  AFFILIATE_NOTIFICATION: {
    COMMISSION_NOTE_PENDING: 'Elle sera intégrée à votre prochain versement.',
    COMMISSION_NOTE_REVIEW:
      'Elle est retenue le temps que nous validions ce parrainage, et sera confirmée dès que c’est fait.',
    COMMISSION_NOTE_OTHER: 'Vous en suivez le statut dans votre espace ambassadeur.',
  },
  AFFILIATE_SPACE: {
    LOGIN_TITLE: 'Espace affilié',
    LOGIN_SUBTITLE: 'Connectez-vous avec votre email pour suivre vos filleuls et vos commissions.',
    LOGIN_EMAIL_LABEL: 'Votre email',
    LOGIN_EMAIL_PLACEHOLDER: 'vous@exemple.fr',
    LOGIN_SEND_CODE: 'Recevoir mon code',
    LOGIN_CODE_SENT: 'Si un compte affilié existe pour cet email, un code de connexion vient de vous être envoyé.',
    LOGIN_CODE_LABEL: 'Code reçu par email',
    LOGIN_SUBMIT: 'Se connecter',
    LOGIN_BACK: 'Changer d’email',
    LOGIN_ERROR_INVALID_CODE: 'Code invalide ou expiré. Redemandez un code et réessayez.',
    LOGIN_ERROR_GENERIC: 'Une erreur est survenue. Réessayez dans un instant.',
    LOGIN_NO_ACCOUNT: 'Pas encore ambassadeur ? Rejoindre le programme',
    LOGIN_HAVE_ACCOUNT: 'J’ai déjà un compte',
    // ── Auto-inscription au programme (porté de la v1) ─────────────────────
    SIGNUP_TITLE: 'Rejoindre le programme ambassadeur',
    SIGNUP_SUBTITLE: 'Créez votre compte, votre lien de parrainage est actif immédiatement.',
    SIGNUP_FIRST_NAME: 'Prénom',
    SIGNUP_FIRST_NAME_PLACEHOLDER: 'Marie',
    SIGNUP_LAST_NAME: 'Nom',
    SIGNUP_LAST_NAME_PLACEHOLDER: 'Durand',
    SIGNUP_PHONE: 'Téléphone',
    SIGNUP_PHONE_PLACEHOLDER: '6 12 34 56 78',
    SIGNUP_REGIME_LABEL: 'Vous êtes',
    SIGNUP_REGIME_PRO_EXTERNE: 'Un professionnel (non client)',
    SIGNUP_REGIME_PRO_EXTERNE_HINT: 'Vos gains vous sont versés par virement, sur facture.',
    SIGNUP_REGIME_PARTICULIER: 'Un particulier',
    SIGNUP_REGIME_PARTICULIER_HINT: 'Vos gains vous sont versés en carte cadeau.',
    SIGNUP_REGIME_CLIENT_PRO: `Déjà client ${PROJECT_CONFIG.brand_string}`,
    SIGNUP_REGIME_CLIENT_PRO_HINT: 'Vos gains sont déduits de votre abonnement.',
    SIGNUP_CLIENT_PRO_INFO: `Bonne nouvelle : votre espace ambassadeur est déjà inclus dans votre application ${PROJECT_CONFIG.brand_string}. Retrouvez votre lien de parrainage dans Compte → Parrainage ; vos gains sont automatiquement déduits de vos prochaines factures.`,
    SIGNUP_CLIENT_PRO_CTA: 'Ouvrir mon espace parrainage',
    SIGNUP_TERMS_PREFIX: 'J’accepte les',
    SIGNUP_TERMS_LINK: 'conditions du programme',
    SIGNUP_SUBMIT: 'Créer mon compte ambassadeur',
    SIGNUP_ERROR_TERMS: 'Vous devez accepter les conditions du programme pour continuer.',
    SIGNUP_ERROR_GENERIC: 'Impossible de créer le compte pour le moment. Réessayez dans un instant.',
    // Validation de saisie : un message par champ, affiché sous le champ fautif.
    ERROR_EMAIL_INVALID: 'Saisissez une adresse email valide.',
    ERROR_FIRST_NAME_REQUIRED: 'Indiquez votre prénom.',
    ERROR_LAST_NAME_REQUIRED: 'Indiquez votre nom.',
    ERROR_PHONE_INVALID: 'Numéro de téléphone invalide. Vérifiez l’indicatif du pays et le numéro.',
    ERROR_CODE_FORMAT: 'Le code reçu par email contient 6 chiffres.',
    ACCOUNT_TITLE: 'Mon espace affilié',
    ACCOUNT_SUBTITLE: 'Vos filleuls, vos commissions et votre lien de parrainage.',
    ACCOUNT_LOGOUT: 'Se déconnecter',
    // L'espace affilié a son propre layout racine : sans ce retour, un pro entré
    // depuis l'app n'a aucun chemin de sortie autre que la déconnexion.
    ACCOUNT_BACK_TO_APP: 'Retour à mon compte',
    ACCOUNT_BACK_TO_SITE: 'Retour sur {brand}',
    ACCOUNT_PENDING: 'Solde à verser',
    ACCOUNT_REVIEW: 'Gains en cours de validation',
    ACCOUNT_REFERRAL_UNDER_REVIEW: 'En cours de vérification',
    ACCOUNT_REVIEW_HINT:
      'Ces gains sont bien enregistrés à votre nom. Ils rejoignent votre solde à verser une fois vérifiés par notre équipe.',
    ACCOUNT_PAID: 'Déjà versé',
    ACCOUNT_CLICKS_30D: 'Clics (30 j)',
    ACCOUNT_REFERRAL_LINK: 'Votre lien de parrainage',
    ACCOUNT_COPY_LINK: 'Copier le lien',
    ACCOUNT_LINK_COPIED: 'Lien copié !',
    ACCOUNT_REFERRAL_LINK_DESCRIPTION: 'Deux façons de parrainer : partagez votre lien, ou donnez votre code promo.',
    ACCOUNT_BOUNTY_BADGE: '{bounty} offerts à votre filleul',
    ACCOUNT_BOUNTY_CODE_LABEL: 'Votre code promo',
    ACCOUNT_BOUNTY_HINT:
      'Appliqué automatiquement quand votre filleul passe par votre lien. Sinon, il saisit ce code au moment de s’abonner : la remise lui est accordée et le parrainage vous est attribué.',
    ACCOUNT_COPY_CODE: 'Copier le code',
    ACCOUNT_CODE_COPIED: 'Code copié !',
    ACCOUNT_REFERRALS_TITLE: 'Vos filleuls',
    ACCOUNT_REFERRALS_EMPTY: 'Pas encore de filleul. Partagez votre lien !',
    ACCOUNT_REFERRAL_COL_NAME: 'Filleul',
    ACCOUNT_REFERRAL_COL_SINCE: 'Client depuis',
    ACCOUNT_REFERRAL_COL_RATE: 'Taux actuel',
    ACCOUNT_REFERRAL_COL_TOTAL: 'Commissions cumulées',
    ACCOUNT_REFERRAL_NOT_PAYING: 'Pas encore abonné',
    ACCOUNT_LEDGER_TITLE: 'Vos commissions',
    ACCOUNT_LEDGER_EMPTY: 'Aucune commission pour le moment.',
    ACCOUNT_LEDGER_COL_DATE: 'Date',
    ACCOUNT_LEDGER_COL_KIND: 'Type',
    ACCOUNT_LEDGER_COL_PRO: 'Filleul',
    ACCOUNT_LEDGER_COL_AMOUNT: 'Montant',
    ACCOUNT_LEDGER_COL_STATUS: 'Statut',
    ACCOUNT_PAYOUT_TITLE: 'Versement',
    ACCOUNT_PAYOUT_THRESHOLD: 'Seuil de versement : {threshold}',
    ACCOUNT_PAYOUT_REQUEST: 'Demander un versement',
    ACCOUNT_PAYOUT_BELOW_THRESHOLD: 'Votre solde doit atteindre {threshold} pour demander un versement.',
    ACCOUNT_PAYOUT_REQUESTED: 'Demande de versement envoyée le {date}. Notre équipe la traite au plus vite.',
    ACCOUNT_PAYOUT_SUCCESS: 'Votre demande de versement a bien été envoyée.',
    ACCOUNT_SESSION_EXPIRED: 'Votre session a expiré, reconnectez-vous.',
    ACCOUNT_LOADING: 'Chargement…',
    // ── Modération : le lien attribue dès l'inscription, la vérification porte
    //    sur chaque filleul (et donc sur les gains), jamais sur le compte. ──────
    ACCOUNT_PENDING_TITLE: 'Bienvenue dans le programme',
    ACCOUNT_PENDING_TEXT:
      'Votre lien de parrainage est actif : les inscriptions qu’il génère vous sont attribuées dès maintenant. Chaque nouveau filleul est vérifié par notre équipe, puis les gains correspondants rejoignent votre solde à verser.',
    ACCOUNT_SUSPENDED_TITLE: 'Compte suspendu',
    ACCOUNT_SUSPENDED_TEXT: 'Votre participation au programme est suspendue. Contactez-nous pour en savoir plus.',
    // ── Coordonnées de versement (régimes particulier / professionnel) ──────
    ACCOUNT_PAYOUT_DETAILS_TITLE: 'Coordonnées de versement',
    ACCOUNT_PAYOUT_DETAILS_SUBTITLE_PRO:
      'Vos commissions vous sont versées par virement. Renseignez le compte à créditer et l’identité à facturer.',
    ACCOUNT_PAYOUT_DETAILS_SUBTITLE_PARTICULIER:
      'Vos commissions vous sont versées en carte cadeau. Indiquez l’adresse email de livraison.',
    ACCOUNT_PAYOUT_DETAILS_SUBTITLE_CLIENT_PRO:
      'Vos commissions sont déduites de votre propre abonnement. Aucune coordonnée bancaire n’est nécessaire.',
    ACCOUNT_PAYOUT_HOLDER: 'Titulaire du compte',
    ACCOUNT_PAYOUT_IBAN: 'IBAN',
    ACCOUNT_PAYOUT_IBAN_SAVED: 'IBAN enregistré : {masked}',
    ACCOUNT_PAYOUT_IBAN_REPLACE: 'Saisissez un nouvel IBAN pour le remplacer.',
    ACCOUNT_PAYOUT_BIC: 'BIC / SWIFT',
    ACCOUNT_PAYOUT_COMPANY: 'Raison sociale',
    ACCOUNT_PAYOUT_SIRET: 'SIRET',
    ACCOUNT_PAYOUT_GIFT_EMAIL: 'Email de réception de la carte cadeau',
    ACCOUNT_PAYOUT_DETAILS_SAVE: 'Enregistrer',
    ACCOUNT_PAYOUT_DETAILS_SAVED: 'Coordonnées enregistrées.',
    ACCOUNT_PAYOUT_DETAILS_INCOMPLETE: 'Complétez vos coordonnées de versement pour pouvoir demander un versement.',
    ACCOUNT_PAYOUT_ERROR_IBAN: 'Cet IBAN est invalide. Vérifiez la saisie.',
    ACCOUNT_PAYOUT_ERROR_BIC: 'Ce BIC est invalide. Vérifiez la saisie.',
    ACCOUNT_PAYOUT_ERROR_THRESHOLD:
      'Votre solde à verser est repassé sous le seuil : la demande n’a pas été enregistrée.',
    ACCOUNT_PAYOUT_ERROR_DETAILS_REQUIRED: 'Complétez vos coordonnées de versement avant de demander un versement.',
    ACCOUNT_TERMS_LINK: 'Conditions du programme',
    // Pont depuis l'app pro (« Mon compte » → Parrainage) — pas d'OTP, échange de session.
    PRO_BRIDGE_LOADING: 'Ouverture de votre espace ambassadeur…',
    PRO_BRIDGE_NOT_AFFILIATE_TITLE: 'Devenez ambassadeur',
    PRO_BRIDGE_NOT_AFFILIATE_TEXT:
      'Recommandez {brand} aux professionnels de votre réseau et touchez {rate_year_1} % de leur abonnement la première année, puis {rate_year_2_3} % pendant deux ans. Chaque filleul reçoit {bounty} de remise à l’inscription.',
    PRO_BRIDGE_ACTIVATE: 'Activer mon compte ambassadeur',
    PRO_BRIDGE_ACTIVATING: 'Activation en cours…',
    PRO_BRIDGE_TERMS_PREFIX: 'En activant votre compte, vous acceptez les',
    PRO_BRIDGE_TERMS_LINK: 'conditions du programme',
    PRO_BRIDGE_OWNER_ONLY:
      'Seul le propriétaire du compte peut activer le programme pour cet établissement. Vous pouvez rejoindre le programme à titre personnel depuis la page publique.',
    PRO_BRIDGE_ERROR: 'Impossible d’ouvrir votre espace ambassadeur pour le moment. Réessayez dans un instant.',
    PRO_BRIDGE_RETRY: 'Réessayer',
  },
  // Pages servies par le backend derrière les liens « en un clic » des e-mails du pack SEO
  // (jeton signé ; le GET ne fait que confirmer, l'action part au POST du bouton).
  SEO_PUBLIC: {
    INVALID_TITLE: 'Lien invalide ou expiré',
    INVALID_TEXT: 'Ce lien n’est plus valable. Retrouvez vos sujets et vos articles dans votre espace {brand}.',
    INACTIVE_TITLE: 'Pack référencement inactif',
    INACTIVE_TEXT:
      'Ce lien est rattaché à un pack référencement qui n’est plus actif sur votre compte {brand}. Contactez-nous si vous souhaitez le réactiver.',
    CONFIRM_TOPICS_TITLE: 'Valider {count} sujet(s) d’articles',
    CONFIRM_TOPICS_TEXT:
      'La rédaction démarre pour ces sujets. Vous relirez chaque article avant publication : rien n’est publié sans votre accord.',
    CONFIRM_TOPICS_BUTTON: 'Valider ces sujets',
    CONFIRM_ARTICLES_TITLE: 'Programmer {count} article(s)',
    CONFIRM_ARTICLES_TEXT:
      'Chaque article validé prend votre prochain créneau de publication sur votre site. Vous pouvez encore le relire ou le retirer depuis votre espace {brand}.',
    CONFIRM_ARTICLES_BUTTON: 'Valider et programmer',
    OPEN_APP: 'Ouvrir mon espace',
  },
  // Textes composés par le backend dans les notifications et demandes du pack référencement
  // (fragments injectés dans les templates `pro_seo_*`, conversation support d'une demande hors pack).
  SEO_NOTIFICATION: {
    REMINDER_PREFIX: 'Rappel : ',
    ARTICLE_REVIEW_LINK: 'Relire',
    ARTICLE_VALIDATE_LINK: 'Valider et programmer',
    UPSELL_KIND_ARTICLE: 'article(s) SEO supplémentaire(s)',
    UPSELL_KIND_BACKLINK: 'backlink(s) supplémentaire(s)',
    UPSELL_SUBJECT: 'Demande : {quantity} {what}',
    UPSELL_MESSAGE: 'Bonjour, je souhaite commander {quantity} {what} en plus de mon pack référencement.',
    UPSELL_DETAILS: 'Précisions : {message}',
    BACKLINK_PUBLISHED_SOURCE: 'Article publié sur {host}',
    BACKLINK_REVIEW_LINK: 'Relire et valider',
  },
  // Fragments composés par le backend dans les notifications des promotions (cloche et push,
  // templates `PRO_PROMOTION_*` : veille du démarrage, 80 % du quota, bilan de fin).
  PROMOTION_NOTIFICATION: {
    PERIOD_FROM_TO: 'du {from} au {to}',
    PERIOD_FROM: 'à partir du {from}',
    USAGE_ONE: '{count} utilisation sur {max}',
    USAGE_OTHER: '{count} utilisations sur {max}',
    BOOKINGS_ONE: '{count} réservation',
    BOOKINGS_OTHER: '{count} réservations',
  },
  // Textes servis par le backend aux personnes suivies par le CRM (SMS, page à une question).
  // Rédaction de Kaltouma attendue avec chaque lot : ceux-ci sont des premières versions.
  CRM_PUBLIC: {
    // Désinscription des emails de la séquence (page servie par le backend, lien signé).
    UNSUBSCRIBE_INVALID_TITLE: 'Lien invalide ou expiré',
    UNSUBSCRIBE_INVALID_TEXT: 'Ce lien de désinscription n’est plus valable.',
    UNSUBSCRIBE_CONFIRM_TITLE: 'Confirmer la désinscription',
    UNSUBSCRIBE_CONFIRM_TEXT:
      'Vous ne recevrez plus les emails d’information de {brand}. Les messages liés à votre compte (mot de passe, facturation) continueront d’arriver.',
    UNSUBSCRIBE_CONFIRM_BUTTON: 'Me désinscrire',
    UNSUBSCRIBE_DONE_TITLE: 'Vous êtes désinscrit',
    UNSUBSCRIBE_DONE_TEXT:
      'Vous ne recevrez plus les emails d’information de {brand}. Les emails liés à votre compte continuent d’arriver.',
    SMS_LAST_CHANCE:
      '{brand} : on n’a pas réussi à vous joindre. Qu’est-ce qui vous a arrêté ? 1 question, 20 secondes : {link}',
    SMS_TRAINING_MISSED:
      '{brand} : vous nous avez manqué à la formation. Une autre séance a lieu bientôt, on vous y garde une place ? Répondez-nous ou réinscrivez-vous : {link}',
    SMS_TRAINING_LAST_CALL:
      '{brand} : qu’est-ce qui vous a empêché de venir à la formation ? 1 question, 20 secondes : {link}',
    SMS_TRAINING_ATTENDED:
      '{brand} : merci d’être venu à la formation. Il vous reste à finir votre configuration, puis à choisir votre formule : {link}',
    FEEDBACK_TITLE_NON_CONVERSION: 'Qu’est-ce qui vous a arrêté ?',
    FEEDBACK_TITLE_TRAINING_MISSED: 'Qu’est-ce qui vous a empêché de venir ?',
    FEEDBACK_SUBTITLE: 'Une seule question, pour comprendre. Choisissez la réponse qui vous ressemble le plus.',
    FEEDBACK_OTHER_PLACEHOLDER: 'Dites-nous en un mot (facultatif)',
    // Une clé par raison de `NON_CONVERSION_REASONS_SELECTABLE`, dite par la personne elle-même.
    FEEDBACK_REASON_NO_TIME: 'Je n’ai pas eu le temps de m’y mettre',
    FEEDBACK_REASON_TOO_COMPLEX: 'Je n’ai pas compris comment faire',
    FEEDBACK_REASON_BLOCKED_ON_STEP: 'J’ai bloqué sur une étape',
    FEEDBACK_REASON_EXPECTATION_MISMATCH: 'Ce n’est pas ce que j’attendais',
    FEEDBACK_REASON_MISSING_FEATURE: 'Il me manque une fonctionnalité indispensable',
    FEEDBACK_REASON_PRICE: 'C’est trop cher pour moi',
    FEEDBACK_REASON_ALREADY_EQUIPPED: 'Je garde mon outil actuel',
    FEEDBACK_REASON_NOT_ENOUGH_CUSTOMERS: 'Je n’ai pas assez de clients pour le moment',
    FEEDBACK_REASON_NO_INTENT: 'Je voulais seulement regarder',
    FEEDBACK_REASON_PREVIEW_DISLIKED: 'Le site proposé ne me plaisait pas',
    FEEDBACK_REASON_NOT_AWARE: 'Je n’ai rien reçu, je n’étais pas au courant',
    FEEDBACK_REASON_BUSINESS_STOPPED: 'Mon activité est arrêtée ou en pause',
    FEEDBACK_REASON_OTHER: 'Autre raison',
    FEEDBACK_SEND: 'Envoyer',
    FEEDBACK_THANKS_TITLE: 'Merci',
    FEEDBACK_THANKS_SUBTITLE: 'Votre réponse est enregistrée. Bonne continuation.',
    FEEDBACK_INVALID_TITLE: 'Lien invalide ou expiré',
    FEEDBACK_INVALID_SUBTITLE: 'Ce lien n’est plus valable.',
  },
  ADMIN: {
    APP_TITLE: `Admin ${PROJECT_CONFIG.brand_string}`,
    LOGIN_TITLE: 'Connexion',
    LOGIN_SUBTITLE: 'Espace réservé à l’équipe interne.',
    LOGIN_EMAIL: 'Email',
    LOGIN_EMAIL_PLACEHOLDER: 'votre.email@wm-dev.fr',
    LOGIN_PASSWORD: 'Mot de passe',
    LOGIN_PASSWORD_PLACEHOLDER: 'Mot de passe',
    LOGIN_SHOW_PASSWORD: 'Afficher le mot de passe',
    LOGIN_HIDE_PASSWORD: 'Masquer le mot de passe',
    LOGIN_SUBMIT: 'Se connecter',
    LOGIN_ERROR: 'Email ou mot de passe invalide.',
    LOGIN_LOADING: 'Connexion en cours…',
    MFA_CHALLENGE_TITLE: 'Double authentification',
    MFA_CHALLENGE_SUBTITLE: 'Saisissez le code à 6 chiffres affiché par votre application d’authentification.',
    MFA_CODE_LABEL: 'Code',
    MFA_CODE_PLACEHOLDER: '123456',
    MFA_RECOVERY_HINT: 'Téléphone indisponible ? Saisissez un de vos codes de secours (xxxx-xxxx).',
    MFA_SUBMIT: 'Valider',
    MFA_BACK: 'Retour',
    MFA_ERROR: 'Code invalide, expiré ou déjà utilisé.',
    MFA_LOCKED: 'Trop de codes invalides : réessayez dans 15 minutes.',
    MFA_TOKEN_EXPIRED: 'Étape expirée : reconnectez-vous.',
    MFA_SECRET_UNREADABLE:
      'Votre secret de double authentification est illisible (clé de chiffrement changée ?). Demandez à un super-admin de réinitialiser votre 2FA, ou utilisez un code de secours.',
    MFA_ENROLL_START_FAILED: 'Impossible de préparer l’activation pour le moment (réseau ou trop de tentatives).',
    MFA_RETRY: 'Réessayer',
    MFA_ENROLL_TITLE: 'Activer la double authentification',
    MFA_ENROLL_SUBTITLE:
      'Obligatoire pour accéder à l’admin. Scannez ce QR code avec une application d’authentification (Google Authenticator, 1Password, Aegis, Yubico Authenticator…), puis saisissez le code affiché.',
    MFA_ENROLL_QR_ALT: 'QR code à scanner avec votre application d’authentification',
    MFA_ENROLL_MANUAL: 'Saisie manuelle de la clé :',
    MFA_ENROLL_LOADING: 'Préparation…',
    MFA_ENROLL_SUBMIT: 'Activer',
    MFA_RECOVERY_TITLE: 'Vos codes de secours',
    MFA_RECOVERY_SUBTITLE:
      'Chaque code permet UNE connexion si vous n’avez plus accès à votre application. Ils ne seront plus jamais affichés : conservez-les dans un gestionnaire de mots de passe.',
    MFA_RECOVERY_COPY: 'Copier les codes',
    MFA_RECOVERY_COPIED: 'Codes copiés.',
    MFA_RECOVERY_ACK: 'J’ai conservé mes codes de secours',
    MFA_RECOVERY_CONTINUE: 'Accéder à l’admin',
    SIDEBAR_DASHBOARD: 'Tableau de bord',
    SIDEBAR_LEADS: 'Leads',
    SIDEBAR_PROFESSIONALS: 'Clients',
    SIDEBAR_ACTIVITY_CATALOG: 'Métiers',
    SIDEBAR_DOMAINS: 'Domaines',
    SIDEBAR_MAIL_MIGRATION: 'Migration mail OVH',
    SIDEBAR_MONITORING: 'Monitoring',
    SIDEBAR_AUDIT_LOGS: 'Journal d’audit',
    SIDEBAR_SETTINGS: 'Paramètres',
    SIDEBAR_GOOGLE_RESERVE: 'Réserver avec Google',
    SIDEBAR_AFFILIATE: 'Affiliation',
    // ── Affiliation (/affiliate) ───────────────────────────────────────────
    AFFILIATE_TITLE: 'Affiliation',
    AFFILIATE_SUBTITLE: 'Affiliés, filleuls, commissions et règlements — pilotage manuel du programme.',
    AFFILIATE_CREATE: 'Nouvel affilié',
    AFFILIATE_SEARCH_PLACEHOLDER: 'Rechercher (email, nom, code)…',
    AFFILIATE_FILTER_ALL_STATUSES: 'Tous les statuts',
    AFFILIATE_COL_AFFILIATE: 'Affilié',
    AFFILIATE_COL_REGIME: 'Régime',
    AFFILIATE_COL_STATUS: 'Statut',
    AFFILIATE_COL_REFERRED: 'Filleuls',
    AFFILIATE_COL_REFERRED_ACTIVE: '{count, plural, one {# actif} other {# actifs}}',
    AFFILIATE_COL_PENDING: 'Solde dû',
    AFFILIATE_COL_PAID: 'Déjà versé',
    AFFILIATE_COL_CREATED_AT: 'Créé le',
    AFFILIATE_PAYOUT_REQUESTED_BADGE: 'Versement demandé',
    AFFILIATE_PAYOUT_REQUESTED_AT: 'Versement demandé le',
    AFFILIATE_EMPTY: 'Aucun affilié.',
    AFFILIATE_VIEW: 'Voir',
    AFFILIATE_DETAIL_TITLE: 'Fiche affilié',
    AFFILIATE_DETAIL_IDENTITY: 'Identité',
    AFFILIATE_DETAIL_REF_TOKEN: 'Code affilié',
    AFFILIATE_DETAIL_REFERRAL_URL: 'Lien de parrainage',
    AFFILIATE_DETAIL_COPY_URL: 'Copier le lien',
    AFFILIATE_DETAIL_URL_COPIED: 'Lien copié !',
    AFFILIATE_DETAIL_BOUNTY_CODE: 'Code bounty filleul (20 €)',
    AFFILIATE_DETAIL_BALANCES: 'Soldes',
    AFFILIATE_DETAIL_PENDING: 'Solde dû',
    AFFILIATE_DETAIL_PAID: 'Déjà versé',
    AFFILIATE_DETAIL_REFERRALS: 'Échéancier des filleuls',
    AFFILIATE_DETAIL_REFERRALS_EMPTY: 'Aucun filleul attribué.',
    AFFILIATE_REFERRAL_COL_PRO: 'Filleul',
    AFFILIATE_REFERRAL_COL_REFERRED_AT: '1er paiement',
    AFFILIATE_REFERRAL_COL_MONTH: 'Mois de relation',
    AFFILIATE_REFERRAL_COL_RATE: 'Taux en vigueur',
    AFFILIATE_REFERRAL_COL_SWITCH: 'Bascule 30→10 %',
    AFFILIATE_REFERRAL_COL_END: 'Fin des 36 mois',
    AFFILIATE_REFERRAL_COL_TOTAL: 'Commissions cumulées',
    AFFILIATE_REFERRAL_NOT_PAYING: 'Pas encore payant',
    AFFILIATE_DETAIL_LEDGER: 'Ledger des commissions',
    AFFILIATE_DETAIL_LEDGER_EMPTY: 'Aucune ligne.',
    AFFILIATE_LEDGER_COL_KIND: 'Type',
    AFFILIATE_LEDGER_COL_STATUS: 'Statut',
    AFFILIATE_LEDGER_COL_PRO: 'Filleul',
    AFFILIATE_LEDGER_COL_BASE: 'Base (plan HT)',
    AFFILIATE_LEDGER_COL_AMOUNT: 'Commission',
    AFFILIATE_LEDGER_COL_RATE: 'Taux',
    AFFILIATE_LEDGER_COL_MONTH: 'Mois',
    AFFILIATE_LEDGER_COL_DATE: 'Date',
    AFFILIATE_LEDGER_COL_NOTES: 'Notes',
    AFFILIATE_STATS_TITLE: 'Funnel',
    AFFILIATE_STATS_CLICKS: 'Clics (30 j)',
    AFFILIATE_STATS_SIGNUPS: 'Inscriptions',
    AFFILIATE_STATS_PAYING: 'Filleuls payants',
    AFFILIATE_STATS_COMMISSIONS: 'Commissions',
    AFFILIATE_STATS_TOP_SOURCES: 'Top sources',
    AFFILIATE_STATS_UNAVAILABLE: '—',
    AFFILIATE_MANUAL_ENTRY: 'Saisie manuelle',
    AFFILIATE_MANUAL_ENTRY_TITLE: 'Saisir une ligne de commission',
    AFFILIATE_MANUAL_ENTRY_KIND: 'Type de ligne',
    AFFILIATE_MANUAL_ENTRY_AMOUNT: 'Montant (centimes, négatif pour un ajustement à la baisse)',
    AFFILIATE_MANUAL_ENTRY_PRO: 'Filleul concerné (id pro, optionnel)',
    AFFILIATE_MANUAL_ENTRY_NOTES: 'Notes (obligatoires — trace du passage manuel)',
    AFFILIATE_MANUAL_ENTRY_SUBMIT: 'Enregistrer la ligne',
    AFFILIATE_SETTLE: 'Régler la sélection',
    AFFILIATE_SETTLE_TITLE: 'Règlement de commissions',
    AFFILIATE_SETTLE_SELECTED: '{count, plural, one {# ligne sélectionnée} other {# lignes sélectionnées}}',
    AFFILIATE_SETTLE_TOTAL: 'Total sélectionné',
    AFFILIATE_SETTLE_MODE_BUDGET: 'Convertir en réduction abo (code enveloppe)',
    AFFILIATE_SETTLE_MODE_BUDGET_HINT:
      'Crée un code promo enveloppe sur l’abonnement du pro de l’affilié, consommé facture après facture. Plafonné au coût annuel restant — le surplus reste à verser.',
    AFFILIATE_SETTLE_MODE_BANK: 'Virement bancaire (pro externe)',
    AFFILIATE_SETTLE_MODE_BANK_HINT:
      'Virement exécuté sur les coordonnées saisies par l’affilié. Nécessite des coordonnées complètes et une référence de virement.',
    AFFILIATE_SETTLE_MODE_GIFT: 'Carte cadeau (particulier)',
    AFFILIATE_SETTLE_MODE_GIFT_HINT:
      'Carte cadeau envoyée à l’adresse indiquée par l’affilié. Nécessite une référence de commande.',
    AFFILIATE_SETTLE_MODE_MARK_PAID: 'Marquer versé (sans canal)',
    AFFILIATE_SETTLE_MODE_MARK_PAID_HINT:
      'Rattrapage ou règlement historique, sans contrôle de régime ni de coordonnées. Notes conseillées.',
    AFFILIATE_SETTLE_REFERENCE: 'Référence du versement',
    AFFILIATE_SETTLE_REFERENCE_HINT:
      'Référence du virement ou numéro de commande de la carte cadeau — tracée au ledger.',
    AFFILIATE_SETTLE_NOTES: 'Notes',
    AFFILIATE_SETTLE_SUBMIT: 'Valider le règlement',
    AFFILIATE_SETTLE_SUCCESS_PROMO: 'Code enveloppe {code} créé.',
    AFFILIATE_SETTLE_SURPLUS: 'Surplus non converti (plafond) : {amount} — resté à verser.',
    AFFILIATE_EDIT: 'Modifier',
    AFFILIATE_EDIT_TITLE: 'Modifier l’affilié',
    // Modération des auto-inscriptions + coordonnées de versement.
    AFFILIATE_APPROVE: 'Valider le compte',
    // Validation des gains retenus : l'attribution du filleul, elle, est déjà faite.
    AFFILIATE_DETAIL_REVIEW: 'Gains à valider',
    AFFILIATE_REVIEW: '{count, plural, one {Valider # gain} other {Valider # gains}}',
    AFFILIATE_REVIEW_TITLE: 'Validation des gains',
    AFFILIATE_REVIEW_HINT:
      'Ces gains sont enregistrés mais retenus : ils n’entrent ni dans le solde à verser, ni dans le seuil de retrait, tant qu’ils ne sont pas validés. Refuser une ligne l’annule définitivement.',
    AFFILIATE_REVIEW_SCOPE_SELECTION:
      '{count, plural, one {# ligne sélectionnée} other {# lignes sélectionnées}} dans le ledger.',
    AFFILIATE_REVIEW_SCOPE_ALL:
      'Aucune sélection : l’action porte sur {count, plural, one {le # gain retenu} other {les # gains retenus}}, soit {amount}.',
    AFFILIATE_REVIEW_REASON: 'Motif',
    AFFILIATE_REVIEW_REASON_PLACEHOLDER: 'Filleul vérifié, parrainage légitime…',
    AFFILIATE_REVIEW_REASON_REQUIRED: 'Un motif est obligatoire pour refuser un gain.',
    AFFILIATE_REVIEW_APPROVE: 'Valider les gains',
    // Validation FILLEUL PAR FILLEUL : l'unité de modération, plus fine que le compte.
    AFFILIATE_REFERRAL_COL_REVIEW: 'Parrainage',
    AFFILIATE_REFERRAL_REVIEW_ACTION: 'Vérifier',
    AFFILIATE_REFERRAL_REVIEW_TITLE: 'Validation du parrainage',
    AFFILIATE_REFERRAL_REVIEW_HELD: 'Gains actuellement retenus pour ce filleul : {amount}',
    AFFILIATE_REFERRAL_REVIEW_HINT:
      'Votre décision vaut aussi pour les commissions que ce filleul générera ensuite. Valider libère les gains retenus ; refuser les annule et stoppe toute commission future pour ce filleul.',
    AFFILIATE_REFERRAL_REVIEW_APPROVE: 'Valider le parrainage',
    AFFILIATE_REFERRAL_REVIEW_REJECT: 'Refuser le parrainage',
    AFFILIATE_REVIEW_REJECT: 'Refuser',
    // Rapatriement FirstPromoter (cohabitation v1/v2) : le cron nocturne fait le
    // même travail, ce déclencheur sert au premier run et aux rattrapages.
    AFFILIATE_FP_SYNC: 'Synchroniser FirstPromoter',
    AFFILIATE_FP_SYNC_TITLE: 'Rapatriement FirstPromoter',
    AFFILIATE_FP_SYNC_HINT:
      'Importe les commissions acquises sur l’ancien programme (v1) dans ce ledger. Lecture seule chez FirstPromoter, et rejouable sans risque de doublon. Les gains d’un filleul déjà migré ne sont pas repris : ils sont produits par notre propre moteur.',
    AFFILIATE_FP_SYNC_SIMULATE: 'Simuler',
    AFFILIATE_FP_SYNC_APPLY: 'Lancer l’import',
    AFFILIATE_FP_SYNC_NOT_CONFIGURED:
      'FirstPromoter n’est pas configuré sur cet environnement : aucune synchronisation n’est possible.',
    AFFILIATE_FP_SYNC_RESULT_SIMULATED: 'Simulation (rien n’a été écrit)',
    AFFILIATE_FP_SYNC_RESULT_APPLIED: 'Import terminé',
    AFFILIATE_FP_SYNC_REFERRALS_SEEN: 'Filleuls lus',
    AFFILIATE_FP_SYNC_REFERRALS_ATTACHED: 'Parrainages rattachés',
    AFFILIATE_FP_SYNC_REFERRALS_CONFLICT: 'Désaccords d’attribution (à arbitrer)',
    AFFILIATE_FP_SYNC_REFERRED_AT: 'Dates d’ancienneté corrigées',
    AFFILIATE_FP_SYNC_REFERRALS_CONFLICT_WARN:
      'FirstPromoter et notre base ne désignent pas le même parrain pour ces filleuls. Rien n’a été modifié : tranchez depuis la réconciliation.',
    AFFILIATE_FP_SYNC_SEEN: 'Commissions lues',
    AFFILIATE_FP_SYNC_CREATED: 'Lignes créées',
    AFFILIATE_FP_SYNC_UPDATED: 'Statuts mis à jour',
    AFFILIATE_FP_SYNC_AFFILIATES: 'Affiliés repris',
    AFFILIATE_FP_SYNC_BOUNTY_CODES: 'Codes promo créés',
    AFFILIATE_FP_SYNC_BOUNTY_CODES_FAILED: 'Codes promo en échec',
    AFFILIATE_FP_SYNC_REGIMES_RECLASSIFIED: 'Régimes reclassés client pro',
    AFFILIATE_FP_SYNC_SKIPPED_MIGRATION: 'Ignorées (filleul déjà migré)',
    AFFILIATE_FP_SYNC_HELD_GAP: 'Retenues (filleul migré, parrainage non rattaché)',
    AFFILIATE_FP_SYNC_HELD_GAP_WARN:
      'Ces filleuls sont migrés mais leur parrainage n’est rattaché à personne en v2 : notre moteur ne produira aucune commission pour eux. Rattachez-les depuis la réconciliation, sinon leurs gains futurs tomberont dans le vide.',
    AFFILIATE_FP_SYNC_SKIPPED_UNKNOWN: 'Ignorées (promoteur inconnu)',
    AFFILIATE_FP_SYNC_SKIPPED_NON_CASH: 'Ignorées (récompense non monétaire)',
    AFFILIATE_FP_SYNC_UNRESOLVED: 'Sans filleul identifié',
    AFFILIATE_FP_SYNC_RELINKED: 'Filleuls rattachés a posteriori',
    AFFILIATE_FP_SYNC_FLAGGED: 'Retenues à valider',
    AFFILIATE_FP_SYNC_ERROR: 'La synchronisation a échoué. Réessayez dans un instant.',
    AFFILIATE_DETAIL_TERMS_ACCEPTED: 'Conditions acceptées le',
    AFFILIATE_DETAIL_PAYOUT_DETAILS: 'Coordonnées de versement',
    AFFILIATE_PAYOUT_COMPANY: 'Raison sociale',
    AFFILIATE_PAYOUT_SIRET: 'SIRET',
    AFFILIATE_PAYOUT_HOLDER: 'Titulaire du compte',
    AFFILIATE_PAYOUT_IBAN: 'IBAN',
    AFFILIATE_PAYOUT_BIC: 'BIC',
    AFFILIATE_PAYOUT_GIFT_EMAIL: 'Email carte cadeau',
    AFFILIATE_PAYOUT_DETAILS_UPDATED_AT: 'Mises à jour le',
    AFFILIATE_FORM_EMAIL: 'Email',
    AFFILIATE_FORM_FIRST_NAME: 'Prénom',
    AFFILIATE_FORM_LAST_NAME: 'Nom',
    AFFILIATE_FORM_PHONE: 'Téléphone',
    AFFILIATE_FORM_REGIME: 'Régime de versement',
    AFFILIATE_FORM_STATUS: 'Statut',
    AFFILIATE_FORM_PRO: 'Compte pro rattaché (si affilié client)',
    AFFILIATE_FORM_REGIME_LOCKED:
      'Régime imposé par le compte pro rattaché — détacher le pro pour choisir un autre canal de versement.',
    // --- Rattachement manuel d'un FILLEUL (≠ compte pro DE l'affilié ci-dessous) ---
    AFFILIATE_ATTACH_REFERRAL_ACTION: 'Rattacher un filleul…',
    AFFILIATE_ATTACH_REFERRAL_TITLE: 'Rattacher un filleul',
    AFFILIATE_ATTACH_REFERRAL_INTRO:
      'Le pro choisi sera attribué à cet ambassadeur comme filleul (parrainage validé d’office). Ses prochaines échéances d’abonnement produiront une commission.',
    AFFILIATE_ATTACH_REFERRAL_PRO_LABEL: 'Filleul',
    AFFILIATE_ATTACH_REFERRAL_AFFILIATE_LABEL: 'Parrain',
    AFFILIATE_ATTACH_REFERRAL_CHANGE_PRO: 'Changer de pro',
    AFFILIATE_ATTACH_REFERRAL_PREVIEW_LOADING: 'Vérification…',
    AFFILIATE_ATTACH_REFERRAL_CONFLICT: 'Déjà parrainé par {email} : rattachement impossible.',
    AFFILIATE_ATTACH_REFERRAL_SELF:
      'Auto-parrainage : ce pro est l’établissement de l’ambassadeur ou partage un email avec lui.',
    AFFILIATE_ATTACH_REFERRAL_BACKFILL_LABEL: 'Créditer les échéances déjà payées',
    AFFILIATE_ATTACH_REFERRAL_BACKFILL_HINT:
      '{count} facture(s) payée(s) → {total} de commissions, horloge des 36 mois démarrée le {date}.',
    AFFILIATE_ATTACH_REFERRAL_BACKFILL_NONE:
      'Aucune facture payée à rejouer : les commissions démarreront au prochain encaissement.',
    AFFILIATE_ATTACH_REFERRAL_BACKFILL_SKIPPED:
      '{count} facture(s) sans segment résoluble, à saisir à la main si besoin.',
    AFFILIATE_ATTACH_REFERRAL_NO_BACKFILL_HINT:
      'Sans cette option, l’horloge des 36 mois démarre au prochain encaissement du filleul.',
    AFFILIATE_ATTACH_REFERRAL_NOTIFY_LABEL: 'Prévenir l’ambassadeur par email (« nouveau filleul »)',
    AFFILIATE_ATTACH_REFERRAL_NOTE_LABEL: 'Note (source de la demande, contexte)',
    AFFILIATE_ATTACH_REFERRAL_NOTE_PLACEHOLDER:
      'Ex. : demande du pro par email du 12/09, parrain cité lors de l’onboarding…',
    AFFILIATE_ATTACH_REFERRAL_SUBMIT: 'Rattacher',
    AFFILIATE_ATTACH_REFERRAL_ERROR_SUSPENDED:
      'Cet ambassadeur est suspendu : aucun filleul ne peut lui être rattaché.',
    AFFILIATE_ATTACH_REFERRAL_ERROR_SELF: 'Auto-parrainage refusé.',
    AFFILIATE_ATTACH_REFERRAL_ERROR_TAKEN: 'Ce pro est déjà rattaché à un ambassadeur.',
    AFFILIATE_PICKER_PLACEHOLDER: 'Rechercher un ambassadeur (nom, email, code)…',
    AFFILIATE_PICKER_NO_RESULT: 'Aucun ambassadeur trouvé.',
    AFFILIATE_PICKER_SELECT: 'Choisir',
    AFFILIATE_PRO_LINK_TITLE: 'Compte pro rattaché',
    AFFILIATE_PRO_LINK_NONE: 'Aucun compte pro rattaché.',
    AFFILIATE_PRO_LINK_ACTION: 'Rattacher un compte pro…',
    AFFILIATE_PRO_LINK_CHANGE: 'Changer',
    AFFILIATE_PRO_LINK_UNLINK: 'Détacher',
    AFFILIATE_PRO_LINK_SELECT: 'Rattacher',
    AFFILIATE_PRO_LINK_SEARCH_PLACEHOLDER: 'Rechercher un pro (nom, email, id)…',
    AFFILIATE_PRO_LINK_SEARCH_HINT: 'Saisir au moins 2 caractères pour rechercher.',
    AFFILIATE_PRO_LINK_NO_RESULT: 'Aucun pro trouvé.',
    AFFILIATE_PRO_LINK_TAKEN: 'Déjà rattaché à {email}',
    AFFILIATE_PRO_LINK_ERROR_TAKEN: 'Ce compte pro est déjà rattaché à un autre ambassadeur.',
    AFFILIATE_PRO_LINK_ERROR_NOT_FOUND: 'Ce compte pro est introuvable.',
    AFFILIATE_PRO_LINK_ERROR_REGIME_REQUIRED:
      'Choisir le régime de versement à appliquer après le détachement du compte pro.',
    AFFILIATE_PRO_LINK_ERROR_REGIME_MISMATCH:
      'Un ambassadeur rattaché à un compte pro doit être en régime « Client (réduction abo) ».',
    AFFILIATE_PRO_LINK_REGIME_NOTICE:
      'Le rattachement bascule ce compte en régime « {regime} » : sa cagnotte sera convertie en réduction sur l’abonnement du pro rattaché.',
    AFFILIATE_PRO_LINK_UNLINK_HINT:
      'Sans compte pro rattaché, la conversion de la cagnotte en réduction d’abonnement n’est plus possible : choisir le canal de versement qui prend le relais.',
    AFFILIATE_PRO_LINK_UNLINK_REGIME_LABEL: 'Régime de versement après détachement',
    AFFILIATE_PRO_LINK_UNLINK_CONFIRM: 'Détacher et appliquer ce régime',
    AFFILIATE_FORM_REF_TOKEN: 'Code affilié (optionnel, auto-généré sinon)',
    AFFILIATE_FORM_NOTES: 'Notes internes',
    AFFILIATE_FORM_SUBMIT: 'Enregistrer',
    AFFILIATE_RECONCILIATION_TITLE: 'Réconciliation import FirstPromoter',
    AFFILIATE_RECONCILIATION_SUBTITLE:
      'Référés FP non rapprochés d’un pro v2 — rattacher à la main ou ignorer. Ne jamais inventer une attribution.',
    AFFILIATE_RECONCILIATION_EMPTY: 'Rien à rapprocher.',
    AFFILIATE_RECONCILIATION_COL_EMAIL: 'Email FP',
    AFFILIATE_RECONCILIATION_COL_AFFILIATE: 'Parrain',
    AFFILIATE_RECONCILIATION_COL_FIRST_PAYMENT: '1er paiement v1',
    AFFILIATE_RECONCILIATION_COL_STATE: 'État',
    AFFILIATE_RECONCILIATION_ATTACH: 'Rattacher au pro…',
    AFFILIATE_RECONCILIATION_ATTACH_PRO_ID: 'Id du professionnel v2',
    AFFILIATE_RECONCILIATION_CONFIRM: 'Valider',
    AFFILIATE_RECONCILIATION_IGNORE: 'Ignorer',
    // ── Réserver avec Google (/google-reserve) ─────────────────────────────
    GOOGLE_RESERVE_TITLE: 'Réserver avec Google',
    GOOGLE_RESERVE_SUBTITLE: 'Demandes d’activation et derniers runs du feed.',
    GOOGLE_RESERVE_FILTER_ALL: 'Tous les statuts',
    GOOGLE_RESERVE_COL_PRO: 'Professionnel',
    GOOGLE_RESERVE_COL_STATUS: 'Statut',
    GOOGLE_RESERVE_COL_REQUESTED_AT: 'Demandé le',
    GOOGLE_RESERVE_COL_ELIGIBLE_PRESTATIONS: 'Prestas éligibles',
    GOOGLE_RESERVE_COL_CHECKLIST: 'Pré-requis',
    GOOGLE_RESERVE_CHECKLIST_OK: 'Complets',
    GOOGLE_RESERVE_CHECKLIST_KO: 'Incomplets',
    GOOGLE_RESERVE_VIEW: 'Voir',
    GOOGLE_RESERVE_EMPTY: 'Aucune demande pour ce filtre.',
    GOOGLE_RESERVE_APPROVE: 'Approuver',
    GOOGLE_RESERVE_REJECT: 'Rejeter',
    GOOGLE_RESERVE_REJECT_REASON_LABEL: 'Raison communiquée au pro',
    GOOGLE_RESERVE_ADMIN_NOTE_LABEL: 'Note interne (facultative)',
    GOOGLE_RESERVE_CONFIRM_APPROVE: 'Approuver ce professionnel pour le feed Google ?',
    GOOGLE_RESERVE_PRESTATIONS_TITLE: 'Prestations (sélection automatique)',
    GOOGLE_RESERVE_PLACES_TITLE: 'Lieux',
    GOOGLE_RESERVE_RUNS_TITLE: 'Runs du feed',
    GOOGLE_RESERVE_RUNS_SUBTITLE: 'Historique des générations quotidiennes du feed Google.',
    GOOGLE_RESERVE_RUN_TRIGGER: 'Déclencher un run',
    GOOGLE_RESERVE_RUN_TRIGGERED: 'Run déclenché.',
    GOOGLE_RESERVE_COL_RUN_STARTED: 'Démarré le',
    GOOGLE_RESERVE_COL_RUN_STATUS: 'Statut',
    GOOGLE_RESERVE_COL_RUN_PROS: 'Pros (v2 / v1 / skippés)',
    GOOGLE_RESERVE_COL_RUN_SERVICES: 'Services',
    GOOGLE_RESERVE_COL_RUN_CHUNKS: 'Chunks',
    GOOGLE_RESERVE_RUN_DETAILS: 'Détails',
    GOOGLE_RESERVE_RUNS_EMPTY: 'Aucun run pour le moment.',
    GOOGLE_RESERVE_EXPORT_TITLE: 'Fichiers du feed (dry-run)',
    GOOGLE_RESERVE_EXPORT_SUBTITLE:
      'Génère les fichiers du feed à la volée (pros v2 + v1 fusionnés), sans rien envoyer à Google : pour vérifier le contenu à tout moment, notamment avant la bascule.',
    GOOGLE_RESERVE_EXPORT_GENERATE: 'Générer les fichiers',
    GOOGLE_RESERVE_EXPORT_DOWNLOAD: 'Télécharger',
    GOOGLE_RESERVE_EXPORT_DOWNLOAD_ALL: 'Tout télécharger',
    GOOGLE_RESERVE_EXPORT_SUMMARY:
      '{merchants} marchands (v2 : {v2}, v1 : {v1}, dédupliqués : {deduped}, skippés : {skipped}). {services} services, {chunks} chunk(s).',
    GOOGLE_RESERVE_EXPORT_SAFETY_WARNING:
      'Moins de {min} marchands : le run nocturne refuserait d’envoyer ce feed (garde-fou).',
    GOOGLE_RESERVE_EXPORT_V1_ERROR: 'Source v1 injoignable : fichiers générés avec les pros v2 uniquement.',
    GOOGLE_RESERVE_EXPORT_SHADOW_BADGE: 'Mode shadow actif',
    GOOGLE_RESERVE_EXPORT_COL_FILE: 'Fichier',
    GOOGLE_RESERVE_EXPORT_COL_CHUNK: 'Chunk',
    GOOGLE_RESERVE_EXPORT_COL_ITEMS: 'Éléments',
    GOOGLE_RESERVE_EXPORT_GZIP_NOTE:
      'Fichiers servis en JSON lisible ; sur le SFTP Google, les fichiers de données partent gzippés (.json.gz).',
    // ── Fiche CRM 360 (onglet « 360 » de /professionals/[id]) ────────────────
    PRO_TAB_360: 'Vue 360',
    PRO_TAB_BILLING: 'Facturation & accès',
    PRO_TAB_TECHNICAL: 'Technique',
    PRO_360_UNAVAILABLE: 'Vue 360 indisponible pour ce pro.',
    // ── Onglet « Pulse » de la fiche pro : un agent interroge Pulse sur ce pro (lecture seule) ──
    PRO_TAB_PULSE: 'Pulse',
    PRO_PULSE_TITLE: 'Interroger Pulse sur ce pro',
    PRO_PULSE_SUBTITLE:
      'Pulse lit la configuration réelle du pro (agenda, catalogue, clients, site, abonnement) et répond avec ce qu’il a consulté. Rien de ce que vous écrivez ici n’apparaît côté pro.',
    PRO_PULSE_READ_ONLY_BANNER: 'Lecture seule : Pulse ne peut rien modifier chez ce pro.',
    PRO_PULSE_DISABLED: 'Pulse admin est désactivé sur cet environnement. L’historique reste consultable.',
    PRO_PULSE_THREADS_TITLE: 'Conversations',
    PRO_PULSE_THREADS_EMPTY: 'Aucune conversation sur ce pro pour l’instant.',
    PRO_PULSE_THREAD_UNTITLED: 'Conversation sans titre',
    PRO_PULSE_THREAD_BY: 'par {name}',
    PRO_PULSE_NEW_THREAD: 'Nouvelle conversation',
    PRO_PULSE_DELETE_THREAD: 'Archiver la conversation',
    PRO_PULSE_EMPTY_STATE: 'Posez une question sur ce pro, ou partez d’un cas fréquent :',
    PRO_PULSE_SUGGESTION_NO_SLOTS: 'Pourquoi ses clientes ne voient-elles aucun créneau en ligne ?',
    PRO_PULSE_SUGGESTION_NOT_BOOKABLE: 'Une de ses prestations n’est pas réservable en ligne : laquelle, et pourquoi ?',
    PRO_PULSE_SUGGESTION_WEBSITE: 'Son site est-il publié, et sur quelle adresse ?',
    PRO_PULSE_SUGGESTION_SUBSCRIPTION: 'Où en est son abonnement : plan, prochaine échéance, dernière facture ?',
    PRO_PULSE_INPUT_PLACEHOLDER: 'Votre question sur ce pro…',
    PRO_PULSE_SEND: 'Envoyer',
    PRO_PULSE_THINKING: 'Pulse consulte les données du pro…',
    PRO_PULSE_AUTHOR_AGENT: 'Vous',
    PRO_PULSE_AUTHOR_OTHER_AGENT: 'Agent',
    PRO_PULSE_AUTHOR_PULSE: 'Pulse',
    PRO_PULSE_TOOL_READS: '{count, plural, =1 {Pulse a consulté 1 source} other {Pulse a consulté # sources}}',
    PRO_PULSE_TOOL_ARGS: 'Paramètres',
    PRO_PULSE_TOOL_RESULT: 'Résultat (extrait)',
    PRO_PULSE_TOOL_FAILED: 'Lecture en échec',
    PRO_PULSE_OTHER_AGENT_THREAD:
      'Cette conversation a été ouverte par {name} : vous pouvez la lire, pas la poursuivre.',
    PRO_PULSE_OPEN_MY_THREAD: 'Ouvrir ma propre conversation',
    PRO_PULSE_ERROR_GENERIC: 'La question n’a pas pu être envoyée. Réessayez dans un instant.',
    PRO_PULSE_ERROR_PROVIDER:
      'Pulse n’a pas répondu (modèle indisponible). Votre question est revenue dans la zone de saisie : renvoyez-la.',
    PRO_PULSE_ERROR_NO_FINAL_ANSWER:
      'Pulse a consulté les données sans parvenir à conclure. Votre question est revenue dans la zone de saisie : reformulez-la en plus ciblé (une prestation, une date, un écran).',
    PRO_PULSE_ERROR_NO_ACCESS:
      'Ce professionnel n’a aucun accès actif : Pulse ne peut pas ouvrir de session pour lire ses données.',
    PRO_PULSE_ERROR_NOT_OWNER: 'Seul l’agent qui a ouvert cette conversation peut la poursuivre.',
    PRO_PULSE_ERROR_THROTTLED: 'Trop de questions en une minute. Patientez un instant.',
    // ── Onglet « Synchro agenda » de la fiche pro ────────────────────────────
    PRO_CALENDAR_SYNC_TITLE: 'Synchronisation calendrier',
    PRO_CALENDAR_SYNC_SUBTITLE:
      'Connexions qui importent des événements vers l’agenda Propelsia. La réconciliation supprime les blocs dont l’événement n’existe plus côté calendrier distant.',
    PRO_CALENDAR_SYNC_EMPTY: 'Aucune connexion calendrier en import pour ce pro.',
    PRO_CALENDAR_SYNC_UNAVAILABLE: 'État de la synchro indisponible pour ce pro.',
    PRO_CALENDAR_SYNC_COL_MEMBER: 'Membre',
    PRO_CALENDAR_SYNC_COL_PROVIDER: 'Fournisseur',
    PRO_CALENDAR_SYNC_COL_CALENDAR: 'Calendrier',
    PRO_CALENDAR_SYNC_COL_LAST_SYNC: 'Dernière synchro',
    PRO_CALENDAR_SYNC_COL_BLOCKS: 'Blocs externes',
    PRO_CALENDAR_SYNC_COL_LAST_RECONCILE: 'Dernière réconciliation',
    PRO_CALENDAR_SYNC_RECONCILE: 'Réconcilier',
    PRO_CALENDAR_SYNC_RECONCILE_ALL: 'Tout réconcilier',
    PRO_CALENDAR_SYNC_RECONCILE_DONE:
      'Réconciliation lancée sur {count} connexion(s). Le nettoyage se fait en tâche de fond, comptez une minute.',
    PRO_CALENDAR_SYNC_RECONCILE_ERROR: 'La réconciliation n’a pas pu être lancée. Réessayez dans un instant.',
    PRO_CALENDAR_SYNC_RECONCILE_NEVER: 'Jamais',
    PRO_CALENDAR_SYNC_RECONCILE_LAST: '{date} : {count} bloc(s) supprimé(s)',
    PRO_CALENDAR_SYNC_RECONCILE_BLOCKED: 'Bloquée : {count} suppressions au-dessus du plafond de sécurité',
    // ── Onglet « Site » de la fiche pro ──────────────────────────────────────
    PRO_WEBSITE_TITLE: 'Site vitrine',
    PRO_WEBSITE_UNAVAILABLE: 'État du site indisponible pour ce pro.',
    PRO_WEBSITE_OPEN: 'Ouvrir le site',
    PRO_WEBSITE_NONE: 'Aucun contenu : le site n’a jamais été construit.',
    PRO_WEBSITE_PUBLISHED: 'Publié',
    PRO_WEBSITE_NOT_PUBLISHED: 'Non publié',
    PRO_WEBSITE_UNPUBLISHED_CHANGES: '{count} modification(s) non publiée(s)',
    PRO_WEBSITE_LAST_PUBLISHED: 'Dernière publication',
    PRO_WEBSITE_DEFAULT_SUBDOMAIN: 'Sous-domaine par défaut',
    PRO_WEBSITE_DOMAINS: 'Domaines',
    PRO_CAMPAIGN_SENDER_TITLE: 'Expéditeur campagnes',
    PRO_CAMPAIGN_SENDER_DESC: 'Domaine du pro déclaré comme expéditeur Mailjet de ses campagnes e-mail.',
    PRO_CAMPAIGN_SENDER_NONE: `Aucun domaine expéditeur configuré (adresse ${PROJECT_CONFIG.brand_string}).`,
    PRO_CAMPAIGN_SENDER_EMAIL: 'Adresse choisie',
    PRO_CAMPAIGN_SENDER_EMAIL_NONE: `aucune (adresse ${PROJECT_CONFIG.brand_string})`,
    PRO_CAMPAIGN_SENDER_DKIM: 'DKIM',
    PRO_CAMPAIGN_SENDER_SPF: 'SPF',
    PRO_CAMPAIGN_SENDER_LAST_CHECK: 'Dernière vérification',
    PRO_CAMPAIGN_SENDER_VERIFIED_AT: 'Validé le',
    PRO_CAMPAIGN_SENDER_LAST_ERROR: 'Dernière erreur',
    PRO_CAMPAIGN_SENDER_RECHECK: 'Re-vérifier',
    PRO_CAMPAIGN_SENDER_RECHECK_DONE: 'Vérification relancée.',
    PRO_CAMPAIGN_SENDER_REMOVE: 'Retirer',
    PRO_CAMPAIGN_SENDER_REMOVE_CONFIRM: `Retirer le domaine expéditeur {domain} ? Le pro repasse sur son adresse ${PROJECT_CONFIG.brand_string}.`,
    PRO_CAMPAIGN_SENDER_REMOVE_DONE: 'Domaine expéditeur retiré.',
    PRO_CAMPAIGN_SENDER_ERROR: 'Action impossible : réessayez ou vérifiez les droits.',
    PRO_CAMPAIGN_SENDER_UNAVAILABLE: 'Expéditeur campagnes indisponible.',
    PRO_WEBSITE_DOMAINS_SUBTITLE: 'État DNS et activation de chaque domaine rattaché au site.',
    PRO_WEBSITE_DOMAINS_EMPTY: 'Aucun domaine personnalisé : le site est servi sur le sous-domaine par défaut.',
    PRO_WEBSITE_PRIMARY: '(primaire)',
    PRO_WEBSITE_COL_DOMAIN: 'Domaine',
    PRO_WEBSITE_COL_DNS: 'DNS',
    PRO_WEBSITE_COL_ACTIVATION: 'Activation',
    PRO_WEBSITE_COL_MAIL: 'Email',
    PRO_WEBSITE_COL_SEARCH_ENGINES: 'Moteurs',
    PRO_WEBSITE_SEARCH_ENGINE_GSC: 'GSC',
    PRO_WEBSITE_SEARCH_ENGINE_BING: 'Bing',
    PRO_ACCESS_QUOTA_TITLE: 'Accès & quotas',
    // ── Mini-app Chatwoot (panneau agent) ────────────────────────────────────
    CHATWOOT_APP_NO_PRO: 'Ce contact n’est rattaché à aucun professionnel Propelsia.',
    CHATWOOT_APP_NO_CONTEXT:
      'Contexte Chatwoot non reçu. Recharge le panneau ; si ça persiste, vérifie la configuration de la Dashboard App.',
    CHATWOOT_APP_LOGIN: 'Se connecter',
    CHATWOOT_APP_LOGIN_HINT: 'Connecte-toi avec ton compte admin pour voir la fiche de ce professionnel.',
    CHATWOOT_APP_AGENT_MISMATCH:
      'Tu agis en tant que {admin} alors que la session Chatwoot est celle de {agent}. Vérifie que c’est bien voulu.',
    CHATWOOT_APP_OPEN_ADMIN: 'Ouvrir dans l’admin',
    // ── Handoff de session admin (popup ouverte par la mini-app) ─────────────
    HANDOFF_PENDING: 'Connexion en cours…',
    HANDOFF_NEEDS_LOGIN: 'Ta session admin a expiré. Reconnecte-toi pour continuer.',
    HANDOFF_LOGIN_CTA: 'Se connecter à l’admin',
    HANDOFF_NO_OPENER: 'Cette page s’ouvre automatiquement depuis l’application Chatwoot.',
    CRM_360_TITLE: 'Fiche CRM 360',
    CRM_360_SUBTITLE: 'Vue unifiée lead + client : identité, abonnement, santé et timeline.',
    CRM_360_IDENTITY: 'Identité',
    CRM_360_EMAIL: 'Email',
    CRM_360_PHONE: 'Téléphone',
    CRM_360_ACQUIRED_AT: 'Client depuis',
    CRM_360_MIGRATED: 'Migré v1',
    CRM_360_LEAD: 'Lead',
    CRM_360_LEAD_SOURCE: 'Source',
    CRM_360_NO_LEAD: 'Aucun lead lié.',
    CRM_360_SUBSCRIPTION: 'Abonnement',
    CRM_360_AT_RISK: 'À risque',
    CRM_360_PLATFORM: 'Clients finaux',
    CRM_360_CUSTOMERS: 'Clients gérés',
    CRM_360_INVOICES: 'Factures',
    CRM_360_TIMELINE: 'Timeline',
    CRM_360_TIMELINE_SUBTITLE: 'Événements de cycle de vie + facturation (récents).',
    CRM_360_TIMELINE_EMPTY: 'Aucun événement.',
    CRM_360_TRIAL: "Relance d'essai",
    CRM_360_TRIAL_DAY: 'Jour {day} · {days_left} j restants',
    CRM_360_TRIAL_PRE_WIZARD: 'Mode reprise (wizard non terminé)',
    CRM_360_TRIAL_STAGE: 'Étage {stage} franchi · prochain : {next}',
    CRM_360_TRIAL_NEXT_ACTION: 'Prochaine sous-action',
    CRM_360_TRIAL_LAST: 'Dernière relance',
    CRM_360_TRIAL_NEXT: 'Prochain moment',
    CRM_360_TRIAL_PAUSED: 'Séquence en pause (un humain a la main)',
    CRM_360_TRIAL_ABANDONED: 'Séquence stoppée',
    CRM_360_TRIAL_OPTED_OUT: 'Désabonné des emails de cycle de vie',
    CRM_360_TRIAL_IN_CALL_QUEUE: 'Relances suspendues : dans la file d’appels',
    CRM_360_TRIAL_ENGAGEMENT: '{sessions} sessions · {minutes} min',
    TRIAL_RELANCE_SUBTITLE:
      'Pros en essai (score, segment, étage, voie) et relances envoyées J0 → J7. Le contenu de chaque envoi est archivé.',
    TRIAL_RELANCE_TAB_UPCOMING: 'À venir',
    TRIAL_RELANCE_UPCOMING_SUBTITLE:
      'Prévisionnel : ce que le cron enverra si l’état des pros ne change pas d’ici là. Recalculé à chaque affichage. Sur un même étage, l’angle du message tourne à chaque relance (action → détail → démo) : deux lignes qui portent la même sous-action n’envoient pas le même texte.',
    TRIAL_RELANCE_UPCOMING_EMPTY: 'Aucune relance prévue sur cette période.',
    TRIAL_RELANCE_COL_PLANNED_AT: 'Prévue le',
    TRIAL_RELANCE_HORIZON_1: '24 h',
    TRIAL_RELANCE_HORIZON_2: '48 h',
    TRIAL_RELANCE_HORIZON_7: '7 jours',
    TRIAL_RELANCE_BLOCKED: 'Ne partira pas',
    TRIAL_RELANCE_FILTER_ALL_SEGMENTS: 'Tous les segments',
    TRIAL_RELANCE_FILTER_ALL_MOMENTS: 'Tous les moments',
    TRIAL_RELANCE_SEARCH_PLACEHOLDER: 'Rechercher un pro (nom, email)…',
    TRIAL_RELANCE_EMPTY: 'Aucun pro en essai.',
    TRIAL_RELANCE_NOTIF_EMPTY: 'Aucune relance envoyée.',
    TRIAL_RELANCE_COL_PRO: 'Pro',
    TRIAL_RELANCE_COL_DAY: 'Jour',
    TRIAL_RELANCE_COL_VOIE: 'Voie',
    TRIAL_RELANCE_COL_SCORE: 'Score',
    TRIAL_RELANCE_COL_STAGE: 'Étage',
    TRIAL_RELANCE_COL_SEGMENT: 'Segment',
    TRIAL_RELANCE_COL_NEXT_ACTION: 'Prochaine sous-action',
    // Onglet « À venir » : ce que le message dira, et pas l'état du pro — un J7 ne redemande
    // jamais la sous-action, il ne parle que de la fin d'essai.
    TRIAL_RELANCE_COL_MESSAGE_FOCUS: 'Contenu du message',
    TRIAL_RELANCE_FOCUS_CLOSING: 'Fin d’essai · choisir une formule',
    TRIAL_RELANCE_FOCUS_CLOSING_SHORT: 'fin d’essai',
    TRIAL_RELANCE_FOCUS_RESUME: 'Reprise de la configuration',
    TRIAL_RELANCE_COL_LAST: 'Dernière relance',
    TRIAL_RELANCE_COL_NEXT: 'Prochain moment',
    TRIAL_RELANCE_COL_ENGAGEMENT: 'Activité',
    TRIAL_RELANCE_COL_ACTIONS: 'Actions',
    TRIAL_RELANCE_COL_MOMENT: 'Moment',
    TRIAL_RELANCE_COL_CHANNELS: 'Canaux',
    TRIAL_RELANCE_COL_SUBJECT: 'Sujet',
    TRIAL_RELANCE_COL_SENT_AT: 'Envoyée le',
    TRIAL_RELANCE_PRE_WIZARD: 'Reprise',
    TRIAL_RELANCE_DAY_LABEL: 'J{day} · {days_left} j restants',
    TRIAL_RELANCE_STAGE_LABEL: '{reached} / 4',
    TRIAL_RELANCE_ALL_DONE: 'Tout est fait',
    TRIAL_RELANCE_SEQUENCE_DONE: 'Séquence terminée',
    TRIAL_RELANCE_PAUSED: 'En pause',
    TRIAL_RELANCE_ABANDONED: 'Stoppée',
    TRIAL_RELANCE_OPTED_OUT: 'Désabonné',
    TRIAL_RELANCE_IN_CALL_QUEUE: 'File d’appels',
    TRIAL_RELANCE_SKIPPED: 'Consommé sans envoi',
    TRIAL_RELANCE_ACTION_PAUSE: 'Prendre la main',
    TRIAL_RELANCE_ACTION_RESUME: 'Rendre la main',
    TRIAL_RELANCE_ACTION_ABANDON: 'Stopper',
    TRIAL_RELANCE_ACTION_RESEND: 'Renvoyer',
    TRIAL_RELANCE_ACTION_VIEW: 'Voir',
    TRIAL_RELANCE_ACTION_PREVIEW: 'Aperçu du message',
    TRIAL_RELANCE_PREVIEW_TITLE: 'Aperçu · {moment}',
    TRIAL_RELANCE_PREVIEW_SUBTITLE:
      'Message rendu exactement comme il partira (template compris), sur les données du jour de ce pro. Rien n’est envoyé ni consommé.',
    TRIAL_RELANCE_PREVIEW_WOULD_SEND: 'Partirait',
    TRIAL_RELANCE_PREVIEW_BLOCK_NOT_ELIGIBLE:
      'Ne partira pas : pro interne ou migré, séquence en pause ou stoppée, ou pro désabonné',
    TRIAL_RELANCE_PREVIEW_BLOCK_NO_CONTENT: 'Rien à dire à ce pro pour ce moment',
    TRIAL_RELANCE_PREVIEW_BLOCK_NO_CHANNEL: 'Aucun canal ouvert (pas de téléphone, ou email en rebond dur)',
    TRIAL_RELANCE_PREVIEW_EMAIL: 'Email',
    TRIAL_RELANCE_PREVIEW_EMAIL_FRAME: 'Rendu de l’email',
    TRIAL_RELANCE_PREVIEW_SMS: 'SMS',
    TRIAL_RELANCE_PREVIEW_PUSH: 'Notification push',
    TRIAL_RELANCE_PREVIEW_IN_APP: 'Cloche (in-app)',
    TRIAL_RELANCE_PREVIEW_FROM: 'De',
    TRIAL_RELANCE_PREVIEW_TO: 'À',
    TRIAL_RELANCE_PREVIEW_REPLY_TO: 'Répondre à',
    TRIAL_RELANCE_PREVIEW_SENDER: 'Expéditeur',
    TRIAL_RELANCE_PREVIEW_SMS_COUNT: '{characters} caractères · {segments} SMS · {encoding}',
    TRIAL_RELANCE_PREVIEW_SMS_NOTE:
      'Le lien est affiché en entier, mais compté à sa longueur raccourcie (22 caractères) : le nombre de segments est celui du SMS qui partira.',
    TRIAL_RELANCE_RESENT: 'Relance renvoyée ({moment}).',
    TRIAL_RELANCE_RESEND_NOTHING: 'Rien à renvoyer pour ce pro aujourd’hui.',
    TRIAL_RELANCE_DETAIL_TITLE: 'Relance {moment}',
    TRIAL_RELANCE_DETAIL_CONTEXT: '{voie} · étage {stage} · angle {angle} · {segment}',
    TRIAL_RELANCE_DETAIL_CTA: 'Lien du bouton',
    TRIAL_RELANCE_DETAIL_DELIVERY: 'Livraison',
    TRIAL_RELANCE_DETAIL_DELIVERY_EMPTY: 'Aucun statut de livraison encore remonté.',
    TRIAL_RELANCE_ERROR: 'L’action a échoué.',

    // ── Navigation : nouvelles entrées CRM ──────────────────────────────────
    SIDEBAR_RELANCES: 'Relances',
    SIDEBAR_ESCALATIONS: 'Escalades',

    // ── Tableau de bord : récap « coup d'œil » ──────────────────────────────
    DASHBOARD_WINDOW_LABEL: 'Fenêtre',
    DASHBOARD_WINDOW_7: '7 jours',
    DASHBOARD_WINDOW_30: '30 jours',
    DASHBOARD_WINDOW_90: '90 jours',
    DASHBOARD_WINDOW_365: '12 mois',
    DASHBOARD_ANALYTICS_HINT:
      'Funnel, cohortes et séries sont sur Metabase — ici, uniquement ce qui demande une action.',

    DASHBOARD_KPI_ACTIVE: 'Clients actifs',
    DASHBOARD_KPI_ACTIVE_META: 'Abonnements en cours',
    DASHBOARD_KPI_TRIALS: 'En essai',
    DASHBOARD_KPI_TRIALS_META: 'Essai en cours, sans abonnement',
    DASHBOARD_KPI_AT_RISK: 'À risque',
    DASHBOARD_KPI_AT_RISK_META: 'Paiement en défaut',
    DASHBOARD_KPI_NEW: 'Nouveaux',
    DASHBOARD_KPI_NEW_META: '{converted} devenus payants',

    DASHBOARD_CLIENTS_TITLE: 'Clients',
    DASHBOARD_CLIENTS_SUBTITLE: 'Parc et mouvements sur la fenêtre.',
    DASHBOARD_CLIENTS_NEW: 'Inscriptions',
    DASHBOARD_CLIENTS_CONVERTED: 'Devenus payants',
    DASHBOARD_CLIENTS_CHURNED: 'Résiliations',
    DASHBOARD_CLIENTS_AT_RISK: 'Paiement en défaut',
    DASHBOARD_CLIENTS_LINK: 'Voir les clients',

    DASHBOARD_LEADS_TITLE: 'Leads',
    DASHBOARD_LEADS_SUBTITLE: '{total} au total, par état.',
    DASHBOARD_LEADS_EMPTY: 'Aucun lead.',
    DASHBOARD_LEADS_LINK: 'Voir les leads',

    DASHBOARD_RELANCES_TITLE: 'Relances & escalades',
    DASHBOARD_RELANCES_SUBTITLE: 'Ce qui attend une action de l’équipe.',
    DASHBOARD_RELANCES_PENDING: 'Programmées',
    DASHBOARD_RELANCES_LATE: 'En retard',
    DASHBOARD_RELANCES_FAILED: 'En échec',
    DASHBOARD_RELANCES_SENT_24H: 'Envoyées (24 h)',
    DASHBOARD_RELANCES_ESCALATIONS: 'Escalades ouvertes',
    DASHBOARD_RELANCES_LINK: 'Ouvrir la file',
    DASHBOARD_ESCALATIONS_LINK: 'Ouvrir les escalades',

    DASHBOARD_MONITORING_TITLE: 'Santé technique',
    DASHBOARD_MONITORING_SUBTITLE: 'Le détail est sur la page Monitoring.',
    DASHBOARD_MONITORING_QUEUE_FAILED: 'Jobs en échec',
    DASHBOARD_MONITORING_PROVIDERS: 'Providers dégradés',
    DASHBOARD_MONITORING_CRONS: 'Crons en échec',
    DASHBOARD_MONITORING_ERRORS: 'Erreurs (24 h)',
    DASHBOARD_MONITORING_DEGRADED:
      'Redis injoignable : les compteurs de queues et de disjoncteurs sont indisponibles, pas à zéro.',
    DASHBOARD_MONITORING_LINK: 'Ouvrir le monitoring',

    DASHBOARD_PULSE_TITLE: 'Runtime Pulse',
    DASHBOARD_PULSE_SUBTITLE: 'Supervision du moteur conversationnel.',
    DASHBOARD_PULSE_CONVERSATIONS: 'Conversations',
    DASHBOARD_PULSE_MESSAGES_24H: 'Messages (24 h)',
    DASHBOARD_PULSE_TOOL_ERRORS: 'Outils en erreur (24 h)',

    DASHBOARD_SEVERITY_OK: 'Rien à signaler',
    DASHBOARD_SEVERITY_WARN: 'À surveiller',
    DASHBOARD_SEVERITY_ALERT: 'À traiter',

    // ── CRM : registre de contact et tâches (suivi humain après essai) ──────
    SIDEBAR_CRM_TASKS: 'Tâches',
    CRM_CANCEL: 'Annuler',
    CRM_CONTACT_BANNER_CUT: 'Coupé :',
    CRM_CONTACT_BANNER_CUT_ALL:
      'Tout est coupé : relances Pulse, relances d’essai, appels, SMS, liste de diffusion et newsletter.',
    CRM_CONTACT_BANNER_PULSE_STILL_ANSWERS:
      'Pulse répond encore si la personne écrit. Les messages liés au compte (réservations, factures) continuent.',
    CRM_CONTACT_BANNER_IN_QUEUE: 'Dans la file d’appels : les relances automatiques sont suspendues.',
    CRM_CONSENT_TITLE: 'Consentement et contact',
    CRM_CONSENT_DESC:
      'Ce que la personne a refusé, quand, et comment on l’a su. Un refus coupe ce qui part de nous sans sollicitation.',
    CRM_CONSENT_EMPTY: 'Aucun refus enregistré : contact autorisé.',
    CRM_CONSENT_LINE_REFUSED: 'Refus',
    CRM_CONSENT_LINE_ALLOWED: 'Ajout manuel',
    CRM_CONSENT_LINE_REVOKED: 'Levé',
    CRM_CONSENT_REVOKE: 'Lever',
    CRM_CONSENT_REMOVE: 'Retirer',
    CRM_CONSENT_REVOKED_LINE: 'Levé le {date} par {name}',
    CRM_CONSENT_PERSON_REQUESTED_SHORT: 'à la demande de la personne',
    CRM_CONSENT_LEGACY_TITLE: 'Relance d’essai',
    CRM_CONSENT_LEGACY_EMAIL_OPT_OUT: 'Désabonné des conseils d’essai',
    CRM_CONSENT_LEGACY_EMAIL_BOUNCED: 'Adresse email en échec',
    CRM_CONSENT_LEGACY_SMS_OPT_OUT: 'STOP reçu sur les SMS d’essai',
    CRM_CONSENT_NEW: 'Enregistrer une décision',
    CRM_CONSENT_DECISION_DO_NOT_CONTACT: 'Ne plus contacter (tout est coupé)',
    CRM_CONSENT_DECISION_DO_NOT_CALL: 'Ne pas rappeler (téléphone seulement)',
    CRM_CONSENT_DECISION_STOP_SMS: 'Ne plus envoyer de SMS',
    CRM_CONSENT_DECISION_REMOVE_PROSPECTION: 'Retirer de la liste de diffusion',
    CRM_CONSENT_DECISION_REMOVE_NEWSLETTER: 'Retirer de la newsletter clients',
    CRM_CONSENT_DECISION_ADD_PROSPECTION: 'Ajouter à la liste de diffusion',
    CRM_CONSENT_DECISION_ADD_NEWSLETTER: 'Ajouter à la newsletter clients',
    CRM_CONSENT_VERBATIM: 'Ce que la personne a dit, ou le motif',
    CRM_CONSENT_VERBATIM_PLACEHOLDER: '« Je n’ai plus le temps, ne m’appelez plus »',
    CRM_CONSENT_SAVE: 'Enregistrer',
    CRM_CONSENT_SAVED: 'Décision enregistrée',
    CRM_CONSENT_REVOKED: 'Ligne levée',
    CRM_CONSENT_ERROR: 'L’enregistrement a échoué.',
    CRM_CONSENT_REVOKE_TITLE: 'Lever cette décision',
    CRM_CONSENT_REVOKE_DESC:
      'Les envois concernés pourront reprendre. Le motif est obligatoire et conservé avec votre nom.',
    CRM_CONSENT_REVOKE_DESC_PERSON:
      'La personne s’est désabonnée elle-même. La reprise n’est possible que si elle l’a demandée explicitement : notez sa demande dans le motif et cochez la case.',
    CRM_CONSENT_REVOKE_REASON: 'Motif',
    CRM_CONSENT_PERSON_REQUESTED: 'La personne a demandé elle-même la reprise des envois',
    CRM_CONSENT_REVOKE_CONFIRM: 'Lever',
    CRM_TASK_TITLE_CONSENT_REVIEW: 'Vérifier le refus de contact détecté par Pulse : {name}',
    CRM_TASK_TITLE_ACCOUNT_DELETION: 'Traiter la demande de suppression de compte : {name}',
    CRM_TASK_TITLE_TEAM_MEMBER_REQUEST:
      'Vérifier une demande d’arrêt ou de suppression écrite par un membre de l’équipe (pas le titulaire, aucun refus posé) : {name}',
    CRM_TASKS_TITLE: 'Tâches',
    CRM_TASKS_SUBTITLE:
      'Demandes de suppression de compte, refus détectés par Pulse à vérifier, et tâches saisies par l’équipe.',
    CRM_TASKS_TAB_OPEN: 'À faire',
    CRM_TASKS_TAB_LATE: 'En retard',
    CRM_TASKS_TAB_CLOSED: 'Faites et annulées',
    CRM_TASKS_EMPTY: 'Aucune tâche',
    CRM_TASKS_EMPTY_HINT: 'Rien à traiter dans cette vue.',
    CRM_TASKS_COL_TASK: 'Tâche',
    CRM_TASKS_COL_PERSON: 'Personne',
    CRM_TASKS_COL_DUE: 'Échéance',
    CRM_TASKS_COL_STATUS: 'État',
    CRM_TASKS_DONE: 'Fait',
    CRM_TASKS_REOPEN: 'Rouvrir',
    CRM_TASKS_CLOSED_DONE: 'Tâche faite, retrouvable dans « Faites et annulées ».',
    CRM_TASKS_CLOSED_CANCELLED: 'Tâche annulée, retrouvable dans « Faites et annulées ».',
    CRM_TASKS_UNDO: 'Rétablir',
    CRM_TASKS_NEW: 'Nouvelle tâche',
    CRM_TASKS_NEW_DESC: 'Un titre et une échéance. La tâche est visible de toute l’équipe.',
    CRM_TASKS_FIELD_TITLE: 'Titre',
    CRM_TASKS_FIELD_DUE: 'Échéance',
    CRM_TASKS_CREATE: 'Créer',
    CRM_TASKS_CREATED: 'Tâche créée',
    CRM_TASKS_ERROR: 'L’action a échoué.',
    CRM_TASKS_CREATED_BY: 'Créée par {name}',
    CRM_TASKS_REVIEW_HINT:
      'Refus posé et relances coupées. Si c’est une erreur de lecture, levez le refus depuis la fiche puis clôturez.',
    CRM_TASKS_REVIEW_LIFTED: 'Le refus a été levé depuis la fiche.',

    // ── CRM : file d'appels, fiche d'appel, suivi ──────────────────────────
    SIDEBAR_CRM_WORK_QUEUE: 'Ma journée',
    CRM_WQ_TITLE: 'Ma journée',
    CRM_WQ_SUBTITLE:
      'Les appels à passer aujourd’hui, dans l’ordre : en retard, rappels promis, demandes d’humain, puis la file.',
    CRM_WQ_TAB_TODAY: 'Aujourd’hui',
    CRM_WQ_TAB_JOURNAL: 'Journal des appels',
    CRM_WQ_EMPTY: 'Rien à appeler aujourd’hui',
    CRM_WQ_EMPTY_HINT: 'La file se remplit chaque matin avec les essais terminés et les leads restés sans réponse.',
    CRM_WQ_TRUNCATED:
      'La file compte plus de {max} dossiers ouverts : seuls les {max} plus urgents sont affichés. Les autres apparaîtront à mesure que la file se vide.',
    CRM_WQ_LATE: 'En retard',
    CRM_WQ_LATE_HINT:
      'Rappels dépassés et dossiers en file depuis plus de sept jours sans tentative. À traiter en premier.',
    CRM_WQ_CALLBACKS: 'Rappels du jour',
    CRM_WQ_CALLBACKS_HINT:
      'La personne a demandé à être rappelée à cette heure : c’est le meilleur moment pour la joindre.',
    CRM_WQ_PRIORITY: 'Ont demandé un humain',
    CRM_WQ_PRIORITY_HINT: 'Leads qui ont demandé à parler à quelqu’un pendant une conversation Pulse.',
    CRM_WQ_QUEUE: 'La file',
    CRM_WQ_QUEUE_HINT:
      'Les dossiers frais d’abord, le stock ensuite. Trois tentatives au plus, sur trois jours différents.',
    CRM_WQ_TASKS: 'Tâches ouvertes',
    CRM_WQ_WAITING: 'En attente',
    CRM_WQ_WAITING_HINT:
      'Dossiers ouverts qu’on ne peut pas appeler aujourd’hui (rappel à venir, déjà tentés aujourd’hui).',
    CRM_WQ_SHOW: 'Afficher',
    CRM_WQ_HIDE: 'Masquer',
    CRM_WQ_JOURNAL_HINT: 'Chaque tentative, gardée définitivement : qui a appelé, quand, l’issue.',
    CRM_WQ_JOURNAL_ALL_CALLERS: 'Toute l’équipe',
    CRM_WQ_JOURNAL_ALL_KINDS: 'Toutes natures',
    CRM_WQ_FILTER_SEARCH: 'Nom',
    CRM_WQ_FILTER_SEARCH_PLACEHOLDER: 'Nom ou numéro',
    CRM_WQ_FILTER_KIND: 'Nature',
    CRM_WQ_FILTER_REASON: 'Motif d’entrée',
    CRM_WQ_FILTER_STAGE: 'Étape du cycle de vie',
    CRM_WQ_FILTER_CALLABLE: 'Appelable maintenant',
    CRM_WQ_FILTER_ATTEMPTS: 'Tentatives',
    CRM_WQ_FILTER_ATTEMPTS_NONE: 'Jamais tenté',
    CRM_WQ_FILTER_ATTEMPTS_SOME: 'Déjà tenté',
    CRM_WQ_FILTER_SCORE: 'Score de configuration',
    CRM_WQ_FILTER_SCORE_MIN: 'min',
    CRM_WQ_FILTER_SCORE_MAX: 'max',
    CRM_WQ_FILTER_ANY: 'Tous',
    CRM_WQ_FILTER_RESET: 'Effacer les filtres',
    CRM_WQ_FILTER_NO_MATCH: 'Aucun passage ne correspond aux filtres.',
    CRM_WQ_JOURNAL_EMPTY: 'Aucun appel enregistré',
    CRM_QUEUE_CALL: 'Appeler',
    CRM_QUEUE_CALLABLE: 'Appel possible',
    CRM_QUEUE_NOT_CALLABLE: 'Pas maintenant',
    CRM_QUEUE_NEXT_ALLOWED: 'Possible à partir du {date}',
    CRM_QUEUE_LAST_ATTEMPT: 'Dernière tentative le {date}',
    CRM_QUEUE_CALLBACK_AT: 'Rappel le {date}',
    CRM_QUEUE_REFERENCE_AT: 'Fait générateur le {date}',
    CRM_QUEUE_CONFIG_SCORE: 'Score de configuration : {score}',
    CRM_CALL_LOCAL_TIME: 'Chez la personne : {time}',
    CRM_CALL_ATTEMPTS: '{count, plural, =0 {aucune tentative} one {1 tentative} other {# tentatives}}',
    CRM_CALL_OUTCOME: 'Issue de l’appel',
    CRM_CALL_CONVERTED: 'La personne s’est abonnée pendant l’appel',
    CRM_CALL_REASON: 'Raison de non-conversion',
    CRM_CALL_OPTIONAL: '(si elle l’a donnée)',
    CRM_CALL_BLOCKED_STEP: 'Étape de blocage',
    CRM_CALL_REASON_NOTE: 'Précision',
    CRM_CALL_REASON_NOTE_PLACEHOLDER: 'Obligatoire pour « autre » et pour une fonctionnalité manquante : laquelle ?',
    CRM_CALL_TRAINING: 'Formation',
    CRM_CALL_TRAINING_HINT: `L’inscription se fait dans le compte ${PROJECT_CONFIG.brand_string} des formations ; cochez « inscrit » une fois la réservation faite.`,
    CRM_CALL_TRAINING_REFUSAL_NOTE: 'Pourquoi elle refuse (facultatif)',
    CRM_CALL_CALLBACK_AT: 'Date et heure du rappel',
    CRM_CALL_CALLBACK_HINT:
      'Un jour ouvré, entre 9 h et 19 h chez la personne. Le rappel passe en tête de la journée à cette heure.',
    CRM_CALL_CALLBACK_VERBATIM: 'Ce que la personne a dit, mot pour mot',
    CRM_CALL_CALLBACK_VERBATIM_PLACEHOLDER: '« Je suis en clientèle le matin, rappelez-moi après 17 h. »',
    CRM_CALL_REFUSE_ALL: 'Elle refuse aussi les emails et les SMS (ne plus contacter)',
    CRM_CALL_FOLLOW_UP: 'Prévoir un nouvel appel',
    CRM_CALL_FOLLOW_UP_HINT:
      'Ce passage est traité ; un rappel « à la demande » s’ouvre à la date choisie, sans plafond de reports.',
    CRM_CALL_FOLLOW_UP_AT: 'Date et heure du nouvel appel',
    CRM_CALL_FOLLOW_UP_VERBATIM: 'Pourquoi (facultatif)',
    CRM_CALL_FOLLOW_UP_VERBATIM_PLACEHOLDER: '« Veut voir le replay avant », « rappeler après sa démo du 22 »',
    CRM_CALL_ON_DEMAND_HINT:
      'Rappel à la demande : la raison, l’étape et la formation sont facultatives (celles du cycle précédent sont gardées).',
    CRM_CALL_OPTIONAL_SHORT: '(facultatif)',
    CRM_CALL_NOTE: 'Note d’appel',
    CRM_CALL_NOTE_PLACEHOLDER: 'Où on en était, ce qui a été dit, ce qui reste à traiter.',
    CRM_CALL_SAVE: 'Enregistrer l’appel',
    CRM_CALL_SAVED: 'Appel enregistré',
    CRM_CALL_ERROR: 'L’appel n’a pas pu être enregistré.',
    CRM_CALL_DIAL_RINGING: 'Votre téléphone sonne : décrochez, le numéro est composé ensuite.',
    CRM_CALL_DIAL_ERROR: 'L’appel n’a pas pu être lancé.',
    CRM_DIAL_CONFIRM_TITLE: 'Appeler le {number} ?',
    CRM_DIAL_CONFIRM_HOW: 'Votre softphone sonne d’abord : décrochez, le numéro est composé ensuite.',
    CRM_DIAL_CONFIRM_CHECK: 'Vérifiez que votre softphone est ouvert et connecté.',
    CRM_DIAL_CONFIRM_WHY: 'Sinon la personne est appelée quand même et tombe sur la messagerie de votre ligne.',
    CRM_DIAL_CONFIRM_SUBMIT: 'Lancer l’appel',
    CRM_DIAL_CONFIRM_MANUAL: 'Composer depuis ce poste',
    CRM_CALL_FROM_OVH: 'Appel passé le {date} ({minutes} min)',
    CRM_LIVE_WAITING: 'En attente de l’appel : lancez-le ici ou depuis votre téléphone.',
    CRM_LIVE_RINGING: 'Ça sonne chez la personne…',
    CRM_LIVE_IN_CALL: 'En ligne · {duration}',
    CRM_LIVE_ENDED_ANSWERED: 'Appel terminé · {duration}',
    CRM_LIVE_ENDED_UNANSWERED: 'Pas de réponse',
    CRM_LIVE_SHORT_ANSWER: 'Décroché moins de 30 s : répondeur ? Choisissez l’issue.',
    CRM_LIVE_PREFILLED: 'Issue pré-remplie d’après l’appel : vérifiez-la, complétez et enregistrez.',
    CRM_QUEUE_UNLOGGED_CALL: 'Appel du {date} ({minutes} min) pas encore saisi',
    CRM_QUEUE_LOG_UNLOGGED: 'Saisir',
    CRM_QUEUE_LOG_INBOUND: 'Noter un appel reçu',
    CRM_CALL_INBOUND_HINT:
      'La personne vous a appelé : notez ce qu’elle a dit. Un appel reçu ne compte pas comme une tentative.',
    CRM_JOURNAL_COL_WHEN: 'Quand',
    CRM_JOURNAL_COL_PERSON: 'Personne',
    CRM_JOURNAL_COL_WHO: 'Appelé par',
    CRM_JOURNAL_COL_OUTCOME: 'Issue',
    CRM_JOURNAL_COL_NOTE: 'Note',
    CRM_JOURNAL_DURATION: '{minutes} min',
    CRM_JOURNAL_DURATION_MEASURED: 'Durée mesurée par la ligne',
    CRM_JOURNAL_OUTSIDE_QUEUE: 'Hors file d’appels',
    CRM_FREE_CALL_LOG: 'Noter un appel',
    CRM_FREE_CALL_HINT:
      'Appel hors file d’appels (support, rappel) : il va au journal, sans compter comme tentative ni changer la file.',
    CRM_JOURNAL_CONVERTED: 'S’est abonnée pendant l’appel',
    CRM_JOURNAL_WAS_CALLBACK: 'Rappel programmé',
    CRM_DOSSIER_TITLE: 'Suivi',
    CRM_DOSSIER_DESC:
      'Une seule fiche par personne : son parcours, sa place dans la file d’appels, ses appels et les notes de l’équipe.',
    CRM_DOSSIER_ERROR: 'L’action a échoué.',
    CRM_DOSSIER_ENTER_QUEUE: 'Faire entrer dans la file',
    CRM_DOSSIER_SCHEDULE_CALLBACK: 'Planifier un rappel',
    CRM_DOSSIER_SCHEDULE_CALLBACK_DESC:
      'Un passage « à la demande » s’ouvre sur ce rappel : il passe en tête de la journée à cette heure, se reporte sans plafond et ne déclenche aucune relance automatique.',
    CRM_DOSSIER_SCHEDULE_CALLBACK_SUBMIT: 'Planifier',
    CRM_DOSSIER_CALLBACK_SCHEDULED: 'Rappel planifié',
    CRM_DOSSIER_EXIT_QUEUE: 'Sortir de la file',
    CRM_DOSSIER_ENTERED: 'Entrée dans la file d’appels',
    CRM_DOSSIER_EXITED: 'Sortie de la file d’appels',
    CRM_DOSSIER_NOT_IN_QUEUE: 'Pas dans la file d’appels.',
    CRM_DOSSIER_OPEN_ENTRY: 'Dans la file',
    CRM_DOSSIER_PAST_ENTRIES: 'Passages précédents',
    CRM_DOSSIER_CONFIG_SCORE: 'Score de configuration',
    CRM_DOSSIER_PHONE_INVALID: 'Numéro marqué invalide le',
    CRM_DOSSIER_REASON: 'Raison',
    CRM_DOSSIER_TRAINING: 'Formation',
    CRM_DOSSIER_NOTES: 'Notes',
    CRM_DOSSIER_NOTES_DESC:
      'Datées, signées, jamais supprimées. Une note épinglée reste en haut et s’affiche dans la file.',
    CRM_DOSSIER_NOTES_EMPTY: 'Aucune note.',
    CRM_DOSSIER_NOTE_PLACEHOLDER: 'Ce qu’il faut savoir avant le prochain appel.',
    CRM_DOSSIER_NOTE_ADD: 'Ajouter',
    CRM_DOSSIER_NOTE_ADD_PINNED: 'Ajouter et épingler',
    CRM_DOSSIER_NOTE_PIN: 'Épingler',
    CRM_DOSSIER_NOTE_UNPIN: 'Désépingler',
    CRM_DOSSIER_NOTE_EDIT: 'Corriger (dix minutes)',
    CRM_DOSSIER_NOTE_EDITED: 'corrigée',
    CRM_DOSSIER_NOTE_SAVE: 'Enregistrer',
    CRM_DOSSIER_CALLS: 'Appels',
    CRM_LIFECYCLE_LEAD_SINCE: 'Lead depuis',
    CRM_LIFECYCLE_SIGNED_UP_AT: 'Inscrit le',
    CRM_LIFECYCLE_TRIAL_END_AT: 'Fin d’essai',
    CRM_LIFECYCLE_CLIENT_SINCE: 'Client depuis',
    CRM_LIFECYCLE_CHURNED_AT: 'Résilié le',
    SIDEBAR_CRM_TRAININGS: 'Formations & démos',
    CRM_TRAINING_TITLE: 'Formations & démos',
    CRM_TRAINING_SUBTITLE: `Les séances de formation et de démo du compte ${PROJECT_CONFIG.brand_string} qui les porte, et la présence à cocher après chaque séance.`,
    CRM_TRAINING_KIND: 'Nature',
    CRM_TRAINING_KIND_ALL: 'Toutes',
    CRM_TRAINING_TAB_PAST: 'Séances passées',
    CRM_TRAINING_TAB_UPCOMING: 'À venir',
    CRM_TRAINING_NOT_CONFIGURED: 'Aucun compte de formation configuré',
    CRM_TRAINING_NOT_CONFIGURED_HINT: `Renseignez CRM_TRAINING_PROFESSIONAL_ID (le compte ${PROJECT_CONFIG.brand_string} des formations) dans l’environnement.`,
    CRM_TRAINING_EMPTY: 'Aucune séance',
    CRM_TRAINING_LATE: 'Présences à saisir',
    CRM_TRAINING_ALL_MARKED: 'Présences saisies',
    CRM_TRAINING_ATTENDEES: '{count, plural, =0 {aucun inscrit} one {1 inscrit} other {# inscrits}}',
    CRM_TRAINING_NO_DOSSIER: 'aucune fiche trouvée avec ce numéro ou cet email',
    CRM_TRAINING_STOPPED: 'Deux absences : on ne propose plus la formation.',
    CRM_TRAINING_MISSED_REASON: 'Raison donnée : {reason}',
    CRM_TRAINING_ABSENCES: '{count, plural, one {1 absence} other {# absences}}',
    CRM_TRAINING_ERROR: 'La présence n’a pas pu être enregistrée.',
    CRM_TRAINING_ENROLLED_AT: 'inscrit le {date}',
    CRM_WQ_TRAININGS_TO_MARK:
      '{count, plural, one {1 séance passée} other {# séances passées}} avec des présences à saisir',
    CRM_WQ_TRAININGS_LINK: 'Ouvrir les formations et démos',

    // ── CRM : retrouver, filtrer, résumer (lot 4) ───────────────────────────
    SIDEBAR_CRM_PEOPLE: 'Personnes',
    CRM_PEOPLE_TITLE: 'Personnes',
    CRM_PEOPLE_SUBTITLE:
      'Leads, inscrits et clients sur une seule liste. Les filtres se cumulent ; le compte se met à jour à chaque filtre.',
    CRM_PEOPLE_VIEWS: 'Vues',
    CRM_PEOPLE_VIEW_ALL: 'Toutes les personnes',
    CRM_PEOPLE_VIEW_TRIAL_ENDED_NEVER_CALLED: 'Essais terminés jamais appelés',
    CRM_PEOPLE_VIEW_CALLBACKS_THIS_WEEK: 'Rappels de la semaine',
    CRM_PEOPLE_VIEW_BLOCKED_ON_CATALOG: 'Bloqués sur le catalogue',
    CRM_PEOPLE_VIEW_TRAINED_NOT_SUBSCRIBED: 'Formés, pas encore clients',
    CRM_PEOPLE_FILTERS: 'Filtres',
    CRM_PEOPLE_FILTER_STAGE: 'Étape',
    CRM_PEOPLE_FILTER_CALLS: 'Appels',
    CRM_PEOPLE_FILTER_CALLS_ANY: 'Peu importe',
    CRM_PEOPLE_FILTER_CALLS_NONE: 'Jamais appelé',
    CRM_PEOPLE_FILTER_CALLS_SOME: 'Déjà appelé',
    CRM_PEOPLE_FILTER_CONTACT_ALLOWED: 'Contact autorisé seulement',
    CRM_PEOPLE_FILTER_CALLBACK: 'Rappel',
    CRM_PEOPLE_FILTER_CALLBACK_ANY: 'Peu importe',
    CRM_PEOPLE_FILTER_CALLBACK_THIS_WEEK: 'Cette semaine',
    CRM_PEOPLE_FILTER_CALLBACK_OVERDUE: 'En retard',
    CRM_PEOPLE_FILTER_BLOCKED_STEP: 'Étape bloquante',
    CRM_PEOPLE_FILTER_REASON: 'Raison de non-conversion',
    CRM_PEOPLE_FILTER_TRAINING: 'Formation',
    CRM_PEOPLE_FILTER_TRAINING_ANY: 'Peu importe',
    CRM_PEOPLE_FILTER_TRAINING_ENROLLED: 'Inscrit à une séance',
    CRM_PEOPLE_FILTER_TRAINING_ATTENDED: 'A suivi la formation',
    CRM_PEOPLE_FILTER_TRAINING_MISSED: 'A manqué une séance',
    CRM_PEOPLE_FILTER_TRAINING_NEVER: 'Jamais inscrit',
    CRM_PEOPLE_FILTER_DEMO: 'Démo',
    CRM_PEOPLE_FILTER_DEMO_ATTENDED: 'A suivi une démo',
    CRM_PEOPLE_FILTER_DEMO_MISSED: 'A manqué une démo',
    CRM_PEOPLE_FILTER_DEMO_NEVER: 'Aucune démo pointée',
    CRM_PEOPLE_FILTER_HAS_PHONE: 'Avec un numéro',
    CRM_PEOPLE_FILTER_HAS_EMAIL: 'Avec un email',
    CRM_PEOPLE_FILTER_SCORE: 'Score de configuration',
    CRM_PEOPLE_FILTER_SCORE_MIN: 'min',
    CRM_PEOPLE_FILTER_SCORE_MAX: 'max',
    CRM_PEOPLE_FILTER_TRIAL_ENDED_DAYS: 'Essai terminé depuis moins de (jours)',
    CRM_PEOPLE_FILTER_SIGNED_UP_DAYS: 'Inscrit depuis moins de (jours)',
    CRM_PEOPLE_FILTER_CITY: 'Ville',
    CRM_PEOPLE_FILTER_IN_QUEUE: 'Dans la file d’appels',
    CRM_PEOPLE_FILTER_MIGRATED: 'Comptes migrés',
    CRM_PEOPLE_FILTER_TRISTATE_ANY: 'Peu importe',
    CRM_PEOPLE_FILTER_TRISTATE_YES: 'Oui',
    CRM_PEOPLE_FILTER_TRISTATE_NO: 'Non',
    CRM_PEOPLE_FILTER_RESET: 'Effacer les filtres',
    CRM_PEOPLE_SORT: 'Tri',
    CRM_PEOPLE_SORT_RECENT: 'Plus récents',
    CRM_PEOPLE_SORT_TRIAL_ENDED: 'Fin d’essai',
    CRM_PEOPLE_SORT_LAST_CALL: 'Dernier appel',
    CRM_PEOPLE_SORT_NAME: 'Nom',
    CRM_PEOPLE_COUNT: '{count, plural, =0 {Aucune personne} one {1 personne} other {# personnes}}',
    CRM_PEOPLE_EXPORT: 'Exporter en CSV',
    CRM_PEOPLE_EXPORT_HINT: 'Au plus {max} lignes, avec les filtres en cours. L’export est journalisé.',
    CRM_PEOPLE_EXPORT_ERROR: 'L’export n’a pas pu être généré.',
    CRM_PEOPLE_EMPTY: 'Aucune personne ne correspond à ces filtres.',
    CRM_PEOPLE_COL_PERSON: 'Personne',
    CRM_PEOPLE_COL_STAGE: 'Étape',
    CRM_PEOPLE_COL_CONTACT: 'Contact',
    CRM_PEOPLE_COL_SCORE: 'Score',
    CRM_PEOPLE_COL_CALLS: 'Appels',
    CRM_PEOPLE_COL_FOLLOWUP: 'Suivi',
    CRM_PEOPLE_COL_DATES: 'Dates',
    CRM_PEOPLE_CALLS_COUNT: '{count, plural, =0 {aucun appel} one {1 appel} other {# appels}}',
    CRM_PEOPLE_LAST_CALL: 'dernier le {date}',
    CRM_PEOPLE_SIGNED_UP: 'inscrit le {date}',
    CRM_PEOPLE_TRIAL_END: 'fin d’essai le {date}',
    CRM_PEOPLE_CALLBACK_AT: 'rappel le {date}',
    CRM_PEOPLE_TRAINING_ATTENDED: 'formé',
    CRM_PEOPLE_TRAINING_MISSED: 'absent à une formation',
    CRM_PEOPLE_MIGRATED: 'migré',
    CRM_PEOPLE_PAGE: 'Page {page} sur {pages}',
    CRM_PEOPLE_PREVIOUS: 'Précédente',
    CRM_PEOPLE_NEXT: 'Suivante',
    CRM_SEARCH_PLACEHOLDER: 'Rechercher une personne (nom, numéro, email)',
    CRM_SEARCH_EMPTY: 'Aucune personne trouvée',
    CRM_SEARCH_HINT: 'Au moins deux caractères',
    CRM_SEARCH_ALL_RESULTS: 'Voir toutes les personnes',
    CRM_MAILING_LISTS_TITLE: 'Listes de diffusion',
    CRM_MAILING_LISTS_HINT:
      'Déduites de l’étape et des désabonnements, jamais saisies : un inscrit non client reçoit la liste de diffusion, un client la newsletter.',
    CRM_MAILING_LIST_MEMBER: 'Inscrite',
    CRM_MAILING_LIST_NOT_MEMBER: 'Non inscrite',
    CRM_MAILING_LIST_ADD: 'Ajouter à la main',
    CRM_MAILING_LIST_REMOVE: 'Retirer',
    CRM_SUMMARY_TITLE: 'Pulse sur ce dossier',
    CRM_SUMMARY_ASK: 'Résumer le dossier',
    CRM_SUMMARY_HINT:
      'Un résumé en trois lignes, ou la réponse à une question, tirés de ce que la fiche montre. Rien n’est écrit sur la fiche.',
    CRM_SUMMARY_QUESTION_PLACEHOLDER:
      'Poser une question : a-t-elle suivi la formation ? qu’a-t-on promis au dernier appel ?',
    CRM_SUMMARY_QUESTION_SUBMIT: 'Demander',
    CRM_SUMMARY_HINT_PRO:
      'Pulse lit le compte comme le pro (planning, configuration, site…) et le suivi (appels, notes, formation). Rien n’est écrit sur la fiche.',
    CRM_SUMMARY_QUESTION_PLACEHOLDER_PRO:
      'Poser une question : pourquoi aucun créneau samedi ? a-t-il suivi la formation ? son site est-il publié ?',
    CRM_SUMMARY_THINKING: 'Pulse réfléchit…',
    CRM_SUMMARY_CONTINUE_IN_PULSE: 'Continuer dans l’onglet Pulse',
    CRM_SUMMARY_GENERATED_AT: 'Rédigé le {date}',
    CRM_SUMMARY_ERROR: 'Le résumé n’a pas pu être rédigé.',
    // Fiche en bref dans la fiche d'appel : le dossier sous les yeux pendant que ça sonne.
    CRM_CALL_RECAP_TITLE: 'Fiche en bref',
    CRM_CALL_RECAP_OPEN_SHEET: 'Ouvrir la fiche',
    CRM_CALL_RECAP_PULSE: 'Résumé Pulse',
    CRM_CALL_RECAP_ERROR: 'La fiche n’a pas pu être chargée.',
    CRM_CALL_RECAP_LAST_CALLS: 'Derniers appels',
    CRM_CALL_RECAP_NO_CALLS: 'Aucun appel enregistré.',
    CRM_CALL_RECAP_NOTES: 'Dernières notes',
    CRM_CALL_RECAP_TRAINING: '{count, plural, =1 {1 séance de formation} other {# séances de formation}}',
    CRM_CALL_RECAP_ABSENCES: '{count, plural, =1 {1 absence} other {# absences}}',

    // ── CRM : communications (lot 6) ────────────────────────────────────────
    NAV_GROUP_COMMUNICATIONS: 'Communications',
    SIDEBAR_CRM_CAMPAIGNS: 'Campagnes',
    SIDEBAR_CRM_AUDIENCES: 'Audiences',
    SIDEBAR_CRM_SEQUENCE: 'Séquences automatiques',
    SIDEBAR_CRM_TEMPLATES: 'Modèles d’email',
    CRM_TEMPLATES_TITLE: 'Modèles d’email',
    CRM_TEMPLATES_SUBTITLE:
      'Emails prêts à l’emploi, réutilisables dans une campagne, une étape de séquence ou un email de suite de séance. Un modèle se copie : le modifier ne change pas ce qui a déjà été repris.',
    CRM_TEMPLATES_NEW: 'Nouveau modèle',
    CRM_TEMPLATES_NEW_DESC: 'Donnez-lui un nom et un objet ; le contenu se rédige ensuite dans le constructeur.',
    CRM_TEMPLATES_CREATE: 'Créer le modèle',
    CRM_TEMPLATES_RENAME: 'Renommer',
    CRM_TEMPLATES_DUPLICATE: 'Dupliquer',
    CRM_TEMPLATES_DUPLICATED: 'Modèle dupliqué.',
    CRM_TEMPLATES_COPY_SUFFIX: '(copie)',
    CRM_TEMPLATES_DELETE: 'Supprimer',
    CRM_TEMPLATES_DELETE_TITLE: 'Supprimer ce modèle ?',
    CRM_TEMPLATES_DELETE_DESC: 'Le modèle « {name} » sera supprimé. Les emails qui l’ont repris ne changent pas.',
    CRM_TEMPLATES_DELETED: 'Modèle supprimé.',
    CRM_TEMPLATES_EMPTY: 'Aucun modèle.',
    CRM_TEMPLATES_EMPTY_HINT:
      'Créez-en un ici, ou enregistrez comme modèle le contenu d’une campagne, d’une étape ou d’un email de suite.',
    CRM_TEMPLATES_EMPTY_CONTENT: 'Pas encore de contenu',
    CRM_TEMPLATES_UPDATED_AT: 'Modifié le {date}',
    CRM_TEMPLATES_UPDATED_BY: 'par {name}',
    CRM_TEMPLATES_ERROR: 'L’action sur le modèle a échoué.',
    CRM_TEMPLATES_USE: 'Utiliser un modèle',
    CRM_TEMPLATES_USE_DESC:
      'L’objet et le contenu du modèle remplacent ceux de cet email. Rien ne lie l’email au modèle ensuite.',
    CRM_TEMPLATES_USE_CONFIRM: 'Reprendre ce modèle',
    CRM_TEMPLATES_USED: 'Modèle repris.',
    CRM_TEMPLATES_PICK_EMPTY: 'Aucun modèle avec du contenu. Créez-en un dans « Modèles d’email ».',
    CRM_TEMPLATES_SAVE_AS: 'Enregistrer comme modèle',
    CRM_TEMPLATES_SAVE_AS_DESC: 'L’objet et le contenu actuels sont copiés dans un nouveau modèle de la bibliothèque.',
    CRM_TEMPLATES_SAVED_AS: 'Modèle « {name} » enregistré.',
    // Communs aux trois écrans
    CRM_COMMS_FIELD_NAME: 'Nom',
    CRM_COMMS_FIELD_LIST: 'Liste',
    CRM_COMMS_FIELD_LIST_HINT:
      'Liste de diffusion : les inscrits qui ne sont pas clients. Newsletter : les clients. Les personnes en cours d’essai ne reçoivent rien.',
    CRM_COMMS_FIELD_SENDER: 'Expéditeur',
    CRM_COMMS_SENDER_FIXED: 'Envoyé par {name} <{email}>, les réponses arrivent à {reply_to}.',
    CRM_COMMS_FIELD_SUBJECT: 'Objet',
    CRM_COMMS_SAVE: 'Enregistrer',
    CRM_COMMS_SAVED: 'Enregistré.',
    CRM_COMMS_EDIT_CONTENT: 'Modifier le contenu',
    CRM_COMMS_PREVIEW: 'Aperçu',
    CRM_COMMS_PREVIEW_TITLE: 'Aperçu de l’email',
    CRM_COMMS_PREVIEW_DESC: 'Rendu avec des valeurs d’exemple à la place des informations du destinataire.',
    CRM_COMMS_PREVIEW_ERROR: 'L’aperçu n’a pas pu être affiché.',
    CRM_COMMS_SEND_TEST: 'Envoyer un test',
    CRM_COMMS_TEST_SENT: 'Test envoyé à {address}.',
    CRM_COMMS_AUDIENCE_RECIPIENTS:
      '{count, plural, =0 {Aucun destinataire} one {1 destinataire} other {# destinataires}} si l’envoi partait maintenant',
    CRM_COMMS_AUDIENCE_MATCHED:
      '{count, plural, =0 {Aucune personne ne correspond} one {1 personne correspond} other {# personnes correspondent}} aux filtres, avant les exclusions',
    CRM_COMMS_AUDIENCE_EXCLUDED: 'Exclusions',
    CRM_COMMS_TRACE_TITLE: 'Communications',
    CRM_COMMS_TRACE_DESC: 'Campagnes et messages des séquences automatiques reçus par cette personne.',
    CRM_COMMS_TRACE_OPENED: 'Ouvert',
    CRM_COMMS_TRACE_CLICKED: 'Cliqué',
    CRM_COMMS_TRACE_UNSUBSCRIBED: 'Désinscrit',
    // Campagnes
    CRM_CAMPAIGNS_TAB_CAMPAIGNS: 'Campagnes',
    CRM_CAMPAIGNS_TAB_AUTOMATIC: 'Emails automatiques',
    CRM_SESSION_FOLLOWUP_TITLE: 'Emails de suite de séance',
    CRM_SESSION_FOLLOWUP_DESC:
      'Un email par formation et par démo, envoyé automatiquement dans l’heure qui suit le pointage d’une présence dans « Formations & démos ». Un merci de service : il part aussi aux clients déjà abonnés, sans lien de désinscription.',
    CRM_SESSION_FOLLOWUP_NONE:
      'Aucune formation ni démo configurée : les emails de suite apparaissent ici dès qu’une prestation de séance est déclarée (CRM_TRAINING_PRESTATION_IDS / CRM_DEMO_PRESTATION_IDS).',
    CRM_SESSION_FOLLOWUP_ACTIVE: 'Actif',
    CRM_SESSION_FOLLOWUP_INACTIVE: 'Inactif',
    CRM_SESSION_FOLLOWUP_ACTIVATE: 'Activer l’envoi automatique',
    CRM_SESSION_FOLLOWUP_ACTIVATE_HINT: 'Rédigez l’objet et le contenu avant d’activer.',
    CRM_SESSION_FOLLOWUP_SCHEDULE: 'Part dans l’heure qui suit le pointage de la présence',
    CRM_SESSION_FOLLOWUP_SENT: '{count, plural, =0 {Aucun envoi} one {1 envoi} other {# envois}}',
    CRM_SESSION_FOLLOWUP_LAST_SENT: 'dernier le {date}',
    CRM_SESSION_FOLLOWUP_SAVE: 'Enregistrer les réglages',
    CRM_SESSION_FOLLOWUP_SAVED: 'Réglages enregistrés',
    CRM_SESSION_FOLLOWUP_ERROR: 'L’emplacement n’a pas pu être enregistré.',
    CRM_SESSION_FOLLOWUP_EMPTY: 'Pas encore de contenu',
    CRM_CAMPAIGNS_TITLE: 'Campagnes',
    CRM_CAMPAIGNS_SUBTITLE:
      'Emails et SMS envoyés à nos propres leads et clients. Les destinataires sont recalculés au moment de l’envoi.',
    CRM_CAMPAIGNS_NEW: 'Nouvelle campagne',
    CRM_CAMPAIGNS_NEW_DESC:
      'La campagne est créée en brouillon. Le contenu, l’audience et l’envoi se règlent sur sa page.',
    CRM_CAMPAIGNS_CREATE: 'Créer le brouillon',
    CRM_CAMPAIGNS_FIELD_TYPE: 'Canal',
    CRM_CAMPAIGNS_FIELD_AUDIENCE: 'Audience',
    CRM_CAMPAIGNS_FIELD_SMS: 'Texte du SMS',
    CRM_CAMPAIGNS_SMS_COUNTER: '{count} / {max} caractères',
    CRM_CAMPAIGNS_AUDIENCE_WHOLE_LIST: 'Toute la liste',
    CRM_CAMPAIGNS_FILTER_ALL: 'Toutes',
    CRM_CAMPAIGNS_FILTER_STATUS: 'Filtrer par statut',
    CRM_CAMPAIGNS_EMPTY: 'Aucune campagne.',
    CRM_CAMPAIGNS_EMPTY_HINT: 'Une campagne commence par un brouillon : rien ne part tant qu’on ne l’a pas demandé.',
    CRM_CAMPAIGNS_COL_NAME: 'Campagne',
    CRM_CAMPAIGNS_COL_LIST: 'Liste et audience',
    CRM_CAMPAIGNS_COL_STATUS: 'Statut',
    CRM_CAMPAIGNS_COL_DATE: 'Date',
    CRM_CAMPAIGNS_COL_RECIPIENTS: 'Destinataires',
    CRM_CAMPAIGNS_COL_OPENED: 'Ouvertures',
    CRM_CAMPAIGNS_COL_CLICKED: 'Clics',
    CRM_CAMPAIGNS_COL_UNSUBSCRIBED: 'Désinscriptions',
    CRM_CAMPAIGNS_SCHEDULED_AT: 'Programmée le {date}',
    CRM_CAMPAIGNS_SENT_AT: 'Envoyée le {date}',
    CRM_CAMPAIGNS_UNSUB_ALERT_BADGE: 'Désinscriptions élevées',
    CRM_CAMPAIGNS_DUPLICATE: 'Dupliquer',
    CRM_CAMPAIGNS_DUPLICATED: 'Campagne dupliquée en brouillon.',
    CRM_CAMPAIGNS_DELETE: 'Supprimer',
    CRM_CAMPAIGNS_DELETE_TITLE: 'Supprimer ce brouillon ?',
    CRM_CAMPAIGNS_DELETE_DESC: 'Le brouillon « {name} » sera supprimé. Cette action est définitive.',
    CRM_CAMPAIGNS_DELETED: 'Brouillon supprimé.',
    CRM_CAMPAIGNS_ERROR: 'L’action sur la campagne a échoué.',
    CRM_CAMPAIGNS_BACK: 'Toutes les campagnes',
    CRM_CAMPAIGNS_NOT_FOUND: 'Cette campagne est introuvable.',
    CRM_CAMPAIGNS_SETTINGS: 'Réglages',
    CRM_CAMPAIGNS_SETTINGS_DESC: 'Modifiables tant que la campagne est en brouillon.',
    CRM_CAMPAIGNS_READ_ONLY: 'La campagne n’est plus un brouillon : ses réglages ne se modifient plus.',
    CRM_CAMPAIGNS_CONTENT: 'Contenu de l’email',
    CRM_CAMPAIGNS_CONTENT_DESC: 'Aperçu rendu avec des valeurs d’exemple à la place des informations du destinataire.',
    CRM_CAMPAIGNS_CONTENT_EMPTY: 'Aucun contenu pour l’instant.',
    CRM_CAMPAIGNS_RECIPIENTS: 'Destinataires',
    CRM_CAMPAIGNS_RECIPIENTS_DESC:
      'Effectif calculé maintenant. Il est recalculé juste avant l’envoi : il peut encore changer.',
    CRM_CAMPAIGNS_SAVE_FIRST: 'Enregistre les réglages pour mettre à jour l’effectif et pouvoir envoyer.',
    CRM_CAMPAIGNS_NO_RECIPIENT: 'Aucun destinataire : l’envoi immédiat est bloqué.',
    CRM_CAMPAIGNS_SENDING: 'Envoi',
    CRM_CAMPAIGNS_SENDING_DESC: 'Le test part à ton adresse. L’envoi réel part à tous les destinataires.',
    CRM_CAMPAIGNS_SENDING_HINT: 'Envoi en cours. Les statistiques apparaîtront une fois l’envoi terminé.',
    CRM_CAMPAIGNS_SEND_NOW: 'Envoyer maintenant',
    CRM_CAMPAIGNS_SEND_CONFIRM_TITLE: 'Envoyer la campagne ?',
    CRM_CAMPAIGNS_SEND_CONFIRM_DESC:
      '« {name} » va partir à {count, plural, one {1 destinataire} other {# destinataires}}. Un envoi ne s’annule pas.',
    CRM_CAMPAIGNS_SEND_CONFIRM_DESC_UNKNOWN: '« {name} » va partir à ses destinataires. Un envoi ne s’annule pas.',
    CRM_CAMPAIGNS_SEND_STARTED: 'Envoi lancé.',
    CRM_CAMPAIGNS_SEND_ERROR: 'L’envoi a échoué : {reason}.',
    CRM_CAMPAIGNS_SCHEDULE_AT: 'Programmer pour le',
    CRM_CAMPAIGNS_SCHEDULE: 'Programmer',
    CRM_CAMPAIGNS_SCHEDULE_PAST: 'Choisis une date à venir.',
    CRM_CAMPAIGNS_SCHEDULED: 'Campagne programmée.',
    CRM_CAMPAIGNS_UNSCHEDULE: 'Déprogrammer',
    CRM_CAMPAIGNS_UNSCHEDULED: 'Campagne repassée en brouillon.',
    CRM_CAMPAIGNS_UNSUB_ALERT:
      'Plus de {rate} % des destinataires se sont désinscrits. Vérifie l’audience et le contenu avant le prochain envoi.',
    CRM_CAMPAIGNS_STAT_RECIPIENTS: 'Destinataires',
    CRM_CAMPAIGNS_STAT_DELIVERED: 'Délivrés',
    CRM_CAMPAIGNS_STAT_OPENED: 'Ouvertures',
    CRM_CAMPAIGNS_STAT_CLICKED: 'Clics',
    CRM_CAMPAIGNS_STAT_UNSUBSCRIBED: 'Désinscriptions',
    CRM_CAMPAIGNS_STAT_BOUNCED: 'Adresses en erreur',
    CRM_CAMPAIGNS_STAT_FAILED: 'Échecs d’envoi',
    CRM_CAMPAIGNS_RECIPIENTS_LIST: '{count, plural, one {1 destinataire} other {# destinataires}}',
    CRM_CAMPAIGNS_RECIPIENTS_EMPTY: 'Aucun destinataire enregistré.',
    CRM_CAMPAIGNS_RCPT_COL_PERSON: 'Personne',
    CRM_CAMPAIGNS_RCPT_COL_SENT: 'Envoyé',
    CRM_CAMPAIGNS_RCPT_COL_OPENED: 'Ouvert',
    CRM_CAMPAIGNS_RCPT_COL_CLICKED: 'Cliqué',
    CRM_CAMPAIGNS_RCPT_COL_UNSUBSCRIBED: 'Désinscrit',
    CRM_CAMPAIGNS_RCPT_BOUNCED: 'Adresse en erreur',
    // Audiences
    CRM_AUDIENCES_TITLE: 'Audiences',
    CRM_AUDIENCES_SUBTITLE:
      'Une audience = une liste et des filtres de la page Personnes. Elle est recalculée à chaque envoi : l’effectif affiché est indicatif.',
    CRM_AUDIENCES_NEW: 'Nouvelle audience',
    CRM_AUDIENCES_EDIT: 'Modifier l’audience',
    CRM_AUDIENCES_DIALOG_DESC:
      'Les filtres se cumulent. Les refus et les personnes en essai sont écartés en plus, à l’envoi.',
    CRM_AUDIENCES_EMPTY: 'Aucune audience.',
    CRM_AUDIENCES_EMPTY_HINT: 'Sans audience, une campagne ou une séquence vise toute sa liste.',
    CRM_AUDIENCES_COL_FILTERS: 'Filtres',
    CRM_AUDIENCES_COL_COUNT: 'Effectif (email)',
    CRM_AUDIENCES_COL_CAMPAIGNS: 'Utilisée par',
    CRM_AUDIENCES_USAGE:
      '{campaigns, plural, =0 {Aucune campagne en attente} one {1 campagne en attente} other {# campagnes en attente}} · {sequences, plural, =0 {aucune séquence} one {1 séquence} other {# séquences}}',
    CRM_AUDIENCES_FILTERS_COUNT: '{count, plural, =0 {Aucun filtre} one {1 filtre} other {# filtres}}',
    CRM_AUDIENCES_SEE_PEOPLE: 'Voir les personnes',
    CRM_AUDIENCES_UPDATED_AT: 'Modifiée le {date}',
    CRM_AUDIENCES_COUNT: 'Calculer l’effectif',
    CRM_AUDIENCES_DELETE: 'Supprimer',
    CRM_AUDIENCES_DELETE_BLOCKED: 'Une campagne qui n’est pas encore partie, ou une séquence, vise cette audience.',
    CRM_AUDIENCES_DELETE_TITLE: 'Supprimer cette audience ?',
    CRM_AUDIENCES_DELETE_DESC: 'L’audience « {name} » sera supprimée. Les campagnes déjà envoyées ne changent pas.',
    CRM_AUDIENCES_DELETED: 'Audience supprimée.',
    CRM_AUDIENCES_ERROR: 'L’action sur l’audience a échoué.',
    // Séquences automatiques : liste
    CRM_SEQS_TITLE: 'Séquences automatiques',
    CRM_SEQS_SUBTITLE:
      'Des emails et SMS envoyés d’office, étape par étape, à une audience : la liste de diffusion, les clients, ou une audience enregistrée. Chaque séquence a ses étapes, ses délais et ses textes.',
    CRM_SEQS_NEW: 'Nouvelle séquence',
    CRM_SEQS_NEW_DESC:
      'La séquence est créée inactive, sans étape. Les étapes, les textes et l’activation se règlent sur sa page.',
    CRM_SEQS_CREATE: 'Créer la séquence',
    CRM_SEQS_EMPTY: 'Aucune séquence.',
    CRM_SEQS_EMPTY_HINT: 'Une séquence est créée inactive : rien ne part tant qu’on ne l’a pas activée.',
    CRM_SEQS_COL_NAME: 'Séquence',
    CRM_SEQS_COL_AUDIENCE: 'Audience',
    CRM_SEQS_COL_STEPS: 'Étapes',
    CRM_SEQS_COL_SENT: 'Envoyés',
    CRM_SEQS_COL_STATE: 'État',
    CRM_SEQS_STEPS_COUNT: '{active, plural, =0 {Aucune active} one {1 active} other {# actives}} sur {total}',
    CRM_SEQS_BACK: 'Toutes les séquences',
    CRM_SEQS_ERROR: 'L’action sur les séquences a échoué.',
    // Séquence automatique : une séquence
    CRM_SEQ_TITLE: 'Séquence automatique',
    CRM_SEQ_SUBTITLE:
      'Les étapes, les délais, les textes et les heures d’envoi de cette séquence se règlent ici, sans déploiement.',
    CRM_SEQ_FIELD_AUDIENCE: 'Audience',
    CRM_SEQ_FIELD_SENDER_HINT: 'Liste fixe. Quel que soit l’expéditeur, les réponses arrivent toutes à la même boîte.',
    CRM_SEQ_FIELD_AUDIENCE_HINT:
      'Toute la liste, ou une audience enregistrée (la séquence prend alors sa liste). L’audience est recalculée à chaque passage : une personne qui en sort ne reçoit plus rien. Les personnes en essai ne reçoivent rien.',
    CRM_SEQ_AUDIENCE_WHOLE_LIST: '{list} : toute la liste',
    CRM_SEQ_LOCKED_HINT: 'Désactivez la séquence pour changer son audience ou son point de départ.',
    CRM_SEQ_MEMBERS:
      '{count, plural, =0 {Personne dans l’audience} one {1 personne dans l’audience} other {# personnes dans l’audience}}',
    CRM_SEQ_ANCHOR_ENTRY_HINT:
      'L’entrée est relevée à chaque passage horaire : la première étape se compte à partir du moment où la personne apparaît dans l’audience.',
    CRM_SEQ_ACTIVATE_EXISTING:
      'Écrire aussi {count, plural, one {à la personne déjà} other {aux # personnes déjà}} dans l’audience',
    CRM_SEQ_ACTIVATE_EXISTING_HINT:
      'Décoché, elles sont mises de côté : seules les personnes qui entrent dans l’audience à partir de maintenant reçoivent la séquence.',
    CRM_SEQ_DELETE: 'Supprimer la séquence',
    CRM_SEQ_DELETE_TITLE: 'Supprimer cette séquence ?',
    CRM_SEQ_DELETE_DESC:
      'La séquence « {name} » s’arrête et disparaît de la liste. Les messages déjà envoyés restent sur les fiches.',
    CRM_SEQ_DELETED: 'Séquence supprimée.',
    CRM_SEQ_STATE: 'État',
    CRM_SEQ_ACTIVE: 'Active',
    CRM_SEQ_INACTIVE: 'Inactive',
    CRM_SEQ_ACTIVATE: 'Activer la séquence',
    CRM_SEQ_DEACTIVATE: 'Désactiver la séquence',
    CRM_SEQ_ACTIVATE_TITLE: 'Activer la séquence ?',
    CRM_SEQ_ACTIVATE_DESC:
      'Les messages des {count, plural, =0 {étapes actives (aucune pour l’instant)} one {1 étape active} other {# étapes actives}} partiront d’eux-mêmes aux personnes concernées, à partir du prochain passage.',
    CRM_SEQ_IN_PROGRESS:
      '{count, plural, =0 {Personne n’est dans la séquence} one {1 personne est dans la séquence} other {# personnes sont dans la séquence}} en ce moment',
    CRM_SEQ_SETTINGS: 'Réglages',
    CRM_SEQ_SETTINGS_DESC:
      'Chaque étape se compte à partir de l’étape précédente ; la première, à partir du point de départ.',
    CRM_SEQ_FIELD_ANCHOR: 'Point de départ',
    CRM_SEQ_FIELD_ANCHOR_HINT: 'L’événement à partir duquel la première étape est comptée.',
    CRM_SEQ_FIELD_APPLIES_FROM: 'S’applique aux personnes à partir du',
    CRM_SEQ_FIELD_APPLIES_FROM_HINT:
      'Seules les personnes dont le point de départ est postérieur à cette date entrent dans la séquence.',
    CRM_SEQ_APPLIES_FROM_CURRENT: 'Réglage actuel : {date}. Les personnes antérieures n’entrent pas dans la séquence.',
    CRM_SEQ_FIELD_WEEKENDS: 'Envoyer aussi le samedi et le dimanche',
    CRM_SEQ_WEEKENDS_HINT:
      'Concerne les étapes « X jours après l’étape précédente » : décoché, une étape qui tombe un week-end part le lundi, à son heure. Une étape à jour fixe part le jour choisi. Jamais un jour férié (reportée au lendemain). Les SMS ne partent jamais le dimanche.',
    CRM_SEQ_STEPS: 'Étapes',
    CRM_SEQ_STEPS_DESC:
      'Dans l’ordre de la liste. Chaque étape se compte à partir de l’étape précédente (la première, à partir du point de départ) : un retard sur une étape décale les suivantes. Une étape inactive est sautée. Deux étapes ne partent jamais le même jour à une même personne. Une personne sans adresse pour le canal d’une étape, ou qui a refusé ce canal, passe directement à l’étape suivante.',
    CRM_SEQ_STEPS_EMPTY: 'Aucune étape pour l’instant.',
    CRM_SEQ_STEP_ADD: 'Ajouter une étape',
    CRM_SEQ_STEP_EDIT: 'Modifier l’étape',
    CRM_SEQ_STEP_DIALOG_DESC: 'Heure de Paris. Le contenu d’un email se rédige ensuite, avec « Modifier le contenu ».',
    CRM_SEQ_STEP_FIELD_TIMING: 'Quand',
    CRM_SEQ_STEP_FIELD_WEEKDAY: 'Jour',
    CRM_SEQ_STEP_FIELD_HOUR: 'Heure',
    CRM_SEQ_STEP_SMS_HOURS_HINT: 'Un SMS part entre {start} h et {end} h, jamais le dimanche.',
    CRM_SEQ_STEP_TIMING_AFTER_PREVIOUS:
      '{count, plural, =0 {Le jour même} one {1 jour après} other {# jours après}}, à {hour} h',
    CRM_SEQ_STEP_TIMING_WEEKDAY: '{day} à {hour} h',
    CRM_SEQ_WEEKDAY_1: 'Lundi',
    CRM_SEQ_WEEKDAY_2: 'Mardi',
    CRM_SEQ_WEEKDAY_3: 'Mercredi',
    CRM_SEQ_WEEKDAY_4: 'Jeudi',
    CRM_SEQ_WEEKDAY_5: 'Vendredi',
    CRM_SEQ_WEEKDAY_6: 'Samedi',
    CRM_SEQ_WEEKDAY_7: 'Dimanche',
    CRM_SEQ_STEP_FIELD_CHANNEL: 'Canal',
    CRM_SEQ_STEP_FIELD_NAME: 'Nom de l’étape',
    CRM_SEQ_STEP_SMS_STOP_HINT: 'La mention STOP est ajoutée à l’envoi. Variables possibles : {variables}.',
    CRM_SEQ_STEP_FIELD_DELAY: 'Jours après l’étape précédente (0 à {max})',
    CRM_SEQ_HOUR: '{hour} h',
    CRM_SEQ_STEP_INACTIVE: 'Inactive',
    CRM_SEQ_STEP_ACTIVATE: 'Activer l’étape',
    CRM_SEQ_STEP_DEACTIVATE: 'Désactiver l’étape',
    CRM_SEQ_STEP_COUNTERS:
      '{sent, plural, =0 {Aucun envoi} one {1 envoi} other {# envois}} · {opened, plural, one {1 ouverture} other {# ouvertures}} · {clicked, plural, one {1 clic} other {# clics}} · {unsubscribed, plural, one {1 désinscription} other {# désinscriptions}}',
    CRM_SEQ_STEP_COUNTERS_SMS: '{sent, plural, =0 {Aucun envoi} one {1 envoi} other {# envois}}',
    CRM_SEQ_STEP_DELETE: 'Supprimer l’étape',
    CRM_SEQ_STEP_DELETE_TITLE: 'Supprimer cette étape ?',
    CRM_SEQ_STEP_DELETE_DESC: 'L’étape « {subject} » ne sera plus envoyée. Cette action est définitive.',
    CRM_SEQ_ERROR: 'L’action sur la séquence a échoué.',
    // Constructeur d’email (iframe)
    CRM_BUILDER_TITLE: 'Contenu : {name}',
    CRM_BUILDER_SAVE: 'Enregistrer',
    CRM_BUILDER_UNSAVED: 'Modifications non enregistrées',
    CRM_BUILDER_LOADING: 'Chargement du constructeur…',
    CRM_BUILDER_LOAD_ERROR: 'Le constructeur d’email ne s’est pas chargé.',
    CRM_BUILDER_LOAD_ERROR_HINT:
      'Rien n’est perdu : le contenu enregistré n’a pas changé. Réessaie, ou ferme et rouvre.',
    CRM_BUILDER_RETRY: 'Réessayer',
    CRM_BUILDER_CLOSE_CONFIRM_TITLE: 'Fermer sans enregistrer ?',
    CRM_BUILDER_CLOSE_CONFIRM_DESC: 'Les modifications faites depuis le dernier enregistrement seront perdues.',
    CRM_BUILDER_CLOSE_CONFIRM_STAY: 'Continuer la rédaction',
    CRM_BUILDER_CLOSE_CONFIRM_LEAVE: 'Fermer sans enregistrer',

    // ── Relances 1:1 (file trigger_run) ─────────────────────────────────────
    RELANCES_TITLE: 'Relances',
    RELANCES_SUBTITLE: 'Ce qui part vers les leads (cascades Pulse) et vers les comptes en essai.',
    RELANCES_TAB_LEADS: 'Leads',
    RELANCES_TAB_TRIAL_PROS: 'Pros en essai',
    RELANCES_TAB_TRIAL_UPCOMING: 'Essais à venir',
    RELANCES_TAB_TRIAL_SENT: 'Essais envoyées',
    RELANCES_VIEW_UPCOMING: 'À venir',
    RELANCES_VIEW_LATE: 'En retard',
    RELANCES_VIEW_SENT: 'Envoyées',
    RELANCES_VIEW_FAILED: 'Échecs',
    RELANCES_VIEW_CANCELLED: 'Annulées',
    RELANCES_COL_SUBJECT: 'Sujet',
    RELANCES_COL_REASON: 'Cascade',
    RELANCES_COL_TEMPLATE: 'Message',
    RELANCES_ACTION_VIEW: 'Voir',
    RELANCES_DETAIL_TITLE: 'Relance envoyée : {reason}',
    RELANCES_COL_CHANNEL: 'Canal',
    RELANCES_COL_SCHEDULED: 'Programmée',
    RELANCES_COL_ATTEMPTS: 'Tentatives',
    RELANCES_COL_STATUS: 'Statut',
    RELANCES_LATE_BADGE: 'En retard',
    RELANCES_CANCEL: 'Annuler',
    RELANCES_RETRY: 'Reprogrammer',
    RELANCES_EMPTY_UPCOMING: 'Aucune relance programmée.',
    RELANCES_EMPTY_LATE: 'Aucune relance en retard — le worker suit le rythme.',
    RELANCES_EMPTY_SENT: 'Aucune relance envoyée.',
    RELANCES_EMPTY_FAILED: 'Aucun échec d’envoi.',
    RELANCES_EMPTY_CANCELLED: 'Aucune relance annulée.',
    RELANCES_CANCEL_SUCCESS: 'Relance annulée.',
    RELANCES_RETRY_SUCCESS: 'Relance reprogrammée immédiatement.',
    RELANCES_LATE_HINT:
      'Ces relances ont dépassé leur échéance sans partir. Si le volume ne descend pas, le worker de relance est probablement arrêté.',
    RELANCES_ERROR: 'L’action a échoué.',

    // ── Escalades (conversation.pilot = HUMAN) ──────────────────────────────
    ESCALATIONS_TITLE: 'Escalades',
    ESCALATIONS_SUBTITLE: 'Conversations passées en pilotage humain — à reprendre, puis à rendre à Pulse.',
    ESCALATIONS_COL_SUBJECT: 'Sujet',
    ESCALATIONS_COL_STATE: 'État',
    ESCALATIONS_COL_PLAYBOOK: 'Playbook',
    ESCALATIONS_COL_LAST_MESSAGE: 'Dernier message',
    ESCALATIONS_COL_WAITING: 'En attente',
    ESCALATIONS_WAITING_MINUTES: '{minutes} min',
    ESCALATIONS_WAITING_HOURS: '{hours} h',
    ESCALATIONS_WAITING_DAYS: '{days} j',
    ESCALATIONS_WAITING_NONE: '—',
    ESCALATIONS_OPEN_LEAD: 'Ouvrir la conversation',
    ESCALATIONS_RELEASE: 'Rendre à Pulse',
    ESCALATIONS_RELEASE_SUCCESS: 'Conversation rendue à Pulse.',
    ESCALATIONS_EMPTY: 'Aucune conversation en pilotage humain.',
    ESCALATIONS_EMPTY_HINT: 'Une conversation arrive ici quand Pulse escalade ou qu’un admin prend la main.',
    ESCALATIONS_ERROR: 'L’action a échoué.',

    // ── Familles de la spine (timeline 360) ─────────────────────────────────
    LIFECYCLE_FAMILY_TRANSITION: 'Transition',
    LIFECYCLE_FAMILY_ACTION: 'Action',
    LIFECYCLE_FAMILY_SIGNAL: 'Signal',
    NAV_GROUP_PILOTAGE: 'Pilotage',
    NAV_GROUP_DAILY: 'Au quotidien',
    NAV_GROUP_CONTACTS: 'Contacts',
    NAV_GROUP_FOLLOW_UP: 'Accompagnement',
    NAV_GROUP_GROWTH: 'Offres & partenaires',
    NAV_GROUP_CONTENT: 'Contenu & produit',
    NAV_GROUP_SYSTEM: 'Système',
    NAV_GROUP_TOOLS: 'Outils',
    HEADER_LOGOUT: 'Se déconnecter',
    HEADER_OPEN_MENU: 'Ouvrir le menu',
    HEADER_ACCOUNT_MENU: 'Menu du compte',
    DASHBOARD_TITLE: 'Tableau de bord',
    DASHBOARD_SUBTITLE: 'Tout ce qui demande une action, d’un coup d’œil.',
    LEADS_TITLE: 'Leads',
    LEADS_SUBTITLE: 'Liste des leads et de leur état dans le parcours.',
    LEADS_EMPTY: 'Aucun lead pour le moment.',
    LEADS_FILTER_ALL_STATES: 'Tous les états',
    LEADS_COL_ID: 'ID',
    LEADS_COL_PRO: 'Pro',
    LEADS_COL_STATE: 'État',
    LEADS_COL_PLAYBOOK: 'Playbook',
    LEADS_COL_SOURCE: 'Source',
    LEADS_COL_LAST_CHANNEL: 'Canal',
    LEADS_COL_PHONE: 'Téléphone',
    LEADS_COL_PROJECT_DATE: 'Lancement visé',
    LEADS_COL_UPDATED: 'Mis à jour',
    LEADS_BADGE_ESCALATED: 'Escaladé',
    LEADS_BADGE_ESCALATED_HINT: 'Conversation en pilotage humain, à traiter depuis les escalades.',
    LEAD_DETAIL_BACK: 'Retour aux leads',
    LEAD_DETAIL_QUALIFICATION: 'Qualification',
    LEAD_DETAIL_QUALIFICATION_EMPTY: 'Aucune qualification renseignée.',
    LEAD_DETAIL_RESET_BUTTON: 'Réinitialiser le contexte',
    LEAD_DETAIL_RESET_HINT:
      'Vide la conversation, la qualification et les relances pour rejouer le parcours Pulse depuis ce numéro. L’attribution marketing est conservée.',
    LEAD_DETAIL_RESET_TITLE: 'Réinitialiser le contexte de ce lead ?',
    LEAD_DETAIL_RESET_CONFIRM:
      'La conversation en cours sera fermée (conservée pour l’audit), la qualification vidée et les relances annulées. L’attribution marketing est conservée.',
    LEAD_DETAIL_RESET_SUBMIT: 'Réinitialiser',
    LEAD_DETAIL_RESET_DONE: 'Contexte du lead remis à zéro.',
    LEAD_DETAIL_RESET_ERROR: 'La remise à zéro a échoué.',
    LEAD_DETAIL_CONVERSATION: 'Conversation',
    LEAD_DETAIL_CONVERSATION_EMPTY: 'Aucun message dans cette conversation.',
    LEAD_DETAIL_CONVERSATION_LOAD_OLDER: 'Voir les messages précédents',
    LEAD_DETAIL_CONVERSATION_LOADING_OLDER: 'Chargement…',
    LEAD_DETAIL_TOOL_CALLS: 'Outils appelés',
    LEAD_DETAIL_ATTACHMENT_IMAGE: 'Image jointe',
    LEAD_DETAIL_ATTACHMENT_TRANSCRIPT: 'Transcription / description',
    LEAD_DETAIL_ATTACHMENT_UNAVAILABLE: 'Média indisponible',
    LEAD_DETAIL_PRO_NAME: 'Pro lié',
    LEAD_DETAIL_NO_PRO: 'Pas encore de pro associé',
    LEAD_DETAIL_CHANNEL_LAST_SEEN: 'Dernier canal utilisé',
    LEAD_DETAIL_PHONE: 'Téléphone',
    LEAD_DETAIL_EMAIL: 'Email',
    LEAD_DETAIL_CREATED_AT: 'Créé le',
    LEAD_DETAIL_UPDATED_AT: 'Mis à jour le',
    LEAD_DETAIL_SOURCE: 'Source',
    LEAD_DETAIL_ATTRIBUTION: 'Attribution marketing',
    LEAD_DETAIL_ATTRIBUTION_EMPTY: "Aucune donnée d'attribution (visite directe, ou lead antérieur au tracking).",
    LEAD_DETAIL_ATTR_CHANNEL: "Canal d'origine",
    LEAD_DETAIL_ATTR_UTM_SOURCE: 'Source (utm_source)',
    LEAD_DETAIL_ATTR_UTM_MEDIUM: 'Support (utm_medium)',
    LEAD_DETAIL_ATTR_UTM_CAMPAIGN: 'Campagne (utm_campaign)',
    LEAD_DETAIL_ATTR_UTM_CONTENT: 'Contenu (utm_content)',
    LEAD_DETAIL_ATTR_UTM_TERM: 'Terme (utm_term)',
    LEAD_DETAIL_ATTR_REFERRER: 'Referrer',
    LEAD_DETAIL_ATTR_LANDING_PAGE: "Page d'arrivée",
    LEAD_DETAIL_ATTR_GCLID: 'Clic Google Ads (gclid)',
    LEAD_DETAIL_ATTR_FBCLID: 'Clic Meta Ads (fbclid)',
    LEAD_DETAIL_ATTR_CTWA_SOURCE: 'Pub click-to-WhatsApp',
    LEAD_DETAIL_ATTR_CONSENT: 'Consentement marketing',
    LEADS_COL_CONTACT: 'Contact',
    LEAD_DETAIL_FIRSTNAME: 'Prénom',
    LEAD_DETAIL_LASTNAME: 'Nom',
    LEAD_DETAIL_EDIT_BUTTON: 'Modifier la fiche',
    LEAD_DETAIL_EDIT_TITLE: 'Modifier la fiche du lead',
    LEAD_DETAIL_EDIT_HINT:
      'Prénom, nom, email et téléphone de la personne. Un champ vidé est effacé ; le téléphone est enregistré au format international.',
    LEAD_DETAIL_EDIT_PRO_HINT: 'Ce lead a un compte pro : ces champs ne modifient que la fiche lead, pas le compte.',
    LEAD_DETAIL_EDIT_SUBMIT: 'Enregistrer',
    LEAD_DETAIL_EDIT_DONE: 'Fiche du lead mise à jour.',
    LEAD_DETAIL_EDIT_ERROR: 'La modification a échoué.',
    PAGINATION_PAGE: 'Page {page}',
    PAGINATION_PREV: 'Précédent',
    PAGINATION_NEXT: 'Suivant',
    PAGINATION_ROWS: '{total} résultats',
    // --- Migration v1→v2 : pilotage du redirect legacy par pro ---
    MIGRATION_REDIRECT_TITLE: 'Redirections v1 → v2',
    MIGRATION_REDIRECT_SUBTITLE:
      'Active ou désactive, par pro migré, la redirection des anciennes URLs Cfixe vers Propelsia.',
    MIGRATION_REDIRECT_SEARCH_PLACEHOLDER: 'Rechercher un pro (nom, slug)…',
    MIGRATION_REDIRECT_LOADING: 'Chargement…',
    MIGRATION_REDIRECT_EMPTY: 'Aucun professionnel migré pour le moment.',
    MIGRATION_REDIRECT_COL_PRO: 'Professionnel',
    MIGRATION_REDIRECT_COL_MIGRATED_AT: 'Migré (beta) le',
    MIGRATION_REDIRECT_COL_DOMAIN: 'Domaine perso',
    MIGRATION_REDIRECT_COL_REDIRECT: 'Redirection',
    MIGRATION_REDIRECT_ACTIVE: 'Active',
    MIGRATION_REDIRECT_INACTIVE: 'Inactive',
    MIGRATION_REDIRECT_ENABLE: 'Activer',
    MIGRATION_REDIRECT_DISABLE: 'Désactiver',
    MIGRATION_REDIRECT_NO_DOMAIN: 'Aucun',
    MIGRATION_REDIRECT_DOMAIN_ONLINE: 'En ligne (HTTPS)',
    MIGRATION_REDIRECT_CONFIRM_DISABLE:
      'Désactiver la redirection de ce pro ? Ses anciennes URLs Cfixe ne pointeront plus vers Propelsia.',
    // --- Bascule finale v1→v2 (page migration-cutover) ---
    MIGRATION_CUTOVER_TITLE: 'Bascule finale v1→v2',
    MIGRATION_BASCULE_TITLE: 'Bascules programmées',
    MIGRATION_BASCULE_SUBTITLE:
      'Demandes de bascule Cfixé → Propelsia saisies par les pros. La donnée vient de la base v1.',
    MIGRATION_BASCULE_FILTER_ALL: 'Tous les statuts',
    MIGRATION_BASCULE_COL_DATE: 'Date de bascule',
    MIGRATION_BASCULE_COL_ESTABLISHMENT: 'Établissement',
    MIGRATION_BASCULE_COL_PRO: 'Compte',
    MIGRATION_BASCULE_COL_CONTACT: 'Contact',
    MIGRATION_BASCULE_COL_STATUS: 'Statut',
    MIGRATION_BASCULE_COL_CONSENTS: 'Consentements',
    MIGRATION_BASCULE_COL_MESSAGE: 'Commentaire',
    MIGRATION_BASCULE_NO_MESSAGE: '—',
    MIGRATION_BASCULE_COL_ACTION: 'Action',
    MIGRATION_BASCULE_EMPTY: 'Aucune bascule programmée pour le moment.',
    MIGRATION_BASCULE_VALIDATE: 'Valider la bascule',
    MIGRATION_BASCULE_VALIDATE_CONFIRM: 'Confirmer ?',
    MIGRATION_BASCULE_VALIDATE_CANCEL: 'Annuler',
    MIGRATION_BASCULE_VALIDATED:
      "Bascule validée. Envoyez l'email de fin au pro quand le domaine répond (« Envoyer l'email de fin »).",
    MIGRATION_BASCULE_SEND_EMAIL: "Envoyer l'email de fin",
    MIGRATION_BASCULE_RESEND_EMAIL: "Renvoyer l'email de fin",
    MIGRATION_BASCULE_SEND_EMAIL_CONFIRM: 'Envoyer ?',
    MIGRATION_BASCULE_EMAIL_SENT_AT: 'Envoyé le {date}',
    MIGRATION_BASCULE_EMAIL_NOT_SENT: 'Email de fin non envoyé',
    MIGRATION_BASCULE_NO_LOGIN: 'Aucun compte Propelsia',
    MIGRATION_BASCULE_SENT_WITH_EMAIL: "L'email de fin de bascule est en cours d'envoi au pro.",
    MIGRATION_BASCULE_SENT_NO_EMAIL: "L'email n'a pas pu être mis en file (adresse manquante ?).",
    MIGRATION_BASCULE_ERROR: "L'action a échoué, la liste a été rafraîchie.",
    MIGRATION_CUTOVER_SUBTITLE:
      'Wipe + réimport frais depuis Cfixé pour un pro beta-migré, par bloc. À la clôture, Propelsia devient maître : activez ensuite le redirect depuis la page Redirections.',
    MIGRATION_CUTOVER_SELECT_PRO: 'Professionnel beta-migré',
    MIGRATION_CUTOVER_SEARCH_PLACEHOLDER: 'Rechercher un pro (nom, slug)…',
    MIGRATION_CUTOVER_EMPTY: 'Aucun professionnel beta-migré.',
    MIGRATION_CUTOVER_COMPLETED_BADGE: 'Bascule clôturée',
    MIGRATION_CUTOVER_REDIRECT_ACTIVE_BADGE: 'Redirect ACTIF',
    MIGRATION_CUTOVER_BLOCKS_TITLE: 'Éléments à migrer',
    MIGRATION_CUTOVER_BLOCKS_SUBTITLE:
      "Tout est coché par défaut : décochez selon les réponses du formulaire de consentement. L'abonnement n'est PAS dans cette liste (page « Migration abo »).",
    MIGRATION_CUTOVER_BLOCK_PROFILE: 'Profil + équipe',
    MIGRATION_CUTOVER_BLOCK_WEBSITE: 'Site vitrine',
    MIGRATION_CUTOVER_BLOCK_CATALOG: 'Catalogue (prestations, prix, lieux)',
    MIGRATION_CUTOVER_BLOCK_CUSTOMERS: 'Clients + tags',
    MIGRATION_CUTOVER_BLOCK_APPOINTMENTS: 'RDV historiques',
    MIGRATION_CUTOVER_BLOCK_GIFT_CARDS_PAYMENTS: 'Cartes cadeau + paiements clients',
    MIGRATION_CUTOVER_BLOCK_MARKETING: 'Campagnes + actualités',
    MIGRATION_CUTOVER_DEP_CASCADE: 'Le décocher retirera aussi : {blocks}',
    MIGRATION_CUTOVER_KEEP_CONTENT:
      'Le pro a créé du contenu réel dans Propelsia à conserver (mode arbitrage : pas de wipe automatique)',
    MIGRATION_CUTOVER_REGENERATE_WEBSITE_LABEL: 'Régénérer le site vitrine depuis Cfixé',
    MIGRATION_CUTOVER_REGENERATE_WEBSITE_WARNING: `⚠️ Décoché par défaut : on PRÉSERVE le site que le pro a personnalisé dans ${PROJECT_CONFIG.brand_string} pendant la beta (pages, couleurs, contenu). Ne cochez que si le pro n'a pas retouché son site, sinon son travail sera écrasé par le site reconstruit depuis Cfixé.`,
    MIGRATION_CUTOVER_WIPE_WARNING:
      'Les données Propelsia des blocs cochés seront EFFACÉES puis réimportées depuis Cfixé (état du jour).',
    MIGRATION_CUTOVER_ARBITRAGE_WARNING:
      'Mode arbitrage : import SANS effacement préalable, avec risque de doublons à traiter manuellement bloc par bloc.',
    MIGRATION_CUTOVER_REDIRECT_ACTIVE_BLOCKED:
      'Le redirect legacy est actif pour ce pro : désactivez-le avant toute bascule.',
    MIGRATION_CUTOVER_TRACKING_BADGE: 'Tracking v1',
    MIGRATION_CUTOVER_TRACKING_TITLE: '⚠️ Tracking Cfixé codé en dur, à reporter à la main',
    MIGRATION_CUTOVER_TRACKING_BODY:
      'La migration ne transfère AUCUN pixel ni script : à recréer après la bascule dans Site web → Paramètres (ID Google + Pixel Meta), et en scripts personnalisés (plan MAX) pour le reste.',
    MIGRATION_CUTOVER_TRACKING_CONVERSIONS: 'Conversions : {labels}',
    MIGRATION_CUTOVER_TRACKING_EVENTS:
      'Déclencheurs v1 : {events}. Ils n’existent plus, à réécrire sur l’événement site:event (ou sur le dataLayer du site).',
    MIGRATION_CUTOVER_TRACKING_DOC: 'Détail complet : docs/reference/migration-v1-tracking-inventory.md',
    MIGRATION_CUTOVER_EXECUTE: 'Exécuter la bascule',
    MIGRATION_CUTOVER_CONFIRM:
      'Confirmer la bascule finale ? Les données Propelsia des blocs cochés seront définitivement remplacées par les données Cfixé.',
    MIGRATION_CUTOVER_CONFIRM_ARBITRAGE: 'Confirmer l’import SANS wipe (mode arbitrage) ?',
    MIGRATION_CUTOVER_RUN_PENDING: 'Démarrage de l’import… (récupération du statut du run en cours)',
    MIGRATION_CUTOVER_RUN_TITLE: 'Import en cours',
    MIGRATION_CUTOVER_RUN_DONE: 'Import terminé',
    MIGRATION_CUTOVER_STATE_QUEUED: 'En attente',
    MIGRATION_CUTOVER_STATE_RUNNING: 'En cours…',
    MIGRATION_CUTOVER_STATE_DONE: 'Terminé',
    MIGRATION_CUTOVER_STATE_ERROR: 'Erreur',
    MIGRATION_CUTOVER_STATE_SKIPPED: 'Non sélectionné',
    MIGRATION_CUTOVER_IMPORTED_COUNT: '{count, plural, one {# élément} other {# éléments}}',
    MIGRATION_CUTOVER_COMPLETE_CTA: 'Clôturer la bascule (Propelsia devient maître)',
    MIGRATION_CUTOVER_COMPLETE_CONFIRM:
      'Clôturer la bascule ? Le pro ne pourra plus relancer d’import self-serve. Activez ensuite le redirect.',
    MIGRATION_CUTOVER_COMPLETE_WITHOUT_RUN:
      'Aucun réimport n’est nécessaire si le pro a déjà tout préparé pendant la beta : la clôture publie le site, détecte les domaines perso Cfixé et repointe leur DNS, puis reprend « Réserver avec Google ».',
    MIGRATION_CUTOVER_COMPLETED_AT: 'Clôturée le {date}',
    MIGRATION_CUTOVER_GO_REDIRECT: 'Ouvrir la page Redirections',
    MIGRATION_CUTOVER_WEBSITE_PUBLISHED: 'Site Propelsia publié',
    MIGRATION_CUTOVER_WEBSITE_PUBLISH_SKIPPED: 'Publication du site sautée ({reason})',
    MIGRATION_CUTOVER_DOMAINS_TITLE: 'Domaines v1 détectés et migrés',
    MIGRATION_CUTOVER_DOMAINS_NONE: 'Aucun domaine perso détecté côté Cfixé (site sur cfixe.pro).',
    MIGRATION_CUTOVER_DOMAINS_SKIPPED:
      'Détection des domaines NON exécutée (site non publié) : vérifier les domaines v1 du pro et les migrer via la page Migration abonnement.',
    MIGRATION_CUTOVER_DOMAIN_CREATED: 'Migré (DNS repointé, activation en cours)',
    MIGRATION_CUTOVER_DOMAIN_EXISTING: 'Déjà migré',
    MIGRATION_CUTOVER_DOMAIN_PRIMARY: 'principal',
    MIGRATION_CUTOVER_DOMAINS_BILLING_NOTE:
      'Facturation du renouvellement + annulation Stripe v1 à attacher via la page Migration abonnement.',
    MIGRATION_CUTOVER_GOOGLE_RESERVE_TITLE: 'Réserver avec Google',
    MIGRATION_CUTOVER_GOOGLE_RESERVE_CARRIED: 'Repris du feed v1 : demande approuvée automatiquement côté Propelsia.',
    MIGRATION_CUTOVER_GOOGLE_RESERVE_NO_PLACE:
      'Approuvé, mais AUCUN lieu activé (le pro n’a pas d’établissement) : le feed n’inclura rien tant qu’un lieu n’est pas opt-in.',
    MIGRATION_CUTOVER_GOOGLE_RESERVE_NOT_IN_V1_FEED: 'Pro absent du feed v1 : rien à reprendre.',
    MIGRATION_CUTOVER_GOOGLE_RESERVE_STATUS_REJECTED:
      'Non repris : la demande est REFUSÉE côté Propelsia (décision admin conservée).',
    MIGRATION_CUTOVER_GOOGLE_RESERVE_STATUS_DISABLED:
      'Non repris : « Réserver avec Google » est désactivé côté Propelsia (choix du pro conservé).',
    MIGRATION_CUTOVER_GOOGLE_RESERVE_CARRY_FAILED:
      'ÉCHEC de la reprise (v1 injoignable) : le pro sortira du feed Google au prochain run. Approuver la demande à la main via la page Réserver avec Google.',
    MIGRATION_CUTOVER_DELETED_ROWS: '{count} lignes effacées',
    MIGRATION_CUTOVER_ERROR: 'Échec de la bascule. Vérifiez le statut du pro et réessayez.',
    MIGRATION_CREATE_FROM_V1_TITLE: 'Créer + migrer depuis Cfixé v1',
    MIGRATION_CREATE_FROM_V1_SUBTITLE:
      'Crée le compte Propelsia à partir du profil v1 puis lance l’import complet. Le pro est marqué migré dès la création : aucun email de bienvenue, aucune relance d’essai. Essai de {days} jours. La bascule finale reste à faire depuis cet écran.',
    MIGRATION_CREATE_FROM_V1_ID_LABEL: 'Id du pro côté v1',
    MIGRATION_CREATE_FROM_V1_EMAIL_LABEL: 'Email de connexion (facultatif)',
    MIGRATION_CREATE_FROM_V1_EMAIL_HINT:
      'Par défaut, l’email du profil v1. À renseigner seulement s’il est déjà utilisé sur Propelsia.',
    MIGRATION_CREATE_FROM_V1_BUTTON: 'Créer le compte et lancer l’import',
    MIGRATION_CREATE_FROM_V1_CONFIRM: 'Créer le compte Propelsia depuis le pro v1 #{id} et lancer l’import complet ?',
    MIGRATION_CREATE_FROM_V1_SUCCESS: 'Compte « {name} » créé ({email}), import lancé.',
    MIGRATION_CREATE_FROM_V1_ERROR: 'Création impossible. Vérifiez l’id v1 et que l’email n’est pas déjà utilisé.',
    SIDEBAR_MIGRATION_CUTOVER: 'Bascule finale v1→v2',
    SIDEBAR_MIGRATION_BASCULE: 'Bascules programmées',
    // --- Migration des boîtes mail OVH (Exchange / Email Pro) → Stalwart ---
    MAILMIG_TITLE: 'Migration mail OVH',
    MAILMIG_SUBTITLE:
      'Rapatriement des boîtes OVH (Exchange / Email Pro) vers la messagerie Propelsia : un domaine = une soirée, DNS basculé avant la copie, rien n’est supprimé automatiquement.',
    MAILMIG_READ_ONLY_HINT:
      'Vous voyez le récap (qui, quand, où ça en est). Les actions sont réservées aux administrateurs Propelsia.',
    MAILMIG_INVENTORY: 'Rafraîchir l’inventaire OVH',
    MAILMIG_INVENTORY_DONE: 'Inventaire OVH lancé (quelques minutes).',
    MAILMIG_INVENTORY_ERROR: 'Impossible de lancer l’inventaire.',
    MAILMIG_FILTER_ALL_STATES: 'Tous les statuts',
    MAILMIG_FILTER_ALL_OFFERS: 'Toutes les offres',
    MAILMIG_SEARCH_PLACEHOLDER: 'Rechercher un domaine ou un client…',
    MAILMIG_EMPTY: 'Aucun domaine candidat. Lancez l’inventaire OVH.',
    MAILMIG_COL_DOMAIN: 'Domaine',
    MAILMIG_COL_PRO: 'Client',
    MAILMIG_COL_OFFER: 'Offre OVH',
    MAILMIG_COL_MAILBOXES: 'Boîtes',
    MAILMIG_COL_CHECKS: 'Prérequis',
    MAILMIG_COL_SCHEDULED: 'Date prévue',
    MAILMIG_COL_STATUS: 'Statut',
    MAILMIG_COL_UPDATED: 'MAJ',
    MAILMIG_MAILBOXES_COUNT: '{count} boîte(s)',
    MAILMIG_CHECKS_OK: 'OK',
    MAILMIG_CHECKS_BLOCKING: '{count} bloquant(s)',
    MAILMIG_CHECKS_WARNINGS: '{count} avertissement(s)',
    MAILMIG_CHECKS_NOT_RUN: 'Non vérifiés',
    MAILMIG_STAT_CANDIDATES: 'Candidats',
    MAILMIG_STAT_SCHEDULED: 'Planifiés',
    MAILMIG_STAT_READY: 'Prêts',
    MAILMIG_STAT_BLOCKED: 'Bloqués',
    MAILMIG_STAT_IN_PROGRESS: 'En cours',
    MAILMIG_STAT_DONE: 'Terminés',
    MAILMIG_STAT_ERROR: 'En erreur',
    // Fiche
    MAILMIG_DETAIL_OVH: 'Service OVH',
    MAILMIG_DETAIL_IMAP_HOST: 'Serveur IMAP OVH',
    MAILMIG_DETAIL_SCHEDULED: 'Bascule prévue',
    MAILMIG_DETAIL_NOTE: 'Note de pilotage',
    MAILMIG_DETAIL_NOTE_PLACEHOLDER: 'Ex. pro prévenu le 12/11, vidéo envoyée…',
    MAILMIG_DETAIL_STARTED: 'Lancée le',
    MAILMIG_DETAIL_FINISHED: 'Terminée le',
    MAILMIG_DETAIL_ROLLED_BACK: 'Annulée le',
    MAILMIG_DETAIL_INVENTORY_AT: 'Inventaire du',
    MAILMIG_DETAIL_MAIL_DOMAIN: 'Domaine mail Propelsia',
    MAILMIG_DETAIL_LAST_ERROR: 'Dernière erreur',
    MAILMIG_CHECKS_TITLE: 'Prérequis (tous verts pour migrer)',
    MAILMIG_CHECKS_EMPTY: 'Pas encore vérifiés : cliquez sur « Préparer ».',
    MAILMIG_WARNINGS_TITLE: 'Avertissements (à dire au pro, jamais bloquants)',
    MAILMIG_MAILBOXES_TITLE: 'Boîtes',
    MAILMIG_MAILBOX_COPIED: '{copied} / {source} messages',
    MAILMIG_MAILBOX_LAST_SYNC: 'Dernière recopie : {date}',
    MAILMIG_MAILBOX_ALIASES: 'Alias : {aliases}',
    MAILMIG_LOG_TITLE: 'Journal de la copie',
    MAILMIG_DNS_TITLE: 'DNS : zone actuelle → cible',
    MAILMIG_DNS_CURRENT: 'Slots mail dans la zone OVH aujourd’hui',
    MAILMIG_DNS_PLAN: 'Records que la bascule posera (+ DKIM lu chez Stalwart)',
    MAILMIG_DNS_SNAPSHOT_TAKEN: 'Instantané DNS pris : retour arrière possible tant que les comptes OVH existent.',
    MAILMIG_DNS_SNAPSHOT_MISSING: 'Instantané DNS pris au lancement de la bascule.',
    MAILMIG_CSM_TODO_TITLE: 'À faire côté CSM',
    MAILMIG_CSM_TODO_BEFORE:
      'Avant J : prévenir le pro (date, nouveau serveur, vidéo), lui faire ajouter une adresse de récupération, lui faire exporter contacts et agendas.',
    MAILMIG_CSM_TODO_AFTER:
      'Après J : le pro régénère son mot de passe dans Site → Domaine et emails, puis reconfigure ses clients (imap.propelsia.ai:993 / smtp.propelsia.ai:465).',
    // Actions
    MAILMIG_ACTION_SCHEDULE: 'Planifier',
    MAILMIG_ACTION_SCHEDULE_DONE: 'Planification enregistrée.',
    MAILMIG_ACTION_CANCEL_EDIT: 'Annuler',
    MAILMIG_ACTION_PREPARE: 'Préparer',
    MAILMIG_ACTION_PREPARE_DONE: 'Prérequis vérifiés.',
    MAILMIG_ACTION_LAUNCH: 'Migrer',
    MAILMIG_ACTION_LAUNCH_CONFIRM:
      'Lancer la bascule de {domain} maintenant ? Les mots de passe OVH seront réinitialisés et le DNS basculé dans les minutes qui suivent.',
    MAILMIG_ACTION_LAUNCH_DONE: 'Bascule lancée.',
    MAILMIG_ACTION_RETRY: 'Réessayer',
    MAILMIG_ACTION_RETRY_DONE: 'Reprise lancée.',
    MAILMIG_ACTION_RESYNC: 'Resynchroniser',
    MAILMIG_ACTION_RESYNC_DONE: 'Recopie demandée.',
    MAILMIG_ACTION_FINALIZE: 'Finaliser',
    MAILMIG_ACTION_FINALIZE_CONFIRM: 'Passer {domain} en « Terminé » sans attendre la recopie finale ?',
    MAILMIG_ACTION_FINALIZE_DONE: 'Migration finalisée.',
    MAILMIG_ACTION_ROLLBACK: 'Annuler la migration',
    MAILMIG_ACTION_ROLLBACK_CONFIRM:
      'Annuler la migration de {domain} ? Le DNS d’origine sera reposé, le courrier arrivé chez nous recopié vers OVH et un nouveau mot de passe OVH posé (à transmettre au pro). Non couvert : les clients déjà reconfigurés en IMAP, les contacts/agendas créés chez nous.',
    MAILMIG_ACTION_ROLLBACK_DONE: 'Retour arrière lancé.',
    MAILMIG_ACTION_ROLLBACK_PASSWORD: 'Révéler le mot de passe OVH de remise',
    MAILMIG_ROLLBACK_PASSWORD_HINT:
      'Nouveau mot de passe des boîtes OVH, affiché une seule fois : transmettez-le au pro puis fermez cette fenêtre.',
    MAILMIG_ACTION_ERROR: 'Action impossible.',
    // --- Domaines : supervision de l'activation ---
    DOMAINS_TITLE: 'Domaines',
    DOMAINS_SUBTITLE: "Suivi de l'activation des domaines custom (achat/transfert → DNS → mise en ligne HTTPS).",
    DOMAINS_FILTER_ALL_STATES: 'Tous les statuts',
    DOMAINS_SEARCH_PLACEHOLDER: 'Rechercher un domaine ou un client…',
    DOMAINS_EMPTY: 'Aucun domaine.',
    DOMAINS_COL_DOMAIN: 'Domaine',
    DOMAINS_COL_PRO: 'Client',
    DOMAINS_COL_TYPE: 'Type',
    DOMAINS_COL_STATUS: 'Statut',
    DOMAINS_COL_EMAIL: 'Email',
    DOMAINS_COL_CREATED: 'Créé le',
    DOMAINS_COL_UPDATED: 'MAJ',
    DOMAINS_TYPE_PRIMARY: 'Principal',
    DOMAINS_TYPE_SECONDARY: 'Redirection',
    DOMAINS_STAT_TOTAL: 'Total',
    DOMAINS_STAT_ONLINE: 'En ligne',
    DOMAINS_STAT_IN_PROGRESS: 'En cours',
    DOMAINS_STAT_FAILED: 'Échecs',
    DOMAINS_STAT_MANUAL: 'Action requise',
    DOMAINS_STAT_MAILBOXES: 'Boîtes email',
    DOMAINS_EMAIL_NONE: 'Non activé',
    DOMAINS_EMAIL_MAILBOXES: '{count, plural, =0 {Aucune boîte} one {# boîte} other {# boîtes}}',
    DOMAINS_EMAIL_MAILBOXES_ACTIVE: '{active}/{total} active(s)',
    DOMAINS_DETAIL_ORDER_ID: 'N° commande provider',
    DOMAINS_DETAIL_AUTH_CODE: "Code d'autorisation",
    DOMAINS_DETAIL_K8S: 'Ressources k8s',
    DOMAINS_DETAIL_CERT_READY: 'Certificat prêt',
    DOMAINS_DETAIL_MAIL_SECTION: 'Hébergement email',
    DOMAINS_DETAIL_MAIL_STATUS: 'Statut du domaine mail',
    DOMAINS_DETAIL_MAIL_VERIFIED_AT: 'DNS mail vérifié le',
    DOMAINS_DETAIL_MAIL_ERROR: 'Dernière erreur',
    DOMAINS_DETAIL_MAIL_NONE: 'Aucun hébergement email sur ce domaine.',
    DOMAINS_DETAIL_MAILBOXES_EMPTY: 'Domaine provisionné, mais aucune boîte créée.',
    DOMAINS_YES: 'Oui',
    DOMAINS_NO: 'Non',
    // Enrôlement chez les moteurs de recherche (GSC / Bing), plan Bing D8.
    DOMAINS_COL_GSC: 'Search Console',
    DOMAINS_COL_BING: 'Bing',
    DOMAINS_FILTER_SEARCH_ENGINE_ALL: 'Moteurs : tous',
    DOMAINS_FILTER_SEARCH_ENGINE_MISSING: 'Moteur manquant',
    DOMAINS_STAT_GSC_VERIFIED: 'GSC vérifiés',
    DOMAINS_STAT_BING_VERIFIED: 'Bing vérifiés',
    DOMAINS_STAT_SEARCH_ENGINE_MISSING: 'Moteur manquant',
    DOMAINS_DETAIL_SEARCH_ENGINES_SECTION: 'Moteurs de recherche',
    DOMAINS_DETAIL_SEARCH_ENGINE_VERIFIED_AT: 'Vérifié le',
    DOMAINS_DETAIL_SEARCH_ENGINE_CHECKED_AT: 'Dernier contrôle',
    DOMAINS_DETAIL_SEARCH_ENGINE_ATTEMPTS: '{count, plural, one {# tentative} other {# tentatives}}',
    DOMAINS_DETAIL_SEARCH_ENGINE_ERROR: 'Dernière erreur',
    DOMAINS_DETAIL_SEARCH_ENGINE_SECONDARY: 'Domaine de redirection : jamais déclaré aux moteurs.',
    DOMAINS_SEARCH_ENGINES_RETRY: 'Réessayer les moteurs',
    DOMAINS_SEARCH_ENGINES_RETRY_DONE: 'Relance de l’enrôlement GSC + Bing mise en file (worker).',
    DOMAINS_DELETE: 'Supprimer le domaine',
    DOMAINS_DELETE_CONFIRM:
      'Retirer « {domain} » du site ? Son renouvellement est coupé (rien n’est touché chez OVH). Si c’est le domaine principal, un autre domaine prend le relais, sinon le site revient sur son sous-domaine.',
    DOMAINS_DELETED: 'Domaine supprimé.',
    DOMAINS_DELETE_ERROR: 'La suppression du domaine a échoué.',
    // --- Clients (professionnels) : liste / détail / édition ---
    PROS_TITLE: 'Clients',
    PROS_SUBTITLE: 'Professionnels, abonnements et segments de facturation.',
    PROS_EMPTY: 'Aucun client pour le moment.',
    PROS_SEARCH_PLACEHOLDER: 'Nom ou email…',
    PROS_SEARCH_SUBMIT: 'Rechercher',
    PROS_FILTER_ALL_PLANS: 'Tous les plans',
    PROS_FILTER_ALL_STATES: 'Tous les états',
    PROS_COL_ID: 'ID',
    PROS_COL_NAME: 'Nom',
    PROS_COL_EMAIL: 'Email',
    PROS_COL_PLAN: 'Plan',
    PROS_COL_ACCESS_STATE: 'État',
    PROS_COL_VAT_REGIME: 'Régime TVA',
    PROS_FILTER_VAT_REVIEW: 'TVA à arbitrer',
    PROS_COL_TRIAL_END: 'Fin d’essai',
    PROS_COL_CREATED: 'Créé le',
    PRO_DETAIL_BACK: 'Retour aux clients',
    PRO_DETAIL_IDENTITY: 'Identité',
    PRO_DETAIL_EMAIL: 'Email',
    PRO_DETAIL_LEGAL_NAME: 'Raison sociale',
    PRO_DETAIL_LOCALE: 'Langue',
    PRO_DETAIL_TIMEZONE: 'Fuseau horaire',
    PRO_DETAIL_CURRENCY: 'Devise',
    PRO_DETAIL_STRIPE_CUSTOMER: 'ID client Stripe',
    PRO_DETAIL_STRIPE_CONNECT: 'ID compte Stripe Connect',
    PRO_DETAIL_PENNYLANE_CUSTOMER: 'ID client Pennylane',
    PRO_DETAIL_TRIAL: 'Période d’essai',
    PRO_DETAIL_ACCESS_STATE: 'État d’accès',
    PRO_DETAIL_TRIAL_STARTED: 'Essai démarré le',
    PRO_DETAIL_TRIAL_END: 'Fin d’essai',
    PRO_DETAIL_SUBSCRIPTION: 'Abonnement',
    PRO_DETAIL_NO_SUBSCRIPTION: 'Aucun abonnement payant (le client est encore en essai).',
    PRO_DETAIL_PLAN: 'Plan',
    PRO_DETAIL_SUB_STATUS: 'Statut',
    PRO_DETAIL_SUB_SIZE: 'Taille',
    PRO_DETAIL_SUB_COMMITMENT: 'Engagement',
    PRO_DETAIL_SUB_BILLING_PERIOD: 'Période de facturation',
    PRO_DETAIL_SUB_AMOUNT: 'Montant',
    PRO_DETAIL_SUB_NEXT_RENEWAL: 'Prochain renouvellement',
    PRO_DETAIL_SUB_COMMITMENT_END: 'Fin d’engagement',
    PRO_DETAIL_SUB_END: 'Fin d’abonnement',
    PRO_DETAIL_QUOTA: 'Quotas',
    PRO_DETAIL_NO_QUOTA: 'Aucun quota initialisé.',
    PRO_DETAIL_QUOTA_EMAIL: 'Emails restants (mensuel)',
    PRO_DETAIL_QUOTA_SMS: 'SMS restants (mensuel)',
    PRO_DETAIL_QUOTA_CREDIT_EMAIL: 'Crédits email',
    PRO_DETAIL_QUOTA_CREDIT_SMS: 'Crédits SMS',
    PRO_DETAIL_QUOTA_RESET: 'Réinitialisation du cycle',
    PRO_DETAIL_SEGMENTS: 'Segments de facturation',
    PRO_DETAIL_SEGMENTS_EMPTY: 'Aucun segment de facturation.',
    PRO_SEGMENT_COL_PERIOD: 'Période',
    PRO_SEGMENT_COL_TYPE: 'Type',
    PRO_SEGMENT_COL_AMOUNT: 'Montant',
    PRO_SEGMENT_COL_DISCOUNT: 'Remise',
    PRO_SEGMENT_COL_STATUS: 'Statut',
    PRO_SEGMENT_TYPE_TRIAL: 'Essai',
    PRO_SEGMENT_TYPE_PAID: 'Payant',
    PRO_SEGMENT_TYPE_PRORATA: 'Prorata',
    PRO_SEGMENT_PRORATA_PLAN: 'Prorata abonnement',
    PRO_SEGMENT_PRORATA_ADDON: 'Prorata option',
    PRO_SEGMENT_STATUS_BILLED: 'Facturé',
    PRO_SEGMENT_STATUS_EDITABLE: 'Éditable',
    PRO_SEGMENT_STATUS_PENDING: 'En attente',
    PRO_SEGMENT_STATUS_FAILED: 'Échec',
    // Édition date d'essai (override DB god-mode)
    PRO_TRIAL_EDIT: 'Modifier',
    PRO_TRIAL_EDIT_TITLE: 'Modifier la fin d’essai',
    PRO_TRIAL_EDIT_DESC: 'Override direct de la date de fin d’essai. Pilote l’état d’accès du compte (gel / dégel).',
    PRO_TRIAL_EDIT_SUB_NOTE:
      'Ce client a un abonnement : si un segment d’essai existe, les segments suivants seront recalculés en conséquence.',
    PRO_TRIAL_REQUIRED: 'Choisissez une date.',
    PRO_TRIAL_CLEAR: 'Retirer l’essai',
    PRO_TRIAL_BILLED_ERROR:
      'Impossible : décaler l’essai recomposerait un segment déjà facturé. L’historique facturé est en lecture seule.',
    PRO_RESET_TRIAL: 'Remettre en essai',
    PRO_RESET_TRIAL_TITLE: 'Remettre ce pro en essai',
    PRO_RESET_TRIAL_DESC:
      'Outil de test : supprime l’abonnement, les segments et l’historique de facturation, puis recrée un essai neuf. Le pro garde son accès ACTIVE jusqu’au prochain refresh du token (≤ 1 min hors prod).',
    PRO_RESET_TRIAL_DAYS: 'Durée de l’essai (jours)',
    PRO_RESET_TRIAL_WARNING: '⚠️ Ce pro a un abonnement actif : il sera supprimé.',
    PRO_RESET_TRIAL_CONFIRM: 'Remettre en essai',
    PRO_RESET_TRIAL_CANCEL: 'Annuler',
    // Régénération des segments via le scheduler
    PRO_SEGMENT_REGEN: 'Régénérer les segments',
    PRO_SEGMENT_REGEN_TITLE: 'Régénérer les segments futurs',
    PRO_SEGMENT_REGEN_DESC:
      'Recompose les segments à partir d’une date via le planificateur (plan, addons et promos courants). Les segments déjà facturés sont préservés.',
    PRO_SEGMENT_REGEN_WARNING:
      'Action support : les montants sont recalculés depuis le catalogue. Pas de synchronisation Stripe immédiate : les prélèvements suivront les nouvelles dates au prochain passage du cron.',
    PRO_SEGMENT_REGEN_FROM: 'Régénérer à partir du',
    PRO_SEGMENT_REGEN_TRIAL_DAYS: 'Jours d’essai à appliquer (optionnel)',
    PRO_SEGMENT_REGEN_TRIAL_DAYS_PLACEHOLDER: 'ex. 7',
    PRO_SEGMENT_REGEN_CONFIRM: 'Régénérer',
    PRO_SEGMENT_REGEN_BILLED_ERROR:
      'La date choisie précède un segment déjà facturé : l’historique facturé est en lecture seule.',
    // Override d'abonnement (god-mode, test d'accès — aucun paiement)
    PRO_SUB_EDIT: 'Modifier',
    PRO_SUB_EDIT_TITLE: 'Override de l’abonnement',
    PRO_SUB_EDIT_DESC:
      'Force le plan, la taille, l’engagement, le statut et les options d’un client pour tester le gating d’accès.',
    PRO_SUB_EDIT_WARNING:
      '⚠️ Outil de test uniquement. Écriture directe en base, AUCUN paiement n’est déclenché : la facturation Stripe n’est pas branchée sur cette action. À n’utiliser que pour vérifier les accès / fonctionnalités d’un compte, jamais pour gérer un vrai abonnement payant.',
    PRO_SUB_PROPAGATION_NOTE:
      'Les nouveaux accès s’appliquent au prochain rafraîchissement du token du pro (jusqu’à 15 min en prod, immédiat en local après reconnexion).',
    PRO_SUB_PLAN: 'Plan',
    PRO_SUB_SIZE: 'Taille',
    PRO_SUB_COMMITMENT: 'Engagement',
    PRO_SUB_STATUS: 'Statut',
    PRO_SUB_FLAGS: 'Options (addons)',
    PRO_SUB_FLAG_WHITE_LABEL: 'Marque blanche (white-label)',
    PRO_SUB_FLAG_SMART_RIDE: 'Smart Ride (VTC / Taxi)',
    PRO_SUB_FLAG_MOBILE_APP: 'App mobile marque blanche',
    PRO_SUB_SYNC_QUOTA: 'Resynchroniser les quotas sur le plan',
    PRO_SUB_SYNC_QUOTA_HINT: 'Réécrit les plafonds mensuels SMS / email depuis la définition du plan choisi.',
    PRO_SUB_FIRST_SEGMENT_DATE: 'Date du 1er segment (test prorata)',
    PRO_SUB_FIRST_SEGMENT_DATE_HINT:
      'Optionnel. Ancre la régénération des segments à cette date : la placer dans le passé fait tomber « maintenant » en milieu de cycle pour tester les proratas d’upgrade. Sans effet avant un segment déjà facturé. Vide = comportement par défaut.',
    PRO_SUB_EDIT_CONFIRM: 'Appliquer l’override',
    // --- Recouvrement (impayé abonnement) ---
    PRO_DUNNING_TITLE: 'Recouvrement',
    PRO_DUNNING_NONE: 'Aucun impayé : les prélèvements passent.',
    PRO_DUNNING_LOAD_ERROR: "Impossible de charger l'état des impayés. Rechargez la page.",
    PRO_DUNNING_PHASE: 'Phase',
    PRO_DUNNING_PHASE_RECOVERY: 'Recouvrement (J0 → J+30)',
    PRO_DUNNING_PHASE_SEMI_FROZEN: 'Semi-gel : réservation en ligne coupée (J+30 → J+60)',
    PRO_DUNNING_PHASE_FROZEN: 'Gel total : compte suspendu',
    PRO_DUNNING_STARTED_AT: 'Impayé depuis le',
    PRO_DUNNING_AMOUNT: 'Solde impayé',
    PRO_DUNNING_OPEN_CHAINS: 'Prélèvements en échec',
    PRO_DUNNING_LAST_ERROR: 'Dernier motif de refus',
    PRO_DUNNING_LAST_FAILED_AT: 'Dernier échec le',
    // Prélèvement SEPA lancé (rejeu, « Payer maintenant ») : ni encaissé ni rejeté, l'impayé n'est pas soldé.
    PRO_DUNNING_IN_FLIGHT: 'Régularisation en cours — confirmation attendue',
    PRO_DUNNING_IN_FLIGHT_DESC:
      '{count} prélèvement(s) SEPA lancé(s) pour {amount} : encaissement ou rejet sous quelques jours ouvrés. L’impayé reste ouvert jusque-là.',
    PRO_DUNNING_LAST_RETRY: 'Dernier rejeu : {result}',
    PRO_DUNNING_HARD_DECLINE:
      'Refus définitif de la banque (carte volée, perdue ou fraude) : les rejeux automatiques sont stoppés, seul un nouveau moyen de paiement peut débloquer.',
    PRO_DUNNING_STOPPED_BANNER:
      'Recouvrement automatique arrêté le {date} : plus aucune relance, plus aucun rejeu de prélèvement, pas de gel à J+60. Le solde reste dû.',
    PRO_DUNNING_RETRY: 'Rejouer les prélèvements',
    PRO_DUNNING_RETRY_TITLE: 'Rejouer les prélèvements en échec',
    PRO_DUNNING_RETRY_DESC:
      'Retente immédiatement tous les prélèvements en échec de ce pro sur son moyen de paiement par défaut. Débit réel. Si tout passe, le compte est dégelé et le pro reçoit un accusé de réception.',
    PRO_DUNNING_RETRY_CONFIRM: 'Rejouer maintenant',
    PRO_DUNNING_RETRY_RESULT: '{succeeded}/{attempted} prélèvement(s) encaissé(s).',
    // Prélèvements SEPA en vol après le rejeu : ni encaissés ni refusés, l'impayé n'est pas soldé.
    PRO_DUNNING_RETRY_RESULT_PENDING:
      '{pending} prélèvement(s) SEPA en cours : encaissement sous quelques jours ouvrés.',
    PRO_DUNNING_RETRY_RESULT_RECOVERED: 'Impayé soldé : le compte est à jour.',
    PRO_DUNNING_STOP: 'Arrêter les relances',
    PRO_DUNNING_STOP_TITLE: 'Arrêter le recouvrement automatique',
    PRO_DUNNING_STOP_DESC:
      'Coupe les relances au pro, les rejeux de prélèvement planifiés et le gel automatique à J+60. L’abonnement reste dans son état actuel et le solde reste dû. À utiliser quand un humain reprend la main (appel, échéancier). Le pro peut toujours payer lui-même.',
    PRO_DUNNING_STOP_CONFIRM: 'Arrêter les relances',
    PRO_DUNNING_RESUME: 'Reprendre les relances',
    PRO_DUNNING_RESUME_TITLE: 'Reprendre le recouvrement automatique',
    PRO_DUNNING_RESUME_DESC:
      'Réarme les relances, les rejeux planifiés et le gel à J+60. La cadence reprend là où elle en était (aucune rafale de rattrapage).',
    PRO_DUNNING_RESUME_CONFIRM: 'Reprendre',
    PRO_DUNNING_CANCEL: 'Résilier pour impayé',
    PRO_DUNNING_CANCEL_TITLE: 'Résilier l’abonnement pour impayé',
    PRO_DUNNING_CANCEL_DESC:
      'Résiliation immédiate : l’abonnement passe en CANCELED et prend fin maintenant. Le pro perd l’accès à son compte au prochain rafraîchissement, plus aucun prélèvement ni relance ne part, et il sort du MRR. Le solde impayé reste tracé. Action irréversible depuis cet écran.',
    PRO_DUNNING_CANCEL_CONFIRM: 'Résilier maintenant',
    PRO_DUNNING_ACTION_CANCEL: 'Annuler',
    // --- Parrainage : l'ambassadeur qui a apporté ce pro ---
    PRO_REFERRAL_TITLE: 'Parrainage',
    PRO_REFERRAL_NONE: 'Aucun parrain attribué.',
    PRO_REFERRAL_ATTACH: 'Attribuer un parrain…',
    PRO_REFERRAL_AFFILIATE: 'Ambassadeur',
    PRO_REFERRAL_CODE: 'Code / lien',
    PRO_REFERRAL_REVIEW_STATE: 'État du parrainage',
    PRO_REFERRAL_REFERRED_AT: 'Client depuis (1er encaissement)',
    PRO_REFERRAL_NOT_PAYING: 'Pas encore payant',
    PRO_REFERRAL_OPEN_AFFILIATE: 'Ouvrir la fiche ambassadeur',
    // --- TVA : régime applicable à ce QU'ON FACTURE au pro ---
    PRO_DETAIL_VAT: 'TVA',
    PRO_VAT_REGIME: 'Régime',
    PRO_VAT_RATE: 'Taux appliqué',
    PRO_VAT_COUNTRY: 'Pays de facturation',
    PRO_VAT_NUMBER: 'N° TVA intracommunautaire',
    PRO_VAT_SUGGESTED: 'Régime suggéré (d’après le pays)',
    PRO_VAT_LEGAL_MENTION: 'Mention portée sur les factures',
    PRO_VAT_BLOCKED_WARNING:
      'Régime non tranché : aucune facture n’est émise pour ce pro tant qu’un régime n’a pas été choisi. Les segments restent dus et repartent d’eux-mêmes une fois la décision prise.',
    PRO_VAT_EDIT: 'Choisir le régime',
    PRO_VAT_EDIT_TITLE: 'Régime de TVA du pro',
    PRO_VAT_EDIT_DESC:
      'Le pays ne suffit pas à déterminer le régime : une même adresse (DOM notamment) admet la TVA locale OU l’autoliquidation par le preneur. Le régime choisi fixe le taux facturé ET la mention légale imprimée sur les factures.',
    PRO_VAT_RESYNC: 'Répercuter sur l’abonnement et les segments non facturés',
    PRO_VAT_RESYNC_HINT:
      'Sans cette option, le nouveau taux ne s’appliquerait qu’au cycle suivant. Les segments déjà facturés ne sont jamais modifiés : seul un avoir peut les corriger.',
    // --- Raison de non-conversion (A3) ---
    PRO_NON_CONVERSION_TITLE: 'Raison de non-conversion',
    PRO_NON_CONVERSION_DESC:
      'Pourquoi l’essai ne s’est pas transformé en abonnement. À renseigner après l’appel de fin d’essai : c’est ce qui permet de compter les raisons dans les tableaux de bord.',
    PRO_NON_CONVERSION_REASON: 'Raison',
    PRO_NON_CONVERSION_REASON_NONE: 'Non renseignée',
    PRO_NON_CONVERSION_NOTE: 'Note',
    PRO_NON_CONVERSION_NOTE_PLACEHOLDER: 'Ce qu’il a dit, ce qui l’aurait fait changer d’avis…',
    PRO_NON_CONVERSION_UPDATED_AT: 'Mis à jour le {date}',
    PRO_NON_CONVERSION_SAVED: 'Enregistré',
    // --- Pack référencement (ouverture par compte tant que SEO_ARTICLES_OPEN_TO_ALL est faux) ---
    PRO_SEO_PACK_TITLE: 'Pack référencement',
    PRO_SEO_PACK_DESC:
      'Articles de blog rédigés chaque mois + un lien partenaire. Réservé à la formule Max : l’ouvrir ici ne suffit pas sans elle, sauf dérogation « hors Max ». Le pro découvre le pack sur la page de son blog et suit un court parcours d’activation (auteur, concurrents, sujets) qui lance ses premiers sujets pour le mois suivant.',
    PRO_SEO_PACK_OPEN_TO_ALL: 'Ouvert à tous les comptes Max par l’environnement : l’interrupteur n’a pas d’effet ici.',
    PRO_SEO_PACK_ENABLED: 'Ouvert pour ce compte',
    PRO_SEO_PACK_DISABLED: 'Fermé pour ce compte',
    PRO_SEO_PACK_ENABLED_AT: 'Ouvert le {date}',
    PRO_SEO_PACK_ONBOARDED_AT: 'Parcours d’activation suivi le {date}',
    PRO_SEO_PACK_NOT_ONBOARDED: 'Parcours d’activation pas encore suivi',
    PRO_SEO_PACK_ENABLE: 'Ouvrir le pack',
    PRO_SEO_PACK_DISABLE: 'Fermer le pack',
    PRO_SEO_PACK_ENABLE_CONFIRM:
      'Le pro verra le pack sur son blog à sa prochaine connexion (ou au rafraîchissement de sa session). Prévenez-le : rien ne lui est envoyé automatiquement.',
    PRO_SEO_PACK_DISABLE_CONFIRM:
      'Le pro perd l’accès à l’espace référencement ; les sujets et articles déjà produits restent en base, les propositions mensuelles s’arrêtent.',
    PRO_SEO_PACK_SAVED: 'Enregistré',
    PRO_SEO_PACK_PLAN_MAX: 'Formule Max en cours',
    PRO_SEO_PACK_PLAN_MAX_ENDING:
      'Formule Max quittée, encore payée jusqu’à la fin de la période : sans dérogation, le pack se fermera au changement de formule.',
    PRO_SEO_PACK_PLAN_NOT_MAX: 'Pas de formule Max : sans dérogation, le pack reste invisible pour ce pro.',
    PRO_SEO_PACK_ANY_PLAN_AT: 'Ouvert hors Max le {date}',
    PRO_SEO_PACK_ANY_PLAN_ENABLE: 'Ouvrir hors Max',
    PRO_SEO_PACK_ANY_PLAN_DISABLE: 'Exiger Max',
    PRO_SEO_PACK_ANY_PLAN_ENABLE_CONFIRM:
      'Le pack s’ouvre avec la formule actuelle du pro, comme pour un compte Max (articles, liens partenaires, propositions mensuelles), sans rien facturer en plus. Il faut un abonnement payant en cours : jamais pendant l’essai. Le pack est aussi ouvert s’il était fermé. Effet côté pro dans les 15 minutes (au rafraîchissement de sa session).',
    PRO_SEO_PACK_ANY_PLAN_DISABLE_CONFIRM:
      'Le pack ne reste ouvert que si le pro a la formule Max. Sinon il est aussi fermé pour ce compte : le pro perd l’accès dans les 15 minutes (au rafraîchissement de sa session) et les propositions mensuelles s’arrêtent.',
    // Commun édition
    PRO_EDIT_CANCEL: 'Annuler',
    PRO_EDIT_SAVE: 'Enregistrer',
    PRO_EDIT_SAVING: 'Enregistrement…',
    PRO_EDIT_ERROR: 'Une erreur est survenue. Réessayez.',
    // --- Référentiel des métiers (catégories + activités) ---
    ACTIVITY_TITLE: 'Métiers',
    ACTIVITY_SUBTITLE: 'Référentiel des métiers : catégories et activités proposées aux professionnels.',
    ACTIVITY_TAB_ACTIVITIES: 'Activités',
    ACTIVITY_TAB_CATEGORIES: 'Catégories',
    ACTIVITY_SEARCH_PLACEHOLDER: 'Rechercher une activité…',
    ACTIVITY_FILTER_ALL_CATEGORIES: 'Toutes les catégories',
    ACTIVITY_FILTER_INCLUDE_INACTIVE: 'Inclure les inactives',
    ACTIVITY_FILTER_INCLUDE_DELETED: 'Inclure les supprimées',
    ACTIVITY_EMPTY: 'Aucune activité.',
    ACTIVITY_CATEGORIES_EMPTY: 'Aucune catégorie.',
    // Colonnes activités
    ACTIVITY_COL_LABEL: 'Libellé',
    ACTIVITY_COL_SLUG: 'Slug',
    ACTIVITY_COL_CATEGORY: 'Catégorie',
    ACTIVITY_COL_POPULARITY: 'Popularité',
    ACTIVITY_COL_SORT_ORDER: 'Ordre',
    ACTIVITY_COL_USAGE: 'Pros',
    ACTIVITY_COL_STATUS: 'Statut',
    ACTIVITY_COL_ACTIONS: 'Actions',
    // Colonnes catégories
    ACTIVITY_CAT_COL_LABEL: 'Libellé',
    ACTIVITY_CAT_COL_SLUG: 'Slug',
    ACTIVITY_CAT_COL_SECTOR: 'Secteur',
    ACTIVITY_CAT_COL_ORDER: 'Ordre',
    ACTIVITY_CAT_COL_COUNT: 'Activités',
    ACTIVITY_CAT_COL_STATUS: 'Statut',
    ACTIVITY_CAT_COL_ACTIONS: 'Actions',
    // Statuts
    ACTIVITY_STATUS_ACTIVE: 'Active',
    ACTIVITY_STATUS_INACTIVE: 'Inactive',
    ACTIVITY_STATUS_DELETED: 'Supprimée',
    // Boutons
    ACTIVITY_NEW: 'Nouvelle activité',
    ACTIVITY_CAT_NEW: 'Nouvelle catégorie',
    ACTIVITY_EDIT: 'Modifier',
    ACTIVITY_DELETE: 'Supprimer',
    // Champs formulaire activité
    ACTIVITY_FORM_SLUG: 'Slug (identifiant stable, non modifiable après création)',
    ACTIVITY_FORM_SLUG_PLACEHOLDER: 'coiffeur',
    ACTIVITY_FORM_LABEL: 'Libellé affiché',
    ACTIVITY_FORM_LABEL_PLACEHOLDER: 'Coiffeur',
    ACTIVITY_FORM_CATEGORY: 'Catégorie',
    ACTIVITY_FORM_SEO_ARTICLE: 'Libellé SEO avec article',
    ACTIVITY_FORM_SEO_ARTICLE_PLACEHOLDER: 'un coiffeur',
    ACTIVITY_FORM_SEO_PLURAL: 'Libellé SEO pluriel',
    ACTIVITY_FORM_SEO_PLURAL_PLACEHOLDER: 'Coiffeurs',
    ACTIVITY_FORM_SEO_FEMININE: 'Libellé SEO féminin',
    ACTIVITY_FORM_SEO_FEMININE_PLACEHOLDER: 'Coiffeuse',
    ACTIVITY_FORM_SEO_PRACTICE: "Nom de l'art (pratique)",
    ACTIVITY_FORM_SEO_PRACTICE_PLACEHOLDER: 'Coiffure',
    ACTIVITY_FORM_SCHEMA_ORG: 'Type schema.org',
    ACTIVITY_FORM_SCHEMA_ORG_PLACEHOLDER: 'HairSalon',
    ACTIVITY_FORM_SYNONYMS: 'Synonymes (séparés par une virgule)',
    ACTIVITY_FORM_SYNONYMS_PLACEHOLDER: 'coiffure, barbier',
    ACTIVITY_FORM_POPULARITY: 'Score de popularité',
    ACTIVITY_FORM_SORT_ORDER: 'Ordre manuel (optionnel)',
    ACTIVITY_FORM_ACTIVE: 'Active (visible dans le sélecteur)',
    // Champs formulaire catégorie
    ACTIVITY_CAT_FORM_SLUG: 'Slug (identifiant stable, non modifiable après création)',
    ACTIVITY_CAT_FORM_SLUG_PLACEHOLDER: 'beaute',
    ACTIVITY_CAT_FORM_LABEL: 'Libellé affiché',
    ACTIVITY_CAT_FORM_LABEL_PLACEHOLDER: 'Beauté',
    ACTIVITY_CAT_FORM_SECTOR: 'Secteur',
    ACTIVITY_CAT_FORM_ORDER: "Ordre d'affichage",
    ACTIVITY_CAT_FORM_EMOJI: 'Emoji (optionnel)',
    ACTIVITY_CAT_FORM_EMOJI_PLACEHOLDER: '💅',
    ACTIVITY_CAT_FORM_ACTIVE: 'Active (visible dans le sélecteur)',
    // Dialogues création / édition
    ACTIVITY_CREATE_TITLE: 'Nouvelle activité',
    ACTIVITY_EDIT_TITLE: "Modifier l'activité",
    ACTIVITY_CAT_CREATE_TITLE: 'Nouvelle catégorie',
    ACTIVITY_CAT_EDIT_TITLE: 'Modifier la catégorie',
    ACTIVITY_FORM_REQUIRED: 'Le slug et le libellé sont obligatoires.',
    ACTIVITY_SAVE: 'Enregistrer',
    ACTIVITY_SAVING: 'Enregistrement…',
    ACTIVITY_CANCEL: 'Annuler',
    ACTIVITY_SAVE_ERROR: 'Une erreur est survenue. Réessayez.',
    ACTIVITY_SLUG_EXISTS_ERROR: 'Ce slug est déjà utilisé.',
    // Suppression activité (soft-delete + garde-fou)
    ACTIVITY_DELETE_TITLE: "Supprimer l'activité",
    ACTIVITY_DELETE_DESC:
      "L'activité est retirée du sélecteur (soft-delete). Les professionnels qui l'utilisent déjà la conservent.",
    ACTIVITY_DELETE_IN_USE_WARNING:
      '⚠️ {count} professionnel(s) utilisent cette activité. Cochez la case pour supprimer quand même.',
    ACTIVITY_DELETE_FORCE: 'Supprimer malgré les professionnels rattachés',
    ACTIVITY_DELETE_CONFIRM: 'Supprimer',
    ACTIVITY_DELETE_IN_USE_ERROR:
      'Activité utilisée par des professionnels. Confirmez la suppression forcée pour continuer.',
    // Suppression catégorie (hard-delete bloquée si non vide)
    ACTIVITY_CAT_DELETE_TITLE: 'Supprimer la catégorie',
    ACTIVITY_CAT_DELETE_DESC: 'La catégorie est définitivement supprimée. Elle doit être vide au préalable.',
    ACTIVITY_CAT_DELETE_HAS_ACTIVITIES:
      'Impossible : cette catégorie contient encore des activités. Déplacez ou supprimez-les d’abord.',
    ACTIVITY_CAT_DELETE_CONFIRM: 'Supprimer',
    LEAD_DETAIL_HEADING: 'Lead #{id}',
    LEAD_DETAIL_PLAYBOOK_PREFIX: 'Playbook : {playbook}',
    // ── Journal d'audit ─────────────────────────────────────────────────────
    AUDIT_LOGS_TITLE: 'Journal d’audit',
    AUDIT_LOGS_SUBTITLE: 'Historique des actions sensibles réalisées par l’équipe admin.',
    AUDIT_LOGS_EMPTY: 'Aucune entrée pour ces filtres.',
    AUDIT_LOGS_FILTER_ALL_ACTIONS: 'Toutes les actions',
    AUDIT_LOGS_FILTER_ALL_ACTORS: 'Tous les acteurs',
    AUDIT_LOGS_FILTER_TARGET_KIND: 'Type de cible',
    AUDIT_LOGS_FILTER_TARGET_KIND_PLACEHOLDER: 'ex. lead, professional…',
    AUDIT_LOGS_FILTER_FROM: 'Du',
    AUDIT_LOGS_FILTER_TO: 'Au',
    AUDIT_LOGS_FILTER_RESET: 'Réinitialiser',
    AUDIT_LOGS_COL_DATE: 'Date',
    AUDIT_LOGS_COL_ACTOR: 'Acteur',
    AUDIT_LOGS_COL_ACTION: 'Action',
    AUDIT_LOGS_COL_TARGET: 'Cible',
    AUDIT_LOGS_COL_IP: 'IP',
    AUDIT_LOGS_COL_DETAILS: 'Détails',
    AUDIT_LOGS_DETAILS_SHOW: 'Voir',
    AUDIT_LOGS_DETAILS_BEFORE: 'Avant',
    AUDIT_LOGS_DETAILS_AFTER: 'Après',
    AUDIT_LOGS_DETAILS_NONE: 'Aucun détail',
    // ── Paramètres ──────────────────────────────────────────────────────────
    SETTINGS_TITLE: 'Paramètres',
    SETTINGS_SUBTITLE: 'Votre profil admin et vos préférences.',
    SETTINGS_PROFILE_TITLE: 'Profil',
    SETTINGS_PROFILE_NAME: 'Nom',
    SETTINGS_PROFILE_EMAIL: 'Email',
    SETTINGS_PROFILE_ROLE: 'Rôle',
    SETTINGS_PROFILE_LAST_LOGIN: 'Dernière connexion',
    SETTINGS_LANGUAGE_TITLE: 'Langue',
    SETTINGS_LANGUAGE_DESCRIPTION: 'Langue d’affichage de l’interface admin.',
    SETTINGS_LANGUAGE_FR: 'Français',
    SETTINGS_LANGUAGE_EN: 'English',
    SETTINGS_SECURITY_TITLE: 'Sécurité',
    SETTINGS_SECURITY_2FA_LABEL: 'Double authentification (2FA)',
    SETTINGS_SECURITY_2FA_ON: 'Activée',
    SETTINGS_SECURITY_2FA_ON_SINCE: 'Activée depuis le {date}',
    SETTINGS_SECURITY_2FA_OFF: 'À configurer',
    SETTINGS_SECURITY_2FA_EXEMPT: 'Non requise pour votre rôle',
    SETTINGS_SECURITY_2FA_HELP:
      'Code demandé à chaque connexion via votre application d’authentification. Nouveau téléphone ou codes de secours perdus : demandez à un super-admin de réinitialiser votre 2FA.',
    SETTINGS_USERS_LINK_TITLE: 'Utilisateurs admin',
    SETTINGS_USERS_LINK_DESC: 'Créer, assigner un rôle et désactiver les administrateurs.',
    SETTINGS_USERS_LINK_CTA: 'Gérer les utilisateurs',
    // ── Gestion des utilisateurs admin (/settings/users) ─────────────────────
    ADMIN_USERS_TITLE: 'Utilisateurs admin',
    ADMIN_USERS_SUBTITLE: 'Gérer les accès de l’équipe interne et leurs rôles.',
    ADMIN_USERS_ADD: 'Ajouter un admin',
    ADMIN_USERS_COL_NAME: 'Nom',
    ADMIN_USERS_COL_EMAIL: 'Email',
    ADMIN_USERS_COL_ROLE: 'Rôle',
    ADMIN_USERS_COL_ACTIVE: 'Statut',
    ADMIN_USERS_COL_LAST_LOGIN: 'Dernière connexion',
    ADMIN_USERS_COL_PHONE_LINE: 'Ligne téléphonique',
    ADMIN_USERS_PHONE_LINE_NONE: 'Aucune',
    ADMIN_USERS_PHONE_LINE_HINT:
      'Avec une ligne, un clic sur un numéro dans l’admin fait sonner le téléphone de cette personne puis compose le numéro, et l’appel est suivi en direct dans la fiche d’appel. Sans ligne, le numéro s’ouvre dans l’application téléphone du poste.',
    ADMIN_USERS_PHONE_LINE_ACCOUNT: 'Compte de facturation (ex. ba1234567-ovh-1)',
    ADMIN_USERS_PHONE_LINE_NUMBER: 'Numéro de ligne (ex. 0033422130389)',
    ADMIN_USERS_PHONE_LINE_SAVE: 'Enregistrer la ligne',
    ADMIN_USERS_PHONE_LINE_REMOVE: 'Retirer la ligne',
    ADMIN_USERS_PHONE_LINE_INACTIVE: 'inactive',
    ADMIN_USERS_PHONE_LINE_UNAVAILABLE:
      'La connexion au fournisseur téléphonique n’est pas configurée sur ce serveur : les lignes sont enregistrées mais inactives, les numéros restent des liens tel:.',
    ADMIN_USERS_COL_ACTIONS: 'Actions',
    ADMIN_USERS_ACTIVE: 'Actif',
    ADMIN_USERS_INACTIVE: 'Inactif',
    ADMIN_USERS_RESET_PW: 'Réinitialiser le mot de passe',
    ADMIN_USERS_RESET_PW_SUBMIT: 'Réinitialiser',
    ADMIN_USERS_DELETE: 'Désactiver',
    ADMIN_USERS_DELETE_CONFIRM: 'Désactiver cet administrateur ? (soft-delete, réversible en base)',
    ADMIN_USERS_PASSWORD_PLACEHOLDER: 'Mot de passe (min. 12 caractères)',
    ADMIN_USERS_CREATE_SUBMIT: 'Créer l’admin',
    ADMIN_USERS_ACTION_ERROR: 'L’action a échoué.',
    ADMIN_USERS_CREATED: 'Administrateur créé.',
    ADMIN_USERS_UPDATED: 'Administrateur mis à jour.',
    ADMIN_USERS_RESET_PW_DONE: 'Mot de passe réinitialisé.',
    ADMIN_USERS_DELETED: 'Administrateur désactivé.',
    ADMIN_USERS_COL_MFA: 'Double authentification',
    ADMIN_USERS_MFA_ON: 'Activée',
    ADMIN_USERS_MFA_OFF: 'À configurer',
    ADMIN_USERS_MFA_EXEMPT: 'Non requise (rôle)',
    ADMIN_USERS_MFA_EXEMPT_ENROLLED: 'Configurée, non demandée (rôle)',
    ADMIN_USERS_RESET_MFA: 'Réinitialiser la 2FA',
    ADMIN_USERS_RESET_MFA_CONFIRM:
      'Réinitialiser la double authentification de cet admin (téléphone perdu) ? Il devra la reconfigurer à sa prochaine connexion.',
    ADMIN_USERS_RESET_MFA_DONE: 'Double authentification réinitialisée.',
    SIDEBAR_PREVIEW_DEBUG: 'Lead Preview (debug)',
    PREVIEW_DEBUG_TITLE: 'Génération de preview (debug)',
    PREVIEW_DEBUG_SUBTITLE:
      'Crée un lead jetable et lance le pipeline preview (découverte → scrape → extraction → assemblage).',
    PREVIEW_DEBUG_MODE_URLS: 'URLs sources',
    PREVIEW_DEBUG_MODE_DISCOVERY: 'Découverte',
    PREVIEW_DEBUG_URLS_LABEL: 'URLs (une par ligne)',
    PREVIEW_DEBUG_URLS_PLACEHOLDER: 'https://exemple.com\nhttps://planity.com/exemple',
    PREVIEW_DEBUG_BUSINESS_NAME: 'Nom du commerce',
    PREVIEW_DEBUG_BUSINESS_NAME_PLACEHOLDER: 'Salon Marcel',
    PREVIEW_DEBUG_CITY: 'Ville (optionnel)',
    PREVIEW_DEBUG_CITY_PLACEHOLDER: 'Paris',
    PREVIEW_DEBUG_PLATFORM_HINTS: 'Plateformes citées (optionnel, séparées par virgule)',
    PREVIEW_DEBUG_PLATFORM_HINTS_PLACEHOLDER: 'planity, instagram',
    PREVIEW_DEBUG_MAX_PAGES: 'Pages max par site (optionnel, 1-30)',
    PREVIEW_DEBUG_SUBMIT: 'Générer la preview',
    PREVIEW_DEBUG_LOADING: 'Génération en cours… (peut prendre 30 s à 2 min)',
    PREVIEW_DEBUG_LEAD_INFO: 'Lead #{lead_id} · Job {job_id}',
    PREVIEW_DEBUG_READY_TITLE: 'Preview prête !',
    PREVIEW_DEBUG_READY_OPEN: 'Ouvrir la preview',
    PREVIEW_DEBUG_FAILED_TITLE: 'Échec de la génération',
    PREVIEW_DEBUG_RESET: 'Nouvelle preview',
    PREVIEW_DEBUG_VALIDATION_NEED_SOURCE: 'Fournis au moins une URL ou un nom de commerce.',
    SIDEBAR_PROMO_CODES: 'Codes promo',
    SIDEBAR_SEO_ARTICLES: 'Articles SEO',
    SIDEBAR_SEO_BACKLINKS: 'Backlinks',
    // ── Référencement : suivi des liens commandés (linkuma-integration.md §8) ──
    SEO_MONTH_LABEL: 'Mois',
    MONTH_PICKER_OPTION:
      '{month, select, 1 {janvier} 2 {février} 3 {mars} 4 {avril} 5 {mai} 6 {juin} 7 {juillet} 8 {août} 9 {septembre} 10 {octobre} 11 {novembre} 12 {décembre} other {}} {year}',
    MONTH_PICKER_PREVIOUS: 'Mois précédent',
    MONTH_PICKER_NEXT: 'Mois suivant',
    SEO_ACTION_DONE: 'Action effectuée : {detail}',
    SEO_ACTION_NOTHING: 'Rien n’a été fait : {detail}',
    SEO_BL_TITLE: 'Backlinks du pack',
    SEO_BL_SUBTITLE:
      'Liens commandés chez le partenaire pour chaque pro : page cible, ancre, article publié, vérification. Les actions marquées € dépensent des crédits.',
    SEO_BL_STAT_PROS: 'Pros au pack',
    SEO_BL_STAT_WITHOUT: 'Sans lien ce mois',
    SEO_BL_STAT_TO_REVIEW: 'À relire (pro)',
    SEO_BL_STAT_ORDERED: 'Commandés / en rédaction',
    SEO_BL_STAT_PUBLISHED: 'Publiés',
    SEO_BL_STAT_MISMATCH: 'En écart',
    SEO_BL_STAT_FAILED: 'Échecs / expirés',
    SEO_BL_STAT_COST: 'Dépense HT',
    SEO_BL_STAT_BUDGET: 'sur {budget} de plafond',
    SEO_BL_STAT_CREDIT: 'Solde fournisseur',
    SEO_BL_BY_FAMILY: 'Familles de pages',
    SEO_BL_BY_ANCHOR: 'Types d’ancre',
    SEO_BL_BY_ORIGIN: 'Offres',
    SEO_BL_FILTER_STATUS_ALL: 'Tous les statuts',
    SEO_BL_FILTER_PRO: 'Id du pro',
    SEO_BL_ACTION_POLL: 'Relever les commandes',
    SEO_BL_ACTION_RETRY: 'Renvoyer (€)',
    SEO_BL_ACTION_VERIFY: 'Re-vérifier',
    SEO_BL_ACTION_ORDER_PRO: 'Commander le mois (€)',
    SEO_BL_CONFIRM_RETRY: 'Renvoyer cette commande au partenaire ? Elle sera débitée des crédits.',
    SEO_BL_CONFIRM_ORDER: 'Commander les liens du mois pour ce pro ? Chaque lien est débité des crédits.',
    SEO_BL_COL_PRO: 'Pro',
    SEO_BL_COL_MONTH: 'Mois',
    SEO_BL_COL_OFFER: 'Offre',
    SEO_BL_COL_TARGET: 'Page cible',
    SEO_BL_COL_ANCHOR: 'Ancre',
    SEO_BL_COL_SOURCE: 'Publié sur',
    SEO_BL_COL_STATUS: 'Statut',
    SEO_BL_COL_COST: 'Coût',
    SEO_BL_COL_DATES: 'Dates',
    SEO_BL_COL_ACTIONS: 'Actions',
    SEO_BL_TARGET_REPLACED: 'page remplacée par l’accueil',
    SEO_BL_ORDERED_AT: 'commandé le {date}',
    SEO_BL_SCHEDULED: 'démarrage {date}',
    SEO_BL_PUBLISHED_AT: 'publié le {date}',
    SEO_BL_VERIFIED_AT: 'vérifié le {date}',
    SEO_BL_REVIEW_DUE: 'à valider avant le {date}',
    SEO_BL_INDEXED: 'vu par les moteurs',
    SEO_BL_SHOW_BRIEF: 'Brief',
    SEO_BL_EMPTY: 'Aucun lien pour ces critères.',
    // ── Référencement : articles du pack ──
    SEO_ART_TITLE: 'Articles SEO du pack',
    SEO_ART_SUBTITLE:
      'Par pro et par mois : sujets proposés, validés ou refusés, puis articles en rédaction, en échec de contrôle, à relire ou publiés.',
    SEO_ART_OVERVIEW_TITLE: 'Suivi par pro',
    SEO_ART_LIST_TITLE: 'Articles',
    SEO_ART_COL_PRO: 'Pro',
    SEO_ART_COL_MODE: 'Backlinks',
    SEO_ART_COL_TOPICS: 'Sujets (proposés / validés / refusés)',
    SEO_ART_COL_GENERATING: 'En rédaction',
    SEO_ART_COL_QA_FAILED: 'QA en échec',
    SEO_ART_COL_READY: 'À relire',
    SEO_ART_COL_PUBLISHED: 'Publiés',
    SEO_ART_COL_REJECTED: 'Refusés',
    SEO_ART_COL_NOTIFIED: 'Dernière notification',
    SEO_ART_COL_ACTIONS: 'Actions',
    SEO_ART_SITE_UNPUBLISHED: 'site non publié',
    SEO_ART_PACK_CLOSED: 'pack fermé',
    SEO_ART_NOT_ONBOARDED: 'pack non configuré (parcours d’activation non suivi, rien ne démarre)',
    SEO_ART_ACTION_PROPOSE: 'Proposer les sujets',
    SEO_ART_ACTION_REQUALIFY: 'Rejouer le contrôle',
    SEO_ART_CONFIRM_REQUALIFY:
      'Rejouer le contrôle qualité de cet article (score + relecture par le juge, une à deux minutes) ? Le statut se met à jour une fois la relecture finie.',
    SEO_ART_ACTION_FORCE_READY: 'Passer « à relire »',
    SEO_ART_CONFIRM_FORCE_READY:
      'Passer cet article « à relire » malgré le contrôle en échec ? Le pro sera prévenu qu’il l’attend (sauf s’il l’a déjà validé).',
    SEO_ART_REQUALIFY_STARTED: 'Contrôle relancé, la liste se rafraîchit toute seule.',
    SEO_ART_CONFIRM_PROPOSE: 'Lancer la proposition de sujets {of_month} pour ce pro ? (découverte LLM, e-mail au pro)',
    SEO_ART_TOTAL: 'Total',
    SEO_ART_FILTER_STATUS_ALL: 'Tous les statuts',
    SEO_ART_COL_TITLE: 'Titre',
    SEO_ART_COL_KEYWORD: 'Sujet',
    SEO_ART_COL_STATUS: 'Statut',
    SEO_ART_COL_SCORE: 'Score',
    SEO_ART_COL_WORDS: 'Mots',
    SEO_ART_COL_CREATED: 'Rédigé le',
    SEO_ART_EMPTY: 'Aucun article pour ces critères.',
    SIDEBAR_CLOCK: 'Horloge',
    SIDEBAR_SUBSCRIPTION_MIGRATION: 'Migration abo',
    SIDEBAR_MIGRATION_REDIRECT: 'Redirections v1→v2',
    // ── Migration abonnement v1→v2 ──────────────────────────────────────────
    SUBMIG_TITLE: 'Migration abonnement (v1 → v2)',
    SUBMIG_SUBTITLE:
      'Retrouve l’abonnement Stripe v1 du pro, propose un avant/après éditable, puis migre la formule et les domaines.',
    SUBMIG_PRO_ID_LABEL: 'ID professionnel (v2)',
    SUBMIG_CUSTOMER_ID_LABEL: 'Client Stripe (cus_…), optionnel',
    SUBMIG_LOAD: 'Charger',
    SUBMIG_LOADING: 'Chargement…',
    SUBMIG_CUSTOMER_SOURCE: 'Client Stripe',
    SUBMIG_CUSTOMER_SOURCE_MANUAL: 'saisi manuellement',
    SUBMIG_CUSTOMER_SOURCE_V2_DB: 'déjà en base v2',
    SUBMIG_CUSTOMER_SOURCE_STRIPE_SEARCH_EMAIL: 'trouvé via l’email',
    SUBMIG_CUSTOMER_SOURCE_NONE: 'non résolu : saisir l’ID',
    SUBMIG_CANDIDATES_TITLE: 'Plusieurs clients Stripe trouvés, choisir :',
    SUBMIG_CANDIDATE_SELECT: 'Sélectionner',
    SUBMIG_BEFORE_TITLE: 'Avant (v1)',
    SUBMIG_AFTER_TITLE: 'Après (v2)',
    SUBMIG_PLAN: 'Formule',
    SUBMIG_AMOUNT_HT: 'Montant HT (mensuel)',
    SUBMIG_INTERVAL: 'Périodicité v1',
    SUBMIG_INTERVAL_YEAR_BADGE: 'annuel → converti en mensuel',
    SUBMIG_PERIOD: 'Période en cours',
    SUBMIG_CARD: 'Carte',
    SUBMIG_NO_CARD: 'Aucune carte par défaut',
    SUBMIG_OTHER_SUBS: 'Autres abonnements',
    SUBMIG_BADGE_DOMAIN: 'DOMAINE',
    SUBMIG_BADGE_UNKNOWN: 'INCONNU',
    SUBMIG_NO_PLAN: 'Aucun abonnement « formule » v1 détecté.',
    SUBMIG_ALREADY_MIGRATED_WARNING: 'Ce pro a déjà un abonnement v2 actif : migration bloquée.',
    SUBMIG_TRIAL_WARNING: 'Abonnement v1 en essai : migration manuelle requise.',
    SUBMIG_USAGE_TITLE: 'Usage des fonctionnalités PRO en v1',
    SUBMIG_USAGE_UNAVAILABLE:
      'Usage v1 indisponible (pro non importé ou v1 injoignable) : vérifier la formule à la main.',
    SUBMIG_USAGE_VOUCHERS: 'Cartes cadeaux',
    SUBMIG_USAGE_VOUCHERS_DETAIL:
      '{total} émises · {online} vendues en ligne · {valid} encore valables · {used} utilisées',
    SUBMIG_USAGE_PAYMENTS: 'Paiement en ligne',
    SUBMIG_USAGE_PAYMENTS_DETAIL: '{settled} encaissements · {imprints} empreintes dont {live} non capturées',
    SUBMIG_USAGE_LAST_VOUCHER: 'Dernier bon',
    SUBMIG_USAGE_LAST_PAYMENT: 'Dernier paiement',
    SUBMIG_USAGE_CONFIG: 'Configuration',
    SUBMIG_USAGE_CONFIG_SHOP: 'boutique cadeau activée',
    SUBMIG_USAGE_CONFIG_PRESTAS: '{count} prestations exigent un paiement',
    SUBMIG_USAGE_CONFIG_CONNECT: 'Stripe Connect {status}',
    SUBMIG_USAGE_NONE: 'Aucun usage des fonctionnalités PRO détecté en v1.',
    SUBMIG_UPGRADE_TITLE: 'Formule remontée en PRO',
    SUBMIG_UPGRADE_EXPLAIN:
      'STARTER v2 ne donne ni le paiement en ligne ni la vente de cartes cadeaux : ce pro les utilise encore.',
    SUBMIG_UPGRADE_COST_WARNING: `La remise à vie couvre l’écart de catalogue : le pro garde son tarif, ${PROJECT_CONFIG.brand_string} absorbe la différence.`,
    SUBMIG_UPGRADE_REASON_VOUCHERS_STILL_VALID: 'des bons encore valables à honorer',
    SUBMIG_UPGRADE_REASON_LIVE_IMPRINTS: 'des empreintes non capturées',
    SUBMIG_UPGRADE_REASON_RECENT_VOUCHERS: 'des bons vendus dans les 12 derniers mois',
    SUBMIG_UPGRADE_REASON_RECENT_PAYMENTS: 'des paiements en ligne dans les 12 derniers mois',
    SUBMIG_UPGRADE_REVERT: 'Revenir à {plan}',
    SUBMIG_LABEL_FIELD: 'Formule v2',
    SUBMIG_SIZE_FIELD: 'Taille',
    SUBMIG_SIZE_SOLO: 'Solo',
    SUBMIG_SIZE_TEAM: 'Équipe',
    SUBMIG_SMART_RIDE: 'Option course (smart ride)',
    SUBMIG_ANCHOR_FIELD: 'Ancre (1er jour de cycle)',
    SUBMIG_OLD_PRICE_FIELD: 'Ancien tarif HT mensuel (centimes)',
    SUBMIG_VAT_FIELD: 'TVA (%)',
    SUBMIG_RECAP_CATALOGUE: 'Catalogue',
    SUBMIG_RECAP_DISCOUNT: 'remise à vie',
    SUBMIG_RECAP_FINAL: 'final',
    SUBMIG_RECAP_PROMO: 'Code',
    SUBMIG_FIRST_CHARGE: 'Premier prélèvement v2 le',
    SUBMIG_OPT_CANCEL_V1: 'Annuler l’abonnement Stripe v1',
    SUBMIG_OPT_LIFETIME_DISCOUNT: 'Créer la remise à vie',
    SUBMIG_EXECUTE: 'Migrer l’abonnement',
    SUBMIG_CONFIRM_TITLE: 'Confirmer la migration',
    SUBMIG_CONFIRM_BODY: 'Action irréversible : écritures v2 + annulation de l’abo Stripe v1. Continuer ?',
    SUBMIG_CONFIRM_OK: 'Oui, migrer',
    SUBMIG_CANCEL: 'Annuler',
    SUBMIG_SUCCESS: 'Migration effectuée.',
    SUBMIG_ERROR: 'Échec de la migration.',
    SUBMIG_V1_CANCEL_FAILED: 'DB v2 OK, mais l’annulation Stripe v1 a échoué.',
    SUBMIG_RETRY_CANCEL: 'Réessayer l’annulation v1',
    // Domaines
    SUBMIG_DOMAINS_TITLE: 'Domaines',
    SUBMIG_DOMAINS_WEBSITE_NOT_PUBLISHED: 'Le site v2 doit être publié avant de migrer les domaines.',
    SUBMIG_DOMAIN_NAME: 'Domaine',
    SUBMIG_DOMAIN_PRIMARY: 'Principal',
    SUBMIG_DOMAIN_WITH_BILLING: 'Facturation',
    SUBMIG_DOMAIN_RENEWAL_PRICE: 'Tarif renouvellement HT (centimes)',
    SUBMIG_DOMAIN_RENEWAL_DATE: 'Prochaine échéance',
    SUBMIG_DOMAIN_V1_SUB: 'Abo Stripe v1 à annuler',
    SUBMIG_DOMAINS_ADD_ROW: 'Ajouter un domaine',
    SUBMIG_DOMAINS_REMOVE_ROW: 'Retirer',
    SUBMIG_DOMAINS_EXECUTE: 'Migrer le(s) domaine(s)',
    SUBMIG_DOMAINS_NONE: 'Aucun domaine à migrer.',
    SUBMIG_DOMAINS_CUTOVER_WARNING:
      'La bascule DNS repointe le domaine vers le cluster (fenêtre HTTP-only de quelques minutes avant le certificat). Le site v2 doit être publié.',
    SUBMIG_DOMAINS_SEE_PROGRESS: 'Suivre l’activation dans la vue Domaines.',
    SUBMIG_DOMAINS_EXISTING: 'Domaines déjà en v2',
    CLOCK_TITLE: 'Horloge virtuelle',
    CLOCK_SUBTITLE:
      'Pilote la date vue par le moteur de facturation pour rejouer un cycle complet sans attendre les vraies échéances. Environnement de test uniquement.',
    CLOCK_PROD_WARNING: 'Indisponible en production : l’horloge est neutralisée.',
    CLOCK_NONPROD_WARNING: 'Outil de test : n’affecte que cet environnement (non-prod).',
    CLOCK_NOW_LABEL: 'Date courante du moteur',
    CLOCK_MODE_REAL: 'Temps réel',
    CLOCK_MODE_OFFSET: 'Décalé',
    CLOCK_MODE_FROZEN: 'Figé',
    CLOCK_OFFSET_LABEL: 'Décalage',
    CLOCK_SET_TITLE: 'Fixer une date',
    CLOCK_SET_DATE_LABEL: 'Date / heure',
    CLOCK_SET_FREEZE_LABEL: 'Figer le temps (ne s’écoule plus)',
    CLOCK_SET_BUTTON: 'Appliquer',
    CLOCK_ADVANCE_TITLE: 'Avancer le temps',
    CLOCK_ADVANCE_DAYS: 'Jours',
    CLOCK_ADVANCE_HOURS: 'Heures',
    CLOCK_ADVANCE_BUTTON: 'Avancer',
    CLOCK_RESET_BUTTON: 'Réinitialiser (temps réel)',
    CLOCK_CRON_TITLE: 'Déclencher un cron',
    CLOCK_CRON_RENEWALS: 'Facturation : renouvellements',
    CLOCK_CRON_RETRIES: 'Facturation : relances (retries)',
    CLOCK_CRON_TRIAL_RELANCE: 'Essais : passage horaire des relances',
    CLOCK_CRON_TRIAL_ENGAGEMENT: 'Essais : snapshot PostHog nocturne',
    CLOCK_CRON_CRM_QUEUE: 'File d’appels CRM (passe quotidienne)',
    CLOCK_CRON_CRM_FOLLOWUP: 'Suites CRM : SMS (passe horaire)',
    CLOCK_CRON_CRM_CAMPAIGN_SEND: 'Campagnes CRM : envoi des programmées',
    CLOCK_CRON_CRM_CAMPAIGN_STATS: 'Campagnes CRM : relecture des statistiques',
    CLOCK_CRON_CRM_SEQUENCE: 'Séquence automatique CRM (passe horaire)',
    CLOCK_CRON_DONE: 'Cron exécuté.',
    CLOCK_ACTION_DONE: 'Horloge mise à jour.',
    CLOCK_ERROR: 'Action impossible.',
    PROMO_TITLE: 'Codes promo abonnement',
    PROMO_SUBTITLE: 'Crée et gère les remises appliquées aux abonnements des clients.',
    PROMO_NEW_BUTTON: 'Nouveau code',
    PROMO_SEARCH_PLACEHOLDER: 'Rechercher par code ou libellé…',
    PROMO_FILTER_ALL: 'Tous',
    PROMO_FILTER_ACTIVE: 'Actifs',
    PROMO_FILTER_INACTIVE: 'Inactifs',
    PROMO_EMPTY: 'Aucun code promo.',
    PROMO_COL_CODE: 'Code',
    PROMO_COL_LABEL: 'Libellé',
    PROMO_COL_KIND: 'Type',
    PROMO_COL_VALUE: 'Valeur',
    PROMO_COL_DURATION: 'Durée',
    PROMO_COL_VALIDITY: 'Validité',
    PROMO_COL_REDEMPTIONS: 'Utilisations',
    PROMO_COL_STATUS: 'Statut',
    PROMO_COL_ACTIONS: 'Actions',
    PROMO_DURATION_FOREVER: 'À vie',
    PROMO_DURATION_MONTHS: '{count} mois',
    PROMO_STATUS_ACTIVE: 'Actif',
    PROMO_STATUS_INACTIVE: 'Inactif',
    PROMO_TARGETED_BADGE: '1 pro',
    PROMO_VALIDITY_FROM: 'Dès le {date}',
    PROMO_VALIDITY_RANGE: 'Du {from} au {until}',
    PROMO_REDEMPTIONS_COUNT: '{current} / {max}',
    PROMO_REDEMPTIONS_UNLIMITED: '{current} / ∞',
    PROMO_ACTION_EDIT: 'Modifier',
    PROMO_ACTION_REDEMPTIONS: 'Bénéficiaires',
    PROMO_ACTION_DEACTIVATE: 'Désactiver',
    PROMO_ACTION_ACTIVATE: 'Activer',
    PROMO_FORM_CREATE_TITLE: 'Nouveau code promo',
    PROMO_FORM_EDIT_TITLE: 'Modifier le code promo',
    PROMO_FORM_EDIT_RESTRICTED_NOTE:
      'Le type, la valeur et le ciblage sont figés après création (impact rétroactif sur la facturation). Pour changer la remise : désactive ce code et crée-en un nouveau.',
    PROMO_FORM_CODE: 'Code',
    PROMO_FORM_CODE_PLACEHOLDER: 'BIENVENUE20',
    PROMO_FORM_CODE_HINT: 'Majuscules, chiffres, tirets et underscores uniquement.',
    PROMO_FORM_LABEL: 'Libellé',
    PROMO_FORM_LABEL_PLACEHOLDER: 'Bienvenue -20%',
    PROMO_FORM_DESCRIPTION: 'Description (optionnel)',
    PROMO_FORM_KIND: 'Type de remise',
    PROMO_FORM_VALUE: 'Valeur',
    PROMO_FORM_VALUE_HINT_PERCENT: 'Pourcentage entre 0 et 100.',
    PROMO_FORM_VALUE_HINT_MINOR: 'Montant en centimes (ex. 1000 = 10,00 €).',
    PROMO_FORM_MIN_TOTAL: 'Plancher (centimes, optionnel)',
    PROMO_FORM_MIN_TOTAL_HINT:
      'La facture ne descend jamais sous ce montant HT quand le code s’applique. Ex. 2900 = 29,00 €.',
    PROMO_FORM_DURATION: 'Durée (mois)',
    PROMO_FORM_DURATION_HINT: 'Laisser vide pour une remise à vie.',
    PROMO_FORM_VALID_FROM: 'Valide à partir du',
    PROMO_FORM_VALID_UNTIL: 'Valide jusqu’au (optionnel)',
    PROMO_FORM_MAX_REDEMPTIONS: 'Utilisations max (optionnel)',
    PROMO_FORM_MAX_REDEMPTIONS_HINT: 'Laisser vide pour illimité.',
    PROMO_FORM_IS_ACTIVE: 'Actif',
    PROMO_FORM_IS_STACKABLE: 'Cumulable avec d’autres codes',
    PROMO_FORM_APPLIES_TO_PLAN: 'S’applique au plan',
    PROMO_FORM_APPLIES_TO_ADDONS: 'S’applique aux options',
    PROMO_FORM_ELIGIBLE_PLANS: 'Plans éligibles',
    PROMO_FORM_ELIGIBLE_SIZES: 'Tailles éligibles',
    PROMO_FORM_ELIGIBLE_BILLING: 'Périodicités éligibles',
    PROMO_FORM_ELIGIBLE_ADDONS: 'Options ciblées',
    PROMO_FORM_ELIGIBLE_HINT: 'Aucune sélection = s’applique à tout.',
    PROMO_FORM_VOID_ON_PLAN_CHANGE: 'Annulation au changement de plan',
    PROMO_FORM_VOID_ON_ADDON_ADDED: 'Annuler si une option est ajoutée',
    PROMO_FORM_NOTES: 'Notes internes (optionnel)',
    PROMO_FORM_TARGET_PRO: 'Réserver à un pro (ID, optionnel)',
    PROMO_FORM_TARGET_PRO_HINT: 'Renseigne un ID pour réserver ce code à un seul professionnel.',
    PROMO_FORM_AUTO_REDEEM: 'Appliquer immédiatement au pro (auto-redeem)',
    PROMO_FORM_SUBMIT_CREATE: 'Créer',
    PROMO_FORM_SUBMIT_SAVE: 'Enregistrer',
    PROMO_FORM_CANCEL: 'Annuler',
    PROMO_SIZE_SOLO: 'Solo',
    PROMO_SIZE_TEAM: 'Équipe',
    PROMO_BILLING_MONTHLY: 'Mensuel',
    PROMO_BILLING_YEARLY: 'Annuel',
    PROMO_REDEMPTIONS_TITLE: 'Bénéficiaires de {code}',
    PROMO_REDEMPTIONS_EMPTY: 'Aucun bénéficiaire pour ce code.',
    PROMO_RED_COL_PRO: 'Professionnel',
    PROMO_RED_COL_STARTED: 'Depuis',
    PROMO_RED_COL_ENDS: 'Jusqu’à',
    PROMO_RED_COL_STATUS: 'Statut',
    PROMO_RED_COL_ACTIONS: 'Actions',
    PROMO_RED_FOREVER: 'À vie',
    PROMO_RED_ACTIVE: 'Active',
    PROMO_RED_VOIDED: 'Révoquée',
    PROMO_RED_REVOKE: 'Révoquer',
    PROMO_RED_REVOKE_TITLE: 'Révoquer cette remise ?',
    PROMO_RED_REVOKE_DESC: 'La remise sera retirée des prochains segments de facturation du pro. Action irréversible.',
    PROMO_RED_REVOKE_NOTE: 'Motif (optionnel)',
    PROMO_RED_REVOKE_SUBMIT: 'Révoquer',
    PROMO_TOAST_CREATED: 'Code promo créé.',
    PROMO_TOAST_UPDATED: 'Code promo mis à jour.',
    PROMO_TOAST_REVOKED: 'Remise révoquée.',
    PROMO_TOAST_ERROR: 'Une erreur est survenue.',
  },
  MOBILE: {
    SCANNER_TITLE: 'Scanner un coupon',
    SCANNER_HINT: 'Visez le QR code du coupon',
    SCANNER_CLOSE: 'Fermer',
    SCANNER_TORCH_ON: 'Allumer la lampe',
    SCANNER_TORCH_OFF: 'Éteindre la lampe',
    SCANNER_PERMISSION_DENIED:
      'L’accès à l’appareil photo est désactivé pour l’application. Autorisez-le dans les Réglages pour scanner les coupons.',
    SCANNER_OPEN_SETTINGS: 'Ouvrir les Réglages',
    TAB_HOME: 'Accueil',
    // Libellé lu par VoiceOver / TalkBack quand l'onglet porte la pastille des notifications.
    TAB_HOME_UNREAD_ONE: 'Accueil, 1 notification non lue',
    TAB_HOME_UNREAD_OTHER: 'Accueil, {count} notifications non lues',
    TAB_AGENDA: 'Agenda',
    TAB_SALES: 'Ventes',
    TAB_CUSTOMERS: 'Clients',
    TAB_MENU: 'Menu',
    MENU_CLOSE: 'Fermer le menu',
    NAV_BACK: 'Retour',
    LOADING: 'Chargement…',
    LOGIN_SUBTITLE: 'Connexion pro',
    LOGIN_EMAIL_PLACEHOLDER: 'Email',
    LOGIN_PASSWORD_PLACEHOLDER: 'Mot de passe',
    LOGIN_SHOW_PASSWORD: 'Afficher le mot de passe',
    LOGIN_HIDE_PASSWORD: 'Masquer le mot de passe',
    LOGIN_SUBMIT: 'Se connecter',
    LOGIN_ERROR_GENERIC: 'Connexion impossible. Vérifiez vos identifiants.',
    LOGIN_FORGOT_PASSWORD: 'Mot de passe oublié ?',
    WEBVIEW_TITLE_FORGOT_PASSWORD: 'Mot de passe oublié',
    // Titre du header natif de l'écran qui affiche le centre d'aide DANS l'app.
    WEBVIEW_TITLE_DOCS: 'Aide',
    // Écran de repli rendu à la place de `/register` en WebView mobile. Conformité
    // App Review 3.1.1 (rejet du 30/08/2026) : la création d'un compte pro est lue
    // par Apple comme un accès à un mécanisme d'achat externe. L'app se connecte à
    // un compte existant, elle n'en crée pas. Interdits absolus dans ce texte :
    // URL, lien ou bouton d'inscription, verbe d'achat, tarif — et même l'indication
    // de l'endroit où s'inscrire.
    REGISTRATION_UNAVAILABLE_TITLE: 'Connexion requise',
    REGISTRATION_UNAVAILABLE_DESC: `L’application ${PROJECT_CONFIG.brand_string} s’utilise avec un compte existant. Revenez à l’écran de connexion pour vous identifier.`,
    // Même motif 3.1.1 : l'adhésion au programme ambassadeur crée un compte affilié.
    // Interdits identiques — ni lien, ni bouton d'adhésion, ni taux, ni montant.
    REFERRAL_UNAVAILABLE_TITLE: 'Programme ambassadeur',
    REFERRAL_UNAVAILABLE_DESC: 'Le programme ambassadeur n’est pas disponible dans l’application.',
    // Écran de repli affiché dans la WebView à la place de `/establishment/subscription`
    // (et de ses sous-pages factures / moyens de paiement). Conformité App Review
    // 3.1.3(f) « Free Stand-alone Apps » : l'app est un companion gratuit d'un outil
    // web payant, donc AUCUN achat dans l'app ET aucun call to action d'achat hors
    // de l'app. Ce texte doit rester purement factuel — interdits absolus : URL,
    // lien ou bouton tappable, verbe d'achat (« souscrire », « voir nos tarifs »,
    // « passer au plan »), montant ou tarif.
    BILLING_UNAVAILABLE_DESC: `Votre abonnement, vos moyens de paiement et vos factures se gèrent depuis votre espace ${PROJECT_CONFIG.brand_string} sur ordinateur.`,
    // Affiché à la place d'un CTA d'upsell masqué en WebView mobile (formule
    // supérieure, option payante, recharge de crédits). Mêmes interdits que
    // BILLING_UNAVAILABLE_DESC : ni lien, ni verbe d'achat, ni montant.
    FEATURE_NOT_IN_PLAN:
      'Cette fonctionnalité n’est pas incluse dans votre formule actuelle. Votre abonnement se gère depuis votre espace ordinateur.',
    // Note rendue sous la liste des domaines en WebView mobile : la page reste
    // consultable (domaines, statuts, échéances), seuls l'ajout, le transfert et
    // le paiement — des achats dans l'app — en sont retirés. Mêmes interdits de
    // formulation que BILLING_UNAVAILABLE_DESC : ni lien, ni verbe d'achat, ni montant.
    DOMAIN_MANAGE_ON_DESKTOP:
      'L’ajout et le renouvellement d’un nom de domaine se gèrent depuis votre espace ordinateur.',
    MORE_SECTION_ACTIVITY: 'Mon activité',
    MORE_SECTION_APP: 'Application',
    // Libellés alignés sur le H1 de la page web d'atterrissage (l'écran poussé
    // n'a plus de header natif : le titre visible est celui du web).
    MORE_ESTABLISHMENT: 'Entreprise',
    MORE_MY_ACCOUNT: 'Mon compte',
    MORE_CATALOG: 'Catalogue',
    MORE_MARKETING: 'Communication',
    MORE_WEBSITE: 'Site internet',
    MORE_SUBSCRIPTION: 'Mon abonnement',
    MORE_REVIEWS: 'Avis clients',
    MORE_SUPPORT: 'Aide & support',
    MORE_APP_PREFERENCES: 'Préférences app',
    MORE_ABOUT: 'À propos',
    MORE_LOGOUT: 'Se déconnecter',
    LOGOUT_IN_PROGRESS: 'Déconnexion en cours…',
    MORE_SWITCH_ACCOUNT: 'Changer de compte pro',
    ABOUT_TERMS: 'Conditions générales',
    ABOUT_PRIVACY: 'Politique de confidentialité',
    ABOUT_VERSION: 'Version {version} · {env}',
    // Segment de la référence de build (écran À propos) quand aucune OTA n'est
    // appliquée (lancement sur le bundle embarqué du binaire store). Ligne
    // volontairement cryptique pour le pro — décodage au README mobile.
    ABOUT_BUILD_STORE: 'origine',
    UPDATE_REQUIRED_TITLE: 'Mise à jour requise',
    UPDATE_REQUIRED_DESC: `Cette version de l’app n’est plus compatible. Installez la dernière version depuis le store pour continuer à utiliser ${PROJECT_CONFIG.brand_string}.`,
    UPDATE_REQUIRED_CTA: 'Mettre à jour',
    UPDATE_REQUIRED_RETRY: 'Réessayer',
    OFFLINE_TITLE: 'Pas de connexion',
    OFFLINE_DESC: 'Impossible de charger la page. Vérifiez votre connexion internet, puis réessayez.',
    OFFLINE_RETRY: 'Réessayer',
    APP_PREFERENCES_TITLE: 'Préférences app',
    APP_PREFERENCES_DESC: 'Notifications push, biométrie et langue de l’app (à venir).',
    BIOMETRIC_OPT_IN_TITLE_FACE: 'Activer Face ID ?',
    BIOMETRIC_OPT_IN_TITLE_FINGERPRINT: 'Activer le déverrouillage par empreinte ?',
    BIOMETRIC_OPT_IN_DESC_FACE: `Sécurisez l’accès à ${PROJECT_CONFIG.brand_string} en demandant Face ID à l’ouverture de l’app après une période d’inactivité. Vous pouvez l’activer ou le désactiver à tout moment dans les préférences.`,
    BIOMETRIC_OPT_IN_DESC_FINGERPRINT: `Sécurisez l’accès à ${PROJECT_CONFIG.brand_string} en demandant votre empreinte à l’ouverture de l’app après une période d’inactivité. Vous pouvez l’activer ou le désactiver à tout moment dans les préférences.`,
    BIOMETRIC_OPT_IN_CTA_FACE: 'Activer Face ID',
    BIOMETRIC_OPT_IN_CTA_FINGERPRINT: 'Activer l’empreinte',
    // Variante générique (Android notamment : la feuille système choisit elle-même
    // la biométrie — empreinte, visage… — on ne peut pas nommer la modalité).
    BIOMETRIC_OPT_IN_TITLE_GENERIC: 'Activer le déverrouillage biométrique ?',
    BIOMETRIC_OPT_IN_DESC_GENERIC: `Sécurisez l’accès à ${PROJECT_CONFIG.brand_string} en demandant votre empreinte ou votre visage à l’ouverture de l’app après une période d’inactivité. Vous pouvez l’activer ou le désactiver à tout moment dans les préférences.`,
    BIOMETRIC_OPT_IN_CTA_GENERIC: 'Activer le déverrouillage biométrique',
    BIOMETRIC_OPT_IN_SKIP: 'Plus tard',
    BIOMETRIC_OPT_IN_PROMPT: 'Confirmez pour activer le verrouillage',
    BIOMETRIC_CANCEL: 'Annuler',
    BIOMETRIC_ENABLE_ERROR: 'Impossible d’activer le verrouillage. Réessayez.',
    BIOMETRIC_LOCK_TITLE: 'Déverrouillez pour continuer',
    BIOMETRIC_LOCK_PROMPT: 'Déverrouillez l’app',
    BIOMETRIC_LOCK_UNLOCK: 'Déverrouiller',
    BIOMETRIC_LOCK_LOGIN_INSTEAD: 'Se reconnecter avec mon mot de passe',
    BIOMETRIC_LOCKOUT: 'Trop de tentatives. Reconnectez-vous avec votre mot de passe.',
    BIOMETRIC_FAILED: 'Échec de la reconnaissance. Réessayez.',
    PREF_BIOMETRIC_FACE: 'Verrouillage par Face ID',
    PREF_BIOMETRIC_FINGERPRINT: 'Verrouillage par empreinte',
    PREF_BIOMETRIC_GENERIC: 'Verrouillage biométrique',
    PREF_BIOMETRIC_DESC: 'Demande la biométrie à l’ouverture de l’app après 5 min d’inactivité.',
    PREF_BIOMETRIC_UNAVAILABLE: 'Aucune biométrie configurée sur cet appareil.',
    PREF_SECTION_APPEARANCE: 'Apparence',
    PREF_SECTION_SECURITY: 'Sécurité',
    PREF_THEME_SYSTEM: 'Automatique (système)',
    PREF_THEME_LIGHT: 'Clair',
    PREF_THEME_DARK: 'Sombre',
    PREF_THEME_DESC: 'Le thème s’applique aux écrans de l’app et aux pages intégrées.',
    MORE_PULSE: 'Pulse',
    MORE_CAMPAIGNS: 'Campagnes',
    MORE_STATISTICS: 'Statistiques',
    // Écran Pulse natif. Quota mensuel épuisé (402 PULSE_QUOTA_EXCEEDED) : texte
    // volontairement SANS incitation à changer de formule — conformité App Review
    // 3.1.3(f), mêmes interdits que BILLING_UNAVAILABLE_DESC (ni lien, ni verbe
    // d'achat, ni montant). Ne PAS réutiliser API_ERRORS.PULSE_QUOTA_EXCEEDED ici.
    PULSE_QUOTA_TITLE: 'Quota de messages atteint',
    PULSE_QUOTA_DESC:
      'Vous avez utilisé tous les messages Pulse inclus dans votre formule ce mois-ci. Le compteur se renouvelle le 1er du mois prochain.',
    PULSE_COMPOSER_PLACEHOLDER: 'Écrivez à Pulse…',
    PULSE_SEND: 'Envoyer',
    PULSE_NEW_CONVERSATION: 'Nouvelle conversation',
    PULSE_MESSAGE_FROM_PULSE: 'Message de Pulse',
    PULSE_MESSAGE_FROM_YOU: 'Votre message',
    PULSE_ATTACHMENT_AUDIO: 'Message vocal',
    PULSE_ATTACHMENT_IMAGE: 'Image',
    // Liens vers l'abonnement / le parrainage neutralisés dans les réponses (3.1.3(f)).
    PULSE_LINK_DESKTOP_ONLY: '(depuis votre espace ordinateur)',
  },
  WEBSITE_PREVIEW: {
    BANNER_TITLE: `Aperçu ${PROJECT_CONFIG.brand_string}`,
    BANNER_SUBTITLE: 'voici à quoi ressemblerait votre site.',
    BANNER_CTA: 'Créer mon compte pour le publier',
    BOOKING_TEASER_TITLE: 'Réservation en ligne',
    BOOKING_TEASER_SUBTITLE: 'Vos clients réservent et paient directement depuis votre site, 24h/24.',
    BOOKING_TEASER_BUTTON: 'Prendre rendez-vous',
    BOOKING_SERVICE_NAME_FALLBACK: 'Votre prestation',
    BOOKING_DURATION_UNIT: 'min',
    BOOKING_SECTION_DATE: 'Choisissez une date',
    BOOKING_SECTION_TIME: 'Choisissez un horaire',
    BOOKING_LOCK_CTA: 'Créez votre compte pour activer la réservation',
    BUILDER_BOOKING_CUT:
      'Aperçu de l’éditeur : aucune réservation n’a été créée. Sur votre site en ligne, votre client finaliserait ici sa réservation.',
    BUILDER_GIFT_CUT:
      'Aperçu de l’éditeur : aucun paiement n’a été effectué. Sur votre site en ligne, votre client finaliserait ici son achat.',
    BOOKING_DAY_MON: 'Lun',
    BOOKING_DAY_TUE: 'Mar',
    BOOKING_DAY_WED: 'Mer',
    BOOKING_DAY_THU: 'Jeu',
    BOOKING_DAY_FRI: 'Ven',
    BOOKING_DAY_SAT: 'Sam',
    BOOKING_DAY_SUN: 'Dim',
    GIFT_TEASER_TITLE: 'Cartes cadeaux & packs',
    GIFT_TEASER_SUBTITLE: 'Vos clients offrent une carte cadeau ou achètent un pack en ligne, en quelques clics.',
    GIFT_TEASER_BUTTON: 'Offrir une carte cadeau',
    BOOKING_MODAL_TITLE: 'Activez la réservation en ligne',
    BOOKING_MODAL_SUBTITLE: `Créez votre compte ${PROJECT_CONFIG.brand_string} pour publier votre site et permettre à vos clients de réserver en ligne.`,
    BOOKING_MODAL_CTA: 'Créer mon compte',
    BOOKING_MODAL_DISMISS: 'Plus tard',
    GIFT_MODAL_TITLE: 'Activez les cartes cadeaux',
    GIFT_MODAL_SUBTITLE: `Créez votre compte ${PROJECT_CONFIG.brand_string} pour publier votre site et permettre à vos clients d’offrir vos prestations.`,
    // Phase B (waouh v2 §3.4) : enrichissement en arrière-plan + invitation à recharger.
    ENRICHING_LABEL: '✨ J’enrichis encore ton site (fiche Google, photos, avis)…',
    ENRICHED_READY_LABEL: 'Du nouveau sur ton site',
    ENRICHED_REFRESH_CTA: 'Actualiser',
    // Switcher de styles (waouh v2 Lot 4).
    STYLE_PANEL_TITLE: 'Ton style',
    STYLE_PANEL_TOGGLE: 'Choisir un style',
    STYLE_PANEL_CLOSE: 'Fermer',
  },
  OPENING_HOURS_EDITOR: {
    TITLE: 'Horaires d’ouverture',
    SUBTITLE: 'Définissez les horaires d’ouverture affichés sur la page de votre lieu.',
    DAY_MONDAY: 'Lundi',
    DAY_TUESDAY: 'Mardi',
    DAY_WEDNESDAY: 'Mercredi',
    DAY_THURSDAY: 'Jeudi',
    DAY_FRIDAY: 'Vendredi',
    DAY_SATURDAY: 'Samedi',
    DAY_SUNDAY: 'Dimanche',
    // Formes courtes : rendu compact des horaires dans les comparaisons (onglet Fiche Google).
    DAY_SHORT_MONDAY: 'Lun',
    DAY_SHORT_TUESDAY: 'Mar',
    DAY_SHORT_WEDNESDAY: 'Mer',
    DAY_SHORT_THURSDAY: 'Jeu',
    DAY_SHORT_FRIDAY: 'Ven',
    DAY_SHORT_SATURDAY: 'Sam',
    DAY_SHORT_SUNDAY: 'Dim',
    CLOSED: 'Fermé',
    OPEN: 'Ouvert',
    ADD_RANGE: 'Ajouter une plage',
    ALL_DAY: '24h/24',
    REMOVE_RANGE: 'Supprimer cette plage',
    MAX_RANGES_REACHED: 'Maximum 4 plages par jour.',
    RANGE_SEPARATOR: 'à',
  },
  // Onglet « Fiche Google » d'un lieu. Le vocabulaire est volontairement « envoyer /
  // remplacer », jamais « synchroniser » : le flux est à sens unique et écrase la fiche.
  GMB_SYNC: {
    SECTION_TITLE: 'Informations envoyées à Google',
    SECTION_DESCRIPTION: `Choisissez les informations que ${PROJECT_CONFIG.brand_string} tient à jour sur votre fiche Google. Vous ne les mettez à jour qu'à un seul endroit.`,
    ONE_WAY_NOTICE: `L'envoi va de ${PROJECT_CONFIG.brand_string} vers Google, jamais l'inverse : pour chaque information activée, la valeur ${PROJECT_CONFIG.brand_string} remplace celle de votre fiche.`,

    VIEW_LISTING_BUTTON: 'Voir ma fiche Google',
    VIEW_LISTING_SHORT: 'Voir sur Google',
    VIEW_LISTING_ARIA: 'Ouvrir la fiche Google « {name} » dans un nouvel onglet',

    FIELD_LABEL_REGULAR_HOURS: 'Horaires d’ouverture',
    FIELD_LABEL_DESCRIPTION: 'Description de l’établissement',
    FIELD_LABEL_PHONE: 'Numéro de téléphone',
    FIELD_LABEL_WEBSITE: 'Site web',
    FIELD_LABEL_URL_APPOINTMENT: 'Lien de prise de rendez-vous',

    VALUE_ON_GOOGLE: 'Sur Google aujourd’hui',
    VALUE_ON_BRAND: `Sur ${PROJECT_CONFIG.brand_string}`,
    VALUE_EMPTY: 'Non renseigné',
    VALUE_IDENTICAL: 'Identique à votre fiche Google.',
    COMPARISON_UNAVAILABLE: 'Comparaison avec Google indisponible pour le moment.',
    WILL_OVERWRITE_HINT: 'Sera remplacé au prochain envoi.',

    ROW_IDENTICAL: 'À jour',
    ROW_DIFFERENT: 'Différent',
    ROW_NEVER_PUSHED: 'Jamais envoyé',
    ROW_REJECTED: 'Refusé par Google',
    ROW_SKIPPED: 'Rien à envoyer',
    ROW_REJECTED_HINT: 'Google a refusé cette information. Vérifiez-la, puis relancez l’envoi.',

    BANNER_ALL_OFF_TITLE: 'Rien n’est envoyé à Google pour le moment.',
    BANNER_ALL_OFF_DESCRIPTION:
      '{count, plural, =0 {Votre fiche Google est déjà identique. Activez une information pour qu’elle le reste automatiquement.} one {# information diffère de votre fiche Google. Activez-la pour que Google affiche la bonne.} other {# informations diffèrent de votre fiche Google. Activez-les pour que Google affiche les bonnes.}}',
    BANNER_DIFF_TITLE: '{count, plural, one {# information à aligner} other {# informations à aligner}}',
    BANNER_DIFF_DESCRIPTION: 'Elle partira au prochain envoi, ou tout de suite si vous le demandez.',
    BANNER_UP_TO_DATE_TITLE: 'Votre fiche Google est à jour.',
    BANNER_REJECTED_TITLE:
      '{count, plural, one {# information refusée par Google} other {# informations refusées par Google}}',
    BANNER_REJECTED_DESCRIPTION: 'Corrigez-la puis relancez l’envoi.',
    BANNER_UNREACHABLE_TITLE: 'Impossible de lire votre fiche Google.',
    BANNER_UNREACHABLE_DESCRIPTION: 'Vos réglages restent modifiables. Réessayez dans un instant.',
    BANNER_STALE_DESCRIPTION: 'Comparaison basée sur la dernière lecture réussie.',
    BANNER_ACCOUNT_ERROR_TITLE: 'Votre compte Google doit être reconnecté.',
    BANNER_NOT_CONNECTED_TITLE: 'Cette fiche n’est reliée à aucun compte Google.',
    BANNER_LOCATION_NOT_FOUND_TITLE: 'Cette fiche est introuvable côté Google.',
    RETRY_BUTTON: 'Réessayer',

    ENABLE_ALL_BUTTON: 'Tout aligner sur Google',
    ENABLE_ALL_CONFIRM_TITLE: 'Envoyer ces informations à Google ?',
    ENABLE_ALL_CONFIRM_TEXT: `Les valeurs ${PROJECT_CONFIG.brand_string} remplaceront celles de votre fiche Google et resteront à jour automatiquement. Vous pouvez désactiver chaque information à tout moment.`,

    PUSH_NOW_BUTTON: 'Envoyer à Google maintenant',
    PUSH_NOW_DISABLED_HINT: 'Activez au moins une information pour pouvoir l’envoyer.',
    PUSH_LOCKED_TRIAL_HINT:
      'Pendant l’essai, on lit votre fiche Google sans rien y écrire. L’envoi s’active avec votre abonnement.',
    PUSH_NOW_CONFIRM_TITLE: 'Envoyer maintenant ?',
    PUSH_NOW_CONFIRM_TEXT: 'Les informations activées vont remplacer celles de votre fiche Google.',
    PUSH_NOW_SUCCESS: 'Votre fiche Google a été mise à jour.',
    PUSH_NOW_PARTIAL: 'Fiche mise à jour. Google a refusé une partie des informations.',
    PUSH_NOW_ERROR: 'L’envoi vers Google a échoué. Réessayez dans un instant.',
    PUSH_DELAY_NOTICE: 'La prise en compte côté Google peut demander quelques minutes.',

    TOGGLE_SAVE_ERROR: 'Le réglage n’a pas pu être enregistré.',

    APPLY_TO_OTHER_PLACES_BUTTON:
      '{count, plural, one {Appliquer à mon autre lieu} other {Appliquer à mes # autres lieux}}',
    APPLY_TO_OTHER_PLACES_CONFIRM_TITLE: 'Appliquer ces réglages à vos autres lieux ?',
    APPLY_TO_OTHER_PLACES_CONFIRM_TEXT:
      'Les réglages ci-dessus remplaceront ceux des fiches Google suivantes. Aucune information n’est envoyée tout de suite.',
    APPLY_TO_OTHER_PLACES_SUCCESS:
      '{count, plural, one {Réglages appliqués à # autre lieu.} other {Réglages appliqués à # autres lieux.}}',
    APPLY_TO_OTHER_PLACES_ERROR: 'Impossible d’appliquer les réglages aux autres lieux.',

    LAST_PUSH_AT: 'Dernier envoi',
    READ_AT: 'Fiche lue le',
  },
  AGENDA_SYNC: {
    TAB_TITLE: 'Synchronisation',
    BTN_CONNECT: 'Connecter',
    BTN_DISCONNECT: 'Déconnecter',
    BTN_CONFIGURE: 'Configurer',
    BTN_SAVE_CONFIG: 'Enregistrer',
    ICAL_BLOCK_TITLE: 'Abonnement iCal',
    ICAL_BLOCK_DESCRIPTION: 'Affichez vos rendez-vous dans Apple Calendar, Outlook ou tout autre lecteur iCal.',
    ICAL_ACTIVATE: 'Activer le flux iCal',
    ICAL_URL_LABEL: "URL d'abonnement",
    ICAL_COPY: 'Copier le lien',
    ICAL_COPY_OK: 'Lien copié.',
    ICAL_COPY_FAILED: 'Impossible de copier le lien.',
    ICAL_MORE_OPTIONS: 'Plus d’options',
    ICAL_REGENERATE: "Régénérer l'URL",
    ICAL_REGENERATE_CONFIRM_TITLE: "Régénérer l'URL d'abonnement ?",
    ICAL_REGENERATE_CONFIRM:
      "L'ancienne URL cessera immédiatement de fonctionner pour les personnes qui l'utilisent. Continuer ?",
    ICAL_INCLUDE_CUSTOMER: 'Inclure les informations client (nom, téléphone, notes)',
    PROVIDER_DESCRIPTION: `Connectez le compte pour synchroniser vos rendez-vous avec ${PROJECT_CONFIG.brand_string}.`,
    LAST_SYNC_AT: 'Dernière synchronisation',
    LAST_SYNC_NEVER: 'Jamais',
    SYNC_ERROR_HEADLINE: 'Erreur de synchronisation. Reconnectez votre compte pour reprendre.',
    ACCOUNT_EMAIL: 'Compte connecté',
    CALENDAR_SELECT_LABEL: 'Calendrier de destination',
    CALENDAR_READ_ONLY_SUFFIX: '(lecture seule)',
    CALENDAR_READ_ONLY_HINT: `Ce calendrier est en lecture seule : vos rendez-vous ne peuvent pas y être ajoutés. Choisissez un autre calendrier, ou le sens « Calendrier connecté vers ${PROJECT_CONFIG.brand_string} ».`,
    DIRECTION_LABEL: 'Sens de la synchronisation',
    LOADING: 'Chargement…',
    NO_MEMBERS: 'Aucun membre dans votre équipe pour le moment.',
    UNNAMED_MEMBER: 'Membre',
    CONNECT_OK: 'Calendrier connecté.',
    CONNECT_FAILED: 'La connexion au calendrier a échoué. Réessayez dans un instant.',
    OAUTH_POPUP_BLOCKED: 'La fenêtre de connexion a été bloquée. Autorisez les popups pour ce site, puis réessayez.',
    DISCONNECT_CONFIRM_TITLE: 'Déconnecter ce calendrier ?',
    DISCONNECT_CONFIRM:
      'Les rendez-vous importés depuis le calendrier seront supprimés de votre agenda, et les rendez-vous poussés depuis votre agenda seront supprimés du calendrier connecté. Les rendez-vous créés directement de chaque côté sont préservés.',
    DISCONNECT_OK: 'Calendrier déconnecté.',
    DIRECTION_BOTH: 'Synchronisation dans les deux sens',
    DIRECTION_PROPELSIA_TO_PROVIDER: `${PROJECT_CONFIG.brand_string} vers le calendrier connecté`,
    DIRECTION_PROVIDER_TO_PROPELSIA: `Calendrier connecté vers ${PROJECT_CONFIG.brand_string}`,
    CALLBACK_IN_PROGRESS: 'Authentification en cours…',
    PROVIDER_GOOGLE: 'Google Calendar',
    STATUS_ACTIVE: 'Synchronisé',
    STATUS_ERROR: 'Erreur',
    STATUS_PAUSED: 'À configurer',
    STATUS_NEVER_CONNECTED: 'Non connecté',
    BTN_ACTIVATE_SYNC: 'Activer la synchronisation',
    ACTIVATE_HINT: 'Choisissez le calendrier et le sens, puis activez la synchronisation.',
  },
  /**
   * Labels rendus côté backend (flux iCal + events poussés vers Google). Séparés
   * d'`AGENDA_SYNC` car ces chaînes sortent dans des artefacts non-UX (ICS, Google
   * Calendar) et n'ont pas le même contrat de wording.
   */
  AGENDA_SYNC_BACKEND: {
    DEFAULT_APPOINTMENT_TITLE: 'Rendez-vous',
    DEFAULT_MEMBER_LABEL: 'Membre',
    FEED_DISPLAY_NAME: '{professional} - {member}',
    DESC_WARNING: `⚠️ Cet évènement doit être modifié uniquement depuis ${PROJECT_CONFIG.brand_string} ⚠️`,
    DESC_PRESTATIONS: 'Prestations',
    DESC_CUSTOMER: 'Client',
    DESC_PRO: 'Pro',
    DESC_NOTE: 'Note',
  },

  /**
   * Standalone public booking page (cfixe.com/book/[slug]) — end-customer facing.
   */
  BOOKING_PUBLIC_PAGE: {
    POWERED_BY: 'Propulsé par',
    SERVICE_PARTY_SIZE_SUFFIX: '{count} personnes',
    META_TITLE: 'Réservation en ligne - {name}',
    META_DESCRIPTION: 'Prenez rendez-vous en ligne avec {name}.',
    MANAGE_META_TITLE: 'Gérer mon rendez-vous - {name}',
    MANAGE_TITLE: 'Gérer mon rendez-vous',
    MANAGE_SUBTITLE: 'Consultez, annulez ou déplacez votre rendez-vous.',
    APPOINTMENT_SECTION: 'Votre rendez-vous',
    DATE_TIME_LABEL: 'Date & heure',
    PAYMENT_SECTION: 'Paiement',
    PROFESSIONAL_SECTION: 'Professionnel',
    CANCELLATION_SECTION: 'Annulation',
    RESCHEDULE_SECTION: 'Déplacement',
    CUSTOMER_LABEL: 'Client',
    PROFESSIONAL_LABEL: 'Professionnel',
    PROFESSIONAL_EMAIL_LABEL: 'Email du professionnel',
    PROFESSIONAL_PHONE_LABEL: 'Téléphone du professionnel',
    EMAIL_LABEL: 'Email',
    PLACE_LABEL: 'Lieu',
    PLACE_ADDRESS_LABEL: 'Adresse du lieu',
    TEAM_MEMBER_LABEL: 'Avec',
    TEAM_MEMBERS_LABEL: 'Intervenants',
    SERVICES_LABEL: 'Services',
    NOTE_LABEL: 'Note',
    INSTRUCTIONS_HEADING: 'Instructions',
    INSTRUCTIONS_ATTACHMENTS_LABEL: 'Pièces jointes',
    TOTAL_AMOUNT_LABEL: 'Valeur des prestations',
    // Total après remise du code promo, prix normal barré à côté (récap aligné sur le tunnel).
    TOTAL_AFTER_DISCOUNT_LABEL: 'Total',
    PRICE_FROM_PREFIX: 'À partir de',
    PRICE_ON_QUOTE: 'Sur devis',
    PRICE_FREE: 'Gratuit',
    // Bloc « course VTC » des emails de réservation (injecté dans prestations_html par le bridge).
    RIDE_RECAP_TITLE: 'Votre course',
    RIDE_TRIP_LABEL: 'Course',
    RIDE_PICKUP: 'Départ',
    RIDE_DROPOFF: 'Arrivée',
    RIDE_RETURN: 'Retour',
    RIDE_VEHICLE: 'Véhicule',
    RIDE_PASSENGERS: 'Passagers',
    RIDE_LUGGAGE: 'Bagages',
    RIDE_SMALL_LUGGAGE: 'Petits bagages',
    RIDE_LARGE_LUGGAGE: 'Grands bagages',
    RIDE_DISTANCE: 'Distance',
    RIDE_DURATION: 'Durée estimée',
    /* Réservation course à PLUSIEURS véhicules (email de réservation + page de gestion client).
       Rien de tout ceci n'apparaît sur une course à un seul véhicule. */
    RIDE_VEHICLES: 'Véhicules ({count})',
    RIDE_VEHICLE_ITEM: 'Véhicule {index}',
    RIDE_DRIVER: 'Chauffeur',
    RIDE_VEHICLE_TO_ASSIGN: 'à attribuer',
    RIDE_PASSENGERS_TOTAL: 'Passagers (total)',
    RIDE_YOUR_VEHICLE: 'votre véhicule',
    RIDE_VEHICLES_CANCEL_NOTICE: 'Votre réservation compte {count} véhicules : ils seront tous annulés.',
    PRICE_TO_DETERMINE: 'À déterminer',
    PRICE_TO_DETERMINE_ON_SITE: 'Prix à déterminer sur place',
    // Tout bon (carte cadeau, pack, bon de prestation) : libellé neutre.
    VOUCHER_CODE_LABEL: 'Bon appliqué',
    VOUCHER_DISCOUNT_LABEL: 'Réduction du bon',
    PROMO_CODE_LABEL: 'Code promo appliqué',
    PROMO_DISCOUNT_LABEL: 'Réduction code promo',
    // Promotion appliquée sans code (automatique), suivie de son libellé.
    PROMOTION_DISCOUNT_LABEL: 'Remise',
    MANUAL_DISCOUNT_LABEL: 'Remise accordée',
    PAID_TODAY_LABEL: 'Déjà réglé',
    PAID_ONLINE_LABEL: 'Payé en ligne',
    CHARGED_AT_BOOKING_LABEL: 'Débité à la réservation',
    REMAINING_ON_SITE_LABEL: 'Reste à régler sur place',
    AMOUNT_DUE_LATER_LABEL: 'Montant restant à régler',
    CANCELLATION_DEADLINE_LABEL: "Annulation possible jusqu'au",
    CANCELLATION_DETAILS_TITLE: "Détails de l'annulation",
    AWAITING_CONFIRMATION_TITLE: 'En attente de confirmation',
    AWAITING_CONFIRMATION_NOTICE: 'Le professionnel doit encore confirmer votre demande.',
    CANCELLATION_DATE_LABEL: "Date d'annulation",
    CANCELLATION_REASON_EMPTY: 'Aucun motif renseigné',
    CANCELLED_BOOKING_NOTICE: 'Ce rendez-vous est annulé.',
    CANCELLED_BY_PRO_NOTICE: 'Ce rendez-vous a été annulé par le professionnel.',
    CANCELLED_BY_CUSTOMER_NOTICE: 'Ce rendez-vous a été annulé à votre demande.',
    REFUND_AMOUNT_LABEL: 'Remboursement prévu',
    REFUND_ONLINE_PAYMENT_LABEL: 'Paiement en ligne',
    REFUND_VOUCHER_LABEL: 'Coupon remboursé',
    REFUNDED_AMOUNT_LABEL: 'Montant remboursé',
    NO_REFUND_LABEL: 'Aucun remboursement prévu',
    // Frais d'annulation tardive (Sauvegarde CB / empreinte bancaire) — vue de gestion publique.
    CANCEL_CHARGE_LABEL: "Frais d'annulation",
    DEFERRED_CANCEL_NO_CHARGE_LABEL: 'Aucun montant ne sera prélevé',
    LATE_CANCEL_PENALTY_LABEL: "Frais d'annulation tardive",
    LATE_CANCEL_PENALTY_CARD_NOTICE: '{amount} seront prélevés sur votre carte enregistrée.',
    LATE_CANCEL_PENALTY_IMPRINT_NOTICE: '{amount} pourront être débités sur votre empreinte bancaire.',
    LATE_CANCEL_PENALTY_DEADLINE_HINT:
      "Au-delà de cette date, des frais d'annulation de {amount} seront prélevés sur votre carte enregistrée.",
    LATE_CANCEL_PENALTY_IMPRINT_DEADLINE_HINT:
      "Au-delà de cette date, des frais d'annulation de {amount} pourront être débités.",
    CANCEL_CONFIRM_TEXT_PENALTY:
      "Votre rendez-vous sera annulé. La date limite d'annulation gratuite est dépassée : les frais d'annulation indiqués ci-dessous seront automatiquement prélevés sur votre carte enregistrée.",
    CANCEL_SUCCESS_PENALTY_CHARGED:
      "Votre rendez-vous a bien été annulé. Des frais d'annulation de {amount} ont été prélevés sur votre carte enregistrée.",
    LATE_CANCEL_PENALTY_CHARGED_LABEL: "Frais d'annulation prélevés",
    LATE_CANCEL_PENALTY_CHARGE_FAILED_NOTICE:
      "Le prélèvement des frais d'annulation n'a pas pu aboutir. Le professionnel pourra retenter le prélèvement sur votre carte enregistrée.",
    // Email PRO_BOOKING_CANCELED : bloc d'échec du prélèvement automatique (rendu par le bridge).
    LATE_CANCEL_PENALTY_CHARGE_FAILED_PRO_EMAIL:
      "Le prélèvement automatique des frais d'annulation tardive ({amount}) a échoué : {reason}. Vous pouvez retenter le prélèvement depuis la fiche du paiement.",
    // Email PRO_BOOKING_CANCELED : paiements ajoutés par le pro (liens) encaissés en ligne, que
    // l'annulation client ne rembourse pas — le pro décide depuis la fiche de chaque paiement.
    EXTRA_PAYMENTS_TO_REFUND_PRO_EMAIL:
      '{amount} encaissés via des liens de paiement, à rembourser si besoin depuis la fiche du paiement.',
    // Notification PRO_PAYMENT_RECEIVED : lien du pro réglé APRÈS l'annulation du RDV (page de paiement
    // restée ouverte) — l'argent est pris, le pro décide du remboursement / de l'annulation.
    PAYMENT_ON_CANCELLED_RESERVATION_TO_REFUND_PRO_NOTICE:
      'Attention : ce rendez-vous est annulé. Pensez à rembourser ce paiement si besoin depuis la fiche du paiement.',
    PAYMENT_ON_CANCELLED_RESERVATION_TO_CANCEL_PRO_NOTICE:
      'Attention : ce rendez-vous est annulé. Pensez à annuler ce paiement si besoin depuis la fiche du paiement.',
    CANCEL_REASON_LABEL: "Motif d'annulation",
    CANCEL_REASON_PLACEHOLDER: 'Précisez votre motif si vous le souhaitez.',
    CANCEL_BUTTON: 'Annuler le rendez-vous',
    CANCEL_CONFIRM_TITLE: "Confirmer l'annulation ?",
    CANCEL_CONFIRM_TEXT:
      'Votre rendez-vous sera annulé. Si un remboursement est prévu, il sera traité selon les conditions indiquées.',
    CANCEL_CONFIRM_BUTTON: "Confirmer l'annulation",
    CANCEL_CONFIRM_BACK: 'Conserver le rendez-vous',
    CANCEL_UNAVAILABLE: 'Ce rendez-vous ne peut plus être annulé en ligne.',
    CANCEL_SUCCESS: 'Votre rendez-vous a bien été annulé.',
    RESCHEDULE_DATE_LABEL: 'Chercher à partir du',
    RESCHEDULE_REASON_LABEL: 'Motif du déplacement',
    RESCHEDULE_REASON_PLACEHOLDER: 'Précisez votre motif si vous le souhaitez.',
    LOAD_SLOTS_BUTTON: 'Voir les créneaux',
    NO_SLOTS: 'Aucun créneau disponible sur cette période.',
    NO_SLOTS_FOR_DAY: 'Aucun créneau disponible ce jour.',
    RESCHEDULE_OPEN_BUTTON: 'Choisir un autre créneau',
    RESCHEDULE_BUTTON: 'Déplacer le rendez-vous',
    RESCHEDULE_SELECTED_SLOT_BUTTON: 'Confirmer ce créneau',
    RESCHEDULE_PICKER_TITLE: 'Choisir un nouveau créneau',
    RESCHEDULE_PICKER_TEXT: 'Sélectionnez une date puis un horaire disponible pour déplacer votre rendez-vous.',
    RESCHEDULE_CURRENT_SLOT_LABEL: 'Rendez-vous actuel',
    // Lot 4 : réservation remisée par une promotion liée au créneau (`reschedule_promotion_name`).
    RESCHEDULE_PROMOTION_NOTICE:
      'Ces créneaux gardent votre remise {name}. Pour un autre horaire, contactez le professionnel.',
    RESCHEDULE_CONFIRM_TITLE: 'Confirmer le déplacement ?',
    RESCHEDULE_CONFIRM_TEXT: 'Votre rendez-vous sera déplacé vers le créneau sélectionné.',
    RESCHEDULE_CONFIRM_BUTTON: 'Confirmer ce créneau',
    RESCHEDULE_CONFIRM_BACK: 'Choisir un autre créneau',
    RESCHEDULE_REQUEST_CONFIRM_TITLE: 'Demander ce déplacement ?',
    RESCHEDULE_REQUEST_CONFIRM_TEXT:
      'Votre demande sera envoyée à {pro}. Le nouveau créneau sera confirmé après sa validation.',
    RESCHEDULE_REQUEST_CONFIRM_BUTTON: 'Envoyer la demande',
    SELECTED_SLOT_LABEL: 'Créneau choisi',
    PREVIOUS_WEEK: 'Semaine précédente',
    NEXT_WEEK: 'Semaine suivante',
    MORNING_LABEL: 'Matin',
    AFTERNOON_LABEL: 'Après-midi',
    EVENING_LABEL: 'Soir',
    SLOT_PLACES_ONE: '1 place',
    SLOT_PLACES_OTHER: '{count} places',
    SLOT_FULL: 'Complet',
    RESCHEDULE_UNAVAILABLE: 'Ce rendez-vous ne peut plus être déplacé en ligne.',
    RESCHEDULE_SUCCESS: 'Votre rendez-vous a bien été déplacé.',
    RESCHEDULE_REQUEST_SUCCESS: 'Votre demande de déplacement a été envoyée. Vous recevrez un email dès sa validation.',
    LOADING: 'Chargement...',
    ERROR_LOADING: 'Impossible de charger ce rendez-vous.',
    RETRY: 'Réessayer',
    POWERED_BY_BRAND: 'Propulsé par {brand}',
  },
};
